module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 197);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var core = __webpack_require__(26);

  var hide = __webpack_require__(18);

  var redefine = __webpack_require__(19);

  var ctx = __webpack_require__(27);

  var PROTOTYPE = 'prototype';

  var $export = function $export(type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;

    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

      out = (own ? target : source)[key]; // bind timers to global for call from export context

      exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

      if (target) redefine(target, key, out, type & $export.U); // export

      if (exports[key] != out) hide(exports, key, exp);
      if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
  };

  global.core = core; // type bitmap

  $export.F = 1; // forced

  $export.G = 2; // global

  $export.S = 4; // static

  $export.P = 8; // proto

  $export.B = 16; // bind

  $export.W = 32; // wrap

  $export.U = 64; // safe

  $export.R = 128; // real proto method for `library`

  module.exports = $export;
  /***/
},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== 'production') {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

      var isValidElement = function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }; // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(402)(isValidElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(403)();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 3 */

/***/
function (module, exports) {
  /*
  	MIT License http://www.opensource.org/licenses/mit-license.php
  	Author Tobias Koppers @sokra
  */
  // css base code, injected by the css-loader
  module.exports = function (useSourceMap) {
    var list = []; // return the list of modules as css string

    list.toString = function toString() {
      return this.map(function (item) {
        var content = cssWithMappingToString(item, useSourceMap);

        if (item[2]) {
          return "@media " + item[2] + "{" + content + "}";
        } else {
          return content;
        }
      }).join("");
    }; // import a list of modules into the list


    list.i = function (modules, mediaQuery) {
      if (typeof modules === "string") modules = [[null, modules, ""]];
      var alreadyImportedModules = {};

      for (var i = 0; i < this.length; i++) {
        var id = this[i][0];
        if (typeof id === "number") alreadyImportedModules[id] = true;
      }

      for (i = 0; i < modules.length; i++) {
        var item = modules[i]; // skip already imported module
        // this implementation is not 100% perfect for weird media query combinations
        //  when a module is imported multiple times with different media queries.
        //  I hope this will never occur (Hey this way we have smaller bundles)

        if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
          if (mediaQuery && !item[2]) {
            item[2] = mediaQuery;
          } else if (mediaQuery) {
            item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
          }

          list.push(item);
        }
      }
    };

    return list;
  };

  function cssWithMappingToString(item, useSourceMap) {
    var content = item[1] || '';
    var cssMapping = item[3];

    if (!cssMapping) {
      return content;
    }

    if (useSourceMap && typeof btoa === 'function') {
      var sourceMapping = toComment(cssMapping);
      var sourceURLs = cssMapping.sources.map(function (source) {
        return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
      });
      return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
    }

    return [content].join('\n');
  } // Adapted from convert-source-map (MIT)


  function toComment(sourceMap) {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
    var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
    return '/*# ' + data + ' */';
  }
  /***/

},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  /*
  	MIT License http://www.opensource.org/licenses/mit-license.php
  	Author Tobias Koppers @sokra
  */
  var stylesInDom = {};

  var memoize = function memoize(fn) {
    var memo;
    return function () {
      if (typeof memo === "undefined") memo = fn.apply(this, arguments);
      return memo;
    };
  };

  var isOldIE = memoize(function () {
    // Test for IE <= 9 as proposed by Browserhacks
    // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
    // Tests for existence of standard globals is to allow style-loader
    // to operate correctly into non-standard environments
    // @see https://github.com/webpack-contrib/style-loader/issues/177
    return window && document && document.all && !window.atob;
  });

  var getTarget = function getTarget(target) {
    return document.querySelector(target);
  };

  var getElement = function (fn) {
    var memo = {};
    return function (target) {
      // If passing function in options, then use it for resolve "head" element.
      // Useful for Shadow Root style i.e
      // {
      //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
      // }
      if (typeof target === 'function') {
        return target();
      }

      if (typeof memo[target] === "undefined") {
        var styleTarget = getTarget.call(this, target); // Special case to return head of iframe instead of iframe itself

        if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
          try {
            // This will throw an exception if access to iframe is blocked
            // due to cross-origin restrictions
            styleTarget = styleTarget.contentDocument.head;
          } catch (e) {
            styleTarget = null;
          }
        }

        memo[target] = styleTarget;
      }

      return memo[target];
    };
  }();

  var singleton = null;
  var singletonCounter = 0;
  var stylesInsertedAtTop = [];

  var fixUrls = __webpack_require__(408);

  module.exports = function (list, options) {
    if (typeof DEBUG !== "undefined" && DEBUG) {
      if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
    }

    options = options || {};
    options.attrs = typeof options.attrs === "object" ? options.attrs : {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
    // tags it will allow on a page

    if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE(); // By default, add <style> tags to the <head> element

    if (!options.insertInto) options.insertInto = "head"; // By default, add <style> tags to the bottom of the target

    if (!options.insertAt) options.insertAt = "bottom";
    var styles = listToStyles(list, options);
    addStylesToDom(styles, options);
    return function update(newList) {
      var mayRemove = [];

      for (var i = 0; i < styles.length; i++) {
        var item = styles[i];
        var domStyle = stylesInDom[item.id];
        domStyle.refs--;
        mayRemove.push(domStyle);
      }

      if (newList) {
        var newStyles = listToStyles(newList, options);
        addStylesToDom(newStyles, options);
      }

      for (var i = 0; i < mayRemove.length; i++) {
        var domStyle = mayRemove[i];

        if (domStyle.refs === 0) {
          for (var j = 0; j < domStyle.parts.length; j++) {
            domStyle.parts[j]();
          }

          delete stylesInDom[domStyle.id];
        }
      }
    };
  };

  function addStylesToDom(styles, options) {
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];

      if (domStyle) {
        domStyle.refs++;

        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j](item.parts[j]);
        }

        for (; j < item.parts.length; j++) {
          domStyle.parts.push(addStyle(item.parts[j], options));
        }
      } else {
        var parts = [];

        for (var j = 0; j < item.parts.length; j++) {
          parts.push(addStyle(item.parts[j], options));
        }

        stylesInDom[item.id] = {
          id: item.id,
          refs: 1,
          parts: parts
        };
      }
    }
  }

  function listToStyles(list, options) {
    var styles = [];
    var newStyles = {};

    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var id = options.base ? item[0] + options.base : item[0];
      var css = item[1];
      var media = item[2];
      var sourceMap = item[3];
      var part = {
        css: css,
        media: media,
        sourceMap: sourceMap
      };
      if (!newStyles[id]) styles.push(newStyles[id] = {
        id: id,
        parts: [part]
      });else newStyles[id].parts.push(part);
    }

    return styles;
  }

  function insertStyleElement(options, style) {
    var target = getElement(options.insertInto);

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    }

    var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

    if (options.insertAt === "top") {
      if (!lastStyleElementInsertedAtTop) {
        target.insertBefore(style, target.firstChild);
      } else if (lastStyleElementInsertedAtTop.nextSibling) {
        target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
      } else {
        target.appendChild(style);
      }

      stylesInsertedAtTop.push(style);
    } else if (options.insertAt === "bottom") {
      target.appendChild(style);
    } else if (typeof options.insertAt === "object" && options.insertAt.before) {
      var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
      target.insertBefore(style, nextSibling);
    } else {
      throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
    }
  }

  function removeStyleElement(style) {
    if (style.parentNode === null) return false;
    style.parentNode.removeChild(style);
    var idx = stylesInsertedAtTop.indexOf(style);

    if (idx >= 0) {
      stylesInsertedAtTop.splice(idx, 1);
    }
  }

  function createStyleElement(options) {
    var style = document.createElement("style");
    options.attrs.type = "text/css";
    addAttrs(style, options.attrs);
    insertStyleElement(options, style);
    return style;
  }

  function createLinkElement(options) {
    var link = document.createElement("link");
    options.attrs.type = "text/css";
    options.attrs.rel = "stylesheet";
    addAttrs(link, options.attrs);
    insertStyleElement(options, link);
    return link;
  }

  function addAttrs(el, attrs) {
    Object.keys(attrs).forEach(function (key) {
      el.setAttribute(key, attrs[key]);
    });
  }

  function addStyle(obj, options) {
    var style, update, remove, result; // If a transform function was defined, run it on the css

    if (options.transform && obj.css) {
      result = options.transform(obj.css);

      if (result) {
        // If transform returns a value, use that instead of the original css.
        // This allows running runtime transformations on the css.
        obj.css = result;
      } else {
        // If the transform function returns a falsy value, don't add this css.
        // This allows conditional loading of css
        return function () {// noop
        };
      }
    }

    if (options.singleton) {
      var styleIndex = singletonCounter++;
      style = singleton || (singleton = createStyleElement(options));
      update = applyToSingletonTag.bind(null, style, styleIndex, false);
      remove = applyToSingletonTag.bind(null, style, styleIndex, true);
    } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
      style = createLinkElement(options);
      update = updateLink.bind(null, style, options);

      remove = function remove() {
        removeStyleElement(style);
        if (style.href) URL.revokeObjectURL(style.href);
      };
    } else {
      style = createStyleElement(options);
      update = applyToTag.bind(null, style);

      remove = function remove() {
        removeStyleElement(style);
      };
    }

    update(obj);
    return function updateStyle(newObj) {
      if (newObj) {
        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
          return;
        }

        update(obj = newObj);
      } else {
        remove();
      }
    };
  }

  var replaceText = function () {
    var textStore = [];
    return function (index, replacement) {
      textStore[index] = replacement;
      return textStore.filter(Boolean).join('\n');
    };
  }();

  function applyToSingletonTag(style, index, remove, obj) {
    var css = remove ? "" : obj.css;

    if (style.styleSheet) {
      style.styleSheet.cssText = replaceText(index, css);
    } else {
      var cssNode = document.createTextNode(css);
      var childNodes = style.childNodes;
      if (childNodes[index]) style.removeChild(childNodes[index]);

      if (childNodes.length) {
        style.insertBefore(cssNode, childNodes[index]);
      } else {
        style.appendChild(cssNode);
      }
    }
  }

  function applyToTag(style, obj) {
    var css = obj.css;
    var media = obj.media;

    if (media) {
      style.setAttribute("media", media);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      while (style.firstChild) {
        style.removeChild(style.firstChild);
      }

      style.appendChild(document.createTextNode(css));
    }
  }

  function updateLink(link, options, obj) {
    var css = obj.css;
    var sourceMap = obj.sourceMap;
    /*
    	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
    	and there is no publicPath defined then lets turn convertToAbsoluteUrls
    	on by default.  Otherwise default to the convertToAbsoluteUrls option
    	directly
    */

    var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

    if (options.convertToAbsoluteUrls || autoFixUrls) {
      css = fixUrls(css);
    }

    if (sourceMap) {
      // http://stackoverflow.com/a/26603875
      css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
    }

    var blob = new Blob([css], {
      type: "text/css"
    });
    var oldSrc = link.href;
    link.href = URL.createObjectURL(blob);
    if (oldSrc) URL.revokeObjectURL(oldSrc);
  }
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(8);

  module.exports = function (it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };
  /***/

},
/* 6 */

/***/
function (module, exports) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  /***/

},
/* 8 */

/***/
function (module, exports) {
  module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };
  /***/

},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  var store = __webpack_require__(70)('wks');

  var uid = __webpack_require__(44);

  var Symbol = __webpack_require__(6).Symbol;

  var USE_SYMBOL = typeof Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
  };

  $exports.store = store;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var isMobileView = function isMobileView() {
    return window.innerWidth <= 768;
  };

  var isNotMobileView = function isNotMobileView() {
    return !isMobileView();
  };

  var isEnterKey = function isEnterKey(key) {
    return key === 13 || key === 'Enter';
  };
  /**
   * Generate a random string. Mainly used for generating unique ids
   * @param   {string}  str   This input will be the prefix of the random string returned
   *
   * @returns {string}
   */


  var randomStr = function randomStr() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (str && str.length) {
      return (str.replace(/ +/g, '-') + '-' + Math.random().toString(36).substr(2, 10)).toLowerCase();
    }

    return Math.random().toString(36).substr(2, 10);
  };

  var isNumber = function isNumber(value) {
    return !Number.isNaN(parseFloat(value));
  };

  var isPositiveNumber = function isPositiveNumber(time) {
    return isNumber(time) && Number(time) > 0;
  };

  exports.isMobileView = isMobileView;
  exports.isNotMobileView = isNotMobileView;
  exports.isDesktopView = isNotMobileView;
  exports.isEnterKey = isEnterKey;
  exports.randomStr = randomStr;
  exports.isNumber = isNumber;
  exports.isPositiveNumber = isPositiveNumber;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(7)(function () {
    return Object.defineProperty({}, 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(5);

  var IE8_DOM_DEFINE = __webpack_require__(130);

  var toPrimitive = __webpack_require__(32);

  var dP = Object.defineProperty;
  exports.f = __webpack_require__(11) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return dP(O, P, Attributes);
    } catch (e) {
      /* empty */
    }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.15 ToLength
  var toInteger = __webpack_require__(34);

  var min = Math.min;

  module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };
  /***/

},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.13 ToObject(argument)
  var defined = __webpack_require__(33);

  module.exports = function (it) {
    return Object(defined(it));
  };
  /***/

},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright 2014-2015, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    */

    /**
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */
    var warning = function warning() {};

    if (process.env.NODE_ENV !== 'production') {
      warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);

        for (var key = 2; key < len; key++) {
          args[key - 2] = arguments[key];
        }

        if (format === undefined) {
          throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
        }

        if (format.length < 10 || /^[s\W]*$/.test(format)) {
          throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
        }

        if (!condition) {
          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.error(message);
          }

          try {
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        }
      };
    }

    module.exports = warning;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 16 */

/***/
function (module, exports) {
  module.exports = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };
  /***/

},
/* 17 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(12);

  var createDesc = __webpack_require__(43);

  module.exports = __webpack_require__(11) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var hide = __webpack_require__(18);

  var has = __webpack_require__(21);

  var SRC = __webpack_require__(44)('src');

  var TO_STRING = 'toString';
  var $toString = Function[TO_STRING];
  var TPL = ('' + $toString).split(TO_STRING);

  __webpack_require__(26).inspectSource = function (it) {
    return $toString.call(it);
  };

  (module.exports = function (O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) has(val, 'name') || hide(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

    if (O === global) {
      O[key] = val;
    } else if (!safe) {
      delete O[key];
      hide(O, key, val);
    } else if (O[key]) {
      O[key] = val;
    } else {
      hide(O, key, val);
    } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

  })(Function.prototype, TO_STRING, function toString() {
    return typeof this == 'function' && this[SRC] || $toString.call(this);
  });
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var fails = __webpack_require__(7);

  var defined = __webpack_require__(33);

  var quot = /"/g; // B.2.3.2.1 CreateHTML(string, tag, attribute, value)

  var createHTML = function createHTML(string, tag, attribute, value) {
    var S = String(defined(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
  };

  module.exports = function (NAME, exec) {
    var O = {};
    O[NAME] = exec(createHTML);
    $export($export.P + $export.F * fails(function () {
      var test = ''[NAME]('"');
      return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
  };
  /***/

},
/* 21 */

/***/
function (module, exports) {
  var hasOwnProperty = {}.hasOwnProperty;

  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
  /***/

},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  // to indexed object, toObject with fallback for non-array-like ES3 strings
  var IObject = __webpack_require__(62);

  var defined = __webpack_require__(33);

  module.exports = function (it) {
    return IObject(defined(it));
  };
  /***/

},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  var pIE = __webpack_require__(63);

  var createDesc = __webpack_require__(43);

  var toIObject = __webpack_require__(22);

  var toPrimitive = __webpack_require__(32);

  var has = __webpack_require__(21);

  var IE8_DOM_DEFINE = __webpack_require__(130);

  var gOPD = Object.getOwnPropertyDescriptor;
  exports.f = __webpack_require__(11) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return gOPD(O, P);
    } catch (e) {
      /* empty */
    }
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
  };
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var has = __webpack_require__(21);

  var toObject = __webpack_require__(14);

  var IE_PROTO = __webpack_require__(94)('IE_PROTO');

  var ObjectProto = Object.prototype;

  module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];

    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }

    return O instanceof Object ? ObjectProto : null;
  };
  /***/

},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var bind = __webpack_require__(171);

  var isBuffer = __webpack_require__(475);
  /*global toString:true*/
  // utils is a library of generic helper functions non-specific to axios


  var toString = Object.prototype.toString;
  /**
   * Determine if a value is an Array
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Array, otherwise false
   */

  function isArray(val) {
    return toString.call(val) === '[object Array]';
  }
  /**
   * Determine if a value is an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an ArrayBuffer, otherwise false
   */


  function isArrayBuffer(val) {
    return toString.call(val) === '[object ArrayBuffer]';
  }
  /**
   * Determine if a value is a FormData
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an FormData, otherwise false
   */


  function isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
  }
  /**
   * Determine if a value is a view on an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
   */


  function isArrayBufferView(val) {
    var result;

    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    }

    return result;
  }
  /**
   * Determine if a value is a String
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a String, otherwise false
   */


  function isString(val) {
    return typeof val === 'string';
  }
  /**
   * Determine if a value is a Number
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Number, otherwise false
   */


  function isNumber(val) {
    return typeof val === 'number';
  }
  /**
   * Determine if a value is undefined
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if the value is undefined, otherwise false
   */


  function isUndefined(val) {
    return typeof val === 'undefined';
  }
  /**
   * Determine if a value is an Object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Object, otherwise false
   */


  function isObject(val) {
    return val !== null && typeof val === 'object';
  }
  /**
   * Determine if a value is a Date
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Date, otherwise false
   */


  function isDate(val) {
    return toString.call(val) === '[object Date]';
  }
  /**
   * Determine if a value is a File
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a File, otherwise false
   */


  function isFile(val) {
    return toString.call(val) === '[object File]';
  }
  /**
   * Determine if a value is a Blob
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Blob, otherwise false
   */


  function isBlob(val) {
    return toString.call(val) === '[object Blob]';
  }
  /**
   * Determine if a value is a Function
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Function, otherwise false
   */


  function isFunction(val) {
    return toString.call(val) === '[object Function]';
  }
  /**
   * Determine if a value is a Stream
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Stream, otherwise false
   */


  function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
  }
  /**
   * Determine if a value is a URLSearchParams object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a URLSearchParams object, otherwise false
   */


  function isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
  }
  /**
   * Trim excess whitespace off the beginning and end of a string
   *
   * @param {String} str The String to trim
   * @returns {String} The String freed of excess whitespace
   */


  function trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
  }
  /**
   * Determine if we're running in a standard browser environment
   *
   * This allows axios to run in a web worker, and react-native.
   * Both environments support XMLHttpRequest, but not fully standard globals.
   *
   * web workers:
   *  typeof window -> undefined
   *  typeof document -> undefined
   *
   * react-native:
   *  navigator.product -> 'ReactNative'
   */


  function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
      return false;
    }

    return typeof window !== 'undefined' && typeof document !== 'undefined';
  }
  /**
   * Iterate over an Array or an Object invoking a function for each item.
   *
   * If `obj` is an Array callback will be called passing
   * the value, index, and complete array for each item.
   *
   * If 'obj' is an Object callback will be called passing
   * the value, key, and complete object for each property.
   *
   * @param {Object|Array} obj The object to iterate
   * @param {Function} fn The callback to invoke for each item
   */


  function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
      return;
    } // Force an array if not already something iterable


    if (typeof obj !== 'object') {
      /*eslint no-param-reassign:0*/
      obj = [obj];
    }

    if (isArray(obj)) {
      // Iterate over array values
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      // Iterate over object keys
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }
  /**
   * Accepts varargs expecting each argument to be an object, then
   * immutably merges the properties of each object and returns result.
   *
   * When multiple objects contain the same key the later object in
   * the arguments list will take precedence.
   *
   * Example:
   *
   * ```js
   * var result = merge({foo: 123}, {foo: 456});
   * console.log(result.foo); // outputs 456
   * ```
   *
   * @param {Object} obj1 Object to merge
   * @returns {Object} Result of all merge properties
   */


  function merge()
  /* obj1, obj2, obj3, ... */
  {
    var result = {};

    function assignValue(val, key) {
      if (typeof result[key] === 'object' && typeof val === 'object') {
        result[key] = merge(result[key], val);
      } else {
        result[key] = val;
      }
    }

    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }

    return result;
  }
  /**
   * Extends object a by mutably adding to it the properties of object b.
   *
   * @param {Object} a The object to be extended
   * @param {Object} b The object to copy properties from
   * @param {Object} thisArg The object to bind function to
   * @return {Object} The resulting value of object a
   */


  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === 'function') {
        a[key] = bind(val, thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }

  module.exports = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim
  };
  /***/
},
/* 26 */

/***/
function (module, exports) {
  var core = module.exports = {
    version: '2.5.7'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

  /***/
},
/* 27 */

/***/
function (module, exports, __webpack_require__) {
  // optional / simple context binding
  var aFunction = __webpack_require__(16);

  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;

    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };

      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };

      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }

    return function ()
    /* ...args */
    {
      return fn.apply(that, arguments);
    };
  };
  /***/

},
/* 28 */

/***/
function (module, exports) {
  var toString = {}.toString;

  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };
  /***/

},
/* 29 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var fails = __webpack_require__(7);

  module.exports = function (method, arg) {
    return !!method && fails(function () {
      // eslint-disable-next-line no-useless-call
      arg ? method.call(null, function () {
        /* empty */
      }, 1) : method.call(null);
    });
  };
  /***/

},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Img = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(409);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Img = exports.Img = function Img(_ref) {
    var src = _ref.src,
        alt = _ref.alt,
        isFluid = _ref.isFluid,
        className = _ref.className;
    var classes = ['img', className];

    if (isFluid) {
      classes.push('img--fluid');
    }

    return _react2.default.createElement('img', {
      src: src,
      alt: alt,
      className: classes.join(' ')
    });
  };

  Img.propTypes = {
    src: _propTypes2.default.string,
    alt: _propTypes2.default.string,
    isFluid: _propTypes2.default.bool,
    className: _propTypes2.default.string
  };
  Img.defaultProps = {
    src: null,
    alt: '',
    isFluid: false,
    className: null
  };
  exports.default = Img;
  /***/
},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var invariant = function invariant(condition, format, a, b, c, d, e, f) {
      if (process.env.NODE_ENV !== 'production') {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      }

      if (!condition) {
        var error;

        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }

        error.framesToPop = 1; // we don't care about invariant's own frame

        throw error;
      }
    };

    module.exports = invariant;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(8); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string


  module.exports = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  /***/

},
/* 33 */

/***/
function (module, exports) {
  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };
  /***/

},
/* 34 */

/***/
function (module, exports) {
  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;

  module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
  /***/

},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  // most Object methods by ES6 should accept primitives
  var $export = __webpack_require__(0);

  var core = __webpack_require__(26);

  var fails = __webpack_require__(7);

  module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () {
      fn(1);
    }), 'Object', exp);
  };
  /***/

},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  // 0 -> Array#forEach
  // 1 -> Array#map
  // 2 -> Array#filter
  // 3 -> Array#some
  // 4 -> Array#every
  // 5 -> Array#find
  // 6 -> Array#findIndex
  var ctx = __webpack_require__(27);

  var IObject = __webpack_require__(62);

  var toObject = __webpack_require__(14);

  var toLength = __webpack_require__(13);

  var asc = __webpack_require__(111);

  module.exports = function (TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || asc;
    return function ($this, callbackfn, that) {
      var O = toObject($this);
      var self = IObject(O);
      var f = ctx(callbackfn, that, 3);
      var length = toLength(self.length);
      var index = 0;
      var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
      var val, res;

      for (; length > index; index++) {
        if (NO_HOLES || index in self) {
          val = self[index];
          res = f(val, index, O);

          if (TYPE) {
            if (IS_MAP) result[index] = res; // map
            else if (res) switch (TYPE) {
                case 3:
                  return true;
                // some

                case 5:
                  return val;
                // find

                case 6:
                  return index;
                // findIndex

                case 2:
                  result.push(val);
                // filter
              } else if (IS_EVERY) return false; // every
          }
        }
      }

      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
  };
  /***/

},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Links = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _reactRouterDom = __webpack_require__(87);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(445);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable jsx-a11y/anchor-is-valid */


  var Links = exports.Links = function Links(_ref) {
    var text = _ref.text,
        location = _ref.location,
        isExternal = _ref.isExternal,
        className = _ref.className,
        showExternalIcon = _ref.showExternalIcon,
        plainLink = _ref.plainLink;

    if (isExternal) {
      return _react2.default.createElement('a', {
        href: location,
        className: 'gr-cta ' + className + '\n        ' + className + '--external ' + (showExternalIcon ? 'gr-cta--icon' : ''),
        target: '_blank',
        rel: 'noopener noreferrer'
      }, _react2.default.createElement('span', {
        className: 'gr-cta__text ' + (showExternalIcon ? 'gr-cta__text--hide-arrow' : '')
      }, text), _react2.default.createElement('span', {
        className: 'sr-only'
      }, '(Opens in new window)'), showExternalIcon && _react2.default.createElement('i', {
        className: 'gr-icon icon-leave-site gr-cta__icon',
        'aria-hidden': 'true'
      }));
    }

    return _react2.default.createElement(_reactRouterDom.Link, {
      to: location,
      className: className
    }, _react2.default.createElement('span', {
      className: '' + (plainLink ? '' : 'gr-cta__text')
    }, text));
  };

  Links.propTypes = {
    text: _propTypes2.default.string.isRequired,
    location: _propTypes2.default.string.isRequired,
    isExternal: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    showExternalIcon: _propTypes2.default.bool,
    plainLink: _propTypes2.default.bool
  };
  Links.defaultProps = {
    isExternal: false,
    className: 'gr-cta',
    showExternalIcon: false,
    plainLink: false
  };
  exports.default = Links;
  /***/
},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  if (__webpack_require__(11)) {
    var LIBRARY = __webpack_require__(41);

    var global = __webpack_require__(6);

    var fails = __webpack_require__(7);

    var $export = __webpack_require__(0);

    var $typed = __webpack_require__(81);

    var $buffer = __webpack_require__(117);

    var ctx = __webpack_require__(27);

    var anInstance = __webpack_require__(50);

    var propertyDesc = __webpack_require__(43);

    var hide = __webpack_require__(18);

    var redefineAll = __webpack_require__(52);

    var toInteger = __webpack_require__(34);

    var toLength = __webpack_require__(13);

    var toIndex = __webpack_require__(156);

    var toAbsoluteIndex = __webpack_require__(46);

    var toPrimitive = __webpack_require__(32);

    var has = __webpack_require__(21);

    var classof = __webpack_require__(64);

    var isObject = __webpack_require__(8);

    var toObject = __webpack_require__(14);

    var isArrayIter = __webpack_require__(108);

    var create = __webpack_require__(47);

    var getPrototypeOf = __webpack_require__(24);

    var gOPN = __webpack_require__(48).f;

    var getIterFn = __webpack_require__(110);

    var uid = __webpack_require__(44);

    var wks = __webpack_require__(9);

    var createArrayMethod = __webpack_require__(36);

    var createArrayIncludes = __webpack_require__(71);

    var speciesConstructor = __webpack_require__(78);

    var ArrayIterators = __webpack_require__(113);

    var Iterators = __webpack_require__(59);

    var $iterDetect = __webpack_require__(75);

    var setSpecies = __webpack_require__(49);

    var arrayFill = __webpack_require__(112);

    var arrayCopyWithin = __webpack_require__(146);

    var $DP = __webpack_require__(12);

    var $GOPD = __webpack_require__(23);

    var dP = $DP.f;
    var gOPD = $GOPD.f;
    var RangeError = global.RangeError;
    var TypeError = global.TypeError;
    var Uint8Array = global.Uint8Array;
    var ARRAY_BUFFER = 'ArrayBuffer';
    var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
    var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var PROTOTYPE = 'prototype';
    var ArrayProto = Array[PROTOTYPE];
    var $ArrayBuffer = $buffer.ArrayBuffer;
    var $DataView = $buffer.DataView;
    var arrayForEach = createArrayMethod(0);
    var arrayFilter = createArrayMethod(2);
    var arraySome = createArrayMethod(3);
    var arrayEvery = createArrayMethod(4);
    var arrayFind = createArrayMethod(5);
    var arrayFindIndex = createArrayMethod(6);
    var arrayIncludes = createArrayIncludes(true);
    var arrayIndexOf = createArrayIncludes(false);
    var arrayValues = ArrayIterators.values;
    var arrayKeys = ArrayIterators.keys;
    var arrayEntries = ArrayIterators.entries;
    var arrayLastIndexOf = ArrayProto.lastIndexOf;
    var arrayReduce = ArrayProto.reduce;
    var arrayReduceRight = ArrayProto.reduceRight;
    var arrayJoin = ArrayProto.join;
    var arraySort = ArrayProto.sort;
    var arraySlice = ArrayProto.slice;
    var arrayToString = ArrayProto.toString;
    var arrayToLocaleString = ArrayProto.toLocaleString;
    var ITERATOR = wks('iterator');
    var TAG = wks('toStringTag');
    var TYPED_CONSTRUCTOR = uid('typed_constructor');
    var DEF_CONSTRUCTOR = uid('def_constructor');
    var ALL_CONSTRUCTORS = $typed.CONSTR;
    var TYPED_ARRAY = $typed.TYPED;
    var VIEW = $typed.VIEW;
    var WRONG_LENGTH = 'Wrong length!';
    var $map = createArrayMethod(1, function (O, length) {
      return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
    });
    var LITTLE_ENDIAN = fails(function () {
      // eslint-disable-next-line no-undef
      return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
    });
    var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
      new Uint8Array(1).set({});
    });

    var toOffset = function toOffset(it, BYTES) {
      var offset = toInteger(it);
      if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
      return offset;
    };

    var validate = function validate(it) {
      if (isObject(it) && TYPED_ARRAY in it) return it;
      throw TypeError(it + ' is not a typed array!');
    };

    var allocate = function allocate(C, length) {
      if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
        throw TypeError('It is not a typed array constructor!');
      }

      return new C(length);
    };

    var speciesFromList = function speciesFromList(O, list) {
      return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
    };

    var fromList = function fromList(C, list) {
      var index = 0;
      var length = list.length;
      var result = allocate(C, length);

      while (length > index) {
        result[index] = list[index++];
      }

      return result;
    };

    var addGetter = function addGetter(it, key, internal) {
      dP(it, key, {
        get: function get() {
          return this._d[internal];
        }
      });
    };

    var $from = function from(source
    /* , mapfn, thisArg */
    ) {
      var O = toObject(source);
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var iterFn = getIterFn(O);
      var i, length, values, result, step, iterator;

      if (iterFn != undefined && !isArrayIter(iterFn)) {
        for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
          values.push(step.value);
        }

        O = values;
      }

      if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);

      for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
        result[i] = mapping ? mapfn(O[i], i) : O[i];
      }

      return result;
    };

    var $of = function of()
    /* ...items */
    {
      var index = 0;
      var length = arguments.length;
      var result = allocate(this, length);

      while (length > index) {
        result[index] = arguments[index++];
      }

      return result;
    }; // iOS Safari 6.x fails here


    var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
      arrayToLocaleString.call(new Uint8Array(1));
    });

    var $toLocaleString = function toLocaleString() {
      return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
    };

    var proto = {
      copyWithin: function copyWithin(target, start
      /* , end */
      ) {
        return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
      },
      every: function every(callbackfn
      /* , thisArg */
      ) {
        return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      fill: function fill(value
      /* , start, end */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayFill.apply(validate(this), arguments);
      },
      filter: function filter(callbackfn
      /* , thisArg */
      ) {
        return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
      },
      find: function find(predicate
      /* , thisArg */
      ) {
        return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
      },
      findIndex: function findIndex(predicate
      /* , thisArg */
      ) {
        return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
      },
      forEach: function forEach(callbackfn
      /* , thisArg */
      ) {
        arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      indexOf: function indexOf(searchElement
      /* , fromIndex */
      ) {
        return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
      },
      includes: function includes(searchElement
      /* , fromIndex */
      ) {
        return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
      },
      join: function join(separator) {
        // eslint-disable-line no-unused-vars
        return arrayJoin.apply(validate(this), arguments);
      },
      lastIndexOf: function lastIndexOf(searchElement
      /* , fromIndex */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayLastIndexOf.apply(validate(this), arguments);
      },
      map: function map(mapfn
      /* , thisArg */
      ) {
        return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      reduce: function reduce(callbackfn
      /* , initialValue */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayReduce.apply(validate(this), arguments);
      },
      reduceRight: function reduceRight(callbackfn
      /* , initialValue */
      ) {
        // eslint-disable-line no-unused-vars
        return arrayReduceRight.apply(validate(this), arguments);
      },
      reverse: function reverse() {
        var that = this;
        var length = validate(that).length;
        var middle = Math.floor(length / 2);
        var index = 0;
        var value;

        while (index < middle) {
          value = that[index];
          that[index++] = that[--length];
          that[length] = value;
        }

        return that;
      },
      some: function some(callbackfn
      /* , thisArg */
      ) {
        return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      },
      sort: function sort(comparefn) {
        return arraySort.call(validate(this), comparefn);
      },
      subarray: function subarray(begin, end) {
        var O = validate(this);
        var length = O.length;
        var $begin = toAbsoluteIndex(begin, length);
        return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
      }
    };

    var $slice = function slice(start, end) {
      return speciesFromList(this, arraySlice.call(validate(this), start, end));
    };

    var $set = function set(arrayLike
    /* , offset */
    ) {
      validate(this);
      var offset = toOffset(arguments[1], 1);
      var length = this.length;
      var src = toObject(arrayLike);
      var len = toLength(src.length);
      var index = 0;
      if (len + offset > length) throw RangeError(WRONG_LENGTH);

      while (index < len) {
        this[offset + index] = src[index++];
      }
    };

    var $iterators = {
      entries: function entries() {
        return arrayEntries.call(validate(this));
      },
      keys: function keys() {
        return arrayKeys.call(validate(this));
      },
      values: function values() {
        return arrayValues.call(validate(this));
      }
    };

    var isTAIndex = function isTAIndex(target, key) {
      return isObject(target) && target[TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };

    var $getDesc = function getOwnPropertyDescriptor(target, key) {
      return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
    };

    var $setDesc = function defineProperty(target, key, desc) {
      if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set') // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
        target[key] = desc.value;
        return target;
      }

      return dP(target, key, desc);
    };

    if (!ALL_CONSTRUCTORS) {
      $GOPD.f = $getDesc;
      $DP.f = $setDesc;
    }

    $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
      getOwnPropertyDescriptor: $getDesc,
      defineProperty: $setDesc
    });

    if (fails(function () {
      arrayToString.call({});
    })) {
      arrayToString = arrayToLocaleString = function toString() {
        return arrayJoin.call(this);
      };
    }

    var $TypedArrayPrototype$ = redefineAll({}, proto);
    redefineAll($TypedArrayPrototype$, $iterators);
    hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
    redefineAll($TypedArrayPrototype$, {
      slice: $slice,
      set: $set,
      constructor: function constructor() {
        /* noop */
      },
      toString: arrayToString,
      toLocaleString: $toLocaleString
    });
    addGetter($TypedArrayPrototype$, 'buffer', 'b');
    addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
    addGetter($TypedArrayPrototype$, 'byteLength', 'l');
    addGetter($TypedArrayPrototype$, 'length', 'e');
    dP($TypedArrayPrototype$, TAG, {
      get: function get() {
        return this[TYPED_ARRAY];
      }
    }); // eslint-disable-next-line max-statements

    module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
      CLAMPED = !!CLAMPED;
      var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
      var GETTER = 'get' + KEY;
      var SETTER = 'set' + KEY;
      var TypedArray = global[NAME];
      var Base = TypedArray || {};
      var TAC = TypedArray && getPrototypeOf(TypedArray);
      var FORCED = !TypedArray || !$typed.ABV;
      var O = {};
      var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];

      var getter = function getter(that, index) {
        var data = that._d;
        return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
      };

      var setter = function setter(that, index, value) {
        var data = that._d;
        if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
        data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
      };

      var addElement = function addElement(that, index) {
        dP(that, index, {
          get: function get() {
            return getter(this, index);
          },
          set: function set(value) {
            return setter(this, index, value);
          },
          enumerable: true
        });
      };

      if (FORCED) {
        TypedArray = wrapper(function (that, data, $offset, $length) {
          anInstance(that, TypedArray, NAME, '_d');
          var index = 0;
          var offset = 0;
          var buffer, byteLength, length, klass;

          if (!isObject(data)) {
            length = toIndex(data);
            byteLength = length * BYTES;
            buffer = new $ArrayBuffer(byteLength);
          } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
            buffer = data;
            offset = toOffset($offset, BYTES);
            var $len = data.byteLength;

            if ($length === undefined) {
              if ($len % BYTES) throw RangeError(WRONG_LENGTH);
              byteLength = $len - offset;
              if (byteLength < 0) throw RangeError(WRONG_LENGTH);
            } else {
              byteLength = toLength($length) * BYTES;
              if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
            }

            length = byteLength / BYTES;
          } else if (TYPED_ARRAY in data) {
            return fromList(TypedArray, data);
          } else {
            return $from.call(TypedArray, data);
          }

          hide(that, '_d', {
            b: buffer,
            o: offset,
            l: byteLength,
            e: length,
            v: new $DataView(buffer)
          });

          while (index < length) {
            addElement(that, index++);
          }
        });
        TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
        hide(TypedArrayPrototype, 'constructor', TypedArray);
      } else if (!fails(function () {
        TypedArray(1);
      }) || !fails(function () {
        new TypedArray(-1); // eslint-disable-line no-new
      }) || !$iterDetect(function (iter) {
        new TypedArray(); // eslint-disable-line no-new

        new TypedArray(null); // eslint-disable-line no-new

        new TypedArray(1.5); // eslint-disable-line no-new

        new TypedArray(iter); // eslint-disable-line no-new
      }, true)) {
        TypedArray = wrapper(function (that, data, $offset, $length) {
          anInstance(that, TypedArray, NAME);
          var klass; // `ws` module bug, temporarily remove validation length for Uint8Array
          // https://github.com/websockets/ws/pull/645

          if (!isObject(data)) return new Base(toIndex(data));

          if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
            return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
          }

          if (TYPED_ARRAY in data) return fromList(TypedArray, data);
          return $from.call(TypedArray, data);
        });
        arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
          if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
        });
        TypedArray[PROTOTYPE] = TypedArrayPrototype;
        if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
      }

      var $nativeIterator = TypedArrayPrototype[ITERATOR];
      var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
      var $iterator = $iterators.values;
      hide(TypedArray, TYPED_CONSTRUCTOR, true);
      hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
      hide(TypedArrayPrototype, VIEW, true);
      hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

      if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
        dP(TypedArrayPrototype, TAG, {
          get: function get() {
            return NAME;
          }
        });
      }

      O[NAME] = TypedArray;
      $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
      $export($export.S, NAME, {
        BYTES_PER_ELEMENT: BYTES
      });
      $export($export.S + $export.F * fails(function () {
        Base.of.call(TypedArray, 1);
      }), NAME, {
        from: $from,
        of: $of
      });
      if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
      $export($export.P, NAME, proto);
      setSpecies(NAME);
      $export($export.P + $export.F * FORCED_SET, NAME, {
        set: $set
      });
      $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
      if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
      $export($export.P + $export.F * fails(function () {
        new TypedArray(1).slice();
      }), NAME, {
        slice: $slice
      });
      $export($export.P + $export.F * (fails(function () {
        return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
      }) || !fails(function () {
        TypedArrayPrototype.toLocaleString.call([1, 2]);
      })), NAME, {
        toLocaleString: $toLocaleString
      });
      Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
      if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
    };
  } else module.exports = function () {
    /* empty */
  };
  /***/

},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  var Map = __webpack_require__(151);

  var $export = __webpack_require__(0);

  var shared = __webpack_require__(70)('metadata');

  var store = shared.store || (shared.store = new (__webpack_require__(154))());

  var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
    var targetMetadata = store.get(target);

    if (!targetMetadata) {
      if (!create) return undefined;
      store.set(target, targetMetadata = new Map());
    }

    var keyMetadata = targetMetadata.get(targetKey);

    if (!keyMetadata) {
      if (!create) return undefined;
      targetMetadata.set(targetKey, keyMetadata = new Map());
    }

    return keyMetadata;
  };

  var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
    var metadataMap = getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
  };

  var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
    var metadataMap = getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
  };

  var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
    getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
  };

  var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
    var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function (_, key) {
      keys.push(key);
    });
    return keys;
  };

  var toMetaKey = function toMetaKey(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
  };

  var exp = function exp(O) {
    $export($export.S, 'Reflect', O);
  };

  module.exports = {
    store: store,
    map: getOrCreateMetadataMap,
    has: ordinaryHasOwnMetadata,
    get: ordinaryGetOwnMetadata,
    set: ordinaryDefineOwnMetadata,
    keys: ordinaryOwnMetadataKeys,
    key: toMetaKey,
    exp: exp
  };
  /***/
},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  var META = __webpack_require__(44)('meta');

  var isObject = __webpack_require__(8);

  var has = __webpack_require__(21);

  var setDesc = __webpack_require__(12).f;

  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !__webpack_require__(7)(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
  /***/
},
/* 41 */

/***/
function (module, exports) {
  module.exports = false;
  /***/
},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.3.31 Array.prototype[@@unscopables]
  var UNSCOPABLES = __webpack_require__(9)('unscopables');

  var ArrayProto = Array.prototype;
  if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(18)(ArrayProto, UNSCOPABLES, {});

  module.exports = function (key) {
    ArrayProto[UNSCOPABLES][key] = true;
  };
  /***/

},
/* 43 */

/***/
function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  /***/

},
/* 44 */

/***/
function (module, exports) {
  var id = 0;
  var px = Math.random();

  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };
  /***/

},
/* 45 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  var $keys = __webpack_require__(132);

  var enumBugKeys = __webpack_require__(95);

  module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
  };
  /***/

},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(34);

  var max = Math.max;
  var min = Math.min;

  module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };
  /***/

},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var anObject = __webpack_require__(5);

  var dPs = __webpack_require__(133);

  var enumBugKeys = __webpack_require__(95);

  var IE_PROTO = __webpack_require__(94)('IE_PROTO');

  var Empty = function Empty() {
    /* empty */
  };

  var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

  var _createDict = function createDict() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(92)('iframe');

    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';

    __webpack_require__(96).appendChild(iframe);

    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);

    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    _createDict = iframeDocument.F;

    while (i--) {
      delete _createDict[PROTOTYPE][enumBugKeys[i]];
    }

    return _createDict();
  };

  module.exports = Object.create || function create(O, Properties) {
    var result;

    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

      result[IE_PROTO] = O;
    } else result = _createDict();

    return Properties === undefined ? result : dPs(result, Properties);
  };
  /***/

},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var $keys = __webpack_require__(132);

  var hiddenKeys = __webpack_require__(95).concat('length', 'prototype');

  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
  };
  /***/

},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(6);

  var dP = __webpack_require__(12);

  var DESCRIPTORS = __webpack_require__(11);

  var SPECIES = __webpack_require__(9)('species');

  module.exports = function (KEY) {
    var C = global[KEY];
    if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  };
  /***/

},
/* 50 */

/***/
function (module, exports) {
  module.exports = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
      throw TypeError(name + ': incorrect invocation!');
    }

    return it;
  };
  /***/

},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  var ctx = __webpack_require__(27);

  var call = __webpack_require__(144);

  var isArrayIter = __webpack_require__(108);

  var anObject = __webpack_require__(5);

  var toLength = __webpack_require__(13);

  var getIterFn = __webpack_require__(110);

  var BREAK = {};
  var RETURN = {};

  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () {
      return iterable;
    } : getIterFn(iterable);
    var f = ctx(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

    if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
      result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      if (result === BREAK || result === RETURN) return result;
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      result = call(iterator, f, step.value, entries);
      if (result === BREAK || result === RETURN) return result;
    }
  };

  exports.BREAK = BREAK;
  exports.RETURN = RETURN;
  /***/
},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  var redefine = __webpack_require__(19);

  module.exports = function (target, src, safe) {
    for (var key in src) {
      redefine(target, key, src[key], safe);
    }

    return target;
  };
  /***/

},
/* 53 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction(arg) {
    return function () {
      return arg;
    };
  }
  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */


  var emptyFunction = function emptyFunction() {};

  emptyFunction.thatReturns = makeEmptyFunction;
  emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
  emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
  emptyFunction.thatReturnsNull = makeEmptyFunction(null);

  emptyFunction.thatReturnsThis = function () {
    return this;
  };

  emptyFunction.thatReturnsArgument = function (arg) {
    return arg;
  };

  module.exports = emptyFunction;
  /***/
},
/* 54 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    *
    */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var validateFormat = function validateFormat(format) {};

    if (process.env.NODE_ENV !== 'production') {
      validateFormat = function validateFormat(format) {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      };
    }

    function invariant(condition, format, a, b, c, d, e, f) {
      validateFormat(format);

      if (!condition) {
        var error;

        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }

        error.framesToPop = 1; // we don't care about invariant's own frame

        throw error;
      }
    }

    module.exports = invariant;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 55 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    function checkDCE() {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
        return;
      }

      if (process.env.NODE_ENV !== 'production') {
        // This branch is unreachable because this function is only called
        // in production, but the condition is true only in development.
        // Therefore if the branch is still here, dead code elimination wasn't
        // properly applied.
        // Don't change the message. React DevTools relies on it. Also make sure
        // this message doesn't occur elsewhere in this function, or it will cause
        // a false positive.
        throw new Error('^_^');
      }

      try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
      } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
      }
    }

    if (process.env.NODE_ENV === 'production') {
      // DCE check should happen before ReactDOM bundle executes so that
      // DevTools can report bad minification during injection.
      checkDCE();
      module.exports = __webpack_require__(506);
    } else {
      module.exports = __webpack_require__(509);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 56 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  var def = __webpack_require__(12).f;

  var has = __webpack_require__(21);

  var TAG = __webpack_require__(9)('toStringTag');

  module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
      configurable: true,
      value: tag
    });
  };
  /***/

},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var defined = __webpack_require__(33);

  var fails = __webpack_require__(7);

  var spaces = __webpack_require__(98);

  var space = '[' + spaces + ']';
  var non = "\u200B\x85";
  var ltrim = RegExp('^' + space + space + '*');
  var rtrim = RegExp(space + space + '*$');

  var exporter = function exporter(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = fails(function () {
      return !!spaces[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $export($export.P + $export.F * FORCE, 'String', exp);
  }; // 1 -> String#trimLeft
  // 2 -> String#trimRight
  // 3 -> String#trim


  var trim = exporter.trim = function (string, TYPE) {
    string = String(defined(string));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };

  module.exports = exporter;
  /***/
},
/* 59 */

/***/
function (module, exports) {
  module.exports = {};
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(8);

  module.exports = function (it, TYPE) {
    if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
  };
  /***/

},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.List = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(406);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var List = exports.List = function List(_ref) {
    var isOrdered = _ref.isOrdered,
        isInline = _ref.isInline,
        isUnstyled = _ref.isUnstyled,
        children = _ref.children,
        className = _ref.className;
    var classes = ['list'];

    if (isInline) {
      classes.push('list--inline');
    }

    if (isUnstyled) {
      classes.push('list--unstyled');
    }

    classes.push(className);
    return isOrdered ? _react2.default.createElement('ol', {
      className: classes.join(' ')
    }, children) : _react2.default.createElement('ul', {
      className: classes.join(' ')
    }, children);
  };

  List.propTypes = {
    isInline: _propTypes2.default.bool,
    isUnstyled: _propTypes2.default.bool,
    isOrdered: _propTypes2.default.bool,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element]).isRequired,
    className: _propTypes2.default.string
  };
  List.defaultProps = {
    isInline: false,
    isUnstyled: false,
    isOrdered: false,
    className: null
  };
  exports.default = List;
  /***/
},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var cof = __webpack_require__(28); // eslint-disable-next-line no-prototype-builtins


  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };
  /***/
},
/* 63 */

/***/
function (module, exports) {
  exports.f = {}.propertyIsEnumerable;
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  // getting tag from 19.1.3.6 Object.prototype.toString()
  var cof = __webpack_require__(28);

  var TAG = __webpack_require__(9)('toStringTag'); // ES3 wrong here


  var ARG = cof(function () {
    return arguments;
  }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

  var tryGet = function tryGet(it, key) {
    try {
      return it[key];
    } catch (e) {
      /* empty */
    }
  };

  module.exports = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
    : ARG ? cof(O) // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };
  /***/

},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /***/
},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
  };

  var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
  };

  var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
  };

  var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
  };

  var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
  };

  var parsePath = exports.parsePath = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');

    if (hashIndex !== -1) {
      hash = pathname.substr(hashIndex);
      pathname = pathname.substr(0, hashIndex);
    }

    var searchIndex = pathname.indexOf('?');

    if (searchIndex !== -1) {
      search = pathname.substr(searchIndex);
      pathname = pathname.substr(0, searchIndex);
    }

    return {
      pathname: pathname,
      search: search === '?' ? '' : search,
      hash: hash === '#' ? '' : hash
    };
  };

  var createPath = exports.createPath = function createPath(location) {
    var pathname = location.pathname,
        search = location.search,
        hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
  };
  /***/

},
/* 67 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return addLeadingSlash;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return stripLeadingSlash;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return hasBasename;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return stripBasename;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return stripTrailingSlash;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return parsePath;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return createPath;
  });

  var addLeadingSlash = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
  };

  var stripLeadingSlash = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
  };

  var hasBasename = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
  };

  var stripBasename = function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
  };

  var stripTrailingSlash = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
  };

  var parsePath = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');

    if (hashIndex !== -1) {
      hash = pathname.substr(hashIndex);
      pathname = pathname.substr(0, hashIndex);
    }

    var searchIndex = pathname.indexOf('?');

    if (searchIndex !== -1) {
      search = pathname.substr(searchIndex);
      pathname = pathname.substr(0, searchIndex);
    }

    return {
      pathname: pathname,
      search: search === '?' ? '' : search,
      hash: hash === '#' ? '' : hash
    };
  };

  var createPath = function createPath(location) {
    var pathname = location.pathname,
        search = location.search,
        hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
  };
  /***/

},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Carousel = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactSlick = __webpack_require__(503);

  var _reactSlick2 = _interopRequireDefault(_reactSlick);

  __webpack_require__(525);

  var _Arrow = __webpack_require__(527);

  var _generic = __webpack_require__(10);

  __webpack_require__(184);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Carousel = exports.Carousel = function (_PureComponent) {
    _inherits(Carousel, _PureComponent);

    function Carousel(props) {
      _classCallCheck(this, Carousel);

      var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

      var _this$props = _this.props,
          infinite = _this$props.infinite,
          adaptiveHeight = _this$props.adaptiveHeight,
          fullWidth = _this$props.fullWidth,
          autoPlaySpeed = _this$props.autoPlaySpeed,
          centerMode = _this$props.centerMode,
          arrows = _this$props.arrows,
          plainDesign = _this$props.plainDesign,
          heroDesign = _this$props.heroDesign,
          autoPlay = _this$props.autoPlay,
          dots = _this$props.dots;
      _this.sliderSettings = {
        infinite: infinite,
        adaptiveHeight: adaptiveHeight,
        speed: 500,
        slidesToShow: Number(fullWidth),
        slidesToScroll: 1,
        autoplay: autoPlay,
        autoplaySpeed: autoPlaySpeed,
        pauseOnHover: false,
        centerMode: centerMode,
        dots: dots,
        dotsClass: 'gr-carousel__dots',
        customPaging: function customPaging(i) {
          return _react2.default.createElement('button', {
            className: 'gr-carousel__dot'
          }, _react2.default.createElement('span', {
            className: 'sr-only'
          }, 'Go to slide ', i + 1));
        },
        arrows: arrows,
        nextArrow: _react2.default.createElement(_Arrow.Arrow, {
          type: 'next',
          plainDesign: plainDesign,
          heroDesign: heroDesign
        }),
        prevArrow: _react2.default.createElement(_Arrow.Arrow, {
          type: 'prev',
          plainDesign: plainDesign,
          heroDesign: heroDesign
        }),
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false
          }
        }]
      };
      return _this;
    }

    _createClass(Carousel, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.adaptiveHeight) {
          var IMAGES = this.slider.innerSlider.list.querySelectorAll('img');
          var loadedImgs = 0;
          [].slice.call(IMAGES).forEach(function (img) {
            img.addEventListener('load', function () {
              loadedImgs += 1;

              if (loadedImgs === IMAGES.length) {
                _this2.slider.innerSlider.adaptHeight();
              }
            });
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        return _react2.default.createElement('div', {
          className: 'gr-carousel'
        }, this.props.children.length && _react2.default.createElement(_reactSlick2.default, _extends({}, this.sliderSettings, {
          ref: function ref(node) {
            _this3.slider = node;
          }
        }), this.props.children.length && this.props.children.map(function (child) {
          return _react2.default.createElement('div', {
            key: (0, _generic.randomStr)(),
            className: 'gr-carousel__slide\n                ' + (_this3.sliderSettings.slidesToShow === 1 ? 'gr-carousel__slide--full-width' : '')
          }, child);
        })));
      }
    }]);

    return Carousel;
  }(_react.PureComponent);

  Carousel.propTypes = {
    plainDesign: _propTypes2.default.bool,
    fullWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
    centerMode: _propTypes2.default.bool,
    autoPlay: _propTypes2.default.bool,
    autoPlaySpeed: _propTypes2.default.number,
    children: _propTypes2.default.array,
    // eslint-disable-line react/forbid-prop-types
    infinite: _propTypes2.default.bool,
    adaptiveHeight: _propTypes2.default.bool,
    arrows: _propTypes2.default.bool,
    heroDesign: _propTypes2.default.bool,
    dots: _propTypes2.default.bool
  };
  Carousel.defaultProps = {
    plainDesign: false,
    fullWidth: 0,
    centerMode: true,
    autoPlaySpeed: 8000,
    autoPlay: false,
    children: null,
    infinite: true,
    adaptiveHeight: false,
    arrows: true,
    heroDesign: false,
    dots: false
  };
  exports.default = Carousel;
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports);
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports);
      global.String = mod.exports;
    }
  })(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var camelize = exports.camelize = function camelize(str) {
      return str.split(' ').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join('');
    };
  });
  /***/

},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  var core = __webpack_require__(26);

  var global = __webpack_require__(6);

  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || (global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: core.version,
    mode: __webpack_require__(41) ? 'pure' : 'global',
    copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
  });
  /***/
},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  // false -> Array#indexOf
  // true  -> Array#includes
  var toIObject = __webpack_require__(22);

  var toLength = __webpack_require__(13);

  var toAbsoluteIndex = __webpack_require__(46);

  module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value; // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare

      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++]; // eslint-disable-next-line no-self-compare

        if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if (IS_INCLUDES || index in O) {
          if (O[index] === el) return IS_INCLUDES || index || 0;
        }
      }
      return !IS_INCLUDES && -1;
    };
  };
  /***/

},
/* 72 */

/***/
function (module, exports) {
  exports.f = Object.getOwnPropertySymbols;
  /***/
},
/* 73 */

/***/
function (module, exports, __webpack_require__) {
  // 7.2.2 IsArray(argument)
  var cof = __webpack_require__(28);

  module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
  };
  /***/

},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  // 7.2.8 IsRegExp(argument)
  var isObject = __webpack_require__(8);

  var cof = __webpack_require__(28);

  var MATCH = __webpack_require__(9)('match');

  module.exports = function (it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
  };
  /***/

},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  var ITERATOR = __webpack_require__(9)('iterator');

  var SAFE_CLOSING = false;

  try {
    var riter = [7][ITERATOR]();

    riter['return'] = function () {
      SAFE_CLOSING = true;
    }; // eslint-disable-next-line no-throw-literal


    Array.from(riter, function () {
      throw 2;
    });
  } catch (e) {
    /* empty */
  }

  module.exports = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;

    try {
      var arr = [7];
      var iter = arr[ITERATOR]();

      iter.next = function () {
        return {
          done: safe = true
        };
      };

      arr[ITERATOR] = function () {
        return iter;
      };

      exec(arr);
    } catch (e) {
      /* empty */
    }

    return safe;
  };
  /***/

},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.2.5.3 get RegExp.prototype.flags

  var anObject = __webpack_require__(5);

  module.exports = function () {
    var that = anObject(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
  };
  /***/

},
/* 77 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var hide = __webpack_require__(18);

  var redefine = __webpack_require__(19);

  var fails = __webpack_require__(7);

  var defined = __webpack_require__(33);

  var wks = __webpack_require__(9);

  module.exports = function (KEY, length, exec) {
    var SYMBOL = wks(KEY);
    var fns = exec(defined, SYMBOL, ''[KEY]);
    var strfn = fns[0];
    var rxfn = fns[1];

    if (fails(function () {
      var O = {};

      O[SYMBOL] = function () {
        return 7;
      };

      return ''[KEY](O) != 7;
    })) {
      redefine(String.prototype, KEY, strfn);
      hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) {
        return rxfn.call(string, this, arg);
      } // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) {
        return rxfn.call(string, this);
      });
    }
  };
  /***/

},
/* 78 */

/***/
function (module, exports, __webpack_require__) {
  // 7.3.20 SpeciesConstructor(O, defaultConstructor)
  var anObject = __webpack_require__(5);

  var aFunction = __webpack_require__(16);

  var SPECIES = __webpack_require__(9)('species');

  module.exports = function (O, D) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
  };
  /***/

},
/* 79 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var navigator = global.navigator;
  module.exports = navigator && navigator.userAgent || '';
  /***/
},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(6);

  var $export = __webpack_require__(0);

  var redefine = __webpack_require__(19);

  var redefineAll = __webpack_require__(52);

  var meta = __webpack_require__(40);

  var forOf = __webpack_require__(51);

  var anInstance = __webpack_require__(50);

  var isObject = __webpack_require__(8);

  var fails = __webpack_require__(7);

  var $iterDetect = __webpack_require__(75);

  var setToStringTag = __webpack_require__(57);

  var inheritIfRequired = __webpack_require__(99);

  module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = global[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};

    var fixMethod = function fixMethod(KEY) {
      var fn = proto[KEY];
      redefine(proto, KEY, KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) {
        fn.call(this, a === 0 ? 0 : a);
        return this;
      } : function set(a, b) {
        fn.call(this, a === 0 ? 0 : a, b);
        return this;
      });
    };

    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
      new C().entries().next();
    }))) {
      // create collection constructor
      C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
      redefineAll(C.prototype, methods);
      meta.NEED = true;
    } else {
      var instance = new C(); // early implementations not supports chaining

      var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false

      var THROWS_ON_PRIMITIVES = fails(function () {
        instance.has(1);
      }); // most early implementations doesn't supports iterables, most modern - not close it correctly

      var ACCEPT_ITERABLES = $iterDetect(function (iter) {
        new C(iter);
      }); // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same

      var BUGGY_ZERO = !IS_WEAK && fails(function () {
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C();
        var index = 5;

        while (index--) {
          $instance[ADDER](index, index);
        }

        return !$instance.has(-0);
      });

      if (!ACCEPT_ITERABLES) {
        C = wrapper(function (target, iterable) {
          anInstance(target, C, NAME);
          var that = inheritIfRequired(new Base(), target, C);
          if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          return that;
        });
        C.prototype = proto;
        proto.constructor = C;
      }

      if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
        fixMethod('delete');
        fixMethod('has');
        IS_MAP && fixMethod('get');
      }

      if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

      if (IS_WEAK && proto.clear) delete proto.clear;
    }

    setToStringTag(C, NAME);
    O[NAME] = C;
    $export($export.G + $export.W + $export.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
  };
  /***/

},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var hide = __webpack_require__(18);

  var uid = __webpack_require__(44);

  var TYPED = uid('typed_array');
  var VIEW = uid('view');
  var ABV = !!(global.ArrayBuffer && global.DataView);
  var CONSTR = ABV;
  var i = 0;
  var l = 9;
  var Typed;
  var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

  while (i < l) {
    if (Typed = global[TypedArrayConstructors[i++]]) {
      hide(Typed.prototype, TYPED, true);
      hide(Typed.prototype, VIEW, true);
    } else CONSTR = false;
  }

  module.exports = {
    ABV: ABV,
    CONSTR: CONSTR,
    TYPED: TYPED,
    VIEW: VIEW
  };
  /***/
},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Forced replacement prototype accessors methods

  module.exports = __webpack_require__(41) || !__webpack_require__(7)(function () {
    var K = Math.random(); // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call

    __defineSetter__.call(null, K, function () {
      /* empty */
    });

    delete __webpack_require__(6)[K];
  });
  /***/
},
/* 83 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-setmap-offrom/

  var $export = __webpack_require__(0);

  module.exports = function (COLLECTION) {
    $export($export.S, COLLECTION, {
      of: function of() {
        var length = arguments.length;
        var A = new Array(length);

        while (length--) {
          A[length] = arguments[length];
        }

        return new this(A);
      }
    });
  };
  /***/

},
/* 84 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-setmap-offrom/

  var $export = __webpack_require__(0);

  var aFunction = __webpack_require__(16);

  var ctx = __webpack_require__(27);

  var forOf = __webpack_require__(51);

  module.exports = function (COLLECTION) {
    $export($export.S, COLLECTION, {
      from: function from(source
      /* , mapFn, thisArg */
      ) {
        var mapFn = arguments[1];
        var mapping, A, n, cb;
        aFunction(this);
        mapping = mapFn !== undefined;
        if (mapping) aFunction(mapFn);
        if (source == undefined) return new this();
        A = [];

        if (mapping) {
          n = 0;
          cb = ctx(mapFn, arguments[2], 2);
          forOf(source, false, function (nextItem) {
            A.push(cb(nextItem, n++));
          });
        } else {
          forOf(source, false, A.push, A);
        }

        return new this(A);
      }
    });
  };
  /***/

},
/* 85 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2014-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    *
    */
    var emptyFunction = __webpack_require__(53);
    /**
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */


    var warning = emptyFunction;

    if (process.env.NODE_ENV !== 'production') {
      var printWarning = function printWarning(format) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function () {
          return args[argIndex++];
        });

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };

      warning = function warning(condition, format) {
        if (format === undefined) {
          throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
        }

        if (format.indexOf('Failed Composite propType: ') === 0) {
          return; // Ignore CompositeComponent proptype check.
        }

        if (!condition) {
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }

          printWarning.apply(undefined, [format].concat(args));
        }
      };
    }

    module.exports = warning;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(_x, _x2, _x3) {
    var _again = true;

    _function: while (_again) {
      var object = _x,
          property = _x2,
          receiver = _x3;
      _again = false;
      if (object === null) object = Function.prototype;
      var desc = Object.getOwnPropertyDescriptor(object, property);

      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);

        if (parent === null) {
          return undefined;
        } else {
          _x = parent;
          _x2 = property;
          _x3 = receiver;
          _again = true;
          desc = parent = undefined;
          continue _function;
        }
      } else if ("value" in desc) {
        return desc.value;
      } else {
        var getter = desc.get;

        if (getter === undefined) {
          return undefined;
        }

        return getter.call(receiver);
      }
    }
  };

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _lodashThrottle = __webpack_require__(404);

  var _lodashThrottle2 = _interopRequireDefault(_lodashThrottle);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var ScrollAnimation = function (_Component) {
    _inherits(ScrollAnimation, _Component);

    function ScrollAnimation(props) {
      _classCallCheck(this, ScrollAnimation);

      _get(Object.getPrototypeOf(ScrollAnimation.prototype), "constructor", this).call(this, props);

      this.serverSide = typeof window === "undefined";
      this.listener = (0, _lodashThrottle2["default"])(this.handleScroll.bind(this), 50);
      this.visibility = {
        onScreen: false,
        inViewport: false
      };
      this.state = {
        classes: "animated",
        style: {
          animationDuration: this.props.duration + "s",
          opacity: this.props.initiallyVisible ? 1 : 0
        }
      };
    }

    _createClass(ScrollAnimation, [{
      key: "getElementTop",
      value: function getElementTop(elm) {
        var yPos = 0;

        while (elm && elm.offsetTop !== undefined && elm.clientTop !== undefined) {
          yPos += elm.offsetTop + elm.clientTop;
          elm = elm.offsetParent;
        }

        return yPos;
      }
    }, {
      key: "getScrollPos",
      value: function getScrollPos() {
        if (this.scrollableParent.pageYOffset !== undefined) {
          return this.scrollableParent.pageYOffset;
        }

        return this.scrollableParent.scrollTop;
      }
    }, {
      key: "getScrollableParentHeight",
      value: function getScrollableParentHeight() {
        if (this.scrollableParent.innerHeight !== undefined) {
          return this.scrollableParent.innerHeight;
        }

        return this.scrollableParent.clientHeight;
      }
    }, {
      key: "getViewportTop",
      value: function getViewportTop() {
        return this.getScrollPos() + this.props.offset;
      }
    }, {
      key: "getViewportBottom",
      value: function getViewportBottom() {
        return this.getScrollPos() + this.getScrollableParentHeight() - this.props.offset;
      }
    }, {
      key: "isInViewport",
      value: function isInViewport(y) {
        return y >= this.getViewportTop() && y <= this.getViewportBottom();
      }
    }, {
      key: "isAboveViewport",
      value: function isAboveViewport(y) {
        return y < this.getViewportTop();
      }
    }, {
      key: "isBelowViewport",
      value: function isBelowViewport(y) {
        return y > this.getViewportBottom();
      }
    }, {
      key: "inViewport",
      value: function inViewport(elementTop, elementBottom) {
        return this.isInViewport(elementTop) || this.isInViewport(elementBottom) || this.isAboveViewport(elementTop) && this.isBelowViewport(elementBottom);
      }
    }, {
      key: "onScreen",
      value: function onScreen(elementTop, elementBottom) {
        return !this.isAboveScreen(elementBottom) && !this.isBelowScreen(elementTop);
      }
    }, {
      key: "isAboveScreen",
      value: function isAboveScreen(y) {
        return y < this.getScrollPos();
      }
    }, {
      key: "isBelowScreen",
      value: function isBelowScreen(y) {
        return y > this.getScrollPos() + this.getScrollableParentHeight();
      }
    }, {
      key: "getVisibility",
      value: function getVisibility() {
        var elementTop = this.getElementTop(this.node) - this.getElementTop(this.scrollableParent);
        var elementBottom = elementTop + this.node.clientHeight;
        return {
          inViewport: this.inViewport(elementTop, elementBottom),
          onScreen: this.onScreen(elementTop, elementBottom)
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.serverSide) {
          var parentSelector = this.props.scrollableParentSelector;
          this.scrollableParent = parentSelector ? document.querySelector(parentSelector) : window;

          if (this.scrollableParent && this.scrollableParent.addEventListener) {
            this.scrollableParent.addEventListener("scroll", this.listener);
          } else {
            console.warn("Cannot find element by locator: " + this.props.scrollableParentSelector);
          }

          if (this.props.animatePreScroll) {
            this.handleScroll();
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearTimeout(this.delayedAnimationTimeout);
        clearTimeout(this.callbackTimeout);

        if (window && window.removeEventListener) {
          window.removeEventListener("scroll", this.listener);
        }
      }
    }, {
      key: "visibilityHasChanged",
      value: function visibilityHasChanged(previousVis, currentVis) {
        return previousVis.inViewport !== currentVis.inViewport || previousVis.onScreen !== currentVis.onScreen;
      }
    }, {
      key: "animate",
      value: function animate(animation, callback) {
        var _this = this;

        this.delayedAnimationTimeout = setTimeout(function () {
          _this.animating = true;

          _this.setState({
            classes: "animated " + animation,
            style: {
              animationDuration: _this.props.duration + "s"
            }
          });

          _this.callbackTimeout = setTimeout(callback, _this.props.duration * 1000);
        }, this.props.delay);
      }
    }, {
      key: "animateIn",
      value: function animateIn(callback) {
        var _this2 = this;

        this.animate(this.props.animateIn, function () {
          if (!_this2.props.animateOnce) {
            _this2.setState({
              style: {
                animationDuration: _this2.props.duration + "s",
                opacity: 1
              }
            });

            _this2.animating = false;
          }

          var vis = _this2.getVisibility();

          if (callback) {
            callback(vis);
          }
        });
      }
    }, {
      key: "animateOut",
      value: function animateOut(callback) {
        var _this3 = this;

        this.animate(this.props.animateOut, function () {
          _this3.setState({
            classes: "animated",
            style: {
              animationDuration: _this3.props.duration + "s",
              opacity: 0
            }
          });

          var vis = _this3.getVisibility();

          if (vis.inViewport && _this3.props.animateIn) {
            _this3.animateIn(_this3.props.afterAnimatedIn);
          } else {
            _this3.animating = false;
          }

          if (callback) {
            callback(vis);
          }
        });
      }
    }, {
      key: "handleScroll",
      value: function handleScroll() {
        if (!this.animating) {
          var currentVis = this.getVisibility();

          if (this.visibilityHasChanged(this.visibility, currentVis)) {
            clearTimeout(this.delayedAnimationTimeout);

            if (!currentVis.onScreen) {
              this.setState({
                classes: "animated",
                style: {
                  animationDuration: this.props.duration + "s",
                  opacity: this.props.initiallyVisible ? 1 : 0
                }
              });
            } else if (currentVis.inViewport && this.props.animateIn) {
              this.animateIn(this.props.afterAnimatedIn);
            } else if (currentVis.onScreen && this.visibility.inViewport && this.props.animateOut && this.state.style.opacity === 1) {
              this.animateOut(this.props.afterAnimatedOut);
            }

            this.visibility = currentVis;
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        var classes = this.props.className ? this.props.className + " " + this.state.classes : this.state.classes;
        return _react2["default"].createElement("div", {
          ref: function ref(node) {
            _this4.node = node;
          },
          className: classes,
          style: Object.assign({}, this.state.style, this.props.style)
        }, this.props.children);
      }
    }]);

    return ScrollAnimation;
  }(_react.Component);

  exports["default"] = ScrollAnimation;
  ScrollAnimation.defaultProps = {
    offset: 150,
    duration: 1,
    initiallyVisible: false,
    delay: 0,
    animateOnce: false,
    animatePreScroll: true
  };
  ScrollAnimation.propTypes = {
    animateIn: _propTypes2["default"].string,
    animateOut: _propTypes2["default"].string,
    offset: _propTypes2["default"].number,
    duration: _propTypes2["default"].number,
    delay: _propTypes2["default"].number,
    initiallyVisible: _propTypes2["default"].bool,
    animateOnce: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    scrollableParentSelector: _propTypes2["default"].string,
    className: _propTypes2["default"].string,
    animatePreScroll: _propTypes2["default"].bool
  };
  module.exports = exports["default"];
  /***/
},
/* 87 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(419);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "BrowserRouter", function () {
    return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(421);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "HashRouter", function () {
    return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(167);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Link", function () {
    return __WEBPACK_IMPORTED_MODULE_2__Link__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(423);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "MemoryRouter", function () {
    return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(426);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "NavLink", function () {
    return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(429);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Prompt", function () {
    return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(431);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Redirect", function () {
    return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(168);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Route", function () {
    return __WEBPACK_IMPORTED_MODULE_7__Route__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(122);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Router", function () {
    return __WEBPACK_IMPORTED_MODULE_8__Router__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(437);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "StaticRouter", function () {
    return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(439);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Switch", function () {
    return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(441);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "matchPath", function () {
    return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(442);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "withRouter", function () {
    return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"];
  });
  /***/

},
/* 88 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return createLocation;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return locationsAreEqual;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(164);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(165);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(67);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var createLocation = function createLocation(path, state, key, currentLocation) {
    var location = void 0;

    if (typeof path === 'string') {
      // Two-arg form: push(path, state)
      location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d"
      /* parsePath */
      ])(path);
      location.state = state;
    } else {
      // One-arg form: push(location)
      location = _extends({}, path);
      if (location.pathname === undefined) location.pathname = '';

      if (location.search) {
        if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
      } else {
        location.search = '';
      }

      if (location.hash) {
        if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
      } else {
        location.hash = '';
      }

      if (state !== undefined && location.state === undefined) location.state = state;
    }

    try {
      location.pathname = decodeURI(location.pathname);
    } catch (e) {
      if (e instanceof URIError) {
        throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
      } else {
        throw e;
      }
    }

    if (key) location.key = key;

    if (currentLocation) {
      // Resolve incomplete/relative pathname relative to current location.
      if (!location.pathname) {
        location.pathname = currentLocation.pathname;
      } else if (location.pathname.charAt(0) !== '/') {
        location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
      }
    } else {
      // When there is no prior location and pathname is empty, set it to /
      if (!location.pathname) {
        location.pathname = '/';
      }
    }

    return location;
  };

  var locationsAreEqual = function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
  };
  /***/

},
/* 89 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    *
    */
    var emptyObject = {};

    if (process.env.NODE_ENV !== 'production') {
      Object.freeze(emptyObject);
    }

    module.exports = emptyObject;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 90 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
  */

  /* global define */


  (function () {
    'use strict';

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          classes.push(classNames.apply(null, arg));
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (typeof module !== 'undefined' && module.exports) {
      module.exports = classNames;
    } else if (true) {
      // register as 'classnames', consistent with npm package name
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return classNames;
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      window.classNames = classNames;
    }
  })();
  /***/

},
/* 91 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _reactDom = __webpack_require__(55);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = lazyStartIndex(spec);
    var endIndex = lazyEndIndex(spec);

    for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
      if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
        onDemandSlides.push(slideIndex);
      }
    }

    return onDemandSlides;
  }; // return list of slides that need to be present


  var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = lazyStartIndex(spec);
    var endIndex = lazyEndIndex(spec);

    for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
      requiredSlides.push(slideIndex);
    }

    return requiredSlides;
  }; // startIndex that needs to be present


  var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - lazySlidesOnLeft(spec);
  };

  var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + lazySlidesOnRight(spec);
  };

  var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
  };

  var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
  }; // get width of an element


  var getWidth = exports.getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
  };

  var getHeight = exports.getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
  };

  var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);

    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }

    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return "left";
    }

    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return "right";
    }

    if (verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return "up";
      } else {
        return "down";
      }
    }

    return "vertical";
  }; // whether or not we can go next


  var canGoNext = exports.canGoNext = function canGoNext(spec) {
    var canGo = true;

    if (!spec.infinite) {
      if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
        canGo = false;
      } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
        canGo = false;
      }
    }

    return canGo;
  }; // given an object and a list of keys, return new object with given keys


  var extractObject = exports.extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function (key) {
      return newObject[key] = spec[key];
    });
    return newObject;
  }; // get initialized state


  var initializedState = exports.initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = _react2.default.Children.count(spec.children);

    var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
    var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
    var slideWidth = void 0;

    if (!spec.vertical) {
      var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

      if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
        centerPaddingAdj *= listWidth / 100;
      }

      slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else {
      slideWidth = listWidth;
    }

    var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

    if (spec.rtl && spec.currentSlide === undefined) {
      currentSlide = slideCount - 1 - spec.initialSlide;
    }

    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = getOnDemandLazySlides({
      currentSlide: currentSlide,
      lazyLoadedList: lazyLoadedList
    }, spec);
    lazyLoadedList.concat(slidesToLoad);
    var state = {
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      currentSlide: currentSlide,
      slideHeight: slideHeight,
      listHeight: listHeight,
      lazyLoadedList: lazyLoadedList
    };

    if (spec.autoplaying === null && spec.autoplay) {
      state["autoplaying"] = "playing";
    }

    return state;
  };

  var slideHandler = exports.slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate,
        animating = spec.animating,
        fade = spec.fade,
        infinite = spec.infinite,
        index = spec.index,
        slideCount = spec.slideCount,
        lazyLoadedList = spec.lazyLoadedList,
        lazyLoad = spec.lazyLoad,
        currentSlide = spec.currentSlide,
        centerMode = spec.centerMode,
        slidesToScroll = spec.slidesToScroll,
        slidesToShow = spec.slidesToShow,
        useCSS = spec.useCSS;
    if (waitForAnimate && animating) return {};
    var animationSlide = index,
        finalSlide = void 0,
        animationLeft = void 0,
        finalLeft = void 0;
    var state = {},
        nextState = {};

    if (fade) {
      if (!infinite && (index < 0 || index >= slideCount)) return {};

      if (index < 0) {
        animationSlide = index + slideCount;
      } else if (index >= slideCount) {
        animationSlide = index - slideCount;
      }

      if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
        lazyLoadedList.push(animationSlide);
      }

      state = {
        animating: true,
        currentSlide: animationSlide,
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false
      };
    } else {
      finalSlide = animationSlide;

      if (animationSlide < 0) {
        finalSlide = animationSlide + slideCount;
        if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
      } else if (!canGoNext(spec) && animationSlide > currentSlide) {
        animationSlide = finalSlide = currentSlide;
      } else if (centerMode && animationSlide >= slideCount) {
        animationSlide = infinite ? slideCount : slideCount - 1;
        finalSlide = infinite ? 0 : slideCount - 1;
      } else if (animationSlide >= slideCount) {
        finalSlide = animationSlide - slideCount;
        if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
      }

      animationLeft = getTrackLeft(_extends({}, spec, {
        slideIndex: animationSlide
      }));
      finalLeft = getTrackLeft(_extends({}, spec, {
        slideIndex: finalSlide
      }));

      if (!infinite) {
        if (animationLeft === finalLeft) animationSlide = finalSlide;
        animationLeft = finalLeft;
      }

      lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, {
        currentSlide: animationSlide
      })));

      if (!useCSS) {
        state = {
          currentSlide: finalSlide,
          trackStyle: getTrackCSS(_extends({}, spec, {
            left: finalLeft
          })),
          lazyLoadedList: lazyLoadedList
        };
      } else {
        state = {
          animating: true,
          currentSlide: finalSlide,
          trackStyle: getTrackAnimateCSS(_extends({}, spec, {
            left: animationLeft
          })),
          lazyLoadedList: lazyLoadedList
        };
        nextState = {
          animating: false,
          currentSlide: finalSlide,
          trackStyle: getTrackCSS(_extends({}, spec, {
            left: finalLeft
          })),
          swipeLeft: null
        };
      }
    }

    return {
      state: state,
      nextState: nextState
    };
  };

  var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll,
        slidesToShow = spec.slidesToShow,
        slideCount = spec.slideCount,
        currentSlide = spec.currentSlide,
        lazyLoad = spec.lazyLoad,
        infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

    if (options.message === "previous") {
      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
      targetSlide = currentSlide - slideOffset;

      if (lazyLoad && !infinite) {
        previousInt = currentSlide - slideOffset;
        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
      }
    } else if (options.message === "next") {
      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
      targetSlide = currentSlide + slideOffset;

      if (lazyLoad && !infinite) {
        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
      }
    } else if (options.message === "dots") {
      // Click on dots
      targetSlide = options.index * options.slidesToScroll;

      if (targetSlide === options.currentSlide) {
        return null;
      }
    } else if (options.message === "children") {
      // Click on the slides
      targetSlide = options.index;

      if (targetSlide === options.currentSlide) {
        return null;
      }

      if (infinite) {
        var direction = siblingDirection(_extends({}, spec, {
          targetSlide: targetSlide
        }));

        if (targetSlide > options.currentSlide && direction === "left") {
          targetSlide = targetSlide - slideCount;
        } else if (targetSlide < options.currentSlide && direction === "right") {
          targetSlide = targetSlide + slideCount;
        }
      }
    } else if (options.message === "index") {
      targetSlide = Number(options.index);

      if (targetSlide === options.currentSlide) {
        return null;
      }
    }

    return targetSlide;
  };

  var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
  };

  var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && e.preventDefault();
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
      dragging: true,
      touchObject: {
        startX: e.touches ? e.touches[0].pageX : e.clientX,
        startY: e.touches ? e.touches[0].pageY : e.clientY,
        curX: e.touches ? e.touches[0].pageX : e.clientX,
        curY: e.touches ? e.touches[0].pageY : e.clientY
      }
    };
  };

  var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling,
        animating = spec.animating,
        vertical = spec.vertical,
        swipeToSlide = spec.swipeToSlide,
        verticalSwiping = spec.verticalSwiping,
        rtl = spec.rtl,
        currentSlide = spec.currentSlide,
        edgeFriction = spec.edgeFriction,
        edgeDragged = spec.edgeDragged,
        onEdge = spec.onEdge,
        swiped = spec.swiped,
        swiping = spec.swiping,
        slideCount = spec.slideCount,
        slidesToScroll = spec.slidesToScroll,
        infinite = spec.infinite,
        touchObject = spec.touchObject,
        swipeEvent = spec.swipeEvent,
        listHeight = spec.listHeight,
        listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return e.preventDefault();
    if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
    var swipeLeft = void 0,
        state = {};
    var curLeft = getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
      return {
        scrolling: true
      };
    }

    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;

    if (!infinite) {
      if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
        touchSwipeLength = touchObject.swipeLength * edgeFriction;

        if (edgeDragged === false && onEdge) {
          onEdge(swipeDirection);
          state["edgeDragged"] = true;
        }
      }
    }

    if (!swiped && swipeEvent) {
      swipeEvent(swipeDirection);
      state["swiped"] = true;
    }

    if (!vertical) {
      if (!rtl) {
        swipeLeft = curLeft + touchSwipeLength * positionOffset;
      } else {
        swipeLeft = curLeft - touchSwipeLength * positionOffset;
      }
    } else {
      swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    }

    if (verticalSwiping) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    }

    state = _extends({}, state, {
      touchObject: touchObject,
      swipeLeft: swipeLeft,
      trackStyle: getTrackCSS(_extends({}, spec, {
        left: swipeLeft
      }))
    });

    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
      return state;
    }

    if (touchObject.swipeLength > 10) {
      state["swiping"] = true;
      e.preventDefault();
    }

    return state;
  };

  var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging,
        swipe = spec.swipe,
        touchObject = spec.touchObject,
        listWidth = spec.listWidth,
        touchThreshold = spec.touchThreshold,
        verticalSwiping = spec.verticalSwiping,
        listHeight = spec.listHeight,
        currentSlide = spec.currentSlide,
        swipeToSlide = spec.swipeToSlide,
        scrolling = spec.scrolling,
        onSwipe = spec.onSwipe;

    if (!dragging) {
      if (swipe) e.preventDefault();
      return {};
    }

    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

    var state = {
      dragging: false,
      edgeDragged: false,
      scrolling: false,
      swiping: false,
      swiped: false,
      swipeLeft: null,
      touchObject: {}
    };

    if (scrolling) {
      return state;
    }

    if (!touchObject.swipeLength) {
      return state;
    }

    if (touchObject.swipeLength > minSwipe) {
      e.preventDefault();

      if (onSwipe) {
        onSwipe(swipeDirection);
      }

      var slideCount = void 0,
          newSlide = void 0;

      switch (swipeDirection) {
        case "left":
        case "up":
          newSlide = currentSlide + getSlideCount(spec);
          slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
          state["currentDirection"] = 0;
          break;

        case "right":
        case "down":
          newSlide = currentSlide - getSlideCount(spec);
          slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
          state["currentDirection"] = 1;
          break;

        default:
          slideCount = currentSlide;
      }

      state["triggerSlideHandler"] = slideCount;
    } else {
      // Adjust the track back to it's original position.
      var currentLeft = getTrackLeft(spec);
      state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, {
        left: currentLeft
      }));
    }

    return state;
  };

  var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];

    while (breakpoint < max) {
      indexes.push(breakpoint);
      breakpoint = counter + spec.slidesToScroll;
      counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }

    return indexes;
  };

  var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
    var navigables = getNavigableIndexes(spec);
    var prevNavigable = 0;

    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }

        prevNavigable = navigables[n];
      }
    }

    return index;
  };

  var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

    if (spec.swipeToSlide) {
      var swipedSlide = void 0;

      var slickList = _reactDom2.default.findDOMNode(spec.listRef);

      var slides = slickList.querySelectorAll(".slick-slide");
      Array.from(slides).every(function (slide) {
        if (!spec.vertical) {
          if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        } else {
          if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        }

        return true;
      });

      if (!swipedSlide) {
        return 0;
      }

      var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
      var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
      return slidesTraversed;
    } else {
      return spec.slidesToScroll;
    }
  };

  var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function (value, key) {
      return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
  };

  var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
    checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
    var trackWidth = void 0,
        trackHeight = void 0;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

    if (!spec.vertical) {
      trackWidth = getTotalSlides(spec) * spec.slideWidth;
    } else {
      trackHeight = trackChildren * spec.slideHeight;
    }

    var style = {
      opacity: 1,
      transition: "",
      WebkitTransition: ""
    };

    if (spec.useTransform) {
      var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
      var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
      var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
      style = _extends({}, style, {
        WebkitTransform: WebkitTransform,
        transform: transform,
        msTransform: msTransform
      });
    } else {
      if (spec.vertical) {
        style["top"] = spec.left;
      } else {
        style["left"] = spec.left;
      }
    }

    if (spec.fade) style = {
      opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight; // Fallback for IE8

    if (window && !window.addEventListener && window.attachEvent) {
      if (!spec.vertical) {
        style.marginLeft = spec.left + "px";
      } else {
        style.marginTop = spec.left + "px";
      }
    }

    return style;
  };

  var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
    var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

    if (spec.useTransform) {
      style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
      style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else {
      if (spec.vertical) {
        style.transition = "top " + spec.speed + "ms " + spec.cssEase;
      } else {
        style.transition = "left " + spec.speed + "ms " + spec.cssEase;
      }
    }

    return style;
  };

  var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) {
      return 0;
    }

    checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
    var slideIndex = spec.slideIndex,
        trackRef = spec.trackRef,
        infinite = spec.infinite,
        centerMode = spec.centerMode,
        slideCount = spec.slideCount,
        slidesToShow = spec.slidesToShow,
        slidesToScroll = spec.slidesToScroll,
        slideWidth = spec.slideWidth,
        listWidth = spec.listWidth,
        variableWidth = spec.variableWidth,
        slideHeight = spec.slideHeight,
        fade = spec.fade,
        vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;

    if (fade || spec.slideCount === 1) {
      return 0;
    }

    var slidesToOffset = 0;

    if (infinite) {
      slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
      // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

      if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
        slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
      } // shift current slide to center of the frame


      if (centerMode) {
        slidesToOffset += parseInt(slidesToShow / 2);
      }
    } else {
      if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
        slidesToOffset = slidesToShow - slideCount % slidesToScroll;
      }

      if (centerMode) {
        slidesToOffset = parseInt(slidesToShow / 2);
      }
    }

    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;

    if (!vertical) {
      targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    } else {
      targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    }

    if (variableWidth === true) {
      var targetSlideIndex;

      var trackElem = _reactDom2.default.findDOMNode(trackRef);

      targetSlideIndex = slideIndex + getPreClones(spec);
      targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
      targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

      if (centerMode === true) {
        targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
        targetSlide = trackElem && trackElem.children[targetSlideIndex];
        targetLeft = 0;

        for (var slide = 0; slide < targetSlideIndex; slide++) {
          targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
        }

        targetLeft -= parseInt(spec.centerPadding);
        targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
      }
    }

    return targetLeft;
  };

  var getPreClones = exports.getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) {
      return 0;
    }

    if (spec.variableWidth) {
      return spec.slideCount;
    }

    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
  };

  var getPostClones = exports.getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) {
      return 0;
    }

    return spec.slideCount;
  };

  var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
  };

  var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
      if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
        return "left";
      }

      return "right";
    } else {
      if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
        return "right";
      }

      return "left";
    }
  };

  var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow,
        centerMode = _ref.centerMode,
        rtl = _ref.rtl,
        centerPadding = _ref.centerPadding; // returns no of slides on the right of active slide

    if (centerMode) {
      var right = (slidesToShow - 1) / 2 + 1;
      if (parseInt(centerPadding) > 0) right += 1;
      if (rtl && slidesToShow % 2 === 0) right += 1;
      return right;
    }

    if (rtl) {
      return 0;
    }

    return slidesToShow - 1;
  };

  var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow,
        centerMode = _ref2.centerMode,
        rtl = _ref2.rtl,
        centerPadding = _ref2.centerPadding; // returns no of slides on the left of active slide

    if (centerMode) {
      var left = (slidesToShow - 1) / 2 + 1;
      if (parseInt(centerPadding) > 0) left += 1;
      if (!rtl && slidesToShow % 2 === 0) left += 1;
      return left;
    }

    if (rtl) {
      return slidesToShow - 1;
    }

    return 0;
  };

  var canUseDOM = exports.canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
  };
  /***/

},
/* 92 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(8);

  var document = __webpack_require__(6).document; // typeof document.createElement is 'object' in old IE


  var is = isObject(document) && isObject(document.createElement);

  module.exports = function (it) {
    return is ? document.createElement(it) : {};
  };
  /***/

},
/* 93 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var core = __webpack_require__(26);

  var LIBRARY = __webpack_require__(41);

  var wksExt = __webpack_require__(131);

  var defineProperty = __webpack_require__(12).f;

  module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
      value: wksExt.f(name)
    });
  };
  /***/

},
/* 94 */

/***/
function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(70)('keys');

  var uid = __webpack_require__(44);

  module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
  };
  /***/

},
/* 95 */

/***/
function (module, exports) {
  // IE 8- don't enum bug keys
  module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
  /***/
},
/* 96 */

/***/
function (module, exports, __webpack_require__) {
  var document = __webpack_require__(6).document;

  module.exports = document && document.documentElement;
  /***/
},
/* 97 */

/***/
function (module, exports, __webpack_require__) {
  // Works with __proto__ only. Old v8 can't work with null proto objects.

  /* eslint-disable no-proto */
  var isObject = __webpack_require__(8);

  var anObject = __webpack_require__(5);

  var check = function check(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };

  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(27)(Function.call, __webpack_require__(23).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }

      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };
  /***/
},
/* 98 */

/***/
function (module, exports) {
  module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  /***/
},
/* 99 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(8);

  var setPrototypeOf = __webpack_require__(97).set;

  module.exports = function (that, target, C) {
    var S = target.constructor;
    var P;

    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
      setPrototypeOf(that, P);
    }

    return that;
  };
  /***/

},
/* 100 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var toInteger = __webpack_require__(34);

  var defined = __webpack_require__(33);

  module.exports = function repeat(count) {
    var str = String(defined(this));
    var res = '';
    var n = toInteger(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

    for (; n > 0; (n >>>= 1) && (str += str)) {
      if (n & 1) res += str;
    }

    return res;
  };
  /***/

},
/* 101 */

/***/
function (module, exports) {
  // 20.2.2.28 Math.sign(x)
  module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
  };
  /***/

},
/* 102 */

/***/
function (module, exports) {
  // 20.2.2.14 Math.expm1(x)
  var $expm1 = Math.expm1;
  module.exports = !$expm1 // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 // Tor Browser bug
  || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
  } : $expm1;
  /***/
},
/* 103 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(34);

  var defined = __webpack_require__(33); // true  -> String#at
  // false -> String#codePointAt


  module.exports = function (TO_STRING) {
    return function (that, pos) {
      var s = String(defined(that));
      var i = toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };
  /***/

},
/* 104 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(41);

  var $export = __webpack_require__(0);

  var redefine = __webpack_require__(19);

  var hide = __webpack_require__(18);

  var Iterators = __webpack_require__(59);

  var $iterCreate = __webpack_require__(105);

  var setToStringTag = __webpack_require__(57);

  var getPrototypeOf = __webpack_require__(24);

  var ITERATOR = __webpack_require__(9)('iterator');

  var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

  var FF_ITERATOR = '@@iterator';
  var KEYS = 'keys';
  var VALUES = 'values';

  var returnThis = function returnThis() {
    return this;
  };

  module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);

    var getMethod = function getMethod(kind) {
      if (!BUGGY && kind in proto) return proto[kind];

      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };

        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }

      return function entries() {
        return new Constructor(this, kind);
      };
    };

    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype; // Fix native

    if ($anyNative) {
      IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        // Set @@toStringTag to native iterators
        setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
      }
    } // fix Array#{values, @@iterator}.name in V8 / FF


    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;

      $default = function values() {
        return $native.call(this);
      };
    } // Define iterator


    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      hide(proto, ITERATOR, $default);
    } // Plug for library


    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;

    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) redefine(proto, key, methods[key]);
      } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }

    return methods;
  };
  /***/

},
/* 105 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var create = __webpack_require__(47);

  var descriptor = __webpack_require__(43);

  var setToStringTag = __webpack_require__(57);

  var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

  __webpack_require__(18)(IteratorPrototype, __webpack_require__(9)('iterator'), function () {
    return this;
  });

  module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
      next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + ' Iterator');
  };
  /***/

},
/* 106 */

/***/
function (module, exports, __webpack_require__) {
  // helper for String#{startsWith, endsWith, includes}
  var isRegExp = __webpack_require__(74);

  var defined = __webpack_require__(33);

  module.exports = function (that, searchString, NAME) {
    if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String(defined(that));
  };
  /***/

},
/* 107 */

/***/
function (module, exports, __webpack_require__) {
  var MATCH = __webpack_require__(9)('match');

  module.exports = function (KEY) {
    var re = /./;

    try {
      '/./'[KEY](re);
    } catch (e) {
      try {
        re[MATCH] = false;
        return !'/./'[KEY](re);
      } catch (f) {
        /* empty */
      }
    }

    return true;
  };
  /***/

},
/* 108 */

/***/
function (module, exports, __webpack_require__) {
  // check on default Array iterator
  var Iterators = __webpack_require__(59);

  var ITERATOR = __webpack_require__(9)('iterator');

  var ArrayProto = Array.prototype;

  module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
  };
  /***/

},
/* 109 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $defineProperty = __webpack_require__(12);

  var createDesc = __webpack_require__(43);

  module.exports = function (object, index, value) {
    if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
  };
  /***/

},
/* 110 */

/***/
function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(64);

  var ITERATOR = __webpack_require__(9)('iterator');

  var Iterators = __webpack_require__(59);

  module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
  };
  /***/

},
/* 111 */

/***/
function (module, exports, __webpack_require__) {
  // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
  var speciesConstructor = __webpack_require__(290);

  module.exports = function (original, length) {
    return new (speciesConstructor(original))(length);
  };
  /***/

},
/* 112 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

  var toObject = __webpack_require__(14);

  var toAbsoluteIndex = __webpack_require__(46);

  var toLength = __webpack_require__(13);

  module.exports = function fill(value
  /* , start = 0, end = @length */
  ) {
    var O = toObject(this);
    var length = toLength(O.length);
    var aLen = arguments.length;
    var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

    while (endPos > index) {
      O[index++] = value;
    }

    return O;
  };
  /***/

},
/* 113 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var addToUnscopables = __webpack_require__(42);

  var step = __webpack_require__(147);

  var Iterators = __webpack_require__(59);

  var toIObject = __webpack_require__(22); // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()


  module.exports = __webpack_require__(104)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target

    this._i = 0; // next index

    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;

    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }

    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

  Iterators.Arguments = Iterators.Array;
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');
  /***/
},
/* 114 */

/***/
function (module, exports, __webpack_require__) {
  var ctx = __webpack_require__(27);

  var invoke = __webpack_require__(137);

  var html = __webpack_require__(96);

  var cel = __webpack_require__(92);

  var global = __webpack_require__(6);

  var process = global.process;
  var setTask = global.setImmediate;
  var clearTask = global.clearImmediate;
  var MessageChannel = global.MessageChannel;
  var Dispatch = global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var defer, channel, port;

  var run = function run() {
    var id = +this; // eslint-disable-next-line no-prototype-builtins

    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };

  var listener = function listener(event) {
    run.call(event.data);
  }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


  if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
      var args = [];
      var i = 1;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      queue[++counter] = function () {
        // eslint-disable-next-line no-new-func
        invoke(typeof fn == 'function' ? fn : Function(fn), args);
      };

      defer(counter);
      return counter;
    };

    clearTask = function clearImmediate(id) {
      delete queue[id];
    }; // Node.js 0.8-


    if (__webpack_require__(28)(process) == 'process') {
      defer = function defer(id) {
        process.nextTick(ctx(run, id, 1));
      }; // Sphere (JS game engine) Dispatch API

    } else if (Dispatch && Dispatch.now) {
      defer = function defer(id) {
        Dispatch.now(ctx(run, id, 1));
      }; // Browsers with MessageChannel, includes WebWorkers

    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
      // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
      defer = function defer(id) {
        global.postMessage(id + '', '*');
      };

      global.addEventListener('message', listener, false); // IE8-
    } else if (ONREADYSTATECHANGE in cel('script')) {
      defer = function defer(id) {
        html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
          html.removeChild(this);
          run.call(id);
        };
      }; // Rest old browsers

    } else {
      defer = function defer(id) {
        setTimeout(ctx(run, id, 1), 0);
      };
    }
  }

  module.exports = {
    set: setTask,
    clear: clearTask
  };
  /***/
},
/* 115 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var macrotask = __webpack_require__(114).set;

  var Observer = global.MutationObserver || global.WebKitMutationObserver;
  var process = global.process;
  var Promise = global.Promise;
  var isNode = __webpack_require__(28)(process) == 'process';

  module.exports = function () {
    var head, last, notify;

    var flush = function flush() {
      var parent, fn;
      if (isNode && (parent = process.domain)) parent.exit();

      while (head) {
        fn = head.fn;
        head = head.next;

        try {
          fn();
        } catch (e) {
          if (head) notify();else last = undefined;
          throw e;
        }
      }

      last = undefined;
      if (parent) parent.enter();
    }; // Node.js


    if (isNode) {
      notify = function notify() {
        process.nextTick(flush);
      }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

    } else if (Observer && !(global.navigator && global.navigator.standalone)) {
      var toggle = true;
      var node = document.createTextNode('');
      new Observer(flush).observe(node, {
        characterData: true
      }); // eslint-disable-line no-new

      notify = function notify() {
        node.data = toggle = !toggle;
      }; // environments with maybe non-completely correct, but existent Promise

    } else if (Promise && Promise.resolve) {
      // Promise.resolve without an argument throws an error in LG WebOS 2
      var promise = Promise.resolve(undefined);

      notify = function notify() {
        promise.then(flush);
      }; // for other environments - macrotask based on:
      // - setImmediate
      // - MessageChannel
      // - window.postMessag
      // - onreadystatechange
      // - setTimeout

    } else {
      notify = function notify() {
        // strange IE + webpack dev server bug - use .call(global)
        macrotask.call(global, flush);
      };
    }

    return function (fn) {
      var task = {
        fn: fn,
        next: undefined
      };
      if (last) last.next = task;

      if (!head) {
        head = task;
        notify();
      }

      last = task;
    };
  };
  /***/

},
/* 116 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 25.4.1.5 NewPromiseCapability(C)

  var aFunction = __webpack_require__(16);

  function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = aFunction(resolve);
    this.reject = aFunction(reject);
  }

  module.exports.f = function (C) {
    return new PromiseCapability(C);
  };
  /***/

},
/* 117 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(6);

  var DESCRIPTORS = __webpack_require__(11);

  var LIBRARY = __webpack_require__(41);

  var $typed = __webpack_require__(81);

  var hide = __webpack_require__(18);

  var redefineAll = __webpack_require__(52);

  var fails = __webpack_require__(7);

  var anInstance = __webpack_require__(50);

  var toInteger = __webpack_require__(34);

  var toLength = __webpack_require__(13);

  var toIndex = __webpack_require__(156);

  var gOPN = __webpack_require__(48).f;

  var dP = __webpack_require__(12).f;

  var arrayFill = __webpack_require__(112);

  var setToStringTag = __webpack_require__(57);

  var ARRAY_BUFFER = 'ArrayBuffer';
  var DATA_VIEW = 'DataView';
  var PROTOTYPE = 'prototype';
  var WRONG_LENGTH = 'Wrong length!';
  var WRONG_INDEX = 'Wrong index!';
  var $ArrayBuffer = global[ARRAY_BUFFER];
  var $DataView = global[DATA_VIEW];
  var Math = global.Math;
  var RangeError = global.RangeError; // eslint-disable-next-line no-shadow-restricted-names

  var Infinity = global.Infinity;
  var BaseBuffer = $ArrayBuffer;
  var abs = Math.abs;
  var pow = Math.pow;
  var floor = Math.floor;
  var log = Math.log;
  var LN2 = Math.LN2;
  var BUFFER = 'buffer';
  var BYTE_LENGTH = 'byteLength';
  var BYTE_OFFSET = 'byteOffset';
  var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
  var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
  var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET; // IEEE754 conversions based on https://github.com/feross/ieee754

  function packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = abs(value); // eslint-disable-next-line no-self-compare

    if (value != value || value === Infinity) {
      // eslint-disable-next-line no-self-compare
      m = value != value ? 1 : 0;
      e = eMax;
    } else {
      e = floor(log(value) / LN2);

      if (value * (c = pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }

      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * pow(2, 1 - eBias);
      }

      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * pow(2, eBias - 1) * pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {
      ;
    }

    e = e << mLen | m;
    eLen += mLen;

    for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {
      ;
    }

    buffer[--i] |= s * 128;
    return buffer;
  }

  function unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;

    for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {
      ;
    }

    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;

    for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {
      ;
    }

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : s ? -Infinity : Infinity;
    } else {
      m = m + pow(2, mLen);
      e = e - eBias;
    }

    return (s ? -1 : 1) * m * pow(2, e - mLen);
  }

  function unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
  }

  function packI8(it) {
    return [it & 0xff];
  }

  function packI16(it) {
    return [it & 0xff, it >> 8 & 0xff];
  }

  function packI32(it) {
    return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
  }

  function packF64(it) {
    return packIEEE754(it, 52, 8);
  }

  function packF32(it) {
    return packIEEE754(it, 23, 4);
  }

  function addGetter(C, key, internal) {
    dP(C[PROTOTYPE], key, {
      get: function get() {
        return this[internal];
      }
    });
  }

  function get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = toIndex(numIndex);
    if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
    var store = view[$BUFFER]._b;
    var start = intIndex + view[$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
  }

  function set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = toIndex(numIndex);
    if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
    var store = view[$BUFFER]._b;
    var start = intIndex + view[$OFFSET];
    var pack = conversion(+value);

    for (var i = 0; i < bytes; i++) {
      store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
    }
  }

  if (!$typed.ABV) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
      var byteLength = toIndex(length);
      this._b = arrayFill.call(new Array(byteLength), 0);
      this[$LENGTH] = byteLength;
    };

    $DataView = function DataView(buffer, byteOffset, byteLength) {
      anInstance(this, $DataView, DATA_VIEW);
      anInstance(buffer, $ArrayBuffer, DATA_VIEW);
      var bufferLength = buffer[$LENGTH];
      var offset = toInteger(byteOffset);
      if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
      byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
      if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
      this[$BUFFER] = buffer;
      this[$OFFSET] = offset;
      this[$LENGTH] = byteLength;
    };

    if (DESCRIPTORS) {
      addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
      addGetter($DataView, BUFFER, '_b');
      addGetter($DataView, BYTE_LENGTH, '_l');
      addGetter($DataView, BYTE_OFFSET, '_o');
    }

    redefineAll($DataView[PROTOTYPE], {
      getInt8: function getInt8(byteOffset) {
        return get(this, 1, byteOffset)[0] << 24 >> 24;
      },
      getUint8: function getUint8(byteOffset) {
        return get(this, 1, byteOffset)[0];
      },
      getInt16: function getInt16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments[1]);
        return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
      },
      getUint16: function getUint16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments[1]);
        return bytes[1] << 8 | bytes[0];
      },
      getInt32: function getInt32(byteOffset
      /* , littleEndian */
      ) {
        return unpackI32(get(this, 4, byteOffset, arguments[1]));
      },
      getUint32: function getUint32(byteOffset
      /* , littleEndian */
      ) {
        return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(byteOffset, value) {
        set(this, 1, byteOffset, packI8, value);
      },
      setUint8: function setUint8(byteOffset, value) {
        set(this, 1, byteOffset, packI8, value);
      },
      setInt16: function setInt16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packI16, value, arguments[2]);
      },
      setUint16: function setUint16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packI16, value, arguments[2]);
      },
      setInt32: function setInt32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packI32, value, arguments[2]);
      },
      setUint32: function setUint32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packI32, value, arguments[2]);
      },
      setFloat32: function setFloat32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packF32, value, arguments[2]);
      },
      setFloat64: function setFloat64(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 8, byteOffset, packF64, value, arguments[2]);
      }
    });
  } else {
    if (!fails(function () {
      $ArrayBuffer(1);
    }) || !fails(function () {
      new $ArrayBuffer(-1); // eslint-disable-line no-new
    }) || fails(function () {
      new $ArrayBuffer(); // eslint-disable-line no-new

      new $ArrayBuffer(1.5); // eslint-disable-line no-new

      new $ArrayBuffer(NaN); // eslint-disable-line no-new

      return $ArrayBuffer.name != ARRAY_BUFFER;
    })) {
      $ArrayBuffer = function ArrayBuffer(length) {
        anInstance(this, $ArrayBuffer);
        return new BaseBuffer(toIndex(length));
      };

      var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];

      for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
        if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
      }

      if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
    } // iOS Safari 7.x bug


    var view = new $DataView(new $ArrayBuffer(2));
    var $setInt8 = $DataView[PROTOTYPE].setInt8;
    view.setInt8(0, 2147483648);
    view.setInt8(1, 2147483649);
    if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
      setInt8: function setInt8(byteOffset, value) {
        $setInt8.call(this, byteOffset, value << 24 >> 24);
      },
      setUint8: function setUint8(byteOffset, value) {
        $setInt8.call(this, byteOffset, value << 24 >> 24);
      }
    }, true);
  }

  setToStringTag($ArrayBuffer, ARRAY_BUFFER);
  setToStringTag($DataView, DATA_VIEW);
  hide($DataView[PROTOTYPE], $typed.VIEW, true);
  exports[ARRAY_BUFFER] = $ArrayBuffer;
  exports[DATA_VIEW] = $DataView;
  /***/
},
/* 118 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 119 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== 'production') {
      var invariant = __webpack_require__(54);

      var warning = __webpack_require__(85);

      var ReactPropTypesSecret = __webpack_require__(118);

      var loggedTypeFailures = {};
    }
    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */


    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (typeSpecs.hasOwnProperty(typeSpecName)) {
            var error; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);

            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
            }
          }
        }
      }
    }

    module.exports = checkPropTypes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 120 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.locationsAreEqual = exports.createLocation = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _resolvePathname = __webpack_require__(164);

  var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

  var _valueEqual = __webpack_require__(165);

  var _valueEqual2 = _interopRequireDefault(_valueEqual);

  var _PathUtils = __webpack_require__(66);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
    var location = void 0;

    if (typeof path === 'string') {
      // Two-arg form: push(path, state)
      location = (0, _PathUtils.parsePath)(path);
      location.state = state;
    } else {
      // One-arg form: push(location)
      location = _extends({}, path);
      if (location.pathname === undefined) location.pathname = '';

      if (location.search) {
        if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
      } else {
        location.search = '';
      }

      if (location.hash) {
        if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
      } else {
        location.hash = '';
      }

      if (state !== undefined && location.state === undefined) location.state = state;
    }

    try {
      location.pathname = decodeURI(location.pathname);
    } catch (e) {
      if (e instanceof URIError) {
        throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
      } else {
        throw e;
      }
    }

    if (key) location.key = key;

    if (currentLocation) {
      // Resolve incomplete/relative pathname relative to current location.
      if (!location.pathname) {
        location.pathname = currentLocation.pathname;
      } else if (location.pathname.charAt(0) !== '/') {
        location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
      }
    } else {
      // When there is no prior location and pathname is empty, set it to /
      if (!location.pathname) {
        location.pathname = '/';
      }
    }

    return location;
  };

  var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
  };
  /***/

},
/* 121 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _warning = __webpack_require__(15);

  var _warning2 = _interopRequireDefault(_warning);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var createTransitionManager = function createTransitionManager() {
    var prompt = null;

    var setPrompt = function setPrompt(nextPrompt) {
      (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
      prompt = nextPrompt;
      return function () {
        if (prompt === nextPrompt) prompt = null;
      };
    };

    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
      // TODO: If another transition starts while we're still confirming
      // the previous one, we may end up in a weird state. Figure out the
      // best way to handle this.
      if (prompt != null) {
        var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

        if (typeof result === 'string') {
          if (typeof getUserConfirmation === 'function') {
            getUserConfirmation(result, callback);
          } else {
            (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
            callback(true);
          }
        } else {
          // Return false from a transition hook to cancel the transition.
          callback(result !== false);
        }
      } else {
        callback(true);
      }
    };

    var listeners = [];

    var appendListener = function appendListener(fn) {
      var isActive = true;

      var listener = function listener() {
        if (isActive) fn.apply(undefined, arguments);
      };

      listeners.push(listener);
      return function () {
        isActive = false;
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    };

    var notifyListeners = function notifyListeners() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      listeners.forEach(function (listener) {
        return listener.apply(undefined, args);
      });
    };

    return {
      setPrompt: setPrompt,
      confirmTransitionTo: confirmTransitionTo,
      appendListener: appendListener,
      notifyListeners: notifyListeners
    };
  };

  exports.default = createTransitionManager;
  /***/
},
/* 122 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(123); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a"
  /* default */
  ];
  /***/
},
/* 123 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for putting history on context.
   */


  var Router = function (_React$Component) {
    _inherits(Router, _React$Component);

    function Router() {
      var _temp, _this, _ret;

      _classCallCheck(this, Router);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        match: _this.computeMatch(_this.props.history.location.pathname)
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Router.prototype.getChildContext = function getChildContext() {
      return {
        router: _extends({}, this.context.router, {
          history: this.props.history,
          route: {
            location: this.props.history.location,
            match: this.state.match
          }
        })
      };
    };

    Router.prototype.computeMatch = function computeMatch(pathname) {
      return {
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/'
      };
    };

    Router.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          history = _props.history;

      __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element'); // Do this here so we can setState when a <Redirect> changes the
      // location in componentWillMount. This happens e.g. when doing
      // server rendering using a <StaticRouter>.


      this.unlisten = history.listen(function () {
        _this2.setState({
          match: _this2.computeMatch(history.location.pathname)
        });
      });
    };

    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
    };

    Router.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unlisten();
    };

    Router.prototype.render = function render() {
      var children = this.props.children;
      return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
    };

    return Router;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  Router.propTypes = {
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
  };
  Router.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  };
  Router.childContextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
  };
  /* harmony default export */

  __webpack_exports__["a"] = Router;
  /***/
},
/* 124 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(427);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);

  var patternCache = {};
  var cacheLimit = 10000;
  var cacheCount = 0;

  var compilePath = function compilePath(pattern, options) {
    var cacheKey = '' + options.end + options.strict + options.sensitive;
    var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];

    var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);

    var compiledPattern = {
      re: re,
      keys: keys
    };

    if (cacheCount < cacheLimit) {
      cache[pattern] = compiledPattern;
      cacheCount++;
    }

    return compiledPattern;
  };
  /**
   * Public API for matching a URL pathname to a path pattern.
   */


  var matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (typeof options === 'string') options = {
      path: options
    };
    var _options = options,
        _options$path = _options.path,
        path = _options$path === undefined ? '/' : _options$path,
        _options$exact = _options.exact,
        exact = _options$exact === undefined ? false : _options$exact,
        _options$strict = _options.strict,
        strict = _options$strict === undefined ? false : _options$strict,
        _options$sensitive = _options.sensitive,
        sensitive = _options$sensitive === undefined ? false : _options$sensitive;

    var _compilePath = compilePath(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        re = _compilePath.re,
        keys = _compilePath.keys;

    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path pattern used to match
      url: path === '/' && url === '' ? '/' : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = matchPath;
  /***/
},
/* 125 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);

  var createTransitionManager = function createTransitionManager() {
    var prompt = null;

    var setPrompt = function setPrompt(nextPrompt) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

      prompt = nextPrompt;
      return function () {
        if (prompt === nextPrompt) prompt = null;
      };
    };

    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
      // TODO: If another transition starts while we're still confirming
      // the previous one, we may end up in a weird state. Figure out the
      // best way to handle this.
      if (prompt != null) {
        var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

        if (typeof result === 'string') {
          if (typeof getUserConfirmation === 'function') {
            getUserConfirmation(result, callback);
          } else {
            __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

            callback(true);
          }
        } else {
          // Return false from a transition hook to cancel the transition.
          callback(result !== false);
        }
      } else {
        callback(true);
      }
    };

    var listeners = [];

    var appendListener = function appendListener(fn) {
      var isActive = true;

      var listener = function listener() {
        if (isActive) fn.apply(undefined, arguments);
      };

      listeners.push(listener);
      return function () {
        isActive = false;
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    };

    var notifyListeners = function notifyListeners() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      listeners.forEach(function (listener) {
        return listener.apply(undefined, args);
      });
    };

    return {
      setPrompt: setPrompt,
      confirmTransitionTo: confirmTransitionTo,
      appendListener: appendListener,
      notifyListeners: notifyListeners
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = createTransitionManager;
  /***/
},
/* 126 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    var utils = __webpack_require__(25);

    var normalizeHeaderName = __webpack_require__(477);

    var DEFAULT_CONTENT_TYPE = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
        headers['Content-Type'] = value;
      }
    }

    function getDefaultAdapter() {
      var adapter;

      if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use XHR adapter
        adapter = __webpack_require__(172);
      } else if (typeof process !== 'undefined') {
        // For node use HTTP adapter
        adapter = __webpack_require__(172);
      }

      return adapter;
    }

    var defaults = {
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, 'Content-Type');

        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }

        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }

        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
          return data.toString();
        }

        if (utils.isObject(data)) {
          setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
          return JSON.stringify(data);
        }

        return data;
      }],
      transformResponse: [function transformResponse(data) {
        /*eslint no-param-reassign:0*/
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            /* Ignore */
          }
        }

        return data;
      }],

      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',
      maxContentLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    defaults.headers = {
      common: {
        'Accept': 'application/json, text/plain, */*'
      }
    };
    utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 127 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LeftSail = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var LeftSail = exports.LeftSail = function LeftSail(_ref) {
    var fill = _ref.fill;
    return _react2.default.createElement('svg', {
      viewBox: '0 0 442 487'
    }, _react2.default.createElement('defs', null), _react2.default.createElement('g', {
      id: (0, _generic.randomStr)('left-sail'),
      fill: fill
    }, _react2.default.createElement('polygon', {
      points: '0 485.867879 42.1316713 486 433.720208 55.5462083 442 0'
    }), _react2.default.createElement('polygon', {
      points: '418.719363 162.496202 427 107 82 485.867994 124.135973 486'
    }), _react2.default.createElement('polygon', {
      points: '402.714384 268.635743 411 213 163 485.867663 205.16131 486'
    }), _react2.default.createElement('polygon', {
      points: '386.707143 376.594658 395 321 244 486.869113 286.198153 487'
    }), _react2.default.createElement('polygon', {
      points: '379 428 325 486.858948 370.130625 487'
    })));
  };

  LeftSail.propTypes = {
    fill: _propTypes2.default.string
  };
  LeftSail.defaultProps = {
    fill: '#4E8382'
  };
  exports.default = LeftSail;
  /***/
},
/* 128 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  var hyphenate = __webpack_require__(510);

  var msPattern = /^ms-/;
  /**
   * Hyphenates a camelcased CSS property name, for example:
   *
   *   > hyphenateStyleName('backgroundColor')
   *   < "background-color"
   *   > hyphenateStyleName('MozTransition')
   *   < "-moz-transition"
   *   > hyphenateStyleName('msTransition')
   *   < "-ms-transition"
   *
   * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
   * is converted to `-ms-`.
   *
   * @param {string} string
   * @return {string}
   */

  function hyphenateStyleName(string) {
    return hyphenate(string).replace(msPattern, '-ms-');
  }

  module.exports = hyphenateStyleName;
  /***/
},
/* 129 */

/***/
function (module, exports) {
  module.exports = extend;

  function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }
  /***/

},
/* 130 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = !__webpack_require__(11) && !__webpack_require__(7)(function () {
    return Object.defineProperty(__webpack_require__(92)('div'), 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 131 */

/***/
function (module, exports, __webpack_require__) {
  exports.f = __webpack_require__(9);
  /***/
},
/* 132 */

/***/
function (module, exports, __webpack_require__) {
  var has = __webpack_require__(21);

  var toIObject = __webpack_require__(22);

  var arrayIndexOf = __webpack_require__(71)(false);

  var IE_PROTO = __webpack_require__(94)('IE_PROTO');

  module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;

    for (key in O) {
      if (key != IE_PROTO) has(O, key) && result.push(key);
    } // Don't enum bug & hidden keys


    while (names.length > i) {
      if (has(O, key = names[i++])) {
        ~arrayIndexOf(result, key) || result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 133 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(12);

  var anObject = __webpack_require__(5);

  var getKeys = __webpack_require__(45);

  module.exports = __webpack_require__(11) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;

    while (length > i) {
      dP.f(O, P = keys[i++], Properties[P]);
    }

    return O;
  };
  /***/
},
/* 134 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var toIObject = __webpack_require__(22);

  var gOPN = __webpack_require__(48).f;

  var toString = {}.toString;
  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function getWindowNames(it) {
    try {
      return gOPN(it);
    } catch (e) {
      return windowNames.slice();
    }
  };

  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
  };
  /***/

},
/* 135 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

  var getKeys = __webpack_require__(45);

  var gOPS = __webpack_require__(72);

  var pIE = __webpack_require__(63);

  var toObject = __webpack_require__(14);

  var IObject = __webpack_require__(62);

  var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

  module.exports = !$assign || __webpack_require__(7)(function () {
    var A = {};
    var B = {}; // eslint-disable-next-line no-undef

    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) {
      B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;

    while (aLen > index) {
      var S = IObject(arguments[index++]);
      var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
      var length = keys.length;
      var j = 0;
      var key;

      while (length > j) {
        if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
      }
    }

    return T;
  } : $assign;
  /***/
},
/* 136 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var aFunction = __webpack_require__(16);

  var isObject = __webpack_require__(8);

  var invoke = __webpack_require__(137);

  var arraySlice = [].slice;
  var factories = {};

  var construct = function construct(F, len, args) {
    if (!(len in factories)) {
      for (var n = [], i = 0; i < len; i++) {
        n[i] = 'a[' + i + ']';
      } // eslint-disable-next-line no-new-func


      factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }

    return factories[len](F, args);
  };

  module.exports = Function.bind || function bind(that
  /* , ...args */
  ) {
    var fn = aFunction(this);
    var partArgs = arraySlice.call(arguments, 1);

    var bound = function bound()
    /* args... */
    {
      var args = partArgs.concat(arraySlice.call(arguments));
      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
    };

    if (isObject(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
  };
  /***/

},
/* 137 */

/***/
function (module, exports) {
  // fast apply, http://jsperf.lnkit.com/fast-apply/5
  module.exports = function (fn, args, that) {
    var un = that === undefined;

    switch (args.length) {
      case 0:
        return un ? fn() : fn.call(that);

      case 1:
        return un ? fn(args[0]) : fn.call(that, args[0]);

      case 2:
        return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

      case 3:
        return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

      case 4:
        return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }

    return fn.apply(that, args);
  };
  /***/

},
/* 138 */

/***/
function (module, exports, __webpack_require__) {
  var $parseInt = __webpack_require__(6).parseInt;

  var $trim = __webpack_require__(58).trim;

  var ws = __webpack_require__(98);

  var hex = /^[-+]?0[xX]/;
  module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $trim(String(str), 3);
    return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
  } : $parseInt;
  /***/
},
/* 139 */

/***/
function (module, exports, __webpack_require__) {
  var $parseFloat = __webpack_require__(6).parseFloat;

  var $trim = __webpack_require__(58).trim;

  module.exports = 1 / $parseFloat(__webpack_require__(98) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $trim(String(str), 3);
    var result = $parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
  } : $parseFloat;
  /***/
},
/* 140 */

/***/
function (module, exports, __webpack_require__) {
  var cof = __webpack_require__(28);

  module.exports = function (it, msg) {
    if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
    return +it;
  };
  /***/

},
/* 141 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.3 Number.isInteger(number)
  var isObject = __webpack_require__(8);

  var floor = Math.floor;

  module.exports = function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
  };
  /***/

},
/* 142 */

/***/
function (module, exports) {
  // 20.2.2.20 Math.log1p(x)
  module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
  };
  /***/

},
/* 143 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.16 Math.fround(x)
  var sign = __webpack_require__(101);

  var pow = Math.pow;
  var EPSILON = pow(2, -52);
  var EPSILON32 = pow(2, -23);
  var MAX32 = pow(2, 127) * (2 - EPSILON32);
  var MIN32 = pow(2, -126);

  var roundTiesToEven = function roundTiesToEven(n) {
    return n + 1 / EPSILON - 1 / EPSILON;
  };

  module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = sign(x);
    var a, result;
    if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs); // eslint-disable-next-line no-self-compare

    if (result > MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
  };
  /***/

},
/* 144 */

/***/
function (module, exports, __webpack_require__) {
  // call something on iterator step with safe closing on error
  var anObject = __webpack_require__(5);

  module.exports = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) anObject(ret.call(iterator));
      throw e;
    }
  };
  /***/

},
/* 145 */

/***/
function (module, exports, __webpack_require__) {
  var aFunction = __webpack_require__(16);

  var toObject = __webpack_require__(14);

  var IObject = __webpack_require__(62);

  var toLength = __webpack_require__(13);

  module.exports = function (that, callbackfn, aLen, memo, isRight) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IObject(O);
    var length = toLength(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for (;;) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }

      index += i;

      if (isRight ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }

    for (; isRight ? index >= 0 : length > index; index += i) {
      if (index in self) {
        memo = callbackfn(memo, self[index], index, O);
      }
    }

    return memo;
  };
  /***/

},
/* 146 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

  var toObject = __webpack_require__(14);

  var toAbsoluteIndex = __webpack_require__(46);

  var toLength = __webpack_require__(13);

  module.exports = [].copyWithin || function copyWithin(target
  /* = 0 */
  , start
  /* = 0, end = @length */
  ) {
    var O = toObject(this);
    var len = toLength(O.length);
    var to = toAbsoluteIndex(target, len);
    var from = toAbsoluteIndex(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
    var inc = 1;

    if (from < to && to < from + count) {
      inc = -1;
      from += count - 1;
      to += count - 1;
    }

    while (count-- > 0) {
      if (from in O) O[to] = O[from];else delete O[to];
      to += inc;
      from += inc;
    }

    return O;
  };
  /***/

},
/* 147 */

/***/
function (module, exports) {
  module.exports = function (done, value) {
    return {
      value: value,
      done: !!done
    };
  };
  /***/

},
/* 148 */

/***/
function (module, exports, __webpack_require__) {
  // 21.2.5.3 get RegExp.prototype.flags()
  if (__webpack_require__(11) && /./g.flags != 'g') __webpack_require__(12).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: __webpack_require__(76)
  });
  /***/
},
/* 149 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return {
        e: false,
        v: exec()
      };
    } catch (e) {
      return {
        e: true,
        v: e
      };
    }
  };
  /***/

},
/* 150 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(5);

  var isObject = __webpack_require__(8);

  var newPromiseCapability = __webpack_require__(116);

  module.exports = function (C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };
  /***/

},
/* 151 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var strong = __webpack_require__(152);

  var validate = __webpack_require__(60);

  var MAP = 'Map'; // 23.1 Map Objects

  module.exports = __webpack_require__(80)(MAP, function (get) {
    return function Map() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
      var entry = strong.getEntry(validate(this, MAP), key);
      return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
      return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
    }
  }, strong, true);
  /***/
},
/* 152 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var dP = __webpack_require__(12).f;

  var create = __webpack_require__(47);

  var redefineAll = __webpack_require__(52);

  var ctx = __webpack_require__(27);

  var anInstance = __webpack_require__(50);

  var forOf = __webpack_require__(51);

  var $iterDefine = __webpack_require__(104);

  var step = __webpack_require__(147);

  var setSpecies = __webpack_require__(49);

  var DESCRIPTORS = __webpack_require__(11);

  var fastKey = __webpack_require__(40).fastKey;

  var validate = __webpack_require__(60);

  var SIZE = DESCRIPTORS ? '_s' : 'size';

  var getEntry = function getEntry(that, key) {
    // fast case
    var index = fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index]; // frozen object case

    for (entry = that._f; entry; entry = entry.n) {
      if (entry.k == key) return entry;
    }
  };

  module.exports = {
    getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        anInstance(that, C, NAME, '_i');
        that._t = NAME; // collection type

        that._i = create(null); // index

        that._f = undefined; // first entry

        that._l = undefined; // last entry

        that[SIZE] = 0; // size

        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
      });
      redefineAll(C.prototype, {
        // 23.1.3.1 Map.prototype.clear()
        // 23.2.3.2 Set.prototype.clear()
        clear: function clear() {
          for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
            entry.r = true;
            if (entry.p) entry.p = entry.p.n = undefined;
            delete data[entry.i];
          }

          that._f = that._l = undefined;
          that[SIZE] = 0;
        },
        // 23.1.3.3 Map.prototype.delete(key)
        // 23.2.3.4 Set.prototype.delete(value)
        'delete': function _delete(key) {
          var that = validate(this, NAME);
          var entry = getEntry(that, key);

          if (entry) {
            var next = entry.n;
            var prev = entry.p;
            delete that._i[entry.i];
            entry.r = true;
            if (prev) prev.n = next;
            if (next) next.p = prev;
            if (that._f == entry) that._f = next;
            if (that._l == entry) that._l = prev;
            that[SIZE]--;
          }

          return !!entry;
        },
        // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
        // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
        forEach: function forEach(callbackfn
        /* , that = undefined */
        ) {
          validate(this, NAME);
          var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
          var entry;

          while (entry = entry ? entry.n : this._f) {
            f(entry.v, entry.k, this); // revert to the last existing entry

            while (entry && entry.r) {
              entry = entry.p;
            }
          }
        },
        // 23.1.3.7 Map.prototype.has(key)
        // 23.2.3.7 Set.prototype.has(value)
        has: function has(key) {
          return !!getEntry(validate(this, NAME), key);
        }
      });
      if (DESCRIPTORS) dP(C.prototype, 'size', {
        get: function get() {
          return validate(this, NAME)[SIZE];
        }
      });
      return C;
    },
    def: function def(that, key, value) {
      var entry = getEntry(that, key);
      var prev, index; // change existing entry

      if (entry) {
        entry.v = value; // create new entry
      } else {
        that._l = entry = {
          i: index = fastKey(key, true),
          // <- index
          k: key,
          // <- key
          v: value,
          // <- value
          p: prev = that._l,
          // <- previous entry
          n: undefined,
          // <- next entry
          r: false // <- removed

        };
        if (!that._f) that._f = entry;
        if (prev) prev.n = entry;
        that[SIZE]++; // add to index

        if (index !== 'F') that._i[index] = entry;
      }

      return that;
    },
    getEntry: getEntry,
    setStrong: function setStrong(C, NAME, IS_MAP) {
      // add .keys, .values, .entries, [@@iterator]
      // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
      $iterDefine(C, NAME, function (iterated, kind) {
        this._t = validate(iterated, NAME); // target

        this._k = kind; // kind

        this._l = undefined; // previous
      }, function () {
        var that = this;
        var kind = that._k;
        var entry = that._l; // revert to the last existing entry

        while (entry && entry.r) {
          entry = entry.p;
        } // get next entry


        if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
          // or finish the iteration
          that._t = undefined;
          return step(1);
        } // return step by kind


        if (kind == 'keys') return step(0, entry.k);
        if (kind == 'values') return step(0, entry.v);
        return step(0, [entry.k, entry.v]);
      }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

      setSpecies(NAME);
    }
  };
  /***/
},
/* 153 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var strong = __webpack_require__(152);

  var validate = __webpack_require__(60);

  var SET = 'Set'; // 23.2 Set Objects

  module.exports = __webpack_require__(80)(SET, function (get) {
    return function Set() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
      return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
    }
  }, strong);
  /***/
},
/* 154 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var each = __webpack_require__(36)(0);

  var redefine = __webpack_require__(19);

  var meta = __webpack_require__(40);

  var assign = __webpack_require__(135);

  var weak = __webpack_require__(155);

  var isObject = __webpack_require__(8);

  var fails = __webpack_require__(7);

  var validate = __webpack_require__(60);

  var WEAK_MAP = 'WeakMap';
  var getWeak = meta.getWeak;
  var isExtensible = Object.isExtensible;
  var uncaughtFrozenStore = weak.ufstore;
  var tmp = {};
  var InternalMap;

  var wrapper = function wrapper(get) {
    return function WeakMap() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  };

  var methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
      if (isObject(key)) {
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
        return data ? data[this._i] : undefined;
      }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
      return weak.def(validate(this, WEAK_MAP), key, value);
    }
  }; // 23.3 WeakMap Objects

  var $WeakMap = module.exports = __webpack_require__(80)(WEAK_MAP, wrapper, methods, weak, true, true); // IE11 WeakMap frozen keys fix


  if (fails(function () {
    return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
  })) {
    InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
    assign(InternalMap.prototype, methods);
    meta.NEED = true;
    each(['delete', 'has', 'get', 'set'], function (key) {
      var proto = $WeakMap.prototype;
      var method = proto[key];
      redefine(proto, key, function (a, b) {
        // store frozen objects on internal weakmap shim
        if (isObject(a) && !isExtensible(a)) {
          if (!this._f) this._f = new InternalMap();

          var result = this._f[key](a, b);

          return key == 'set' ? this : result; // store all the rest on native weakmap
        }

        return method.call(this, a, b);
      });
    });
  }
  /***/

},
/* 155 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var redefineAll = __webpack_require__(52);

  var getWeak = __webpack_require__(40).getWeak;

  var anObject = __webpack_require__(5);

  var isObject = __webpack_require__(8);

  var anInstance = __webpack_require__(50);

  var forOf = __webpack_require__(51);

  var createArrayMethod = __webpack_require__(36);

  var $has = __webpack_require__(21);

  var validate = __webpack_require__(60);

  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var id = 0; // fallback for uncaught frozen keys

  var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
    return that._l || (that._l = new UncaughtFrozenStore());
  };

  var UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.a = [];
  };

  var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return arrayFind(store.a, function (it) {
      return it[0] === key;
    });
  };

  UncaughtFrozenStore.prototype = {
    get: function get(key) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) return entry[1];
    },
    has: function has(key) {
      return !!findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) entry[1] = value;else this.a.push([key, value]);
    },
    'delete': function _delete(key) {
      var index = arrayFindIndex(this.a, function (it) {
        return it[0] === key;
      });
      if (~index) this.a.splice(index, 1);
      return !!~index;
    }
  };
  module.exports = {
    getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        anInstance(that, C, NAME, '_i');
        that._t = NAME; // collection type

        that._i = id++; // collection id

        that._l = undefined; // leak store for uncaught frozen objects

        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
      });
      redefineAll(C.prototype, {
        // 23.3.3.2 WeakMap.prototype.delete(key)
        // 23.4.3.3 WeakSet.prototype.delete(value)
        'delete': function _delete(key) {
          if (!isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
          return data && $has(data, this._i) && delete data[this._i];
        },
        // 23.3.3.4 WeakMap.prototype.has(key)
        // 23.4.3.4 WeakSet.prototype.has(value)
        has: function has(key) {
          if (!isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
          return data && $has(data, this._i);
        }
      });
      return C;
    },
    def: function def(that, key, value) {
      var data = getWeak(anObject(key), true);
      if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
      return that;
    },
    ufstore: uncaughtFrozenStore
  };
  /***/
},
/* 156 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/ecma262/#sec-toindex
  var toInteger = __webpack_require__(34);

  var toLength = __webpack_require__(13);

  module.exports = function (it) {
    if (it === undefined) return 0;
    var number = toInteger(it);
    var length = toLength(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
  };
  /***/

},
/* 157 */

/***/
function (module, exports, __webpack_require__) {
  // all object keys, includes non-enumerable and symbols
  var gOPN = __webpack_require__(48);

  var gOPS = __webpack_require__(72);

  var anObject = __webpack_require__(5);

  var Reflect = __webpack_require__(6).Reflect;

  module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
    var keys = gOPN.f(anObject(it));
    var getSymbols = gOPS.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
  };
  /***/

},
/* 158 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

  var isArray = __webpack_require__(73);

  var isObject = __webpack_require__(8);

  var toLength = __webpack_require__(13);

  var ctx = __webpack_require__(27);

  var IS_CONCAT_SPREADABLE = __webpack_require__(9)('isConcatSpreadable');

  function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
    var element, spreadable;

    while (sourceIndex < sourceLen) {
      if (sourceIndex in source) {
        element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
        spreadable = false;

        if (isObject(element)) {
          spreadable = element[IS_CONCAT_SPREADABLE];
          spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
        }

        if (spreadable && depth > 0) {
          targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
        } else {
          if (targetIndex >= 0x1fffffffffffff) throw TypeError();
          target[targetIndex] = element;
        }

        targetIndex++;
      }

      sourceIndex++;
    }

    return targetIndex;
  }

  module.exports = flattenIntoArray;
  /***/
},
/* 159 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-string-pad-start-end
  var toLength = __webpack_require__(13);

  var repeat = __webpack_require__(100);

  var defined = __webpack_require__(33);

  module.exports = function (that, maxLength, fillString, left) {
    var S = String(defined(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
  };
  /***/

},
/* 160 */

/***/
function (module, exports, __webpack_require__) {
  var getKeys = __webpack_require__(45);

  var toIObject = __webpack_require__(22);

  var isEnum = __webpack_require__(63).f;

  module.exports = function (isEntries) {
    return function (it) {
      var O = toIObject(it);
      var keys = getKeys(O);
      var length = keys.length;
      var i = 0;
      var result = [];
      var key;

      while (length > i) {
        if (isEnum.call(O, key = keys[i++])) {
          result.push(isEntries ? [key, O[key]] : O[key]);
        }
      }

      return result;
    };
  };
  /***/

},
/* 161 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var classof = __webpack_require__(64);

  var from = __webpack_require__(162);

  module.exports = function (NAME) {
    return function toJSON() {
      if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
      return from(this);
    };
  };
  /***/

},
/* 162 */

/***/
function (module, exports, __webpack_require__) {
  var forOf = __webpack_require__(51);

  module.exports = function (iter, ITERATOR) {
    var result = [];
    forOf(iter, false, result.push, result, ITERATOR);
    return result;
  };
  /***/

},
/* 163 */

/***/
function (module, exports) {
  // https://rwaldron.github.io/proposal-math-extensions/
  module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    if (arguments.length === 0 // eslint-disable-next-line no-self-compare
    || x != x // eslint-disable-next-line no-self-compare
    || inLow != inLow // eslint-disable-next-line no-self-compare
    || inHigh != inHigh // eslint-disable-next-line no-self-compare
    || outLow != outLow // eslint-disable-next-line no-self-compare
    || outHigh != outHigh) return NaN;
    if (x === Infinity || x === -Infinity) return x;
    return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
  };
  /***/

},
/* 164 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });

  function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
  } // About 1.5x faster than the two-arg version of Array#splice()


  function spliceOne(list, index) {
    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
      list[i] = list[k];
    }

    list.pop();
  } // This implementation is based heavily on node's url.parse


  function resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;

    if (to && isAbsolute(to)) {
      // to is absolute
      fromParts = toParts;
    } else if (toParts.length) {
      // to is relative, drop the filename
      fromParts.pop();
      fromParts = fromParts.concat(toParts);
    }

    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;

    if (fromParts.length) {
      var last = fromParts[fromParts.length - 1];
      hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else {
      hasTrailingSlash = false;
    }

    var up = 0;

    for (var i = fromParts.length; i >= 0; i--) {
      var part = fromParts[i];

      if (part === '.') {
        spliceOne(fromParts, i);
      } else if (part === '..') {
        spliceOne(fromParts, i);
        up++;
      } else if (up) {
        spliceOne(fromParts, i);
        up--;
      }
    }

    if (!mustEndAbs) for (; up--; up) {
      fromParts.unshift('..');
    }
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
  }
  /* harmony default export */


  __webpack_exports__["default"] = resolvePathname;
  /***/
},
/* 165 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;

    if (Array.isArray(a)) {
      return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
        return valueEqual(item, b[index]);
      });
    }

    var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
    if (aType !== bType) return false;

    if (aType === 'object') {
      var aValue = a.valueOf();
      var bValue = b.valueOf();
      if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
      var aKeys = Object.keys(a);
      var bKeys = Object.keys(b);
      if (aKeys.length !== bKeys.length) return false;
      return aKeys.every(function (key) {
        return valueEqual(a[key], b[key]);
      });
    }

    return false;
  }
  /* harmony default export */


  __webpack_exports__["default"] = valueEqual;
  /***/
},
/* 166 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

  var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
  };

  var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
  };

  var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
    return callback(window.confirm(message));
  }; // eslint-disable-line no-alert

  /**
   * Returns true if the HTML5 history API is supported. Taken from Modernizr.
   *
   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
   * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
   */


  var supportsHistory = exports.supportsHistory = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
  };
  /**
   * Returns true if browser fires popstate on hash change.
   * IE10 and IE11 do not.
   */


  var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
  };
  /**
   * Returns false if using go(n) with hash history causes a full page reload.
   */


  var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
  };
  /**
   * Returns true if a given popstate event is an extraneous WebKit event.
   * Accounts for the fact that Chrome on iOS fires real popstate events
   * containing undefined state when pressing the back button.
   */


  var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
  };
  /***/

},
/* 167 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
  };
  /**
   * The public API for rendering a history-aware <a>.
   */


  var Link = function (_React$Component) {
    _inherits(Link, _React$Component);

    function Link() {
      var _temp, _this, _ret;

      _classCallCheck(this, Link);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (_this.props.onClick) _this.props.onClick(event);

        if (!event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore right clicks
        !_this.props.target && // let browser handle "target=_blank" etc.
        !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();
            var history = _this.context.router.history;
            var _this$props = _this.props,
                replace = _this$props.replace,
                to = _this$props.to;

            if (replace) {
              history.replace(to);
            } else {
              history.push(to);
            }
          }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Link.prototype.render = function render() {
      var _props = this.props,
          replace = _props.replace,
          to = _props.to,
          innerRef = _props.innerRef,
          props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars


      __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

      var href = this.context.router.history.createHref(typeof to === 'string' ? {
        pathname: to
      } : to);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, {
        onClick: this.handleClick,
        href: href,
        ref: innerRef
      }));
    };

    return Link;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  Link.propTypes = {
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
  };
  Link.defaultProps = {
    replace: false
  };
  Link.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
      }).isRequired
    }).isRequired
  };
  /* harmony default export */

  __webpack_exports__["a"] = Link;
  /***/
},
/* 168 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(169); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a"
  /* default */
  ];
  /***/
},
/* 169 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(124);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var isEmptyChildren = function isEmptyChildren(children) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
  };
  /**
   * The public API for matching a single path and rendering.
   */


  var Route = function (_React$Component) {
    _inherits(Route, _React$Component);

    function Route() {
      var _temp, _this, _ret;

      _classCallCheck(this, Route);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        match: _this.computeMatch(_this.props, _this.context.router)
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Route.prototype.getChildContext = function getChildContext() {
      return {
        router: _extends({}, this.context.router, {
          route: {
            location: this.props.location || this.context.router.route.location,
            match: this.state.match
          }
        })
      };
    };

    Route.prototype.computeMatch = function computeMatch(_ref, router) {
      var computedMatch = _ref.computedMatch,
          location = _ref.location,
          path = _ref.path,
          strict = _ref.strict,
          exact = _ref.exact,
          sensitive = _ref.sensitive;
      if (computedMatch) return computedMatch; // <Switch> already computed the match for us

      __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

      var route = router.route;
      var pathname = (location || route.location).pathname;
      return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a"
      /* default */
      ])(pathname, {
        path: path,
        strict: strict,
        exact: exact,
        sensitive: sensitive
      }) : route.match;
    };

    Route.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
    };

    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

      this.setState({
        match: this.computeMatch(nextProps, nextContext.router)
      });
    };

    Route.prototype.render = function render() {
      var match = this.state.match;
      var _props = this.props,
          children = _props.children,
          component = _props.component,
          render = _props.render;
      var _context$router = this.context.router,
          history = _context$router.history,
          route = _context$router.route,
          staticContext = _context$router.staticContext;
      var location = this.props.location || route.location;
      var props = {
        match: match,
        location: location,
        history: history,
        staticContext: staticContext
      };
      return component ? // component prop gets first priority, only called if there's a match
      match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
      match ? render(props) : null : children ? // children come last, always called
      typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
    };

    return Route;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  Route.propTypes = {
    computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    // private, from <Switch>
    path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  };
  Route.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
      route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
      staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
    })
  };
  Route.childContextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
  };
  /* harmony default export */

  __webpack_exports__["a"] = Route;
  /***/
},
/* 170 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return canUseDOM;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return addEventListener;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return removeEventListener;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return getConfirmation;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return supportsHistory;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return supportsPopStateOnHashChange;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return supportsGoWithoutReloadUsingHash;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return isExtraneousPopstateEvent;
  });

  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

  var addEventListener = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
  };

  var removeEventListener = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
  };

  var getConfirmation = function getConfirmation(message, callback) {
    return callback(window.confirm(message));
  }; // eslint-disable-line no-alert

  /**
   * Returns true if the HTML5 history API is supported. Taken from Modernizr.
   *
   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
   * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
   */


  var supportsHistory = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
  };
  /**
   * Returns true if browser fires popstate on hash change.
   * IE10 and IE11 do not.
   */


  var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
  };
  /**
   * Returns false if using go(n) with hash history causes a full page reload.
   */


  var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
  };
  /**
   * Returns true if a given popstate event is an extraneous WebKit event.
   * Accounts for the fact that Chrome on iOS fires real popstate events
   * containing undefined state when pressing the back button.
   */


  var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
  };
  /***/

},
/* 171 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function bind(fn, thisArg) {
    return function wrap() {
      var args = new Array(arguments.length);

      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      return fn.apply(thisArg, args);
    };
  };
  /***/

},
/* 172 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    var utils = __webpack_require__(25);

    var settle = __webpack_require__(478);

    var buildURL = __webpack_require__(480);

    var parseHeaders = __webpack_require__(481);

    var isURLSameOrigin = __webpack_require__(482);

    var createError = __webpack_require__(173);

    var btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || __webpack_require__(483);

    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;

        if (utils.isFormData(requestData)) {
          delete requestHeaders['Content-Type']; // Let the browser set it
        }

        var request = new XMLHttpRequest();
        var loadEvent = 'onreadystatechange';
        var xDomain = false; // For IE 8/9 CORS support
        // Only supports POST and GET calls and doesn't returns the response headers.
        // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.

        if (process.env.NODE_ENV !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
          request = new window.XDomainRequest();
          loadEvent = 'onload';
          xDomain = true;

          request.onprogress = function handleProgress() {};

          request.ontimeout = function handleTimeout() {};
        } // HTTP basic authentication


        if (config.auth) {
          var username = config.auth.username || '';
          var password = config.auth.password || '';
          requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }

        request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true); // Set the request timeout in MS

        request.timeout = config.timeout; // Listen for ready state

        request[loadEvent] = function handleLoad() {
          if (!request || request.readyState !== 4 && !xDomain) {
            return;
          } // The request errored out and we didn't get a response, this will be
          // handled by onerror instead
          // With one exception: request that using file: protocol, most browsers
          // will return status as 0 even though it's a successful request


          if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
            return;
          } // Prepare the response


          var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
          var response = {
            data: responseData,
            // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
            status: request.status === 1223 ? 204 : request.status,
            statusText: request.status === 1223 ? 'No Content' : request.statusText,
            headers: responseHeaders,
            config: config,
            request: request
          };
          settle(resolve, reject, response); // Clean up request

          request = null;
        }; // Handle low level network errors


        request.onerror = function handleError() {
          // Real errors are hidden from us by the browser
          // onerror should only fire if it's a network error
          reject(createError('Network Error', config, null, request)); // Clean up request

          request = null;
        }; // Handle timeout


        request.ontimeout = function handleTimeout() {
          reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request)); // Clean up request

          request = null;
        }; // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.


        if (utils.isStandardBrowserEnv()) {
          var cookies = __webpack_require__(484); // Add xsrf header


          var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        } // Add headers to the request


        if ('setRequestHeader' in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
              // Remove Content-Type if data is undefined
              delete requestHeaders[key];
            } else {
              // Otherwise add header to the request
              request.setRequestHeader(key, val);
            }
          });
        } // Add withCredentials to request if needed


        if (config.withCredentials) {
          request.withCredentials = true;
        } // Add responseType to request if needed


        if (config.responseType) {
          try {
            request.responseType = config.responseType;
          } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') {
              throw e;
            }
          }
        } // Handle progress if needed


        if (typeof config.onDownloadProgress === 'function') {
          request.addEventListener('progress', config.onDownloadProgress);
        } // Not all browsers support upload events


        if (typeof config.onUploadProgress === 'function' && request.upload) {
          request.upload.addEventListener('progress', config.onUploadProgress);
        }

        if (config.cancelToken) {
          // Handle cancellation
          config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) {
              return;
            }

            request.abort();
            reject(cancel); // Clean up request

            request = null;
          });
        }

        if (requestData === undefined) {
          requestData = null;
        } // Send the request


        request.send(requestData);
      });
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 173 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var enhanceError = __webpack_require__(479);
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   * @returns {Error} The created error.
   */


  module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError(error, config, code, request, response);
  };
  /***/

},
/* 174 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
  };
  /***/

},
/* 175 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * A `Cancel` is an object that is thrown when an operation is canceled.
   *
   * @class
   * @param {string=} message The message.
   */

  function Cancel(message) {
    this.message = message;
  }

  Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
  };

  Cancel.prototype.__CANCEL__ = true;
  module.exports = Cancel;
  /***/
},
/* 176 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LargeStripedSail = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable max-len */


  var LargeStripedSail = exports.LargeStripedSail = function LargeStripedSail(_ref) {
    var fill = _ref.fill;
    return _react2.default.createElement('svg', {
      viewBox: '0 0 442 176'
    }, _react2.default.createElement('defs', null), _react2.default.createElement('g', {
      id: (0, _generic.randomStr)('large-striped-sail'),
      fill: fill
    }, _react2.default.createElement('path', {
      d: 'M270.976661,53.7959462 L244,175 C245.371672,174.844476 248.512327,174.485162 252.963841,173.970325 L281,48 L270.976661,53.7959462'
    }), _react2.default.createElement('path', {
      d: 'M290.009222,42.7719789 L261,173 C263.761372,172.678222 266.757124,172.32707 269.938763,171.95322 L300,37 L290.009222,42.7719789'
    }), _react2.default.createElement('path', {
      d: 'M310.278488,30.752891 L280,170 C282.813708,169.657994 285.724396,169.300018 288.700609,168.934058 L320,25 L310.278488,30.752891'
    }), _react2.default.createElement('path', {
      d: 'M331.984785,18 L329.813536,19.2747084 L297,169 C299.917616,168.639436 302.871154,168.270829 305.837995,167.898202 L336,30.2806292 L331.984785,18'
    }), _react2.default.createElement('path', {
      d: 'M341.947839,46 L316,166 C318.912699,165.623879 321.813643,165.246424 324.684545,164.867635 L347,61.6663814 L341.947839,46'
    }), _react2.default.createElement('path', {
      d: 'M362.04966,109 L351,161 C354.032387,160.555942 356.890764,160.123849 359.541863,159.71037 L367,124.616486 L362.04966,109'
    }), _react2.default.createElement('path', {
      d: 'M351.879453,77 L333,163 C336.010919,162.60065 338.955663,162.205294 341.811735,161.815262 L357,92.6372107 L351.879453,77'
    })));
  };

  LargeStripedSail.propTypes = {
    fill: _propTypes2.default.string
  };
  LargeStripedSail.defaultProps = {
    fill: '#4E8382'
  };
  exports.default = LargeStripedSail;
  /***/
},
/* 177 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SmallFrontSail = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SmallFrontSail = exports.SmallFrontSail = function SmallFrontSail(_ref) {
    var fill = _ref.fill;
    return _react2.default.createElement('svg', {
      viewBox: '0 0 160 100'
    }, _react2.default.createElement('defs', null), _react2.default.createElement('g', {
      id: (0, _generic.randomStr)('small-front-sail'),
      fill: fill
    }, _react2.default.createElement('polyline', {
      points: '0 93.6094366 122.687905 76.8800845 157.928232 0.191971831 0 93.6094366'
    })));
  };

  SmallFrontSail.propTypes = {
    fill: _propTypes2.default.string
  };
  SmallFrontSail.defaultProps = {
    fill: '#4E8382'
  };
  exports.default = SmallFrontSail;
  /***/
},
/* 178 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   */

  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  /**
   * Simple, lightweight module assisting with the detection and context of
   * Worker. Helps avoid circular dependencies and allows code to reason about
   * whether or not they are in a Worker, even if they never include the main
   * `ReactWorker` dependency.
   */

  var ExecutionEnvironment = {
    canUseDOM: canUseDOM,
    canUseWorkers: typeof Worker !== 'undefined',
    canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
    canUseViewport: canUseDOM && !!window.screen,
    isInWorker: !canUseDOM // For now, this is true - might change in the future.

  };
  module.exports = ExecutionEnvironment;
  /***/
},
/* 179 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  /* eslint-disable fb-www/typeof-undefined */

  /**
   * Same as document.activeElement but wraps in a try-catch block. In IE it is
   * not safe to call document.activeElement if there is nothing focused.
   *
   * The activeElement will be null only if the document or document body is not
   * yet defined.
   *
   * @param {?DOMDocument} doc Defaults to current document.
   * @return {?DOMElement}
   */

  function getActiveElement(doc)
  /*?DOMElement*/
  {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);

    if (typeof doc === 'undefined') {
      return null;
    }

    try {
      return doc.activeElement || doc.body;
    } catch (e) {
      return doc.body;
    }
  }

  module.exports = getActiveElement;
  /***/
},
/* 180 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   * 
   */

  /*eslint-disable no-self-compare */

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      // Added the nonzero y check to make Flow happy, but it is redundant
      return x !== 0 || y !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /**
   * Performs equality by iterating through keys on an object and returning false
   * when any key has values which are not strictly equal between the arguments.
   * Returns true when the values of all keys are strictly equal.
   */


  function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
      return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
      return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    } // Test for A's keys different from B.


    for (var i = 0; i < keysA.length; i++) {
      if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
        return false;
      }
    }

    return true;
  }

  module.exports = shallowEqual;
  /***/
},
/* 181 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  var isTextNode = __webpack_require__(507);
  /*eslint-disable no-bitwise */

  /**
   * Checks if a given DOM node contains or is another DOM node.
   */


  function containsNode(outerNode, innerNode) {
    if (!outerNode || !innerNode) {
      return false;
    } else if (outerNode === innerNode) {
      return true;
    } else if (isTextNode(outerNode)) {
      return false;
    } else if (isTextNode(innerNode)) {
      return containsNode(outerNode, innerNode.parentNode);
    } else if ('contains' in outerNode) {
      return outerNode.contains(innerNode);
    } else if (outerNode.compareDocumentPosition) {
      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
    } else {
      return false;
    }
  }

  module.exports = containsNode;
  /***/
},
/* 182 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  var camelize = __webpack_require__(511);

  var msPattern = /^-ms-/;
  /**
   * Camelcases a hyphenated CSS property name, for example:
   *
   *   > camelizeStyleName('background-color')
   *   < "backgroundColor"
   *   > camelizeStyleName('-moz-transition')
   *   < "MozTransition"
   *   > camelizeStyleName('-ms-transition')
   *   < "msTransition"
   *
   * As Andi Smith suggests
   * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
   * is converted to lowercase `ms`.
   *
   * @param {string} string
   * @return {string}
   */

  function camelizeStyleName(string) {
    return camelize(string.replace(msPattern, 'ms-'));
  }

  module.exports = camelizeStyleName;
  /***/
},
/* 183 */

/***/
function (module, exports) {
  /**
   * Helper function for iterating over a collection
   *
   * @param collection
   * @param fn
   */
  function each(collection, fn) {
    var i = 0,
        length = collection.length,
        cont;

    for (i; i < length; i++) {
      cont = fn(collection[i], i);

      if (cont === false) {
        break; //allow early exit
      }
    }
  }
  /**
   * Helper function for determining whether target object is an array
   *
   * @param target the object under test
   * @return {Boolean} true if array, false otherwise
   */


  function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
  }
  /**
   * Helper function for determining whether target object is a function
   *
   * @param target the object under test
   * @return {Boolean} true if function, false otherwise
   */


  function isFunction(target) {
    return typeof target === 'function';
  }

  module.exports = {
    isFunction: isFunction,
    isArray: isArray,
    each: each
  };
  /***/
},
/* 184 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(528);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Carousel.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Carousel.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 185 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Request = __webpack_require__(186);

  var extractResponseProps = __webpack_require__(187);

  function Response(props) {
    this.request = props.request;
    this.xhr = props.xhr;
    this.headers = props.headers || {};
    this.status = props.status || 0;
    this.text = props.text;
    this.body = props.body;
    this.contentType = props.contentType;
    this.isHttpError = props.status >= 400;
  }

  Response.prototype.header = Request.prototype.header;

  Response.fromRequest = function (req) {
    return new Response(extractResponseProps(req));
  };

  module.exports = Response;
  /***/
},
/* 186 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function Request(optsOrUrl) {
    var opts = typeof optsOrUrl === 'string' ? {
      url: optsOrUrl
    } : optsOrUrl || {};
    this.method = opts.method ? opts.method.toUpperCase() : 'GET';
    this.url = opts.url;
    this.headers = opts.headers || {};
    this.body = opts.body;
    this.timeout = opts.timeout || 0;
    this.errorOn404 = opts.errorOn404 != null ? opts.errorOn404 : true;
    this.onload = opts.onload;
    this.onerror = opts.onerror;
  }

  Request.prototype.abort = function () {
    if (this.aborted) return;
    this.aborted = true;
    this.xhr.abort();
    return this;
  };

  Request.prototype.header = function (name, value) {
    var k;

    for (k in this.headers) {
      if (this.headers.hasOwnProperty(k)) {
        if (name.toLowerCase() === k.toLowerCase()) {
          if (arguments.length === 1) {
            return this.headers[k];
          }

          delete this.headers[k];
          break;
        }
      }
    }

    if (value != null) {
      this.headers[name] = value;
      return value;
    }
  };

  module.exports = Request;
  /***/
},
/* 187 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var extend = __webpack_require__(129);

  module.exports = function (req) {
    var xhr = req.xhr;
    var props = {
      request: req,
      xhr: xhr
    }; // Try to create the response from the request. If the request was aborted,
    // accesssing properties of the XHR may throw an error, so we wrap in a
    // try/catch.

    try {
      var lines,
          i,
          m,
          headers = {};

      if (xhr.getAllResponseHeaders) {
        lines = xhr.getAllResponseHeaders().split('\n');

        for (i = 0; i < lines.length; i++) {
          if (m = lines[i].match(/\s*([^\s]+):\s+([^\s]+)/)) {
            headers[m[1]] = m[2];
          }
        }
      }

      props = extend(props, {
        status: xhr.status,
        contentType: xhr.contentType || xhr.getResponseHeader && xhr.getResponseHeader('Content-Type'),
        headers: headers,
        text: xhr.responseText,
        body: xhr.response || xhr.responseText
      });
    } catch (err) {}

    return props;
  };
  /***/

},
/* 188 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // A "once" utility.

  module.exports = function (fn) {
    var result,
        called = false;
    return function () {
      if (!called) {
        called = true;
        result = fn.apply(this, arguments);
      }

      return result;
    };
  };
  /***/

},
/* 189 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(575);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Navigation.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Navigation.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 190 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(581);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./PropertyManagers.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./PropertyManagers.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 191 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(589), __webpack_require__(593), __webpack_require__(594), __webpack_require__(598), __webpack_require__(599), __webpack_require__(601), __webpack_require__(1), __webpack_require__(2), __webpack_require__(55), __webpack_require__(69), __webpack_require__(600)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('./GoogleApiComponent'), require('./components/Marker'), require('./components/InfoWindow'), require('./components/HeatMap'), require('./components/Polygon'), require('./components/Polyline'), require('react'), require('prop-types'), require('react-dom'), require('./lib/String'), require('./lib/cancelablePromise'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.GoogleApiComponent, global.Marker, global.InfoWindow, global.HeatMap, global.Polygon, global.Polyline, global.react, global.propTypes, global.reactDom, global.String, global.cancelablePromise);
      global.index = mod.exports;
    }
  })(this, function (exports, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Map = exports.Polyline = exports.Polygon = exports.HeatMap = exports.InfoWindow = exports.Marker = exports.GoogleApiWrapper = undefined;
    Object.defineProperty(exports, 'GoogleApiWrapper', {
      enumerable: true,
      get: function get() {
        return _GoogleApiComponent.wrapper;
      }
    });
    Object.defineProperty(exports, 'Marker', {
      enumerable: true,
      get: function get() {
        return _Marker.Marker;
      }
    });
    Object.defineProperty(exports, 'InfoWindow', {
      enumerable: true,
      get: function get() {
        return _InfoWindow.InfoWindow;
      }
    });
    Object.defineProperty(exports, 'HeatMap', {
      enumerable: true,
      get: function get() {
        return _HeatMap.HeatMap;
      }
    });
    Object.defineProperty(exports, 'Polygon', {
      enumerable: true,
      get: function get() {
        return _Polygon.Polygon;
      }
    });
    Object.defineProperty(exports, 'Polyline', {
      enumerable: true,
      get: function get() {
        return _Polyline.Polyline;
      }
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var mapStyles = {
      container: {
        position: 'absolute',
        width: '100%',
        height: '100%'
      },
      map: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0
      }
    };
    var evtNames = ['ready', 'click', 'dragend', 'recenter', 'bounds_changed', 'center_changed', 'dblclick', 'dragstart', 'heading_change', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];

    var Map = exports.Map = function (_React$Component) {
      _inherits(Map, _React$Component);

      function Map(props) {
        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

        if (!props.hasOwnProperty('google')) {
          throw new Error('You must include a `google` prop');
        }

        _this.listeners = {};
        _this.state = {
          currentLocation: {
            lat: _this.props.initialCenter.lat,
            lng: _this.props.initialCenter.lng
          }
        };
        return _this;
      }

      _createClass(Map, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (this.props.centerAroundCurrentLocation) {
            if (navigator && navigator.geolocation) {
              this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function (resolve, reject) {
                navigator.geolocation.getCurrentPosition(resolve, reject);
              }));
              this.geoPromise.promise.then(function (pos) {
                var coords = pos.coords;

                _this2.setState({
                  currentLocation: {
                    lat: coords.latitude,
                    lng: coords.longitude
                  }
                });
              }).catch(function (e) {
                return e;
              });
            }
          }

          this.loadMap();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          if (prevProps.google !== this.props.google) {
            this.loadMap();
          }

          if (this.props.visible !== prevProps.visible) {
            this.restyleMap();
          }

          if (this.props.zoom !== prevProps.zoom) {
            this.map.setZoom(this.props.zoom);
          }

          if (this.props.center !== prevProps.center) {
            this.setState({
              currentLocation: this.props.center
            });
          }

          if (prevState.currentLocation !== this.state.currentLocation) {
            this.recenterMap();
          }

          if (this.props.bounds !== prevProps.bounds) {
            this.map.fitBounds(this.props.bounds);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this3 = this;

          var google = this.props.google;

          if (this.geoPromise) {
            this.geoPromise.cancel();
          }

          Object.keys(this.listeners).forEach(function (e) {
            google.maps.event.removeListener(_this3.listeners[e]);
          });
        }
      }, {
        key: 'loadMap',
        value: function loadMap() {
          var _this4 = this;

          if (this.props && this.props.google) {
            var google = this.props.google;
            var maps = google.maps;
            var mapRef = this.refs.map;

            var node = _reactDom2.default.findDOMNode(mapRef);

            var curr = this.state.currentLocation;
            var center = new maps.LatLng(curr.lat, curr.lng);
            var mapTypeIds = this.props.google.maps.MapTypeId || {};
            var mapTypeFromProps = String(this.props.mapType).toUpperCase();
            var mapConfig = Object.assign({}, {
              mapTypeId: mapTypeIds[mapTypeFromProps],
              center: center,
              zoom: this.props.zoom,
              maxZoom: this.props.maxZoom,
              minZoom: this.props.minZoom,
              clickableIcons: !!this.props.clickableIcons,
              disableDefaultUI: this.props.disableDefaultUI,
              zoomControl: this.props.zoomControl,
              mapTypeControl: this.props.mapTypeControl,
              scaleControl: this.props.scaleControl,
              streetViewControl: this.props.streetViewControl,
              panControl: this.props.panControl,
              rotateControl: this.props.rotateControl,
              fullscreenControl: this.props.fullscreenControl,
              scrollwheel: this.props.scrollwheel,
              draggable: this.props.draggable,
              keyboardShortcuts: this.props.keyboardShortcuts,
              disableDoubleClickZoom: this.props.disableDoubleClickZoom,
              noClear: this.props.noClear,
              styles: this.props.styles,
              gestureHandling: this.props.gestureHandling
            });
            Object.keys(mapConfig).forEach(function (key) {
              // Allow to configure mapConfig with 'false'
              if (mapConfig[key] === null) {
                delete mapConfig[key];
              }
            });
            this.map = new maps.Map(node, mapConfig);
            evtNames.forEach(function (e) {
              _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
            });
            maps.event.trigger(this.map, 'ready');
            this.forceUpdate();
          }
        }
      }, {
        key: 'handleEvent',
        value: function handleEvent(evtName) {
          var _this5 = this;

          var timeout = void 0;
          var handlerName = 'on' + (0, _String.camelize)(evtName);
          return function (e) {
            if (timeout) {
              clearTimeout(timeout);
              timeout = null;
            }

            timeout = setTimeout(function () {
              if (_this5.props[handlerName]) {
                _this5.props[handlerName](_this5.props, _this5.map, e);
              }
            }, 0);
          };
        }
      }, {
        key: 'recenterMap',
        value: function recenterMap() {
          var map = this.map;
          var google = this.props.google;
          if (!google) return;
          var maps = google.maps;

          if (map) {
            var center = this.state.currentLocation;

            if (!(center instanceof google.maps.LatLng)) {
              center = new google.maps.LatLng(center.lat, center.lng);
            } // map.panTo(center)


            map.setCenter(center);
            maps.event.trigger(map, 'recenter');
          }
        }
      }, {
        key: 'restyleMap',
        value: function restyleMap() {
          if (this.map) {
            var google = this.props.google;
            google.maps.event.trigger(this.map, 'resize');
          }
        }
      }, {
        key: 'renderChildren',
        value: function renderChildren() {
          var _this6 = this;

          var children = this.props.children;
          if (!children) return;
          return _react2.default.Children.map(children, function (c) {
            if (!c) return;
            return _react2.default.cloneElement(c, {
              map: _this6.map,
              google: _this6.props.google,
              mapCenter: _this6.state.currentLocation
            });
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var style = Object.assign({}, mapStyles.map, this.props.style, {
            display: this.props.visible ? 'inherit' : 'none'
          });
          var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);
          return _react2.default.createElement('div', {
            style: containerStyles,
            className: this.props.className
          }, _react2.default.createElement('div', {
            style: style,
            ref: 'map'
          }, 'Loading map...'), this.renderChildren());
        }
      }]);

      return Map;
    }(_react2.default.Component);

    Map.propTypes = {
      google: _propTypes2.default.object,
      zoom: _propTypes2.default.number,
      centerAroundCurrentLocation: _propTypes2.default.bool,
      center: _propTypes2.default.object,
      initialCenter: _propTypes2.default.object,
      className: _propTypes2.default.string,
      style: _propTypes2.default.object,
      containerStyle: _propTypes2.default.object,
      visible: _propTypes2.default.bool,
      mapType: _propTypes2.default.string,
      maxZoom: _propTypes2.default.number,
      minZoom: _propTypes2.default.number,
      clickableIcons: _propTypes2.default.bool,
      disableDefaultUI: _propTypes2.default.bool,
      zoomControl: _propTypes2.default.bool,
      mapTypeControl: _propTypes2.default.bool,
      scaleControl: _propTypes2.default.bool,
      streetViewControl: _propTypes2.default.bool,
      panControl: _propTypes2.default.bool,
      rotateControl: _propTypes2.default.bool,
      fullscreenControl: _propTypes2.default.bool,
      scrollwheel: _propTypes2.default.bool,
      draggable: _propTypes2.default.bool,
      keyboardShortcuts: _propTypes2.default.bool,
      disableDoubleClickZoom: _propTypes2.default.bool,
      noClear: _propTypes2.default.bool,
      styles: _propTypes2.default.array,
      gestureHandling: _propTypes2.default.string,
      bounds: _propTypes2.default.object
    };
    evtNames.forEach(function (e) {
      return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
    });
    Map.defaultProps = {
      zoom: 14,
      initialCenter: {
        lat: 37.774929,
        lng: -122.419416
      },
      center: {},
      centerAroundCurrentLocation: false,
      style: {},
      containerStyle: {},
      visible: true
    };
    exports.default = Map;
  });
  /***/

},
/* 192 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks static-only
   */

  /**
   * Memoizes the return value of a function that accepts one string argument.
   */

  function memoizeStringOnly(callback) {
    var cache = {};
    return function (string) {
      if (!cache.hasOwnProperty(string)) {
        cache[string] = callback.call(this, string);
      }

      return cache[string];
    };
  }

  module.exports = memoizeStringOnly;
  /***/
},
/* 193 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports);
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports);
      global.arePathsEqual = mod.exports;
    }
  })(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
     * Compares two path arrays of LatLng objects.
     */


    var arePathsEqual = exports.arePathsEqual = function arePathsEqual(pathA, pathB) {
      if (pathA === pathB) {
        return true;
      }

      if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
        return false;
      }

      if (pathA.length !== pathB.length) {
        return false;
      }

      for (var i = 0; i < pathA.length; ++i) {
        if (pathA[i] === pathB[i]) {
          continue;
        }

        if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) {
          return false;
        }

        if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) {
          return false;
        }
      }

      return true;
    };
    /**
     * Helper that checks whether an array consists of objects
     * with lat and lng properties
     * @param {object} elem the element to check
     * @returns {boolean} whether or not it's valid
     */


    var isValidLatLng = function isValidLatLng(elem) {
      return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('lat') && elem.hasOwnProperty('lng');
    };
  });
  /***/

},
/* 194 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/5bc8a6a54d97b974a90d40c5e03ac47e.svg";
  /***/
},
/* 195 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /* eslint-disable */

  var counter = 0;
  var scriptMap = new Map();

  var ScriptCache = exports.ScriptCache = function (global) {
    return function ScriptCache(scripts) {
      var Cache = {};

      Cache._onLoad = function (key) {
        return function (cb) {
          var stored = scriptMap.get(key);

          if (stored) {
            stored.promise.then(function () {
              stored.error ? cb(stored.error) : cb(null, stored);
            });
          } else {// TODO:
          }
        };
      };

      Cache._scriptTag = function (key, src) {
        if (!scriptMap.has(key)) {
          var tag = document.createElement('script');
          var promise = new Promise(function (resolve, reject) {
            var resolved = false,
                errored = false,
                body = document.getElementsByTagName('body')[0];
            tag.type = 'text/javascript';
            tag.async = false; // Load in order

            var cbName = 'loaderCB' + counter++ + Date.now();
            var cb = void 0;

            var handleResult = function handleResult(state) {
              return function (evt) {
                var stored = scriptMap.get(key);

                if (state === 'loaded') {
                  stored.resolved = true;
                  resolve(src); // stored.handlers.forEach(h => h.call(null, stored))
                  // stored.handlers = []
                } else if (state === 'error') {
                  stored.errored = true; // stored.handlers.forEach(h => h.call(null, stored))
                  // stored.handlers = [];

                  reject(evt);
                }

                cleanup();
              };
            };

            var cleanup = function cleanup() {
              if (global[cbName] && typeof global[cbName] === 'function') {
                global[cbName] = null;
              }
            };

            tag.onload = handleResult('loaded');
            tag.onerror = handleResult('error');

            tag.onreadystatechange = function () {
              handleResult(tag.readyState);
            }; // Pick off callback, if there is one


            if (src.match(/callback=CALLBACK_NAME/)) {
              src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
              cb = window[cbName] = tag.onload;
            } else {
              tag.addEventListener('load', tag.onload);
            }

            tag.addEventListener('error', tag.onerror);
            tag.src = src;
            body.appendChild(tag);
            return tag;
          });
          var initialState = {
            loaded: false,
            error: false,
            promise: promise,
            tag: tag
          };
          scriptMap.set(key, initialState);
        }

        return scriptMap.get(key);
      };

      Object.keys(scripts).forEach(function (key) {
        var script = scripts[key];
        Cache[key] = {
          tag: Cache._scriptTag(key, script),
          onLoad: Cache._onLoad(key)
        };
      });
      return Cache;
    };
  }(window);

  exports.default = ScriptCache;
  /***/
},
/* 196 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/8340531d9c59594ee75ae1e751c25737.eot";
  /***/
},
/* 197 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(198);

  module.exports = __webpack_require__(400);
  /***/
},
/* 198 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global) {
    __webpack_require__(199);

    __webpack_require__(396);

    __webpack_require__(397);

    if (global._babelPolyfill) {
      throw new Error("only one instance of babel-polyfill is allowed");
    }

    global._babelPolyfill = true;
    var DEFINE_PROPERTY = "defineProperty";

    function define(O, key, value) {
      O[key] || Object[DEFINE_PROPERTY](O, key, {
        writable: true,
        configurable: true,
        value: value
      });
    }

    define(String.prototype, "padLeft", "".padStart);
    define(String.prototype, "padRight", "".padEnd);
    "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
      [][key] && define(Array, key, Function.call.bind([][key]));
    });
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(56));
  /***/
},
/* 199 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(200);

  __webpack_require__(202);

  __webpack_require__(203);

  __webpack_require__(204);

  __webpack_require__(205);

  __webpack_require__(206);

  __webpack_require__(207);

  __webpack_require__(208);

  __webpack_require__(209);

  __webpack_require__(210);

  __webpack_require__(211);

  __webpack_require__(212);

  __webpack_require__(213);

  __webpack_require__(214);

  __webpack_require__(215);

  __webpack_require__(216);

  __webpack_require__(218);

  __webpack_require__(219);

  __webpack_require__(220);

  __webpack_require__(221);

  __webpack_require__(222);

  __webpack_require__(223);

  __webpack_require__(224);

  __webpack_require__(225);

  __webpack_require__(226);

  __webpack_require__(227);

  __webpack_require__(228);

  __webpack_require__(229);

  __webpack_require__(230);

  __webpack_require__(231);

  __webpack_require__(232);

  __webpack_require__(233);

  __webpack_require__(234);

  __webpack_require__(235);

  __webpack_require__(236);

  __webpack_require__(237);

  __webpack_require__(238);

  __webpack_require__(239);

  __webpack_require__(240);

  __webpack_require__(241);

  __webpack_require__(242);

  __webpack_require__(243);

  __webpack_require__(244);

  __webpack_require__(245);

  __webpack_require__(246);

  __webpack_require__(247);

  __webpack_require__(248);

  __webpack_require__(249);

  __webpack_require__(250);

  __webpack_require__(251);

  __webpack_require__(252);

  __webpack_require__(253);

  __webpack_require__(254);

  __webpack_require__(255);

  __webpack_require__(256);

  __webpack_require__(257);

  __webpack_require__(258);

  __webpack_require__(259);

  __webpack_require__(260);

  __webpack_require__(261);

  __webpack_require__(262);

  __webpack_require__(263);

  __webpack_require__(264);

  __webpack_require__(265);

  __webpack_require__(266);

  __webpack_require__(267);

  __webpack_require__(268);

  __webpack_require__(269);

  __webpack_require__(270);

  __webpack_require__(271);

  __webpack_require__(272);

  __webpack_require__(273);

  __webpack_require__(274);

  __webpack_require__(275);

  __webpack_require__(276);

  __webpack_require__(277);

  __webpack_require__(278);

  __webpack_require__(280);

  __webpack_require__(281);

  __webpack_require__(283);

  __webpack_require__(284);

  __webpack_require__(285);

  __webpack_require__(286);

  __webpack_require__(287);

  __webpack_require__(288);

  __webpack_require__(289);

  __webpack_require__(291);

  __webpack_require__(292);

  __webpack_require__(293);

  __webpack_require__(294);

  __webpack_require__(295);

  __webpack_require__(296);

  __webpack_require__(297);

  __webpack_require__(298);

  __webpack_require__(299);

  __webpack_require__(300);

  __webpack_require__(301);

  __webpack_require__(302);

  __webpack_require__(303);

  __webpack_require__(113);

  __webpack_require__(304);

  __webpack_require__(305);

  __webpack_require__(148);

  __webpack_require__(306);

  __webpack_require__(307);

  __webpack_require__(308);

  __webpack_require__(309);

  __webpack_require__(310);

  __webpack_require__(151);

  __webpack_require__(153);

  __webpack_require__(154);

  __webpack_require__(311);

  __webpack_require__(312);

  __webpack_require__(313);

  __webpack_require__(314);

  __webpack_require__(315);

  __webpack_require__(316);

  __webpack_require__(317);

  __webpack_require__(318);

  __webpack_require__(319);

  __webpack_require__(320);

  __webpack_require__(321);

  __webpack_require__(322);

  __webpack_require__(323);

  __webpack_require__(324);

  __webpack_require__(325);

  __webpack_require__(326);

  __webpack_require__(327);

  __webpack_require__(328);

  __webpack_require__(329);

  __webpack_require__(330);

  __webpack_require__(331);

  __webpack_require__(332);

  __webpack_require__(333);

  __webpack_require__(334);

  __webpack_require__(335);

  __webpack_require__(336);

  __webpack_require__(337);

  __webpack_require__(338);

  __webpack_require__(339);

  __webpack_require__(340);

  __webpack_require__(341);

  __webpack_require__(342);

  __webpack_require__(343);

  __webpack_require__(344);

  __webpack_require__(345);

  __webpack_require__(346);

  __webpack_require__(347);

  __webpack_require__(348);

  __webpack_require__(349);

  __webpack_require__(350);

  __webpack_require__(351);

  __webpack_require__(352);

  __webpack_require__(353);

  __webpack_require__(354);

  __webpack_require__(355);

  __webpack_require__(356);

  __webpack_require__(357);

  __webpack_require__(358);

  __webpack_require__(359);

  __webpack_require__(360);

  __webpack_require__(361);

  __webpack_require__(362);

  __webpack_require__(363);

  __webpack_require__(364);

  __webpack_require__(365);

  __webpack_require__(366);

  __webpack_require__(367);

  __webpack_require__(368);

  __webpack_require__(369);

  __webpack_require__(370);

  __webpack_require__(371);

  __webpack_require__(372);

  __webpack_require__(373);

  __webpack_require__(374);

  __webpack_require__(375);

  __webpack_require__(376);

  __webpack_require__(377);

  __webpack_require__(378);

  __webpack_require__(379);

  __webpack_require__(380);

  __webpack_require__(381);

  __webpack_require__(382);

  __webpack_require__(383);

  __webpack_require__(384);

  __webpack_require__(385);

  __webpack_require__(386);

  __webpack_require__(387);

  __webpack_require__(388);

  __webpack_require__(389);

  __webpack_require__(390);

  __webpack_require__(391);

  __webpack_require__(392);

  __webpack_require__(393);

  __webpack_require__(394);

  __webpack_require__(395);

  module.exports = __webpack_require__(26);
  /***/
},
/* 200 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // ECMAScript 6 symbols shim

  var global = __webpack_require__(6);

  var has = __webpack_require__(21);

  var DESCRIPTORS = __webpack_require__(11);

  var $export = __webpack_require__(0);

  var redefine = __webpack_require__(19);

  var META = __webpack_require__(40).KEY;

  var $fails = __webpack_require__(7);

  var shared = __webpack_require__(70);

  var setToStringTag = __webpack_require__(57);

  var uid = __webpack_require__(44);

  var wks = __webpack_require__(9);

  var wksExt = __webpack_require__(131);

  var wksDefine = __webpack_require__(93);

  var enumKeys = __webpack_require__(201);

  var isArray = __webpack_require__(73);

  var anObject = __webpack_require__(5);

  var isObject = __webpack_require__(8);

  var toIObject = __webpack_require__(22);

  var toPrimitive = __webpack_require__(32);

  var createDesc = __webpack_require__(43);

  var _create = __webpack_require__(47);

  var gOPNExt = __webpack_require__(134);

  var $GOPD = __webpack_require__(23);

  var $DP = __webpack_require__(12);

  var $keys = __webpack_require__(45);

  var gOPD = $GOPD.f;
  var dP = $DP.f;
  var gOPN = gOPNExt.f;
  var $Symbol = global.Symbol;
  var $JSON = global.JSON;

  var _stringify = $JSON && $JSON.stringify;

  var PROTOTYPE = 'prototype';
  var HIDDEN = wks('_hidden');
  var TO_PRIMITIVE = wks('toPrimitive');
  var isEnum = {}.propertyIsEnumerable;
  var SymbolRegistry = shared('symbol-registry');
  var AllSymbols = shared('symbols');
  var OPSymbols = shared('op-symbols');
  var ObjectProto = Object[PROTOTYPE];
  var USE_NATIVE = typeof $Symbol == 'function';
  var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

  var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

  var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
      get: function get() {
        return dP(this, 'a', {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
  } : dP;

  var wrap = function wrap(tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);

    if (has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _create(D, {
          enumerable: createDesc(0, false)
        });
      }

      return setSymbolDesc(it, key, D);
    }

    return dP(it, key, D);
  };

  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;

    while (l > i) {
      $defineProperty(it, key = keys[i++], P[key]);
    }

    return it;
  };

  var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;

    while (names.length > i) {
      if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    }

    return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;

    while (names.length > i) {
      if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    }

    return result;
  }; // 19.4.1.1 Symbol([description])


  if (!USE_NATIVE) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

      var $set = function $set(value) {
        if (this === ObjectProto) $set.call(OPSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      };

      if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
        configurable: true,
        set: $set
      });
      return wrap(tag);
    };

    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
      return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(48).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(63).f = $propertyIsEnumerable;
    __webpack_require__(72).f = $getOwnPropertySymbols;

    if (DESCRIPTORS && !__webpack_require__(41)) {
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    wksExt.f = function (name) {
      return wrap(wks(name));
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
  });

  for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
    wks(es6Symbols[j++]);
  }

  for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
    wksDefine(wellKnownSymbols[k++]);
  }

  $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function _for(key) {
      return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

      for (var key in SymbolRegistry) {
        if (SymbolRegistry[key] === sym) return key;
      }
    },
    useSetter: function useSetter() {
      setter = true;
    },
    useSimple: function useSimple() {
      setter = false;
    }
  });
  $export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

  $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols

    return _stringify([S]) != '[null]' || _stringify({
      a: S
    }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      $replacer = replacer = args[1];
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

      if (!isArray(replacer)) replacer = function replacer(key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

  $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(18)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

  setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

  setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

  setToStringTag(global.JSON, 'JSON', true);
  /***/
},
/* 201 */

/***/
function (module, exports, __webpack_require__) {
  // all enumerable object keys, includes symbols
  var getKeys = __webpack_require__(45);

  var gOPS = __webpack_require__(72);

  var pIE = __webpack_require__(63);

  module.exports = function (it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;

    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = pIE.f;
      var i = 0;
      var key;

      while (symbols.length > i) {
        if (isEnum.call(it, key = symbols[i++])) result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 202 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


  $export($export.S, 'Object', {
    create: __webpack_require__(47)
  });
  /***/
},
/* 203 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


  $export($export.S + $export.F * !__webpack_require__(11), 'Object', {
    defineProperty: __webpack_require__(12).f
  });
  /***/
},
/* 204 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0); // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)


  $export($export.S + $export.F * !__webpack_require__(11), 'Object', {
    defineProperties: __webpack_require__(133)
  });
  /***/
},
/* 205 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  var toIObject = __webpack_require__(22);

  var $getOwnPropertyDescriptor = __webpack_require__(23).f;

  __webpack_require__(35)('getOwnPropertyDescriptor', function () {
    return function getOwnPropertyDescriptor(it, key) {
      return $getOwnPropertyDescriptor(toIObject(it), key);
    };
  });
  /***/

},
/* 206 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 Object.getPrototypeOf(O)
  var toObject = __webpack_require__(14);

  var $getPrototypeOf = __webpack_require__(24);

  __webpack_require__(35)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
      return $getPrototypeOf(toObject(it));
    };
  });
  /***/

},
/* 207 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 Object.keys(O)
  var toObject = __webpack_require__(14);

  var $keys = __webpack_require__(45);

  __webpack_require__(35)('keys', function () {
    return function keys(it) {
      return $keys(toObject(it));
    };
  });
  /***/

},
/* 208 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  __webpack_require__(35)('getOwnPropertyNames', function () {
    return __webpack_require__(134).f;
  });
  /***/

},
/* 209 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.5 Object.freeze(O)
  var isObject = __webpack_require__(8);

  var meta = __webpack_require__(40).onFreeze;

  __webpack_require__(35)('freeze', function ($freeze) {
    return function freeze(it) {
      return $freeze && isObject(it) ? $freeze(meta(it)) : it;
    };
  });
  /***/

},
/* 210 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.17 Object.seal(O)
  var isObject = __webpack_require__(8);

  var meta = __webpack_require__(40).onFreeze;

  __webpack_require__(35)('seal', function ($seal) {
    return function seal(it) {
      return $seal && isObject(it) ? $seal(meta(it)) : it;
    };
  });
  /***/

},
/* 211 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.15 Object.preventExtensions(O)
  var isObject = __webpack_require__(8);

  var meta = __webpack_require__(40).onFreeze;

  __webpack_require__(35)('preventExtensions', function ($preventExtensions) {
    return function preventExtensions(it) {
      return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
    };
  });
  /***/

},
/* 212 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.12 Object.isFrozen(O)
  var isObject = __webpack_require__(8);

  __webpack_require__(35)('isFrozen', function ($isFrozen) {
    return function isFrozen(it) {
      return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
  });
  /***/

},
/* 213 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.13 Object.isSealed(O)
  var isObject = __webpack_require__(8);

  __webpack_require__(35)('isSealed', function ($isSealed) {
    return function isSealed(it) {
      return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
    };
  });
  /***/

},
/* 214 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.11 Object.isExtensible(O)
  var isObject = __webpack_require__(8);

  __webpack_require__(35)('isExtensible', function ($isExtensible) {
    return function isExtensible(it) {
      return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
  });
  /***/

},
/* 215 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.1 Object.assign(target, source)
  var $export = __webpack_require__(0);

  $export($export.S + $export.F, 'Object', {
    assign: __webpack_require__(135)
  });
  /***/
},
/* 216 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.10 Object.is(value1, value2)
  var $export = __webpack_require__(0);

  $export($export.S, 'Object', {
    is: __webpack_require__(217)
  });
  /***/
},
/* 217 */

/***/
function (module, exports) {
  // 7.2.9 SameValue(x, y)
  module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };
  /***/

},
/* 218 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.19 Object.setPrototypeOf(O, proto)
  var $export = __webpack_require__(0);

  $export($export.S, 'Object', {
    setPrototypeOf: __webpack_require__(97).set
  });
  /***/
},
/* 219 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 19.1.3.6 Object.prototype.toString()

  var classof = __webpack_require__(64);

  var test = {};
  test[__webpack_require__(9)('toStringTag')] = 'z';

  if (test + '' != '[object z]') {
    __webpack_require__(19)(Object.prototype, 'toString', function toString() {
      return '[object ' + classof(this) + ']';
    }, true);
  }
  /***/

},
/* 220 */

/***/
function (module, exports, __webpack_require__) {
  // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
  var $export = __webpack_require__(0);

  $export($export.P, 'Function', {
    bind: __webpack_require__(136)
  });
  /***/
},
/* 221 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(12).f;

  var FProto = Function.prototype;
  var nameRE = /^\s*function ([^ (]*)/;
  var NAME = 'name'; // 19.2.4.2 name

  NAME in FProto || __webpack_require__(11) && dP(FProto, NAME, {
    configurable: true,
    get: function get() {
      try {
        return ('' + this).match(nameRE)[1];
      } catch (e) {
        return '';
      }
    }
  });
  /***/
},
/* 222 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var isObject = __webpack_require__(8);

  var getPrototypeOf = __webpack_require__(24);

  var HAS_INSTANCE = __webpack_require__(9)('hasInstance');

  var FunctionProto = Function.prototype; // 19.2.3.6 Function.prototype[@@hasInstance](V)

  if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(12).f(FunctionProto, HAS_INSTANCE, {
    value: function value(O) {
      if (typeof this != 'function' || !isObject(O)) return false;
      if (!isObject(this.prototype)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

      while (O = getPrototypeOf(O)) {
        if (this.prototype === O) return true;
      }

      return false;
    }
  });
  /***/
},
/* 223 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseInt = __webpack_require__(138); // 18.2.5 parseInt(string, radix)


  $export($export.G + $export.F * (parseInt != $parseInt), {
    parseInt: $parseInt
  });
  /***/
},
/* 224 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseFloat = __webpack_require__(139); // 18.2.4 parseFloat(string)


  $export($export.G + $export.F * (parseFloat != $parseFloat), {
    parseFloat: $parseFloat
  });
  /***/
},
/* 225 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(6);

  var has = __webpack_require__(21);

  var cof = __webpack_require__(28);

  var inheritIfRequired = __webpack_require__(99);

  var toPrimitive = __webpack_require__(32);

  var fails = __webpack_require__(7);

  var gOPN = __webpack_require__(48).f;

  var gOPD = __webpack_require__(23).f;

  var dP = __webpack_require__(12).f;

  var $trim = __webpack_require__(58).trim;

  var NUMBER = 'Number';
  var $Number = global[NUMBER];
  var Base = $Number;
  var proto = $Number.prototype; // Opera ~12 has broken Object#toString

  var BROKEN_COF = cof(__webpack_require__(47)(proto)) == NUMBER;
  var TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)

  var toNumber = function toNumber(argument) {
    var it = toPrimitive(argument, false);

    if (typeof it == 'string' && it.length > 2) {
      it = TRIM ? it.trim() : $trim(it, 3);
      var first = it.charCodeAt(0);
      var third, radix, maxCode;

      if (first === 43 || first === 45) {
        third = it.charCodeAt(2);
        if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
      } else if (first === 48) {
        switch (it.charCodeAt(1)) {
          case 66:
          case 98:
            radix = 2;
            maxCode = 49;
            break;
          // fast equal /^0b[01]+$/i

          case 79:
          case 111:
            radix = 8;
            maxCode = 55;
            break;
          // fast equal /^0o[0-7]+$/i

          default:
            return +it;
        }

        for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
          code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
          // but ToNumber should return NaN if a string contains unavailable symbols

          if (code < 48 || code > maxCode) return NaN;
        }

        return parseInt(digits, radix);
      }
    }

    return +it;
  };

  if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
    $Number = function Number(value) {
      var it = arguments.length < 1 ? 0 : value;
      var that = this;
      return that instanceof $Number // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () {
        proto.valueOf.call(that);
      }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
    };

    for (var keys = __webpack_require__(11) ? gOPN(Base) : ( // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
      if (has(Base, key = keys[j]) && !has($Number, key)) {
        dP($Number, key, gOPD(Base, key));
      }
    }

    $Number.prototype = proto;
    proto.constructor = $Number;

    __webpack_require__(19)(global, NUMBER, $Number);
  }
  /***/

},
/* 226 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toInteger = __webpack_require__(34);

  var aNumberValue = __webpack_require__(140);

  var repeat = __webpack_require__(100);

  var $toFixed = 1.0.toFixed;
  var floor = Math.floor;
  var data = [0, 0, 0, 0, 0, 0];
  var ERROR = 'Number.toFixed: incorrect invocation!';
  var ZERO = '0';

  var multiply = function multiply(n, c) {
    var i = -1;
    var c2 = c;

    while (++i < 6) {
      c2 += n * data[i];
      data[i] = c2 % 1e7;
      c2 = floor(c2 / 1e7);
    }
  };

  var divide = function divide(n) {
    var i = 6;
    var c = 0;

    while (--i >= 0) {
      c += data[i];
      data[i] = floor(c / n);
      c = c % n * 1e7;
    }
  };

  var numToString = function numToString() {
    var i = 6;
    var s = '';

    while (--i >= 0) {
      if (s !== '' || i === 0 || data[i] !== 0) {
        var t = String(data[i]);
        s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
      }
    }

    return s;
  };

  var pow = function pow(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
  };

  var log = function log(x) {
    var n = 0;
    var x2 = x;

    while (x2 >= 4096) {
      n += 12;
      x2 /= 4096;
    }

    while (x2 >= 2) {
      n += 1;
      x2 /= 2;
    }

    return n;
  };

  $export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(7)(function () {
    // V8 ~ Android 4.3-
    $toFixed.call({});
  })), 'Number', {
    toFixed: function toFixed(fractionDigits) {
      var x = aNumberValue(this, ERROR);
      var f = toInteger(fractionDigits);
      var s = '';
      var m = ZERO;
      var e, z, j, k;
      if (f < 0 || f > 20) throw RangeError(ERROR); // eslint-disable-next-line no-self-compare

      if (x != x) return 'NaN';
      if (x <= -1e21 || x >= 1e21) return String(x);

      if (x < 0) {
        s = '-';
        x = -x;
      }

      if (x > 1e-21) {
        e = log(x * pow(2, 69, 1)) - 69;
        z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
        z *= 0x10000000000000;
        e = 52 - e;

        if (e > 0) {
          multiply(0, z);
          j = f;

          while (j >= 7) {
            multiply(1e7, 0);
            j -= 7;
          }

          multiply(pow(10, j, 1), 0);
          j = e - 1;

          while (j >= 23) {
            divide(1 << 23);
            j -= 23;
          }

          divide(1 << j);
          multiply(1, 1);
          divide(2);
          m = numToString();
        } else {
          multiply(0, z);
          multiply(1 << -e, 0);
          m = numToString() + repeat.call(ZERO, f);
        }
      }

      if (f > 0) {
        k = m.length;
        m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
      } else {
        m = s + m;
      }

      return m;
    }
  });
  /***/
},
/* 227 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $fails = __webpack_require__(7);

  var aNumberValue = __webpack_require__(140);

  var $toPrecision = 1.0.toPrecision;
  $export($export.P + $export.F * ($fails(function () {
    // IE7-
    return $toPrecision.call(1, undefined) !== '1';
  }) || !$fails(function () {
    // V8 ~ Android 4.3-
    $toPrecision.call({});
  })), 'Number', {
    toPrecision: function toPrecision(precision) {
      var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
      return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
    }
  });
  /***/
},
/* 228 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.1 Number.EPSILON
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    EPSILON: Math.pow(2, -52)
  });
  /***/
},
/* 229 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.2 Number.isFinite(number)
  var $export = __webpack_require__(0);

  var _isFinite = __webpack_require__(6).isFinite;

  $export($export.S, 'Number', {
    isFinite: function isFinite(it) {
      return typeof it == 'number' && _isFinite(it);
    }
  });
  /***/
},
/* 230 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.3 Number.isInteger(number)
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    isInteger: __webpack_require__(141)
  });
  /***/
},
/* 231 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.4 Number.isNaN(number)
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    isNaN: function isNaN(number) {
      // eslint-disable-next-line no-self-compare
      return number != number;
    }
  });
  /***/
},
/* 232 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.5 Number.isSafeInteger(number)
  var $export = __webpack_require__(0);

  var isInteger = __webpack_require__(141);

  var abs = Math.abs;
  $export($export.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
      return isInteger(number) && abs(number) <= 0x1fffffffffffff;
    }
  });
  /***/
},
/* 233 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.6 Number.MAX_SAFE_INTEGER
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
  });
  /***/
},
/* 234 */

/***/
function (module, exports, __webpack_require__) {
  // 20.1.2.10 Number.MIN_SAFE_INTEGER
  var $export = __webpack_require__(0);

  $export($export.S, 'Number', {
    MIN_SAFE_INTEGER: -0x1fffffffffffff
  });
  /***/
},
/* 235 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseFloat = __webpack_require__(139); // 20.1.2.12 Number.parseFloat(string)


  $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {
    parseFloat: $parseFloat
  });
  /***/
},
/* 236 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $parseInt = __webpack_require__(138); // 20.1.2.13 Number.parseInt(string, radix)


  $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {
    parseInt: $parseInt
  });
  /***/
},
/* 237 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.3 Math.acosh(x)
  var $export = __webpack_require__(0);

  var log1p = __webpack_require__(142);

  var sqrt = Math.sqrt;
  var $acosh = Math.acosh;
  $export($export.S + $export.F * !($acosh // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710 // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
      return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
    }
  });
  /***/
},
/* 238 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.5 Math.asinh(x)
  var $export = __webpack_require__(0);

  var $asinh = Math.asinh;

  function asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
  } // Tor Browser bug: Math.asinh(0) -> -0


  $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {
    asinh: asinh
  });
  /***/
},
/* 239 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.7 Math.atanh(x)
  var $export = __webpack_require__(0);

  var $atanh = Math.atanh; // Tor Browser bug: Math.atanh(-0) -> 0

  $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
      return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
  });
  /***/
},
/* 240 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.9 Math.cbrt(x)
  var $export = __webpack_require__(0);

  var sign = __webpack_require__(101);

  $export($export.S, 'Math', {
    cbrt: function cbrt(x) {
      return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
  });
  /***/
},
/* 241 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.11 Math.clz32(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    clz32: function clz32(x) {
      return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
  });
  /***/
},
/* 242 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.12 Math.cosh(x)
  var $export = __webpack_require__(0);

  var exp = Math.exp;
  $export($export.S, 'Math', {
    cosh: function cosh(x) {
      return (exp(x = +x) + exp(-x)) / 2;
    }
  });
  /***/
},
/* 243 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.14 Math.expm1(x)
  var $export = __webpack_require__(0);

  var $expm1 = __webpack_require__(102);

  $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {
    expm1: $expm1
  });
  /***/
},
/* 244 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.16 Math.fround(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    fround: __webpack_require__(143)
  });
  /***/
},
/* 245 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
  var $export = __webpack_require__(0);

  var abs = Math.abs;
  $export($export.S, 'Math', {
    hypot: function hypot(value1, value2) {
      // eslint-disable-line no-unused-vars
      var sum = 0;
      var i = 0;
      var aLen = arguments.length;
      var larg = 0;
      var arg, div;

      while (i < aLen) {
        arg = abs(arguments[i++]);

        if (larg < arg) {
          div = larg / arg;
          sum = sum * div * div + 1;
          larg = arg;
        } else if (arg > 0) {
          div = arg / larg;
          sum += div * div;
        } else sum += arg;
      }

      return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
  });
  /***/
},
/* 246 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.18 Math.imul(x, y)
  var $export = __webpack_require__(0);

  var $imul = Math.imul; // some WebKit versions fails with big numbers, some has wrong arity

  $export($export.S + $export.F * __webpack_require__(7)(function () {
    return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
  }), 'Math', {
    imul: function imul(x, y) {
      var UINT16 = 0xffff;
      var xn = +x;
      var yn = +y;
      var xl = UINT16 & xn;
      var yl = UINT16 & yn;
      return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
  });
  /***/
},
/* 247 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.21 Math.log10(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    log10: function log10(x) {
      return Math.log(x) * Math.LOG10E;
    }
  });
  /***/
},
/* 248 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.20 Math.log1p(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    log1p: __webpack_require__(142)
  });
  /***/
},
/* 249 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.22 Math.log2(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    log2: function log2(x) {
      return Math.log(x) / Math.LN2;
    }
  });
  /***/
},
/* 250 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.28 Math.sign(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    sign: __webpack_require__(101)
  });
  /***/
},
/* 251 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.30 Math.sinh(x)
  var $export = __webpack_require__(0);

  var expm1 = __webpack_require__(102);

  var exp = Math.exp; // V8 near Chromium 38 has a problem with very small numbers

  $export($export.S + $export.F * __webpack_require__(7)(function () {
    return !Math.sinh(-2e-17) != -2e-17;
  }), 'Math', {
    sinh: function sinh(x) {
      return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
    }
  });
  /***/
},
/* 252 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.33 Math.tanh(x)
  var $export = __webpack_require__(0);

  var expm1 = __webpack_require__(102);

  var exp = Math.exp;
  $export($export.S, 'Math', {
    tanh: function tanh(x) {
      var a = expm1(x = +x);
      var b = expm1(-x);
      return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
    }
  });
  /***/
},
/* 253 */

/***/
function (module, exports, __webpack_require__) {
  // 20.2.2.34 Math.trunc(x)
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    trunc: function trunc(it) {
      return (it > 0 ? Math.floor : Math.ceil)(it);
    }
  });
  /***/
},
/* 254 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var toAbsoluteIndex = __webpack_require__(46);

  var fromCharCode = String.fromCharCode;
  var $fromCodePoint = String.fromCodePoint; // length should be 1, old FF problem

  $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
      // eslint-disable-line no-unused-vars
      var res = [];
      var aLen = arguments.length;
      var i = 0;
      var code;

      while (aLen > i) {
        code = +arguments[i++];
        if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
        res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
      }

      return res.join('');
    }
  });
  /***/
},
/* 255 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var toIObject = __webpack_require__(22);

  var toLength = __webpack_require__(13);

  $export($export.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
      var tpl = toIObject(callSite.raw);
      var len = toLength(tpl.length);
      var aLen = arguments.length;
      var res = [];
      var i = 0;

      while (len > i) {
        res.push(String(tpl[i++]));
        if (i < aLen) res.push(String(arguments[i]));
      }

      return res.join('');
    }
  });
  /***/
},
/* 256 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.25 String.prototype.trim()

  __webpack_require__(58)('trim', function ($trim) {
    return function trim() {
      return $trim(this, 3);
    };
  });
  /***/

},
/* 257 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $at = __webpack_require__(103)(true); // 21.1.3.27 String.prototype[@@iterator]()


  __webpack_require__(104)(String, 'String', function (iterated) {
    this._t = String(iterated); // target

    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
  /***/

},
/* 258 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $at = __webpack_require__(103)(false);

  $export($export.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
      return $at(this, pos);
    }
  });
  /***/
},
/* 259 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

  var $export = __webpack_require__(0);

  var toLength = __webpack_require__(13);

  var context = __webpack_require__(106);

  var ENDS_WITH = 'endsWith';
  var $endsWith = ''[ENDS_WITH];
  $export($export.P + $export.F * __webpack_require__(107)(ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString
    /* , endPosition = @length */
    ) {
      var that = context(this, searchString, ENDS_WITH);
      var endPosition = arguments.length > 1 ? arguments[1] : undefined;
      var len = toLength(that.length);
      var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
      var search = String(searchString);
      return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
  });
  /***/
},
/* 260 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.7 String.prototype.includes(searchString, position = 0)

  var $export = __webpack_require__(0);

  var context = __webpack_require__(106);

  var INCLUDES = 'includes';
  $export($export.P + $export.F * __webpack_require__(107)(INCLUDES), 'String', {
    includes: function includes(searchString
    /* , position = 0 */
    ) {
      return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 261 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  $export($export.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: __webpack_require__(100)
  });
  /***/
},
/* 262 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

  var $export = __webpack_require__(0);

  var toLength = __webpack_require__(13);

  var context = __webpack_require__(106);

  var STARTS_WITH = 'startsWith';
  var $startsWith = ''[STARTS_WITH];
  $export($export.P + $export.F * __webpack_require__(107)(STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString
    /* , position = 0 */
    ) {
      var that = context(this, searchString, STARTS_WITH);
      var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
      var search = String(searchString);
      return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
  });
  /***/
},
/* 263 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.2 String.prototype.anchor(name)

  __webpack_require__(20)('anchor', function (createHTML) {
    return function anchor(name) {
      return createHTML(this, 'a', 'name', name);
    };
  });
  /***/

},
/* 264 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.3 String.prototype.big()

  __webpack_require__(20)('big', function (createHTML) {
    return function big() {
      return createHTML(this, 'big', '', '');
    };
  });
  /***/

},
/* 265 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.4 String.prototype.blink()

  __webpack_require__(20)('blink', function (createHTML) {
    return function blink() {
      return createHTML(this, 'blink', '', '');
    };
  });
  /***/

},
/* 266 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.5 String.prototype.bold()

  __webpack_require__(20)('bold', function (createHTML) {
    return function bold() {
      return createHTML(this, 'b', '', '');
    };
  });
  /***/

},
/* 267 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.6 String.prototype.fixed()

  __webpack_require__(20)('fixed', function (createHTML) {
    return function fixed() {
      return createHTML(this, 'tt', '', '');
    };
  });
  /***/

},
/* 268 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.7 String.prototype.fontcolor(color)

  __webpack_require__(20)('fontcolor', function (createHTML) {
    return function fontcolor(color) {
      return createHTML(this, 'font', 'color', color);
    };
  });
  /***/

},
/* 269 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.8 String.prototype.fontsize(size)

  __webpack_require__(20)('fontsize', function (createHTML) {
    return function fontsize(size) {
      return createHTML(this, 'font', 'size', size);
    };
  });
  /***/

},
/* 270 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.9 String.prototype.italics()

  __webpack_require__(20)('italics', function (createHTML) {
    return function italics() {
      return createHTML(this, 'i', '', '');
    };
  });
  /***/

},
/* 271 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.10 String.prototype.link(url)

  __webpack_require__(20)('link', function (createHTML) {
    return function link(url) {
      return createHTML(this, 'a', 'href', url);
    };
  });
  /***/

},
/* 272 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.11 String.prototype.small()

  __webpack_require__(20)('small', function (createHTML) {
    return function small() {
      return createHTML(this, 'small', '', '');
    };
  });
  /***/

},
/* 273 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.12 String.prototype.strike()

  __webpack_require__(20)('strike', function (createHTML) {
    return function strike() {
      return createHTML(this, 'strike', '', '');
    };
  });
  /***/

},
/* 274 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.13 String.prototype.sub()

  __webpack_require__(20)('sub', function (createHTML) {
    return function sub() {
      return createHTML(this, 'sub', '', '');
    };
  });
  /***/

},
/* 275 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // B.2.3.14 String.prototype.sup()

  __webpack_require__(20)('sup', function (createHTML) {
    return function sup() {
      return createHTML(this, 'sup', '', '');
    };
  });
  /***/

},
/* 276 */

/***/
function (module, exports, __webpack_require__) {
  // 20.3.3.1 / 15.9.4.4 Date.now()
  var $export = __webpack_require__(0);

  $export($export.S, 'Date', {
    now: function now() {
      return new Date().getTime();
    }
  });
  /***/
},
/* 277 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(14);

  var toPrimitive = __webpack_require__(32);

  $export($export.P + $export.F * __webpack_require__(7)(function () {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
      toISOString: function toISOString() {
        return 1;
      }
    }) !== 1;
  }), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
      var O = toObject(this);
      var pv = toPrimitive(O);
      return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
  });
  /***/
},
/* 278 */

/***/
function (module, exports, __webpack_require__) {
  // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
  var $export = __webpack_require__(0);

  var toISOString = __webpack_require__(279); // PhantomJS / old WebKit has a broken implementations


  $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
    toISOString: toISOString
  });
  /***/
},
/* 279 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

  var fails = __webpack_require__(7);

  var getTime = Date.prototype.getTime;
  var $toISOString = Date.prototype.toISOString;

  var lz = function lz(num) {
    return num > 9 ? num : '0' + num;
  }; // PhantomJS / old WebKit has a broken implementations


  module.exports = fails(function () {
    return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
  }) || !fails(function () {
    $toISOString.call(new Date(NaN));
  }) ? function toISOString() {
    if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  } : $toISOString;
  /***/
},
/* 280 */

/***/
function (module, exports, __webpack_require__) {
  var DateProto = Date.prototype;
  var INVALID_DATE = 'Invalid Date';
  var TO_STRING = 'toString';
  var $toString = DateProto[TO_STRING];
  var getTime = DateProto.getTime;

  if (new Date(NaN) + '' != INVALID_DATE) {
    __webpack_require__(19)(DateProto, TO_STRING, function toString() {
      var value = getTime.call(this); // eslint-disable-next-line no-self-compare

      return value === value ? $toString.call(this) : INVALID_DATE;
    });
  }
  /***/

},
/* 281 */

/***/
function (module, exports, __webpack_require__) {
  var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive');

  var proto = Date.prototype;
  if (!(TO_PRIMITIVE in proto)) __webpack_require__(18)(proto, TO_PRIMITIVE, __webpack_require__(282));
  /***/
},
/* 282 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var anObject = __webpack_require__(5);

  var toPrimitive = __webpack_require__(32);

  var NUMBER = 'number';

  module.exports = function (hint) {
    if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return toPrimitive(anObject(this), hint != NUMBER);
  };
  /***/

},
/* 283 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
  var $export = __webpack_require__(0);

  $export($export.S, 'Array', {
    isArray: __webpack_require__(73)
  });
  /***/
},
/* 284 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ctx = __webpack_require__(27);

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(14);

  var call = __webpack_require__(144);

  var isArrayIter = __webpack_require__(108);

  var toLength = __webpack_require__(13);

  var createProperty = __webpack_require__(109);

  var getIterFn = __webpack_require__(110);

  $export($export.S + $export.F * !__webpack_require__(75)(function (iter) {
    Array.from(iter);
  }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike
    /* , mapfn = undefined, thisArg = undefined */
    ) {
      var O = toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = getIterFn(O);
      var length, result, step, iterator;
      if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

      if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = toLength(O.length);

        for (result = new C(length); length > index; index++) {
          createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }

      result.length = index;
      return result;
    }
  });
  /***/
},
/* 285 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var createProperty = __webpack_require__(109); // WebKit Array.of isn't generic


  $export($export.S + $export.F * __webpack_require__(7)(function () {
    function F() {
      /* empty */
    }

    return !(Array.of.call(F) instanceof F);
  }), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of()
    /* ...args */
    {
      var index = 0;
      var aLen = arguments.length;
      var result = new (typeof this == 'function' ? this : Array)(aLen);

      while (aLen > index) {
        createProperty(result, index, arguments[index++]);
      }

      result.length = aLen;
      return result;
    }
  });
  /***/
},
/* 286 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.13 Array.prototype.join(separator)

  var $export = __webpack_require__(0);

  var toIObject = __webpack_require__(22);

  var arrayJoin = [].join; // fallback for not array-like strings

  $export($export.P + $export.F * (__webpack_require__(62) != Object || !__webpack_require__(29)(arrayJoin)), 'Array', {
    join: function join(separator) {
      return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
    }
  });
  /***/
},
/* 287 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var html = __webpack_require__(96);

  var cof = __webpack_require__(28);

  var toAbsoluteIndex = __webpack_require__(46);

  var toLength = __webpack_require__(13);

  var arraySlice = [].slice; // fallback for not array-like ES3 strings and DOM objects

  $export($export.P + $export.F * __webpack_require__(7)(function () {
    if (html) arraySlice.call(html);
  }), 'Array', {
    slice: function slice(begin, end) {
      var len = toLength(this.length);
      var klass = cof(this);
      end = end === undefined ? len : end;
      if (klass == 'Array') return arraySlice.call(this, begin, end);
      var start = toAbsoluteIndex(begin, len);
      var upTo = toAbsoluteIndex(end, len);
      var size = toLength(upTo - start);
      var cloned = new Array(size);
      var i = 0;

      for (; i < size; i++) {
        cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
      }

      return cloned;
    }
  });
  /***/
},
/* 288 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var aFunction = __webpack_require__(16);

  var toObject = __webpack_require__(14);

  var fails = __webpack_require__(7);

  var $sort = [].sort;
  var test = [1, 2, 3];
  $export($export.P + $export.F * (fails(function () {
    // IE8-
    test.sort(undefined);
  }) || !fails(function () {
    // V8 bug
    test.sort(null); // Old WebKit
  }) || !__webpack_require__(29)($sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
      return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
    }
  });
  /***/
},
/* 289 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $forEach = __webpack_require__(36)(0);

  var STRICT = __webpack_require__(29)([].forEach, true);

  $export($export.P + $export.F * !STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn
    /* , thisArg */
    ) {
      return $forEach(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 290 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(8);

  var isArray = __webpack_require__(73);

  var SPECIES = __webpack_require__(9)('species');

  module.exports = function (original) {
    var C;

    if (isArray(original)) {
      C = original.constructor; // cross-realm fallback

      if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;

      if (isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    }

    return C === undefined ? Array : C;
  };
  /***/

},
/* 291 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $map = __webpack_require__(36)(1);

  $export($export.P + $export.F * !__webpack_require__(29)([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn
    /* , thisArg */
    ) {
      return $map(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 292 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $filter = __webpack_require__(36)(2);

  $export($export.P + $export.F * !__webpack_require__(29)([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn
    /* , thisArg */
    ) {
      return $filter(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 293 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $some = __webpack_require__(36)(3);

  $export($export.P + $export.F * !__webpack_require__(29)([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn
    /* , thisArg */
    ) {
      return $some(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 294 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $every = __webpack_require__(36)(4);

  $export($export.P + $export.F * !__webpack_require__(29)([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn
    /* , thisArg */
    ) {
      return $every(this, callbackfn, arguments[1]);
    }
  });
  /***/
},
/* 295 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $reduce = __webpack_require__(145);

  $export($export.P + $export.F * !__webpack_require__(29)([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn
    /* , initialValue */
    ) {
      return $reduce(this, callbackfn, arguments.length, arguments[1], false);
    }
  });
  /***/
},
/* 296 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $reduce = __webpack_require__(145);

  $export($export.P + $export.F * !__webpack_require__(29)([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn
    /* , initialValue */
    ) {
      return $reduce(this, callbackfn, arguments.length, arguments[1], true);
    }
  });
  /***/
},
/* 297 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $indexOf = __webpack_require__(71)(false);

  var $native = [].indexOf;
  var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
  $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(29)($native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement
    /* , fromIndex = 0 */
    ) {
      return NEGATIVE_ZERO // convert -0 to +0
      ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
    }
  });
  /***/
},
/* 298 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toIObject = __webpack_require__(22);

  var toInteger = __webpack_require__(34);

  var toLength = __webpack_require__(13);

  var $native = [].lastIndexOf;
  var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
  $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(29)($native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement
    /* , fromIndex = @[*-1] */
    ) {
      // convert -0 to +0
      if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
      var O = toIObject(this);
      var length = toLength(O.length);
      var index = length - 1;
      if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
      if (index < 0) index = length + index;

      for (; index >= 0; index--) {
        if (index in O) if (O[index] === searchElement) return index || 0;
      }

      return -1;
    }
  });
  /***/
},
/* 299 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
  var $export = __webpack_require__(0);

  $export($export.P, 'Array', {
    copyWithin: __webpack_require__(146)
  });

  __webpack_require__(42)('copyWithin');
  /***/

},
/* 300 */

/***/
function (module, exports, __webpack_require__) {
  // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
  var $export = __webpack_require__(0);

  $export($export.P, 'Array', {
    fill: __webpack_require__(112)
  });

  __webpack_require__(42)('fill');
  /***/

},
/* 301 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

  var $export = __webpack_require__(0);

  var $find = __webpack_require__(36)(5);

  var KEY = 'find';
  var forced = true; // Shouldn't skip holes

  if (KEY in []) Array(1)[KEY](function () {
    forced = false;
  });
  $export($export.P + $export.F * forced, 'Array', {
    find: function find(callbackfn
    /* , that = undefined */
    ) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  __webpack_require__(42)(KEY);
  /***/

},
/* 302 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

  var $export = __webpack_require__(0);

  var $find = __webpack_require__(36)(6);

  var KEY = 'findIndex';
  var forced = true; // Shouldn't skip holes

  if (KEY in []) Array(1)[KEY](function () {
    forced = false;
  });
  $export($export.P + $export.F * forced, 'Array', {
    findIndex: function findIndex(callbackfn
    /* , that = undefined */
    ) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  __webpack_require__(42)(KEY);
  /***/

},
/* 303 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(49)('Array');
  /***/

},
/* 304 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(6);

  var inheritIfRequired = __webpack_require__(99);

  var dP = __webpack_require__(12).f;

  var gOPN = __webpack_require__(48).f;

  var isRegExp = __webpack_require__(74);

  var $flags = __webpack_require__(76);

  var $RegExp = global.RegExp;
  var Base = $RegExp;
  var proto = $RegExp.prototype;
  var re1 = /a/g;
  var re2 = /a/g; // "new" creates a new object, old webkit buggy here

  var CORRECT_NEW = new $RegExp(re1) !== re1;

  if (__webpack_require__(11) && (!CORRECT_NEW || __webpack_require__(7)(function () {
    re2[__webpack_require__(9)('match')] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

    return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
  }))) {
    $RegExp = function RegExp(p, f) {
      var tiRE = this instanceof $RegExp;
      var piRE = isRegExp(p);
      var fiU = f === undefined;
      return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
    };

    var proxy = function proxy(key) {
      key in $RegExp || dP($RegExp, key, {
        configurable: true,
        get: function get() {
          return Base[key];
        },
        set: function set(it) {
          Base[key] = it;
        }
      });
    };

    for (var keys = gOPN(Base), i = 0; keys.length > i;) {
      proxy(keys[i++]);
    }

    proto.constructor = $RegExp;
    $RegExp.prototype = proto;

    __webpack_require__(19)(global, 'RegExp', $RegExp);
  }

  __webpack_require__(49)('RegExp');
  /***/

},
/* 305 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  __webpack_require__(148);

  var anObject = __webpack_require__(5);

  var $flags = __webpack_require__(76);

  var DESCRIPTORS = __webpack_require__(11);

  var TO_STRING = 'toString';
  var $toString = /./[TO_STRING];

  var define = function define(fn) {
    __webpack_require__(19)(RegExp.prototype, TO_STRING, fn, true);
  }; // 21.2.5.14 RegExp.prototype.toString()


  if (__webpack_require__(7)(function () {
    return $toString.call({
      source: 'a',
      flags: 'b'
    }) != '/a/b';
  })) {
    define(function toString() {
      var R = anObject(this);
      return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
    }); // FF44- RegExp#toString has a wrong name
  } else if ($toString.name != TO_STRING) {
    define(function toString() {
      return $toString.call(this);
    });
  }
  /***/

},
/* 306 */

/***/
function (module, exports, __webpack_require__) {
  // @@match logic
  __webpack_require__(77)('match', 1, function (defined, MATCH, $match) {
    // 21.1.3.11 String.prototype.match(regexp)
    return [function match(regexp) {
      'use strict';

      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    }, $match];
  });
  /***/

},
/* 307 */

/***/
function (module, exports, __webpack_require__) {
  // @@replace logic
  __webpack_require__(77)('replace', 2, function (defined, REPLACE, $replace) {
    // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
    return [function replace(searchValue, replaceValue) {
      'use strict';

      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
    }, $replace];
  });
  /***/

},
/* 308 */

/***/
function (module, exports, __webpack_require__) {
  // @@search logic
  __webpack_require__(77)('search', 1, function (defined, SEARCH, $search) {
    // 21.1.3.15 String.prototype.search(regexp)
    return [function search(regexp) {
      'use strict';

      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    }, $search];
  });
  /***/

},
/* 309 */

/***/
function (module, exports, __webpack_require__) {
  // @@split logic
  __webpack_require__(77)('split', 2, function (defined, SPLIT, $split) {
    'use strict';

    var isRegExp = __webpack_require__(74);

    var _split = $split;
    var $push = [].push;
    var $SPLIT = 'split';
    var LENGTH = 'length';
    var LAST_INDEX = 'lastIndex';

    if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
      var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
      // based on es5-shim implementation, need to rework it

      $split = function $split(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

        if (!isRegExp(separator)) return _split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? 4294967295 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var separator2, match, lastIndex, lastLength, i; // Doesn't need flags gy, but they don't hurt

        if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);

        while (match = separatorCopy.exec(string)) {
          // `separatorCopy.lastIndex` is not reliable cross-browser
          lastIndex = match.index + match[0][LENGTH];

          if (lastIndex > lastLastIndex) {
            output.push(string.slice(lastLastIndex, match.index)); // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
            // eslint-disable-next-line no-loop-func

            if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
              for (i = 1; i < arguments[LENGTH] - 2; i++) {
                if (arguments[i] === undefined) match[i] = undefined;
              }
            });
            if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
            lastLength = match[0][LENGTH];
            lastLastIndex = lastIndex;
            if (output[LENGTH] >= splitLimit) break;
          }

          if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
        }

        if (lastLastIndex === string[LENGTH]) {
          if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));

        return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
      }; // Chakra, V8

    } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
      $split = function $split(separator, limit) {
        return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
      };
    } // 21.1.3.17 String.prototype.split(separator, limit)


    return [function split(separator, limit) {
      var O = defined(this);
      var fn = separator == undefined ? undefined : separator[SPLIT];
      return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
    }, $split];
  });
  /***/

},
/* 310 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(41);

  var global = __webpack_require__(6);

  var ctx = __webpack_require__(27);

  var classof = __webpack_require__(64);

  var $export = __webpack_require__(0);

  var isObject = __webpack_require__(8);

  var aFunction = __webpack_require__(16);

  var anInstance = __webpack_require__(50);

  var forOf = __webpack_require__(51);

  var speciesConstructor = __webpack_require__(78);

  var task = __webpack_require__(114).set;

  var microtask = __webpack_require__(115)();

  var newPromiseCapabilityModule = __webpack_require__(116);

  var perform = __webpack_require__(149);

  var userAgent = __webpack_require__(79);

  var promiseResolve = __webpack_require__(150);

  var PROMISE = 'Promise';
  var TypeError = global.TypeError;
  var process = global.process;
  var versions = process && process.versions;
  var v8 = versions && versions.v8 || '';
  var $Promise = global[PROMISE];
  var isNode = classof(process) == 'process';

  var empty = function empty() {
    /* empty */
  };

  var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
  var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
  var USE_NATIVE = !!function () {
    try {
      // correct subclassing with @@species support
      var promise = $Promise.resolve(1);

      var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
        exec(empty, empty);
      }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


      return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
    } catch (e) {
      /* empty */
    }
  }(); // helpers

  var isThenable = function isThenable(it) {
    var then;
    return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };

  var notify = function notify(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
      var value = promise._v;
      var ok = promise._s == 1;
      var i = 0;

      var run = function run(reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;

        try {
          if (handler) {
            if (!ok) {
              if (promise._h == 2) onHandleUnhandled(promise);
              promise._h = 1;
            }

            if (handler === true) result = value;else {
              if (domain) domain.enter();
              result = handler(value); // may throw

              if (domain) {
                domain.exit();
                exited = true;
              }
            }

            if (result === reaction.promise) {
              reject(TypeError('Promise-chain cycle'));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (e) {
          if (domain && !exited) domain.exit();
          reject(e);
        }
      };

      while (chain.length > i) {
        run(chain[i++]);
      } // variable length - can't use forEach


      promise._c = [];
      promise._n = false;
      if (isReject && !promise._h) onUnhandled(promise);
    });
  };

  var onUnhandled = function onUnhandled(promise) {
    task.call(global, function () {
      var value = promise._v;
      var unhandled = isUnhandled(promise);
      var result, handler, console;

      if (unhandled) {
        result = perform(function () {
          if (isNode) {
            process.emit('unhandledRejection', value, promise);
          } else if (handler = global.onunhandledrejection) {
            handler({
              promise: promise,
              reason: value
            });
          } else if ((console = global.console) && console.error) {
            console.error('Unhandled promise rejection', value);
          }
        }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

        promise._h = isNode || isUnhandled(promise) ? 2 : 1;
      }

      promise._a = undefined;
      if (unhandled && result.e) throw result.v;
    });
  };

  var isUnhandled = function isUnhandled(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
  };

  var onHandleUnhandled = function onHandleUnhandled(promise) {
    task.call(global, function () {
      var handler;

      if (isNode) {
        process.emit('rejectionHandled', promise);
      } else if (handler = global.onrejectionhandled) {
        handler({
          promise: promise,
          reason: promise._v
        });
      }
    });
  };

  var $reject = function $reject(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap

    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    notify(promise, true);
  };

  var $resolve = function $resolve(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap

    try {
      if (promise === value) throw TypeError("Promise can't be resolved itself");

      if (then = isThenable(value)) {
        microtask(function () {
          var wrapper = {
            _w: promise,
            _d: false
          }; // wrap

          try {
            then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
          } catch (e) {
            $reject.call(wrapper, e);
          }
        });
      } else {
        promise._v = value;
        promise._s = 1;
        notify(promise, false);
      }
    } catch (e) {
      $reject.call({
        _w: promise,
        _d: false
      }, e); // wrap
    }
  }; // constructor polyfill


  if (!USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $Promise = function Promise(executor) {
      anInstance(this, $Promise, PROMISE, '_h');
      aFunction(executor);
      Internal.call(this);

      try {
        executor(ctx($resolve, this, 1), ctx($reject, this, 1));
      } catch (err) {
        $reject.call(this, err);
      }
    }; // eslint-disable-next-line no-unused-vars


    Internal = function Promise(executor) {
      this._c = []; // <- awaiting reactions

      this._a = undefined; // <- checked in isUnhandled reactions

      this._s = 0; // <- state

      this._d = false; // <- done

      this._v = undefined; // <- value

      this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

      this._n = false; // <- notify
    };

    Internal.prototype = __webpack_require__(52)($Promise.prototype, {
      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
      then: function then(onFulfilled, onRejected) {
        var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        reaction.domain = isNode ? process.domain : undefined;

        this._c.push(reaction);

        if (this._a) this._a.push(reaction);
        if (this._s) notify(this, false);
        return reaction.promise;
      },
      // 25.4.5.1 Promise.prototype.catch(onRejected)
      'catch': function _catch(onRejected) {
        return this.then(undefined, onRejected);
      }
    });

    OwnPromiseCapability = function OwnPromiseCapability() {
      var promise = new Internal();
      this.promise = promise;
      this.resolve = ctx($resolve, promise, 1);
      this.reject = ctx($reject, promise, 1);
    };

    newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
      return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Promise: $Promise
  });

  __webpack_require__(57)($Promise, PROMISE);

  __webpack_require__(49)(PROMISE);

  Wrapper = __webpack_require__(26)[PROMISE]; // statics

  $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      var $$reject = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
      return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
    }
  });
  $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(75)(function (iter) {
    $Promise.all(iter)['catch'](empty);
  })), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var values = [];
        var index = 0;
        var remaining = 1;
        forOf(iterable, false, function (promise) {
          var $index = index++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[$index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.e) reject(result.v);
      return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = perform(function () {
        forOf(iterable, false, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.e) reject(result.v);
      return capability.promise;
    }
  });
  /***/
},
/* 311 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var weak = __webpack_require__(155);

  var validate = __webpack_require__(60);

  var WEAK_SET = 'WeakSet'; // 23.4 WeakSet Objects

  __webpack_require__(80)(WEAK_SET, function (get) {
    return function WeakSet() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
      return weak.def(validate(this, WEAK_SET), value, true);
    }
  }, weak, false, true);
  /***/

},
/* 312 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var $typed = __webpack_require__(81);

  var buffer = __webpack_require__(117);

  var anObject = __webpack_require__(5);

  var toAbsoluteIndex = __webpack_require__(46);

  var toLength = __webpack_require__(13);

  var isObject = __webpack_require__(8);

  var ArrayBuffer = __webpack_require__(6).ArrayBuffer;

  var speciesConstructor = __webpack_require__(78);

  var $ArrayBuffer = buffer.ArrayBuffer;
  var $DataView = buffer.DataView;
  var $isView = $typed.ABV && ArrayBuffer.isView;
  var $slice = $ArrayBuffer.prototype.slice;
  var VIEW = $typed.VIEW;
  var ARRAY_BUFFER = 'ArrayBuffer';
  $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {
    ArrayBuffer: $ArrayBuffer
  });
  $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
      return $isView && $isView(it) || isObject(it) && VIEW in it;
    }
  });
  $export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
    return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
  }), ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
      if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix

      var len = anObject(this).byteLength;
      var first = toAbsoluteIndex(start, len);
      var fin = toAbsoluteIndex(end === undefined ? len : end, len);
      var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
      var viewS = new $DataView(this);
      var viewT = new $DataView(result);
      var index = 0;

      while (first < fin) {
        viewT.setUint8(index++, viewS.getUint8(first++));
      }

      return result;
    }
  });

  __webpack_require__(49)(ARRAY_BUFFER);
  /***/

},
/* 313 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  $export($export.G + $export.W + $export.F * !__webpack_require__(81).ABV, {
    DataView: __webpack_require__(117).DataView
  });
  /***/
},
/* 314 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Int8', 1, function (init) {
    return function Int8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 315 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Uint8', 1, function (init) {
    return function Uint8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 316 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Uint8', 1, function (init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  }, true);
  /***/

},
/* 317 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Int16', 2, function (init) {
    return function Int16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 318 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Uint16', 2, function (init) {
    return function Uint16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 319 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Int32', 4, function (init) {
    return function Int32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 320 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Uint32', 4, function (init) {
    return function Uint32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 321 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Float32', 4, function (init) {
    return function Float32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 322 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(38)('Float64', 8, function (init) {
    return function Float64Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/

},
/* 323 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
  var $export = __webpack_require__(0);

  var aFunction = __webpack_require__(16);

  var anObject = __webpack_require__(5);

  var rApply = (__webpack_require__(6).Reflect || {}).apply;
  var fApply = Function.apply; // MS Edge argumentsList argument is optional

  $export($export.S + $export.F * !__webpack_require__(7)(function () {
    rApply(function () {
      /* empty */
    });
  }), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
      var T = aFunction(target);
      var L = anObject(argumentsList);
      return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
    }
  });
  /***/
},
/* 324 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
  var $export = __webpack_require__(0);

  var create = __webpack_require__(47);

  var aFunction = __webpack_require__(16);

  var anObject = __webpack_require__(5);

  var isObject = __webpack_require__(8);

  var fails = __webpack_require__(7);

  var bind = __webpack_require__(136);

  var rConstruct = (__webpack_require__(6).Reflect || {}).construct; // MS Edge supports only 2 arguments and argumentsList argument is optional
  // FF Nightly sets third argument as `new.target`, but does not create `this` from it

  var NEW_TARGET_BUG = fails(function () {
    function F() {
      /* empty */
    }

    return !(rConstruct(function () {
      /* empty */
    }, [], F) instanceof F);
  });
  var ARGS_BUG = !fails(function () {
    rConstruct(function () {
      /* empty */
    });
  });
  $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args
    /* , newTarget */
    ) {
      aFunction(Target);
      anObject(args);
      var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
      if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);

      if (Target == newTarget) {
        // w/o altered newTarget, optimization for 0-4 arguments
        switch (args.length) {
          case 0:
            return new Target();

          case 1:
            return new Target(args[0]);

          case 2:
            return new Target(args[0], args[1]);

          case 3:
            return new Target(args[0], args[1], args[2]);

          case 4:
            return new Target(args[0], args[1], args[2], args[3]);
        } // w/o altered newTarget, lot of arguments case


        var $args = [null];
        $args.push.apply($args, args);
        return new (bind.apply(Target, $args))();
      } // with altered newTarget, not support built-in constructors


      var proto = newTarget.prototype;
      var instance = create(isObject(proto) ? proto : Object.prototype);
      var result = Function.apply.call(Target, instance, args);
      return isObject(result) ? result : instance;
    }
  });
  /***/
},
/* 325 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
  var dP = __webpack_require__(12);

  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(5);

  var toPrimitive = __webpack_require__(32); // MS Edge has broken Reflect.defineProperty - throwing instead of returning false


  $export($export.S + $export.F * __webpack_require__(7)(function () {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty(dP.f({}, 1, {
      value: 1
    }), 1, {
      value: 2
    });
  }), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
      anObject(target);
      propertyKey = toPrimitive(propertyKey, true);
      anObject(attributes);

      try {
        dP.f(target, propertyKey, attributes);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  /***/
},
/* 326 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.4 Reflect.deleteProperty(target, propertyKey)
  var $export = __webpack_require__(0);

  var gOPD = __webpack_require__(23).f;

  var anObject = __webpack_require__(5);

  $export($export.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
      var desc = gOPD(anObject(target), propertyKey);
      return desc && !desc.configurable ? false : delete target[propertyKey];
    }
  });
  /***/
},
/* 327 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 26.1.5 Reflect.enumerate(target)

  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(5);

  var Enumerate = function Enumerate(iterated) {
    this._t = anObject(iterated); // target

    this._i = 0; // next index

    var keys = this._k = []; // keys

    var key;

    for (key in iterated) {
      keys.push(key);
    }
  };

  __webpack_require__(105)(Enumerate, 'Object', function () {
    var that = this;
    var keys = that._k;
    var key;

    do {
      if (that._i >= keys.length) return {
        value: undefined,
        done: true
      };
    } while (!((key = keys[that._i++]) in that._t));

    return {
      value: key,
      done: false
    };
  });

  $export($export.S, 'Reflect', {
    enumerate: function enumerate(target) {
      return new Enumerate(target);
    }
  });
  /***/
},
/* 328 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.6 Reflect.get(target, propertyKey [, receiver])
  var gOPD = __webpack_require__(23);

  var getPrototypeOf = __webpack_require__(24);

  var has = __webpack_require__(21);

  var $export = __webpack_require__(0);

  var isObject = __webpack_require__(8);

  var anObject = __webpack_require__(5);

  function get(target, propertyKey
  /* , receiver */
  ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if (anObject(target) === receiver) return target[propertyKey];
    if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
  }

  $export($export.S, 'Reflect', {
    get: get
  });
  /***/
},
/* 329 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
  var gOPD = __webpack_require__(23);

  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(5);

  $export($export.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
      return gOPD.f(anObject(target), propertyKey);
    }
  });
  /***/
},
/* 330 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.8 Reflect.getPrototypeOf(target)
  var $export = __webpack_require__(0);

  var getProto = __webpack_require__(24);

  var anObject = __webpack_require__(5);

  $export($export.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
      return getProto(anObject(target));
    }
  });
  /***/
},
/* 331 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.9 Reflect.has(target, propertyKey)
  var $export = __webpack_require__(0);

  $export($export.S, 'Reflect', {
    has: function has(target, propertyKey) {
      return propertyKey in target;
    }
  });
  /***/
},
/* 332 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.10 Reflect.isExtensible(target)
  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(5);

  var $isExtensible = Object.isExtensible;
  $export($export.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
      anObject(target);
      return $isExtensible ? $isExtensible(target) : true;
    }
  });
  /***/
},
/* 333 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.11 Reflect.ownKeys(target)
  var $export = __webpack_require__(0);

  $export($export.S, 'Reflect', {
    ownKeys: __webpack_require__(157)
  });
  /***/
},
/* 334 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.12 Reflect.preventExtensions(target)
  var $export = __webpack_require__(0);

  var anObject = __webpack_require__(5);

  var $preventExtensions = Object.preventExtensions;
  $export($export.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
      anObject(target);

      try {
        if ($preventExtensions) $preventExtensions(target);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  /***/
},
/* 335 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
  var dP = __webpack_require__(12);

  var gOPD = __webpack_require__(23);

  var getPrototypeOf = __webpack_require__(24);

  var has = __webpack_require__(21);

  var $export = __webpack_require__(0);

  var createDesc = __webpack_require__(43);

  var anObject = __webpack_require__(5);

  var isObject = __webpack_require__(8);

  function set(target, propertyKey, V
  /* , receiver */
  ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = gOPD.f(anObject(target), propertyKey);
    var existingDescriptor, proto;

    if (!ownDesc) {
      if (isObject(proto = getPrototypeOf(target))) {
        return set(proto, propertyKey, V, receiver);
      }

      ownDesc = createDesc(0);
    }

    if (has(ownDesc, 'value')) {
      if (ownDesc.writable === false || !isObject(receiver)) return false;

      if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
        if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
        existingDescriptor.value = V;
        dP.f(receiver, propertyKey, existingDescriptor);
      } else dP.f(receiver, propertyKey, createDesc(0, V));

      return true;
    }

    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
  }

  $export($export.S, 'Reflect', {
    set: set
  });
  /***/
},
/* 336 */

/***/
function (module, exports, __webpack_require__) {
  // 26.1.14 Reflect.setPrototypeOf(target, proto)
  var $export = __webpack_require__(0);

  var setProto = __webpack_require__(97);

  if (setProto) $export($export.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
      setProto.check(target, proto);

      try {
        setProto.set(target, proto);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  /***/
},
/* 337 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/Array.prototype.includes

  var $export = __webpack_require__(0);

  var $includes = __webpack_require__(71)(true);

  $export($export.P, 'Array', {
    includes: function includes(el
    /* , fromIndex = 0 */
    ) {
      return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  __webpack_require__(42)('includes');
  /***/

},
/* 338 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap

  var $export = __webpack_require__(0);

  var flattenIntoArray = __webpack_require__(158);

  var toObject = __webpack_require__(14);

  var toLength = __webpack_require__(13);

  var aFunction = __webpack_require__(16);

  var arraySpeciesCreate = __webpack_require__(111);

  $export($export.P, 'Array', {
    flatMap: function flatMap(callbackfn
    /* , thisArg */
    ) {
      var O = toObject(this);
      var sourceLen, A;
      aFunction(callbackfn);
      sourceLen = toLength(O.length);
      A = arraySpeciesCreate(O, 0);
      flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
      return A;
    }
  });

  __webpack_require__(42)('flatMap');
  /***/

},
/* 339 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten

  var $export = __webpack_require__(0);

  var flattenIntoArray = __webpack_require__(158);

  var toObject = __webpack_require__(14);

  var toLength = __webpack_require__(13);

  var toInteger = __webpack_require__(34);

  var arraySpeciesCreate = __webpack_require__(111);

  $export($export.P, 'Array', {
    flatten: function flatten()
    /* depthArg = 1 */
    {
      var depthArg = arguments[0];
      var O = toObject(this);
      var sourceLen = toLength(O.length);
      var A = arraySpeciesCreate(O, 0);
      flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
      return A;
    }
  });

  __webpack_require__(42)('flatten');
  /***/

},
/* 340 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/mathiasbynens/String.prototype.at

  var $export = __webpack_require__(0);

  var $at = __webpack_require__(103)(true);

  $export($export.P, 'String', {
    at: function at(pos) {
      return $at(this, pos);
    }
  });
  /***/
},
/* 341 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-string-pad-start-end

  var $export = __webpack_require__(0);

  var $pad = __webpack_require__(159);

  var userAgent = __webpack_require__(79); // https://github.com/zloirock/core-js/issues/280


  $export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
    padStart: function padStart(maxLength
    /* , fillString = ' ' */
    ) {
      return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
  });
  /***/
},
/* 342 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-string-pad-start-end

  var $export = __webpack_require__(0);

  var $pad = __webpack_require__(159);

  var userAgent = __webpack_require__(79); // https://github.com/zloirock/core-js/issues/280


  $export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
    padEnd: function padEnd(maxLength
    /* , fillString = ' ' */
    ) {
      return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
  });
  /***/
},
/* 343 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/sebmarkbage/ecmascript-string-left-right-trim

  __webpack_require__(58)('trimLeft', function ($trim) {
    return function trimLeft() {
      return $trim(this, 1);
    };
  }, 'trimStart');
  /***/

},
/* 344 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/sebmarkbage/ecmascript-string-left-right-trim

  __webpack_require__(58)('trimRight', function ($trim) {
    return function trimRight() {
      return $trim(this, 2);
    };
  }, 'trimEnd');
  /***/

},
/* 345 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://tc39.github.io/String.prototype.matchAll/

  var $export = __webpack_require__(0);

  var defined = __webpack_require__(33);

  var toLength = __webpack_require__(13);

  var isRegExp = __webpack_require__(74);

  var getFlags = __webpack_require__(76);

  var RegExpProto = RegExp.prototype;

  var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
    this._r = regexp;
    this._s = string;
  };

  __webpack_require__(105)($RegExpStringIterator, 'RegExp String', function next() {
    var match = this._r.exec(this._s);

    return {
      value: match,
      done: match === null
    };
  });

  $export($export.P, 'String', {
    matchAll: function matchAll(regexp) {
      defined(this);
      if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
      var S = String(this);
      var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
      var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
      rx.lastIndex = toLength(regexp.lastIndex);
      return new $RegExpStringIterator(rx, S);
    }
  });
  /***/
},
/* 346 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(93)('asyncIterator');
  /***/

},
/* 347 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(93)('observable');
  /***/

},
/* 348 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-object-getownpropertydescriptors
  var $export = __webpack_require__(0);

  var ownKeys = __webpack_require__(157);

  var toIObject = __webpack_require__(22);

  var gOPD = __webpack_require__(23);

  var createProperty = __webpack_require__(109);

  $export($export.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
      var O = toIObject(object);
      var getDesc = gOPD.f;
      var keys = ownKeys(O);
      var result = {};
      var i = 0;
      var key, desc;

      while (keys.length > i) {
        desc = getDesc(O, key = keys[i++]);
        if (desc !== undefined) createProperty(result, key, desc);
      }

      return result;
    }
  });
  /***/
},
/* 349 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-object-values-entries
  var $export = __webpack_require__(0);

  var $values = __webpack_require__(160)(false);

  $export($export.S, 'Object', {
    values: function values(it) {
      return $values(it);
    }
  });
  /***/
},
/* 350 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-object-values-entries
  var $export = __webpack_require__(0);

  var $entries = __webpack_require__(160)(true);

  $export($export.S, 'Object', {
    entries: function entries(it) {
      return $entries(it);
    }
  });
  /***/
},
/* 351 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(14);

  var aFunction = __webpack_require__(16);

  var $defineProperty = __webpack_require__(12); // B.2.2.2 Object.prototype.__defineGetter__(P, getter)


  __webpack_require__(11) && $export($export.P + __webpack_require__(82), 'Object', {
    __defineGetter__: function __defineGetter__(P, getter) {
      $defineProperty.f(toObject(this), P, {
        get: aFunction(getter),
        enumerable: true,
        configurable: true
      });
    }
  });
  /***/
},
/* 352 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(14);

  var aFunction = __webpack_require__(16);

  var $defineProperty = __webpack_require__(12); // B.2.2.3 Object.prototype.__defineSetter__(P, setter)


  __webpack_require__(11) && $export($export.P + __webpack_require__(82), 'Object', {
    __defineSetter__: function __defineSetter__(P, setter) {
      $defineProperty.f(toObject(this), P, {
        set: aFunction(setter),
        enumerable: true,
        configurable: true
      });
    }
  });
  /***/
},
/* 353 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(14);

  var toPrimitive = __webpack_require__(32);

  var getPrototypeOf = __webpack_require__(24);

  var getOwnPropertyDescriptor = __webpack_require__(23).f; // B.2.2.4 Object.prototype.__lookupGetter__(P)


  __webpack_require__(11) && $export($export.P + __webpack_require__(82), 'Object', {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject(this);
      var K = toPrimitive(P, true);
      var D;

      do {
        if (D = getOwnPropertyDescriptor(O, K)) return D.get;
      } while (O = getPrototypeOf(O));
    }
  });
  /***/
},
/* 354 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(0);

  var toObject = __webpack_require__(14);

  var toPrimitive = __webpack_require__(32);

  var getPrototypeOf = __webpack_require__(24);

  var getOwnPropertyDescriptor = __webpack_require__(23).f; // B.2.2.5 Object.prototype.__lookupSetter__(P)


  __webpack_require__(11) && $export($export.P + __webpack_require__(82), 'Object', {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var K = toPrimitive(P, true);
      var D;

      do {
        if (D = getOwnPropertyDescriptor(O, K)) return D.set;
      } while (O = getPrototypeOf(O));
    }
  });
  /***/
},
/* 355 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var $export = __webpack_require__(0);

  $export($export.P + $export.R, 'Map', {
    toJSON: __webpack_require__(161)('Map')
  });
  /***/
},
/* 356 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/DavidBruant/Map-Set.prototype.toJSON
  var $export = __webpack_require__(0);

  $export($export.P + $export.R, 'Set', {
    toJSON: __webpack_require__(161)('Set')
  });
  /***/
},
/* 357 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
  __webpack_require__(83)('Map');
  /***/

},
/* 358 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
  __webpack_require__(83)('Set');
  /***/

},
/* 359 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
  __webpack_require__(83)('WeakMap');
  /***/

},
/* 360 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
  __webpack_require__(83)('WeakSet');
  /***/

},
/* 361 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
  __webpack_require__(84)('Map');
  /***/

},
/* 362 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
  __webpack_require__(84)('Set');
  /***/

},
/* 363 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
  __webpack_require__(84)('WeakMap');
  /***/

},
/* 364 */

/***/
function (module, exports, __webpack_require__) {
  // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
  __webpack_require__(84)('WeakSet');
  /***/

},
/* 365 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-global
  var $export = __webpack_require__(0);

  $export($export.G, {
    global: __webpack_require__(6)
  });
  /***/
},
/* 366 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-global
  var $export = __webpack_require__(0);

  $export($export.S, 'System', {
    global: __webpack_require__(6)
  });
  /***/
},
/* 367 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/ljharb/proposal-is-error
  var $export = __webpack_require__(0);

  var cof = __webpack_require__(28);

  $export($export.S, 'Error', {
    isError: function isError(it) {
      return cof(it) === 'Error';
    }
  });
  /***/
},
/* 368 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    clamp: function clamp(x, lower, upper) {
      return Math.min(upper, Math.max(lower, x));
    }
  });
  /***/
},
/* 369 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    DEG_PER_RAD: Math.PI / 180
  });
  /***/
},
/* 370 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  var RAD_PER_DEG = 180 / Math.PI;
  $export($export.S, 'Math', {
    degrees: function degrees(radians) {
      return radians * RAD_PER_DEG;
    }
  });
  /***/
},
/* 371 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  var scale = __webpack_require__(163);

  var fround = __webpack_require__(143);

  $export($export.S, 'Math', {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
      return fround(scale(x, inLow, inHigh, outLow, outHigh));
    }
  });
  /***/
},
/* 372 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    iaddh: function iaddh(x0, x1, y0, y1) {
      var $x0 = x0 >>> 0;
      var $x1 = x1 >>> 0;
      var $y0 = y0 >>> 0;
      return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
  });
  /***/
},
/* 373 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    isubh: function isubh(x0, x1, y0, y1) {
      var $x0 = x0 >>> 0;
      var $x1 = x1 >>> 0;
      var $y0 = y0 >>> 0;
      return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
  });
  /***/
},
/* 374 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    imulh: function imulh(u, v) {
      var UINT16 = 0xffff;
      var $u = +u;
      var $v = +v;
      var u0 = $u & UINT16;
      var v0 = $v & UINT16;
      var u1 = $u >> 16;
      var v1 = $v >> 16;
      var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
      return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
  });
  /***/
},
/* 375 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    RAD_PER_DEG: 180 / Math.PI
  });
  /***/
},
/* 376 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  var DEG_PER_RAD = Math.PI / 180;
  $export($export.S, 'Math', {
    radians: function radians(degrees) {
      return degrees * DEG_PER_RAD;
    }
  });
  /***/
},
/* 377 */

/***/
function (module, exports, __webpack_require__) {
  // https://rwaldron.github.io/proposal-math-extensions/
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    scale: __webpack_require__(163)
  });
  /***/
},
/* 378 */

/***/
function (module, exports, __webpack_require__) {
  // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    umulh: function umulh(u, v) {
      var UINT16 = 0xffff;
      var $u = +u;
      var $v = +v;
      var u0 = $u & UINT16;
      var v0 = $v & UINT16;
      var u1 = $u >>> 16;
      var v1 = $v >>> 16;
      var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
      return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
  });
  /***/
},
/* 379 */

/***/
function (module, exports, __webpack_require__) {
  // http://jfbastien.github.io/papers/Math.signbit.html
  var $export = __webpack_require__(0);

  $export($export.S, 'Math', {
    signbit: function signbit(x) {
      // eslint-disable-next-line no-self-compare
      return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
    }
  });
  /***/
},
/* 380 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-promise-finally

  var $export = __webpack_require__(0);

  var core = __webpack_require__(26);

  var global = __webpack_require__(6);

  var speciesConstructor = __webpack_require__(78);

  var promiseResolve = __webpack_require__(150);

  $export($export.P + $export.R, 'Promise', {
    'finally': function _finally(onFinally) {
      var C = speciesConstructor(this, core.Promise || global.Promise);
      var isFunction = typeof onFinally == 'function';
      return this.then(isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () {
          return x;
        });
      } : onFinally, isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () {
          throw e;
        });
      } : onFinally);
    }
  });
  /***/
},
/* 381 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-promise-try

  var $export = __webpack_require__(0);

  var newPromiseCapability = __webpack_require__(116);

  var perform = __webpack_require__(149);

  $export($export.S, 'Promise', {
    'try': function _try(callbackfn) {
      var promiseCapability = newPromiseCapability.f(this);
      var result = perform(callbackfn);
      (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
      return promiseCapability.promise;
    }
  });
  /***/
},
/* 382 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var toMetaKey = metadata.key;
  var ordinaryDefineOwnMetadata = metadata.set;
  metadata.exp({
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
      ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
    }
  });
  /***/
},
/* 383 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var toMetaKey = metadata.key;
  var getOrCreateMetadataMap = metadata.map;
  var store = metadata.store;
  metadata.exp({
    deleteMetadata: function deleteMetadata(metadataKey, target
    /* , targetKey */
    ) {
      var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
      var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
      if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
      if (metadataMap.size) return true;
      var targetMetadata = store.get(target);
      targetMetadata['delete'](targetKey);
      return !!targetMetadata.size || store['delete'](target);
    }
  });
  /***/
},
/* 384 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var getPrototypeOf = __webpack_require__(24);

  var ordinaryHasOwnMetadata = metadata.has;
  var ordinaryGetOwnMetadata = metadata.get;
  var toMetaKey = metadata.key;

  var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
    var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = getPrototypeOf(O);
    return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
  };

  metadata.exp({
    getMetadata: function getMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 385 */

/***/
function (module, exports, __webpack_require__) {
  var Set = __webpack_require__(153);

  var from = __webpack_require__(162);

  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var getPrototypeOf = __webpack_require__(24);

  var ordinaryOwnMetadataKeys = metadata.keys;
  var toMetaKey = metadata.key;

  var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
    var oKeys = ordinaryOwnMetadataKeys(O, P);
    var parent = getPrototypeOf(O);
    if (parent === null) return oKeys;
    var pKeys = ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
  };

  metadata.exp({
    getMetadataKeys: function getMetadataKeys(target
    /* , targetKey */
    ) {
      return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
    }
  });
  /***/
},
/* 386 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var ordinaryGetOwnMetadata = metadata.get;
  var toMetaKey = metadata.key;
  metadata.exp({
    getOwnMetadata: function getOwnMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 387 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var ordinaryOwnMetadataKeys = metadata.keys;
  var toMetaKey = metadata.key;
  metadata.exp({
    getOwnMetadataKeys: function getOwnMetadataKeys(target
    /* , targetKey */
    ) {
      return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
    }
  });
  /***/
},
/* 388 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var getPrototypeOf = __webpack_require__(24);

  var ordinaryHasOwnMetadata = metadata.has;
  var toMetaKey = metadata.key;

  var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
    var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = getPrototypeOf(O);
    return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
  };

  metadata.exp({
    hasMetadata: function hasMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 389 */

/***/
function (module, exports, __webpack_require__) {
  var metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var ordinaryHasOwnMetadata = metadata.has;
  var toMetaKey = metadata.key;
  metadata.exp({
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target
    /* , targetKey */
    ) {
      return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
    }
  });
  /***/
},
/* 390 */

/***/
function (module, exports, __webpack_require__) {
  var $metadata = __webpack_require__(39);

  var anObject = __webpack_require__(5);

  var aFunction = __webpack_require__(16);

  var toMetaKey = $metadata.key;
  var ordinaryDefineOwnMetadata = $metadata.set;
  $metadata.exp({
    metadata: function metadata(metadataKey, metadataValue) {
      return function decorator(target, targetKey) {
        ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
      };
    }
  });
  /***/
},
/* 391 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
  var $export = __webpack_require__(0);

  var microtask = __webpack_require__(115)();

  var process = __webpack_require__(6).process;

  var isNode = __webpack_require__(28)(process) == 'process';
  $export($export.G, {
    asap: function asap(fn) {
      var domain = isNode && process.domain;
      microtask(domain ? domain.bind(fn) : fn);
    }
  });
  /***/
},
/* 392 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/zenparsing/es-observable

  var $export = __webpack_require__(0);

  var global = __webpack_require__(6);

  var core = __webpack_require__(26);

  var microtask = __webpack_require__(115)();

  var OBSERVABLE = __webpack_require__(9)('observable');

  var aFunction = __webpack_require__(16);

  var anObject = __webpack_require__(5);

  var anInstance = __webpack_require__(50);

  var redefineAll = __webpack_require__(52);

  var hide = __webpack_require__(18);

  var forOf = __webpack_require__(51);

  var RETURN = forOf.RETURN;

  var getMethod = function getMethod(fn) {
    return fn == null ? undefined : aFunction(fn);
  };

  var cleanupSubscription = function cleanupSubscription(subscription) {
    var cleanup = subscription._c;

    if (cleanup) {
      subscription._c = undefined;
      cleanup();
    }
  };

  var subscriptionClosed = function subscriptionClosed(subscription) {
    return subscription._o === undefined;
  };

  var closeSubscription = function closeSubscription(subscription) {
    if (!subscriptionClosed(subscription)) {
      subscription._o = undefined;
      cleanupSubscription(subscription);
    }
  };

  var Subscription = function Subscription(observer, subscriber) {
    anObject(observer);
    this._c = undefined;
    this._o = observer;
    observer = new SubscriptionObserver(this);

    try {
      var cleanup = subscriber(observer);
      var subscription = cleanup;

      if (cleanup != null) {
        if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
          subscription.unsubscribe();
        };else aFunction(cleanup);
        this._c = cleanup;
      }
    } catch (e) {
      observer.error(e);
      return;
    }

    if (subscriptionClosed(this)) cleanupSubscription(this);
  };

  Subscription.prototype = redefineAll({}, {
    unsubscribe: function unsubscribe() {
      closeSubscription(this);
    }
  });

  var SubscriptionObserver = function SubscriptionObserver(subscription) {
    this._s = subscription;
  };

  SubscriptionObserver.prototype = redefineAll({}, {
    next: function next(value) {
      var subscription = this._s;

      if (!subscriptionClosed(subscription)) {
        var observer = subscription._o;

        try {
          var m = getMethod(observer.next);
          if (m) return m.call(observer, value);
        } catch (e) {
          try {
            closeSubscription(subscription);
          } finally {
            throw e;
          }
        }
      }
    },
    error: function error(value) {
      var subscription = this._s;
      if (subscriptionClosed(subscription)) throw value;
      var observer = subscription._o;
      subscription._o = undefined;

      try {
        var m = getMethod(observer.error);
        if (!m) throw value;
        value = m.call(observer, value);
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      }

      cleanupSubscription(subscription);
      return value;
    },
    complete: function complete(value) {
      var subscription = this._s;

      if (!subscriptionClosed(subscription)) {
        var observer = subscription._o;
        subscription._o = undefined;

        try {
          var m = getMethod(observer.complete);
          value = m ? m.call(observer, value) : undefined;
        } catch (e) {
          try {
            cleanupSubscription(subscription);
          } finally {
            throw e;
          }
        }

        cleanupSubscription(subscription);
        return value;
      }
    }
  });

  var $Observable = function Observable(subscriber) {
    anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
  };

  redefineAll($Observable.prototype, {
    subscribe: function subscribe(observer) {
      return new Subscription(observer, this._f);
    },
    forEach: function forEach(fn) {
      var that = this;
      return new (core.Promise || global.Promise)(function (resolve, reject) {
        aFunction(fn);
        var subscription = that.subscribe({
          next: function next(value) {
            try {
              return fn(value);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  });
  redefineAll($Observable, {
    from: function from(x) {
      var C = typeof this === 'function' ? this : $Observable;
      var method = getMethod(anObject(x)[OBSERVABLE]);

      if (method) {
        var observable = anObject(method.call(x));
        return observable.constructor === C ? observable : new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      return new C(function (observer) {
        var done = false;
        microtask(function () {
          if (!done) {
            try {
              if (forOf(x, false, function (it) {
                observer.next(it);
                if (done) return RETURN;
              }) === RETURN) return;
            } catch (e) {
              if (done) throw e;
              observer.error(e);
              return;
            }

            observer.complete();
          }
        });
        return function () {
          done = true;
        };
      });
    },
    of: function of() {
      for (var i = 0, l = arguments.length, items = new Array(l); i < l;) {
        items[i] = arguments[i++];
      }

      return new (typeof this === 'function' ? this : $Observable)(function (observer) {
        var done = false;
        microtask(function () {
          if (!done) {
            for (var j = 0; j < items.length; ++j) {
              observer.next(items[j]);
              if (done) return;
            }

            observer.complete();
          }
        });
        return function () {
          done = true;
        };
      });
    }
  });
  hide($Observable.prototype, OBSERVABLE, function () {
    return this;
  });
  $export($export.G, {
    Observable: $Observable
  });

  __webpack_require__(49)('Observable');
  /***/

},
/* 393 */

/***/
function (module, exports, __webpack_require__) {
  // ie9- setTimeout & setInterval additional parameters fix
  var global = __webpack_require__(6);

  var $export = __webpack_require__(0);

  var userAgent = __webpack_require__(79);

  var slice = [].slice;
  var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

  var wrap = function wrap(set) {
    return function (fn, time
    /* , ...args */
    ) {
      var boundArgs = arguments.length > 2;
      var args = boundArgs ? slice.call(arguments, 2) : false;
      return set(boundArgs ? function () {
        // eslint-disable-next-line no-new-func
        (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
      } : fn, time);
    };
  };

  $export($export.G + $export.B + $export.F * MSIE, {
    setTimeout: wrap(global.setTimeout),
    setInterval: wrap(global.setInterval)
  });
  /***/
},
/* 394 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(0);

  var $task = __webpack_require__(114);

  $export($export.G + $export.B, {
    setImmediate: $task.set,
    clearImmediate: $task.clear
  });
  /***/
},
/* 395 */

/***/
function (module, exports, __webpack_require__) {
  var $iterators = __webpack_require__(113);

  var getKeys = __webpack_require__(45);

  var redefine = __webpack_require__(19);

  var global = __webpack_require__(6);

  var hide = __webpack_require__(18);

  var Iterators = __webpack_require__(59);

  var wks = __webpack_require__(9);

  var ITERATOR = wks('iterator');
  var TO_STRING_TAG = wks('toStringTag');
  var ArrayValues = Iterators.Array;
  var DOMIterables = {
    CSSRuleList: true,
    // TODO: Not spec compliant, should be false.
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    // TODO: Not spec compliant, should be false.
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    // TODO: Not spec compliant, should be false.
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
  };

  for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
    var NAME = collections[i];
    var explicit = DOMIterables[NAME];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    var key;

    if (proto) {
      if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
      if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
      Iterators[NAME] = ArrayValues;
      if (explicit) for (key in $iterators) {
        if (!proto[key]) redefine(proto, key, $iterators[key], true);
      }
    }
  }
  /***/

},
/* 396 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * Copyright (c) 2014, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
    * additional grant of patent rights can be found in the PATENTS file in
    * the same directory.
    */
    !function (global) {
      "use strict";

      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined; // More compressible than void 0.

      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
      var inModule = typeof module === "object";
      var runtime = global.regeneratorRuntime;

      if (runtime) {
        if (inModule) {
          // If regeneratorRuntime is defined globally and we're in a module,
          // make the exports object identical to regeneratorRuntime.
          module.exports = runtime;
        } // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.


        return;
      } // Define the runtime globally (as expected by generated code) as either
      // module.exports (if we're in a module) or a new, empty object.


      runtime = global.regeneratorRuntime = inModule ? module.exports : {};

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.

        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }

      runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.

      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.

      var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.


      var IteratorPrototype = {};

      IteratorPrototype[iteratorSymbol] = function () {
        return this;
      };

      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.

      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          prototype[method] = function (arg) {
            return this._invoke(method, arg);
          };
        });
      }

      runtime.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      runtime.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;

          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }

        genFun.prototype = Object.create(Gp);
        return genFun;
      }; // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.


      runtime.awrap = function (arg) {
        return {
          __await: arg
        };
      };

      function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);

          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;

            if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
              return Promise.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return Promise.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration. If the Promise is rejected, however, the
              // result for this iteration will be rejected with the same
              // reason. Note that rejections of yielded Promises are not
              // thrown back into the generator function, as is the case
              // when an awaited Promise is rejected. This difference in
              // behavior between yield and await is important, because it
              // allows the consumer to decide what to do with the yielded
              // rejection (swallow it and continue, manually .throw it back
              // into the generator, abandon iteration, whatever). With
              // await, by contrast, there is no opportunity to examine the
              // rejection reason outside the generator function, so the
              // only option is to throw it from the await expression, and
              // let the generator function handle the exception.
              result.value = unwrapped;
              resolve(result);
            }, reject);
          }
        }

        if (typeof global.process === "object" && global.process.domain) {
          invoke = global.process.domain.bind(invoke);
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        } // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).


        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);

      AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
      };

      runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.

      runtime.async = function (innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            } // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;

            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);

              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);

            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted; // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.

              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      } // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.


      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];

        if (method === undefined) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            if (delegate.iterator.return) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

          context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.

          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        } // The delegate iterator is finished, so forget it and continue with
        // the outer generator.


        context.delegate = null;
        return ContinueSentinel;
      } // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.


      defineIteratorMethods(Gp);
      Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.

      Gp[iteratorSymbol] = function () {
        return this;
      };

      Gp.toString = function () {
        return "[object Generator]";
      };

      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{
          tryLoc: "root"
        }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      runtime.keys = function (object) {
        var keys = [];

        for (var key in object) {
          keys.push(key);
        }

        keys.reverse(); // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.

        return function next() {
          while (keys.length) {
            var key = keys.pop();

            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          } // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.


          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];

          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined;
              next.done = true;
              return next;
            };

            return next.next = next;
          }
        } // Return an iterator with no values.


        return {
          next: doneResult
        };
      }

      runtime.values = values;

      function doneResult() {
        return {
          value: undefined,
          done: true
        };
      }

      Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0; // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.

          this.sent = this._sent = undefined;
          this.done = false;
          this.delegate = null;
          this.method = "next";
          this.arg = undefined;
          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },
        stop: function stop() {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;

          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;

          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];

            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;

              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }

              return thrown;
            }
          } // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.


          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
          }

          return ContinueSentinel;
        }
      };
    }( // Among the various tricks for obtaining a reference to the global
    // object, this seems to be the most reliable technique that does not
    // use indirect eval (which violates Content Security Policy).
    typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : this);
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(56));
  /***/
},
/* 397 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(398);

  module.exports = __webpack_require__(26).RegExp.escape;
  /***/
},
/* 398 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/benjamingr/RexExp.escape
  var $export = __webpack_require__(0);

  var $re = __webpack_require__(399)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

  $export($export.S, 'RegExp', {
    escape: function escape(it) {
      return $re(it);
    }
  });
  /***/
},
/* 399 */

/***/
function (module, exports) {
  module.exports = function (regExp, replace) {
    var replacer = replace === Object(replace) ? function (part) {
      return replace[part];
    } : replace;
    return function (it) {
      return String(it).replace(regExp, replacer);
    };
  };
  /***/

},
/* 400 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Loading = exports.LeftSail = exports.SmallFrontSail = exports.ImageTiles = exports.WalkScore = exports.RentingProcess = exports.RentalProcess = exports.SimpleMap = exports.POIMap = exports.QuoteBlock = exports.PropertyManagers = exports.NotFound = exports.Navigation = exports.ImageLinks = exports.PriceBox = exports.LandingPage = exports.HeroVideo = exports.HeroBox = exports.HeroBanner = exports.GraingerBar = exports.GraingerAward = exports.Gallery = exports.FloorPlans = exports.FloatingTextImage = exports.ImageSection = exports.Footer = exports.DigitalWalkthrough = exports.CTATextBanner = exports.CTAText = exports.CtaSection = exports.CookieBar = exports.Commute = exports.BrandProperties = exports.BasicContent = exports.Amenities = exports.Accreditation = undefined;

  var _Accreditation = __webpack_require__(401);

  Object.defineProperty(exports, 'Accreditation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Accreditation).default;
    }
  });

  var _Amenities = __webpack_require__(415);

  Object.defineProperty(exports, 'Amenities', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Amenities).default;
    }
  });

  var _BasicContent = __webpack_require__(449);

  Object.defineProperty(exports, 'BasicContent', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_BasicContent).default;
    }
  });

  var _BrandProperties = __webpack_require__(452);

  Object.defineProperty(exports, 'BrandProperties', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_BrandProperties).default;
    }
  });

  var _Commute = __webpack_require__(455);

  Object.defineProperty(exports, 'Commute', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Commute).default;
    }
  });

  var _CookieBar = __webpack_require__(458);

  Object.defineProperty(exports, 'CookieBar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_CookieBar).default;
    }
  });

  var _CtaSection = __webpack_require__(462);

  Object.defineProperty(exports, 'CtaSection', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_CtaSection).default;
    }
  });

  var _CTAText = __webpack_require__(463);

  Object.defineProperty(exports, 'CTAText', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_CTAText).default;
    }
  });

  var _CTATextBanner = __webpack_require__(466);

  Object.defineProperty(exports, 'CTATextBanner', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_CTATextBanner).default;
    }
  });

  var _DigitalWalkthrough = __webpack_require__(469);

  Object.defineProperty(exports, 'DigitalWalkthrough', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_DigitalWalkthrough).default;
    }
  });

  var _Footer = __webpack_require__(472);

  Object.defineProperty(exports, 'Footer', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Footer).default;
    }
  });

  var _ImageSection = __webpack_require__(496);

  Object.defineProperty(exports, 'ImageSection', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_ImageSection).default;
    }
  });

  var _FloatingTextImage = __webpack_require__(499);

  Object.defineProperty(exports, 'FloatingTextImage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_FloatingTextImage).default;
    }
  });

  var _FloorPlans = __webpack_require__(502);

  Object.defineProperty(exports, 'FloorPlans', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_FloorPlans).default;
    }
  });

  var _Gallery = __webpack_require__(534);

  Object.defineProperty(exports, 'Gallery', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Gallery).default;
    }
  });

  var _GraingerAward = __webpack_require__(537);

  Object.defineProperty(exports, 'GraingerAward', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_GraingerAward).default;
    }
  });

  var _GraingerBar = __webpack_require__(540);

  Object.defineProperty(exports, 'GraingerBar', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_GraingerBar).default;
    }
  });

  var _HeroBanner = __webpack_require__(555);

  Object.defineProperty(exports, 'HeroBanner', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_HeroBanner).default;
    }
  });

  var _HeroBox = __webpack_require__(558);

  Object.defineProperty(exports, 'HeroBox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_HeroBox).default;
    }
  });

  var _HeroVideo = __webpack_require__(561);

  Object.defineProperty(exports, 'HeroVideo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_HeroVideo).default;
    }
  });

  var _LandingPage = __webpack_require__(564);

  Object.defineProperty(exports, 'LandingPage', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_LandingPage).default;
    }
  });

  var _PriceBox = __webpack_require__(567);

  Object.defineProperty(exports, 'PriceBox', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_PriceBox).default;
    }
  });

  var _ImageLinks = __webpack_require__(570);

  Object.defineProperty(exports, 'ImageLinks', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_ImageLinks).default;
    }
  });

  var _Navigation = __webpack_require__(573);

  Object.defineProperty(exports, 'Navigation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Navigation).default;
    }
  });

  var _NotFound = __webpack_require__(576);

  Object.defineProperty(exports, 'NotFound', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_NotFound).default;
    }
  });

  var _PropertyManagers = __webpack_require__(579);

  Object.defineProperty(exports, 'PropertyManagers', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_PropertyManagers).default;
    }
  });

  var _QuoteBlock = __webpack_require__(582);

  Object.defineProperty(exports, 'QuoteBlock', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_QuoteBlock).default;
    }
  });

  var _POIMap = __webpack_require__(588);

  Object.defineProperty(exports, 'POIMap', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_POIMap).default;
    }
  });

  var _SimpleMap = __webpack_require__(611);

  Object.defineProperty(exports, 'SimpleMap', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_SimpleMap).default;
    }
  });

  var _RentalProcess = __webpack_require__(617);

  Object.defineProperty(exports, 'RentalProcess', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_RentalProcess).default;
    }
  });

  var _RentingProcess = __webpack_require__(624);

  Object.defineProperty(exports, 'RentingProcess', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_RentingProcess).default;
    }
  });

  var _WalkScore = __webpack_require__(627);

  Object.defineProperty(exports, 'WalkScore', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_WalkScore).default;
    }
  });

  var _ImageTiles = __webpack_require__(630);

  Object.defineProperty(exports, 'ImageTiles', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_ImageTiles).default;
    }
  });

  var _SmallFrontSail = __webpack_require__(177);

  Object.defineProperty(exports, 'SmallFrontSail', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_SmallFrontSail).default;
    }
  });

  var _LeftSail = __webpack_require__(127);

  Object.defineProperty(exports, 'LeftSail', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_LeftSail).default;
    }
  });

  var _Loading = __webpack_require__(636);

  Object.defineProperty(exports, 'Loading', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Loading).default;
    }
  });

  __webpack_require__(639);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /***/

},
/* 401 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactAnimateOnScroll = __webpack_require__(86);

  var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);

  var _ListAccreditationLogos = __webpack_require__(405);

  __webpack_require__(413);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Accreditation = function Accreditation(_ref) {
    var title = _ref.title,
        text = _ref.text,
        logos = _ref.logos;
    return _react2.default.createElement('div', {
      className: 'gr-accreditation'
    }, _react2.default.createElement('div', {
      className: 'container'
    }, _react2.default.createElement(_reactAnimateOnScroll2.default, {
      animateOnce: true,
      animateIn: 'fadeInUp',
      animationInDelay: '1000'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-accreditation__title'
    }, title)), text && _react2.default.createElement(_reactAnimateOnScroll2.default, {
      animateOnce: true,
      animateIn: 'fadeInUp',
      animationInDelay: '2000'
    }, _react2.default.createElement('div', {
      className: 'gr-accreditation__text',
      dangerouslySetInnerHTML: {
        __html: text
      }
    })), _react2.default.createElement(_reactAnimateOnScroll2.default, {
      animateOnce: true,
      animateIn: 'fadeInUp',
      animationInDelay: '3000'
    }, logos && _react2.default.createElement('div', {
      className: 'gr-accreditation__logos'
    }, _react2.default.createElement(_ListAccreditationLogos.ListAccreditationLogos, {
      logos: logos
    })))));
  };

  Accreditation.propTypes = {
    title: _propTypes2.default.string,
    text: _propTypes2.default.string,
    logos: _propTypes2.default.arrayOf(_propTypes2.default.shape)
  };
  Accreditation.defaultProps = {
    title: null,
    text: null,
    logos: null
  };
  exports.default = Accreditation;
  /***/
},
/* 402 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var emptyFunction = __webpack_require__(53);

    var invariant = __webpack_require__(54);

    var warning = __webpack_require__(85);

    var assign = __webpack_require__(65);

    var ReactPropTypesSecret = __webpack_require__(118);

    var checkPropTypes = __webpack_require__(119);

    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */

      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */


      var ANONYMOUS = '<<anonymous>>'; // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      /*eslint-disable no-self-compare*/

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */


      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      } // Make `instanceof Error` still work for returned errors.


      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }

        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;

              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName);
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }

          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }

              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunction.thatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }

          var propValue = props[propName];

          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }

          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
          return emptyFunction.thatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }

          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }

          for (var key in propValue) {
            if (propValue.hasOwnProperty(key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunction.thatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (typeof checker !== 'function') {
            warning(false, 'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received %s at index %s.', getPostfixForTypeWarning(checker), i);
            return emptyFunction.thatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }

          for (var key in shapeTypes) {
            var checker = shapeTypes[key];

            if (!checker) {
              continue;
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          } // We need to check all keys in case some are required but missing from
          // props.


          var allKeys = assign({}, props[propName], shapeTypes);

          for (var key in allKeys) {
            var checker = shapeTypes[key];

            if (!checker) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (typeof propValue) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;

          case 'boolean':
            return !propValue;

          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }

            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);

            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;

              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;

                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;

          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        } // Fallback for non-spec compliant Symbols which are polyfilled.


        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      } // Equivalent of `typeof` but with special handling for array and regexp.


      function getPropType(propValue) {
        var propType = typeof propValue;

        if (Array.isArray(propValue)) {
          return 'array';
        }

        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }

        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }

        return propType;
      } // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.


      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }

        var propType = getPropType(propValue);

        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }

        return propType;
      } // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"


      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);

        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;

          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;

          default:
            return type;
        }
      } // Returns class name of the object, if any.


      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }

        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 403 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var emptyFunction = __webpack_require__(53);

  var invariant = __webpack_require__(54);

  var ReactPropTypesSecret = __webpack_require__(118);

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim
    };
    ReactPropTypes.checkPropTypes = emptyFunction;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 404 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the `TypeError` message for "Functions" methods. */
    var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as references for various `Number` constants. */

    var NAN = 0 / 0;
    /** `Object#toString` result references. */

    var symbolTag = '[object Symbol]';
    /** Used to match leading and trailing whitespace. */

    var reTrim = /^\s+|\s+$/g;
    /** Used to detect bad signed hexadecimal string values. */

    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */

    var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */

    var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */

    var freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /** Used for built-in method references. */

    var objectProto = Object.prototype;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeMax = Math.max,
        nativeMin = Math.min;
    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */

    var now = function now() {
      return root.Date.now();
    };
    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */


    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }

      wait = toNumber(wait) || 0;

      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time; // Start the timer for the trailing edge.

        timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.

        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }

      function timerExpired() {
        var time = now();

        if (shouldInvoke(time)) {
          return trailingEdge(time);
        } // Restart the timer.


        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.

        if (trailing && lastArgs) {
          return invokeFunc(time);
        }

        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }

        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }

          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }

        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }

        return result;
      }

      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */


    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }

      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */


    function isSymbol(value) {
      return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */


    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }

      if (isSymbol(value)) {
        return NAN;
      }

      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
      }

      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }

      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }

    module.exports = throttle;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(56));
  /***/
},
/* 405 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ListAccreditationLogos = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _List = __webpack_require__(61);

  var _Img = __webpack_require__(30);

  var _generic = __webpack_require__(10);

  __webpack_require__(411);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ListAccreditationLogos = exports.ListAccreditationLogos = function ListAccreditationLogos(_ref) {
    var logos = _ref.logos;
    return logos && _react2.default.createElement(_List.List, {
      isUnstyled: true,
      isInline: true,
      className: 'gr-accreditation-logos row'
    }, logos.map(function (logo) {
      return logo.url && _react2.default.createElement('li', {
        className: 'gr-accreditation-logos__logo',
        key: (0, _generic.randomStr)(logo.url)
      }, _react2.default.createElement(_Img.Img, {
        src: logo.url,
        alt: logo.name || 'Logo for accrediation',
        isFluid: true,
        className: 'gr-accreditation-logos__image'
      }));
    }));
  };

  ListAccreditationLogos.propTypes = {
    logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      url: _propTypes2.default.string,
      name: _propTypes2.default.name
    }))
  };
  ListAccreditationLogos.defaultProps = {
    logos: null
  };
  exports.default = ListAccreditationLogos;
  /***/
},
/* 406 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(407);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./List.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./List.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 407 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".list--unstyled {\n  padding: 0;\n  margin: 0;\n  list-style: none; }\n\n.list--inline {\n  display: flex;\n  list-style: none;\n  padding: 0; }\n  .list--inline li {\n    margin-right: 1rem; }\n", ""]); // exports

  /***/
},
/* 408 */

/***/
function (module, exports) {
  /**
   * When source maps are enabled, `style-loader` uses a link element with a data-uri to
   * embed the css on the page. This breaks all relative urls because now they are relative to a
   * bundle instead of the current page.
   *
   * One solution is to only use full urls, but that may be impossible.
   *
   * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
   *
   * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
   *
   */
  module.exports = function (css) {
    // get current location
    var location = typeof window !== "undefined" && window.location;

    if (!location) {
      throw new Error("fixUrls requires window.location");
    } // blank or null?


    if (!css || typeof css !== "string") {
      return css;
    }

    var baseUrl = location.protocol + "//" + location.host;
    var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/"); // convert each url(...)

    /*
    This regular expression is just a way to recursively match brackets within
    a string.
    	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
       (  = Start a capturing group
         (?:  = Start a non-capturing group
             [^)(]  = Match anything that isn't a parentheses
             |  = OR
             \(  = Match a start parentheses
                 (?:  = Start another non-capturing groups
                     [^)(]+  = Match anything that isn't a parentheses
                     |  = OR
                     \(  = Match a start parentheses
                         [^)(]*  = Match anything that isn't a parentheses
                     \)  = Match a end parentheses
                 )  = End Group
                 *\) = Match anything and then a close parens
             )  = Close non-capturing group
             *  = Match anything
          )  = Close capturing group
     \)  = Match a close parens
    	 /gi  = Get all matches, not the first.  Be case insensitive.
     */

    var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
      // strip quotes (if they exist)
      var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
        return $1;
      }).replace(/^'(.*)'$/, function (o, $1) {
        return $1;
      }); // already a full url? no change

      if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
        return fullMatch;
      } // convert the url to a full url


      var newUrl;

      if (unquotedOrigUrl.indexOf("//") === 0) {
        //TODO: should we add protocol?
        newUrl = unquotedOrigUrl;
      } else if (unquotedOrigUrl.indexOf("/") === 0) {
        // path should be relative to the base url
        newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
      } else {
        // path should be relative to current directory
        newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
      } // send back the fixed url(...)


      return "url(" + JSON.stringify(newUrl) + ")";
    }); // send back the fixed css

    return fixedCss;
  };
  /***/

},
/* 409 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(410);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Img.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Img.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 410 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".img--fluid {\n  max-width: 100%;\n  height: auto; }\n", ""]); // exports

  /***/
},
/* 411 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(412);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!./ListAccreditationLogos.css", function () {
      var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!./ListAccreditationLogos.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 412 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-accreditation-logos {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .gr-accreditation-logos li {\n    margin-top: 30px;\n    margin-right: 0;\n    flex: 0 0 50%;\n    max-width: 50%;\n    padding: 0 15px; }\n    @media all and (min-width: 768px) {\n      .gr-accreditation-logos li {\n        margin-top: 40px; } }\n  .gr-accreditation-logos__image {\n    -webkit-filter: grayscale(100%);\n    filter: grayscale(100%); }\n", ""]); // exports

  /***/
},
/* 413 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(414);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Accreditation.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Accreditation.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 414 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-accreditation {\n  margin: 40px 0;\n  text-align: center; }\n  @media all and (min-width: 768px) {\n    .gr-accreditation {\n      margin: 70px 0; } }\n  .gr-accreditation__title {\n    text-transform: uppercase;\n    color: #00627B;\n    font-size: 20px;\n    font-family: \"fs_elliotbold\";\n    margin: 0 0 20px; }\n    @media all and (min-width: 768px) {\n      .gr-accreditation__title {\n        font-size: 30px; } }\n  .gr-accreditation__text {\n    max-width: 720px;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-accreditation__text {\n        font-size: 20px;\n        margin-top: -10px; } }\n  @media all and (min-width: 768px) {\n    .gr-accreditation__logos {\n      max-width: 700px;\n      margin: 0 auto; } }\n", ""]); // exports

  /***/
},
/* 415 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Amenities = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  var _Amenity = __webpack_require__(416);

  var _Links = __webpack_require__(37);

  var _List = __webpack_require__(61);

  __webpack_require__(447);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var rel = {
    1: 12,
    2: 6,
    3: 6,
    4: 6,
    5: 4,
    6: 4,
    7: 3,
    8: 3
  };
  /**
   * Amenities component displays a list of an apartments amenites.
   */

  var Amenities = exports.Amenities = function (_PureComponent) {
    _inherits(Amenities, _PureComponent);

    function Amenities(props) {
      _classCallCheck(this, Amenities);

      var _this = _possibleConstructorReturn(this, (Amenities.__proto__ || Object.getPrototypeOf(Amenities)).call(this, props));

      _this.state = {
        activeAmenity: null,
        width: window.innerWidth
        /* eslint-disable-line react/no-unused-state */

      };
      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    _createClass(Amenities, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        window.addEventListener('resize', function () {
          if ((0, _generic.isDesktopView)()) {
            _this2.setState({
              activeAmenity: null
            });
          }

          _this2.setState({
            width: window.innerWidth
            /* eslint-disable-line react/no-unused-state */

          });
        });
      }
    }, {
      key: 'toggle',
      value: function toggle(i) {
        this.setState({
          activeAmenity: i === this.state.activeAmenity ? null : i
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            title = _props.title,
            amenities = _props.amenities,
            more = _props.more,
            cta = _props.cta;
        var colSize = amenities && rel[amenities.length];
        var zoom = amenities && Math.floor(colSize / 2);
        return _react2.default.createElement('section', {
          className: 'gr-amenities'
        }, _react2.default.createElement('div', {
          className: 'gr-amenities__container'
        }, title && _react2.default.createElement('h2', {
          className: 'gr-amenities__title'
        }, title), amenities && _react2.default.createElement('div', {
          className: 'gr-amenities__content'
        }, _react2.default.createElement(_List.List, {
          className: 'gr-amenities__amenities no-gutters row zoom-' + zoom
        }, amenities.map(function (amenity, index) {
          return _react2.default.createElement(_Amenity.Amenity, {
            key: (0, _generic.randomStr)(amenity.title),
            amenity: amenity,
            onClick: function onClick() {
              return _this3.toggle(index);
            },
            active: _this3.state.activeAmenity === index,
            colSize: colSize
          });
        }))), _react2.default.createElement('div', {
          className: 'gr-amenities__extra'
        }, more && _react2.default.createElement('div', {
          className: 'gr-amenities__more'
        }, _react2.default.createElement('strong', {
          className: 'gr-amenities__and-more'
        }, 'And more...'), _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: more
          }
        })), cta && cta.text && cta.url && _react2.default.createElement('div', {
          className: 'gr-amenities__button'
        }, _react2.default.createElement(_Links.Links, {
          location: cta.url,
          text: cta.text,
          isExternal: cta.isExternal,
          className: 'gr-cta gr-amenities__cta'
        })))));
      }
    }]);

    return Amenities;
  }(_react.PureComponent);

  Amenities.propTypes = {
    title: _propTypes2.default.string,
    amenities: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /** The name/title of the amenity */
      title: _propTypes2.default.string,

      /** An icon that represents the amenity, should be from the list of icons available */
      icon: _propTypes2.default.string,

      /** True/False, whether this amenity is open to the public. This will turn the icon orange. */
      isPublic: _propTypes2.default.bool,

      /** The url of the image provided in prismic for each amenity. */
      imageUrl: _propTypes2.default.string
    })),

    /** A string of text that intices the user to 'view more'. */
    more: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      /** A url where the cta points to */
      url: _propTypes2.default.string,

      /** Whether the cta is internal. */
      isExternal: _propTypes2.default.bool,

      /** The text that displays in the cta. */
      text: _propTypes2.default.string
    })
  };
  Amenities.defaultProps = {
    title: null,
    more: null,
    cta: null,
    amenities: null
  };
  exports.default = Amenities;
  /***/
},
/* 416 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Amenity = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Img = __webpack_require__(30);

  var _generic = __webpack_require__(10);

  __webpack_require__(417);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Amenity = exports.Amenity = function (_PureComponent) {
    _inherits(Amenity, _PureComponent);

    function Amenity(props) {
      _classCallCheck(this, Amenity);

      var _this = _possibleConstructorReturn(this, (Amenity.__proto__ || Object.getPrototypeOf(Amenity)).call(this, props));

      _this.setRef = _this.setRef.bind(_this);
      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    _createClass(Amenity, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        document.addEventListener('keyup', function (e) {
          var key = e.key || e.keyCode;

          if (key === 13 || key === 'Enter') {
            _this2.toggle();
          }
        });
      }
    }, {
      key: 'setRef',
      value: function setRef(node) {
        this.amenityExplanation = node;
      }
    }, {
      key: 'toggle',
      value: function toggle() {
        if (window.innerWidth <= 768 && this.amenityExplanation) {
          this.props.onClick();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            amenity = _props.amenity,
            active = _props.active,
            colSize = _props.colSize;
        var backgroundUrl = amenity ? amenity.imageUrl : '';
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

        return _react2.default.createElement('li', {
          onClick: this.toggle,
          onKeyUp: function onKeyUp() {
            return false;
          },
          className: 'col-12 col-md-6 col-lg-' + colSize + ' gr-amenity\n          ' + (active ? 'gr-amenity--open' : '') + '\n          ' + (!amenity.explanation ? 'gr-amenity--no-explanation' : ''),
          style: backgroundUrl && (0, _generic.isNotMobileView)() ? {
            backgroundImage: 'url(' + backgroundUrl + ')'
          } : null
        }, _react2.default.createElement('div', {
          className: 'gr-amenity__content'
        }, backgroundUrl && (0, _generic.isMobileView)() && _react2.default.createElement(_Img.Img, {
          src: backgroundUrl,
          className: 'gr-amenity__image'
        }), _react2.default.createElement('div', {
          className: 'gr-amenity__info'
        }, amenity.icon && _react2.default.createElement('div', {
          className: 'gr-amenity__icon-wrapper'
        }, _react2.default.createElement('i', {
          className: 'gr-icon icon-' + amenity.icon + ' gr-amenity__icon\n                    ' + (active ? 'gr-amenity__icon--rotate' : '')
        })), amenity.title && _react2.default.createElement('strong', {
          className: 'gr-amenity__title'
        }, amenity.title), amenity.explanation && _react2.default.createElement('i', {
          className: 'gr-icon gr-amenity__chevron icon-chevron-down\n                  ' + (active ? 'gr-amenity__chevron--rotate' : '') + ' '
        })), amenity.explanation && _react2.default.createElement('div', {
          className: 'gr-amenity__explanation ' + (active ? 'gr-amenity__explanation--show' : ''),
          ref: function ref(node) {
            return _this3.setRef(node);
          }
        }, _react2.default.createElement('div', {
          className: 'gr-amenity__explanation-wrapper'
        }, amenity.title && _react2.default.createElement('strong', {
          className: 'gr-amenity__title gr-amenity__title--explanation'
        }, amenity.title), _react2.default.createElement('span', {
          className: 'gr-amenity__explanation-content'
        }, amenity.explanation)))));
      }
    }]);

    return Amenity;
  }(_react.PureComponent);

  Amenity.propTypes = {
    amenity: _propTypes2.default.shape({
      title: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      explanation: _propTypes2.default.string
    }),
    active: _propTypes2.default.bool,
    colSize: _propTypes2.default.number,
    onClick: _propTypes2.default.func
  };
  Amenity.defaultProps = {
    amenity: null,
    active: false,
    colSize: null,
    onClick: null
  };
  exports.default = Amenity;
  /***/
},
/* 417 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(418);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!./Amenity.css", function () {
      var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!./Amenity.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 418 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-amenity {\n  padding: 12px 20px;\n  transition: background-color .2s linear; }\n  .gr-amenity:hover, .gr-amenity:focus {\n    color: #FFFFFF;\n    outline: none; }\n    .gr-amenity:hover .gr-amenity__chevron, .gr-amenity:focus .gr-amenity__chevron {\n      color: #FFFFFF; }\n  .gr-amenity--no-explanation:hover, .gr-amenity--no-explanation:focus {\n    background-color: #979797; }\n  @media all and (min-width: 768px) {\n    .gr-amenity {\n      height: 210px;\n      position: relative;\n      padding: 20px; }\n      .gr-amenity:hover .gr-amenity__explanation, .gr-amenity:focus .gr-amenity__explanation {\n        opacity: 1;\n        z-index: 1;\n        transition: opacity .2s linear; } }\n  @media all and (min-width: 992px) {\n    .gr-amenity {\n      height: 200px;\n      padding: 15px; } }\n  .gr-amenity__info {\n    display: flex;\n    align-items: center;\n    position: relative;\n    padding-right: 50px; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__info {\n        height: 100%;\n        padding: 0;\n        align-items: inherit;\n        justify-content: flex-end;\n        flex-direction: column-reverse; } }\n  .gr-amenity__icon-wrapper {\n    width: 55px;\n    display: inline-flex; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__icon-wrapper {\n        width: auto;\n        text-align: center;\n        flex: 1;\n        align-items: flex-start; } }\n  .gr-amenity__icon {\n    font-size: 35px; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__icon {\n        margin: 0 auto; } }\n  .gr-amenity__image {\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 100%;\n    display: none; }\n  .gr-amenity__title {\n    text-transform: uppercase; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__title {\n        color: #FFFFFF; } }\n    .gr-amenity__title--explanation {\n      display: none; }\n      @media all and (min-width: 768px) {\n        .gr-amenity__title--explanation {\n          display: block;\n          color: #FFFFFF;\n          min-height: auto; } }\n  .gr-amenity__chevron {\n    color: #000000;\n    font-size: 40px;\n    position: absolute;\n    right: 0;\n    transform: rotateX(0);\n    transition: transform .3s ease-in-out, color .2s linear; }\n    .gr-amenity__chevron--rotate {\n      transform: rotateX(-180deg);\n      color: #FFFFFF; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__chevron {\n        display: none; } }\n  .gr-amenity__explanation {\n    padding: 0 45px 0 55px;\n    display: none; }\n    .gr-amenity__explanation--show {\n      display: block; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__explanation {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        display: block;\n        opacity: 0;\n        z-index: -1;\n        padding: 20px;\n        transition: opacity .2s linear; } }\n    @media all and (min-width: 992px) {\n      .gr-amenity__explanation {\n        padding: 15px; } }\n  .gr-amenity__explanation-wrapper {\n    padding-bottom: 6px; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__explanation-wrapper {\n        padding-bottom: 0; } }\n  .gr-amenity__explanation-content {\n    line-height: 18px;\n    display: block; }\n    @media all and (min-width: 768px) {\n      .gr-amenity__explanation-content {\n        margin: 8px 0 0; } }\n  .gr-amenity--open {\n    background-color: #979797; }\n    .gr-amenity--open .gr-amenity__image {\n      display: block; }\n", ""]); // exports

  /***/
},
/* 419 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(420);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(122);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for a <Router> that uses HTML5 history.
   */


  var BrowserRouter = function (_React$Component) {
    _inherits(BrowserRouter, _React$Component);

    function BrowserRouter() {
      var _temp, _this, _ret;

      _classCallCheck(this, BrowserRouter);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
    }

    BrowserRouter.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
    };

    BrowserRouter.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a"
      /* default */
      ], {
        history: this.history,
        children: this.props.children
      });
    };

    return BrowserRouter;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  BrowserRouter.propTypes = {
    basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
  };
  /* harmony default export */

  __webpack_exports__["a"] = BrowserRouter;
  /***/
},
/* 420 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _warning = __webpack_require__(15);

  var _warning2 = _interopRequireDefault(_warning);

  var _invariant = __webpack_require__(31);

  var _invariant2 = _interopRequireDefault(_invariant);

  var _LocationUtils = __webpack_require__(120);

  var _PathUtils = __webpack_require__(66);

  var _createTransitionManager = __webpack_require__(121);

  var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

  var _DOMUtils = __webpack_require__(166);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PopStateEvent = 'popstate';
  var HashChangeEvent = 'hashchange';

  var getHistoryState = function getHistoryState() {
    try {
      return window.history.state || {};
    } catch (e) {
      // IE 11 sometimes throws when accessing window.history.state
      // See https://github.com/ReactTraining/history/pull/289
      return {};
    }
  };
  /**
   * Creates a history object that uses the HTML5 history API including
   * pushState, replaceState, and the popstate event.
   */


  var createBrowserHistory = function createBrowserHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
    var globalHistory = window.history;
    var canUseHistory = (0, _DOMUtils.supportsHistory)();
    var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
    var _props$forceRefresh = props.forceRefresh,
        forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
        _props$getUserConfirm = props.getUserConfirmation,
        getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
        _props$keyLength = props.keyLength,
        keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

    var getDOMLocation = function getDOMLocation(historyState) {
      var _ref = historyState || {},
          key = _ref.key,
          state = _ref.state;

      var _window$location = window.location,
          pathname = _window$location.pathname,
          search = _window$location.search,
          hash = _window$location.hash;
      var path = pathname + search + hash;
      (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
      if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
      return (0, _LocationUtils.createLocation)(path, state, key);
    };

    var createKey = function createKey() {
      return Math.random().toString(36).substr(2, keyLength);
    };

    var transitionManager = (0, _createTransitionManager2.default)();

    var setState = function setState(nextState) {
      _extends(history, nextState);

      history.length = globalHistory.length;
      transitionManager.notifyListeners(history.location, history.action);
    };

    var handlePopState = function handlePopState(event) {
      // Ignore extraneous popstate events in WebKit.
      if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
      handlePop(getDOMLocation(event.state));
    };

    var handleHashChange = function handleHashChange() {
      handlePop(getDOMLocation(getHistoryState()));
    };

    var forceNextPop = false;

    var handlePop = function handlePop(location) {
      if (forceNextPop) {
        forceNextPop = false;
        setState();
      } else {
        var action = 'POP';
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
          if (ok) {
            setState({
              action: action,
              location: location
            });
          } else {
            revertPop(location);
          }
        });
      }
    };

    var revertPop = function revertPop(fromLocation) {
      var toLocation = history.location; // TODO: We could probably make this more reliable by
      // keeping a list of keys we've seen in sessionStorage.
      // Instead, we just default to 0 for keys we don't know.

      var toIndex = allKeys.indexOf(toLocation.key);
      if (toIndex === -1) toIndex = 0;
      var fromIndex = allKeys.indexOf(fromLocation.key);
      if (fromIndex === -1) fromIndex = 0;
      var delta = toIndex - fromIndex;

      if (delta) {
        forceNextPop = true;
        go(delta);
      }
    };

    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [initialLocation.key]; // Public interface

    var createHref = function createHref(location) {
      return basename + (0, _PathUtils.createPath)(location);
    };

    var push = function push(path, state) {
      (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
      var action = 'PUSH';
      var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var href = createHref(location);
        var key = location.key,
            state = location.state;

        if (canUseHistory) {
          globalHistory.pushState({
            key: key,
            state: state
          }, null, href);

          if (forceRefresh) {
            window.location.href = href;
          } else {
            var prevIndex = allKeys.indexOf(history.location.key);
            var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
            nextKeys.push(location.key);
            allKeys = nextKeys;
            setState({
              action: action,
              location: location
            });
          }
        } else {
          (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
          window.location.href = href;
        }
      });
    };

    var replace = function replace(path, state) {
      (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
      var action = 'REPLACE';
      var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var href = createHref(location);
        var key = location.key,
            state = location.state;

        if (canUseHistory) {
          globalHistory.replaceState({
            key: key,
            state: state
          }, null, href);

          if (forceRefresh) {
            window.location.replace(href);
          } else {
            var prevIndex = allKeys.indexOf(history.location.key);
            if (prevIndex !== -1) allKeys[prevIndex] = location.key;
            setState({
              action: action,
              location: location
            });
          }
        } else {
          (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
          window.location.replace(href);
        }
      });
    };

    var go = function go(n) {
      globalHistory.go(n);
    };

    var goBack = function goBack() {
      return go(-1);
    };

    var goForward = function goForward() {
      return go(1);
    };

    var listenerCount = 0;

    var checkDOMListeners = function checkDOMListeners(delta) {
      listenerCount += delta;

      if (listenerCount === 1) {
        (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
        if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
      } else if (listenerCount === 0) {
        (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
        if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
      }
    };

    var isBlocked = false;

    var block = function block() {
      var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var unblock = transitionManager.setPrompt(prompt);

      if (!isBlocked) {
        checkDOMListeners(1);
        isBlocked = true;
      }

      return function () {
        if (isBlocked) {
          isBlocked = false;
          checkDOMListeners(-1);
        }

        return unblock();
      };
    };

    var listen = function listen(listener) {
      var unlisten = transitionManager.appendListener(listener);
      checkDOMListeners(1);
      return function () {
        checkDOMListeners(-1);
        unlisten();
      };
    };

    var history = {
      length: globalHistory.length,
      action: 'POP',
      location: initialLocation,
      createHref: createHref,
      push: push,
      replace: replace,
      go: go,
      goBack: goBack,
      goForward: goForward,
      block: block,
      listen: listen
    };
    return history;
  };

  exports.default = createBrowserHistory;
  /***/
},
/* 421 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(422);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(122);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for a <Router> that uses window.location.hash.
   */


  var HashRouter = function (_React$Component) {
    _inherits(HashRouter, _React$Component);

    function HashRouter() {
      var _temp, _this, _ret;

      _classCallCheck(this, HashRouter);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
    }

    HashRouter.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
    };

    HashRouter.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a"
      /* default */
      ], {
        history: this.history,
        children: this.props.children
      });
    };

    return HashRouter;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  HashRouter.propTypes = {
    basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
  };
  /* harmony default export */

  __webpack_exports__["a"] = HashRouter;
  /***/
},
/* 422 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _warning = __webpack_require__(15);

  var _warning2 = _interopRequireDefault(_warning);

  var _invariant = __webpack_require__(31);

  var _invariant2 = _interopRequireDefault(_invariant);

  var _LocationUtils = __webpack_require__(120);

  var _PathUtils = __webpack_require__(66);

  var _createTransitionManager = __webpack_require__(121);

  var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

  var _DOMUtils = __webpack_require__(166);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var HashChangeEvent = 'hashchange';
  var HashPathCoders = {
    hashbang: {
      encodePath: function encodePath(path) {
        return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
      },
      decodePath: function decodePath(path) {
        return path.charAt(0) === '!' ? path.substr(1) : path;
      }
    },
    noslash: {
      encodePath: _PathUtils.stripLeadingSlash,
      decodePath: _PathUtils.addLeadingSlash
    },
    slash: {
      encodePath: _PathUtils.addLeadingSlash,
      decodePath: _PathUtils.addLeadingSlash
    }
  };

  var getHashPath = function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
  };

  var pushHashPath = function pushHashPath(path) {
    return window.location.hash = path;
  };

  var replaceHashPath = function replaceHashPath(path) {
    var hashIndex = window.location.href.indexOf('#');
    window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
  };

  var createHashHistory = function createHashHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
    var globalHistory = window.history;
    var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
    var _props$getUserConfirm = props.getUserConfirmation,
        getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
        _props$hashType = props.hashType,
        hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
    var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType],
        encodePath = _HashPathCoders$hashT.encodePath,
        decodePath = _HashPathCoders$hashT.decodePath;

    var getDOMLocation = function getDOMLocation() {
      var path = decodePath(getHashPath());
      (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
      if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
      return (0, _LocationUtils.createLocation)(path);
    };

    var transitionManager = (0, _createTransitionManager2.default)();

    var setState = function setState(nextState) {
      _extends(history, nextState);

      history.length = globalHistory.length;
      transitionManager.notifyListeners(history.location, history.action);
    };

    var forceNextPop = false;
    var ignorePath = null;

    var handleHashChange = function handleHashChange() {
      var path = getHashPath();
      var encodedPath = encodePath(path);

      if (path !== encodedPath) {
        // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
      } else {
        var location = getDOMLocation();
        var prevLocation = history.location;
        if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

        if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

        ignorePath = null;
        handlePop(location);
      }
    };

    var handlePop = function handlePop(location) {
      if (forceNextPop) {
        forceNextPop = false;
        setState();
      } else {
        var action = 'POP';
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
          if (ok) {
            setState({
              action: action,
              location: location
            });
          } else {
            revertPop(location);
          }
        });
      }
    };

    var revertPop = function revertPop(fromLocation) {
      var toLocation = history.location; // TODO: We could probably make this more reliable by
      // keeping a list of paths we've seen in sessionStorage.
      // Instead, we just default to 0 for paths we don't know.

      var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
      if (toIndex === -1) toIndex = 0;
      var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
      if (fromIndex === -1) fromIndex = 0;
      var delta = toIndex - fromIndex;

      if (delta) {
        forceNextPop = true;
        go(delta);
      }
    }; // Ensure the hash is encoded properly before doing anything else.


    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [(0, _PathUtils.createPath)(initialLocation)]; // Public interface

    var createHref = function createHref(location) {
      return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
    };

    var push = function push(path, state) {
      (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
      var action = 'PUSH';
      var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var path = (0, _PathUtils.createPath)(location);
        var encodedPath = encodePath(basename + path);
        var hashChanged = getHashPath() !== encodedPath;

        if (hashChanged) {
          // We cannot tell if a hashchange was caused by a PUSH, so we'd
          // rather setState here and ignore the hashchange. The caveat here
          // is that other hash histories in the page will consider it a POP.
          ignorePath = path;
          pushHashPath(encodedPath);
          var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
          var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextPaths.push(path);
          allPaths = nextPaths;
          setState({
            action: action,
            location: location
          });
        } else {
          (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
          setState();
        }
      });
    };

    var replace = function replace(path, state) {
      (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
      var action = 'REPLACE';
      var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var path = (0, _PathUtils.createPath)(location);
        var encodedPath = encodePath(basename + path);
        var hashChanged = getHashPath() !== encodedPath;

        if (hashChanged) {
          // We cannot tell if a hashchange was caused by a REPLACE, so we'd
          // rather setState here and ignore the hashchange. The caveat here
          // is that other hash histories in the page will consider it a POP.
          ignorePath = path;
          replaceHashPath(encodedPath);
        }

        var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
        if (prevIndex !== -1) allPaths[prevIndex] = path;
        setState({
          action: action,
          location: location
        });
      });
    };

    var go = function go(n) {
      (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
      globalHistory.go(n);
    };

    var goBack = function goBack() {
      return go(-1);
    };

    var goForward = function goForward() {
      return go(1);
    };

    var listenerCount = 0;

    var checkDOMListeners = function checkDOMListeners(delta) {
      listenerCount += delta;

      if (listenerCount === 1) {
        (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
      } else if (listenerCount === 0) {
        (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
      }
    };

    var isBlocked = false;

    var block = function block() {
      var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var unblock = transitionManager.setPrompt(prompt);

      if (!isBlocked) {
        checkDOMListeners(1);
        isBlocked = true;
      }

      return function () {
        if (isBlocked) {
          isBlocked = false;
          checkDOMListeners(-1);
        }

        return unblock();
      };
    };

    var listen = function listen(listener) {
      var unlisten = transitionManager.appendListener(listener);
      checkDOMListeners(1);
      return function () {
        checkDOMListeners(-1);
        unlisten();
      };
    };

    var history = {
      length: globalHistory.length,
      action: 'POP',
      location: initialLocation,
      createHref: createHref,
      push: push,
      replace: replace,
      go: go,
      goBack: goBack,
      goForward: goForward,
      block: block,
      listen: listen
    };
    return history;
  };

  exports.default = createHashHistory;
  /***/
},
/* 423 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(424); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a"
  /* default */
  ];
  /***/
},
/* 424 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(425);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(123);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for a <Router> that stores location in memory.
   */


  var MemoryRouter = function (_React$Component) {
    _inherits(MemoryRouter, _React$Component);

    function MemoryRouter() {
      var _temp, _this, _ret;

      _classCallCheck(this, MemoryRouter);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
    }

    MemoryRouter.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
    };

    MemoryRouter.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a"
      /* default */
      ], {
        history: this.history,
        children: this.props.children
      });
    };

    return MemoryRouter;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  MemoryRouter.propTypes = {
    initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
  };
  /* harmony default export */

  __webpack_exports__["a"] = MemoryRouter;
  /***/
},
/* 425 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _warning = __webpack_require__(15);

  var _warning2 = _interopRequireDefault(_warning);

  var _PathUtils = __webpack_require__(66);

  var _LocationUtils = __webpack_require__(120);

  var _createTransitionManager = __webpack_require__(121);

  var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var clamp = function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
  };
  /**
   * Creates a history object that stores locations in memory.
   */


  var createMemoryHistory = function createMemoryHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getUserConfirmation = props.getUserConfirmation,
        _props$initialEntries = props.initialEntries,
        initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
        _props$initialIndex = props.initialIndex,
        initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
        _props$keyLength = props.keyLength,
        keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var transitionManager = (0, _createTransitionManager2.default)();

    var setState = function setState(nextState) {
      _extends(history, nextState);

      history.length = history.entries.length;
      transitionManager.notifyListeners(history.location, history.action);
    };

    var createKey = function createKey() {
      return Math.random().toString(36).substr(2, keyLength);
    };

    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function (entry) {
      return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
    }); // Public interface

    var createHref = _PathUtils.createPath;

    var push = function push(path, state) {
      (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
      var action = 'PUSH';
      var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var prevIndex = history.index;
        var nextIndex = prevIndex + 1;
        var nextEntries = history.entries.slice(0);

        if (nextEntries.length > nextIndex) {
          nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
        } else {
          nextEntries.push(location);
        }

        setState({
          action: action,
          location: location,
          index: nextIndex,
          entries: nextEntries
        });
      });
    };

    var replace = function replace(path, state) {
      (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
      var action = 'REPLACE';
      var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        history.entries[history.index] = location;
        setState({
          action: action,
          location: location
        });
      });
    };

    var go = function go(n) {
      var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
      var action = 'POP';
      var location = history.entries[nextIndex];
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location,
            index: nextIndex
          });
        } else {
          // Mimic the behavior of DOM histories by
          // causing a render after a cancelled POP.
          setState();
        }
      });
    };

    var goBack = function goBack() {
      return go(-1);
    };

    var goForward = function goForward() {
      return go(1);
    };

    var canGo = function canGo(n) {
      var nextIndex = history.index + n;
      return nextIndex >= 0 && nextIndex < history.entries.length;
    };

    var block = function block() {
      var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return transitionManager.setPrompt(prompt);
    };

    var listen = function listen(listener) {
      return transitionManager.appendListener(listener);
    };

    var history = {
      length: entries.length,
      action: 'POP',
      location: entries[index],
      index: index,
      entries: entries,
      createHref: createHref,
      push: push,
      replace: replace,
      go: go,
      goBack: goBack,
      goForward: goForward,
      canGo: canGo,
      block: block,
      listen: listen
    };
    return history;
  };

  exports.default = createMemoryHistory;
  /***/
},
/* 426 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(168);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(167);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }
  /**
   * A <Link> wrapper that knows if it's "active" or not.
   */


  var NavLink = function NavLink(_ref) {
    var to = _ref.to,
        exact = _ref.exact,
        strict = _ref.strict,
        location = _ref.location,
        activeClassName = _ref.activeClassName,
        className = _ref.className,
        activeStyle = _ref.activeStyle,
        style = _ref.style,
        getIsActive = _ref.isActive,
        ariaCurrent = _ref.ariaCurrent,
        rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a"
    /* default */
    ], {
      path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
      exact: exact,
      strict: strict,
      location: location,
      children: function children(_ref2) {
        var location = _ref2.location,
            match = _ref2.match;
        var isActive = !!(getIsActive ? getIsActive(match, location) : match);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a"
        /* default */
        ], _extends({
          to: to,
          className: isActive ? [className, activeClassName].filter(function (i) {
            return i;
          }).join(' ') : className,
          style: isActive ? _extends({}, style, activeStyle) : style,
          'aria-current': isActive && ariaCurrent
        }, rest));
      }
    });
  };

  NavLink.propTypes = {
    to: __WEBPACK_IMPORTED_MODULE_3__Link__["a"
    /* default */
    ].propTypes.to,
    exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
  };
  NavLink.defaultProps = {
    activeClassName: 'active',
    ariaCurrent: 'true'
  };
  /* harmony default export */

  __webpack_exports__["a"] = NavLink;
  /***/
},
/* 427 */

/***/
function (module, exports, __webpack_require__) {
  var isarray = __webpack_require__(428);
  /**
   * Expose `pathToRegexp`.
   */


  module.exports = pathToRegexp;
  module.exports.parse = parse;
  module.exports.compile = compile;
  module.exports.tokensToFunction = tokensToFunction;
  module.exports.tokensToRegExp = tokensToRegExp;
  /**
   * The main path matching regexp utility.
   *
   * @type {RegExp}
   */

  var PATH_REGEXP = new RegExp([// Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)', // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');
  /**
   * Parse a string for the raw tokens.
   *
   * @param  {string}  str
   * @param  {Object=} options
   * @return {!Array}
   */

  function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;

    while ((res = PATH_REGEXP.exec(str)) != null) {
      var m = res[0];
      var escaped = res[1];
      var offset = res.index;
      path += str.slice(index, offset);
      index = offset + m.length; // Ignore already escaped sequences.

      if (escaped) {
        path += escaped[1];
        continue;
      }

      var next = str[index];
      var prefix = res[2];
      var name = res[3];
      var capture = res[4];
      var group = res[5];
      var modifier = res[6];
      var asterisk = res[7]; // Push the current path onto the tokens.

      if (path) {
        tokens.push(path);
        path = '';
      }

      var partial = prefix != null && next != null && next !== prefix;
      var repeat = modifier === '+' || modifier === '*';
      var optional = modifier === '?' || modifier === '*';
      var delimiter = res[2] || defaultDelimiter;
      var pattern = capture || group;
      tokens.push({
        name: name || key++,
        prefix: prefix || '',
        delimiter: delimiter,
        optional: optional,
        repeat: repeat,
        partial: partial,
        asterisk: !!asterisk,
        pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
      });
    } // Match any characters still remaining.


    if (index < str.length) {
      path += str.substr(index);
    } // If the path exists, push it onto the end.


    if (path) {
      tokens.push(path);
    }

    return tokens;
  }
  /**
   * Compile a string to a template function for the path.
   *
   * @param  {string}             str
   * @param  {Object=}            options
   * @return {!function(Object=, Object=)}
   */


  function compile(str, options) {
    return tokensToFunction(parse(str, options));
  }
  /**
   * Prettier encoding of URI path segments.
   *
   * @param  {string}
   * @return {string}
   */


  function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
  }
  /**
   * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
   *
   * @param  {string}
   * @return {string}
   */


  function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
  }
  /**
   * Expose a method for transforming tokens into the path function.
   */


  function tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length); // Compile all the patterns before compilation.

    for (var i = 0; i < tokens.length; i++) {
      if (typeof tokens[i] === 'object') {
        matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
      }
    }

    return function (obj, opts) {
      var path = '';
      var data = obj || {};
      var options = opts || {};
      var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];

        if (typeof token === 'string') {
          path += token;
          continue;
        }

        var value = data[token.name];
        var segment;

        if (value == null) {
          if (token.optional) {
            // Prepend partial segment prefixes.
            if (token.partial) {
              path += token.prefix;
            }

            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to be defined');
          }
        }

        if (isarray(value)) {
          if (!token.repeat) {
            throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
          }

          if (value.length === 0) {
            if (token.optional) {
              continue;
            } else {
              throw new TypeError('Expected "' + token.name + '" to not be empty');
            }
          }

          for (var j = 0; j < value.length; j++) {
            segment = encode(value[j]);

            if (!matches[i].test(segment)) {
              throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
            }

            path += (j === 0 ? token.prefix : token.delimiter) + segment;
          }

          continue;
        }

        segment = token.asterisk ? encodeAsterisk(value) : encode(value);

        if (!matches[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
        }

        path += token.prefix + segment;
      }

      return path;
    };
  }
  /**
   * Escape a regular expression string.
   *
   * @param  {string} str
   * @return {string}
   */


  function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
  }
  /**
   * Escape the capturing group by escaping special characters and meaning.
   *
   * @param  {string} group
   * @return {string}
   */


  function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
  }
  /**
   * Attach the keys as a property of the regexp.
   *
   * @param  {!RegExp} re
   * @param  {Array}   keys
   * @return {!RegExp}
   */


  function attachKeys(re, keys) {
    re.keys = keys;
    return re;
  }
  /**
   * Get the flags for a regexp from the options.
   *
   * @param  {Object} options
   * @return {string}
   */


  function flags(options) {
    return options.sensitive ? '' : 'i';
  }
  /**
   * Pull out keys from a regexp.
   *
   * @param  {!RegExp} path
   * @param  {!Array}  keys
   * @return {!RegExp}
   */


  function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);

    if (groups) {
      for (var i = 0; i < groups.length; i++) {
        keys.push({
          name: i,
          prefix: null,
          delimiter: null,
          optional: false,
          repeat: false,
          partial: false,
          asterisk: false,
          pattern: null
        });
      }
    }

    return attachKeys(path, keys);
  }
  /**
   * Transform an array into a regexp.
   *
   * @param  {!Array}  path
   * @param  {Array}   keys
   * @param  {!Object} options
   * @return {!RegExp}
   */


  function arrayToRegexp(path, keys, options) {
    var parts = [];

    for (var i = 0; i < path.length; i++) {
      parts.push(pathToRegexp(path[i], keys, options).source);
    }

    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
  }
  /**
   * Create a path regexp from string input.
   *
   * @param  {string}  path
   * @param  {!Array}  keys
   * @param  {!Object} options
   * @return {!RegExp}
   */


  function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
  }
  /**
   * Expose a function for taking tokens and returning a RegExp.
   *
   * @param  {!Array}          tokens
   * @param  {(Array|Object)=} keys
   * @param  {Object=}         options
   * @return {!RegExp}
   */


  function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
      options =
      /** @type {!Object} */
      keys || options;
      keys = [];
    }

    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = ''; // Iterate over the tokens and create our regexp string.

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        route += escapeString(token);
      } else {
        var prefix = escapeString(token.prefix);
        var capture = '(?:' + token.pattern + ')';
        keys.push(token);

        if (token.repeat) {
          capture += '(?:' + prefix + capture + ')*';
        }

        if (token.optional) {
          if (!token.partial) {
            capture = '(?:' + prefix + '(' + capture + '))?';
          } else {
            capture = prefix + '(' + capture + ')?';
          }
        } else {
          capture = prefix + '(' + capture + ')';
        }

        route += capture;
      }
    }

    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter; // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".

    if (!strict) {
      route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    }

    if (end) {
      route += '$';
    } else {
      // In non-ending mode, we need the capturing groups to match as much as
      // possible by using a positive lookahead to the end or next path segment.
      route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    }

    return attachKeys(new RegExp('^' + route, flags(options)), keys);
  }
  /**
   * Normalize the given path string, returning a regular expression.
   *
   * An empty array can be passed in for the keys, which will hold the
   * placeholder key descriptions. For example, using `/user/:id`, `keys` will
   * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
   *
   * @param  {(string|RegExp|Array)} path
   * @param  {(Array|Object)=}       keys
   * @param  {Object=}               options
   * @return {!RegExp}
   */


  function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
      options =
      /** @type {!Object} */
      keys || options;
      keys = [];
    }

    options = options || {};

    if (path instanceof RegExp) {
      return regexpToRegexp(path,
      /** @type {!Array} */
      keys);
    }

    if (isarray(path)) {
      return arrayToRegexp(
      /** @type {!Array} */
      path,
      /** @type {!Array} */
      keys, options);
    }

    return stringToRegexp(
    /** @type {string} */
    path,
    /** @type {!Array} */
    keys, options);
  }
  /***/

},
/* 428 */

/***/
function (module, exports) {
  module.exports = Array.isArray || function (arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
  };
  /***/

},
/* 429 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(430); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a"
  /* default */
  ];
  /***/
},
/* 430 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for prompting the user before navigating away
   * from a screen with a component.
   */


  var Prompt = function (_React$Component) {
    _inherits(Prompt, _React$Component);

    function Prompt() {
      _classCallCheck(this, Prompt);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Prompt.prototype.enable = function enable(message) {
      if (this.unblock) this.unblock();
      this.unblock = this.context.router.history.block(message);
    };

    Prompt.prototype.disable = function disable() {
      if (this.unblock) {
        this.unblock();
        this.unblock = null;
      }
    };

    Prompt.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

      if (this.props.when) this.enable(this.props.message);
    };

    Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (nextProps.when) {
        if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
      } else {
        this.disable();
      }
    };

    Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
      this.disable();
    };

    Prompt.prototype.render = function render() {
      return null;
    };

    return Prompt;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  Prompt.propTypes = {
    when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
  };
  Prompt.defaultProps = {
    when: true
  };
  Prompt.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
      }).isRequired
    }).isRequired
  };
  /* harmony default export */

  __webpack_exports__["a"] = Prompt;
  /***/
},
/* 431 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(432); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a"
  /* default */
  ];
  /***/
},
/* 432 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(433);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for updating the location programmatically
   * with a component.
   */


  var Redirect = function (_React$Component) {
    _inherits(Redirect, _React$Component);

    function Redirect() {
      _classCallCheck(this, Redirect);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Redirect.prototype.isStatic = function isStatic() {
      return this.context.router && this.context.router.staticContext;
    };

    Redirect.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

      if (this.isStatic()) this.perform();
    };

    Redirect.prototype.componentDidMount = function componentDidMount() {
      if (!this.isStatic()) this.perform();
    };

    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a"
      /* createLocation */
      ])(prevProps.to);
      var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a"
      /* createLocation */
      ])(this.props.to);

      if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b"
      /* locationsAreEqual */
      ])(prevTo, nextTo)) {
        __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));

        return;
      }

      this.perform();
    };

    Redirect.prototype.perform = function perform() {
      var history = this.context.router.history;
      var _props = this.props,
          push = _props.push,
          to = _props.to;

      if (push) {
        history.push(to);
      } else {
        history.replace(to);
      }
    };

    Redirect.prototype.render = function render() {
      return null;
    };

    return Redirect;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  Redirect.propTypes = {
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
  };
  Redirect.defaultProps = {
    push: false
  };
  Redirect.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
      }).isRequired,
      staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    }).isRequired
  };
  /* harmony default export */

  __webpack_exports__["a"] = Redirect;
  /***/
},
/* 433 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(434);
  /* unused harmony reexport createBrowserHistory */

  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(435);
  /* unused harmony reexport createHashHistory */

  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(436);
  /* unused harmony reexport createMemoryHistory */

  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(88);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(67);
  /* unused harmony reexport parsePath */

  /* unused harmony reexport createPath */

  /***/

},
/* 434 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(88);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(67);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(125);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(170);

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var PopStateEvent = 'popstate';
  var HashChangeEvent = 'hashchange';

  var getHistoryState = function getHistoryState() {
    try {
      return window.history.state || {};
    } catch (e) {
      // IE 11 sometimes throws when accessing window.history.state
      // See https://github.com/ReactTraining/history/pull/289
      return {};
    }
  };
  /**
   * Creates a history object that uses the HTML5 history API including
   * pushState, replaceState, and the popstate event.
   */


  var createBrowserHistory = function createBrowserHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b"
    /* canUseDOM */
    ], 'Browser history needs a DOM');

    var globalHistory = window.history;
    var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g"
    /* supportsHistory */
    ])();
    var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h"
    /* supportsPopStateOnHashChange */
    ])();
    var _props$forceRefresh = props.forceRefresh,
        forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
        _props$getUserConfirm = props.getUserConfirmation,
        getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c"
    /* getConfirmation */
    ] : _props$getUserConfirm,
        _props$keyLength = props.keyLength,
        keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g"
    /* stripTrailingSlash */
    ])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a"
    /* addLeadingSlash */
    ])(props.basename)) : '';

    var getDOMLocation = function getDOMLocation(historyState) {
      var _ref = historyState || {},
          key = _ref.key,
          state = _ref.state;

      var _window$location = window.location,
          pathname = _window$location.pathname,
          search = _window$location.search,
          hash = _window$location.hash;
      var path = pathname + search + hash;

      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c"
      /* hasBasename */
      ])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

      if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e"
      /* stripBasename */
      ])(path, basename);
      return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, state, key);
    };

    var createKey = function createKey() {
      return Math.random().toString(36).substr(2, keyLength);
    };

    var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a"
    /* default */
    ])();

    var setState = function setState(nextState) {
      _extends(history, nextState);

      history.length = globalHistory.length;
      transitionManager.notifyListeners(history.location, history.action);
    };

    var handlePopState = function handlePopState(event) {
      // Ignore extraneous popstate events in WebKit.
      if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d"
      /* isExtraneousPopstateEvent */
      ])(event)) return;
      handlePop(getDOMLocation(event.state));
    };

    var handleHashChange = function handleHashChange() {
      handlePop(getDOMLocation(getHistoryState()));
    };

    var forceNextPop = false;

    var handlePop = function handlePop(location) {
      if (forceNextPop) {
        forceNextPop = false;
        setState();
      } else {
        var action = 'POP';
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
          if (ok) {
            setState({
              action: action,
              location: location
            });
          } else {
            revertPop(location);
          }
        });
      }
    };

    var revertPop = function revertPop(fromLocation) {
      var toLocation = history.location; // TODO: We could probably make this more reliable by
      // keeping a list of keys we've seen in sessionStorage.
      // Instead, we just default to 0 for keys we don't know.

      var toIndex = allKeys.indexOf(toLocation.key);
      if (toIndex === -1) toIndex = 0;
      var fromIndex = allKeys.indexOf(fromLocation.key);
      if (fromIndex === -1) fromIndex = 0;
      var delta = toIndex - fromIndex;

      if (delta) {
        forceNextPop = true;
        go(delta);
      }
    };

    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [initialLocation.key]; // Public interface

    var createHref = function createHref(location) {
      return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
      /* createPath */
      ])(location);
    };

    var push = function push(path, state) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

      var action = 'PUSH';
      var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var href = createHref(location);
        var key = location.key,
            state = location.state;

        if (canUseHistory) {
          globalHistory.pushState({
            key: key,
            state: state
          }, null, href);

          if (forceRefresh) {
            window.location.href = href;
          } else {
            var prevIndex = allKeys.indexOf(history.location.key);
            var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
            nextKeys.push(location.key);
            allKeys = nextKeys;
            setState({
              action: action,
              location: location
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

          window.location.href = href;
        }
      });
    };

    var replace = function replace(path, state) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

      var action = 'REPLACE';
      var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var href = createHref(location);
        var key = location.key,
            state = location.state;

        if (canUseHistory) {
          globalHistory.replaceState({
            key: key,
            state: state
          }, null, href);

          if (forceRefresh) {
            window.location.replace(href);
          } else {
            var prevIndex = allKeys.indexOf(history.location.key);
            if (prevIndex !== -1) allKeys[prevIndex] = location.key;
            setState({
              action: action,
              location: location
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

          window.location.replace(href);
        }
      });
    };

    var go = function go(n) {
      globalHistory.go(n);
    };

    var goBack = function goBack() {
      return go(-1);
    };

    var goForward = function goForward() {
      return go(1);
    };

    var listenerCount = 0;

    var checkDOMListeners = function checkDOMListeners(delta) {
      listenerCount += delta;

      if (listenerCount === 1) {
        Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a"
        /* addEventListener */
        ])(window, PopStateEvent, handlePopState);
        if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a"
        /* addEventListener */
        ])(window, HashChangeEvent, handleHashChange);
      } else if (listenerCount === 0) {
        Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e"
        /* removeEventListener */
        ])(window, PopStateEvent, handlePopState);
        if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e"
        /* removeEventListener */
        ])(window, HashChangeEvent, handleHashChange);
      }
    };

    var isBlocked = false;

    var block = function block() {
      var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var unblock = transitionManager.setPrompt(prompt);

      if (!isBlocked) {
        checkDOMListeners(1);
        isBlocked = true;
      }

      return function () {
        if (isBlocked) {
          isBlocked = false;
          checkDOMListeners(-1);
        }

        return unblock();
      };
    };

    var listen = function listen(listener) {
      var unlisten = transitionManager.appendListener(listener);
      checkDOMListeners(1);
      return function () {
        checkDOMListeners(-1);
        unlisten();
      };
    };

    var history = {
      length: globalHistory.length,
      action: 'POP',
      location: initialLocation,
      createHref: createHref,
      push: push,
      replace: replace,
      go: go,
      goBack: goBack,
      goForward: goForward,
      block: block,
      listen: listen
    };
    return history;
  };
  /* unused harmony default export */


  var _unused_webpack_default_export = createBrowserHistory;
  /***/
},
/* 435 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(88);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(67);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(125);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(170);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var HashChangeEvent = 'hashchange';
  var HashPathCoders = {
    hashbang: {
      encodePath: function encodePath(path) {
        return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f"
        /* stripLeadingSlash */
        ])(path);
      },
      decodePath: function decodePath(path) {
        return path.charAt(0) === '!' ? path.substr(1) : path;
      }
    },
    noslash: {
      encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f"
      /* stripLeadingSlash */
      ],
      decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a"
      /* addLeadingSlash */
      ]
    },
    slash: {
      encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a"
      /* addLeadingSlash */
      ],
      decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a"
      /* addLeadingSlash */
      ]
    }
  };

  var getHashPath = function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
  };

  var pushHashPath = function pushHashPath(path) {
    return window.location.hash = path;
  };

  var replaceHashPath = function replaceHashPath(path) {
    var hashIndex = window.location.href.indexOf('#');
    window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
  };

  var createHashHistory = function createHashHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b"
    /* canUseDOM */
    ], 'Hash history needs a DOM');

    var globalHistory = window.history;
    var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f"
    /* supportsGoWithoutReloadUsingHash */
    ])();
    var _props$getUserConfirm = props.getUserConfirmation,
        getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c"
    /* getConfirmation */
    ] : _props$getUserConfirm,
        _props$hashType = props.hashType,
        hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
    var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g"
    /* stripTrailingSlash */
    ])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a"
    /* addLeadingSlash */
    ])(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType],
        encodePath = _HashPathCoders$hashT.encodePath,
        decodePath = _HashPathCoders$hashT.decodePath;

    var getDOMLocation = function getDOMLocation() {
      var path = decodePath(getHashPath());

      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c"
      /* hasBasename */
      ])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

      if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e"
      /* stripBasename */
      ])(path, basename);
      return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path);
    };

    var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a"
    /* default */
    ])();

    var setState = function setState(nextState) {
      _extends(history, nextState);

      history.length = globalHistory.length;
      transitionManager.notifyListeners(history.location, history.action);
    };

    var forceNextPop = false;
    var ignorePath = null;

    var handleHashChange = function handleHashChange() {
      var path = getHashPath();
      var encodedPath = encodePath(path);

      if (path !== encodedPath) {
        // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
      } else {
        var location = getDOMLocation();
        var prevLocation = history.location;
        if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b"
        /* locationsAreEqual */
        ])(prevLocation, location)) return; // A hashchange doesn't always == location change.

        if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
        /* createPath */
        ])(location)) return; // Ignore this change; we already setState in push/replace.

        ignorePath = null;
        handlePop(location);
      }
    };

    var handlePop = function handlePop(location) {
      if (forceNextPop) {
        forceNextPop = false;
        setState();
      } else {
        var action = 'POP';
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
          if (ok) {
            setState({
              action: action,
              location: location
            });
          } else {
            revertPop(location);
          }
        });
      }
    };

    var revertPop = function revertPop(fromLocation) {
      var toLocation = history.location; // TODO: We could probably make this more reliable by
      // keeping a list of paths we've seen in sessionStorage.
      // Instead, we just default to 0 for paths we don't know.

      var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
      /* createPath */
      ])(toLocation));
      if (toIndex === -1) toIndex = 0;
      var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
      /* createPath */
      ])(fromLocation));
      if (fromIndex === -1) fromIndex = 0;
      var delta = toIndex - fromIndex;

      if (delta) {
        forceNextPop = true;
        go(delta);
      }
    }; // Ensure the hash is encoded properly before doing anything else.


    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
    /* createPath */
    ])(initialLocation)]; // Public interface

    var createHref = function createHref(location) {
      return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
      /* createPath */
      ])(location));
    };

    var push = function push(path, state) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

      var action = 'PUSH';
      var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, undefined, undefined, history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
        /* createPath */
        ])(location);
        var encodedPath = encodePath(basename + path);
        var hashChanged = getHashPath() !== encodedPath;

        if (hashChanged) {
          // We cannot tell if a hashchange was caused by a PUSH, so we'd
          // rather setState here and ignore the hashchange. The caveat here
          // is that other hash histories in the page will consider it a POP.
          ignorePath = path;
          pushHashPath(encodedPath);
          var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
          /* createPath */
          ])(history.location));
          var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextPaths.push(path);
          allPaths = nextPaths;
          setState({
            action: action,
            location: location
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

          setState();
        }
      });
    };

    var replace = function replace(path, state) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

      var action = 'REPLACE';
      var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, undefined, undefined, history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
        /* createPath */
        ])(location);
        var encodedPath = encodePath(basename + path);
        var hashChanged = getHashPath() !== encodedPath;

        if (hashChanged) {
          // We cannot tell if a hashchange was caused by a REPLACE, so we'd
          // rather setState here and ignore the hashchange. The caveat here
          // is that other hash histories in the page will consider it a POP.
          ignorePath = path;
          replaceHashPath(encodedPath);
        }

        var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b"
        /* createPath */
        ])(history.location));
        if (prevIndex !== -1) allPaths[prevIndex] = path;
        setState({
          action: action,
          location: location
        });
      });
    };

    var go = function go(n) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

      globalHistory.go(n);
    };

    var goBack = function goBack() {
      return go(-1);
    };

    var goForward = function goForward() {
      return go(1);
    };

    var listenerCount = 0;

    var checkDOMListeners = function checkDOMListeners(delta) {
      listenerCount += delta;

      if (listenerCount === 1) {
        Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a"
        /* addEventListener */
        ])(window, HashChangeEvent, handleHashChange);
      } else if (listenerCount === 0) {
        Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e"
        /* removeEventListener */
        ])(window, HashChangeEvent, handleHashChange);
      }
    };

    var isBlocked = false;

    var block = function block() {
      var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var unblock = transitionManager.setPrompt(prompt);

      if (!isBlocked) {
        checkDOMListeners(1);
        isBlocked = true;
      }

      return function () {
        if (isBlocked) {
          isBlocked = false;
          checkDOMListeners(-1);
        }

        return unblock();
      };
    };

    var listen = function listen(listener) {
      var unlisten = transitionManager.appendListener(listener);
      checkDOMListeners(1);
      return function () {
        checkDOMListeners(-1);
        unlisten();
      };
    };

    var history = {
      length: globalHistory.length,
      action: 'POP',
      location: initialLocation,
      createHref: createHref,
      push: push,
      replace: replace,
      go: go,
      goBack: goBack,
      goForward: goForward,
      block: block,
      listen: listen
    };
    return history;
  };
  /* unused harmony default export */


  var _unused_webpack_default_export = createHashHistory;
  /***/
},
/* 436 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(67);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(88);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(125);

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var clamp = function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
  };
  /**
   * Creates a history object that stores locations in memory.
   */


  var createMemoryHistory = function createMemoryHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var getUserConfirmation = props.getUserConfirmation,
        _props$initialEntries = props.initialEntries,
        initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
        _props$initialIndex = props.initialIndex,
        initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
        _props$keyLength = props.keyLength,
        keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a"
    /* default */
    ])();

    var setState = function setState(nextState) {
      _extends(history, nextState);

      history.length = history.entries.length;
      transitionManager.notifyListeners(history.location, history.action);
    };

    var createKey = function createKey() {
      return Math.random().toString(36).substr(2, keyLength);
    };

    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function (entry) {
      return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(entry, undefined, entry.key || createKey());
    }); // Public interface

    var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b"
    /* createPath */
    ];

    var push = function push(path, state) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

      var action = 'PUSH';
      var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        var prevIndex = history.index;
        var nextIndex = prevIndex + 1;
        var nextEntries = history.entries.slice(0);

        if (nextEntries.length > nextIndex) {
          nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
        } else {
          nextEntries.push(location);
        }

        setState({
          action: action,
          location: location,
          index: nextIndex,
          entries: nextEntries
        });
      });
    };

    var replace = function replace(path, state) {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

      var action = 'REPLACE';
      var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a"
      /* createLocation */
      ])(path, state, createKey(), history.location);
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (!ok) return;
        history.entries[history.index] = location;
        setState({
          action: action,
          location: location
        });
      });
    };

    var go = function go(n) {
      var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
      var action = 'POP';
      var location = history.entries[nextIndex];
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location,
            index: nextIndex
          });
        } else {
          // Mimic the behavior of DOM histories by
          // causing a render after a cancelled POP.
          setState();
        }
      });
    };

    var goBack = function goBack() {
      return go(-1);
    };

    var goForward = function goForward() {
      return go(1);
    };

    var canGo = function canGo(n) {
      var nextIndex = history.index + n;
      return nextIndex >= 0 && nextIndex < history.entries.length;
    };

    var block = function block() {
      var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return transitionManager.setPrompt(prompt);
    };

    var listen = function listen(listener) {
      return transitionManager.appendListener(listener);
    };

    var history = {
      length: entries.length,
      action: 'POP',
      location: entries[index],
      index: index,
      entries: entries,
      createHref: createHref,
      push: push,
      replace: replace,
      go: go,
      goBack: goBack,
      goForward: goForward,
      canGo: canGo,
      block: block,
      listen: listen
    };
    return history;
  };
  /* unused harmony default export */


  var _unused_webpack_default_export = createMemoryHistory;
  /***/
},
/* 437 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(438); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a"
  /* default */
  ];
  /***/
},
/* 438 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(66);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(123);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var normalizeLocation = function normalizeLocation(object) {
    var _object$pathname = object.pathname,
        pathname = _object$pathname === undefined ? '/' : _object$pathname,
        _object$search = object.search,
        search = _object$search === undefined ? '' : _object$search,
        _object$hash = object.hash,
        hash = _object$hash === undefined ? '' : _object$hash;
    return {
      pathname: pathname,
      search: search === '?' ? '' : search,
      hash: hash === '#' ? '' : hash
    };
  };

  var addBasename = function addBasename(basename, location) {
    if (!basename) return location;
    return _extends({}, location, {
      pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
    });
  };

  var stripBasename = function stripBasename(basename, location) {
    if (!basename) return location;
    var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return _extends({}, location, {
      pathname: location.pathname.substr(base.length)
    });
  };

  var createLocation = function createLocation(location) {
    return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
  };

  var createURL = function createURL(location) {
    return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
  };

  var staticHandler = function staticHandler(methodName) {
    return function () {
      __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
    };
  };

  var noop = function noop() {};
  /**
   * The public top-level API for a "static" <Router>, so-called because it
   * can't actually change the current location. Instead, it just records
   * location changes in a context object. Useful mainly in testing and
   * server-rendering scenarios.
   */


  var StaticRouter = function (_React$Component) {
    _inherits(StaticRouter, _React$Component);

    function StaticRouter() {
      var _temp, _this, _ret;

      _classCallCheck(this, StaticRouter);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
      }, _this.handlePush = function (location) {
        var _this$props = _this.props,
            basename = _this$props.basename,
            context = _this$props.context;
        context.action = 'PUSH';
        context.location = addBasename(basename, createLocation(location));
        context.url = createURL(context.location);
      }, _this.handleReplace = function (location) {
        var _this$props2 = _this.props,
            basename = _this$props2.basename,
            context = _this$props2.context;
        context.action = 'REPLACE';
        context.location = addBasename(basename, createLocation(location));
        context.url = createURL(context.location);
      }, _this.handleListen = function () {
        return noop;
      }, _this.handleBlock = function () {
        return noop;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    StaticRouter.prototype.getChildContext = function getChildContext() {
      return {
        router: {
          staticContext: this.props.context
        }
      };
    };

    StaticRouter.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
    };

    StaticRouter.prototype.render = function render() {
      var _props = this.props,
          basename = _props.basename,
          context = _props.context,
          location = _props.location,
          props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

      var history = {
        createHref: this.createHref,
        action: 'POP',
        location: stripBasename(basename, createLocation(location)),
        push: this.handlePush,
        replace: this.handleReplace,
        go: staticHandler('go'),
        goBack: staticHandler('goBack'),
        goForward: staticHandler('goForward'),
        listen: this.handleListen,
        block: this.handleBlock
      };
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a"
      /* default */
      ], _extends({}, props, {
        history: history
      }));
    };

    return StaticRouter;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  StaticRouter.propTypes = {
    basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
  };
  StaticRouter.defaultProps = {
    basename: '',
    location: '/'
  };
  StaticRouter.childContextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
  };
  /* harmony default export */

  __webpack_exports__["a"] = StaticRouter;
  /***/
},
/* 439 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(440); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a"
  /* default */
  ];
  /***/
},
/* 440 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(124);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The public API for rendering the first <Route> that matches.
   */


  var Switch = function (_React$Component) {
    _inherits(Switch, _React$Component);

    function Switch() {
      _classCallCheck(this, Switch);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Switch.prototype.componentWillMount = function componentWillMount() {
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
    };

    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

      __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };

    Switch.prototype.render = function render() {
      var route = this.context.router.route;
      var children = this.props.children;
      var location = this.props.location || route.location;
      var match = void 0,
          child = void 0;

      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;
        var path = pathProp || from;

        if (match == null) {
          child = element;
          match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a"
          /* default */
          ])(location.pathname, {
            path: path,
            exact: exact,
            strict: strict,
            sensitive: sensitive
          }) : route.match;
        }
      });

      return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
        location: location,
        computedMatch: match
      }) : null;
    };

    return Switch;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  Switch.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
    }).isRequired
  };
  Switch.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };
  /* harmony default export */

  __webpack_exports__["a"] = Switch;
  /***/
},
/* 441 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(124); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a"
  /* default */
  ];
  /***/
},
/* 442 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(443); // Written in this round about way for babel-transform-imports

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a"
  /* default */
  ];
  /***/
},
/* 443 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(444);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(169);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }
  /**
   * A public higher-order component to access the imperative API
   */


  var withRouter = function withRouter(Component) {
    var C = function C(props) {
      var wrappedComponentRef = props.wrappedComponentRef,
          remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a"
      /* default */
      ], {
        render: function render(routeComponentProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
            ref: wrappedComponentRef
          }));
        }
      });
    };

    C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
    C.WrappedComponent = Component;
    C.propTypes = {
      wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
  };
  /* harmony default export */


  __webpack_exports__["a"] = withRouter;
  /***/
},
/* 444 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */
  (function (global, factory) {
    true ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.hoistNonReactStatics = factory();
  })(this, function () {
    'use strict';

    var REACT_STATICS = {
      childContextTypes: true,
      contextTypes: true,
      defaultProps: true,
      displayName: true,
      getDefaultProps: true,
      getDerivedStateFromProps: true,
      mixins: true,
      propTypes: true,
      type: true
    };
    var KNOWN_STATICS = {
      name: true,
      length: true,
      prototype: true,
      caller: true,
      callee: true,
      arguments: true,
      arity: true
    };
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
          var inheritedComponent = getPrototypeOf(sourceComponent);

          if (inheritedComponent && inheritedComponent !== objectPrototype) {
            hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
          }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
          keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
          var key = keys[i];

          if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
            var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

            try {
              // Avoid failures from read-only properties
              defineProperty(targetComponent, key, descriptor);
            } catch (e) {}
          }
        }

        return targetComponent;
      }

      return targetComponent;
    };
  });
  /***/

},
/* 445 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(446);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Links.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Links.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 446 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-cta {\n  text-align: center;\n  display: inline-block;\n  color: #000000;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding: 15px 40px;\n  border-radius: 40px;\n  max-width: 240px;\n  line-height: 16px;\n  font-size: 14px;\n  text-transform: uppercase;\n  position: relative;\n  cursor: pointer;\n  transition: background-color .1s linear; }\n  .gr-cta:hover, .gr-cta:focus {\n    text-decoration: none; }\n    .gr-cta:hover .gr-cta__text::before, .gr-cta:focus .gr-cta__text::before {\n      right: -25px;\n      opacity: 1; }\n  @media all and (min-width: 768px) {\n    .gr-cta {\n      margin-bottom: 25px;\n      margin-top: 25px;\n      max-width: 280px;\n      font-size: 16px;\n      line-height: 18px; } }\n  .gr-cta__text {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    line-height: initial; }\n    .gr-cta__text::before {\n      content: '\\E907';\n      font-family: \"grainger-icons\";\n      position: absolute;\n      font-size: 20px;\n      color: #FFFFFF;\n      top: 50%;\n      transform: translateY(-50%);\n      right: -15px;\n      opacity: 0;\n      transition: right .1s linear, opacity .1s linear; }\n    .gr-cta__text--hide-arrow::before {\n      display: none; }\n  .gr-cta--icon {\n    display: inline-flex;\n    align-items: start;\n    justify-content: center; }\n  .gr-cta__icon {\n    margin-left: 10px; }\n    .gr-cta__icon.icon-external-link:before {\n      color: #FFFFFF; }\n", ""]); // exports

  /***/
},
/* 447 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(448);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Amenities.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Amenities.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 448 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-amenities {\n  margin: 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-amenities {\n      margin: 50px 0 30px; } }\n  @media all and (min-width: 768px) {\n    .gr-amenities__container {\n      max-width: 1920px;\n      margin: 0 auto;\n      padding: 0 15px; } }\n  .gr-amenities__title {\n    text-transform: uppercase;\n    color: #000000;\n    text-align: center;\n    font-size: 30px;\n    margin-bottom: 30px;\n    padding: 0 15px;\n    line-height: 30px; }\n    @media all and (min-width: 768px) {\n      .gr-amenities__title {\n        padding: 0; } }\n  .gr-amenities__content {\n    max-width: 1920px;\n    color: #FFFFFF;\n    margin: 0 auto 25px;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-amenities__content {\n        background-color: transparent;\n        margin-bottom: 35px; } }\n  .gr-amenities__amenities {\n    background-color: #979797;\n    padding: 0;\n    list-style: none; }\n    @media all and (min-width: 768px) {\n      .gr-amenities__amenities {\n        max-width: 840px;\n        margin: 0 auto; } }\n    @media all and (min-width: 992px) {\n      .gr-amenities__amenities {\n        max-width: none; }\n        .gr-amenities__amenities.no-gutters {\n          margin: 0 auto; } }\n  .gr-amenities__extra {\n    font-size: 18px;\n    padding: 0 15px; }\n    @media all and (min-width: 768px) {\n      .gr-amenities__extra {\n        max-width: 60%;\n        margin: 0 auto;\n        text-align: center; } }\n  .gr-amenities__more {\n    color: #979797; }\n  .gr-amenities__and-more {\n    font-size: 20px;\n    text-align: center;\n    text-transform: uppercase;\n    display: block;\n    margin-bottom: 10px; }\n  .gr-amenities__button {\n    text-align: center;\n    margin-top: -20px; }\n  .gr-amenities__leaf--container {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-amenities__leaf--container {\n        display: block;\n        position: absolute;\n        z-index: -1;\n        left: -10px;\n        transform: scaleX(-1) rotate(5deg); } }\n  @media all and (min-width: 992px) {\n    .gr-amenities .zoom-1 {\n      zoom: 1;\n      max-width: none; }\n    .gr-amenities .zoom-2 {\n      zoom: 1.1;\n      max-width: 80%; }\n    .gr-amenities .zoom-3 {\n      zoom: 1.2;\n      max-width: 70%; }\n    .gr-amenities .zoom-4 {\n      zoom: 1.3;\n      max-width: 60%; } }\n", ""]); // exports

  /***/
},
/* 449 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BasicContent = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(450);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BasicContent = exports.BasicContent = function BasicContent(_ref) {
    var title = _ref.title,
        content = _ref.content;
    return _react2.default.createElement('div', {
      className: 'gr-basic-content'
    }, _react2.default.createElement('div', {
      className: 'container'
    }, title && _react2.default.createElement('h1', {
      className: 'gr-basic-content__title'
    }, title), content && _react2.default.createElement('div', {
      className: 'gr-basic-content__copy',
      dangerouslySetInnerHTML: {
        __html: content
      }
    })));
  };

  BasicContent.propTypes = {
    title: _propTypes2.default.string,
    content: _propTypes2.default.string
  };
  BasicContent.defaultProps = {
    title: null,
    content: null
  };
  exports.default = BasicContent;
  /***/
},
/* 450 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(451);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./BasicContent.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./BasicContent.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 451 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-basic-content {\n  padding-top: 40px;\n  padding-bottom: 40px; }\n  @media all and (min-width: 992px) {\n    .gr-basic-content {\n      padding: 60px 20px 50px; } }\n  .gr-basic-content a {\n    color: #4E8382;\n    text-decoration: underline; }\n    .gr-basic-content a:hover, .gr-basic-content a:focus {\n      text-decoration: none; }\n  .gr-basic-content__title {\n    text-transform: uppercase;\n    color: #4E8382;\n    font-size: 40px;\n    line-height: 50px;\n    margin-bottom: 25px; }\n    @media all and (min-width: 768px) {\n      .gr-basic-content__title {\n        font-size: 48px;\n        line-height: 55px;\n        margin-bottom: 30px; } }\n", ""]); // exports

  /***/
},
/* 452 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BrandProperties = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactAnimateOnScroll = __webpack_require__(86);

  var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);

  var _List = __webpack_require__(61);

  var _generic = __webpack_require__(10);

  __webpack_require__(453);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BrandProperties = exports.BrandProperties = function BrandProperties(_ref) {
    var properties = _ref.properties,
        title = _ref.title;
    return _react2.default.createElement('div', {
      className: 'gr-brand-properties'
    }, _react2.default.createElement('div', {
      className: 'gr-brand-properties__container'
    }, title && _react2.default.createElement(_reactAnimateOnScroll2.default, {
      animateOnce: true,
      animateIn: 'fadeInUp',
      animationInDelay: '3000'
    }, _react2.default.createElement('h2', {
      className: 'gr-brand-properties__heading'
    }, title)), _react2.default.createElement(_List.List, {
      isUnstyled: true,
      className: 'gr-brand-properties__list'
    }, properties && properties.map(function (item, idx) {
      return _react2.default.createElement('li', {
        className: 'col-12 gr-brand-properties__item',
        key: (0, _generic.randomStr)(item.title)
      }, item.title && _react2.default.createElement(_reactAnimateOnScroll2.default, {
        animateOnce: true,
        animateIn: 'fadeInUp',
        animationInDelay: (idx + 1) * 500
      }, _react2.default.createElement('h3', {
        className: 'gr-brand-properties__title no-gutters'
      }, _react2.default.createElement('span', {
        className: 'gr-brand-properties__title-number col-2'
      }, idx + 1), _react2.default.createElement('span', {
        className: 'gr-brand-properties__title-words col-10'
      }, item.title))), _react2.default.createElement(_reactAnimateOnScroll2.default, {
        animateOnce: true,
        animateIn: 'fadeInUp',
        animationInDelay: (idx + 1) * 500
      }, item.description && _react2.default.createElement('div', {
        className: 'gr-brand-properties__text col-10 offset-2',
        dangerouslySetInnerHTML: {
          __html: item.description
        }
      })));
    }))));
  };

  BrandProperties.propTypes = {
    properties: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      title: _propTypes2.default.string,
      description: _propTypes2.default.string
    })),
    title: _propTypes2.default.string
  };
  BrandProperties.defaultProps = {
    properties: null,
    title: null
  };
  exports.default = BrandProperties;
  /***/
},
/* 453 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(454);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./BrandProperties.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./BrandProperties.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 454 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-brand-properties {\n  max-width: 1920px;\n  margin: 30px 0;\n  overflow: hidden;\n  padding: 50px 0 20px;\n  background-color: #63666A; }\n  @media all and (min-width: 768px) {\n    .gr-brand-properties {\n      padding-bottom: 0;\n      margin: 40px auto; } }\n  @media all and (min-width: 992px) {\n    .gr-brand-properties {\n      margin: 50px auto; } }\n  .gr-brand-properties__container {\n    max-width: 1200px;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-brand-properties__container {\n        padding: 0 15px 30px; } }\n  .gr-brand-properties__list {\n    padding: 0 5% 0 2%; }\n  .gr-brand-properties__heading {\n    text-align: center;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    line-height: 32px;\n    font-size: 30px;\n    margin-bottom: 30px; }\n    @media all and (min-width: 768px) {\n      .gr-brand-properties__heading {\n        margin-bottom: 45px;\n        font-size: 38px;\n        line-height: 40px; } }\n  .gr-brand-properties__item {\n    color: #FFFFFF;\n    max-width: 40%; }\n    @media all and (min-width: 576px) {\n      .gr-brand-properties__item:nth-child(odd) {\n        padding-right: 55% !important; } }\n    @media all and (min-width: 576px) {\n      .gr-brand-properties__item:nth-child(even) {\n        padding-left: 55% !important; } }\n  .gr-brand-properties__title {\n    margin: 0;\n    font-size: 20px;\n    text-transform: uppercase;\n    color: #FFFFFF;\n    font-weight: lighter; }\n    .gr-brand-properties__title-words {\n      display: inline-block; }\n    .gr-brand-properties__title-number {\n      display: inline-block;\n      font-size: 70px;\n      line-height: 65px; }\n  .gr-brand-properties__text {\n    font-size: 16px;\n    line-height: 20px;\n    border-top: 1px solid white;\n    padding: 0 !important; }\n\n@media all and (max-width: 576px) {\n  .fadeInUp {\n    transition-property: none !important;\n    transform: none !important;\n    animation: none !important;\n    -o-transition-property: none !important;\n    -moz-transition-property: none !important;\n    -ms-transition-property: none !important;\n    -webkit-transition-property: none !important;\n    /*CSS transforms*/\n    -o-transform: none !important;\n    -moz-transform: none !important;\n    -ms-transform: none !important;\n    -webkit-transform: none !important;\n    /*CSS animations*/\n    -webkit-animation: none !important;\n    -moz-animation: none !important;\n    -o-animation: none !important;\n    -ms-animation: none !important;\n    overflow: hidden; }\n    .fadeInUp__initial, .fadeInUp__active {\n      visibility: visible !important;\n      animation-duration: 0ms !important;\n      overflow: hidden; } }\n", ""]); // exports

  /***/
},
/* 455 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Commute = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  __webpack_require__(456);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The Commute component takes a list of destinations and a list of methods and the times it takes to get between them
   * and will display the sum of those.
   */


  var Commute = exports.Commute = function (_Component) {
    _inherits(Commute, _Component);

    function Commute(props) {
      _classCallCheck(this, Commute);

      var _this = _possibleConstructorReturn(this, (Commute.__proto__ || Object.getPrototypeOf(Commute)).call(this, props));

      _this.initialCall = true;
      var initialDestination = _this.props.initialDestination || Object.keys(_this.props.destinations)[0];
      var initialMethod = _this.props.initialMethod ? _this.props.destinations[initialDestination].filter(function (item) {
        return item.label === _this.props.initialMethod;
      })[0] : _this.findNextAvailableMethodOfTransport(initialDestination);
      _this.state = {
        destination: initialDestination,
        method: {
          commuteTime: initialMethod.value,
          type: initialMethod.label
        }
      };
      _this.updateCommute = _this.updateCommute.bind(_this);
      _this.updateDestination = _this.updateDestination.bind(_this);
      _this.findNextAvailableMethodOfTransport = _this.findNextAvailableMethodOfTransport.bind(_this);
      return _this;
    }
    /**
     * Will return the next available method by cycling through the transport options of displays the first that is not
     * 'n/a'.
     * If it is the initial call, it will just select the first, given method.
     *
     * @param {string} the destination that the method needs to look up methods of transport for.
     * @public
     */


    _createClass(Commute, [{
      key: 'findNextAvailableMethodOfTransport',
      value: function findNextAvailableMethodOfTransport() {
        var destination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.destination;

        for (var i = 0; i < this.props.destinations[destination].length; i++) {
          if ((0, _generic.isPositiveNumber)(this.props.destinations[destination][i].value)) {
            if (!this.initialCall) {
              this.setState({
                destination: destination,
                method: {
                  commuteTime: this.props.destinations[destination][i].value,
                  type: this.props.destinations[destination][i].label
                }
              });
            }

            this.initialCall = false;
            return this.props.destinations[destination][i];
          }
        }

        throw new Error('No destinations are able to be displayed');
      }
      /**
       * Updates the destination. Gets the time of the newly selected destination based on the existing method.
       * If that new value is not positive number, it will find the next available method so that we can provide a time.
       *
       * @param {object} event from the select box
       * @public
       */

    }, {
      key: 'updateDestination',
      value: function updateDestination(e) {
        var _this2 = this;

        var TIME = this.props.destinations[e.target.value].filter(function (option) {
          return option.label === _this2.state.method.type;
        })[0];

        if (!(0, _generic.isPositiveNumber)(TIME.value)) {
          this.findNextAvailableMethodOfTransport(e.target.value);
        } else {
          this.setState({
            destination: e.target.value,
            method: {
              commuteTime: TIME.value,
              type: TIME.label
            }
          });
        }
      }
      /**
       * Updates the time it takes and the type of transport taken from currently selected item.
       *
       * @param {object} event from the select box
       * @public
       */

    }, {
      key: 'updateCommute',
      value: function updateCommute(e) {
        this.setState({
          method: {
            commuteTime: e.currentTarget.options[e.currentTarget.selectedIndex].dataset.time,
            type: e.currentTarget.options[e.currentTarget.selectedIndex].value
          }
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var selectBoxOptions = function selectBoxOptions(name, value) {
          var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return _react2.default.createElement('option', _extends({
            key: name,
            'data-method': name,
            value: value
          }, attrs), name.replace('-', ' '));
        };

        var renderDestinationOptions = function renderDestinationOptions() {
          return Object.keys(_this3.props.destinations).map(function (key) {
            return selectBoxOptions(key, key);
          });
        };

        var _state = this.state,
            method = _state.method,
            destination = _state.destination;
        return _react2.default.createElement('div', {
          className: 'gr-commute container'
        }, _react2.default.createElement('div', {
          className: 'row no-gutters gr-commute__row'
        }, _react2.default.createElement('div', {
          className: 'col-5 col-xl-6'
        }, _react2.default.createElement('p', {
          className: 'gr-commute__text'
        }, this.props.name, ' is'), _react2.default.createElement('div', {
          className: 'gr-commute__time-box'
        }, _react2.default.createElement('span', {
          className: 'gr-commute__time'
        }, method.commuteTime), 'Minutes', _react2.default.createElement('svg', {
          width: '0',
          height: '0',
          className: 'gr-commute__svg'
        }, _react2.default.createElement('defs', null, _react2.default.createElement('clipPath', {
          id: 'gr-commute-clippath-small',
          clipPathUnits: 'objectBoundingBox'
        }, _react2.default.createElement('polygon', {
          points: '0 .2, 1 0, 1 1, 0 .8'
        })), _react2.default.createElement('clipPath', {
          id: 'gr-commute-clippath-large',
          clipPathUnits: 'objectBoundingBox'
        }, _react2.default.createElement('polygon', {
          points: '.2 .2, 1 0, 1 1, 0 .9'
        }))), _react2.default.createElement('rect', {
          className: 'gr-commute__rect',
          width: '100%',
          height: '100%'
        })))), _react2.default.createElement('div', {
          className: 'col-7 col-xl-6'
        }, _react2.default.createElement('fieldset', {
          className: 'gr-commute__form',
          'aria-controls': 'commute-calculator'
        }, _react2.default.createElement('legend', {
          className: 'sr-only'
        }, 'Commute time calculator'), _react2.default.createElement('div', {
          className: 'row'
        }, _react2.default.createElement('div', {
          className: 'col-12'
        }, _react2.default.createElement('label', {
          htmlFor: 'destination',
          className: 'gr-commute__label'
        }, _react2.default.createElement('span', {
          className: 'sr-only'
        }, 'Select '), 'from ', _react2.default.createElement('span', {
          className: 'sr-only'
        }, 'destination')), _react2.default.createElement('div', {
          className: 'gr-commute__select'
        }, _react2.default.createElement('select', {
          id: 'destination',
          value: destination,
          onChange: this.updateDestination,
          className: 'gr-commute__select-box js-destination-hook'
        }, renderDestinationOptions()), _react2.default.createElement('i', {
          className: 'gr-icon icon-chevron-down gr-commute__select-icon'
        }))), _react2.default.createElement('div', {
          className: 'col-12'
        }, _react2.default.createElement('label', {
          htmlFor: 'method',
          className: 'gr-commute__label'
        }, _react2.default.createElement('span', {
          className: 'sr-only'
        }, 'Select '), 'by ', _react2.default.createElement('span', {
          className: 'sr-only'
        }, ' what method of transport')), _react2.default.createElement('div', {
          className: 'gr-commute__select'
        }, _react2.default.createElement('select', {
          id: 'method',
          value: method.type,
          onChange: this.updateCommute,
          className: 'gr-commute__select-box'
        }, this.props.destinations[destination] && this.props.destinations[destination].map(function (key) {
          return !(0, _generic.isPositiveNumber)(key.value) ? _react2.default.createElement('option', {
            key: key.label,
            'data-time': key.value,
            value: key.label,
            disabled: true
          }, key.label.replace('-', ' ')) : _react2.default.createElement('option', {
            key: key.label,
            'data-time': key.value,
            value: key.label
          }, key.label.replace('-', ' '));
        })), _react2.default.createElement('i', {
          className: 'gr-icon icon-chevron-down gr-commute__select-icon'
        }))))))), _react2.default.createElement('p', {
          className: 'sr-only',
          role: 'region',
          id: 'commute-calculator',
          'aria-live': 'polite'
        }, 'Clippers Quay is ', method.commuteTime, ' minutes away from ', destination.replace('-', ' '), ' by ', method.type));
      }
    }]);

    return Commute;
  }(_react.Component);

  Commute.defaultProps = {
    initialDestination: '',
    initialMethod: ''
  };
  Commute.propTypes = {
    /** An object containing the different destinations available to get to. */
    destinations: _propTypes2.default.shape({
      /** A list of methods of transport available for the current destination */
      methods: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        /** Name of the type of transport */
        label: _propTypes2.default.string,

        /** How long it takes to get from apartment to current destination */
        value: _propTypes2.default.string
      }))
    }),

    /** Name of the apartment blocks */
    name: _propTypes2.default.string,

    /** Set an initial destination */
    initialDestination: _propTypes2.default.string,

    /** Set an initial method of transport */
    initialMethod: _propTypes2.default.string
  };
  Commute.defaultProps = {
    destinations: null,
    name: null
  };
  exports.default = Commute;
  /***/
},
/* 456 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(457);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Commute.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Commute.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 457 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-commute {\n  margin: 30px auto;\n  text-transform: uppercase;\n  color: #7C7C7B;\n  font-weight: 700; }\n  @media all and (min-width: 768px) {\n    .gr-commute {\n      margin: 50px auto; } }\n  @media all and (min-width: 768px) {\n    .gr-commute__row {\n      align-items: center; } }\n  .gr-commute__text {\n    font-size: 20px;\n    margin-bottom: -15px;\n    max-width: 100px; }\n    @media all and (min-width: 768px) {\n      .gr-commute__text {\n        max-width: none;\n        font-size: 26px;\n        margin-bottom: 0;\n        text-align: right; } }\n    @media all and (min-width: 1200px) {\n      .gr-commute__text {\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 30px;\n        font-size: 24px; } }\n  .gr-commute__rect {\n    clip-path: url(\"#gr-commute-clippath-small\");\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0); }\n  .gr-commute__time-box {\n    color: #FFFFFF;\n    padding: 50px 25px;\n    width: calc(100% + 20px);\n    position: relative;\n    left: -20px;\n    text-align: center;\n    font-size: 20px; }\n    @media all and (min-width: 768px) {\n      .gr-commute__time-box {\n        left: auto;\n        width: 100%;\n        max-width: 240px;\n        margin-left: auto; } }\n    @media all and (min-width: 1200px) {\n      .gr-commute__time-box {\n        min-width: 240px;\n        width: auto;\n        margin: 0;\n        padding: 50px 60px 50px 80px;\n        display: inline-block;\n        vertical-align: middle; } }\n  .gr-commute__time {\n    display: block;\n    font-size: 80px;\n    margin: -20px 0;\n    font-family: \"fs_elliotbold\"; }\n  .gr-commute__form {\n    padding-left: 20px;\n    margin-top: 20%;\n    min-width: 0;\n    border: 0; }\n    @media all and (min-width: 768px) {\n      .gr-commute__form {\n        padding-left: 30px;\n        margin-top: 50px; } }\n    @media all and (min-width: 1200px) {\n      .gr-commute__form {\n        padding-left: 0;\n        margin-top: 0; } }\n  .gr-commute__label {\n    font-size: 15px;\n    font-weight: 300;\n    margin-bottom: 5px; }\n    @media all and (min-width: 768px) {\n      .gr-commute__label {\n        font-weight: 700;\n        margin-bottom: 0; } }\n  .gr-commute__select {\n    position: relative;\n    border-bottom: 2px solid #7C7C7B;\n    width: 100%;\n    overflow: hidden;\n    margin-bottom: 40px;\n    max-width: 450px; }\n  .gr-commute__select-box {\n    text-transform: uppercase;\n    font-size: 20px;\n    font-weight: 700;\n    padding: 0 22px 0 0;\n    width: 100%;\n    border: none;\n    box-shadow: none;\n    background: transparent;\n    background-image: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n    appearance: none; }\n    .gr-commute__select-box::-ms-expand {\n      display: none; }\n    @media all and (min-width: 768px) {\n      .gr-commute__select-box {\n        font-size: 26px;\n        padding-right: 36px; } }\n    @media all and (min-width: 992px) {\n      .gr-commute__select-box {\n        font-size: 22px;\n        padding-right: 30px; } }\n  .gr-commute__select-icon {\n    pointer-events: none;\n    font-size: 18px;\n    position: absolute;\n    right: 2px;\n    top: 50%;\n    transform: translateY(-50%); }\n    @media all and (min-width: 768px) {\n      .gr-commute__select-icon {\n        font-size: 32px; } }\n    @media all and (min-width: 992px) {\n      .gr-commute__select-icon {\n        font-size: 25px; } }\n  .gr-commute__svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1; }\n", ""]); // exports

  /***/
},
/* 458 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CookieBar = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _cookies = __webpack_require__(459);

  __webpack_require__(460);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CookieBar = exports.CookieBar = function (_PureComponent) {
    _inherits(CookieBar, _PureComponent);

    function CookieBar(props) {
      _classCallCheck(this, CookieBar);

      var _this = _possibleConstructorReturn(this, (CookieBar.__proto__ || Object.getPrototypeOf(CookieBar)).call(this, props));

      _this.state = {
        showCookies: false
      };
      _this.acceptCookie = _this.acceptCookie.bind(_this);
      return _this;
    }

    _createClass(CookieBar, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setState({
          showCookies: !(0, _cookies.getCookie)(document, 'cookieConsent')
        });
      }
    }, {
      key: 'acceptCookie',
      value: function acceptCookie() {
        var oneYear = 60 * 60 * 24 * 365;
        this.setState({
          showCookies: false
        }, (0, _cookies.setCookie)(document, 'cookieConsent', true, oneYear));
      }
    }, {
      key: 'render',
      value: function render() {
        return !this.state.showCookies ? null : _react2.default.createElement('div', {
          className: 'gr-cookie-bar'
        }, this.props.text && _react2.default.createElement('div', {
          className: 'gr-cookie-bar__content'
        }, _react2.default.createElement('div', {
          className: 'gr-cookie-bar__text',
          dangerouslySetInnerHTML: {
            __html: this.props.text.replace(/(http|https):\/\//i, '/')
          }
        }), _react2.default.createElement('button', {
          className: 'gr-cookie-bar__cta',
          onClick: this.acceptCookie
        }, 'Accept')));
      }
    }]);

    return CookieBar;
  }(_react.PureComponent);

  CookieBar.propTypes = {
    text: _propTypes2.default.string
  };
  CookieBar.defaultProps = {
    text: null
  };
  exports.default = CookieBar;
  /***/
},
/* 459 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var setCookie = exports.setCookie = function setCookie(doc, key, value) {
    var maxAge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var document = doc;
    document.cookie = key + "=" + value + ";max-age=" + maxAge;
  };

  var getCookie = exports.getCookie = function getCookie(document, name) {
    var value = document.cookie.match(new RegExp(name + "=([^;]+)"));
    return value && value[1];
  };

  exports.default = {
    setCookie: setCookie,
    getCookie: getCookie
  };
  /***/
},
/* 460 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(461);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./CookieBar.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./CookieBar.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 461 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-cookie-bar {\n  position: fixed;\n  bottom: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background-color: #62B1AD;\n  color: #FFFFFF;\n  padding: 20px;\n  animation-name: pop-up;\n  -webkit-animation: pop-up;\n  -moz-animation: pop-up;\n  -ms-animation: pop-up;\n  -o-animation: pop-up;\n  animation-fill-mode: forwards;\n  animation-delay: .3s;\n  animation-duration: 1s; }\n  @media all and (min-width: 768px) {\n    .gr-cookie-bar {\n      padding: 15px 20px;\n      padding-bottom: 25px; } }\n  .gr-cookie-bar svg {\n    display: block; }\n  .gr-cookie-bar__content {\n    max-width: 420px;\n    margin: 0 auto;\n    text-align: center;\n    font-weight: 700;\n    font-size: 14px;\n    position: relative; }\n    .gr-cookie-bar__content p {\n      margin-bottom: 0; }\n    .gr-cookie-bar__content a {\n      color: #FFFFFF;\n      text-decoration: underline; }\n      .gr-cookie-bar__content a:hover, .gr-cookie-bar__content a:focus {\n        color: #4E8382; }\n    @media all and (min-width: 768px) {\n      .gr-cookie-bar__content {\n        max-width: 1920px;\n        align-items: center;\n        font-size: 16px;\n        display: flex;\n        justify-content: center; } }\n  .gr-cookie-bar__cta {\n    border: none;\n    text-align: center;\n    display: inline-block;\n    color: #FFFFFF;\n    margin-top: 20px;\n    padding: 15px 40px;\n    border-radius: 40px;\n    min-width: 200px;\n    line-height: 16px;\n    font-size: 14px;\n    font-weight: bold;\n    text-transform: uppercase;\n    position: relative;\n    background-color: #4E8382;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    transition: background-color .1s linear; }\n    .gr-cookie-bar__cta:hover, .gr-cookie-bar__cta:focus {\n      background-color: #F36F4A;\n      color: #FFFFFF;\n      text-decoration: none;\n      cursor: pointer; }\n    @media all and (min-width: 768px) {\n      .gr-cookie-bar__cta {\n        max-width: 200px;\n        margin-top: 0;\n        margin-left: 25px; } }\n\n@-webkit-keyframes pop-up {\n  0% {\n    bottom: -100%; }\n  80% {\n    bottom: 0%; }\n  100% {\n    bottom: -10px; } }\n\n@-moz-keyframes pop-up {\n  0% {\n    bottom: -100%; }\n  80% {\n    bottom: 0%; }\n  100% {\n    bottom: -10px; } }\n\n@-ms-keyframes pop-up {\n  0% {\n    bottom: -100%; }\n  80% {\n    bottom: 0%; }\n  100% {\n    bottom: -10px; } }\n\n@-o-keyframes pop-up {\n  0% {\n    bottom: -100%; }\n  80% {\n    bottom: 0%; }\n  100% {\n    bottom: -10px; } }\n\n@keyframes pop-up {\n  0% {\n    bottom: -100%; }\n  80% {\n    bottom: 0%; }\n  100% {\n    bottom: -10px; } }\n", ""]); // exports

  /***/
},
/* 462 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CtaSection = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Links = __webpack_require__(37);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CtaSection = exports.CtaSection = function CtaSection(_ref) {
    var title = _ref.title,
        text = _ref.text,
        cta = _ref.cta;
    return _react2.default.createElement('section', {
      className: 'gr-cta-section text-center'
    }, _react2.default.createElement('div', {
      className: 'gr-cta-section__content ' + (!text ? 'mb-3 mb-md-0' : '')
    }, title && _react2.default.createElement('h2', {
      className: 'gr-cta-section__header'
    }, title), text && _react2.default.createElement('div', {
      className: 'gr-cta-section__text',
      dangerouslySetInnerHTML: {
        __html: text
      }
    })), cta && _react2.default.createElement(_Links.Links, {
      location: cta.url,
      text: cta.text,
      isExternal: cta.isExternal,
      className: 'gr-cta-section__button'
    }));
  };

  CtaSection.propTypes = {
    title: _propTypes2.default.string,
    text: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    })
  };
  CtaSection.defaultProps = {
    cta: null,
    text: null,
    title: null
  };
  exports.default = CtaSection;
  /***/
},
/* 463 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CTAText = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(464);

  var _Links = __webpack_require__(37);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CTAText = exports.CTAText = function CTAText(props) {
    return _react2.default.createElement('div', {
      className: 'gr-cta-text'
    }, _react2.default.createElement('div', {
      className: 'gr-cta-text__content'
    }, props.title && _react2.default.createElement('h2', {
      className: 'gr-cta-text__heading'
    }, props.title), props.text && _react2.default.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: props.text
      },
      className: 'gr-cta-text__text'
    }), props.cta && props.cta.url && props.cta.text && _react2.default.createElement(_Links.Links, {
      text: props.cta.text,
      location: props.cta.url,
      isExternal: props.cta.isExternal,
      className: 'gr-cta gr-cta-text__cta'
    })));
  };

  CTAText.propTypes = {
    text: _propTypes2.default.string,
    title: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      text: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool
    })
  };
  CTAText.defaultProps = {
    text: null,
    title: null,
    cta: null
  };
  exports.default = CTAText;
  /***/
},
/* 464 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(465);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./CTAText.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./CTAText.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 465 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-cta-text {\n  text-align: center;\n  font-size: 18px;\n  margin: 40px 0;\n  padding: 0 15px; }\n  @media all and (min-width: 768px) {\n    .gr-cta-text {\n      margin: 70px 0; } }\n  .gr-cta-text__heading {\n    color: #62B1AD;\n    font-size: 20px;\n    text-transform: uppercase;\n    max-width: 310px;\n    margin: 0 auto;\n    line-height: 25px; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text__heading {\n        font-size: 30px;\n        max-width: none;\n        line-height: 30px; } }\n  .gr-cta-text__text {\n    max-width: 380px;\n    margin: 0 auto;\n    font-size: 16px;\n    margin-top: 10px; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text__text {\n        max-width: 700px;\n        margin-top: -10px;\n        font-size: 20px; } }\n  .gr-cta-text__cta {\n    margin-bottom: 0; }\n", ""]); // exports

  /***/
},
/* 466 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CTATextBanner = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Links = __webpack_require__(37);

  var _Img = __webpack_require__(30);

  __webpack_require__(467);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CTATextBanner = exports.CTATextBanner = function CTATextBanner(_ref) {
    var image = _ref.image,
        title = _ref.title,
        text = _ref.text,
        cta = _ref.cta;
    return _react2.default.createElement('div', {
      className: 'gr-cta-text-banner'
    }, _react2.default.createElement('div', {
      className: 'gr-cta-text-banner__content'
    }, _react2.default.createElement('div', {
      className: 'gr-cta-text-banner__image'
    }, image && _react2.default.createElement(_Img.Img, {
      src: image,
      alt: 'Grainger award',
      isFluid: true
    })), _react2.default.createElement('div', {
      className: 'gr-cta-text-banner__inner'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-cta-text-banner__heading'
    }, title), text && _react2.default.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: text
      },
      className: 'gr-cta-text-banner__text'
    }), cta && cta.url && cta.text && _react2.default.createElement(_Links.Links, {
      text: cta.text,
      location: cta.url,
      isExternal: cta.isExternal,
      className: 'gr-cta gr-cta-text-banner__cta'
    }))));
  };

  CTATextBanner.propTypes = {
    image: _propTypes2.default.string,
    text: _propTypes2.default.string,
    title: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      text: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool
    })
  };
  CTATextBanner.defaultProps = {
    image: null,
    text: null,
    title: null,
    cta: null
  };
  exports.default = CTATextBanner;
  /***/
},
/* 467 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(468);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./CTATextBanner.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./CTATextBanner.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 468 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-cta-text-banner {\n  margin: 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-cta-text-banner {\n      margin: 50px 0; } }\n  .gr-cta-text-banner__content {\n    position: relative;\n    text-align: center;\n    font-size: 18px;\n    padding: 30px 15px;\n    background-color: #F6F6F6; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text-banner__content {\n        padding: 70px 30px; } }\n    @media all and (min-width: 992px) {\n      .gr-cta-text-banner__content {\n        padding: 90px 30px; } }\n  .gr-cta-text-banner__inner {\n    position: relative;\n    max-width: 380px;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text-banner__inner {\n        max-width: 700px; } }\n  .gr-cta-text-banner__heading {\n    color: #62B1AD;\n    font-size: 18px;\n    text-transform: uppercase;\n    max-width: 310px;\n    margin: 0 auto;\n    line-height: 25px; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text-banner__heading {\n        font-size: 26px;\n        max-width: none;\n        line-height: 30px; } }\n  .gr-cta-text-banner__text {\n    font-size: 14px;\n    margin-top: 10px; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text-banner__text {\n        margin-top: 15px;\n        font-size: 22px; } }\n  .gr-cta-text-banner__cta {\n    margin-bottom: 0; }\n  .gr-cta-text-banner__left-striped-sail, .gr-cta-text-banner__left-sail {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-cta-text-banner__left-striped-sail, .gr-cta-text-banner__left-sail {\n        display: block;\n        position: absolute; } }\n  .gr-cta-text-banner__left-striped-sail {\n    width: 400px;\n    height: 440px;\n    left: -380px;\n    top: -20px;\n    transform: rotate(2deg); }\n    @media all and (min-width: 992px) {\n      .gr-cta-text-banner__left-striped-sail {\n        left: -500px; } }\n  .gr-cta-text-banner__left-sail {\n    width: 500px;\n    height: 312px;\n    left: -475px;\n    top: 100px; }\n    @media all and (min-width: 992px) {\n      .gr-cta-text-banner__left-sail {\n        left: -620px; } }\n", ""]); // exports

  /***/
},
/* 469 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DigitalWalkthrough = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(470);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var DigitalWalkthrough = exports.DigitalWalkthrough = function DigitalWalkthrough(_ref) {
    var url = _ref.url;
    return _react2.default.createElement('div', {
      className: 'gr-digital-walkthrough'
    }, url && _react2.default.createElement('iframe', {
      className: 'gr-digital-walkthrough__iframe',
      src: url,
      frameBorder: '0',
      title: 'Grainger Clippers Quay Digital Walkthrough'
    }));
  };

  exports.default = DigitalWalkthrough;
  DigitalWalkthrough.propTypes = {
    url: _propTypes2.default.string
  };
  DigitalWalkthrough.defaultProps = {
    url: null
  };
  /***/
},
/* 470 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(471);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./DigitalWalkthrough.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./DigitalWalkthrough.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 471 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-digital-walkthrough__iframe {\n  width: 100%;\n  height: 500px; }\n", ""]); // exports

  /***/
},
/* 472 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Footer = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _axios = __webpack_require__(473);

  var _axios2 = _interopRequireDefault(_axios);

  var _generic = __webpack_require__(10);

  __webpack_require__(492);

  var _Img = __webpack_require__(30);

  var _List = __webpack_require__(61);

  var _FooterLinks = __webpack_require__(494);

  var _graingerPlcLogoWhite = __webpack_require__(495);

  var _graingerPlcLogoWhite2 = _interopRequireDefault(_graingerPlcLogoWhite);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * Global footer component for all grainger marketing sites
   */


  var Footer = exports.Footer = function (_Component) {
    _inherits(Footer, _Component);

    function Footer(props) {
      _classCallCheck(this, Footer);

      var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

      _this.state = {
        feed: []
      };
      return _this;
    }

    _createClass(Footer, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        var token = '4105735279.09c61f9.c3721914b3b44822ad62a00ad894a1ea';
        Footer.getFeed(token).then(function (response) {
          return _this2.setState({
            feed: response.data.data
          });
        }).catch(function () {
          throw new Error('Could not get images');
        });
      }
      /**
       * Will retrieve Grainger Instagram feed from API. If not in production, it will return
       * stub data.
       *
       * @param {string} Access token for Instagram API
       * @public
       */

      /* eslint-disable react/sort-comp */

    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            showFeed = _props.showFeed,
            pages = _props.pages,
            social = _props.social,
            text = _props.text,
            graingerInfo = _props.graingerInfo,
            phone = _props.phone;
        return _react2.default.createElement('footer', {
          className: 'gr-footer ' + (this.state.feed && this.state.feed.length > 0 && showFeed ? 'gr-footer--feed' : '')
        }, _react2.default.createElement('div', {
          className: 'container'
        }, this.state.feed && this.state.feed.length > 0 && showFeed && _react2.default.createElement('div', {
          className: 'gr-footer__instagram'
        }, _react2.default.createElement('p', {
          className: 'gr-footer__instagram-text'
        }, 'Instagram', _react2.default.createElement('a', {
          href: 'https://www.instagram.com/graingerplc/',
          target: '_blank',
          rel: 'noopener noreferrer',
          className: 'gr-footer__instagram-link'
        }, '@graingerplc')), _react2.default.createElement('div', {
          className: 'gr-footer__feed'
        }, _react2.default.createElement(_List.List, {
          className: 'row',
          isInline: true,
          isUnstyled: true
        }, this.state.feed.slice(0, 4).map(function (image) {
          return _react2.default.createElement('li', {
            key: image.id,
            className: 'gr-footer__feed-item col-3'
          }, _react2.default.createElement('a', {
            href: image.link,
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'gr-footer__feed-link'
          }, _react2.default.createElement(_Img.Img, {
            alt: '' + (image && image.caption ? 'image.caption.text' : ''),
            src: '' + (image && image.images && image.images.standard_resolution ? image.images.standard_resolution.url : null),
            isFluid: true
          })));
        })))), _react2.default.createElement('div', {
          className: 'row gr-footer__row'
        }, _react2.default.createElement('div', {
          className: 'col-md-7 col-lg-8'
        }, social && _react2.default.createElement(_List.List, {
          className: 'gr-footer__social-links',
          isInline: true,
          isUnstyled: true
        }, social.map(function (link) {
          return _react2.default.createElement('li', {
            key: link.icon
          }, _react2.default.createElement('a', {
            className: 'gr-footer__social-link',
            href: link.link
          }, _react2.default.createElement('span', {
            className: 'sr-only'
          }, link.text), _react2.default.createElement('i', {
            className: 'icon icon-' + link.icon,
            'aria-hidden': 'true'
          })));
        })), _react2.default.createElement(_Img.Img, {
          alt: 'grainger plc',
          src: _graingerPlcLogoWhite2.default,
          className: 'gr-footer__logo'
        }), graingerInfo && _react2.default.createElement('p', {
          className: 'gr-footer__grainger-info'
        }, graingerInfo)), _react2.default.createElement('div', {
          className: 'col-md-5 col-lg-4'
        }, pages && _react2.default.createElement(_List.List, {
          className: 'gr-footer__pages',
          isUnstyled: true
        }, pages.map(function (link) {
          return _react2.default.createElement('li', {
            key: (0, _generic.randomStr)(link.cta.text)
          }, _react2.default.createElement(_FooterLinks.FooterLinks, {
            cta: link.cta
          }));
        })), phone && _react2.default.createElement('a', {
          href: 'tel:' + phone,
          className: 'gr-footer__phone-number'
        }, phone), text && _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: text
          },
          className: 'gr-footer__text'
        })))));
      }
    }], [{
      key: 'getFeed',
      value: function getFeed(token) {
        return _axios2.default.get('https://api.instagram.com/v1/users/self/media/recent/?access_token=' + token);
      }
    }]);

    return Footer;
  }(_react.Component);

  Footer.propTypes = {
    /** Whether or not to show the feed. */
    showFeed: _propTypes2.default.bool,

    /** An array of pages to link to. */
    pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /** The links to the pages. */
      cta: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        isExternal: _propTypes2.default.bool,
        text: _propTypes2.default.string
      })
    })),

    /** List of social icon links to display. */
    social: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /** The icon to display. */
      icon: _propTypes2.default.string,

      /** The link to the social channel. */
      link: _propTypes2.default.string,

      /** Hidden text to support the link. */
      text: _propTypes2.default.string
    })),

    /** Address at the bottom of the footer. */
    text: _propTypes2.default.string,
    graingerInfo: _propTypes2.default.string,
    phone: _propTypes2.default.string
  };
  Footer.defaultProps = {
    showFeed: null,
    pages: null,
    social: null,
    text: null,
    graingerInfo: null,
    phone: null
  };
  exports.default = Footer;
  /***/
},
/* 473 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(474);
  /***/
},
/* 474 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  var bind = __webpack_require__(171);

  var Axios = __webpack_require__(476);

  var defaults = __webpack_require__(126);
  /**
   * Create an instance of Axios
   *
   * @param {Object} defaultConfig The default config for the instance
   * @return {Axios} A new instance of Axios
   */


  function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

    utils.extend(instance, Axios.prototype, context); // Copy context to instance

    utils.extend(instance, context);
    return instance;
  } // Create the default instance to be exported


  var axios = createInstance(defaults); // Expose Axios class to allow class inheritance

  axios.Axios = Axios; // Factory for creating new instances

  axios.create = function create(instanceConfig) {
    return createInstance(utils.merge(defaults, instanceConfig));
  }; // Expose Cancel & CancelToken


  axios.Cancel = __webpack_require__(175);
  axios.CancelToken = __webpack_require__(490);
  axios.isCancel = __webpack_require__(174); // Expose all/spread

  axios.all = function all(promises) {
    return Promise.all(promises);
  };

  axios.spread = __webpack_require__(491);
  module.exports = axios; // Allow use of default import syntax in TypeScript

  module.exports.default = axios;
  /***/
},
/* 475 */

/***/
function (module, exports) {
  /*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */
  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  module.exports = function (obj) {
    return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
  };

  function isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
  } // For Node v0.10 support. Remove this eventually.


  function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
  }
  /***/

},
/* 476 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var defaults = __webpack_require__(126);

  var utils = __webpack_require__(25);

  var InterceptorManager = __webpack_require__(485);

  var dispatchRequest = __webpack_require__(486);
  /**
   * Create a new instance of Axios
   *
   * @param {Object} instanceConfig The default config for the instance
   */


  function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {Object} config The config specific for this request (merged with this.defaults)
   */


  Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
      config = utils.merge({
        url: arguments[0]
      }, arguments[1]);
    }

    config = utils.merge(defaults, {
      method: 'get'
    }, this.defaults, config);
    config.method = config.method.toLowerCase(); // Hook up interceptors middleware

    var chain = [dispatchRequest, undefined];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      chain.push(interceptor.fulfilled, interceptor.rejected);
    });

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }; // Provide aliases for supported request methods


  utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios.prototype[method] = function (url, config) {
      return this.request(utils.merge(config || {}, {
        method: method,
        url: url
      }));
    };
  });
  utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    /*eslint func-names:0*/
    Axios.prototype[method] = function (url, data, config) {
      return this.request(utils.merge(config || {}, {
        method: method,
        url: url,
        data: data
      }));
    };
  });
  module.exports = Axios;
  /***/
},
/* 477 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  module.exports = function normalizeHeaderName(headers, normalizedName) {
    utils.forEach(headers, function processHeader(value, name) {
      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = value;
        delete headers[name];
      }
    });
  };
  /***/

},
/* 478 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var createError = __webpack_require__(173);
  /**
   * Resolve or reject a Promise based on response status.
   *
   * @param {Function} resolve A function that resolves the promise.
   * @param {Function} reject A function that rejects the promise.
   * @param {object} response The response.
   */


  module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus; // Note: status is not exposed by XDomainRequest

    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
    }
  };
  /***/

},
/* 479 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Update an Error with the specified config, error code, and response.
   *
   * @param {Error} error The error to update.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   * @returns {Error} The error.
   */

  module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;

    if (code) {
      error.code = code;
    }

    error.request = request;
    error.response = response;
    return error;
  };
  /***/

},
/* 480 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  function encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
  }
  /**
   * Build a URL by appending params to the end
   *
   * @param {string} url The base of the url (e.g., http://www.google.com)
   * @param {object} [params] The params to be appended
   * @returns {string} The formatted url
   */


  module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/
    if (!params) {
      return url;
    }

    var serializedParams;

    if (paramsSerializer) {
      serializedParams = paramsSerializer(params);
    } else if (utils.isURLSearchParams(params)) {
      serializedParams = params.toString();
    } else {
      var parts = [];
      utils.forEach(params, function serialize(val, key) {
        if (val === null || typeof val === 'undefined') {
          return;
        }

        if (utils.isArray(val)) {
          key = key + '[]';
        } else {
          val = [val];
        }

        utils.forEach(val, function parseValue(v) {
          if (utils.isDate(v)) {
            v = v.toISOString();
          } else if (utils.isObject(v)) {
            v = JSON.stringify(v);
          }

          parts.push(encode(key) + '=' + encode(v));
        });
      });
      serializedParams = parts.join('&');
    }

    if (serializedParams) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }

    return url;
  };
  /***/

},
/* 481 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25); // Headers whose duplicates are ignored by node
  // c.f. https://nodejs.org/api/http.html#http_message_headers


  var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
  /**
   * Parse headers into an object
   *
   * ```
   * Date: Wed, 27 Aug 2014 08:58:49 GMT
   * Content-Type: application/json
   * Connection: keep-alive
   * Transfer-Encoding: chunked
   * ```
   *
   * @param {String} headers Headers needing to be parsed
   * @returns {Object} Headers parsed into an object
   */

  module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;

    if (!headers) {
      return parsed;
    }

    utils.forEach(headers.split('\n'), function parser(line) {
      i = line.indexOf(':');
      key = utils.trim(line.substr(0, i)).toLowerCase();
      val = utils.trim(line.substr(i + 1));

      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }

        if (key === 'set-cookie') {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
      }
    });
    return parsed;
  };
  /***/

},
/* 482 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */

    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */

    return function isURLSameOrigin(requestURL) {
      var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }() : // Non standard browser envs (web workers, react-native) lack needed support.
  function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  }();
  /***/
},
/* 483 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function E() {
    this.message = 'String contains an invalid character';
  }

  E.prototype = new Error();
  E.prototype.code = 5;
  E.prototype.name = 'InvalidCharacterError';

  function btoa(input) {
    var str = String(input);
    var output = '';

    for ( // initialize result and counter
    var block, charCode, idx = 0, map = chars; // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1); // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
      charCode = str.charCodeAt(idx += 3 / 4);

      if (charCode > 0xFF) {
        throw new E();
      }

      block = block << 8 | charCode;
    }

    return output;
  }

  module.exports = btoa;
  /***/
},
/* 484 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
  function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },
      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
      },
      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  }() : // Non standard browser env (web workers, react-native) lack needed support.
  function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }();
  /***/
},
/* 485 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  function InterceptorManager() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */


  InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
      fulfilled: fulfilled,
      rejected: rejected
    });
    return this.handlers.length - 1;
  };
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   */


  InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  };
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   */


  InterceptorManager.prototype.forEach = function forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  };

  module.exports = InterceptorManager;
  /***/
},
/* 486 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);

  var transformData = __webpack_require__(487);

  var isCancel = __webpack_require__(174);

  var defaults = __webpack_require__(126);

  var isAbsoluteURL = __webpack_require__(488);

  var combineURLs = __webpack_require__(489);
  /**
   * Throws a `Cancel` if cancellation has been requested.
   */


  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
  }
  /**
   * Dispatch a request to the server using the configured adapter.
   *
   * @param {object} config The config that is to be used for the request
   * @returns {Promise} The Promise to be fulfilled
   */


  module.exports = function dispatchRequest(config) {
    throwIfCancellationRequested(config); // Support baseURL config

    if (config.baseURL && !isAbsoluteURL(config.url)) {
      config.url = combineURLs(config.baseURL, config.url);
    } // Ensure headers exist


    config.headers = config.headers || {}; // Transform request data

    config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
      delete config.headers[method];
    });
    var adapter = config.adapter || defaults.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config); // Transform response data

      response.data = transformData(response.data, response.headers, config.transformResponse);
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config); // Transform response data

        if (reason && reason.response) {
          reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
        }
      }

      return Promise.reject(reason);
    });
  };
  /***/

},
/* 487 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var utils = __webpack_require__(25);
  /**
   * Transform the data for a request or a response
   *
   * @param {Object|String} data The data to be transformed
   * @param {Array} headers The headers for the request or response
   * @param {Array|Function} fns A single function or Array of functions
   * @returns {*} The resulting transformed data
   */


  module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/
    utils.forEach(fns, function transform(fn) {
      data = fn(data, headers);
    });
    return data;
  };
  /***/

},
/* 488 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Determines whether the specified URL is absolute
   *
   * @param {string} url The URL to test
   * @returns {boolean} True if the specified URL is absolute, otherwise false
   */

  module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  };
  /***/

},
/* 489 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Creates a new URL by combining the specified URLs
   *
   * @param {string} baseURL The base URL
   * @param {string} relativeURL The relative URL
   * @returns {string} The combined URL
   */

  module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
  };
  /***/

},
/* 490 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Cancel = __webpack_require__(175);
  /**
   * A `CancelToken` is an object that can be used to request cancellation of an operation.
   *
   * @class
   * @param {Function} executor The executor function.
   */


  function CancelToken(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new Cancel(message);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `Cancel` if cancellation has been requested.
   */


  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */


  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token: token,
      cancel: cancel
    };
  };

  module.exports = CancelToken;
  /***/
},
/* 491 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Syntactic sugar for invoking a function and expanding an array for arguments.
   *
   * Common use case would be to use `Function.prototype.apply`.
   *
   *  ```js
   *  function f(x, y, z) {}
   *  var args = [1, 2, 3];
   *  f.apply(null, args);
   *  ```
   *
   * With `spread` this example can be re-written.
   *
   *  ```js
   *  spread(function(x, y, z) {})([1, 2, 3]);
   *  ```
   *
   * @param {Function} callback
   * @returns {Function}
   */

  module.exports = function spread(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };
  /***/

},
/* 492 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(493);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Footer.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Footer.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 493 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-footer {\n  background-color: #63666A;\n  color: #FFFFFF;\n  padding: 40px 0 50px; }\n  @media all and (min-width: 768px) {\n    .gr-footer--feed {\n      margin-top: 190px; } }\n  @media all and (min-width: 992px) {\n    .gr-footer--feed {\n      margin-top: 240px; } }\n  @media all and (min-width: 992px) {\n    .gr-footer {\n      padding-bottom: 70px; } }\n  .gr-footer__instagram {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-footer__instagram {\n        display: block;\n        margin-top: -170px;\n        font-weight: 700;\n        color: #4E8382; } }\n    @media all and (min-width: 992px) {\n      .gr-footer__instagram {\n        margin-top: -215px; } }\n  .gr-footer__instagram-text {\n    margin-bottom: 10px;\n    padding: 0 10px; }\n  .gr-footer__instagram-link {\n    color: #4E8382;\n    text-transform: none;\n    display: inline-block;\n    margin-left: 5px; }\n    .gr-footer__instagram-link:hover, .gr-footer__instagram-link:focus {\n      color: #62B1AD; }\n  .gr-footer__feed {\n    margin-bottom: 35px; }\n    .gr-footer__feed li {\n      padding: 0;\n      margin: 0;\n      overflow: hidden; }\n  .gr-footer__feed-link {\n    display: block;\n    transform: scale(1);\n    transition: transform .3s linear;\n    vertical-align: middle; }\n    .gr-footer__feed-link img {\n      display: block; }\n    .gr-footer__feed-link:hover, .gr-footer__feed-link:focus {\n      transform: scale(1.1);\n      transition: transform .3s linear; }\n  @media all and (min-width: 768px) {\n    .gr-footer__row {\n      align-items: flex-end; } }\n  .gr-footer__pages li {\n    margin: 0 0 2px;\n    display: inline-block; }\n    .gr-footer__pages li::after {\n      content: '|';\n      margin: 0 5px; }\n    .gr-footer__pages li:last-child::after {\n      content: none; }\n  .gr-footer__social-links {\n    margin: 0 0 40px; }\n    @media all and (min-width: 768px) {\n      .gr-footer__social-links {\n        margin-bottom: 60px; } }\n    .gr-footer__social-links li {\n      margin-right: 10px; }\n      .gr-footer__social-links li:last-child {\n        margin-right: 0; }\n  .gr-footer__social-link {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: #212721;\n    color: #FFFFFF;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    text-decoration: none;\n    transition: background-color .2s linear, color .2s linear; }\n    .gr-footer__social-link:hover, .gr-footer__social-link:focus {\n      text-decoration: none;\n      color: #63666A;\n      background-color: #FFFFFF; }\n  .gr-footer__logo {\n    max-width: 120px;\n    margin-bottom: 15px; }\n    @media all and (min-width: 768px) {\n      .gr-footer__logo {\n        max-width: 160px; } }\n  .gr-footer__grainger-info {\n    margin-bottom: 40px; }\n    @media all and (min-width: 768px) {\n      .gr-footer__grainger-info {\n        max-width: 75%;\n        font-size: 18px;\n        margin-bottom: 0; } }\n    @media all and (min-width: 992px) {\n      .gr-footer__grainger-info {\n        max-width: 70%; } }\n  .gr-footer__page-link {\n    color: #FFFFFF;\n    font-size: 14px;\n    text-decoration: none; }\n    .gr-footer__page-link:hover, .gr-footer__page-link:focus {\n      color: #FFFFFF;\n      text-decoration: underline; }\n  .gr-footer__phone-number {\n    font-size: 14px;\n    margin-bottom: 20px;\n    display: block;\n    color: #FFFFFF;\n    text-decoration: none; }\n    .gr-footer__phone-number:hover, .gr-footer__phone-number:focus {\n      color: #FFFFFF;\n      text-decoration: underline; }\n  .gr-footer__text {\n    font-size: 14px;\n    margin-bottom: -15px; }\n    .gr-footer__text a {\n      color: #FFFFFF; }\n      .gr-footer__text a:hover, .gr-footer__text a:focus {\n        color: #FFFFFF; }\n", ""]); // exports

  /***/
},
/* 494 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FooterLinks = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactRouterDom = __webpack_require__(87);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FooterLinks = exports.FooterLinks = function FooterLinks(_ref) {
    var cta = _ref.cta;

    if (cta.isExternal) {
      return _react2.default.createElement('a', {
        href: cta.url,
        className: 'gr-footer__page-link',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, cta.text, _react2.default.createElement('span', {
        className: 'sr-only'
      }, '(Opens in new window)'));
    }

    return _react2.default.createElement(_reactRouterDom.Link, {
      to: cta.url,
      className: 'gr-footer__page-link'
    }, cta.text);
  };
  /* eslint-disable jsx-a11y/anchor-is-valid */


  FooterLinks.propTypes = {
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    })
  };
  FooterLinks.defaultProps = {
    cta: null
  };
  exports.default = FooterLinks;
  /***/
},
/* 495 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/3b51858cba7ab464d4838fcfed1b8bea.png";
  /***/
},
/* 496 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ImageSection = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(497);

  var _Links = __webpack_require__(37);

  var _LeftSail = __webpack_require__(127);

  var _LargeStripedSail = __webpack_require__(176);

  var _SmallFrontSail = __webpack_require__(177);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ImageSection = exports.ImageSection = function ImageSection(_ref) {
    var backgroundImage = _ref.backgroundImage,
        title = _ref.title,
        cta = _ref.cta;
    return _react2.default.createElement('div', {
      className: 'gr-image-section'
    }, backgroundImage && _react2.default.createElement('div', {
      className: 'gr-image-section__sail-wrap',
      style: {
        backgroundImage: 'url(' + backgroundImage + ')'
      }
    }, _react2.default.createElement('div', {
      className: 'gr-image-section__left-small-sail'
    }, _react2.default.createElement(_SmallFrontSail.SmallFrontSail, null)), _react2.default.createElement('div', {
      className: 'gr-image-section__left-sail'
    }, _react2.default.createElement(_LeftSail.LeftSail, {
      fill: '#F36F4A'
    })), _react2.default.createElement('div', {
      className: 'gr-image-section__right-sail'
    }, _react2.default.createElement(_LargeStripedSail.LargeStripedSail, {
      fill: '#E5A01D'
    }))), (title || cta) && _react2.default.createElement('div', {
      className: 'gr-image-section__overlay'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-image-section__title'
    }, title), cta && cta.text && cta.url && _react2.default.createElement(_Links.Links, {
      text: cta.text,
      location: cta.url,
      isExternal: cta.isExternal
    })));
  };

  ImageSection.propTypes = {
    backgroundImage: _propTypes2.default.string,
    title: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    })
  };
  ImageSection.defaultProps = {
    backgroundImage: null,
    title: null,
    cta: null
  };
  exports.default = ImageSection;
  /***/
},
/* 497 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(498);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./ImageSection.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./ImageSection.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 498 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-image-section {\n  position: relative;\n  margin-top: 60px;\n  overflow: hidden; }\n  @media all and (min-width: 768px) {\n    .gr-image-section {\n      padding: 10px;\n      margin-top: 0; } }\n  .gr-image-section__title {\n    font-size: 18px;\n    text-transform: uppercase;\n    color: #4E8382; }\n    @media all and (min-width: 768px) {\n      .gr-image-section__title {\n        font-size: 30px; } }\n  .gr-image-section__overlay {\n    position: relative;\n    padding: 30px 30px 0;\n    text-align: center;\n    left: auto;\n    right: auto;\n    max-width: 870px;\n    top: -10px;\n    margin: 0 15px 30px;\n    background-color: #FFFFFF;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n    z-index: 1; }\n    @media all and (min-width: 768px) {\n      .gr-image-section__overlay {\n        top: -50px;\n        margin: 0 auto; } }\n  .gr-image-section__left-sail, .gr-image-section__right-sail, .gr-image-section__left-small-sail {\n    position: absolute; }\n  .gr-image-section__left-sail {\n    width: 200px;\n    left: -120px;\n    bottom: -125px;\n    z-index: -1; }\n    @media all and (min-width: 768px) {\n      .gr-image-section__left-sail {\n        bottom: -50px;\n        left: -250px;\n        width: 400px; } }\n  .gr-image-section__right-sail {\n    width: 700px;\n    right: -163px;\n    top: -80px;\n    z-index: -1; }\n    @media all and (min-width: 768px) {\n      .gr-image-section__right-sail {\n        width: 1000px;\n        right: -303px;\n        top: auto;\n        bottom: -50px; } }\n  .gr-image-section__left-small-sail {\n    left: -500px;\n    width: 550px;\n    bottom: -150px;\n    z-index: -1; }\n    @media all and (min-width: 768px) {\n      .gr-image-section__left-small-sail {\n        bottom: 0; } }\n  .gr-image-section__sail-wrap {\n    position: relative;\n    max-width: 1920px;\n    margin: 0 auto;\n    height: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5); }\n    @media all and (min-width: 768px) {\n      .gr-image-section__sail-wrap {\n        height: 600px; } }\n", ""]); // exports

  /***/
},
/* 499 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FloatingTextImage = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Img = __webpack_require__(30);

  var _LeftSail = __webpack_require__(127);

  var _LargeStripedSail = __webpack_require__(176);

  __webpack_require__(500);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FloatingTextImage = exports.FloatingTextImage = function FloatingTextImage(_ref) {
    var image = _ref.image,
        text = _ref.text,
        title = _ref.title;
    return _react2.default.createElement('div', {
      className: 'gr-floating-text-image'
    }, _react2.default.createElement('div', {
      className: 'gr-floating-text-image__container'
    }, _react2.default.createElement('div', {
      className: 'gr-floating-text-image__left-sail'
    }, _react2.default.createElement(_LeftSail.LeftSail, {
      fill: '#62B1AD'
    })), _react2.default.createElement('div', {
      className: 'gr-floating-text-image__right-sail'
    }, _react2.default.createElement(_LargeStripedSail.LargeStripedSail, {
      fill: '#E5A01D'
    })), image && _react2.default.createElement(_Img.Img, {
      src: image,
      className: 'gr-floating-text-image__image-large',
      isFluid: true
    }), _react2.default.createElement('div', {
      className: 'gr-floating-text-image__content'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-floating-text-image__title'
    }, title), image && _react2.default.createElement(_Img.Img, {
      src: image,
      className: 'gr-floating-text-image__image-small',
      isFluid: true
    }), text && _react2.default.createElement('article', {
      dangerouslySetInnerHTML: {
        __html: text
      },
      className: 'gr-floating-text-image__text'
    }))));
  };

  FloatingTextImage.propTypes = {
    image: _propTypes2.default.string,
    text: _propTypes2.default.string,
    title: _propTypes2.default.string
  };
  FloatingTextImage.defaultProps = {
    image: null,
    text: null,
    title: null
  };
  exports.default = FloatingTextImage;
  /***/
},
/* 500 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(501);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./FloatingTextImage.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./FloatingTextImage.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 501 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-floating-text-image {\n  overflow: hidden;\n  padding: 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-floating-text-image {\n      padding: 80px 20px; } }\n  .gr-floating-text-image__container {\n    position: relative;\n    max-width: 1920px;\n    margin: 0 auto; }\n  .gr-floating-text-image__content {\n    background: #FFFFFF;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n    padding: 15px; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__content {\n        padding: 30px 70px;\n        position: absolute;\n        right: 0;\n        top: 50px;\n        max-width: 575px; } }\n  .gr-floating-text-image__title {\n    text-transform: uppercase;\n    color: #4E8382;\n    margin-bottom: 20px;\n    font-size: 22px;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__title {\n        font-size: 27px;\n        text-align: left; } }\n  .gr-floating-text-image__left-sail, .gr-floating-text-image__right-sail {\n    position: absolute;\n    z-index: -1;\n    height: 100%; }\n  .gr-floating-text-image__left-sail {\n    -moz-transform: scaleX(-1);\n    -o-transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    transform: scaleX(-1);\n    left: -50px;\n    width: 200px;\n    bottom: -35px; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__left-sail {\n        bottom: -50px;\n        left: -90px;\n        width: 300px; } }\n  .gr-floating-text-image__right-sail {\n    right: -170px;\n    top: -80px;\n    width: 700px; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__right-sail {\n        top: -120px;\n        right: -343px;\n        width: 1300px; } }\n  .gr-floating-text-image__image-large {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__image-large {\n        display: block; } }\n  .gr-floating-text-image__image-small {\n    margin-bottom: 20px; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__image-small {\n        display: none; } }\n  .gr-floating-text-image__text {\n    font-size: 12px;\n    padding: 0 25px; }\n    @media all and (min-width: 768px) {\n      .gr-floating-text-image__text {\n        font-size: 16px;\n        padding: 0; } }\n", ""]); // exports

  /***/
},
/* 502 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FloorPlans = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Carousel = __webpack_require__(68);

  var _Img = __webpack_require__(30);

  var _Modal = __webpack_require__(529);

  var _generic = __webpack_require__(10);

  __webpack_require__(532);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * The floorplans component will display a carousel of images as well as the option
   * to add floorplan images that appear within a dialog, triggered by a button.
   */


  var FloorPlans = exports.FloorPlans = function (_PureComponent) {
    _inherits(FloorPlans, _PureComponent);

    function FloorPlans(props) {
      _classCallCheck(this, FloorPlans);

      var _this = _possibleConstructorReturn(this, (FloorPlans.__proto__ || Object.getPrototypeOf(FloorPlans)).call(this, props));

      _this.state = {
        isModalOpen: false,
        currentModal: null
      };
      _this.toggleModal = _this.toggleModal.bind(_this);
      _this.setFloorPlanRef = _this.setFloorPlanRef.bind(_this);
      _this.setWalkthroughRef = _this.setWalkthroughRef.bind(_this);
      window.addEventListener('resize', function () {
        if (window.innerWidth > 991 && _this.state.isModalOpen) {
          document.documentElement.classList.add('gr-body-fixed');
        }
      });
      return _this;
    }

    _createClass(FloorPlans, [{
      key: 'setFloorPlanRef',
      value: function setFloorPlanRef(node) {
        this.floorplanTrigger = node;
      }
    }, {
      key: 'setWalkthroughRef',
      value: function setWalkthroughRef(node) {
        this.walkthroughTrigger = node;
      }
    }, {
      key: 'toggleModal',
      value: function toggleModal(currentModal) {
        this.setState({
          isModalOpen: !this.state.isModalOpen,
          currentModal: currentModal || null
        }, function () {
          document.documentElement.classList.toggle('gr-body-fixed');
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement('div', {
          className: 'gr-floorplan'
        }, _react2.default.createElement('div', {
          className: 'gr-floorplan__container'
        }, _react2.default.createElement('figure', {
          className: 'row no-gutters'
        }, _react2.default.createElement('div', {
          className: 'col-12 col-md-7 col-lg-8'
        }, this.props.apartmentImages.length && _react2.default.createElement(_Carousel.Carousel, {
          fullWidth: true,
          centerMode: false,
          adaptiveHeight: true
        }, this.props.apartmentImages.map(function (image) {
          return _react2.default.createElement('figure', {
            key: (0, _generic.randomStr)(),
            className: 'gr-floorplan__figure'
          }, _react2.default.createElement(_Img.Img, {
            src: image.imageurl,
            isFluid: true,
            className: 'gr-floorplan__image'
          }), image.text && _react2.default.createElement('figcaption', {
            className: 'gr-floorplan__image-description'
          }, image.text));
        }))), _react2.default.createElement('div', {
          className: 'col-12 col-md-5 col-lg-4'
        }, this.props.floorplanImages.length && _react2.default.createElement('div', {
          className: 'gr-floorplan__button-wrapper'
        }, _react2.default.createElement('i', {
          className: 'gr-icon icon-launch-floorplan gr-floorplan__icon gr-floorplan__icon-large',
          'aria-hidden': 'true'
        }), _react2.default.createElement('button', {
          className: 'gr-cta gr-floorplan__button',
          onClick: function onClick() {
            return _this2.toggleModal('floorplans');
          },
          ref: this.setFloorPlanRef
        }, 'View Sample Floorplans', _react2.default.createElement('i', {
          className: 'gr-icon icon-launch-modal gr-floorplan__icon',
          'aria-hidden': 'true'
        }))), this.props.url && _react2.default.createElement('div', {
          className: 'gr-floorplan__button-wrapper'
        }, _react2.default.createElement('i', {
          className: 'gr-icon icon-launch-360 gr-floorplan__icon gr-floorplan__icon-large',
          'aria-hidden': 'true'
        }), _react2.default.createElement('a', {
          className: 'gr-cta gr-floorplan__button',
          href: this.props.url,
          target: '_blank',
          rel: 'noopener noreferrer'
        }, 'Explore the virtual tour', _react2.default.createElement('i', {
          className: 'gr-icon icon-launch-modal gr-floorplan__icon',
          'aria-hidden': 'true'
        }))), this.props.text && _react2.default.createElement('figcaption', {
          className: 'gr-floorplan__text',
          dangerouslySetInnerHTML: {
            __html: this.props.text
          }
        })))), this.props.floorplanImages.length && _react2.default.createElement(_Modal.Modal, {
          isModalOpen: this.state.isModalOpen && this.state.currentModal === 'floorplans',
          onModalClose: this.toggleModal,
          modalTrigger: this.floorplanTrigger
        }, _react2.default.createElement(_Carousel.Carousel, {
          fullWidth: true,
          centerMode: false,
          heroDesign: true
        }, this.props.floorplanImages.map(function (image) {
          return _react2.default.createElement('figure', {
            key: (0, _generic.randomStr)(),
            className: 'gr-floorplan__figure'
          }, _react2.default.createElement(_Img.Img, {
            src: image.imageurl,
            isFluid: true,
            className: 'gr-floorplan__floorplan-image'
          }), image.text && _react2.default.createElement('figcaption', {
            className: 'gr-floorplan__floorplan-description'
          }, image.text));
        }))));
      }
    }]);

    return FloorPlans;
  }(_react.PureComponent);

  FloorPlans.propTypes = {
    /** An array of images to be used in the main carousel. */
    apartmentImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /** The URL of the image to be used on the current slide. */
      imageurl: _propTypes2.default.string
    })),

    /** An array of images to be seen in the dialog. */
    floorplanImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      /** The URL of images in the dialog. */
      imageurl: _propTypes2.default.string,

      /** The accompanying text to the image in the dialog. */
      text: _propTypes2.default.string
    })),

    /** A small bit of text seen below the floorplan button. */
    text: _propTypes2.default.string,
    url: _propTypes2.default.string
  };
  FloorPlans.defaultProps = {
    apartmentImages: [],
    floorplanImages: [],
    text: null,
    url: null
  };
  exports.default = FloorPlans;
  /***/
},
/* 503 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _slider = __webpack_require__(504);

  var _slider2 = _interopRequireDefault(_slider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _slider2.default;
  /***/
},
/* 504 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    exports.__esModule = true;

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _react = __webpack_require__(1);

    var _react2 = _interopRequireDefault(_react);

    var _innerSlider = __webpack_require__(505);

    var _json2mq = __webpack_require__(518);

    var _json2mq2 = _interopRequireDefault(_json2mq);

    var _defaultProps = __webpack_require__(520);

    var _defaultProps2 = _interopRequireDefault(_defaultProps);

    var _innerSliderUtils = __webpack_require__(91);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(521);

    var Slider = function (_React$Component) {
      _inherits(Slider, _React$Component);

      function Slider(props) {
        _classCallCheck(this, Slider);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.innerSliderRefHandler = function (ref) {
          return _this.innerSlider = ref;
        };

        _this.slickPrev = function () {
          return _this.innerSlider.slickPrev();
        };

        _this.slickNext = function () {
          return _this.innerSlider.slickNext();
        };

        _this.slickGoTo = function (slide) {
          var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          return _this.innerSlider.slickGoTo(slide, dontAnimate);
        };

        _this.slickPause = function () {
          return _this.innerSlider.pause("paused");
        };

        _this.slickPlay = function () {
          return _this.innerSlider.autoPlay("play");
        };

        _this.state = {
          breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
      }

      Slider.prototype.media = function media(query, handler) {
        // javascript handler for  css media query
        enquire.register(query, handler);

        this._responsiveMediaHandlers.push({
          query: query,
          handler: handler
        });
      }; // handles responsive breakpoints


      Slider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this; // performance monitoring
        //if (process.env.NODE_ENV !== 'production') {
        //const { whyDidYouUpdate } = require('why-did-you-update')
        //whyDidYouUpdate(React)
        //}


        if (this.props.responsive) {
          var breakpoints = this.props.responsive.map(function (breakpt) {
            return breakpt.breakpoint;
          }); // sort them in increasing order of their numerical value

          breakpoints.sort(function (x, y) {
            return x - y;
          });
          breakpoints.forEach(function (breakpoint, index) {
            // media query for each breakpoint
            var bQuery = void 0;

            if (index === 0) {
              bQuery = (0, _json2mq2.default)({
                minWidth: 0,
                maxWidth: breakpoint
              });
            } else {
              bQuery = (0, _json2mq2.default)({
                minWidth: breakpoints[index - 1] + 1,
                maxWidth: breakpoint
              });
            } // when not using server side rendering


            (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
              _this2.setState({
                breakpoint: breakpoint
              });
            });
          }); // Register media query for full screen. Need to support resize from small to large
          // convert javascript object to media query string

          var query = (0, _json2mq2.default)({
            minWidth: breakpoints.slice(-1)[0]
          });
          (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
            _this2.setState({
              breakpoint: null
            });
          });
        }
      };

      Slider.prototype.componentWillUnmount = function componentWillUnmount() {
        this._responsiveMediaHandlers.forEach(function (obj) {
          enquire.unregister(obj.query, obj.handler);
        });
      };

      Slider.prototype.render = function render() {
        var _this3 = this;

        var settings;
        var newProps;

        if (this.state.breakpoint) {
          newProps = this.props.responsive.filter(function (resp) {
            return resp.breakpoint === _this3.state.breakpoint;
          });
          settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
        } else {
          settings = _extends({}, _defaultProps2.default, this.props);
        } // force scrolling by one if centerMode is on


        if (settings.centerMode) {
          if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
            console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
          }

          settings.slidesToScroll = 1;
        } // force showing one slide and scrolling by one if the fade mode is on


        if (settings.fade) {
          if (settings.slidesToShow > 1 && process.env.NODE_ENV !== "production") {
            console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
          }

          if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
            console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
          }

          settings.slidesToShow = 1;
          settings.slidesToScroll = 1;
        } // makes sure that children is an array, even when there is only 1 child


        var children = _react2.default.Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
        // children may also contain string filled with spaces (in certain cases where we use jsx strings)


        children = children.filter(function (child) {
          if (typeof child === "string") {
            return !!child.trim();
          }

          return !!child;
        }); // rows and slidesPerRow logic is handled here

        if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
          console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
          settings.variableWidth = false;
        }

        var newChildren = [];
        var currentWidth = null;

        for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
          var newSlide = [];

          for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
            var row = [];

            for (var k = j; k < j + settings.slidesPerRow; k += 1) {
              if (settings.variableWidth && children[k].props.style) {
                currentWidth = children[k].props.style.width;
              }

              if (k >= children.length) break;
              row.push(_react2.default.cloneElement(children[k], {
                key: 100 * i + 10 * j + k,
                tabIndex: -1,
                style: {
                  width: 100 / settings.slidesPerRow + "%",
                  display: "inline-block"
                }
              }));
            }

            newSlide.push(_react2.default.createElement("div", {
              key: 10 * i + j
            }, row));
          }

          if (settings.variableWidth) {
            newChildren.push(_react2.default.createElement("div", {
              key: i,
              style: {
                width: currentWidth
              }
            }, newSlide));
          } else {
            newChildren.push(_react2.default.createElement("div", {
              key: i
            }, newSlide));
          }
        }

        if (settings === "unslick") {
          var className = "regular slider " + (this.props.className || "");
          return _react2.default.createElement("div", {
            className: className
          }, newChildren);
        } else if (newChildren.length <= settings.slidesToShow) {
          settings.unslick = true;
        }

        return _react2.default.createElement(_innerSlider.InnerSlider, _extends({
          ref: this.innerSliderRefHandler
        }, settings), newChildren);
      };

      return Slider;
    }(_react2.default.Component);

    exports.default = Slider;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(17));
  /***/
},
/* 505 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.InnerSlider = undefined;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _reactDom = __webpack_require__(55);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _initialState = __webpack_require__(512);

  var _initialState2 = _interopRequireDefault(_initialState);

  var _lodash = __webpack_require__(513);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _classnames = __webpack_require__(90);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _innerSliderUtils = __webpack_require__(91);

  var _track = __webpack_require__(514);

  var _dots = __webpack_require__(515);

  var _arrows = __webpack_require__(516);

  var _resizeObserverPolyfill = __webpack_require__(517);

  var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InnerSlider = exports.InnerSlider = function (_React$Component) {
    _inherits(InnerSlider, _React$Component);

    function InnerSlider(props) {
      _classCallCheck(this, InnerSlider);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.listRefHandler = function (ref) {
        return _this.list = ref;
      };

      _this.trackRefHandler = function (ref) {
        return _this.track = ref;
      };

      _this.adaptHeight = function () {
        if (_this.props.adaptiveHeight && _this.list) {
          var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");

          _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
        }
      };

      _this.componentWillMount = function () {
        _this.ssrInit();

        _this.props.onInit && _this.props.onInit();

        if (_this.props.lazyLoad) {
          var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));

          if (slidesToLoad.length > 0) {
            _this.setState(function (prevState) {
              return {
                lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
              };
            });

            if (_this.props.onLazyLoad) {
              _this.props.onLazyLoad(slidesToLoad);
            }
          }
        }
      };

      _this.componentDidMount = function () {
        var spec = _extends({
          listRef: _this.list,
          trackRef: _this.track
        }, _this.props);

        _this.updateState(spec, true, function () {
          _this.adaptHeight();

          _this.props.autoplay && _this.autoPlay("update");
        });

        if (_this.props.lazyLoad === "progressive") {
          _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
        }

        _this.ro = new _resizeObserverPolyfill2.default(function () {
          if (_this.state.animating) {
            _this.onWindowResized(false); // don't set trackStyle hence don't break animation


            _this.callbackTimers.push(setTimeout(function () {
              return _this.onWindowResized();
            }, _this.props.speed));
          } else {
            _this.onWindowResized();
          }
        });

        _this.ro.observe(_this.list);

        Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
          slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
          slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
        }); // To support server-side rendering

        if (!window) {
          return;
        }

        if (window.addEventListener) {
          window.addEventListener("resize", _this.onWindowResized);
        } else {
          window.attachEvent("onresize", _this.onWindowResized);
        }
      };

      _this.componentWillUnmount = function () {
        if (_this.animationEndCallback) {
          clearTimeout(_this.animationEndCallback);
        }

        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
        }

        if (_this.callbackTimers.length) {
          _this.callbackTimers.forEach(function (timer) {
            return clearTimeout(timer);
          });

          _this.callbackTimers = [];
        }

        if (window.addEventListener) {
          window.removeEventListener("resize", _this.onWindowResized);
        } else {
          window.detachEvent("onresize", _this.onWindowResized);
        }

        if (_this.autoplayTimer) {
          clearInterval(_this.autoplayTimer);
        }
      };

      _this.componentWillReceiveProps = function (nextProps) {
        var spec = _extends({
          listRef: _this.list,
          trackRef: _this.track
        }, nextProps, _this.state);

        var setTrackStyle = false;

        for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var key = _ref;

          if (!nextProps.hasOwnProperty(key)) {
            setTrackStyle = true;
            break;
          }

          if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
            continue;
          }

          if (nextProps[key] !== _this.props[key]) {
            setTrackStyle = true;
            break;
          }
        }

        _this.updateState(spec, setTrackStyle, function () {
          if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
            _this.changeSlide({
              message: "index",
              index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
              currentSlide: _this.state.currentSlide
            });
          }

          if (nextProps.autoplay) {
            _this.autoPlay("update");
          } else {
            _this.pause("paused");
          }
        });
      };

      _this.componentDidUpdate = function () {
        _this.checkImagesLoad();

        _this.props.onReInit && _this.props.onReInit();

        if (_this.props.lazyLoad) {
          var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));

          if (slidesToLoad.length > 0) {
            _this.setState(function (prevState) {
              return {
                lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
              };
            });

            if (_this.props.onLazyLoad) {
              _this.props.onLazyLoad(slidesToLoad);
            }
          }
        } // if (this.props.onLazyLoad) {
        //   this.props.onLazyLoad([leftMostSlide])
        // }


        _this.adaptHeight();
      };

      _this.onWindowResized = function (setTrackStyle) {
        if (_this.debouncedResize) _this.debouncedResize.cancel();
        _this.debouncedResize = (0, _lodash2.default)(function () {
          return _this.resizeWindow(setTrackStyle);
        }, 50);

        _this.debouncedResize();
      };

      _this.resizeWindow = function () {
        var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        if (!_reactDom2.default.findDOMNode(_this.track)) return;

        var spec = _extends({
          listRef: _this.list,
          trackRef: _this.track
        }, _this.props, _this.state);

        _this.updateState(spec, setTrackStyle, function () {
          if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
        }); // animating state should be cleared while resizing, otherwise autoplay stops working


        _this.setState({
          animating: false
        });

        clearTimeout(_this.animationEndCallback);
        delete _this.animationEndCallback;
      };

      _this.updateState = function (spec, setTrackStyle, callback) {
        var updatedState = (0, _innerSliderUtils.initializedState)(spec);
        spec = _extends({}, spec, updatedState, {
          slideIndex: updatedState.currentSlide
        });
        var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
        spec = _extends({}, spec, {
          left: targetLeft
        });
        var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

        if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
          updatedState["trackStyle"] = trackStyle;
        }

        _this.setState(updatedState, callback);
      };

      _this.ssrInit = function () {
        if (_this.props.variableWidth) {
          var _trackWidth = 0,
              _trackLeft = 0;
          var childrenWidths = [];
          var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
            slideCount: _this.props.children.length
          }));
          var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
            slideCount: _this.props.children.length
          }));

          _this.props.children.forEach(function (child) {
            childrenWidths.push(child.props.style.width);
            _trackWidth += child.props.style.width;
          });

          for (var i = 0; i < preClones; i++) {
            _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
            _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
          }

          for (var _i2 = 0; _i2 < postClones; _i2++) {
            _trackWidth += childrenWidths[_i2];
          }

          for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
            _trackLeft += childrenWidths[_i3];
          }

          var _trackStyle = {
            width: _trackWidth + "px",
            left: -_trackLeft + "px"
          };

          if (_this.props.centerMode) {
            var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
            _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
          }

          _this.setState({
            trackStyle: _trackStyle
          });

          return;
        }

        var childrenCount = _react2.default.Children.count(_this.props.children);

        var spec = _extends({}, _this.props, _this.state, {
          slideCount: childrenCount
        });

        var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
        var trackWidth = 100 / _this.props.slidesToShow * slideCount;
        var slideWidth = 100 / slideCount;
        var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

        if (_this.props.centerMode) {
          trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
        }

        var trackStyle = {
          width: trackWidth + "%",
          left: trackLeft + "%"
        };

        _this.setState({
          slideWidth: slideWidth + "%",
          trackStyle: trackStyle
        });
      };

      _this.checkImagesLoad = function () {
        var images = document.querySelectorAll(".slick-slide img");
        var imagesCount = images.length,
            loadedCount = 0;
        Array.prototype.forEach.call(images, function (image) {
          var handler = function handler() {
            return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
          };

          if (!image.onclick) {
            image.onclick = function () {
              return image.parentNode.focus();
            };
          } else {
            var prevClickHandler = image.onclick;

            image.onclick = function () {
              prevClickHandler();
              image.parentNode.focus();
            };
          }

          if (!image.onload) {
            if (_this.props.lazyLoad) {
              image.onload = function () {
                _this.adaptHeight();

                _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
              };
            } else {
              image.onload = handler;

              image.onerror = function () {
                handler();
                _this.props.onLazyLoadError && _this.props.onLazyLoadError();
              };
            }
          }
        });
      };

      _this.progressiveLazyLoad = function () {
        var slidesToLoad = [];

        var spec = _extends({}, _this.props, _this.state);

        for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
          if (_this.state.lazyLoadedList.indexOf(index) < 0) {
            slidesToLoad.push(index);
            break;
          }
        }

        for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
          if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
            slidesToLoad.push(_index);
            break;
          }
        }

        if (slidesToLoad.length > 0) {
          _this.setState(function (state) {
            return {
              lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        } else {
          if (_this.lazyLoadTimer) {
            clearInterval(_this.lazyLoadTimer);
            delete _this.lazyLoadTimer;
          }
        }
      };

      _this.slideHandler = function (index) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _this$props = _this.props,
            asNavFor = _this$props.asNavFor,
            beforeChange = _this$props.beforeChange,
            onLazyLoad = _this$props.onLazyLoad,
            speed = _this$props.speed,
            afterChange = _this$props.afterChange; // capture currentslide before state is updated

        var currentSlide = _this.state.currentSlide;

        var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
          index: index
        }, _this.props, _this.state, {
          trackRef: _this.track,
          useCSS: _this.props.useCSS && !dontAnimate
        })),
            state = _slideHandler.state,
            nextState = _slideHandler.nextState;

        if (!state) return;
        beforeChange && beforeChange(currentSlide, state.currentSlide);
        var slidesToLoad = state.lazyLoadedList.filter(function (value) {
          return _this.state.lazyLoadedList.indexOf(value) < 0;
        });
        onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

        _this.setState(state, function () {
          asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
          if (!nextState) return;
          _this.animationEndCallback = setTimeout(function () {
            var animating = nextState.animating,
                firstBatch = _objectWithoutProperties(nextState, ["animating"]);

            _this.setState(firstBatch, function () {
              _this.callbackTimers.push(setTimeout(function () {
                return _this.setState({
                  animating: animating
                });
              }, 10));

              afterChange && afterChange(state.currentSlide);
              delete _this.animationEndCallback;
            });
          }, speed);
        });
      };

      _this.changeSlide = function (options) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var spec = _extends({}, _this.props, _this.state);

        var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
        if (targetSlide !== 0 && !targetSlide) return;

        if (dontAnimate === true) {
          _this.slideHandler(targetSlide, dontAnimate);
        } else {
          _this.slideHandler(targetSlide);
        }
      };

      _this.clickHandler = function (e) {
        if (_this.clickable === false) {
          e.stopPropagation();
          e.preventDefault();
        }

        _this.clickable = true;
      };

      _this.keyHandler = function (e) {
        var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
        dir !== "" && _this.changeSlide({
          message: dir
        });
      };

      _this.selectHandler = function (options) {
        _this.changeSlide(options);
      };

      _this.disableBodyScroll = function () {
        var preventDefault = function preventDefault(e) {
          e = e || window.event;
          if (e.preventDefault) e.preventDefault();
          e.returnValue = false;
        };

        window.ontouchmove = preventDefault;
      };

      _this.enableBodyScroll = function () {
        window.ontouchmove = null;
      };

      _this.swipeStart = function (e) {
        if (_this.props.verticalSwiping) {
          _this.disableBodyScroll();
        }

        var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
        state !== "" && _this.setState(state);
      };

      _this.swipeMove = function (e) {
        var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
          trackRef: _this.track,
          listRef: _this.list,
          slideIndex: _this.state.currentSlide
        }));
        if (!state) return;

        if (state["swiping"]) {
          _this.clickable = false;
        }

        _this.setState(state);
      };

      _this.swipeEnd = function (e) {
        var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
          trackRef: _this.track,
          listRef: _this.list,
          slideIndex: _this.state.currentSlide
        }));
        if (!state) return;
        var triggerSlideHandler = state["triggerSlideHandler"];
        delete state["triggerSlideHandler"];

        _this.setState(state);

        if (triggerSlideHandler === undefined) return;

        _this.slideHandler(triggerSlideHandler);

        if (_this.props.verticalSwiping) {
          _this.enableBodyScroll();
        }
      };

      _this.slickPrev = function () {
        // this and fellow methods are wrapped in setTimeout
        // to make sure initialize setState has happened before
        // any of such methods are called
        _this.callbackTimers.push(setTimeout(function () {
          return _this.changeSlide({
            message: "previous"
          });
        }, 0));
      };

      _this.slickNext = function () {
        _this.callbackTimers.push(setTimeout(function () {
          return _this.changeSlide({
            message: "next"
          });
        }, 0));
      };

      _this.slickGoTo = function (slide) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        slide = Number(slide);
        if (isNaN(slide)) return "";

        _this.callbackTimers.push(setTimeout(function () {
          return _this.changeSlide({
            message: "index",
            index: slide,
            currentSlide: _this.state.currentSlide
          }, dontAnimate);
        }, 0));
      };

      _this.play = function () {
        var nextIndex;

        if (_this.props.rtl) {
          nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
        } else {
          if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
            nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
          } else {
            return false;
          }
        }

        _this.slideHandler(nextIndex);
      };

      _this.autoPlay = function (playType) {
        if (_this.autoplayTimer) {
          clearInterval(_this.autoplayTimer);
        }

        var autoplaying = _this.state.autoplaying;

        if (playType === "update") {
          if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
            return;
          }
        } else if (playType === "leave") {
          if (autoplaying === "paused" || autoplaying === "focused") {
            return;
          }
        } else if (playType === "blur") {
          if (autoplaying === "paused" || autoplaying === "hovered") {
            return;
          }
        }

        _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

        _this.setState({
          autoplaying: "playing"
        });
      };

      _this.pause = function (pauseType) {
        if (_this.autoplayTimer) {
          clearInterval(_this.autoplayTimer);
          _this.autoplayTimer = null;
        }

        var autoplaying = _this.state.autoplaying;

        if (pauseType === "paused") {
          _this.setState({
            autoplaying: "paused"
          });
        } else if (pauseType === "focused") {
          if (autoplaying === "hovered" || autoplaying === "playing") {
            _this.setState({
              autoplaying: "focused"
            });
          }
        } else {
          // pauseType  is 'hovered'
          if (autoplaying === "playing") {
            _this.setState({
              autoplaying: "hovered"
            });
          }
        }
      };

      _this.onDotsOver = function () {
        return _this.props.autoplay && _this.pause("hovered");
      };

      _this.onDotsLeave = function () {
        return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
      };

      _this.onTrackOver = function () {
        return _this.props.autoplay && _this.pause("hovered");
      };

      _this.onTrackLeave = function () {
        return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
      };

      _this.onSlideFocus = function () {
        return _this.props.autoplay && _this.pause("focused");
      };

      _this.onSlideBlur = function () {
        return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
      };

      _this.render = function () {
        var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
          "slick-vertical": _this.props.vertical,
          "slick-initialized": true
        });

        var spec = _extends({}, _this.props, _this.state);

        var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
        var pauseOnHover = _this.props.pauseOnHover;
        trackProps = _extends({}, trackProps, {
          onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
          onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
          onMouseOver: pauseOnHover ? _this.onTrackOver : null,
          focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
        });
        var dots;

        if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
          var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
          var pauseOnDotsHover = _this.props.pauseOnDotsHover;
          dotProps = _extends({}, dotProps, {
            clickHandler: _this.changeSlide,
            onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
            onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
            onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
          });
          dots = _react2.default.createElement(_dots.Dots, dotProps);
        }

        var prevArrow, nextArrow;
        var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
        arrowProps.clickHandler = _this.changeSlide;

        if (_this.props.arrows) {
          prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
          nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
        }

        var verticalHeightStyle = null;

        if (_this.props.vertical) {
          verticalHeightStyle = {
            height: _this.state.listHeight
          };
        }

        var centerPaddingStyle = null;

        if (_this.props.vertical === false) {
          if (_this.props.centerMode === true) {
            centerPaddingStyle = {
              padding: "0px " + _this.props.centerPadding
            };
          }
        } else {
          if (_this.props.centerMode === true) {
            centerPaddingStyle = {
              padding: _this.props.centerPadding + " 0px"
            };
          }
        }

        var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);

        var touchMove = _this.props.touchMove;
        var listProps = {
          className: "slick-list",
          style: listStyle,
          onClick: _this.clickHandler,
          onMouseDown: touchMove ? _this.swipeStart : null,
          onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
          onMouseUp: touchMove ? _this.swipeEnd : null,
          onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
          onTouchStart: touchMove ? _this.swipeStart : null,
          onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
          onTouchEnd: touchMove ? _this.swipeEnd : null,
          onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
          onKeyDown: _this.props.accessibility ? _this.keyHandler : null
        };
        var innerSliderProps = {
          className: className,
          dir: "ltr"
        };

        if (_this.props.unslick) {
          listProps = {
            className: "slick-list"
          };
          innerSliderProps = {
            className: className
          };
        }

        return _react2.default.createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react2.default.createElement("div", _extends({
          ref: _this.listRefHandler
        }, listProps), _react2.default.createElement(_track.Track, _extends({
          ref: _this.trackRefHandler
        }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
      };

      _this.list = null;
      _this.track = null;
      _this.state = _extends({}, _initialState2.default, {
        currentSlide: _this.props.initialSlide,
        slideCount: _react2.default.Children.count(_this.props.children)
      });
      _this.callbackTimers = [];
      _this.clickable = true;
      _this.debouncedResize = null;
      return _this;
    }

    return InnerSlider;
  }(_react2.default.Component);
  /***/

},
/* 506 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v16.4.0
   * react-dom.production.min.js
   *
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /*
   Modernizr 3.0.0pre (Custom Build) | MIT
  */

  var aa = __webpack_require__(54),
      ca = __webpack_require__(1),
      m = __webpack_require__(178),
      p = __webpack_require__(65),
      v = __webpack_require__(53),
      da = __webpack_require__(179),
      ea = __webpack_require__(180),
      fa = __webpack_require__(181),
      ha = __webpack_require__(89);

  function A(a) {
    for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {
      c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
    }

    aa(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
  }

  ca ? void 0 : A("227");

  function ia(a, b, c, d, e, f, g, h, k) {
    this._hasCaughtError = !1;
    this._caughtError = null;
    var n = Array.prototype.slice.call(arguments, 3);

    try {
      b.apply(c, n);
    } catch (r) {
      this._caughtError = r, this._hasCaughtError = !0;
    }
  }

  var B = {
    _caughtError: null,
    _hasCaughtError: !1,
    _rethrowError: null,
    _hasRethrowError: !1,
    invokeGuardedCallback: function invokeGuardedCallback(a, b, c, d, e, f, g, h, k) {
      ia.apply(B, arguments);
    },
    invokeGuardedCallbackAndCatchFirstError: function invokeGuardedCallbackAndCatchFirstError(a, b, c, d, e, f, g, h, k) {
      B.invokeGuardedCallback.apply(this, arguments);

      if (B.hasCaughtError()) {
        var n = B.clearCaughtError();
        B._hasRethrowError || (B._hasRethrowError = !0, B._rethrowError = n);
      }
    },
    rethrowCaughtError: function rethrowCaughtError() {
      return ka.apply(B, arguments);
    },
    hasCaughtError: function hasCaughtError() {
      return B._hasCaughtError;
    },
    clearCaughtError: function clearCaughtError() {
      if (B._hasCaughtError) {
        var a = B._caughtError;
        B._caughtError = null;
        B._hasCaughtError = !1;
        return a;
      }

      A("198");
    }
  };

  function ka() {
    if (B._hasRethrowError) {
      var a = B._rethrowError;
      B._rethrowError = null;
      B._hasRethrowError = !1;
      throw a;
    }
  }

  var la = null,
      ma = {};

  function na() {
    if (la) for (var a in ma) {
      var b = ma[a],
          c = la.indexOf(a);
      -1 < c ? void 0 : A("96", a);

      if (!oa[c]) {
        b.extractEvents ? void 0 : A("97", a);
        oa[c] = b;
        c = b.eventTypes;

        for (var d in c) {
          var e = void 0;
          var f = c[d],
              g = b,
              h = d;
          pa.hasOwnProperty(h) ? A("99", h) : void 0;
          pa[h] = f;
          var k = f.phasedRegistrationNames;

          if (k) {
            for (e in k) {
              k.hasOwnProperty(e) && qa(k[e], g, h);
            }

            e = !0;
          } else f.registrationName ? (qa(f.registrationName, g, h), e = !0) : e = !1;

          e ? void 0 : A("98", d, a);
        }
      }
    }
  }

  function qa(a, b, c) {
    ra[a] ? A("100", a) : void 0;
    ra[a] = b;
    sa[a] = b.eventTypes[c].dependencies;
  }

  var oa = [],
      pa = {},
      ra = {},
      sa = {};

  function ta(a) {
    la ? A("101") : void 0;
    la = Array.prototype.slice.call(a);
    na();
  }

  function ua(a) {
    var b = !1,
        c;

    for (c in a) {
      if (a.hasOwnProperty(c)) {
        var d = a[c];
        ma.hasOwnProperty(c) && ma[c] === d || (ma[c] ? A("102", c) : void 0, ma[c] = d, b = !0);
      }
    }

    b && na();
  }

  var va = {
    plugins: oa,
    eventNameDispatchConfigs: pa,
    registrationNameModules: ra,
    registrationNameDependencies: sa,
    possibleRegistrationNames: null,
    injectEventPluginOrder: ta,
    injectEventPluginsByName: ua
  },
      wa = null,
      xa = null,
      ya = null;

  function za(a, b, c, d) {
    b = a.type || "unknown-event";
    a.currentTarget = ya(d);
    B.invokeGuardedCallbackAndCatchFirstError(b, c, void 0, a);
    a.currentTarget = null;
  }

  function Aa(a, b) {
    null == b ? A("30") : void 0;
    if (null == a) return b;

    if (Array.isArray(a)) {
      if (Array.isArray(b)) return a.push.apply(a, b), a;
      a.push(b);
      return a;
    }

    return Array.isArray(b) ? [a].concat(b) : [a, b];
  }

  function Ba(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
  }

  var Ca = null;

  function Da(a, b) {
    if (a) {
      var c = a._dispatchListeners,
          d = a._dispatchInstances;
      if (Array.isArray(c)) for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) {
        za(a, b, c[e], d[e]);
      } else c && za(a, b, c, d);
      a._dispatchListeners = null;
      a._dispatchInstances = null;
      a.isPersistent() || a.constructor.release(a);
    }
  }

  function Ea(a) {
    return Da(a, !0);
  }

  function Fa(a) {
    return Da(a, !1);
  }

  var Ga = {
    injectEventPluginOrder: ta,
    injectEventPluginsByName: ua
  };

  function Ha(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = wa(c);
    if (!d) return null;
    c = d[b];

    a: switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
        (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
        a = !d;
        break a;

      default:
        a = !1;
    }

    if (a) return null;
    c && "function" !== typeof c ? A("231", b, typeof c) : void 0;
    return c;
  }

  function Ia(a, b) {
    null !== a && (Ca = Aa(Ca, a));
    a = Ca;
    Ca = null;
    a && (b ? Ba(a, Ea) : Ba(a, Fa), Ca ? A("95") : void 0, B.rethrowCaughtError());
  }

  function Ja(a, b, c, d) {
    for (var e = null, f = 0; f < oa.length; f++) {
      var g = oa[f];
      g && (g = g.extractEvents(a, b, c, d)) && (e = Aa(e, g));
    }

    Ia(e, !1);
  }

  var Ka = {
    injection: Ga,
    getListener: Ha,
    runEventsInBatch: Ia,
    runExtractedEventsInBatch: Ja
  },
      La = Math.random().toString(36).slice(2),
      C = "__reactInternalInstance$" + La,
      Ma = "__reactEventHandlers$" + La;

  function Na(a) {
    if (a[C]) return a[C];

    for (; !a[C];) {
      if (a.parentNode) a = a.parentNode;else return null;
    }

    a = a[C];
    return 5 === a.tag || 6 === a.tag ? a : null;
  }

  function Oa(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    A("33");
  }

  function Pa(a) {
    return a[Ma] || null;
  }

  var Qa = {
    precacheFiberNode: function precacheFiberNode(a, b) {
      b[C] = a;
    },
    getClosestInstanceFromNode: Na,
    getInstanceFromNode: function getInstanceFromNode(a) {
      a = a[C];
      return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
    },
    getNodeFromInstance: Oa,
    getFiberCurrentPropsFromNode: Pa,
    updateFiberProps: function updateFiberProps(a, b) {
      a[Ma] = b;
    }
  };

  function F(a) {
    do {
      a = a.return;
    } while (a && 5 !== a.tag);

    return a ? a : null;
  }

  function Ra(a, b, c) {
    for (var d = []; a;) {
      d.push(a), a = F(a);
    }

    for (a = d.length; 0 < a--;) {
      b(d[a], "captured", c);
    }

    for (a = 0; a < d.length; a++) {
      b(d[a], "bubbled", c);
    }
  }

  function Sa(a, b, c) {
    if (b = Ha(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = Aa(c._dispatchListeners, b), c._dispatchInstances = Aa(c._dispatchInstances, a);
  }

  function Ta(a) {
    a && a.dispatchConfig.phasedRegistrationNames && Ra(a._targetInst, Sa, a);
  }

  function Ua(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
      var b = a._targetInst;
      b = b ? F(b) : null;
      Ra(b, Sa, a);
    }
  }

  function Va(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Ha(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = Aa(c._dispatchListeners, b), c._dispatchInstances = Aa(c._dispatchInstances, a));
  }

  function Xa(a) {
    a && a.dispatchConfig.registrationName && Va(a._targetInst, null, a);
  }

  function Ya(a) {
    Ba(a, Ta);
  }

  function Za(a, b, c, d) {
    if (c && d) a: {
      var e = c;

      for (var f = d, g = 0, h = e; h; h = F(h)) {
        g++;
      }

      h = 0;

      for (var k = f; k; k = F(k)) {
        h++;
      }

      for (; 0 < g - h;) {
        e = F(e), g--;
      }

      for (; 0 < h - g;) {
        f = F(f), h--;
      }

      for (; g--;) {
        if (e === f || e === f.alternate) break a;
        e = F(e);
        f = F(f);
      }

      e = null;
    } else e = null;
    f = e;

    for (e = []; c && c !== f;) {
      g = c.alternate;
      if (null !== g && g === f) break;
      e.push(c);
      c = F(c);
    }

    for (c = []; d && d !== f;) {
      g = d.alternate;
      if (null !== g && g === f) break;
      c.push(d);
      d = F(d);
    }

    for (d = 0; d < e.length; d++) {
      Va(e[d], "bubbled", a);
    }

    for (a = c.length; 0 < a--;) {
      Va(c[a], "captured", b);
    }
  }

  var $a = {
    accumulateTwoPhaseDispatches: Ya,
    accumulateTwoPhaseDispatchesSkipTarget: function accumulateTwoPhaseDispatchesSkipTarget(a) {
      Ba(a, Ua);
    },
    accumulateEnterLeaveDispatches: Za,
    accumulateDirectDispatches: function accumulateDirectDispatches(a) {
      Ba(a, Xa);
    }
  };

  function ab(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    c["ms" + a] = "MS" + b;
    c["O" + a] = "o" + b.toLowerCase();
    return c;
  }

  var bb = {
    animationend: ab("Animation", "AnimationEnd"),
    animationiteration: ab("Animation", "AnimationIteration"),
    animationstart: ab("Animation", "AnimationStart"),
    transitionend: ab("Transition", "TransitionEnd")
  },
      cb = {},
      db = {};
  m.canUseDOM && (db = document.createElement("div").style, "AnimationEvent" in window || (delete bb.animationend.animation, delete bb.animationiteration.animation, delete bb.animationstart.animation), "TransitionEvent" in window || delete bb.transitionend.transition);

  function eb(a) {
    if (cb[a]) return cb[a];
    if (!bb[a]) return a;
    var b = bb[a],
        c;

    for (c in b) {
      if (b.hasOwnProperty(c) && c in db) return cb[a] = b[c];
    }

    return a;
  }

  var fb = eb("animationend"),
      gb = eb("animationiteration"),
      hb = eb("animationstart"),
      ib = eb("transitionend"),
      jb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
      kb = null;

  function lb() {
    !kb && m.canUseDOM && (kb = "textContent" in document.documentElement ? "textContent" : "innerText");
    return kb;
  }

  var G = {
    _root: null,
    _startText: null,
    _fallbackText: null
  };

  function mb() {
    if (G._fallbackText) return G._fallbackText;
    var a,
        b = G._startText,
        c = b.length,
        d,
        e = nb(),
        f = e.length;

    for (a = 0; a < c && b[a] === e[a]; a++) {
      ;
    }

    var g = c - a;

    for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
      ;
    }

    G._fallbackText = e.slice(a, 1 < d ? 1 - d : void 0);
    return G._fallbackText;
  }

  function nb() {
    return "value" in G._root ? G._root.value : G._root[lb()];
  }

  var ob = "dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),
      pb = {
    type: null,
    target: null,
    currentTarget: v.thatReturnsNull,
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function timeStamp(a) {
      return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
  };

  function H(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;

    for (var e in a) {
      a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    }

    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? v.thatReturnsTrue : v.thatReturnsFalse;
    this.isPropagationStopped = v.thatReturnsFalse;
    return this;
  }

  p(H.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = v.thatReturnsTrue);
    },
    stopPropagation: function stopPropagation() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = v.thatReturnsTrue);
    },
    persist: function persist() {
      this.isPersistent = v.thatReturnsTrue;
    },
    isPersistent: v.thatReturnsFalse,
    destructor: function destructor() {
      var a = this.constructor.Interface,
          b;

      for (b in a) {
        this[b] = null;
      }

      for (a = 0; a < ob.length; a++) {
        this[ob[a]] = null;
      }
    }
  });
  H.Interface = pb;

  H.extend = function (a) {
    function b() {}

    function c() {
      return d.apply(this, arguments);
    }

    var d = this;
    b.prototype = d.prototype;
    var e = new b();
    p(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = p({}, d.Interface, a);
    c.extend = d.extend;
    qb(c);
    return c;
  };

  qb(H);

  function rb(a, b, c, d) {
    if (this.eventPool.length) {
      var e = this.eventPool.pop();
      this.call(e, a, b, c, d);
      return e;
    }

    return new this(a, b, c, d);
  }

  function sb(a) {
    a instanceof this ? void 0 : A("223");
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
  }

  function qb(a) {
    a.eventPool = [];
    a.getPooled = rb;
    a.release = sb;
  }

  var tb = H.extend({
    data: null
  }),
      ub = H.extend({
    data: null
  }),
      vb = [9, 13, 27, 32],
      wb = m.canUseDOM && "CompositionEvent" in window,
      xb = null;
  m.canUseDOM && "documentMode" in document && (xb = document.documentMode);
  var yb = m.canUseDOM && "TextEvent" in window && !xb,
      zb = m.canUseDOM && (!wb || xb && 8 < xb && 11 >= xb),
      Ab = String.fromCharCode(32),
      Bb = {
    beforeInput: {
      phasedRegistrationNames: {
        bubbled: "onBeforeInput",
        captured: "onBeforeInputCapture"
      },
      dependencies: ["compositionend", "keypress", "textInput", "paste"]
    },
    compositionEnd: {
      phasedRegistrationNames: {
        bubbled: "onCompositionEnd",
        captured: "onCompositionEndCapture"
      },
      dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
      phasedRegistrationNames: {
        bubbled: "onCompositionStart",
        captured: "onCompositionStartCapture"
      },
      dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
      phasedRegistrationNames: {
        bubbled: "onCompositionUpdate",
        captured: "onCompositionUpdateCapture"
      },
      dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
  },
      Cb = !1;

  function Db(a, b) {
    switch (a) {
      case "keyup":
        return -1 !== vb.indexOf(b.keyCode);

      case "keydown":
        return 229 !== b.keyCode;

      case "keypress":
      case "mousedown":
      case "blur":
        return !0;

      default:
        return !1;
    }
  }

  function Eb(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
  }

  var Fb = !1;

  function Gb(a, b) {
    switch (a) {
      case "compositionend":
        return Eb(b);

      case "keypress":
        if (32 !== b.which) return null;
        Cb = !0;
        return Ab;

      case "textInput":
        return a = b.data, a === Ab && Cb ? null : a;

      default:
        return null;
    }
  }

  function Hb(a, b) {
    if (Fb) return "compositionend" === a || !wb && Db(a, b) ? (a = mb(), G._root = null, G._startText = null, G._fallbackText = null, Fb = !1, a) : null;

    switch (a) {
      case "paste":
        return null;

      case "keypress":
        if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
          if (b.char && 1 < b.char.length) return b.char;
          if (b.which) return String.fromCharCode(b.which);
        }

        return null;

      case "compositionend":
        return zb ? null : b.data;

      default:
        return null;
    }
  }

  var Ib = {
    eventTypes: Bb,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = void 0;
      var f = void 0;
      if (wb) b: {
        switch (a) {
          case "compositionstart":
            e = Bb.compositionStart;
            break b;

          case "compositionend":
            e = Bb.compositionEnd;
            break b;

          case "compositionupdate":
            e = Bb.compositionUpdate;
            break b;
        }

        e = void 0;
      } else Fb ? Db(a, c) && (e = Bb.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = Bb.compositionStart);
      e ? (zb && (Fb || e !== Bb.compositionStart ? e === Bb.compositionEnd && Fb && (f = mb()) : (G._root = d, G._startText = nb(), Fb = !0)), e = tb.getPooled(e, b, c, d), f ? e.data = f : (f = Eb(c), null !== f && (e.data = f)), Ya(e), f = e) : f = null;
      (a = yb ? Gb(a, c) : Hb(a, c)) ? (b = ub.getPooled(Bb.beforeInput, b, c, d), b.data = a, Ya(b)) : b = null;
      return null === f ? b : null === b ? f : [f, b];
    }
  },
      Jb = null,
      Kb = {
    injectFiberControlledHostComponent: function injectFiberControlledHostComponent(a) {
      Jb = a;
    }
  },
      Lb = null,
      Mb = null;

  function Nb(a) {
    if (a = xa(a)) {
      Jb && "function" === typeof Jb.restoreControlledState ? void 0 : A("194");
      var b = wa(a.stateNode);
      Jb.restoreControlledState(a.stateNode, a.type, b);
    }
  }

  function Ob(a) {
    Lb ? Mb ? Mb.push(a) : Mb = [a] : Lb = a;
  }

  function Pb() {
    return null !== Lb || null !== Mb;
  }

  function Qb() {
    if (Lb) {
      var a = Lb,
          b = Mb;
      Mb = Lb = null;
      Nb(a);
      if (b) for (a = 0; a < b.length; a++) {
        Nb(b[a]);
      }
    }
  }

  var Rb = {
    injection: Kb,
    enqueueStateRestore: Ob,
    needsStateRestore: Pb,
    restoreStateIfNeeded: Qb
  };

  function Sb(a, b) {
    return a(b);
  }

  function Tb(a, b, c) {
    return a(b, c);
  }

  function Ub() {}

  var Vb = !1;

  function Wb(a, b) {
    if (Vb) return a(b);
    Vb = !0;

    try {
      return Sb(a, b);
    } finally {
      Vb = !1, Pb() && (Ub(), Qb());
    }
  }

  var Xb = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };

  function Yb(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!Xb[a.type] : "textarea" === b ? !0 : !1;
  }

  function Zb(a) {
    a = a.target || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
  }

  function $b(a, b) {
    if (!m.canUseDOM || b && !("addEventListener" in document)) return !1;
    a = "on" + a;
    b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
  }

  function ac(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
  }

  function bc(a) {
    var b = ac(a) ? "checked" : "value",
        c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
        d = "" + a[b];

    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
      var e = c.get,
          f = c.set;
      Object.defineProperty(a, b, {
        configurable: !0,
        get: function get() {
          return e.call(this);
        },
        set: function set(a) {
          d = "" + a;
          f.call(this, a);
        }
      });
      Object.defineProperty(a, b, {
        enumerable: c.enumerable
      });
      return {
        getValue: function getValue() {
          return d;
        },
        setValue: function setValue(a) {
          d = "" + a;
        },
        stopTracking: function stopTracking() {
          a._valueTracker = null;
          delete a[b];
        }
      };
    }
  }

  function cc(a) {
    a._valueTracker || (a._valueTracker = bc(a));
  }

  function dc(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = ac(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
  }

  var ec = ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      I = "function" === typeof Symbol && Symbol.for,
      fc = I ? Symbol.for("react.element") : 60103,
      gc = I ? Symbol.for("react.portal") : 60106,
      hc = I ? Symbol.for("react.fragment") : 60107,
      ic = I ? Symbol.for("react.strict_mode") : 60108,
      jc = I ? Symbol.for("react.profiler") : 60114,
      mc = I ? Symbol.for("react.provider") : 60109,
      nc = I ? Symbol.for("react.context") : 60110,
      oc = I ? Symbol.for("react.async_mode") : 60111,
      pc = I ? Symbol.for("react.forward_ref") : 60112,
      qc = I ? Symbol.for("react.timeout") : 60113,
      rc = "function" === typeof Symbol && Symbol.iterator;

  function sc(a) {
    if (null === a || "undefined" === typeof a) return null;
    a = rc && a[rc] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }

  function tc(a) {
    var b = a.type;
    if ("function" === typeof b) return b.displayName || b.name;
    if ("string" === typeof b) return b;

    switch (b) {
      case oc:
        return "AsyncMode";

      case nc:
        return "Context.Consumer";

      case hc:
        return "ReactFragment";

      case gc:
        return "ReactPortal";

      case jc:
        return "Profiler(" + a.pendingProps.id + ")";

      case mc:
        return "Context.Provider";

      case ic:
        return "StrictMode";

      case qc:
        return "Timeout";
    }

    if ("object" === typeof b && null !== b) switch (b.$$typeof) {
      case pc:
        return a = b.render.displayName || b.render.name || "", "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef";
    }
    return null;
  }

  function vc(a) {
    var b = "";

    do {
      a: switch (a.tag) {
        case 0:
        case 1:
        case 2:
        case 5:
          var c = a._debugOwner,
              d = a._debugSource;
          var e = tc(a);
          var f = null;
          c && (f = tc(c));
          c = d;
          e = "\n    in " + (e || "Unknown") + (c ? " (at " + c.fileName.replace(/^.*[\\\/]/, "") + ":" + c.lineNumber + ")" : f ? " (created by " + f + ")" : "");
          break a;

        default:
          e = "";
      }

      b += e;
      a = a.return;
    } while (a);

    return b;
  }

  var wc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      xc = {},
      yc = {};

  function zc(a) {
    if (yc.hasOwnProperty(a)) return !0;
    if (xc.hasOwnProperty(a)) return !1;
    if (wc.test(a)) return yc[a] = !0;
    xc[a] = !0;
    return !1;
  }

  function Ac(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;

    switch (typeof b) {
      case "function":
      case "symbol":
        return !0;

      case "boolean":
        if (d) return !1;
        if (null !== c) return !c.acceptsBooleans;
        a = a.toLowerCase().slice(0, 5);
        return "data-" !== a && "aria-" !== a;

      default:
        return !1;
    }
  }

  function Bc(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Ac(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch (c.type) {
      case 3:
        return !b;

      case 4:
        return !1 === b;

      case 5:
        return isNaN(b);

      case 6:
        return isNaN(b) || 1 > b;
    }
    return !1;
  }

  function J(a, b, c, d, e) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
  }

  var K = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
    K[a] = new J(a, 0, !1, a, null);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
    var b = a[0];
    K[b] = new J(b, 1, !1, a[1], null);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
    K[a] = new J(a, 2, !1, a.toLowerCase(), null);
  });
  ["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
    K[a] = new J(a, 2, !1, a, null);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
    K[a] = new J(a, 3, !1, a.toLowerCase(), null);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function (a) {
    K[a] = new J(a, 3, !0, a.toLowerCase(), null);
  });
  ["capture", "download"].forEach(function (a) {
    K[a] = new J(a, 4, !1, a.toLowerCase(), null);
  });
  ["cols", "rows", "size", "span"].forEach(function (a) {
    K[a] = new J(a, 6, !1, a.toLowerCase(), null);
  });
  ["rowSpan", "start"].forEach(function (a) {
    K[a] = new J(a, 5, !1, a.toLowerCase(), null);
  });
  var Cc = /[\-:]([a-z])/g;

  function Dc(a) {
    return a[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
    var b = a.replace(Cc, Dc);
    K[b] = new J(b, 1, !1, a, null);
  });
  "xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
    var b = a.replace(Cc, Dc);
    K[b] = new J(b, 1, !1, a, "http://www.w3.org/1999/xlink");
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
    var b = a.replace(Cc, Dc);
    K[b] = new J(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
  });
  K.tabIndex = new J("tabIndex", 1, !1, "tabindex", null);

  function Ec(a, b, c, d) {
    var e = K.hasOwnProperty(b) ? K[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Bc(b, c, e, d) && (c = null), d || null === e ? zc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
  }

  function Fc(a, b) {
    var c = b.checked;
    return p({}, b, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != c ? c : a._wrapperState.initialChecked
    });
  }

  function Gc(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue,
        d = null != b.checked ? b.checked : b.defaultChecked;
    c = Hc(null != b.value ? b.value : c);
    a._wrapperState = {
      initialChecked: d,
      initialValue: c,
      controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
  }

  function Ic(a, b) {
    b = b.checked;
    null != b && Ec(a, "checked", b, !1);
  }

  function Jc(a, b) {
    Ic(a, b);
    var c = Hc(b.value);
    if (null != c) if ("number" === b.type) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
    b.hasOwnProperty("value") ? Kc(a, b.type, c) : b.hasOwnProperty("defaultValue") && Kc(a, b.type, Hc(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
  }

  function Lc(a, b) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) "" === a.value && (a.value = "" + a._wrapperState.initialValue), a.defaultValue = "" + a._wrapperState.initialValue;
    b = a.name;
    "" !== b && (a.name = "");
    a.defaultChecked = !a.defaultChecked;
    a.defaultChecked = !a.defaultChecked;
    "" !== b && (a.name = b);
  }

  function Kc(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
  }

  function Hc(a) {
    switch (typeof a) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return a;

      default:
        return "";
    }
  }

  var Mc = {
    change: {
      phasedRegistrationNames: {
        bubbled: "onChange",
        captured: "onChangeCapture"
      },
      dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
  };

  function Nc(a, b, c) {
    a = H.getPooled(Mc.change, a, b, c);
    a.type = "change";
    Ob(c);
    Ya(a);
    return a;
  }

  var Oc = null,
      Pc = null;

  function Qc(a) {
    Ia(a, !1);
  }

  function Rc(a) {
    var b = Oa(a);
    if (dc(b)) return a;
  }

  function Sc(a, b) {
    if ("change" === a) return b;
  }

  var Tc = !1;
  m.canUseDOM && (Tc = $b("input") && (!document.documentMode || 9 < document.documentMode));

  function Uc() {
    Oc && (Oc.detachEvent("onpropertychange", Vc), Pc = Oc = null);
  }

  function Vc(a) {
    "value" === a.propertyName && Rc(Pc) && (a = Nc(Pc, a, Zb(a)), Wb(Qc, a));
  }

  function Wc(a, b, c) {
    "focus" === a ? (Uc(), Oc = b, Pc = c, Oc.attachEvent("onpropertychange", Vc)) : "blur" === a && Uc();
  }

  function Xc(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return Rc(Pc);
  }

  function Yc(a, b) {
    if ("click" === a) return Rc(b);
  }

  function Zc(a, b) {
    if ("input" === a || "change" === a) return Rc(b);
  }

  var $c = {
    eventTypes: Mc,
    _isInputEventSupported: Tc,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = b ? Oa(b) : window,
          f = void 0,
          g = void 0,
          h = e.nodeName && e.nodeName.toLowerCase();
      "select" === h || "input" === h && "file" === e.type ? f = Sc : Yb(e) ? Tc ? f = Zc : (f = Xc, g = Wc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = Yc);
      if (f && (f = f(a, b))) return Nc(f, c, d);
      g && g(a, e, b);
      "blur" === a && null != b && (a = b._wrapperState || e._wrapperState) && a.controlled && "number" === e.type && Kc(e, "number", e.value);
    }
  },
      ad = H.extend({
    view: null,
    detail: null
  }),
      bd = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };

  function cd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = bd[a]) ? !!b[a] : !1;
  }

  function dd() {
    return cd;
  }

  var ed = ad.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: dd,
    button: null,
    buttons: null,
    relatedTarget: function relatedTarget(a) {
      return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    }
  }),
      fd = ed.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tiltX: null,
    tiltY: null,
    pointerType: null,
    isPrimary: null
  }),
      gd = {
    mouseEnter: {
      registrationName: "onMouseEnter",
      dependencies: ["mouseout", "mouseover"]
    },
    mouseLeave: {
      registrationName: "onMouseLeave",
      dependencies: ["mouseout", "mouseover"]
    },
    pointerEnter: {
      registrationName: "onPointerEnter",
      dependencies: ["pointerout", "pointerover"]
    },
    pointerLeave: {
      registrationName: "onPointerLeave",
      dependencies: ["pointerout", "pointerover"]
    }
  },
      hd = {
    eventTypes: gd,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = "mouseover" === a || "pointerover" === a,
          f = "mouseout" === a || "pointerout" === a;
      if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;
      e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
      f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? Na(b) : null) : f = null;
      if (f === b) return null;
      var g = void 0,
          h = void 0,
          k = void 0,
          n = void 0;
      if ("mouseout" === a || "mouseover" === a) g = ed, h = gd.mouseLeave, k = gd.mouseEnter, n = "mouse";else if ("pointerout" === a || "pointerover" === a) g = fd, h = gd.pointerLeave, k = gd.pointerEnter, n = "pointer";
      a = null == f ? e : Oa(f);
      e = null == b ? e : Oa(b);
      h = g.getPooled(h, f, c, d);
      h.type = n + "leave";
      h.target = a;
      h.relatedTarget = e;
      c = g.getPooled(k, b, c, d);
      c.type = n + "enter";
      c.target = e;
      c.relatedTarget = a;
      Za(h, c, f, b);
      return [h, c];
    }
  };

  function id(a) {
    var b = a;
    if (a.alternate) for (; b.return;) {
      b = b.return;
    } else {
      if (0 !== (b.effectTag & 2)) return 1;

      for (; b.return;) {
        if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
      }
    }
    return 3 === b.tag ? 2 : 3;
  }

  function jd(a) {
    2 !== id(a) ? A("188") : void 0;
  }

  function kd(a) {
    var b = a.alternate;
    if (!b) return b = id(a), 3 === b ? A("188") : void 0, 1 === b ? null : a;

    for (var c = a, d = b;;) {
      var e = c.return,
          f = e ? e.alternate : null;
      if (!e || !f) break;

      if (e.child === f.child) {
        for (var g = e.child; g;) {
          if (g === c) return jd(e), a;
          if (g === d) return jd(e), b;
          g = g.sibling;
        }

        A("188");
      }

      if (c.return !== d.return) c = e, d = f;else {
        g = !1;

        for (var h = e.child; h;) {
          if (h === c) {
            g = !0;
            c = e;
            d = f;
            break;
          }

          if (h === d) {
            g = !0;
            d = e;
            c = f;
            break;
          }

          h = h.sibling;
        }

        if (!g) {
          for (h = f.child; h;) {
            if (h === c) {
              g = !0;
              c = f;
              d = e;
              break;
            }

            if (h === d) {
              g = !0;
              d = f;
              c = e;
              break;
            }

            h = h.sibling;
          }

          g ? void 0 : A("189");
        }
      }
      c.alternate !== d ? A("190") : void 0;
    }

    3 !== c.tag ? A("188") : void 0;
    return c.stateNode.current === c ? a : b;
  }

  function ld(a) {
    a = kd(a);
    if (!a) return null;

    for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;
      if (b.child) b.child.return = b, b = b.child;else {
        if (b === a) break;

        for (; !b.sibling;) {
          if (!b.return || b.return === a) return null;
          b = b.return;
        }

        b.sibling.return = b.return;
        b = b.sibling;
      }
    }

    return null;
  }

  function md(a) {
    a = kd(a);
    if (!a) return null;

    for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;
      if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;else {
        if (b === a) break;

        for (; !b.sibling;) {
          if (!b.return || b.return === a) return null;
          b = b.return;
        }

        b.sibling.return = b.return;
        b = b.sibling;
      }
    }

    return null;
  }

  var nd = H.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
      od = H.extend({
    clipboardData: function clipboardData(a) {
      return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
  }),
      pd = ad.extend({
    relatedTarget: null
  });

  function qd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
  }

  var rd = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
      sd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
      td = ad.extend({
    key: function key(a) {
      if (a.key) {
        var b = rd[a.key] || a.key;
        if ("Unidentified" !== b) return b;
      }

      return "keypress" === a.type ? (a = qd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? sd[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: dd,
    charCode: function charCode(a) {
      return "keypress" === a.type ? qd(a) : 0;
    },
    keyCode: function keyCode(a) {
      return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
      return "keypress" === a.type ? qd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
  }),
      ud = ed.extend({
    dataTransfer: null
  }),
      vd = ad.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: dd
  }),
      wd = H.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
      xd = ed.extend({
    deltaX: function deltaX(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
  }),
      yd = [["abort", "abort"], [fb, "animationEnd"], [gb, "animationIteration"], [hb, "animationStart"], ["canplay", "canPlay"], ["canplaythrough", "canPlayThrough"], ["drag", "drag"], ["dragenter", "dragEnter"], ["dragexit", "dragExit"], ["dragleave", "dragLeave"], ["dragover", "dragOver"], ["durationchange", "durationChange"], ["emptied", "emptied"], ["encrypted", "encrypted"], ["ended", "ended"], ["error", "error"], ["gotpointercapture", "gotPointerCapture"], ["load", "load"], ["loadeddata", "loadedData"], ["loadedmetadata", "loadedMetadata"], ["loadstart", "loadStart"], ["lostpointercapture", "lostPointerCapture"], ["mousemove", "mouseMove"], ["mouseout", "mouseOut"], ["mouseover", "mouseOver"], ["playing", "playing"], ["pointermove", "pointerMove"], ["pointerout", "pointerOut"], ["pointerover", "pointerOver"], ["progress", "progress"], ["scroll", "scroll"], ["seeking", "seeking"], ["stalled", "stalled"], ["suspend", "suspend"], ["timeupdate", "timeUpdate"], ["toggle", "toggle"], ["touchmove", "touchMove"], [ib, "transitionEnd"], ["waiting", "waiting"], ["wheel", "wheel"]],
      zd = {},
      Ad = {};

  function Bd(a, b) {
    var c = a[0];
    a = a[1];
    var d = "on" + (a[0].toUpperCase() + a.slice(1));
    b = {
      phasedRegistrationNames: {
        bubbled: d,
        captured: d + "Capture"
      },
      dependencies: [c],
      isInteractive: b
    };
    zd[a] = b;
    Ad[c] = b;
  }

  [["blur", "blur"], ["cancel", "cancel"], ["click", "click"], ["close", "close"], ["contextmenu", "contextMenu"], ["copy", "copy"], ["cut", "cut"], ["dblclick", "doubleClick"], ["dragend", "dragEnd"], ["dragstart", "dragStart"], ["drop", "drop"], ["focus", "focus"], ["input", "input"], ["invalid", "invalid"], ["keydown", "keyDown"], ["keypress", "keyPress"], ["keyup", "keyUp"], ["mousedown", "mouseDown"], ["mouseup", "mouseUp"], ["paste", "paste"], ["pause", "pause"], ["play", "play"], ["pointercancel", "pointerCancel"], ["pointerdown", "pointerDown"], ["pointerup", "pointerUp"], ["ratechange", "rateChange"], ["reset", "reset"], ["seeked", "seeked"], ["submit", "submit"], ["touchcancel", "touchCancel"], ["touchend", "touchEnd"], ["touchstart", "touchStart"], ["volumechange", "volumeChange"]].forEach(function (a) {
    Bd(a, !0);
  });
  yd.forEach(function (a) {
    Bd(a, !1);
  });
  var Cd = {
    eventTypes: zd,
    isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {
      a = Ad[a];
      return void 0 !== a && !0 === a.isInteractive;
    },
    extractEvents: function extractEvents(a, b, c, d) {
      var e = Ad[a];
      if (!e) return null;

      switch (a) {
        case "keypress":
          if (0 === qd(c)) return null;

        case "keydown":
        case "keyup":
          a = td;
          break;

        case "blur":
        case "focus":
          a = pd;
          break;

        case "click":
          if (2 === c.button) return null;

        case "dblclick":
        case "mousedown":
        case "mousemove":
        case "mouseup":
        case "mouseout":
        case "mouseover":
        case "contextmenu":
          a = ed;
          break;

        case "drag":
        case "dragend":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop":
          a = ud;
          break;

        case "touchcancel":
        case "touchend":
        case "touchmove":
        case "touchstart":
          a = vd;
          break;

        case fb:
        case gb:
        case hb:
          a = nd;
          break;

        case ib:
          a = wd;
          break;

        case "scroll":
          a = ad;
          break;

        case "wheel":
          a = xd;
          break;

        case "copy":
        case "cut":
        case "paste":
          a = od;
          break;

        case "gotpointercapture":
        case "lostpointercapture":
        case "pointercancel":
        case "pointerdown":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerup":
          a = fd;
          break;

        default:
          a = H;
      }

      b = a.getPooled(e, b, c, d);
      Ya(b);
      return b;
    }
  },
      Dd = Cd.isInteractiveTopLevelEventType,
      Ed = [];

  function Fd(a) {
    var b = a.targetInst;

    do {
      if (!b) {
        a.ancestors.push(b);
        break;
      }

      var c;

      for (c = b; c.return;) {
        c = c.return;
      }

      c = 3 !== c.tag ? null : c.stateNode.containerInfo;
      if (!c) break;
      a.ancestors.push(b);
      b = Na(c);
    } while (b);

    for (c = 0; c < a.ancestors.length; c++) {
      b = a.ancestors[c], Ja(a.topLevelType, b, a.nativeEvent, Zb(a.nativeEvent));
    }
  }

  var Gd = !0;

  function Id(a) {
    Gd = !!a;
  }

  function L(a, b) {
    if (!b) return null;
    var c = (Dd(a) ? Jd : Kd).bind(null, a);
    b.addEventListener(a, c, !1);
  }

  function Ld(a, b) {
    if (!b) return null;
    var c = (Dd(a) ? Jd : Kd).bind(null, a);
    b.addEventListener(a, c, !0);
  }

  function Jd(a, b) {
    Tb(Kd, a, b);
  }

  function Kd(a, b) {
    if (Gd) {
      var c = Zb(b);
      c = Na(c);
      null === c || "number" !== typeof c.tag || 2 === id(c) || (c = null);

      if (Ed.length) {
        var d = Ed.pop();
        d.topLevelType = a;
        d.nativeEvent = b;
        d.targetInst = c;
        a = d;
      } else a = {
        topLevelType: a,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
      };

      try {
        Wb(Fd, a);
      } finally {
        a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Ed.length && Ed.push(a);
      }
    }
  }

  var Md = {
    get _enabled() {
      return Gd;
    },

    setEnabled: Id,
    isEnabled: function isEnabled() {
      return Gd;
    },
    trapBubbledEvent: L,
    trapCapturedEvent: Ld,
    dispatchEvent: Kd
  },
      Nd = {},
      Od = 0,
      Pd = "_reactListenersID" + ("" + Math.random()).slice(2);

  function Qd(a) {
    Object.prototype.hasOwnProperty.call(a, Pd) || (a[Pd] = Od++, Nd[a[Pd]] = {});
    return Nd[a[Pd]];
  }

  function Rd(a) {
    for (; a && a.firstChild;) {
      a = a.firstChild;
    }

    return a;
  }

  function Sd(a, b) {
    var c = Rd(a);
    a = 0;

    for (var d; c;) {
      if (3 === c.nodeType) {
        d = a + c.textContent.length;
        if (a <= b && d >= b) return {
          node: c,
          offset: b - a
        };
        a = d;
      }

      a: {
        for (; c;) {
          if (c.nextSibling) {
            c = c.nextSibling;
            break a;
          }

          c = c.parentNode;
        }

        c = void 0;
      }

      c = Rd(c);
    }
  }

  function Td(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && "text" === a.type || "textarea" === b || "true" === a.contentEditable);
  }

  var Ud = m.canUseDOM && "documentMode" in document && 11 >= document.documentMode,
      Vd = {
    select: {
      phasedRegistrationNames: {
        bubbled: "onSelect",
        captured: "onSelectCapture"
      },
      dependencies: "blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
  },
      Wd = null,
      Xd = null,
      Yd = null,
      Zd = !1;

  function $d(a, b) {
    if (Zd || null == Wd || Wd !== da()) return null;
    var c = Wd;
    "selectionStart" in c && Td(c) ? c = {
      start: c.selectionStart,
      end: c.selectionEnd
    } : window.getSelection ? (c = window.getSelection(), c = {
      anchorNode: c.anchorNode,
      anchorOffset: c.anchorOffset,
      focusNode: c.focusNode,
      focusOffset: c.focusOffset
    }) : c = void 0;
    return Yd && ea(Yd, c) ? null : (Yd = c, a = H.getPooled(Vd.select, Xd, a, b), a.type = "select", a.target = Wd, Ya(a), a);
  }

  var ae = {
    eventTypes: Vd,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
          f;

      if (!(f = !e)) {
        a: {
          e = Qd(e);
          f = sa.onSelect;

          for (var g = 0; g < f.length; g++) {
            var h = f[g];

            if (!e.hasOwnProperty(h) || !e[h]) {
              e = !1;
              break a;
            }
          }

          e = !0;
        }

        f = !e;
      }

      if (f) return null;
      e = b ? Oa(b) : window;

      switch (a) {
        case "focus":
          if (Yb(e) || "true" === e.contentEditable) Wd = e, Xd = b, Yd = null;
          break;

        case "blur":
          Yd = Xd = Wd = null;
          break;

        case "mousedown":
          Zd = !0;
          break;

        case "contextmenu":
        case "mouseup":
          return Zd = !1, $d(c, d);

        case "selectionchange":
          if (Ud) break;

        case "keydown":
        case "keyup":
          return $d(c, d);
      }

      return null;
    }
  };
  Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
  wa = Qa.getFiberCurrentPropsFromNode;
  xa = Qa.getInstanceFromNode;
  ya = Qa.getNodeFromInstance;
  Ga.injectEventPluginsByName({
    SimpleEventPlugin: Cd,
    EnterLeaveEventPlugin: hd,
    ChangeEventPlugin: $c,
    SelectEventPlugin: ae,
    BeforeInputEventPlugin: Ib
  });
  var be = void 0;
  be = "object" === typeof performance && "function" === typeof performance.now ? function () {
    return performance.now();
  } : function () {
    return Date.now();
  };
  var ce = void 0,
      de = void 0;

  if (m.canUseDOM) {
    var ee = [],
        fe = 0,
        ge = {},
        he = -1,
        ie = !1,
        je = !1,
        ke = 0,
        le = 33,
        me = 33,
        ne = {
      didTimeout: !1,
      timeRemaining: function timeRemaining() {
        var a = ke - be();
        return 0 < a ? a : 0;
      }
    },
        oe = function oe(a, b) {
      if (ge[b]) try {
        a(ne);
      } finally {
        delete ge[b];
      }
    },
        pe = "__reactIdleCallback$" + Math.random().toString(36).slice(2);

    window.addEventListener("message", function (a) {
      if (a.source === window && a.data === pe && (ie = !1, 0 !== ee.length)) {
        if (0 !== ee.length && (a = be(), !(-1 === he || he > a))) {
          he = -1;
          ne.didTimeout = !0;

          for (var b = 0, c = ee.length; b < c; b++) {
            var d = ee[b],
                e = d.timeoutTime;
            -1 !== e && e <= a ? oe(d.scheduledCallback, d.callbackId) : -1 !== e && (-1 === he || e < he) && (he = e);
          }
        }

        for (a = be(); 0 < ke - a && 0 < ee.length;) {
          a = ee.shift(), ne.didTimeout = !1, oe(a.scheduledCallback, a.callbackId), a = be();
        }

        0 < ee.length && !je && (je = !0, requestAnimationFrame(qe));
      }
    }, !1);

    var qe = function qe(a) {
      je = !1;
      var b = a - ke + me;
      b < me && le < me ? (8 > b && (b = 8), me = b < le ? le : b) : le = b;
      ke = a + me;
      ie || (ie = !0, window.postMessage(pe, "*"));
    };

    ce = function ce(a, b) {
      var c = -1;
      null != b && "number" === typeof b.timeout && (c = be() + b.timeout);
      if (-1 === he || -1 !== c && c < he) he = c;
      fe++;
      b = fe;
      ee.push({
        scheduledCallback: a,
        callbackId: b,
        timeoutTime: c
      });
      ge[b] = !0;
      je || (je = !0, requestAnimationFrame(qe));
      return b;
    };

    de = function de(a) {
      delete ge[a];
    };
  } else {
    var re = 0,
        se = {};

    ce = function ce(a) {
      var b = re++,
          c = setTimeout(function () {
        a({
          timeRemaining: function timeRemaining() {
            return Infinity;
          },
          didTimeout: !1
        });
      });
      se[b] = c;
      return b;
    };

    de = function de(a) {
      var b = se[a];
      delete se[a];
      clearTimeout(b);
    };
  }

  function te(a) {
    var b = "";
    ca.Children.forEach(a, function (a) {
      null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
    });
    return b;
  }

  function ue(a, b) {
    a = p({
      children: void 0
    }, b);
    if (b = te(b.children)) a.children = b;
    return a;
  }

  function ve(a, b, c, d) {
    a = a.options;

    if (b) {
      b = {};

      for (var e = 0; e < c.length; e++) {
        b["$" + c[e]] = !0;
      }

      for (c = 0; c < a.length; c++) {
        e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
      }
    } else {
      c = "" + c;
      b = null;

      for (e = 0; e < a.length; e++) {
        if (a[e].value === c) {
          a[e].selected = !0;
          d && (a[e].defaultSelected = !0);
          return;
        }

        null !== b || a[e].disabled || (b = a[e]);
      }

      null !== b && (b.selected = !0);
    }
  }

  function we(a, b) {
    var c = b.value;
    a._wrapperState = {
      initialValue: null != c ? c : b.defaultValue,
      wasMultiple: !!b.multiple
    };
  }

  function xe(a, b) {
    null != b.dangerouslySetInnerHTML ? A("91") : void 0;
    return p({}, b, {
      value: void 0,
      defaultValue: void 0,
      children: "" + a._wrapperState.initialValue
    });
  }

  function ye(a, b) {
    var c = b.value;
    null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? A("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : A("93"), b = b[0]), c = "" + b), null == c && (c = ""));
    a._wrapperState = {
      initialValue: "" + c
    };
  }

  function ze(a, b) {
    var c = b.value;
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));
    null != b.defaultValue && (a.defaultValue = b.defaultValue);
  }

  function Ae(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && (a.value = b);
  }

  var Be = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
  };

  function Ce(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";

      case "math":
        return "http://www.w3.org/1998/Math/MathML";

      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }

  function De(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Ce(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
  }

  var Ee = void 0,
      Fe = function (a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function () {
        return a(b, c, d, e);
      });
    } : a;
  }(function (a, b) {
    if (a.namespaceURI !== Be.svg || "innerHTML" in a) a.innerHTML = b;else {
      Ee = Ee || document.createElement("div");
      Ee.innerHTML = "<svg>" + b + "</svg>";

      for (b = Ee.firstChild; a.firstChild;) {
        a.removeChild(a.firstChild);
      }

      for (; b.firstChild;) {
        a.appendChild(b.firstChild);
      }
    }
  });

  function Ge(a, b) {
    if (b) {
      var c = a.firstChild;

      if (c && c === a.lastChild && 3 === c.nodeType) {
        c.nodeValue = b;
        return;
      }
    }

    a.textContent = b;
  }

  var He = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
      Ie = ["Webkit", "ms", "Moz", "O"];
  Object.keys(He).forEach(function (a) {
    Ie.forEach(function (b) {
      b = b + a.charAt(0).toUpperCase() + a.substring(1);
      He[b] = He[a];
    });
  });

  function Je(a, b) {
    a = a.style;

    for (var c in b) {
      if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--");
        var e = c;
        var f = b[c];
        e = null == f || "boolean" === typeof f || "" === f ? "" : d || "number" !== typeof f || 0 === f || He.hasOwnProperty(e) && He[e] ? ("" + f).trim() : f + "px";
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
      }
    }
  }

  var Ke = p({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });

  function Le(a, b, c) {
    b && (Ke[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? A("137", a, c()) : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? A("60") : void 0, "object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML ? void 0 : A("61")), null != b.style && "object" !== typeof b.style ? A("62", c()) : void 0);
  }

  function Me(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;

    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;

      default:
        return !0;
    }
  }

  var Ne = v.thatReturns("");

  function Oe(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = Qd(a);
    b = sa[b];

    for (var d = 0; d < b.length; d++) {
      var e = b[d];

      if (!c.hasOwnProperty(e) || !c[e]) {
        switch (e) {
          case "scroll":
            Ld("scroll", a);
            break;

          case "focus":
          case "blur":
            Ld("focus", a);
            Ld("blur", a);
            c.blur = !0;
            c.focus = !0;
            break;

          case "cancel":
          case "close":
            $b(e, !0) && Ld(e, a);
            break;

          case "invalid":
          case "submit":
          case "reset":
            break;

          default:
            -1 === jb.indexOf(e) && L(e, a);
        }

        c[e] = !0;
      }
    }
  }

  function Pe(a, b, c, d) {
    c = 9 === c.nodeType ? c : c.ownerDocument;
    d === Be.html && (d = Ce(a));
    d === Be.html ? "script" === a ? (a = c.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : a = "string" === typeof b.is ? c.createElement(a, {
      is: b.is
    }) : c.createElement(a) : a = c.createElementNS(d, a);
    return a;
  }

  function Qe(a, b) {
    return (9 === b.nodeType ? b : b.ownerDocument).createTextNode(a);
  }

  function Re(a, b, c, d) {
    var e = Me(b, c);

    switch (b) {
      case "iframe":
      case "object":
        L("load", a);
        var f = c;
        break;

      case "video":
      case "audio":
        for (f = 0; f < jb.length; f++) {
          L(jb[f], a);
        }

        f = c;
        break;

      case "source":
        L("error", a);
        f = c;
        break;

      case "img":
      case "image":
      case "link":
        L("error", a);
        L("load", a);
        f = c;
        break;

      case "form":
        L("reset", a);
        L("submit", a);
        f = c;
        break;

      case "details":
        L("toggle", a);
        f = c;
        break;

      case "input":
        Gc(a, c);
        f = Fc(a, c);
        L("invalid", a);
        Oe(d, "onChange");
        break;

      case "option":
        f = ue(a, c);
        break;

      case "select":
        we(a, c);
        f = p({}, c, {
          value: void 0
        });
        L("invalid", a);
        Oe(d, "onChange");
        break;

      case "textarea":
        ye(a, c);
        f = xe(a, c);
        L("invalid", a);
        Oe(d, "onChange");
        break;

      default:
        f = c;
    }

    Le(b, f, Ne);
    var g = f,
        h;

    for (h in g) {
      if (g.hasOwnProperty(h)) {
        var k = g[h];
        "style" === h ? Je(a, k, Ne) : "dangerouslySetInnerHTML" === h ? (k = k ? k.__html : void 0, null != k && Fe(a, k)) : "children" === h ? "string" === typeof k ? ("textarea" !== b || "" !== k) && Ge(a, k) : "number" === typeof k && Ge(a, "" + k) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (ra.hasOwnProperty(h) ? null != k && Oe(d, h) : null != k && Ec(a, h, k, e));
      }
    }

    switch (b) {
      case "input":
        cc(a);
        Lc(a, c);
        break;

      case "textarea":
        cc(a);
        Ae(a, c);
        break;

      case "option":
        null != c.value && a.setAttribute("value", c.value);
        break;

      case "select":
        a.multiple = !!c.multiple;
        b = c.value;
        null != b ? ve(a, !!c.multiple, b, !1) : null != c.defaultValue && ve(a, !!c.multiple, c.defaultValue, !0);
        break;

      default:
        "function" === typeof f.onClick && (a.onclick = v);
    }
  }

  function Se(a, b, c, d, e) {
    var f = null;

    switch (b) {
      case "input":
        c = Fc(a, c);
        d = Fc(a, d);
        f = [];
        break;

      case "option":
        c = ue(a, c);
        d = ue(a, d);
        f = [];
        break;

      case "select":
        c = p({}, c, {
          value: void 0
        });
        d = p({}, d, {
          value: void 0
        });
        f = [];
        break;

      case "textarea":
        c = xe(a, c);
        d = xe(a, d);
        f = [];
        break;

      default:
        "function" !== typeof c.onClick && "function" === typeof d.onClick && (a.onclick = v);
    }

    Le(b, d, Ne);
    b = a = void 0;
    var g = null;

    for (a in c) {
      if (!d.hasOwnProperty(a) && c.hasOwnProperty(a) && null != c[a]) if ("style" === a) {
        var h = c[a];

        for (b in h) {
          h.hasOwnProperty(b) && (g || (g = {}), g[b] = "");
        }
      } else "dangerouslySetInnerHTML" !== a && "children" !== a && "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (ra.hasOwnProperty(a) ? f || (f = []) : (f = f || []).push(a, null));
    }

    for (a in d) {
      var k = d[a];
      h = null != c ? c[a] : void 0;
      if (d.hasOwnProperty(a) && k !== h && (null != k || null != h)) if ("style" === a) {
        if (h) {
          for (b in h) {
            !h.hasOwnProperty(b) || k && k.hasOwnProperty(b) || (g || (g = {}), g[b] = "");
          }

          for (b in k) {
            k.hasOwnProperty(b) && h[b] !== k[b] && (g || (g = {}), g[b] = k[b]);
          }
        } else g || (f || (f = []), f.push(a, g)), g = k;
      } else "dangerouslySetInnerHTML" === a ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(a, "" + k)) : "children" === a ? h === k || "string" !== typeof k && "number" !== typeof k || (f = f || []).push(a, "" + k) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && (ra.hasOwnProperty(a) ? (null != k && Oe(e, a), f || h === k || (f = [])) : (f = f || []).push(a, k));
    }

    g && (f = f || []).push("style", g);
    return f;
  }

  function Te(a, b, c, d, e) {
    "input" === c && "radio" === e.type && null != e.name && Ic(a, e);
    Me(c, d);
    d = Me(c, e);

    for (var f = 0; f < b.length; f += 2) {
      var g = b[f],
          h = b[f + 1];
      "style" === g ? Je(a, h, Ne) : "dangerouslySetInnerHTML" === g ? Fe(a, h) : "children" === g ? Ge(a, h) : Ec(a, g, h, d);
    }

    switch (c) {
      case "input":
        Jc(a, e);
        break;

      case "textarea":
        ze(a, e);
        break;

      case "select":
        a._wrapperState.initialValue = void 0, b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? ve(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? ve(a, !!e.multiple, e.defaultValue, !0) : ve(a, !!e.multiple, e.multiple ? [] : "", !1));
    }
  }

  function Ue(a, b, c, d, e) {
    switch (b) {
      case "iframe":
      case "object":
        L("load", a);
        break;

      case "video":
      case "audio":
        for (d = 0; d < jb.length; d++) {
          L(jb[d], a);
        }

        break;

      case "source":
        L("error", a);
        break;

      case "img":
      case "image":
      case "link":
        L("error", a);
        L("load", a);
        break;

      case "form":
        L("reset", a);
        L("submit", a);
        break;

      case "details":
        L("toggle", a);
        break;

      case "input":
        Gc(a, c);
        L("invalid", a);
        Oe(e, "onChange");
        break;

      case "select":
        we(a, c);
        L("invalid", a);
        Oe(e, "onChange");
        break;

      case "textarea":
        ye(a, c), L("invalid", a), Oe(e, "onChange");
    }

    Le(b, c, Ne);
    d = null;

    for (var f in c) {
      if (c.hasOwnProperty(f)) {
        var g = c[f];
        "children" === f ? "string" === typeof g ? a.textContent !== g && (d = ["children", g]) : "number" === typeof g && a.textContent !== "" + g && (d = ["children", "" + g]) : ra.hasOwnProperty(f) && null != g && Oe(e, f);
      }
    }

    switch (b) {
      case "input":
        cc(a);
        Lc(a, c);
        break;

      case "textarea":
        cc(a);
        Ae(a, c);
        break;

      case "select":
      case "option":
        break;

      default:
        "function" === typeof c.onClick && (a.onclick = v);
    }

    return d;
  }

  function Ve(a, b) {
    return a.nodeValue !== b;
  }

  var We = {
    createElement: Pe,
    createTextNode: Qe,
    setInitialProperties: Re,
    diffProperties: Se,
    updateProperties: Te,
    diffHydratedProperties: Ue,
    diffHydratedText: Ve,
    warnForUnmatchedText: function warnForUnmatchedText() {},
    warnForDeletedHydratableElement: function warnForDeletedHydratableElement() {},
    warnForDeletedHydratableText: function warnForDeletedHydratableText() {},
    warnForInsertedHydratedElement: function warnForInsertedHydratedElement() {},
    warnForInsertedHydratedText: function warnForInsertedHydratedText() {},
    restoreControlledState: function restoreControlledState(a, b, c) {
      switch (b) {
        case "input":
          Jc(a, c);
          b = c.name;

          if ("radio" === c.type && null != b) {
            for (c = a; c.parentNode;) {
              c = c.parentNode;
            }

            c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

            for (b = 0; b < c.length; b++) {
              var d = c[b];

              if (d !== a && d.form === a.form) {
                var e = Pa(d);
                e ? void 0 : A("90");
                dc(d);
                Jc(d, e);
              }
            }
          }

          break;

        case "textarea":
          ze(a, c);
          break;

        case "select":
          b = c.value, null != b && ve(a, !!c.multiple, b, !1);
      }
    }
  },
      Xe = null,
      Ye = null;

  function Ze(a, b) {
    switch (a) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!b.autoFocus;
    }

    return !1;
  }

  function $e(a, b) {
    return "textarea" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && "string" === typeof b.dangerouslySetInnerHTML.__html;
  }

  var af = be,
      bf = ce,
      cf = de;

  function df(a) {
    for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
      a = a.nextSibling;
    }

    return a;
  }

  function ef(a) {
    for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
      a = a.nextSibling;
    }

    return a;
  }

  new Set();
  var ff = [],
      gf = -1;

  function hf(a) {
    return {
      current: a
    };
  }

  function M(a) {
    0 > gf || (a.current = ff[gf], ff[gf] = null, gf--);
  }

  function N(a, b) {
    gf++;
    ff[gf] = a.current;
    a.current = b;
  }

  var jf = hf(ha),
      O = hf(!1),
      kf = ha;

  function lf(a) {
    return mf(a) ? kf : jf.current;
  }

  function nf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return ha;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {},
        f;

    for (f in c) {
      e[f] = b[f];
    }

    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
  }

  function mf(a) {
    return 2 === a.tag && null != a.type.childContextTypes;
  }

  function of(a) {
    mf(a) && (M(O, a), M(jf, a));
  }

  function pf(a) {
    M(O, a);
    M(jf, a);
  }

  function qf(a, b, c) {
    jf.current !== ha ? A("168") : void 0;
    N(jf, b, a);
    N(O, c, a);
  }

  function rf(a, b) {
    var c = a.stateNode,
        d = a.type.childContextTypes;
    if ("function" !== typeof c.getChildContext) return b;
    c = c.getChildContext();

    for (var e in c) {
      e in d ? void 0 : A("108", tc(a) || "Unknown", e);
    }

    return p({}, b, c);
  }

  function sf(a) {
    if (!mf(a)) return !1;
    var b = a.stateNode;
    b = b && b.__reactInternalMemoizedMergedChildContext || ha;
    kf = jf.current;
    N(jf, b, a);
    N(O, O.current, a);
    return !0;
  }

  function tf(a, b) {
    var c = a.stateNode;
    c ? void 0 : A("169");

    if (b) {
      var d = rf(a, kf);
      c.__reactInternalMemoizedMergedChildContext = d;
      M(O, a);
      M(jf, a);
      N(jf, d, a);
    } else M(O, a);

    N(O, b, a);
  }

  function uf(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.expirationTime = 0;
    this.alternate = null;
  }

  function vf(a, b, c) {
    var d = a.alternate;
    null === d ? (d = new uf(a.tag, b, a.key, a.mode), d.type = a.type, d.stateNode = a.stateNode, d.alternate = a, a.alternate = d) : (d.pendingProps = b, d.effectTag = 0, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null);
    d.expirationTime = c;
    d.child = a.child;
    d.memoizedProps = a.memoizedProps;
    d.memoizedState = a.memoizedState;
    d.updateQueue = a.updateQueue;
    d.sibling = a.sibling;
    d.index = a.index;
    d.ref = a.ref;
    return d;
  }

  function wf(a, b, c) {
    var d = a.type,
        e = a.key;
    a = a.props;
    if ("function" === typeof d) var f = d.prototype && d.prototype.isReactComponent ? 2 : 0;else if ("string" === typeof d) f = 5;else switch (d) {
      case hc:
        return xf(a.children, b, c, e);

      case oc:
        f = 11;
        b |= 3;
        break;

      case ic:
        f = 11;
        b |= 2;
        break;

      case jc:
        return d = new uf(15, a, e, b | 4), d.type = jc, d.expirationTime = c, d;

      case qc:
        f = 16;
        b |= 2;
        break;

      default:
        a: {
          switch ("object" === typeof d && null !== d ? d.$$typeof : null) {
            case mc:
              f = 13;
              break a;

            case nc:
              f = 12;
              break a;

            case pc:
              f = 14;
              break a;

            default:
              A("130", null == d ? d : typeof d, "");
          }

          f = void 0;
        }

    }
    b = new uf(f, a, e, b);
    b.type = d;
    b.expirationTime = c;
    return b;
  }

  function xf(a, b, c, d) {
    a = new uf(10, a, d, b);
    a.expirationTime = c;
    return a;
  }

  function yf(a, b, c) {
    a = new uf(6, a, null, b);
    a.expirationTime = c;
    return a;
  }

  function zf(a, b, c) {
    b = new uf(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
      containerInfo: a.containerInfo,
      pendingChildren: null,
      implementation: a.implementation
    };
    return b;
  }

  function Af(a, b, c) {
    b = new uf(3, null, null, b ? 3 : 0);
    a = {
      current: b,
      containerInfo: a,
      pendingChildren: null,
      earliestPendingTime: 0,
      latestPendingTime: 0,
      earliestSuspendedTime: 0,
      latestSuspendedTime: 0,
      latestPingedTime: 0,
      pendingCommitExpirationTime: 0,
      finishedWork: null,
      context: null,
      pendingContext: null,
      hydrate: c,
      remainingExpirationTime: 0,
      firstBatch: null,
      nextScheduledRoot: null
    };
    return b.stateNode = a;
  }

  var Bf = null,
      Cf = null;

  function Df(a) {
    return function (b) {
      try {
        return a(b);
      } catch (c) {}
    };
  }

  function Ef(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;

    try {
      var c = b.inject(a);
      Bf = Df(function (a) {
        return b.onCommitFiberRoot(c, a);
      });
      Cf = Df(function (a) {
        return b.onCommitFiberUnmount(c, a);
      });
    } catch (d) {}

    return !0;
  }

  function Ff(a) {
    "function" === typeof Bf && Bf(a);
  }

  function Gf(a) {
    "function" === typeof Cf && Cf(a);
  }

  var Hf = !1;

  function If(a) {
    return {
      expirationTime: 0,
      baseState: a,
      firstUpdate: null,
      lastUpdate: null,
      firstCapturedUpdate: null,
      lastCapturedUpdate: null,
      firstEffect: null,
      lastEffect: null,
      firstCapturedEffect: null,
      lastCapturedEffect: null
    };
  }

  function Jf(a) {
    return {
      expirationTime: a.expirationTime,
      baseState: a.baseState,
      firstUpdate: a.firstUpdate,
      lastUpdate: a.lastUpdate,
      firstCapturedUpdate: null,
      lastCapturedUpdate: null,
      firstEffect: null,
      lastEffect: null,
      firstCapturedEffect: null,
      lastCapturedEffect: null
    };
  }

  function Kf(a) {
    return {
      expirationTime: a,
      tag: 0,
      payload: null,
      callback: null,
      next: null,
      nextEffect: null
    };
  }

  function Lf(a, b, c) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
    if (0 === a.expirationTime || a.expirationTime > c) a.expirationTime = c;
  }

  function Mf(a, b, c) {
    var d = a.alternate;

    if (null === d) {
      var e = a.updateQueue;
      var f = null;
      null === e && (e = a.updateQueue = If(a.memoizedState));
    } else e = a.updateQueue, f = d.updateQueue, null === e ? null === f ? (e = a.updateQueue = If(a.memoizedState), f = d.updateQueue = If(d.memoizedState)) : e = a.updateQueue = Jf(f) : null === f && (f = d.updateQueue = Jf(e));

    null === f || e === f ? Lf(e, b, c) : null === e.lastUpdate || null === f.lastUpdate ? (Lf(e, b, c), Lf(f, b, c)) : (Lf(e, b, c), f.lastUpdate = b);
  }

  function Nf(a, b, c) {
    var d = a.updateQueue;
    d = null === d ? a.updateQueue = If(a.memoizedState) : Of(a, d);
    null === d.lastCapturedUpdate ? d.firstCapturedUpdate = d.lastCapturedUpdate = b : (d.lastCapturedUpdate.next = b, d.lastCapturedUpdate = b);
    if (0 === d.expirationTime || d.expirationTime > c) d.expirationTime = c;
  }

  function Of(a, b) {
    var c = a.alternate;
    null !== c && b === c.updateQueue && (b = a.updateQueue = Jf(b));
    return b;
  }

  function Pf(a, b, c, d, e, f) {
    switch (c.tag) {
      case 1:
        return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;

      case 3:
        a.effectTag = a.effectTag & -1025 | 64;

      case 0:
        a = c.payload;
        e = "function" === typeof a ? a.call(f, d, e) : a;
        if (null === e || void 0 === e) break;
        return p({}, d, e);

      case 2:
        Hf = !0;
    }

    return d;
  }

  function Qf(a, b, c, d, e) {
    Hf = !1;

    if (!(0 === b.expirationTime || b.expirationTime > e)) {
      b = Of(a, b);

      for (var f = b.baseState, g = null, h = 0, k = b.firstUpdate, n = f; null !== k;) {
        var r = k.expirationTime;

        if (r > e) {
          if (null === g && (g = k, f = n), 0 === h || h > r) h = r;
        } else n = Pf(a, b, k, n, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k));

        k = k.next;
      }

      r = null;

      for (k = b.firstCapturedUpdate; null !== k;) {
        var w = k.expirationTime;

        if (w > e) {
          if (null === r && (r = k, null === g && (f = n)), 0 === h || h > w) h = w;
        } else n = Pf(a, b, k, n, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k));

        k = k.next;
      }

      null === g && (b.lastUpdate = null);
      null === r ? b.lastCapturedUpdate = null : a.effectTag |= 32;
      null === g && null === r && (f = n);
      b.baseState = f;
      b.firstUpdate = g;
      b.firstCapturedUpdate = r;
      b.expirationTime = h;
      a.memoizedState = n;
    }
  }

  function Rf(a, b) {
    "function" !== typeof a ? A("191", a) : void 0;
    a.call(b);
  }

  function Sf(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
    a = b.firstEffect;

    for (b.firstEffect = b.lastEffect = null; null !== a;) {
      var d = a.callback;
      null !== d && (a.callback = null, Rf(d, c));
      a = a.nextEffect;
    }

    a = b.firstCapturedEffect;

    for (b.firstCapturedEffect = b.lastCapturedEffect = null; null !== a;) {
      b = a.callback, null !== b && (a.callback = null, Rf(b, c)), a = a.nextEffect;
    }
  }

  function Tf(a, b) {
    return {
      value: a,
      source: b,
      stack: vc(b)
    };
  }

  var Uf = hf(null),
      Vf = hf(null),
      Wf = hf(0);

  function Xf(a) {
    var b = a.type._context;
    N(Wf, b._changedBits, a);
    N(Vf, b._currentValue, a);
    N(Uf, a, a);
    b._currentValue = a.pendingProps.value;
    b._changedBits = a.stateNode;
  }

  function Yf(a) {
    var b = Wf.current,
        c = Vf.current;
    M(Uf, a);
    M(Vf, a);
    M(Wf, a);
    a = a.type._context;
    a._currentValue = c;
    a._changedBits = b;
  }

  var Zf = {},
      $f = hf(Zf),
      ag = hf(Zf),
      bg = hf(Zf);

  function cg(a) {
    a === Zf ? A("174") : void 0;
    return a;
  }

  function dg(a, b) {
    N(bg, b, a);
    N(ag, a, a);
    N($f, Zf, a);
    var c = b.nodeType;

    switch (c) {
      case 9:
      case 11:
        b = (b = b.documentElement) ? b.namespaceURI : De(null, "");
        break;

      default:
        c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = De(b, c);
    }

    M($f, a);
    N($f, b, a);
  }

  function eg(a) {
    M($f, a);
    M(ag, a);
    M(bg, a);
  }

  function fg(a) {
    ag.current === a && (M($f, a), M(ag, a));
  }

  function hg(a, b, c) {
    var d = a.memoizedState;
    b = b(c, d);
    d = null === b || void 0 === b ? d : p({}, d, b);
    a.memoizedState = d;
    a = a.updateQueue;
    null !== a && 0 === a.expirationTime && (a.baseState = d);
  }

  var lg = {
    isMounted: function isMounted(a) {
      return (a = a._reactInternalFiber) ? 2 === id(a) : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
      a = a._reactInternalFiber;
      var d = ig();
      d = jg(d, a);
      var e = Kf(d);
      e.payload = b;
      void 0 !== c && null !== c && (e.callback = c);
      Mf(a, e, d);
      kg(a, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
      a = a._reactInternalFiber;
      var d = ig();
      d = jg(d, a);
      var e = Kf(d);
      e.tag = 1;
      e.payload = b;
      void 0 !== c && null !== c && (e.callback = c);
      Mf(a, e, d);
      kg(a, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
      a = a._reactInternalFiber;
      var c = ig();
      c = jg(c, a);
      var d = Kf(c);
      d.tag = 2;
      void 0 !== b && null !== b && (d.callback = b);
      Mf(a, d, c);
      kg(a, c);
    }
  };

  function mg(a, b, c, d, e, f) {
    var g = a.stateNode;
    a = a.type;
    return "function" === typeof g.shouldComponentUpdate ? g.shouldComponentUpdate(c, e, f) : a.prototype && a.prototype.isPureReactComponent ? !ea(b, c) || !ea(d, e) : !0;
  }

  function ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && lg.enqueueReplaceState(b, b.state, null);
  }

  function og(a, b) {
    var c = a.type,
        d = a.stateNode,
        e = a.pendingProps,
        f = lf(a);
    d.props = e;
    d.state = a.memoizedState;
    d.refs = ha;
    d.context = nf(a, f);
    f = a.updateQueue;
    null !== f && (Qf(a, f, e, d, b), d.state = a.memoizedState);
    f = a.type.getDerivedStateFromProps;
    "function" === typeof f && (hg(a, f, e), d.state = a.memoizedState);
    "function" === typeof c.getDerivedStateFromProps || "function" === typeof d.getSnapshotBeforeUpdate || "function" !== typeof d.UNSAFE_componentWillMount && "function" !== typeof d.componentWillMount || (c = d.state, "function" === typeof d.componentWillMount && d.componentWillMount(), "function" === typeof d.UNSAFE_componentWillMount && d.UNSAFE_componentWillMount(), c !== d.state && lg.enqueueReplaceState(d, d.state, null), f = a.updateQueue, null !== f && (Qf(a, f, e, d, b), d.state = a.memoizedState));
    "function" === typeof d.componentDidMount && (a.effectTag |= 4);
  }

  var pg = Array.isArray;

  function qg(a, b, c) {
    a = c.ref;

    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
      if (c._owner) {
        c = c._owner;
        var d = void 0;
        c && (2 !== c.tag ? A("110") : void 0, d = c.stateNode);
        d ? void 0 : A("147", a);
        var e = "" + a;
        if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;

        b = function b(a) {
          var b = d.refs === ha ? d.refs = {} : d.refs;
          null === a ? delete b[e] : b[e] = a;
        };

        b._stringRef = e;
        return b;
      }

      "string" !== typeof a ? A("148") : void 0;
      c._owner ? void 0 : A("254", a);
    }

    return a;
  }

  function rg(a, b) {
    "textarea" !== a.type && A("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
  }

  function sg(a) {
    function b(b, c) {
      if (a) {
        var d = b.lastEffect;
        null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
        c.nextEffect = null;
        c.effectTag = 8;
      }
    }

    function c(c, d) {
      if (!a) return null;

      for (; null !== d;) {
        b(c, d), d = d.sibling;
      }

      return null;
    }

    function d(a, b) {
      for (a = new Map(); null !== b;) {
        null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
      }

      return a;
    }

    function e(a, b, c) {
      a = vf(a, b, c);
      a.index = 0;
      a.sibling = null;
      return a;
    }

    function f(b, c, d) {
      b.index = d;
      if (!a) return c;
      d = b.alternate;
      if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
      b.effectTag = 2;
      return c;
    }

    function g(b) {
      a && null === b.alternate && (b.effectTag = 2);
      return b;
    }

    function h(a, b, c, d) {
      if (null === b || 6 !== b.tag) return b = yf(c, a.mode, d), b.return = a, b;
      b = e(b, c, d);
      b.return = a;
      return b;
    }

    function k(a, b, c, d) {
      if (null !== b && b.type === c.type) return d = e(b, c.props, d), d.ref = qg(a, b, c), d.return = a, d;
      d = wf(c, a.mode, d);
      d.ref = qg(a, b, c);
      d.return = a;
      return d;
    }

    function n(a, b, c, d) {
      if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zf(c, a.mode, d), b.return = a, b;
      b = e(b, c.children || [], d);
      b.return = a;
      return b;
    }

    function r(a, b, c, d, f) {
      if (null === b || 10 !== b.tag) return b = xf(c, a.mode, d, f), b.return = a, b;
      b = e(b, c, d);
      b.return = a;
      return b;
    }

    function w(a, b, c) {
      if ("string" === typeof b || "number" === typeof b) return b = yf("" + b, a.mode, c), b.return = a, b;

      if ("object" === typeof b && null !== b) {
        switch (b.$$typeof) {
          case fc:
            return c = wf(b, a.mode, c), c.ref = qg(a, null, b), c.return = a, c;

          case gc:
            return b = zf(b, a.mode, c), b.return = a, b;
        }

        if (pg(b) || sc(b)) return b = xf(b, a.mode, c, null), b.return = a, b;
        rg(a, b);
      }

      return null;
    }

    function P(a, b, c, d) {
      var e = null !== b ? b.key : null;
      if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

      if ("object" === typeof c && null !== c) {
        switch (c.$$typeof) {
          case fc:
            return c.key === e ? c.type === hc ? r(a, b, c.props.children, d, e) : k(a, b, c, d) : null;

          case gc:
            return c.key === e ? n(a, b, c, d) : null;
        }

        if (pg(c) || sc(c)) return null !== e ? null : r(a, b, c, d, null);
        rg(a, c);
      }

      return null;
    }

    function kc(a, b, c, d, e) {
      if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

      if ("object" === typeof d && null !== d) {
        switch (d.$$typeof) {
          case fc:
            return a = a.get(null === d.key ? c : d.key) || null, d.type === hc ? r(b, a, d.props.children, e, d.key) : k(b, a, d, e);

          case gc:
            return a = a.get(null === d.key ? c : d.key) || null, n(b, a, d, e);
        }

        if (pg(d) || sc(d)) return a = a.get(c) || null, r(b, a, d, e, null);
        rg(b, d);
      }

      return null;
    }

    function Hd(e, g, h, k) {
      for (var u = null, x = null, t = g, q = g = 0, n = null; null !== t && q < h.length; q++) {
        t.index > q ? (n = t, t = null) : n = t.sibling;
        var l = P(e, t, h[q], k);

        if (null === l) {
          null === t && (t = n);
          break;
        }

        a && t && null === l.alternate && b(e, t);
        g = f(l, g, q);
        null === x ? u = l : x.sibling = l;
        x = l;
        t = n;
      }

      if (q === h.length) return c(e, t), u;

      if (null === t) {
        for (; q < h.length; q++) {
          if (t = w(e, h[q], k)) g = f(t, g, q), null === x ? u = t : x.sibling = t, x = t;
        }

        return u;
      }

      for (t = d(e, t); q < h.length; q++) {
        if (n = kc(t, e, q, h[q], k)) a && null !== n.alternate && t.delete(null === n.key ? q : n.key), g = f(n, g, q), null === x ? u = n : x.sibling = n, x = n;
      }

      a && t.forEach(function (a) {
        return b(e, a);
      });
      return u;
    }

    function E(e, g, h, k) {
      var t = sc(h);
      "function" !== typeof t ? A("150") : void 0;
      h = t.call(h);
      null == h ? A("151") : void 0;

      for (var u = t = null, n = g, x = g = 0, y = null, l = h.next(); null !== n && !l.done; x++, l = h.next()) {
        n.index > x ? (y = n, n = null) : y = n.sibling;
        var r = P(e, n, l.value, k);

        if (null === r) {
          n || (n = y);
          break;
        }

        a && n && null === r.alternate && b(e, n);
        g = f(r, g, x);
        null === u ? t = r : u.sibling = r;
        u = r;
        n = y;
      }

      if (l.done) return c(e, n), t;

      if (null === n) {
        for (; !l.done; x++, l = h.next()) {
          l = w(e, l.value, k), null !== l && (g = f(l, g, x), null === u ? t = l : u.sibling = l, u = l);
        }

        return t;
      }

      for (n = d(e, n); !l.done; x++, l = h.next()) {
        l = kc(n, e, x, l.value, k), null !== l && (a && null !== l.alternate && n.delete(null === l.key ? x : l.key), g = f(l, g, x), null === u ? t = l : u.sibling = l, u = l);
      }

      a && n.forEach(function (a) {
        return b(e, a);
      });
      return t;
    }

    return function (a, d, f, h) {
      "object" === typeof f && null !== f && f.type === hc && null === f.key && (f = f.props.children);
      var k = "object" === typeof f && null !== f;
      if (k) switch (f.$$typeof) {
        case fc:
          a: {
            var n = f.key;

            for (k = d; null !== k;) {
              if (k.key === n) {
                if (10 === k.tag ? f.type === hc : k.type === f.type) {
                  c(a, k.sibling);
                  d = e(k, f.type === hc ? f.props.children : f.props, h);
                  d.ref = qg(a, k, f);
                  d.return = a;
                  a = d;
                  break a;
                } else {
                  c(a, k);
                  break;
                }
              } else b(a, k);
              k = k.sibling;
            }

            f.type === hc ? (d = xf(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = wf(f, a.mode, h), h.ref = qg(a, d, f), h.return = a, a = h);
          }

          return g(a);

        case gc:
          a: {
            for (k = f.key; null !== d;) {
              if (d.key === k) {
                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                  c(a, d.sibling);
                  d = e(d, f.children || [], h);
                  d.return = a;
                  a = d;
                  break a;
                } else {
                  c(a, d);
                  break;
                }
              } else b(a, d);
              d = d.sibling;
            }

            d = zf(f, a.mode, h);
            d.return = a;
            a = d;
          }

          return g(a);
      }
      if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = yf(f, a.mode, h), d.return = a, a = d), g(a);
      if (pg(f)) return Hd(a, d, f, h);
      if (sc(f)) return E(a, d, f, h);
      k && rg(a, f);
      if ("undefined" === typeof f) switch (a.tag) {
        case 2:
        case 1:
          h = a.type, A("152", h.displayName || h.name || "Component");
      }
      return c(a, d);
    };
  }

  var tg = sg(!0),
      ug = sg(!1),
      vg = null,
      wg = null,
      xg = !1;

  function yg(a, b) {
    var c = new uf(5, null, null, 0);
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
  }

  function zg(a, b) {
    switch (a.tag) {
      case 5:
        var c = a.type;
        b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
        return null !== b ? (a.stateNode = b, !0) : !1;

      case 6:
        return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;

      default:
        return !1;
    }
  }

  function Ag(a) {
    if (xg) {
      var b = wg;

      if (b) {
        var c = b;

        if (!zg(a, b)) {
          b = df(c);

          if (!b || !zg(a, b)) {
            a.effectTag |= 2;
            xg = !1;
            vg = a;
            return;
          }

          yg(vg, c);
        }

        vg = a;
        wg = ef(b);
      } else a.effectTag |= 2, xg = !1, vg = a;
    }
  }

  function Bg(a) {
    for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag;) {
      a = a.return;
    }

    vg = a;
  }

  function Cg(a) {
    if (a !== vg) return !1;
    if (!xg) return Bg(a), xg = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$e(b, a.memoizedProps)) for (b = wg; b;) {
      yg(a, b), b = df(b);
    }
    Bg(a);
    wg = vg ? df(a.stateNode) : null;
    return !0;
  }

  function Dg() {
    wg = vg = null;
    xg = !1;
  }

  function Q(a, b, c) {
    Eg(a, b, c, b.expirationTime);
  }

  function Eg(a, b, c, d) {
    b.child = null === a ? ug(b, null, c, d) : tg(b, a.child, c, d);
  }

  function Fg(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
  }

  function Gg(a, b, c, d, e) {
    Fg(a, b);
    var f = 0 !== (b.effectTag & 64);
    if (!c && !f) return d && tf(b, !1), R(a, b);
    c = b.stateNode;
    ec.current = b;
    var g = f ? null : c.render();
    b.effectTag |= 1;
    f && (Eg(a, b, null, e), b.child = null);
    Eg(a, b, g, e);
    b.memoizedState = c.state;
    b.memoizedProps = c.props;
    d && tf(b, !0);
    return b.child;
  }

  function Hg(a) {
    var b = a.stateNode;
    b.pendingContext ? qf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && qf(a, b.context, !1);
    dg(a, b.containerInfo);
  }

  function Ig(a, b, c, d) {
    var e = a.child;
    null !== e && (e.return = a);

    for (; null !== e;) {
      switch (e.tag) {
        case 12:
          var f = e.stateNode | 0;

          if (e.type === b && 0 !== (f & c)) {
            for (f = e; null !== f;) {
              var g = f.alternate;
              if (0 === f.expirationTime || f.expirationTime > d) f.expirationTime = d, null !== g && (0 === g.expirationTime || g.expirationTime > d) && (g.expirationTime = d);else if (null !== g && (0 === g.expirationTime || g.expirationTime > d)) g.expirationTime = d;else break;
              f = f.return;
            }

            f = null;
          } else f = e.child;

          break;

        case 13:
          f = e.type === a.type ? null : e.child;
          break;

        default:
          f = e.child;
      }

      if (null !== f) f.return = e;else for (f = e; null !== f;) {
        if (f === a) {
          f = null;
          break;
        }

        e = f.sibling;

        if (null !== e) {
          e.return = f.return;
          f = e;
          break;
        }

        f = f.return;
      }
      e = f;
    }
  }

  function Jg(a, b, c) {
    var d = b.type._context,
        e = b.pendingProps,
        f = b.memoizedProps,
        g = !0;
    if (O.current) g = !1;else if (f === e) return b.stateNode = 0, Xf(b), R(a, b);
    var h = e.value;
    b.memoizedProps = e;
    if (null === f) h = 1073741823;else if (f.value === e.value) {
      if (f.children === e.children && g) return b.stateNode = 0, Xf(b), R(a, b);
      h = 0;
    } else {
      var k = f.value;

      if (k === h && (0 !== k || 1 / k === 1 / h) || k !== k && h !== h) {
        if (f.children === e.children && g) return b.stateNode = 0, Xf(b), R(a, b);
        h = 0;
      } else if (h = "function" === typeof d._calculateChangedBits ? d._calculateChangedBits(k, h) : 1073741823, h |= 0, 0 === h) {
        if (f.children === e.children && g) return b.stateNode = 0, Xf(b), R(a, b);
      } else Ig(b, d, h, c);
    }
    b.stateNode = h;
    Xf(b);
    Q(a, b, e.children);
    return b.child;
  }

  function R(a, b) {
    null !== a && b.child !== a.child ? A("153") : void 0;

    if (null !== b.child) {
      a = b.child;
      var c = vf(a, a.pendingProps, a.expirationTime);
      b.child = c;

      for (c.return = b; null !== a.sibling;) {
        a = a.sibling, c = c.sibling = vf(a, a.pendingProps, a.expirationTime), c.return = b;
      }

      c.sibling = null;
    }

    return b.child;
  }

  function Kg(a, b, c) {
    if (0 === b.expirationTime || b.expirationTime > c) {
      switch (b.tag) {
        case 3:
          Hg(b);
          break;

        case 2:
          sf(b);
          break;

        case 4:
          dg(b, b.stateNode.containerInfo);
          break;

        case 13:
          Xf(b);
      }

      return null;
    }

    switch (b.tag) {
      case 0:
        null !== a ? A("155") : void 0;
        var d = b.type,
            e = b.pendingProps,
            f = lf(b);
        f = nf(b, f);
        d = d(e, f);
        b.effectTag |= 1;
        "object" === typeof d && null !== d && "function" === typeof d.render && void 0 === d.$$typeof ? (f = b.type, b.tag = 2, b.memoizedState = null !== d.state && void 0 !== d.state ? d.state : null, f = f.getDerivedStateFromProps, "function" === typeof f && hg(b, f, e), e = sf(b), d.updater = lg, b.stateNode = d, d._reactInternalFiber = b, og(b, c), a = Gg(a, b, !0, e, c)) : (b.tag = 1, Q(a, b, d), b.memoizedProps = e, a = b.child);
        return a;

      case 1:
        return e = b.type, c = b.pendingProps, O.current || b.memoizedProps !== c ? (d = lf(b), d = nf(b, d), e = e(c, d), b.effectTag |= 1, Q(a, b, e), b.memoizedProps = c, a = b.child) : a = R(a, b), a;

      case 2:
        e = sf(b);
        if (null === a) {
          if (null === b.stateNode) {
            var g = b.pendingProps,
                h = b.type;
            d = lf(b);
            var k = 2 === b.tag && null != b.type.contextTypes;
            f = k ? nf(b, d) : ha;
            g = new h(g, f);
            b.memoizedState = null !== g.state && void 0 !== g.state ? g.state : null;
            g.updater = lg;
            b.stateNode = g;
            g._reactInternalFiber = b;
            k && (k = b.stateNode, k.__reactInternalMemoizedUnmaskedChildContext = d, k.__reactInternalMemoizedMaskedChildContext = f);
            og(b, c);
            d = !0;
          } else {
            h = b.type;
            d = b.stateNode;
            k = b.memoizedProps;
            f = b.pendingProps;
            d.props = k;
            var n = d.context;
            g = lf(b);
            g = nf(b, g);
            var r = h.getDerivedStateFromProps;
            (h = "function" === typeof r || "function" === typeof d.getSnapshotBeforeUpdate) || "function" !== typeof d.UNSAFE_componentWillReceiveProps && "function" !== typeof d.componentWillReceiveProps || (k !== f || n !== g) && ng(b, d, f, g);
            Hf = !1;
            var w = b.memoizedState;
            n = d.state = w;
            var P = b.updateQueue;
            null !== P && (Qf(b, P, f, d, c), n = b.memoizedState);
            k !== f || w !== n || O.current || Hf ? ("function" === typeof r && (hg(b, r, f), n = b.memoizedState), (k = Hf || mg(b, k, f, w, n, g)) ? (h || "function" !== typeof d.UNSAFE_componentWillMount && "function" !== typeof d.componentWillMount || ("function" === typeof d.componentWillMount && d.componentWillMount(), "function" === typeof d.UNSAFE_componentWillMount && d.UNSAFE_componentWillMount()), "function" === typeof d.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof d.componentDidMount && (b.effectTag |= 4), b.memoizedProps = f, b.memoizedState = n), d.props = f, d.state = n, d.context = g, d = k) : ("function" === typeof d.componentDidMount && (b.effectTag |= 4), d = !1);
          }
        } else h = b.type, d = b.stateNode, f = b.memoizedProps, k = b.pendingProps, d.props = f, n = d.context, g = lf(b), g = nf(b, g), r = h.getDerivedStateFromProps, (h = "function" === typeof r || "function" === typeof d.getSnapshotBeforeUpdate) || "function" !== typeof d.UNSAFE_componentWillReceiveProps && "function" !== typeof d.componentWillReceiveProps || (f !== k || n !== g) && ng(b, d, k, g), Hf = !1, n = b.memoizedState, w = d.state = n, P = b.updateQueue, null !== P && (Qf(b, P, k, d, c), w = b.memoizedState), f !== k || n !== w || O.current || Hf ? ("function" === typeof r && (hg(b, r, k), w = b.memoizedState), (r = Hf || mg(b, f, k, n, w, g)) ? (h || "function" !== typeof d.UNSAFE_componentWillUpdate && "function" !== typeof d.componentWillUpdate || ("function" === typeof d.componentWillUpdate && d.componentWillUpdate(k, w, g), "function" === typeof d.UNSAFE_componentWillUpdate && d.UNSAFE_componentWillUpdate(k, w, g)), "function" === typeof d.componentDidUpdate && (b.effectTag |= 4), "function" === typeof d.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof d.componentDidUpdate || f === a.memoizedProps && n === a.memoizedState || (b.effectTag |= 4), "function" !== typeof d.getSnapshotBeforeUpdate || f === a.memoizedProps && n === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = k, b.memoizedState = w), d.props = k, d.state = w, d.context = g, d = r) : ("function" !== typeof d.componentDidUpdate || f === a.memoizedProps && n === a.memoizedState || (b.effectTag |= 4), "function" !== typeof d.getSnapshotBeforeUpdate || f === a.memoizedProps && n === a.memoizedState || (b.effectTag |= 256), d = !1);
        return Gg(a, b, d, e, c);

      case 3:
        Hg(b);
        e = b.updateQueue;
        if (null !== e) {
          if (d = b.memoizedState, d = null !== d ? d.element : null, Qf(b, e, b.pendingProps, null, c), e = b.memoizedState.element, e === d) Dg(), a = R(a, b);else {
            d = b.stateNode;
            if (d = (null === a || null === a.child) && d.hydrate) wg = ef(b.stateNode.containerInfo), vg = b, d = xg = !0;
            d ? (b.effectTag |= 2, b.child = ug(b, null, e, c)) : (Dg(), Q(a, b, e));
            a = b.child;
          }
        } else Dg(), a = R(a, b);
        return a;

      case 5:
        a: {
          cg(bg.current);
          e = cg($f.current);
          d = De(e, b.type);
          e !== d && (N(ag, b, b), N($f, d, b));
          null === a && Ag(b);
          e = b.type;
          k = b.memoizedProps;
          d = b.pendingProps;
          f = null !== a ? a.memoizedProps : null;

          if (!O.current && k === d) {
            if (k = b.mode & 1 && !!d.hidden) b.expirationTime = 1073741823;

            if (!k || 1073741823 !== c) {
              a = R(a, b);
              break a;
            }
          }

          k = d.children;
          $e(e, d) ? k = null : f && $e(e, f) && (b.effectTag |= 16);
          Fg(a, b);
          1073741823 !== c && b.mode & 1 && d.hidden ? (b.expirationTime = 1073741823, b.memoizedProps = d, a = null) : (Q(a, b, k), b.memoizedProps = d, a = b.child);
        }

        return a;

      case 6:
        return null === a && Ag(b), b.memoizedProps = b.pendingProps, null;

      case 16:
        return null;

      case 4:
        return dg(b, b.stateNode.containerInfo), e = b.pendingProps, O.current || b.memoizedProps !== e ? (null === a ? b.child = tg(b, null, e, c) : Q(a, b, e), b.memoizedProps = e, a = b.child) : a = R(a, b), a;

      case 14:
        return e = b.type.render, c = b.pendingProps, d = b.ref, O.current || b.memoizedProps !== c || d !== (null !== a ? a.ref : null) ? (e = e(c, d), Q(a, b, e), b.memoizedProps = c, a = b.child) : a = R(a, b), a;

      case 10:
        return c = b.pendingProps, O.current || b.memoizedProps !== c ? (Q(a, b, c), b.memoizedProps = c, a = b.child) : a = R(a, b), a;

      case 11:
        return c = b.pendingProps.children, O.current || null !== c && b.memoizedProps !== c ? (Q(a, b, c), b.memoizedProps = c, a = b.child) : a = R(a, b), a;

      case 15:
        return c = b.pendingProps, b.memoizedProps === c ? a = R(a, b) : (Q(a, b, c.children), b.memoizedProps = c, a = b.child), a;

      case 13:
        return Jg(a, b, c);

      case 12:
        a: if (d = b.type, f = b.pendingProps, k = b.memoizedProps, e = d._currentValue, g = d._changedBits, O.current || 0 !== g || k !== f) {
          b.memoizedProps = f;
          h = f.unstable_observedBits;
          if (void 0 === h || null === h) h = 1073741823;
          b.stateNode = h;
          if (0 !== (g & h)) Ig(b, d, g, c);else if (k === f) {
            a = R(a, b);
            break a;
          }
          c = f.children;
          c = c(e);
          b.effectTag |= 1;
          Q(a, b, c);
          a = b.child;
        } else a = R(a, b);

        return a;

      default:
        A("156");
    }
  }

  function Lg(a) {
    a.effectTag |= 4;
  }

  var Pg = void 0,
      Qg = void 0,
      Rg = void 0;

  Pg = function Pg() {};

  Qg = function Qg(a, b, c) {
    (b.updateQueue = c) && Lg(b);
  };

  Rg = function Rg(a, b, c, d) {
    c !== d && Lg(b);
  };

  function Sg(a, b) {
    var c = b.pendingProps;

    switch (b.tag) {
      case 1:
        return null;

      case 2:
        return of(b), null;

      case 3:
        eg(b);
        pf(b);
        var d = b.stateNode;
        d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
        if (null === a || null === a.child) Cg(b), b.effectTag &= -3;
        Pg(b);
        return null;

      case 5:
        fg(b);
        d = cg(bg.current);
        var e = b.type;

        if (null !== a && null != b.stateNode) {
          var f = a.memoizedProps,
              g = b.stateNode,
              h = cg($f.current);
          g = Se(g, e, f, c, d);
          Qg(a, b, g, e, f, c, d, h);
          a.ref !== b.ref && (b.effectTag |= 128);
        } else {
          if (!c) return null === b.stateNode ? A("166") : void 0, null;
          a = cg($f.current);
          if (Cg(b)) c = b.stateNode, e = b.type, f = b.memoizedProps, c[C] = b, c[Ma] = f, d = Ue(c, e, f, a, d), b.updateQueue = d, null !== d && Lg(b);else {
            a = Pe(e, c, d, a);
            a[C] = b;
            a[Ma] = c;

            a: for (f = b.child; null !== f;) {
              if (5 === f.tag || 6 === f.tag) a.appendChild(f.stateNode);else if (4 !== f.tag && null !== f.child) {
                f.child.return = f;
                f = f.child;
                continue;
              }
              if (f === b) break;

              for (; null === f.sibling;) {
                if (null === f.return || f.return === b) break a;
                f = f.return;
              }

              f.sibling.return = f.return;
              f = f.sibling;
            }

            Re(a, e, c, d);
            Ze(e, c) && Lg(b);
            b.stateNode = a;
          }
          null !== b.ref && (b.effectTag |= 128);
        }

        return null;

      case 6:
        if (a && null != b.stateNode) Rg(a, b, a.memoizedProps, c);else {
          if ("string" !== typeof c) return null === b.stateNode ? A("166") : void 0, null;
          d = cg(bg.current);
          cg($f.current);
          Cg(b) ? (d = b.stateNode, c = b.memoizedProps, d[C] = b, Ve(d, c) && Lg(b)) : (d = Qe(c, d), d[C] = b, b.stateNode = d);
        }
        return null;

      case 14:
        return null;

      case 16:
        return null;

      case 10:
        return null;

      case 11:
        return null;

      case 15:
        return null;

      case 4:
        return eg(b), Pg(b), null;

      case 13:
        return Yf(b), null;

      case 12:
        return null;

      case 0:
        A("167");

      default:
        A("156");
    }
  }

  function Tg(a, b) {
    var c = b.source;
    null === b.stack && null !== c && vc(c);
    null !== c && tc(c);
    b = b.value;
    null !== a && 2 === a.tag && tc(a);

    try {
      b && b.suppressReactErrorLogging || console.error(b);
    } catch (d) {
      d && d.suppressReactErrorLogging || console.error(d);
    }
  }

  function Ug(a) {
    var b = a.ref;
    if (null !== b) if ("function" === typeof b) try {
      b(null);
    } catch (c) {
      Vg(a, c);
    } else b.current = null;
  }

  function Wg(a) {
    "function" === typeof Gf && Gf(a);

    switch (a.tag) {
      case 2:
        Ug(a);
        var b = a.stateNode;
        if ("function" === typeof b.componentWillUnmount) try {
          b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
        } catch (c) {
          Vg(a, c);
        }
        break;

      case 5:
        Ug(a);
        break;

      case 4:
        Xg(a);
    }
  }

  function Yg(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }

  function Zg(a) {
    a: {
      for (var b = a.return; null !== b;) {
        if (Yg(b)) {
          var c = b;
          break a;
        }

        b = b.return;
      }

      A("160");
      c = void 0;
    }

    var d = b = void 0;

    switch (c.tag) {
      case 5:
        b = c.stateNode;
        d = !1;
        break;

      case 3:
        b = c.stateNode.containerInfo;
        d = !0;
        break;

      case 4:
        b = c.stateNode.containerInfo;
        d = !0;
        break;

      default:
        A("161");
    }

    c.effectTag & 16 && (Ge(b, ""), c.effectTag &= -17);

    a: b: for (c = a;;) {
      for (; null === c.sibling;) {
        if (null === c.return || Yg(c.return)) {
          c = null;
          break a;
        }

        c = c.return;
      }

      c.sibling.return = c.return;

      for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
        if (c.effectTag & 2) continue b;
        if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
      }

      if (!(c.effectTag & 2)) {
        c = c.stateNode;
        break a;
      }
    }

    for (var e = a;;) {
      if (5 === e.tag || 6 === e.tag) {
        if (c) {
          if (d) {
            var f = b,
                g = e.stateNode,
                h = c;
            8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
          } else b.insertBefore(e.stateNode, c);
        } else d ? (f = b, g = e.stateNode, 8 === f.nodeType ? f.parentNode.insertBefore(g, f) : f.appendChild(g)) : b.appendChild(e.stateNode);
      } else if (4 !== e.tag && null !== e.child) {
        e.child.return = e;
        e = e.child;
        continue;
      }
      if (e === a) break;

      for (; null === e.sibling;) {
        if (null === e.return || e.return === a) return;
        e = e.return;
      }

      e.sibling.return = e.return;
      e = e.sibling;
    }
  }

  function Xg(a) {
    for (var b = a, c = !1, d = void 0, e = void 0;;) {
      if (!c) {
        c = b.return;

        a: for (;;) {
          null === c ? A("160") : void 0;

          switch (c.tag) {
            case 5:
              d = c.stateNode;
              e = !1;
              break a;

            case 3:
              d = c.stateNode.containerInfo;
              e = !0;
              break a;

            case 4:
              d = c.stateNode.containerInfo;
              e = !0;
              break a;
          }

          c = c.return;
        }

        c = !0;
      }

      if (5 === b.tag || 6 === b.tag) {
        a: for (var f = b, g = f;;) {
          if (Wg(g), null !== g.child && 4 !== g.tag) g.child.return = g, g = g.child;else {
            if (g === f) break;

            for (; null === g.sibling;) {
              if (null === g.return || g.return === f) break a;
              g = g.return;
            }

            g.sibling.return = g.return;
            g = g.sibling;
          }
        }

        e ? (f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
      } else if (4 === b.tag ? d = b.stateNode.containerInfo : Wg(b), null !== b.child) {
        b.child.return = b;
        b = b.child;
        continue;
      }

      if (b === a) break;

      for (; null === b.sibling;) {
        if (null === b.return || b.return === a) return;
        b = b.return;
        4 === b.tag && (c = !1);
      }

      b.sibling.return = b.return;
      b = b.sibling;
    }
  }

  function $g(a, b) {
    switch (b.tag) {
      case 2:
        break;

      case 5:
        var c = b.stateNode;

        if (null != c) {
          var d = b.memoizedProps;
          a = null !== a ? a.memoizedProps : d;
          var e = b.type,
              f = b.updateQueue;
          b.updateQueue = null;
          null !== f && (c[Ma] = d, Te(c, f, e, a, d));
        }

        break;

      case 6:
        null === b.stateNode ? A("162") : void 0;
        b.stateNode.nodeValue = b.memoizedProps;
        break;

      case 3:
        break;

      case 15:
        break;

      case 16:
        break;

      default:
        A("163");
    }
  }

  function ah(a, b, c) {
    c = Kf(c);
    c.tag = 3;
    c.payload = {
      element: null
    };
    var d = b.value;

    c.callback = function () {
      bh(d);
      Tg(a, b);
    };

    return c;
  }

  function ch(a, b, c) {
    c = Kf(c);
    c.tag = 3;
    var d = a.stateNode;
    null !== d && "function" === typeof d.componentDidCatch && (c.callback = function () {
      null === dh ? dh = new Set([this]) : dh.add(this);
      var c = b.value,
          d = b.stack;
      Tg(a, b);
      this.componentDidCatch(c, {
        componentStack: null !== d ? d : ""
      });
    });
    return c;
  }

  function eh(a, b, c, d, e, f) {
    c.effectTag |= 512;
    c.firstEffect = c.lastEffect = null;
    d = Tf(d, c);
    a = b;

    do {
      switch (a.tag) {
        case 3:
          a.effectTag |= 1024;
          d = ah(a, d, f);
          Nf(a, d, f);
          return;

        case 2:
          if (b = d, c = a.stateNode, 0 === (a.effectTag & 64) && null !== c && "function" === typeof c.componentDidCatch && (null === dh || !dh.has(c))) {
            a.effectTag |= 1024;
            d = ch(a, b, f);
            Nf(a, d, f);
            return;
          }

      }

      a = a.return;
    } while (null !== a);
  }

  function fh(a) {
    switch (a.tag) {
      case 2:
        of(a);
        var b = a.effectTag;
        return b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;

      case 3:
        return eg(a), pf(a), b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;

      case 5:
        return fg(a), null;

      case 16:
        return b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;

      case 4:
        return eg(a), null;

      case 13:
        return Yf(a), null;

      default:
        return null;
    }
  }

  var gh = af(),
      hh = 2,
      ih = gh,
      jh = 0,
      kh = 0,
      lh = !1,
      S = null,
      mh = null,
      T = 0,
      nh = -1,
      oh = !1,
      U = null,
      ph = !1,
      qh = !1,
      dh = null;

  function rh() {
    if (null !== S) for (var a = S.return; null !== a;) {
      var b = a;

      switch (b.tag) {
        case 2:
          of(b);
          break;

        case 3:
          eg(b);
          pf(b);
          break;

        case 5:
          fg(b);
          break;

        case 4:
          eg(b);
          break;

        case 13:
          Yf(b);
      }

      a = a.return;
    }
    mh = null;
    T = 0;
    nh = -1;
    oh = !1;
    S = null;
    qh = !1;
  }

  function sh(a) {
    for (;;) {
      var b = a.alternate,
          c = a.return,
          d = a.sibling;

      if (0 === (a.effectTag & 512)) {
        b = Sg(b, a, T);
        var e = a;

        if (1073741823 === T || 1073741823 !== e.expirationTime) {
          var f = 0;

          switch (e.tag) {
            case 3:
            case 2:
              var g = e.updateQueue;
              null !== g && (f = g.expirationTime);
          }

          for (g = e.child; null !== g;) {
            0 !== g.expirationTime && (0 === f || f > g.expirationTime) && (f = g.expirationTime), g = g.sibling;
          }

          e.expirationTime = f;
        }

        if (null !== b) return b;
        null !== c && 0 === (c.effectTag & 512) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
        if (null !== d) return d;
        if (null !== c) a = c;else {
          qh = !0;
          break;
        }
      } else {
        a = fh(a, oh, T);
        if (null !== a) return a.effectTag &= 511, a;
        null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 512);
        if (null !== d) return d;
        if (null !== c) a = c;else break;
      }
    }

    return null;
  }

  function th(a) {
    var b = Kg(a.alternate, a, T);
    null === b && (b = sh(a));
    ec.current = null;
    return b;
  }

  function uh(a, b, c) {
    lh ? A("243") : void 0;
    lh = !0;
    if (b !== T || a !== mh || null === S) rh(), mh = a, T = b, nh = -1, S = vf(mh.current, null, T), a.pendingCommitExpirationTime = 0;
    var d = !1;
    oh = !c || T <= hh;

    do {
      try {
        if (c) for (; null !== S && !vh();) {
          S = th(S);
        } else for (; null !== S;) {
          S = th(S);
        }
      } catch (f) {
        if (null === S) d = !0, bh(f);else {
          null === S ? A("271") : void 0;
          c = S;
          var e = c.return;

          if (null === e) {
            d = !0;
            bh(f);
            break;
          }

          eh(a, e, c, f, oh, T, ih);
          S = sh(c);
        }
      }

      break;
    } while (1);

    lh = !1;
    if (d) return null;

    if (null === S) {
      if (qh) return a.pendingCommitExpirationTime = b, a.current.alternate;
      oh ? A("262") : void 0;
      0 <= nh && setTimeout(function () {
        var b = a.current.expirationTime;
        0 !== b && (0 === a.remainingExpirationTime || a.remainingExpirationTime < b) && wh(a, b);
      }, nh);
      xh(a.current.expirationTime);
    }

    return null;
  }

  function Vg(a, b) {
    var c;

    a: {
      lh && !ph ? A("263") : void 0;

      for (c = a.return; null !== c;) {
        switch (c.tag) {
          case 2:
            var d = c.stateNode;

            if ("function" === typeof c.type.getDerivedStateFromCatch || "function" === typeof d.componentDidCatch && (null === dh || !dh.has(d))) {
              a = Tf(b, a);
              a = ch(c, a, 1);
              Mf(c, a, 1);
              kg(c, 1);
              c = void 0;
              break a;
            }

            break;

          case 3:
            a = Tf(b, a);
            a = ah(c, a, 1);
            Mf(c, a, 1);
            kg(c, 1);
            c = void 0;
            break a;
        }

        c = c.return;
      }

      3 === a.tag && (c = Tf(b, a), c = ah(a, c, 1), Mf(a, c, 1), kg(a, 1));
      c = void 0;
    }

    return c;
  }

  function yh() {
    var a = 2 + 25 * (((ig() - 2 + 500) / 25 | 0) + 1);
    a <= jh && (a = jh + 1);
    return jh = a;
  }

  function jg(a, b) {
    a = 0 !== kh ? kh : lh ? ph ? 1 : T : b.mode & 1 ? zh ? 2 + 10 * (((a - 2 + 15) / 10 | 0) + 1) : 2 + 25 * (((a - 2 + 500) / 25 | 0) + 1) : 1;
    zh && (0 === Ah || a > Ah) && (Ah = a);
    return a;
  }

  function kg(a, b) {
    for (; null !== a;) {
      if (0 === a.expirationTime || a.expirationTime > b) a.expirationTime = b;
      null !== a.alternate && (0 === a.alternate.expirationTime || a.alternate.expirationTime > b) && (a.alternate.expirationTime = b);
      if (null === a.return) if (3 === a.tag) {
        var c = a.stateNode;
        !lh && 0 !== T && b < T && rh();
        var d = c.current.expirationTime;
        lh && !ph && mh === c || wh(c, d);
        Bh > Ch && A("185");
      } else break;
      a = a.return;
    }
  }

  function ig() {
    ih = af() - gh;
    return hh = (ih / 10 | 0) + 2;
  }

  function Dh(a) {
    var b = kh;
    kh = 2 + 25 * (((ig() - 2 + 500) / 25 | 0) + 1);

    try {
      return a();
    } finally {
      kh = b;
    }
  }

  function Eh(a, b, c, d, e) {
    var f = kh;
    kh = 1;

    try {
      return a(b, c, d, e);
    } finally {
      kh = f;
    }
  }

  var Fh = null,
      V = null,
      Gh = 0,
      Hh = -1,
      W = !1,
      X = null,
      Y = 0,
      Ah = 0,
      Ih = !1,
      Jh = !1,
      Kh = null,
      Lh = null,
      Z = !1,
      Mh = !1,
      zh = !1,
      Nh = null,
      Ch = 1E3,
      Bh = 0,
      Oh = 1;

  function Ph(a) {
    if (0 !== Gh) {
      if (a > Gh) return;
      cf(Hh);
    }

    var b = af() - gh;
    Gh = a;
    Hh = bf(Qh, {
      timeout: 10 * (a - 2) - b
    });
  }

  function wh(a, b) {
    if (null === a.nextScheduledRoot) a.remainingExpirationTime = b, null === V ? (Fh = V = a, a.nextScheduledRoot = a) : (V = V.nextScheduledRoot = a, V.nextScheduledRoot = Fh);else {
      var c = a.remainingExpirationTime;
      if (0 === c || b < c) a.remainingExpirationTime = b;
    }
    W || (Z ? Mh && (X = a, Y = 1, Rh(a, 1, !1)) : 1 === b ? Sh() : Ph(b));
  }

  function Th() {
    var a = 0,
        b = null;
    if (null !== V) for (var c = V, d = Fh; null !== d;) {
      var e = d.remainingExpirationTime;

      if (0 === e) {
        null === c || null === V ? A("244") : void 0;

        if (d === d.nextScheduledRoot) {
          Fh = V = d.nextScheduledRoot = null;
          break;
        } else if (d === Fh) Fh = e = d.nextScheduledRoot, V.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === V) {
          V = c;
          V.nextScheduledRoot = Fh;
          d.nextScheduledRoot = null;
          break;
        } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;

        d = c.nextScheduledRoot;
      } else {
        if (0 === a || e < a) a = e, b = d;
        if (d === V) break;
        c = d;
        d = d.nextScheduledRoot;
      }
    }
    c = X;
    null !== c && c === b && 1 === a ? Bh++ : Bh = 0;
    X = b;
    Y = a;
  }

  function Qh(a) {
    Uh(0, !0, a);
  }

  function Sh() {
    Uh(1, !1, null);
  }

  function Uh(a, b, c) {
    Lh = c;
    Th();
    if (b) for (; null !== X && 0 !== Y && (0 === a || a >= Y) && (!Ih || ig() >= Y);) {
      ig(), Rh(X, Y, !Ih), Th();
    } else for (; null !== X && 0 !== Y && (0 === a || a >= Y);) {
      Rh(X, Y, !1), Th();
    }
    null !== Lh && (Gh = 0, Hh = -1);
    0 !== Y && Ph(Y);
    Lh = null;
    Ih = !1;
    Vh();
  }

  function Wh(a, b) {
    W ? A("253") : void 0;
    X = a;
    Y = b;
    Rh(a, b, !1);
    Sh();
    Vh();
  }

  function Vh() {
    Bh = 0;

    if (null !== Nh) {
      var a = Nh;
      Nh = null;

      for (var b = 0; b < a.length; b++) {
        var c = a[b];

        try {
          c._onComplete();
        } catch (d) {
          Jh || (Jh = !0, Kh = d);
        }
      }
    }

    if (Jh) throw a = Kh, Kh = null, Jh = !1, a;
  }

  function Rh(a, b, c) {
    W ? A("245") : void 0;
    W = !0;
    c ? (c = a.finishedWork, null !== c ? Xh(a, c, b) : (a.finishedWork = null, c = uh(a, b, !0), null !== c && (vh() ? a.finishedWork = c : Xh(a, c, b)))) : (c = a.finishedWork, null !== c ? Xh(a, c, b) : (a.finishedWork = null, c = uh(a, b, !1), null !== c && Xh(a, c, b)));
    W = !1;
  }

  function Xh(a, b, c) {
    var d = a.firstBatch;

    if (null !== d && d._expirationTime <= c && (null === Nh ? Nh = [d] : Nh.push(d), d._defer)) {
      a.finishedWork = b;
      a.remainingExpirationTime = 0;
      return;
    }

    a.finishedWork = null;
    ph = lh = !0;
    c = b.stateNode;
    c.current === b ? A("177") : void 0;
    d = c.pendingCommitExpirationTime;
    0 === d ? A("261") : void 0;
    c.pendingCommitExpirationTime = 0;
    ig();
    ec.current = null;
    if (1 < b.effectTag) {
      if (null !== b.lastEffect) {
        b.lastEffect.nextEffect = b;
        var e = b.firstEffect;
      } else e = b;
    } else e = b.firstEffect;
    Xe = Gd;
    var f = da();

    if (Td(f)) {
      if ("selectionStart" in f) var g = {
        start: f.selectionStart,
        end: f.selectionEnd
      };else a: {
        var h = window.getSelection && window.getSelection();

        if (h && 0 !== h.rangeCount) {
          g = h.anchorNode;
          var k = h.anchorOffset,
              n = h.focusNode;
          h = h.focusOffset;

          try {
            g.nodeType, n.nodeType;
          } catch (Wa) {
            g = null;
            break a;
          }

          var r = 0,
              w = -1,
              P = -1,
              kc = 0,
              Hd = 0,
              E = f,
              t = null;

          b: for (;;) {
            for (var x;;) {
              E !== g || 0 !== k && 3 !== E.nodeType || (w = r + k);
              E !== n || 0 !== h && 3 !== E.nodeType || (P = r + h);
              3 === E.nodeType && (r += E.nodeValue.length);
              if (null === (x = E.firstChild)) break;
              t = E;
              E = x;
            }

            for (;;) {
              if (E === f) break b;
              t === g && ++kc === k && (w = r);
              t === n && ++Hd === h && (P = r);
              if (null !== (x = E.nextSibling)) break;
              E = t;
              t = E.parentNode;
            }

            E = x;
          }

          g = -1 === w || -1 === P ? null : {
            start: w,
            end: P
          };
        } else g = null;
      }
      g = g || {
        start: 0,
        end: 0
      };
    } else g = null;

    Ye = {
      focusedElem: f,
      selectionRange: g
    };
    Id(!1);

    for (U = e; null !== U;) {
      f = !1;
      g = void 0;

      try {
        for (; null !== U;) {
          if (U.effectTag & 256) {
            var u = U.alternate;
            k = U;

            switch (k.tag) {
              case 2:
                if (k.effectTag & 256 && null !== u) {
                  var y = u.memoizedProps,
                      D = u.memoizedState,
                      ja = k.stateNode;
                  ja.props = k.memoizedProps;
                  ja.state = k.memoizedState;
                  var hi = ja.getSnapshotBeforeUpdate(y, D);
                  ja.__reactInternalSnapshotBeforeUpdate = hi;
                }

                break;

              case 3:
              case 5:
              case 6:
              case 4:
                break;

              default:
                A("163");
            }
          }

          U = U.nextEffect;
        }
      } catch (Wa) {
        f = !0, g = Wa;
      }

      f && (null === U ? A("178") : void 0, Vg(U, g), null !== U && (U = U.nextEffect));
    }

    for (U = e; null !== U;) {
      u = !1;
      y = void 0;

      try {
        for (; null !== U;) {
          var q = U.effectTag;
          q & 16 && Ge(U.stateNode, "");

          if (q & 128) {
            var z = U.alternate;

            if (null !== z) {
              var l = z.ref;
              null !== l && ("function" === typeof l ? l(null) : l.current = null);
            }
          }

          switch (q & 14) {
            case 2:
              Zg(U);
              U.effectTag &= -3;
              break;

            case 6:
              Zg(U);
              U.effectTag &= -3;
              $g(U.alternate, U);
              break;

            case 4:
              $g(U.alternate, U);
              break;

            case 8:
              D = U, Xg(D), D.return = null, D.child = null, D.alternate && (D.alternate.child = null, D.alternate.return = null);
          }

          U = U.nextEffect;
        }
      } catch (Wa) {
        u = !0, y = Wa;
      }

      u && (null === U ? A("178") : void 0, Vg(U, y), null !== U && (U = U.nextEffect));
    }

    l = Ye;
    z = da();
    q = l.focusedElem;
    u = l.selectionRange;

    if (z !== q && fa(document.documentElement, q)) {
      Td(q) && (z = u.start, l = u.end, void 0 === l && (l = z), "selectionStart" in q ? (q.selectionStart = z, q.selectionEnd = Math.min(l, q.value.length)) : window.getSelection && (z = window.getSelection(), y = q[lb()].length, l = Math.min(u.start, y), u = void 0 === u.end ? l : Math.min(u.end, y), !z.extend && l > u && (y = u, u = l, l = y), y = Sd(q, l), D = Sd(q, u), y && D && (1 !== z.rangeCount || z.anchorNode !== y.node || z.anchorOffset !== y.offset || z.focusNode !== D.node || z.focusOffset !== D.offset) && (ja = document.createRange(), ja.setStart(y.node, y.offset), z.removeAllRanges(), l > u ? (z.addRange(ja), z.extend(D.node, D.offset)) : (ja.setEnd(D.node, D.offset), z.addRange(ja)))));
      z = [];

      for (l = q; l = l.parentNode;) {
        1 === l.nodeType && z.push({
          element: l,
          left: l.scrollLeft,
          top: l.scrollTop
        });
      }

      q.focus();

      for (q = 0; q < z.length; q++) {
        l = z[q], l.element.scrollLeft = l.left, l.element.scrollTop = l.top;
      }
    }

    Ye = null;
    Id(Xe);
    Xe = null;
    c.current = b;

    for (U = e; null !== U;) {
      e = !1;
      q = void 0;

      try {
        for (z = d; null !== U;) {
          var gg = U.effectTag;

          if (gg & 36) {
            var lc = U.alternate;
            l = U;
            u = z;

            switch (l.tag) {
              case 2:
                var ba = l.stateNode;
                if (l.effectTag & 4) if (null === lc) ba.props = l.memoizedProps, ba.state = l.memoizedState, ba.componentDidMount();else {
                  var ri = lc.memoizedProps,
                      si = lc.memoizedState;
                  ba.props = l.memoizedProps;
                  ba.state = l.memoizedState;
                  ba.componentDidUpdate(ri, si, ba.__reactInternalSnapshotBeforeUpdate);
                }
                var Mg = l.updateQueue;
                null !== Mg && (ba.props = l.memoizedProps, ba.state = l.memoizedState, Sf(l, Mg, ba, u));
                break;

              case 3:
                var Ng = l.updateQueue;

                if (null !== Ng) {
                  y = null;
                  if (null !== l.child) switch (l.child.tag) {
                    case 5:
                      y = l.child.stateNode;
                      break;

                    case 2:
                      y = l.child.stateNode;
                  }
                  Sf(l, Ng, y, u);
                }

                break;

              case 5:
                var ti = l.stateNode;
                null === lc && l.effectTag & 4 && Ze(l.type, l.memoizedProps) && ti.focus();
                break;

              case 6:
                break;

              case 4:
                break;

              case 15:
                break;

              case 16:
                break;

              default:
                A("163");
            }
          }

          if (gg & 128) {
            l = void 0;
            var uc = U.ref;

            if (null !== uc) {
              var Og = U.stateNode;

              switch (U.tag) {
                case 5:
                  l = Og;
                  break;

                default:
                  l = Og;
              }

              "function" === typeof uc ? uc(l) : uc.current = l;
            }
          }

          var ui = U.nextEffect;
          U.nextEffect = null;
          U = ui;
        }
      } catch (Wa) {
        e = !0, q = Wa;
      }

      e && (null === U ? A("178") : void 0, Vg(U, q), null !== U && (U = U.nextEffect));
    }

    lh = ph = !1;
    "function" === typeof Ff && Ff(b.stateNode);
    b = c.current.expirationTime;
    0 === b && (dh = null);
    a.remainingExpirationTime = b;
  }

  function vh() {
    return null === Lh || Lh.timeRemaining() > Oh ? !1 : Ih = !0;
  }

  function bh(a) {
    null === X ? A("246") : void 0;
    X.remainingExpirationTime = 0;
    Jh || (Jh = !0, Kh = a);
  }

  function xh(a) {
    null === X ? A("246") : void 0;
    X.remainingExpirationTime = a;
  }

  function Yh(a, b) {
    var c = Z;
    Z = !0;

    try {
      return a(b);
    } finally {
      (Z = c) || W || Sh();
    }
  }

  function Zh(a, b) {
    if (Z && !Mh) {
      Mh = !0;

      try {
        return a(b);
      } finally {
        Mh = !1;
      }
    }

    return a(b);
  }

  function $h(a, b) {
    W ? A("187") : void 0;
    var c = Z;
    Z = !0;

    try {
      return Eh(a, b);
    } finally {
      Z = c, Sh();
    }
  }

  function ai(a) {
    var b = Z;
    Z = !0;

    try {
      Eh(a);
    } finally {
      (Z = b) || W || Uh(1, !1, null);
    }
  }

  function bi(a, b, c, d, e) {
    var f = b.current;

    if (c) {
      c = c._reactInternalFiber;
      var g;

      b: {
        2 === id(c) && 2 === c.tag ? void 0 : A("170");

        for (g = c; 3 !== g.tag;) {
          if (mf(g)) {
            g = g.stateNode.__reactInternalMemoizedMergedChildContext;
            break b;
          }

          (g = g.return) ? void 0 : A("171");
        }

        g = g.stateNode.context;
      }

      c = mf(c) ? rf(c, g) : g;
    } else c = ha;

    null === b.context ? b.context = c : b.pendingContext = c;
    b = e;
    e = Kf(d);
    e.payload = {
      element: a
    };
    b = void 0 === b ? null : b;
    null !== b && (e.callback = b);
    Mf(f, e, d);
    kg(f, d);
    return d;
  }

  function ci(a) {
    var b = a._reactInternalFiber;
    void 0 === b && ("function" === typeof a.render ? A("188") : A("268", Object.keys(a)));
    a = ld(b);
    return null === a ? null : a.stateNode;
  }

  function di(a, b, c, d) {
    var e = b.current,
        f = ig();
    e = jg(f, e);
    return bi(a, b, c, e, d);
  }

  function ei(a) {
    a = a.current;
    if (!a.child) return null;

    switch (a.child.tag) {
      case 5:
        return a.child.stateNode;

      default:
        return a.child.stateNode;
    }
  }

  function fi(a) {
    var b = a.findFiberByHostInstance;
    return Ef(p({}, a, {
      findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = ld(a);
        return null === a ? null : a.stateNode;
      },
      findFiberByHostInstance: function findFiberByHostInstance(a) {
        return b ? b(a) : null;
      }
    }));
  }

  var gi = {
    updateContainerAtExpirationTime: bi,
    createContainer: function createContainer(a, b, c) {
      return Af(a, b, c);
    },
    updateContainer: di,
    flushRoot: Wh,
    requestWork: wh,
    computeUniqueAsyncExpiration: yh,
    batchedUpdates: Yh,
    unbatchedUpdates: Zh,
    deferredUpdates: Dh,
    syncUpdates: Eh,
    interactiveUpdates: function interactiveUpdates(a, b, c) {
      if (zh) return a(b, c);
      Z || W || 0 === Ah || (Uh(Ah, !1, null), Ah = 0);
      var d = zh,
          e = Z;
      Z = zh = !0;

      try {
        return a(b, c);
      } finally {
        zh = d, (Z = e) || W || Sh();
      }
    },
    flushInteractiveUpdates: function flushInteractiveUpdates() {
      W || 0 === Ah || (Uh(Ah, !1, null), Ah = 0);
    },
    flushControlled: ai,
    flushSync: $h,
    getPublicRootInstance: ei,
    findHostInstance: ci,
    findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
      a = md(a);
      return null === a ? null : a.stateNode;
    },
    injectIntoDevTools: fi
  };

  function ii(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: gc,
      key: null == d ? null : "" + d,
      children: a,
      containerInfo: b,
      implementation: c
    };
  }

  Kb.injectFiberControlledHostComponent(We);

  function ji(a) {
    this._expirationTime = yh();
    this._root = a;
    this._callbacks = this._next = null;
    this._hasChildren = this._didComplete = !1;
    this._children = null;
    this._defer = !0;
  }

  ji.prototype.render = function (a) {
    this._defer ? void 0 : A("250");
    this._hasChildren = !0;
    this._children = a;
    var b = this._root._internalRoot,
        c = this._expirationTime,
        d = new ki();
    bi(a, b, null, c, d._onCommit);
    return d;
  };

  ji.prototype.then = function (a) {
    if (this._didComplete) a();else {
      var b = this._callbacks;
      null === b && (b = this._callbacks = []);
      b.push(a);
    }
  };

  ji.prototype.commit = function () {
    var a = this._root._internalRoot,
        b = a.firstBatch;
    this._defer && null !== b ? void 0 : A("251");

    if (this._hasChildren) {
      var c = this._expirationTime;

      if (b !== this) {
        this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));

        for (var d = null, e = b; e !== this;) {
          d = e, e = e._next;
        }

        null === d ? A("251") : void 0;
        d._next = e._next;
        this._next = b;
        a.firstBatch = this;
      }

      this._defer = !1;
      Wh(a, c);
      b = this._next;
      this._next = null;
      b = a.firstBatch = b;
      null !== b && b._hasChildren && b.render(b._children);
    } else this._next = null, this._defer = !1;
  };

  ji.prototype._onComplete = function () {
    if (!this._didComplete) {
      this._didComplete = !0;
      var a = this._callbacks;
      if (null !== a) for (var b = 0; b < a.length; b++) {
        (0, a[b])();
      }
    }
  };

  function ki() {
    this._callbacks = null;
    this._didCommit = !1;
    this._onCommit = this._onCommit.bind(this);
  }

  ki.prototype.then = function (a) {
    if (this._didCommit) a();else {
      var b = this._callbacks;
      null === b && (b = this._callbacks = []);
      b.push(a);
    }
  };

  ki.prototype._onCommit = function () {
    if (!this._didCommit) {
      this._didCommit = !0;
      var a = this._callbacks;
      if (null !== a) for (var b = 0; b < a.length; b++) {
        var c = a[b];
        "function" !== typeof c ? A("191", c) : void 0;
        c();
      }
    }
  };

  function li(a, b, c) {
    this._internalRoot = Af(a, b, c);
  }

  li.prototype.render = function (a, b) {
    var c = this._internalRoot,
        d = new ki();
    b = void 0 === b ? null : b;
    null !== b && d.then(b);
    di(a, c, null, d._onCommit);
    return d;
  };

  li.prototype.unmount = function (a) {
    var b = this._internalRoot,
        c = new ki();
    a = void 0 === a ? null : a;
    null !== a && c.then(a);
    di(null, b, null, c._onCommit);
    return c;
  };

  li.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
    var d = this._internalRoot,
        e = new ki();
    c = void 0 === c ? null : c;
    null !== c && e.then(c);
    di(b, d, a, e._onCommit);
    return e;
  };

  li.prototype.createBatch = function () {
    var a = new ji(this),
        b = a._expirationTime,
        c = this._internalRoot,
        d = c.firstBatch;
    if (null === d) c.firstBatch = a, a._next = null;else {
      for (c = null; null !== d && d._expirationTime <= b;) {
        c = d, d = d._next;
      }

      a._next = d;
      null !== c && (c._next = a);
    }
    return a;
  };

  function mi(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
  }

  Sb = gi.batchedUpdates;
  Tb = gi.interactiveUpdates;
  Ub = gi.flushInteractiveUpdates;

  function ni(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for (var c; c = a.lastChild;) {
      a.removeChild(c);
    }
    return new li(a, !1, b);
  }

  function oi(a, b, c, d, e) {
    mi(c) ? void 0 : A("200");
    var f = c._reactRootContainer;

    if (f) {
      if ("function" === typeof e) {
        var g = e;

        e = function e() {
          var a = ei(f._internalRoot);
          g.call(a);
        };
      }

      null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    } else {
      f = c._reactRootContainer = ni(c, d);

      if ("function" === typeof e) {
        var h = e;

        e = function e() {
          var a = ei(f._internalRoot);
          h.call(a);
        };
      }

      Zh(function () {
        null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
      });
    }

    return ei(f._internalRoot);
  }

  function pi(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    mi(b) ? void 0 : A("200");
    return ii(a, b, null, c);
  }

  var qi = {
    createPortal: pi,
    findDOMNode: function findDOMNode(a) {
      return null == a ? null : 1 === a.nodeType ? a : ci(a);
    },
    hydrate: function hydrate(a, b, c) {
      return oi(null, a, b, !0, c);
    },
    render: function render(a, b, c) {
      return oi(null, a, b, !1, c);
    },
    unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
      null == a || void 0 === a._reactInternalFiber ? A("38") : void 0;
      return oi(a, b, c, !1, d);
    },
    unmountComponentAtNode: function unmountComponentAtNode(a) {
      mi(a) ? void 0 : A("40");
      return a._reactRootContainer ? (Zh(function () {
        oi(null, null, a, !1, function () {
          a._reactRootContainer = null;
        });
      }), !0) : !1;
    },
    unstable_createPortal: function unstable_createPortal() {
      return pi.apply(void 0, arguments);
    },
    unstable_batchedUpdates: Yh,
    unstable_deferredUpdates: Dh,
    flushSync: $h,
    unstable_flushControlled: ai,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
      EventPluginHub: Ka,
      EventPluginRegistry: va,
      EventPropagators: $a,
      ReactControlledComponent: Rb,
      ReactDOMComponentTree: Qa,
      ReactDOMEventListener: Md
    },
    unstable_createRoot: function unstable_createRoot(a, b) {
      return new li(a, !0, null != b && !0 === b.hydrate);
    }
  };
  fi({
    findFiberByHostInstance: Na,
    bundleType: 0,
    version: "16.4.0",
    rendererPackageName: "react-dom"
  });
  var vi = {
    default: qi
  },
      wi = vi && qi || vi;
  module.exports = wi.default ? wi.default : wi;
  /***/
},
/* 507 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  var isNode = __webpack_require__(508);
  /**
   * @param {*} object The object to check.
   * @return {boolean} Whether or not the object is a DOM text node.
   */


  function isTextNode(object) {
    return isNode(object) && object.nodeType == 3;
  }

  module.exports = isTextNode;
  /***/
},
/* 508 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  /**
   * @param {*} object The object to check.
   * @return {boolean} Whether or not the object is a DOM node.
   */

  function isNode(object) {
    var doc = object ? object.ownerDocument || object : document;
    var defaultView = doc.defaultView || window;
    return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
  }

  module.exports = isNode;
  /***/
},
/* 509 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v16.4.0
    * react-dom.development.js
    *
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict';

        var invariant = __webpack_require__(54);

        var React = __webpack_require__(1);

        var warning = __webpack_require__(85);

        var ExecutionEnvironment = __webpack_require__(178);

        var _assign = __webpack_require__(65);

        var emptyFunction = __webpack_require__(53);

        var checkPropTypes = __webpack_require__(119);

        var getActiveElement = __webpack_require__(179);

        var shallowEqual = __webpack_require__(180);

        var containsNode = __webpack_require__(181);

        var emptyObject = __webpack_require__(89);

        var hyphenateStyleName = __webpack_require__(128);

        var camelizeStyleName = __webpack_require__(182); // Relying on the `invariant()` implementation lets us
        // have preserve the format and params in the www builds.


        !React ? invariant(false, 'ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.') : void 0;

        var invokeGuardedCallback = function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
          this._hasCaughtError = false;
          this._caughtError = null;
          var funcArgs = Array.prototype.slice.call(arguments, 3);

          try {
            func.apply(context, funcArgs);
          } catch (error) {
            this._caughtError = error;
            this._hasCaughtError = true;
          }
        };

        {
          // In DEV mode, we swap out invokeGuardedCallback for a special version
          // that plays more nicely with the browser's DevTools. The idea is to preserve
          // "Pause on exceptions" behavior. Because React wraps all user-provided
          // functions in invokeGuardedCallback, and the production version of
          // invokeGuardedCallback uses a try-catch, all user exceptions are treated
          // like caught exceptions, and the DevTools won't pause unless the developer
          // takes the extra step of enabling pause on caught exceptions. This is
          // untintuitive, though, because even though React has caught the error, from
          // the developer's perspective, the error is uncaught.
          //
          // To preserve the expected "Pause on exceptions" behavior, we don't use a
          // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
          // DOM node, and call the user-provided callback from inside an event handler
          // for that fake event. If the callback throws, the error is "captured" using
          // a global event handler. But because the error happens in a different
          // event loop context, it does not interrupt the normal program flow.
          // Effectively, this gives us try-catch behavior without actually using
          // try-catch. Neat!
          // Check that the browser supports the APIs we need to implement our special
          // DEV version of invokeGuardedCallback
          if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
            var fakeNode = document.createElement('react');

            var invokeGuardedCallbackDev = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
              // If document doesn't exist we know for sure we will crash in this method
              // when we call document.createEvent(). However this can cause confusing
              // errors: https://github.com/facebookincubator/create-react-app/issues/3482
              // So we preemptively throw with a better message instead.
              !(typeof document !== 'undefined') ? invariant(false, 'The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.') : void 0;
              var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
              // set this to true at the beginning, then set it to false right after
              // calling the function. If the function errors, `didError` will never be
              // set to false. This strategy works even if the browser is flaky and
              // fails to call our global error handler, because it doesn't rely on
              // the error event at all.

              var didError = true; // Create an event handler for our fake event. We will synchronously
              // dispatch our fake event using `dispatchEvent`. Inside the handler, we
              // call the user-provided callback.

              var funcArgs = Array.prototype.slice.call(arguments, 3);

              function callCallback() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false);
                func.apply(context, funcArgs);
                didError = false;
              } // Create a global error event handler. We use this to capture the value
              // that was thrown. It's possible that this error handler will fire more
              // than once; for example, if non-React code also calls `dispatchEvent`
              // and a handler for that event throws. We should be resilient to most of
              // those cases. Even if our error event handler fires more than once, the
              // last error event is always used. If the callback actually does error,
              // we know that the last error event is the correct one, because it's not
              // possible for anything else to have happened in between our callback
              // erroring and the code that follows the `dispatchEvent` call below. If
              // the callback doesn't error, but the error event was fired, we know to
              // ignore it because `didError` will be false, as described above.


              var error = void 0; // Use this to track whether the error event is ever called.

              var didSetError = false;
              var isCrossOriginError = false;

              function onError(event) {
                error = event.error;
                didSetError = true;

                if (error === null && event.colno === 0 && event.lineno === 0) {
                  isCrossOriginError = true;
                }
              } // Create a fake event type.


              var evtType = 'react-' + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

              window.addEventListener('error', onError);
              fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
              // errors, it will trigger our global error handler.

              evt.initEvent(evtType, false, false);
              fakeNode.dispatchEvent(evt);

              if (didError) {
                if (!didSetError) {
                  // The callback errored, but the error event never fired.
                  error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
                } else if (isCrossOriginError) {
                  error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://fb.me/react-crossorigin-error for more information.');
                }

                this._hasCaughtError = true;
                this._caughtError = error;
              } else {
                this._hasCaughtError = false;
                this._caughtError = null;
              } // Remove our event listeners


              window.removeEventListener('error', onError);
            };

            invokeGuardedCallback = invokeGuardedCallbackDev;
          }
        }
        var invokeGuardedCallback$1 = invokeGuardedCallback;
        var ReactErrorUtils = {
          // Used by Fiber to simulate a try-catch.
          _caughtError: null,
          _hasCaughtError: false,
          // Used by event system to capture/rethrow the first error.
          _rethrowError: null,
          _hasRethrowError: false,

          /**
           * Call a function while guarding against errors that happens within it.
           * Returns an error if it throws, otherwise null.
           *
           * In production, this is implemented using a try-catch. The reason we don't
           * use a try-catch directly is so that we can swap out a different
           * implementation in DEV mode.
           *
           * @param {String} name of the guard to use for logging or debugging
           * @param {Function} func The function to invoke
           * @param {*} context The context to use when calling the function
           * @param {...*} args Arguments for function
           */
          invokeGuardedCallback: function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
            invokeGuardedCallback$1.apply(ReactErrorUtils, arguments);
          },

          /**
           * Same as invokeGuardedCallback, but instead of returning an error, it stores
           * it in a global so it can be rethrown by `rethrowCaughtError` later.
           * TODO: See if _caughtError and _rethrowError can be unified.
           *
           * @param {String} name of the guard to use for logging or debugging
           * @param {Function} func The function to invoke
           * @param {*} context The context to use when calling the function
           * @param {...*} args Arguments for function
           */
          invokeGuardedCallbackAndCatchFirstError: function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
            ReactErrorUtils.invokeGuardedCallback.apply(this, arguments);

            if (ReactErrorUtils.hasCaughtError()) {
              var error = ReactErrorUtils.clearCaughtError();

              if (!ReactErrorUtils._hasRethrowError) {
                ReactErrorUtils._hasRethrowError = true;
                ReactErrorUtils._rethrowError = error;
              }
            }
          },

          /**
           * During execution of guarded functions we will capture the first error which
           * we will rethrow to be handled by the top level error handler.
           */
          rethrowCaughtError: function rethrowCaughtError() {
            return _rethrowCaughtError.apply(ReactErrorUtils, arguments);
          },
          hasCaughtError: function hasCaughtError() {
            return ReactErrorUtils._hasCaughtError;
          },
          clearCaughtError: function clearCaughtError() {
            if (ReactErrorUtils._hasCaughtError) {
              var error = ReactErrorUtils._caughtError;
              ReactErrorUtils._caughtError = null;
              ReactErrorUtils._hasCaughtError = false;
              return error;
            } else {
              invariant(false, 'clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.');
            }
          }
        };

        var _rethrowCaughtError = function _rethrowCaughtError() {
          if (ReactErrorUtils._hasRethrowError) {
            var error = ReactErrorUtils._rethrowError;
            ReactErrorUtils._rethrowError = null;
            ReactErrorUtils._hasRethrowError = false;
            throw error;
          }
        };
        /**
         * Injectable ordering of event plugins.
         */


        var eventPluginOrder = null;
        /**
         * Injectable mapping from names to event plugin modules.
         */

        var namesToPlugins = {};
        /**
         * Recomputes the plugin list using the injected plugins and plugin ordering.
         *
         * @private
         */

        function recomputePluginOrdering() {
          if (!eventPluginOrder) {
            // Wait until an `eventPluginOrder` is injected.
            return;
          }

          for (var pluginName in namesToPlugins) {
            var pluginModule = namesToPlugins[pluginName];
            var pluginIndex = eventPluginOrder.indexOf(pluginName);
            !(pluginIndex > -1) ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : void 0;

            if (plugins[pluginIndex]) {
              continue;
            }

            !pluginModule.extractEvents ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : void 0;
            plugins[pluginIndex] = pluginModule;
            var publishedEvents = pluginModule.eventTypes;

            for (var eventName in publishedEvents) {
              !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : void 0;
            }
          }
        }
        /**
         * Publishes an event so that it can be dispatched by the supplied plugin.
         *
         * @param {object} dispatchConfig Dispatch configuration for the event.
         * @param {object} PluginModule Plugin publishing the event.
         * @return {boolean} True if the event was successfully published.
         * @private
         */


        function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
          !!eventNameDispatchConfigs.hasOwnProperty(eventName) ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : void 0;
          eventNameDispatchConfigs[eventName] = dispatchConfig;
          var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

          if (phasedRegistrationNames) {
            for (var phaseName in phasedRegistrationNames) {
              if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
                var phasedRegistrationName = phasedRegistrationNames[phaseName];
                publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
              }
            }

            return true;
          } else if (dispatchConfig.registrationName) {
            publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
            return true;
          }

          return false;
        }
        /**
         * Publishes a registration name that is used to identify dispatched events.
         *
         * @param {string} registrationName Registration name to add.
         * @param {object} PluginModule Plugin publishing the event.
         * @private
         */


        function publishRegistrationName(registrationName, pluginModule, eventName) {
          !!registrationNameModules[registrationName] ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : void 0;
          registrationNameModules[registrationName] = pluginModule;
          registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
          {
            var lowerCasedName = registrationName.toLowerCase();
            possibleRegistrationNames[lowerCasedName] = registrationName;

            if (registrationName === 'onDoubleClick') {
              possibleRegistrationNames.ondblclick = registrationName;
            }
          }
        }
        /**
         * Registers plugins so that they can extract and dispatch events.
         *
         * @see {EventPluginHub}
         */

        /**
         * Ordered list of injected plugins.
         */


        var plugins = [];
        /**
         * Mapping from event name to dispatch config
         */

        var eventNameDispatchConfigs = {};
        /**
         * Mapping from registration name to plugin module
         */

        var registrationNameModules = {};
        /**
         * Mapping from registration name to event name
         */

        var registrationNameDependencies = {};
        /**
         * Mapping from lowercase registration names to the properly cased version,
         * used to warn in the case of missing event handlers. Available
         * only in true.
         * @type {Object}
         */

        var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true

        /**
         * Injects an ordering of plugins (by plugin name). This allows the ordering
         * to be decoupled from injection of the actual plugins so that ordering is
         * always deterministic regardless of packaging, on-the-fly injection, etc.
         *
         * @param {array} InjectedEventPluginOrder
         * @internal
         * @see {EventPluginHub.injection.injectEventPluginOrder}
         */

        function injectEventPluginOrder(injectedEventPluginOrder) {
          !!eventPluginOrder ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : void 0; // Clone the ordering so it cannot be dynamically mutated.

          eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
          recomputePluginOrdering();
        }
        /**
         * Injects plugins to be used by `EventPluginHub`. The plugin names must be
         * in the ordering injected by `injectEventPluginOrder`.
         *
         * Plugins can be injected as part of page initialization or on-the-fly.
         *
         * @param {object} injectedNamesToPlugins Map from names to plugin modules.
         * @internal
         * @see {EventPluginHub.injection.injectEventPluginsByName}
         */


        function injectEventPluginsByName(injectedNamesToPlugins) {
          var isOrderingDirty = false;

          for (var pluginName in injectedNamesToPlugins) {
            if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
              continue;
            }

            var pluginModule = injectedNamesToPlugins[pluginName];

            if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
              !!namesToPlugins[pluginName] ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : void 0;
              namesToPlugins[pluginName] = pluginModule;
              isOrderingDirty = true;
            }
          }

          if (isOrderingDirty) {
            recomputePluginOrdering();
          }
        }

        var EventPluginRegistry = Object.freeze({
          plugins: plugins,
          eventNameDispatchConfigs: eventNameDispatchConfigs,
          registrationNameModules: registrationNameModules,
          registrationNameDependencies: registrationNameDependencies,
          possibleRegistrationNames: possibleRegistrationNames,
          injectEventPluginOrder: injectEventPluginOrder,
          injectEventPluginsByName: injectEventPluginsByName
        });
        var getFiberCurrentPropsFromNode = null;
        var getInstanceFromNode = null;
        var getNodeFromInstance = null;
        var injection$1 = {
          injectComponentTree: function injectComponentTree(Injected) {
            getFiberCurrentPropsFromNode = Injected.getFiberCurrentPropsFromNode;
            getInstanceFromNode = Injected.getInstanceFromNode;
            getNodeFromInstance = Injected.getNodeFromInstance;
            {
              !(getNodeFromInstance && getInstanceFromNode) ? warning(false, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
            }
          }
        };
        var validateEventDispatches = void 0;
        {
          validateEventDispatches = function validateEventDispatches(event) {
            var dispatchListeners = event._dispatchListeners;
            var dispatchInstances = event._dispatchInstances;
            var listenersIsArr = Array.isArray(dispatchListeners);
            var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
            var instancesIsArr = Array.isArray(dispatchInstances);
            var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
            !(instancesIsArr === listenersIsArr && instancesLen === listenersLen) ? warning(false, 'EventPluginUtils: Invalid `event`.') : void 0;
          };
        }
        /**
         * Dispatch the event to the listener.
         * @param {SyntheticEvent} event SyntheticEvent to handle
         * @param {boolean} simulated If the event is simulated (changes exn behavior)
         * @param {function} listener Application-level callback
         * @param {*} inst Internal component instance
         */

        function executeDispatch(event, simulated, listener, inst) {
          var type = event.type || 'unknown-event';
          event.currentTarget = getNodeFromInstance(inst);
          ReactErrorUtils.invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
          event.currentTarget = null;
        }
        /**
         * Standard/simple iteration through an event's collected dispatches.
         */


        function executeDispatchesInOrder(event, simulated) {
          var dispatchListeners = event._dispatchListeners;
          var dispatchInstances = event._dispatchInstances;
          {
            validateEventDispatches(event);
          }

          if (Array.isArray(dispatchListeners)) {
            for (var i = 0; i < dispatchListeners.length; i++) {
              if (event.isPropagationStopped()) {
                break;
              } // Listeners and Instances are two parallel arrays that are always in sync.


              executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
            }
          } else if (dispatchListeners) {
            executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
          }

          event._dispatchListeners = null;
          event._dispatchInstances = null;
        }
        /**
         * @see executeDispatchesInOrderStopAtTrueImpl
         */

        /**
         * Execution of a "direct" dispatch - there must be at most one dispatch
         * accumulated on the event or it is considered an error. It doesn't really make
         * sense for an event with multiple dispatches (bubbled) to keep track of the
         * return values at each dispatch execution, but it does tend to make sense when
         * dealing with "direct" dispatches.
         *
         * @return {*} The return value of executing the single dispatch.
         */

        /**
         * @param {SyntheticEvent} event
         * @return {boolean} True iff number of dispatches accumulated is greater than 0.
         */

        /**
         * Accumulates items that must not be null or undefined into the first one. This
         * is used to conserve memory by avoiding array allocations, and thus sacrifices
         * API cleanness. Since `current` can be null before being passed in and not
         * null after this function, make sure to assign it back to `current`:
         *
         * `a = accumulateInto(a, b);`
         *
         * This API should be sparingly used. Try `accumulate` for something cleaner.
         *
         * @return {*|array<*>} An accumulation of items.
         */


        function accumulateInto(current, next) {
          !(next != null) ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : void 0;

          if (current == null) {
            return next;
          } // Both are not empty. Warning: Never call x.concat(y) when you are not
          // certain that x is an Array (x could be a string with concat method).


          if (Array.isArray(current)) {
            if (Array.isArray(next)) {
              current.push.apply(current, next);
              return current;
            }

            current.push(next);
            return current;
          }

          if (Array.isArray(next)) {
            // A bit too dangerous to mutate `next`.
            return [current].concat(next);
          }

          return [current, next];
        }
        /**
         * @param {array} arr an "accumulation" of items which is either an Array or
         * a single item. Useful when paired with the `accumulate` module. This is a
         * simple utility that allows us to reason about a collection of items, but
         * handling the case when there is exactly one item (and we do not need to
         * allocate an array).
         * @param {function} cb Callback invoked with each element or a collection.
         * @param {?} [scope] Scope used as `this` in a callback.
         */


        function forEachAccumulated(arr, cb, scope) {
          if (Array.isArray(arr)) {
            arr.forEach(cb, scope);
          } else if (arr) {
            cb.call(scope, arr);
          }
        }
        /**
         * Internal queue of events that have accumulated their dispatches and are
         * waiting to have their dispatches executed.
         */


        var eventQueue = null;
        /**
         * Dispatches an event and releases it back into the pool, unless persistent.
         *
         * @param {?object} event Synthetic event to be dispatched.
         * @param {boolean} simulated If the event is simulated (changes exn behavior)
         * @private
         */

        var executeDispatchesAndRelease = function executeDispatchesAndRelease(event, simulated) {
          if (event) {
            executeDispatchesInOrder(event, simulated);

            if (!event.isPersistent()) {
              event.constructor.release(event);
            }
          }
        };

        var executeDispatchesAndReleaseSimulated = function executeDispatchesAndReleaseSimulated(e) {
          return executeDispatchesAndRelease(e, true);
        };

        var executeDispatchesAndReleaseTopLevel = function executeDispatchesAndReleaseTopLevel(e) {
          return executeDispatchesAndRelease(e, false);
        };

        function isInteractive(tag) {
          return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
        }

        function shouldPreventMouseEvent(name, type, props) {
          switch (name) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
              return !!(props.disabled && isInteractive(type));

            default:
              return false;
          }
        }
        /**
         * This is a unified interface for event plugins to be installed and configured.
         *
         * Event plugins can implement the following properties:
         *
         *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
         *     Required. When a top-level event is fired, this method is expected to
         *     extract synthetic events that will in turn be queued and dispatched.
         *
         *   `eventTypes` {object}
         *     Optional, plugins that fire events must publish a mapping of registration
         *     names that are used to register listeners. Values of this mapping must
         *     be objects that contain `registrationName` or `phasedRegistrationNames`.
         *
         *   `executeDispatch` {function(object, function, string)}
         *     Optional, allows plugins to override how an event gets dispatched. By
         *     default, the listener is simply invoked.
         *
         * Each plugin that is injected into `EventsPluginHub` is immediately operable.
         *
         * @public
         */

        /**
         * Methods for injecting dependencies.
         */


        var injection = {
          /**
           * @param {array} InjectedEventPluginOrder
           * @public
           */
          injectEventPluginOrder: injectEventPluginOrder,

          /**
           * @param {object} injectedNamesToPlugins Map from names to plugin modules.
           */
          injectEventPluginsByName: injectEventPluginsByName
        };
        /**
         * @param {object} inst The instance, which is the source of events.
         * @param {string} registrationName Name of listener (e.g. `onClick`).
         * @return {?function} The stored callback.
         */

        function getListener(inst, registrationName) {
          var listener = void 0; // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
          // live here; needs to be moved to a better place soon

          var stateNode = inst.stateNode;

          if (!stateNode) {
            // Work in progress (ex: onload events in incremental mode).
            return null;
          }

          var props = getFiberCurrentPropsFromNode(stateNode);

          if (!props) {
            // Work in progress.
            return null;
          }

          listener = props[registrationName];

          if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
            return null;
          }

          !(!listener || typeof listener === 'function') ? invariant(false, 'Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener) : void 0;
          return listener;
        }
        /**
         * Allows registered plugins an opportunity to extract events from top-level
         * native browser events.
         *
         * @return {*} An accumulation of synthetic events.
         * @internal
         */


        function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
          var events = null;

          for (var i = 0; i < plugins.length; i++) {
            // Not every plugin in the ordering may be loaded at runtime.
            var possiblePlugin = plugins[i];

            if (possiblePlugin) {
              var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);

              if (extractedEvents) {
                events = accumulateInto(events, extractedEvents);
              }
            }
          }

          return events;
        }

        function runEventsInBatch(events, simulated) {
          if (events !== null) {
            eventQueue = accumulateInto(eventQueue, events);
          } // Set `eventQueue` to null before processing it so that we can tell if more
          // events get enqueued while processing.


          var processingEventQueue = eventQueue;
          eventQueue = null;

          if (!processingEventQueue) {
            return;
          }

          if (simulated) {
            forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
          } else {
            forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
          }

          !!eventQueue ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : void 0; // This would be a good time to rethrow if any of the event handlers threw.

          ReactErrorUtils.rethrowCaughtError();
        }

        function runExtractedEventsInBatch(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
          var events = extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
          runEventsInBatch(events, false);
        }

        var EventPluginHub = Object.freeze({
          injection: injection,
          getListener: getListener,
          runEventsInBatch: runEventsInBatch,
          runExtractedEventsInBatch: runExtractedEventsInBatch
        });
        var IndeterminateComponent = 0; // Before we know whether it is functional or class

        var FunctionalComponent = 1;
        var ClassComponent = 2;
        var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

        var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

        var HostComponent = 5;
        var HostText = 6;
        var Fragment = 10;
        var Mode = 11;
        var ContextConsumer = 12;
        var ContextProvider = 13;
        var ForwardRef = 14;
        var Profiler = 15;
        var TimeoutComponent = 16;
        var randomKey = Math.random().toString(36).slice(2);
        var internalInstanceKey = '__reactInternalInstance$' + randomKey;
        var internalEventHandlersKey = '__reactEventHandlers$' + randomKey;

        function precacheFiberNode(hostInst, node) {
          node[internalInstanceKey] = hostInst;
        }
        /**
         * Given a DOM node, return the closest ReactDOMComponent or
         * ReactDOMTextComponent instance ancestor.
         */


        function getClosestInstanceFromNode(node) {
          if (node[internalInstanceKey]) {
            return node[internalInstanceKey];
          }

          while (!node[internalInstanceKey]) {
            if (node.parentNode) {
              node = node.parentNode;
            } else {
              // Top of the tree. This node must not be part of a React tree (or is
              // unmounted, potentially).
              return null;
            }
          }

          var inst = node[internalInstanceKey];

          if (inst.tag === HostComponent || inst.tag === HostText) {
            // In Fiber, this will always be the deepest root.
            return inst;
          }

          return null;
        }
        /**
         * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
         * instance, or null if the node was not rendered by this React.
         */


        function getInstanceFromNode$1(node) {
          var inst = node[internalInstanceKey];

          if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText) {
              return inst;
            } else {
              return null;
            }
          }

          return null;
        }
        /**
         * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
         * DOM node.
         */


        function getNodeFromInstance$1(inst) {
          if (inst.tag === HostComponent || inst.tag === HostText) {
            // In Fiber this, is just the state node right now. We assume it will be
            // a host component or host text.
            return inst.stateNode;
          } // Without this first invariant, passing a non-DOM-component triggers the next
          // invariant for a missing parent, which is super confusing.


          invariant(false, 'getNodeFromInstance: Invalid argument.');
        }

        function getFiberCurrentPropsFromNode$1(node) {
          return node[internalEventHandlersKey] || null;
        }

        function updateFiberProps(node, props) {
          node[internalEventHandlersKey] = props;
        }

        var ReactDOMComponentTree = Object.freeze({
          precacheFiberNode: precacheFiberNode,
          getClosestInstanceFromNode: getClosestInstanceFromNode,
          getInstanceFromNode: getInstanceFromNode$1,
          getNodeFromInstance: getNodeFromInstance$1,
          getFiberCurrentPropsFromNode: getFiberCurrentPropsFromNode$1,
          updateFiberProps: updateFiberProps
        });

        function getParent(inst) {
          do {
            inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
            // That is depending on if we want nested subtrees (layers) to bubble
            // events to their parent. We could also go through parentNode on the
            // host node but that wouldn't work for React Native and doesn't let us
            // do the portal feature.
          } while (inst && inst.tag !== HostComponent);

          if (inst) {
            return inst;
          }

          return null;
        }
        /**
         * Return the lowest common ancestor of A and B, or null if they are in
         * different trees.
         */


        function getLowestCommonAncestor(instA, instB) {
          var depthA = 0;

          for (var tempA = instA; tempA; tempA = getParent(tempA)) {
            depthA++;
          }

          var depthB = 0;

          for (var tempB = instB; tempB; tempB = getParent(tempB)) {
            depthB++;
          } // If A is deeper, crawl up.


          while (depthA - depthB > 0) {
            instA = getParent(instA);
            depthA--;
          } // If B is deeper, crawl up.


          while (depthB - depthA > 0) {
            instB = getParent(instB);
            depthB--;
          } // Walk in lockstep until we find a match.


          var depth = depthA;

          while (depth--) {
            if (instA === instB || instA === instB.alternate) {
              return instA;
            }

            instA = getParent(instA);
            instB = getParent(instB);
          }

          return null;
        }
        /**
         * Return if A is an ancestor of B.
         */

        /**
         * Return the parent instance of the passed-in instance.
         */


        function getParentInstance(inst) {
          return getParent(inst);
        }
        /**
         * Simulates the traversal of a two-phase, capture/bubble event dispatch.
         */


        function traverseTwoPhase(inst, fn, arg) {
          var path = [];

          while (inst) {
            path.push(inst);
            inst = getParent(inst);
          }

          var i = void 0;

          for (i = path.length; i-- > 0;) {
            fn(path[i], 'captured', arg);
          }

          for (i = 0; i < path.length; i++) {
            fn(path[i], 'bubbled', arg);
          }
        }
        /**
         * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
         * should would receive a `mouseEnter` or `mouseLeave` event.
         *
         * Does not invoke the callback on the nearest common ancestor because nothing
         * "entered" or "left" that element.
         */


        function traverseEnterLeave(from, to, fn, argFrom, argTo) {
          var common = from && to ? getLowestCommonAncestor(from, to) : null;
          var pathFrom = [];

          while (true) {
            if (!from) {
              break;
            }

            if (from === common) {
              break;
            }

            var alternate = from.alternate;

            if (alternate !== null && alternate === common) {
              break;
            }

            pathFrom.push(from);
            from = getParent(from);
          }

          var pathTo = [];

          while (true) {
            if (!to) {
              break;
            }

            if (to === common) {
              break;
            }

            var _alternate = to.alternate;

            if (_alternate !== null && _alternate === common) {
              break;
            }

            pathTo.push(to);
            to = getParent(to);
          }

          for (var i = 0; i < pathFrom.length; i++) {
            fn(pathFrom[i], 'bubbled', argFrom);
          }

          for (var _i = pathTo.length; _i-- > 0;) {
            fn(pathTo[_i], 'captured', argTo);
          }
        }
        /**
         * Some event types have a notion of different registration names for different
         * "phases" of propagation. This finds listeners by a given phase.
         */


        function listenerAtPhase(inst, event, propagationPhase) {
          var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
          return getListener(inst, registrationName);
        }
        /**
         * A small set of propagation patterns, each of which will accept a small amount
         * of information, and generate a set of "dispatch ready event objects" - which
         * are sets of events that have already been annotated with a set of dispatched
         * listener functions/ids. The API is designed this way to discourage these
         * propagation strategies from actually executing the dispatches, since we
         * always want to collect the entire set of dispatches before executing even a
         * single one.
         */

        /**
         * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
         * here, allows us to not have to bind or create functions for each event.
         * Mutating the event's members allows us to not have to create a wrapping
         * "dispatch" object that pairs the event with the listener.
         */


        function accumulateDirectionalDispatches(inst, phase, event) {
          {
            !inst ? warning(false, 'Dispatching inst must not be null') : void 0;
          }
          var listener = listenerAtPhase(inst, event, phase);

          if (listener) {
            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
          }
        }
        /**
         * Collect dispatches (must be entirely collected before dispatching - see unit
         * tests). Lazily allocate the array to conserve memory.  We must loop through
         * each event and perform the traversal for each one. We cannot perform a
         * single traversal for the entire collection of events because each event may
         * have a different target.
         */


        function accumulateTwoPhaseDispatchesSingle(event) {
          if (event && event.dispatchConfig.phasedRegistrationNames) {
            traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
          }
        }
        /**
         * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
         */


        function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
          if (event && event.dispatchConfig.phasedRegistrationNames) {
            var targetInst = event._targetInst;
            var parentInst = targetInst ? getParentInstance(targetInst) : null;
            traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
          }
        }
        /**
         * Accumulates without regard to direction, does not look for phased
         * registration names. Same as `accumulateDirectDispatchesSingle` but without
         * requiring that the `dispatchMarker` be the same as the dispatched ID.
         */


        function accumulateDispatches(inst, ignoredDirection, event) {
          if (inst && event && event.dispatchConfig.registrationName) {
            var registrationName = event.dispatchConfig.registrationName;
            var listener = getListener(inst, registrationName);

            if (listener) {
              event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
              event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
            }
          }
        }
        /**
         * Accumulates dispatches on an `SyntheticEvent`, but only for the
         * `dispatchMarker`.
         * @param {SyntheticEvent} event
         */


        function accumulateDirectDispatchesSingle(event) {
          if (event && event.dispatchConfig.registrationName) {
            accumulateDispatches(event._targetInst, null, event);
          }
        }

        function accumulateTwoPhaseDispatches(events) {
          forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
        }

        function accumulateTwoPhaseDispatchesSkipTarget(events) {
          forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
        }

        function accumulateEnterLeaveDispatches(leave, enter, from, to) {
          traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
        }

        function accumulateDirectDispatches(events) {
          forEachAccumulated(events, accumulateDirectDispatchesSingle);
        }

        var EventPropagators = Object.freeze({
          accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
          accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
          accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches,
          accumulateDirectDispatches: accumulateDirectDispatches
        }); // Do not uses the below two methods directly!
        // Instead use constants exported from DOMTopLevelEventTypes in ReactDOM.
        // (It is the only module that is allowed to access these methods.)

        function unsafeCastStringToDOMTopLevelType(topLevelType) {
          return topLevelType;
        }

        function unsafeCastDOMTopLevelTypeToString(topLevelType) {
          return topLevelType;
        }
        /**
         * Generate a mapping of standard vendor prefixes using the defined style property and event name.
         *
         * @param {string} styleProp
         * @param {string} eventName
         * @returns {object}
         */


        function makePrefixMap(styleProp, eventName) {
          var prefixes = {};
          prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
          prefixes['Webkit' + styleProp] = 'webkit' + eventName;
          prefixes['Moz' + styleProp] = 'moz' + eventName;
          prefixes['ms' + styleProp] = 'MS' + eventName;
          prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
          return prefixes;
        }
        /**
         * A list of event names to a configurable list of vendor prefixes.
         */


        var vendorPrefixes = {
          animationend: makePrefixMap('Animation', 'AnimationEnd'),
          animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
          animationstart: makePrefixMap('Animation', 'AnimationStart'),
          transitionend: makePrefixMap('Transition', 'TransitionEnd')
        };
        /**
         * Event names that have already been detected and prefixed (if applicable).
         */

        var prefixedEventNames = {};
        /**
         * Element to check for prefixes on.
         */

        var style = {};
        /**
         * Bootstrap if a DOM exists.
         */

        if (ExecutionEnvironment.canUseDOM) {
          style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
          // the un-prefixed "animation" and "transition" properties are defined on the
          // style object but the events that fire will still be prefixed, so we need
          // to check if the un-prefixed events are usable, and if not remove them from the map.

          if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
          } // Same as above


          if (!('TransitionEvent' in window)) {
            delete vendorPrefixes.transitionend.transition;
          }
        }
        /**
         * Attempts to determine the correct vendor prefixed event name.
         *
         * @param {string} eventName
         * @returns {string}
         */


        function getVendorPrefixedEventName(eventName) {
          if (prefixedEventNames[eventName]) {
            return prefixedEventNames[eventName];
          } else if (!vendorPrefixes[eventName]) {
            return eventName;
          }

          var prefixMap = vendorPrefixes[eventName];

          for (var styleProp in prefixMap) {
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
              return prefixedEventNames[eventName] = prefixMap[styleProp];
            }
          }

          return eventName;
        }
        /**
         * To identify top level events in ReactDOM, we use constants defined by this
         * module. This is the only module that uses the unsafe* methods to express
         * that the constants actually correspond to the browser event names. This lets
         * us save some bundle size by avoiding a top level type -> event name map.
         * The rest of ReactDOM code should import top level types from this file.
         */


        var TOP_ABORT = unsafeCastStringToDOMTopLevelType('abort');
        var TOP_ANIMATION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationend'));
        var TOP_ANIMATION_ITERATION = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationiteration'));
        var TOP_ANIMATION_START = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationstart'));
        var TOP_BLUR = unsafeCastStringToDOMTopLevelType('blur');
        var TOP_CAN_PLAY = unsafeCastStringToDOMTopLevelType('canplay');
        var TOP_CAN_PLAY_THROUGH = unsafeCastStringToDOMTopLevelType('canplaythrough');
        var TOP_CANCEL = unsafeCastStringToDOMTopLevelType('cancel');
        var TOP_CHANGE = unsafeCastStringToDOMTopLevelType('change');
        var TOP_CLICK = unsafeCastStringToDOMTopLevelType('click');
        var TOP_CLOSE = unsafeCastStringToDOMTopLevelType('close');
        var TOP_COMPOSITION_END = unsafeCastStringToDOMTopLevelType('compositionend');
        var TOP_COMPOSITION_START = unsafeCastStringToDOMTopLevelType('compositionstart');
        var TOP_COMPOSITION_UPDATE = unsafeCastStringToDOMTopLevelType('compositionupdate');
        var TOP_CONTEXT_MENU = unsafeCastStringToDOMTopLevelType('contextmenu');
        var TOP_COPY = unsafeCastStringToDOMTopLevelType('copy');
        var TOP_CUT = unsafeCastStringToDOMTopLevelType('cut');
        var TOP_DOUBLE_CLICK = unsafeCastStringToDOMTopLevelType('dblclick');
        var TOP_DRAG = unsafeCastStringToDOMTopLevelType('drag');
        var TOP_DRAG_END = unsafeCastStringToDOMTopLevelType('dragend');
        var TOP_DRAG_ENTER = unsafeCastStringToDOMTopLevelType('dragenter');
        var TOP_DRAG_EXIT = unsafeCastStringToDOMTopLevelType('dragexit');
        var TOP_DRAG_LEAVE = unsafeCastStringToDOMTopLevelType('dragleave');
        var TOP_DRAG_OVER = unsafeCastStringToDOMTopLevelType('dragover');
        var TOP_DRAG_START = unsafeCastStringToDOMTopLevelType('dragstart');
        var TOP_DROP = unsafeCastStringToDOMTopLevelType('drop');
        var TOP_DURATION_CHANGE = unsafeCastStringToDOMTopLevelType('durationchange');
        var TOP_EMPTIED = unsafeCastStringToDOMTopLevelType('emptied');
        var TOP_ENCRYPTED = unsafeCastStringToDOMTopLevelType('encrypted');
        var TOP_ENDED = unsafeCastStringToDOMTopLevelType('ended');
        var TOP_ERROR = unsafeCastStringToDOMTopLevelType('error');
        var TOP_FOCUS = unsafeCastStringToDOMTopLevelType('focus');
        var TOP_GOT_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('gotpointercapture');
        var TOP_INPUT = unsafeCastStringToDOMTopLevelType('input');
        var TOP_INVALID = unsafeCastStringToDOMTopLevelType('invalid');
        var TOP_KEY_DOWN = unsafeCastStringToDOMTopLevelType('keydown');
        var TOP_KEY_PRESS = unsafeCastStringToDOMTopLevelType('keypress');
        var TOP_KEY_UP = unsafeCastStringToDOMTopLevelType('keyup');
        var TOP_LOAD = unsafeCastStringToDOMTopLevelType('load');
        var TOP_LOAD_START = unsafeCastStringToDOMTopLevelType('loadstart');
        var TOP_LOADED_DATA = unsafeCastStringToDOMTopLevelType('loadeddata');
        var TOP_LOADED_METADATA = unsafeCastStringToDOMTopLevelType('loadedmetadata');
        var TOP_LOST_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('lostpointercapture');
        var TOP_MOUSE_DOWN = unsafeCastStringToDOMTopLevelType('mousedown');
        var TOP_MOUSE_MOVE = unsafeCastStringToDOMTopLevelType('mousemove');
        var TOP_MOUSE_OUT = unsafeCastStringToDOMTopLevelType('mouseout');
        var TOP_MOUSE_OVER = unsafeCastStringToDOMTopLevelType('mouseover');
        var TOP_MOUSE_UP = unsafeCastStringToDOMTopLevelType('mouseup');
        var TOP_PASTE = unsafeCastStringToDOMTopLevelType('paste');
        var TOP_PAUSE = unsafeCastStringToDOMTopLevelType('pause');
        var TOP_PLAY = unsafeCastStringToDOMTopLevelType('play');
        var TOP_PLAYING = unsafeCastStringToDOMTopLevelType('playing');
        var TOP_POINTER_CANCEL = unsafeCastStringToDOMTopLevelType('pointercancel');
        var TOP_POINTER_DOWN = unsafeCastStringToDOMTopLevelType('pointerdown');
        var TOP_POINTER_MOVE = unsafeCastStringToDOMTopLevelType('pointermove');
        var TOP_POINTER_OUT = unsafeCastStringToDOMTopLevelType('pointerout');
        var TOP_POINTER_OVER = unsafeCastStringToDOMTopLevelType('pointerover');
        var TOP_POINTER_UP = unsafeCastStringToDOMTopLevelType('pointerup');
        var TOP_PROGRESS = unsafeCastStringToDOMTopLevelType('progress');
        var TOP_RATE_CHANGE = unsafeCastStringToDOMTopLevelType('ratechange');
        var TOP_RESET = unsafeCastStringToDOMTopLevelType('reset');
        var TOP_SCROLL = unsafeCastStringToDOMTopLevelType('scroll');
        var TOP_SEEKED = unsafeCastStringToDOMTopLevelType('seeked');
        var TOP_SEEKING = unsafeCastStringToDOMTopLevelType('seeking');
        var TOP_SELECTION_CHANGE = unsafeCastStringToDOMTopLevelType('selectionchange');
        var TOP_STALLED = unsafeCastStringToDOMTopLevelType('stalled');
        var TOP_SUBMIT = unsafeCastStringToDOMTopLevelType('submit');
        var TOP_SUSPEND = unsafeCastStringToDOMTopLevelType('suspend');
        var TOP_TEXT_INPUT = unsafeCastStringToDOMTopLevelType('textInput');
        var TOP_TIME_UPDATE = unsafeCastStringToDOMTopLevelType('timeupdate');
        var TOP_TOGGLE = unsafeCastStringToDOMTopLevelType('toggle');
        var TOP_TOUCH_CANCEL = unsafeCastStringToDOMTopLevelType('touchcancel');
        var TOP_TOUCH_END = unsafeCastStringToDOMTopLevelType('touchend');
        var TOP_TOUCH_MOVE = unsafeCastStringToDOMTopLevelType('touchmove');
        var TOP_TOUCH_START = unsafeCastStringToDOMTopLevelType('touchstart');
        var TOP_TRANSITION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('transitionend'));
        var TOP_VOLUME_CHANGE = unsafeCastStringToDOMTopLevelType('volumechange');
        var TOP_WAITING = unsafeCastStringToDOMTopLevelType('waiting');
        var TOP_WHEEL = unsafeCastStringToDOMTopLevelType('wheel'); // List of events that need to be individually attached to media elements.
        // Note that events in this list will *not* be listened to at the top level
        // unless they're explicitly whitelisted in `ReactBrowserEventEmitter.listenTo`.

        var mediaEventTypes = [TOP_ABORT, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_VOLUME_CHANGE, TOP_WAITING];

        function getRawEventName(topLevelType) {
          return unsafeCastDOMTopLevelTypeToString(topLevelType);
        }

        var contentKey = null;
        /**
         * Gets the key used to access text content on a DOM node.
         *
         * @return {?string} Key used to access text content.
         * @internal
         */

        function getTextContentAccessor() {
          if (!contentKey && ExecutionEnvironment.canUseDOM) {
            // Prefer textContent to innerText because many browsers support both but
            // SVG <text> elements don't support innerText even when <div> does.
            contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
          }

          return contentKey;
        }
        /**
         * This helper object stores information about text content of a target node,
         * allowing comparison of content before and after a given event.
         *
         * Identify the node where selection currently begins, then observe
         * both its text content and its current position in the DOM. Since the
         * browser may natively replace the target node during composition, we can
         * use its position to find its replacement.
         *
         *
         */


        var compositionState = {
          _root: null,
          _startText: null,
          _fallbackText: null
        };

        function initialize(nativeEventTarget) {
          compositionState._root = nativeEventTarget;
          compositionState._startText = getText();
          return true;
        }

        function reset() {
          compositionState._root = null;
          compositionState._startText = null;
          compositionState._fallbackText = null;
        }

        function getData() {
          if (compositionState._fallbackText) {
            return compositionState._fallbackText;
          }

          var start = void 0;
          var startValue = compositionState._startText;
          var startLength = startValue.length;
          var end = void 0;
          var endValue = getText();
          var endLength = endValue.length;

          for (start = 0; start < startLength; start++) {
            if (startValue[start] !== endValue[start]) {
              break;
            }
          }

          var minEnd = startLength - start;

          for (end = 1; end <= minEnd; end++) {
            if (startValue[startLength - end] !== endValue[endLength - end]) {
              break;
            }
          }

          var sliceTail = end > 1 ? 1 - end : undefined;
          compositionState._fallbackText = endValue.slice(start, sliceTail);
          return compositionState._fallbackText;
        }

        function getText() {
          if ('value' in compositionState._root) {
            return compositionState._root.value;
          }

          return compositionState._root[getTextContentAccessor()];
        }
        /* eslint valid-typeof: 0 */


        var didWarnForAddedNewProperty = false;
        var EVENT_POOL_SIZE = 10;
        var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
        /**
         * @interface Event
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var EventInterface = {
          type: null,
          target: null,
          // currentTarget is set when dispatching; no use in copying it here
          currentTarget: emptyFunction.thatReturnsNull,
          eventPhase: null,
          bubbles: null,
          cancelable: null,
          timeStamp: function timeStamp(event) {
            return event.timeStamp || Date.now();
          },
          defaultPrevented: null,
          isTrusted: null
        };
        /**
         * Synthetic events are dispatched by event plugins, typically in response to a
         * top-level event delegation handler.
         *
         * These systems should generally use pooling to reduce the frequency of garbage
         * collection. The system should check `isPersistent` to determine whether the
         * event should be released into the pool after being dispatched. Users that
         * need a persisted event should invoke `persist`.
         *
         * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
         * normalizing browser quirks. Subclasses do not necessarily have to implement a
         * DOM interface; custom application-specific events can also subclass this.
         *
         * @param {object} dispatchConfig Configuration used to dispatch this event.
         * @param {*} targetInst Marker identifying the event target.
         * @param {object} nativeEvent Native browser event.
         * @param {DOMEventTarget} nativeEventTarget Target node.
         */

        function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
          {
            // these have a getter/setter for warnings
            delete this.nativeEvent;
            delete this.preventDefault;
            delete this.stopPropagation;
          }
          this.dispatchConfig = dispatchConfig;
          this._targetInst = targetInst;
          this.nativeEvent = nativeEvent;
          var Interface = this.constructor.Interface;

          for (var propName in Interface) {
            if (!Interface.hasOwnProperty(propName)) {
              continue;
            }

            {
              delete this[propName]; // this has a getter/setter for warnings
            }
            var normalize = Interface[propName];

            if (normalize) {
              this[propName] = normalize(nativeEvent);
            } else {
              if (propName === 'target') {
                this.target = nativeEventTarget;
              } else {
                this[propName] = nativeEvent[propName];
              }
            }
          }

          var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

          if (defaultPrevented) {
            this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
          } else {
            this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
          }

          this.isPropagationStopped = emptyFunction.thatReturnsFalse;
          return this;
        }

        _assign(SyntheticEvent.prototype, {
          preventDefault: function preventDefault() {
            this.defaultPrevented = true;
            var event = this.nativeEvent;

            if (!event) {
              return;
            }

            if (event.preventDefault) {
              event.preventDefault();
            } else if (typeof event.returnValue !== 'unknown') {
              event.returnValue = false;
            }

            this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
          },
          stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;

            if (!event) {
              return;
            }

            if (event.stopPropagation) {
              event.stopPropagation();
            } else if (typeof event.cancelBubble !== 'unknown') {
              // The ChangeEventPlugin registers a "propertychange" event for
              // IE. This event does not support bubbling or cancelling, and
              // any references to cancelBubble throw "Member not found".  A
              // typeof check of "unknown" circumvents this issue (and is also
              // IE specific).
              event.cancelBubble = true;
            }

            this.isPropagationStopped = emptyFunction.thatReturnsTrue;
          },

          /**
           * We release all dispatched `SyntheticEvent`s after each event loop, adding
           * them back into the pool. This allows a way to hold onto a reference that
           * won't be added back into the pool.
           */
          persist: function persist() {
            this.isPersistent = emptyFunction.thatReturnsTrue;
          },

          /**
           * Checks if this event should be released back into the pool.
           *
           * @return {boolean} True if this should not be released, false otherwise.
           */
          isPersistent: emptyFunction.thatReturnsFalse,

          /**
           * `PooledClass` looks for `destructor` on each instance it releases.
           */
          destructor: function destructor() {
            var Interface = this.constructor.Interface;

            for (var propName in Interface) {
              {
                Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
              }
            }

            for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
              this[shouldBeReleasedProperties[i]] = null;
            }

            {
              Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
              Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
              Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
            }
          }
        });

        SyntheticEvent.Interface = EventInterface;
        /**
         * Helper to reduce boilerplate when creating subclasses.
         */

        SyntheticEvent.extend = function (Interface) {
          var Super = this;

          var E = function E() {};

          E.prototype = Super.prototype;
          var prototype = new E();

          function Class() {
            return Super.apply(this, arguments);
          }

          _assign(prototype, Class.prototype);

          Class.prototype = prototype;
          Class.prototype.constructor = Class;
          Class.Interface = _assign({}, Super.Interface, Interface);
          Class.extend = Super.extend;
          addEventPoolingTo(Class);
          return Class;
        };
        /** Proxying after everything set on SyntheticEvent
         * to resolve Proxy issue on some WebKit browsers
         * in which some Event properties are set to undefined (GH#10010)
         */


        {
          var isProxySupported = typeof Proxy === 'function' && // https://github.com/facebook/react/issues/12011
          !Object.isSealed(new Proxy({}, {}));

          if (isProxySupported) {
            /*eslint-disable no-func-assign */
            SyntheticEvent = new Proxy(SyntheticEvent, {
              construct: function construct(target, args) {
                return this.apply(target, Object.create(target.prototype), args);
              },
              apply: function apply(constructor, that, args) {
                return new Proxy(constructor.apply(that, args), {
                  set: function set(target, prop, value) {
                    if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
                      !(didWarnForAddedNewProperty || target.isPersistent()) ? warning(false, "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
                      didWarnForAddedNewProperty = true;
                    }

                    target[prop] = value;
                    return true;
                  }
                });
              }
            });
            /*eslint-enable no-func-assign */
          }
        }
        addEventPoolingTo(SyntheticEvent);
        /**
         * Helper to nullify syntheticEvent instance properties when destructing
         *
         * @param {String} propName
         * @param {?object} getVal
         * @return {object} defineProperty object
         */

        function getPooledWarningPropertyDefinition(propName, getVal) {
          var isFunction = typeof getVal === 'function';
          return {
            configurable: true,
            set: set,
            get: get
          };

          function set(val) {
            var action = isFunction ? 'setting the method' : 'setting the property';
            warn(action, 'This is effectively a no-op');
            return val;
          }

          function get() {
            var action = isFunction ? 'accessing the method' : 'accessing the property';
            var result = isFunction ? 'This is a no-op function' : 'This is set to null';
            warn(action, result);
            return getVal;
          }

          function warn(action, result) {
            var warningCondition = false;
            !warningCondition ? warning(false, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
          }
        }

        function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
          var EventConstructor = this;

          if (EventConstructor.eventPool.length) {
            var instance = EventConstructor.eventPool.pop();
            EventConstructor.call(instance, dispatchConfig, targetInst, nativeEvent, nativeInst);
            return instance;
          }

          return new EventConstructor(dispatchConfig, targetInst, nativeEvent, nativeInst);
        }

        function releasePooledEvent(event) {
          var EventConstructor = this;
          !(event instanceof EventConstructor) ? invariant(false, 'Trying to release an event instance  into a pool of a different type.') : void 0;
          event.destructor();

          if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
            EventConstructor.eventPool.push(event);
          }
        }

        function addEventPoolingTo(EventConstructor) {
          EventConstructor.eventPool = [];
          EventConstructor.getPooled = getPooledEvent;
          EventConstructor.release = releasePooledEvent;
        }

        var SyntheticEvent$1 = SyntheticEvent;
        /**
         * @interface Event
         * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
         */

        var SyntheticCompositionEvent = SyntheticEvent$1.extend({
          data: null
        });
        /**
         * @interface Event
         * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
         *      /#events-inputevents
         */

        var SyntheticInputEvent = SyntheticEvent$1.extend({
          data: null
        });
        var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

        var START_KEYCODE = 229;
        var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
        var documentMode = null;

        if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
          documentMode = document.documentMode;
        } // Webkit offers a very useful `textInput` event that can be used to
        // directly represent `beforeInput`. The IE `textinput` event is not as
        // useful, so we don't use it.


        var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
        // by the native compositionend event may be incorrect. Japanese ideographic
        // spaces, for instance (\u3000) are not recorded correctly.

        var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
        var SPACEBAR_CODE = 32;
        var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE); // Events and their corresponding property names.

        var eventTypes = {
          beforeInput: {
            phasedRegistrationNames: {
              bubbled: 'onBeforeInput',
              captured: 'onBeforeInputCapture'
            },
            dependencies: [TOP_COMPOSITION_END, TOP_KEY_PRESS, TOP_TEXT_INPUT, TOP_PASTE]
          },
          compositionEnd: {
            phasedRegistrationNames: {
              bubbled: 'onCompositionEnd',
              captured: 'onCompositionEndCapture'
            },
            dependencies: [TOP_BLUR, TOP_COMPOSITION_END, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
          },
          compositionStart: {
            phasedRegistrationNames: {
              bubbled: 'onCompositionStart',
              captured: 'onCompositionStartCapture'
            },
            dependencies: [TOP_BLUR, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
          },
          compositionUpdate: {
            phasedRegistrationNames: {
              bubbled: 'onCompositionUpdate',
              captured: 'onCompositionUpdateCapture'
            },
            dependencies: [TOP_BLUR, TOP_COMPOSITION_UPDATE, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
          }
        }; // Track whether we've ever handled a keypress on the space key.

        var hasSpaceKeypress = false;
        /**
         * Return whether a native keypress event is assumed to be a command.
         * This is required because Firefox fires `keypress` events for key commands
         * (cut, copy, select-all, etc.) even though no character is inserted.
         */

        function isKeypressCommand(nativeEvent) {
          return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
          !(nativeEvent.ctrlKey && nativeEvent.altKey);
        }
        /**
         * Translate native top level events into event types.
         *
         * @param {string} topLevelType
         * @return {object}
         */


        function getCompositionEventType(topLevelType) {
          switch (topLevelType) {
            case TOP_COMPOSITION_START:
              return eventTypes.compositionStart;

            case TOP_COMPOSITION_END:
              return eventTypes.compositionEnd;

            case TOP_COMPOSITION_UPDATE:
              return eventTypes.compositionUpdate;
          }
        }
        /**
         * Does our fallback best-guess model think this event signifies that
         * composition has begun?
         *
         * @param {string} topLevelType
         * @param {object} nativeEvent
         * @return {boolean}
         */


        function isFallbackCompositionStart(topLevelType, nativeEvent) {
          return topLevelType === TOP_KEY_DOWN && nativeEvent.keyCode === START_KEYCODE;
        }
        /**
         * Does our fallback mode think that this event is the end of composition?
         *
         * @param {string} topLevelType
         * @param {object} nativeEvent
         * @return {boolean}
         */


        function isFallbackCompositionEnd(topLevelType, nativeEvent) {
          switch (topLevelType) {
            case TOP_KEY_UP:
              // Command keys insert or clear IME input.
              return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

            case TOP_KEY_DOWN:
              // Expect IME keyCode on each keydown. If we get any other
              // code we must have exited earlier.
              return nativeEvent.keyCode !== START_KEYCODE;

            case TOP_KEY_PRESS:
            case TOP_MOUSE_DOWN:
            case TOP_BLUR:
              // Events are not possible without cancelling IME.
              return true;

            default:
              return false;
          }
        }
        /**
         * Google Input Tools provides composition data via a CustomEvent,
         * with the `data` property populated in the `detail` object. If this
         * is available on the event object, use it. If not, this is a plain
         * composition event and we have nothing special to extract.
         *
         * @param {object} nativeEvent
         * @return {?string}
         */


        function getDataFromCustomEvent(nativeEvent) {
          var detail = nativeEvent.detail;

          if (typeof detail === 'object' && 'data' in detail) {
            return detail.data;
          }

          return null;
        } // Track the current IME composition status, if any.


        var isComposing = false;
        /**
         * @return {?object} A SyntheticCompositionEvent.
         */

        function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
          var eventType = void 0;
          var fallbackData = void 0;

          if (canUseCompositionEvent) {
            eventType = getCompositionEventType(topLevelType);
          } else if (!isComposing) {
            if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
              eventType = eventTypes.compositionStart;
            }
          } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
            eventType = eventTypes.compositionEnd;
          }

          if (!eventType) {
            return null;
          }

          if (useFallbackCompositionData) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === eventTypes.compositionStart) {
              isComposing = initialize(nativeEventTarget);
            } else if (eventType === eventTypes.compositionEnd) {
              if (isComposing) {
                fallbackData = getData();
              }
            }
          }

          var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

          if (fallbackData) {
            // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
          } else {
            var customData = getDataFromCustomEvent(nativeEvent);

            if (customData !== null) {
              event.data = customData;
            }
          }

          accumulateTwoPhaseDispatches(event);
          return event;
        }
        /**
         * @param {TopLevelType} topLevelType Number from `TopLevelType`.
         * @param {object} nativeEvent Native browser event.
         * @return {?string} The string corresponding to this `beforeInput` event.
         */


        function getNativeBeforeInputChars(topLevelType, nativeEvent) {
          switch (topLevelType) {
            case TOP_COMPOSITION_END:
              return getDataFromCustomEvent(nativeEvent);

            case TOP_KEY_PRESS:
              /**
               * If native `textInput` events are available, our goal is to make
               * use of them. However, there is a special case: the spacebar key.
               * In Webkit, preventing default on a spacebar `textInput` event
               * cancels character insertion, but it *also* causes the browser
               * to fall back to its default spacebar behavior of scrolling the
               * page.
               *
               * Tracking at:
               * https://code.google.com/p/chromium/issues/detail?id=355103
               *
               * To avoid this issue, use the keypress event as if no `textInput`
               * event is available.
               */
              var which = nativeEvent.which;

              if (which !== SPACEBAR_CODE) {
                return null;
              }

              hasSpaceKeypress = true;
              return SPACEBAR_CHAR;

            case TOP_TEXT_INPUT:
              // Record the characters to be added to the DOM.
              var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
              // it at the keypress level and bail immediately. Android Chrome
              // doesn't give us keycodes, so we need to blacklist it.

              if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                return null;
              }

              return chars;

            default:
              // For other native event types, do nothing.
              return null;
          }
        }
        /**
         * For browsers that do not provide the `textInput` event, extract the
         * appropriate string to use for SyntheticInputEvent.
         *
         * @param {number} topLevelType Number from `TopLevelEventTypes`.
         * @param {object} nativeEvent Native browser event.
         * @return {?string} The fallback string for this `beforeInput` event.
         */


        function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
          // If we are currently composing (IME) and using a fallback to do so,
          // try to extract the composed characters from the fallback object.
          // If composition event is available, we extract a string only at
          // compositionevent, otherwise extract it at fallback events.
          if (isComposing) {
            if (topLevelType === TOP_COMPOSITION_END || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
              var chars = getData();
              reset();
              isComposing = false;
              return chars;
            }

            return null;
          }

          switch (topLevelType) {
            case TOP_PASTE:
              // If a paste event occurs after a keypress, throw out the input
              // chars. Paste events should not lead to BeforeInput events.
              return null;

            case TOP_KEY_PRESS:
              /**
               * As of v27, Firefox may fire keypress events even when no character
               * will be inserted. A few possibilities:
               *
               * - `which` is `0`. Arrow keys, Esc key, etc.
               *
               * - `which` is the pressed key code, but no char is available.
               *   Ex: 'AltGr + d` in Polish. There is no modified character for
               *   this key combination and no character is inserted into the
               *   document, but FF fires the keypress for char code `100` anyway.
               *   No `input` event will occur.
               *
               * - `which` is the pressed key code, but a command combination is
               *   being used. Ex: `Cmd+C`. No character is inserted, and no
               *   `input` event will occur.
               */
              if (!isKeypressCommand(nativeEvent)) {
                // IE fires the `keypress` event when a user types an emoji via
                // Touch keyboard of Windows.  In such a case, the `char` property
                // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                // is 2, the property `which` does not represent an emoji correctly.
                // In such a case, we directly return the `char` property instead of
                // using `which`.
                if (nativeEvent.char && nativeEvent.char.length > 1) {
                  return nativeEvent.char;
                } else if (nativeEvent.which) {
                  return String.fromCharCode(nativeEvent.which);
                }
              }

              return null;

            case TOP_COMPOSITION_END:
              return useFallbackCompositionData ? null : nativeEvent.data;

            default:
              return null;
          }
        }
        /**
         * Extract a SyntheticInputEvent for `beforeInput`, based on either native
         * `textInput` or fallback behavior.
         *
         * @return {?object} A SyntheticInputEvent.
         */


        function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
          var chars = void 0;

          if (canUseTextInputEvent) {
            chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
          } else {
            chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
          } // If no characters are being inserted, no BeforeInput event should
          // be fired.


          if (!chars) {
            return null;
          }

          var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
          event.data = chars;
          accumulateTwoPhaseDispatches(event);
          return event;
        }
        /**
         * Create an `onBeforeInput` event to match
         * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
         *
         * This event plugin is based on the native `textInput` event
         * available in Chrome, Safari, Opera, and IE. This event fires after
         * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
         *
         * `beforeInput` is spec'd but not implemented in any browsers, and
         * the `input` event does not provide any useful information about what has
         * actually been added, contrary to the spec. Thus, `textInput` is the best
         * available event to identify the characters that have actually been inserted
         * into the target node.
         *
         * This plugin is also responsible for emitting `composition` events, thus
         * allowing us to share composition fallback code for both `beforeInput` and
         * `composition` event types.
         */


        var BeforeInputEventPlugin = {
          eventTypes: eventTypes,
          extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
            var composition = extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
            var beforeInput = extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);

            if (composition === null) {
              return beforeInput;
            }

            if (beforeInput === null) {
              return composition;
            }

            return [composition, beforeInput];
          }
        }; // Use to restore controlled state after a change event has fired.

        var fiberHostComponent = null;
        var ReactControlledComponentInjection = {
          injectFiberControlledHostComponent: function injectFiberControlledHostComponent(hostComponentImpl) {
            // The fiber implementation doesn't use dynamic dispatch so we need to
            // inject the implementation.
            fiberHostComponent = hostComponentImpl;
          }
        };
        var restoreTarget = null;
        var restoreQueue = null;

        function restoreStateOfTarget(target) {
          // We perform this translation at the end of the event loop so that we
          // always receive the correct fiber here
          var internalInstance = getInstanceFromNode(target);

          if (!internalInstance) {
            // Unmounted
            return;
          }

          !(fiberHostComponent && typeof fiberHostComponent.restoreControlledState === 'function') ? invariant(false, 'Fiber needs to be injected to handle a fiber target for controlled events. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          var props = getFiberCurrentPropsFromNode(internalInstance.stateNode);
          fiberHostComponent.restoreControlledState(internalInstance.stateNode, internalInstance.type, props);
        }

        var injection$2 = ReactControlledComponentInjection;

        function enqueueStateRestore(target) {
          if (restoreTarget) {
            if (restoreQueue) {
              restoreQueue.push(target);
            } else {
              restoreQueue = [target];
            }
          } else {
            restoreTarget = target;
          }
        }

        function needsStateRestore() {
          return restoreTarget !== null || restoreQueue !== null;
        }

        function restoreStateIfNeeded() {
          if (!restoreTarget) {
            return;
          }

          var target = restoreTarget;
          var queuedTargets = restoreQueue;
          restoreTarget = null;
          restoreQueue = null;
          restoreStateOfTarget(target);

          if (queuedTargets) {
            for (var i = 0; i < queuedTargets.length; i++) {
              restoreStateOfTarget(queuedTargets[i]);
            }
          }
        }

        var ReactControlledComponent = Object.freeze({
          injection: injection$2,
          enqueueStateRestore: enqueueStateRestore,
          needsStateRestore: needsStateRestore,
          restoreStateIfNeeded: restoreStateIfNeeded
        }); // Used as a way to call batchedUpdates when we don't have a reference to
        // the renderer. Such as when we're dispatching events or if third party
        // libraries need to call batchedUpdates. Eventually, this API will go away when
        // everything is batched by default. We'll then have a similar API to opt-out of
        // scheduled work and instead do synchronous work.
        // Defaults

        var _batchedUpdates = function _batchedUpdates(fn, bookkeeping) {
          return fn(bookkeeping);
        };

        var _interactiveUpdates = function _interactiveUpdates(fn, a, b) {
          return fn(a, b);
        };

        var _flushInteractiveUpdates = function _flushInteractiveUpdates() {};

        var isBatching = false;

        function batchedUpdates(fn, bookkeeping) {
          if (isBatching) {
            // If we are currently inside another batch, we need to wait until it
            // fully completes before restoring state.
            return fn(bookkeeping);
          }

          isBatching = true;

          try {
            return _batchedUpdates(fn, bookkeeping);
          } finally {
            // Here we wait until all updates have propagated, which is important
            // when using controlled components within layers:
            // https://github.com/facebook/react/issues/1698
            // Then we restore state of any controlled component.
            isBatching = false;
            var controlledComponentsHavePendingUpdates = needsStateRestore();

            if (controlledComponentsHavePendingUpdates) {
              // If a controlled event was fired, we may need to restore the state of
              // the DOM node back to the controlled value. This is necessary when React
              // bails out of the update without touching the DOM.
              _flushInteractiveUpdates();

              restoreStateIfNeeded();
            }
          }
        }

        function interactiveUpdates(fn, a, b) {
          return _interactiveUpdates(fn, a, b);
        }

        var injection$3 = {
          injectRenderer: function injectRenderer(renderer) {
            _batchedUpdates = renderer.batchedUpdates;
            _interactiveUpdates = renderer.interactiveUpdates;
            _flushInteractiveUpdates = renderer.flushInteractiveUpdates;
          }
        };
        /**
         * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
         */

        var supportedInputTypes = {
          color: true,
          date: true,
          datetime: true,
          'datetime-local': true,
          email: true,
          month: true,
          number: true,
          password: true,
          range: true,
          search: true,
          tel: true,
          text: true,
          time: true,
          url: true,
          week: true
        };

        function isTextInputElement(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

          if (nodeName === 'input') {
            return !!supportedInputTypes[elem.type];
          }

          if (nodeName === 'textarea') {
            return true;
          }

          return false;
        }
        /**
         * HTML nodeType values that represent the type of the node
         */


        var ELEMENT_NODE = 1;
        var TEXT_NODE = 3;
        var COMMENT_NODE = 8;
        var DOCUMENT_NODE = 9;
        var DOCUMENT_FRAGMENT_NODE = 11;
        /**
         * Gets the target node from a native browser event by accounting for
         * inconsistencies in browser DOM APIs.
         *
         * @param {object} nativeEvent Native browser event.
         * @return {DOMEventTarget} Target node.
         */

        function getEventTarget(nativeEvent) {
          var target = nativeEvent.target || window; // Normalize SVG <use> element events #4963

          if (target.correspondingUseElement) {
            target = target.correspondingUseElement;
          } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
          // @see http://www.quirksmode.org/js/events_properties.html


          return target.nodeType === TEXT_NODE ? target.parentNode : target;
        }
        /**
         * Checks if an event is supported in the current execution environment.
         *
         * NOTE: This will not work correctly for non-generic events such as `change`,
         * `reset`, `load`, `error`, and `select`.
         *
         * Borrows from Modernizr.
         *
         * @param {string} eventNameSuffix Event name, e.g. "click".
         * @param {?boolean} capture Check if the capture phase is supported.
         * @return {boolean} True if the event is supported.
         * @internal
         * @license Modernizr 3.0.0pre (Custom Build) | MIT
         */


        function isEventSupported(eventNameSuffix, capture) {
          if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
            return false;
          }

          var eventName = 'on' + eventNameSuffix;
          var isSupported = eventName in document;

          if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
          }

          return isSupported;
        }

        function isCheckable(elem) {
          var type = elem.type;
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
        }

        function getTracker(node) {
          return node._valueTracker;
        }

        function detachTracker(node) {
          node._valueTracker = null;
        }

        function getValueFromNode(node) {
          var value = '';

          if (!node) {
            return value;
          }

          if (isCheckable(node)) {
            value = node.checked ? 'true' : 'false';
          } else {
            value = node.value;
          }

          return value;
        }

        function trackValueOnNode(node) {
          var valueField = isCheckable(node) ? 'checked' : 'value';
          var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
          var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
          // and don't track value will cause over reporting of changes,
          // but it's better then a hard failure
          // (needed for certain tests that spyOn input values and Safari)

          if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
            return;
          }

          var _get2 = descriptor.get,
              _set = descriptor.set;
          Object.defineProperty(node, valueField, {
            configurable: true,
            get: function get() {
              return _get2.call(this);
            },
            set: function set(value) {
              currentValue = '' + value;

              _set.call(this, value);
            }
          }); // We could've passed this the first time
          // but it triggers a bug in IE11 and Edge 14/15.
          // Calling defineProperty() again should be equivalent.
          // https://github.com/facebook/react/issues/11768

          Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
          });
          var tracker = {
            getValue: function getValue() {
              return currentValue;
            },
            setValue: function setValue(value) {
              currentValue = '' + value;
            },
            stopTracking: function stopTracking() {
              detachTracker(node);
              delete node[valueField];
            }
          };
          return tracker;
        }

        function track(node) {
          if (getTracker(node)) {
            return;
          } // TODO: Once it's just Fiber we can move this to node._wrapperState


          node._valueTracker = trackValueOnNode(node);
        }

        function updateValueIfChanged(node) {
          if (!node) {
            return false;
          }

          var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
          // that trying again will succeed

          if (!tracker) {
            return true;
          }

          var lastValue = tracker.getValue();
          var nextValue = getValueFromNode(node);

          if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
          }

          return false;
        }

        var ReactInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        var ReactCurrentOwner = ReactInternals.ReactCurrentOwner;
        var ReactDebugCurrentFrame = ReactInternals.ReactDebugCurrentFrame;

        var describeComponentFrame = function describeComponentFrame(name, source, ownerName) {
          return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
        }; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.


        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_TIMEOUT_TYPE = hasSymbol ? Symbol.for('react.timeout') : 0xead1;
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';

        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable === 'undefined') {
            return null;
          }

          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

          if (typeof maybeIterator === 'function') {
            return maybeIterator;
          }

          return null;
        }

        function getComponentName(fiber) {
          var type = fiber.type;

          if (typeof type === 'function') {
            return type.displayName || type.name;
          }

          if (typeof type === 'string') {
            return type;
          }

          switch (type) {
            case REACT_ASYNC_MODE_TYPE:
              return 'AsyncMode';

            case REACT_CONTEXT_TYPE:
              return 'Context.Consumer';

            case REACT_FRAGMENT_TYPE:
              return 'ReactFragment';

            case REACT_PORTAL_TYPE:
              return 'ReactPortal';

            case REACT_PROFILER_TYPE:
              return 'Profiler(' + fiber.pendingProps.id + ')';

            case REACT_PROVIDER_TYPE:
              return 'Context.Provider';

            case REACT_STRICT_MODE_TYPE:
              return 'StrictMode';

            case REACT_TIMEOUT_TYPE:
              return 'Timeout';
          }

          if (typeof type === 'object' && type !== null) {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                var functionName = type.render.displayName || type.render.name || '';
                return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
            }
          }

          return null;
        }

        function describeFiber(fiber) {
          switch (fiber.tag) {
            case IndeterminateComponent:
            case FunctionalComponent:
            case ClassComponent:
            case HostComponent:
              var owner = fiber._debugOwner;
              var source = fiber._debugSource;
              var name = getComponentName(fiber);
              var ownerName = null;

              if (owner) {
                ownerName = getComponentName(owner);
              }

              return describeComponentFrame(name, source, ownerName);

            default:
              return '';
          }
        } // This function can only be called with a work-in-progress fiber and
        // only during begin or complete phase. Do not call it under any other
        // circumstances.


        function getStackAddendumByWorkInProgressFiber(workInProgress) {
          var info = '';
          var node = workInProgress;

          do {
            info += describeFiber(node); // Otherwise this return pointer might point to the wrong tree:

            node = node.return;
          } while (node);

          return info;
        }

        function getCurrentFiberOwnerName$1() {
          {
            var fiber = ReactDebugCurrentFiber.current;

            if (fiber === null) {
              return null;
            }

            var owner = fiber._debugOwner;

            if (owner !== null && typeof owner !== 'undefined') {
              return getComponentName(owner);
            }
          }
          return null;
        }

        function getCurrentFiberStackAddendum$1() {
          {
            var fiber = ReactDebugCurrentFiber.current;

            if (fiber === null) {
              return null;
            } // Safe because if current fiber exists, we are reconciling,
            // and it is guaranteed to be the work-in-progress version.


            return getStackAddendumByWorkInProgressFiber(fiber);
          }
          return null;
        }

        function resetCurrentFiber() {
          ReactDebugCurrentFrame.getCurrentStack = null;
          ReactDebugCurrentFiber.current = null;
          ReactDebugCurrentFiber.phase = null;
        }

        function setCurrentFiber(fiber) {
          ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackAddendum$1;
          ReactDebugCurrentFiber.current = fiber;
          ReactDebugCurrentFiber.phase = null;
        }

        function setCurrentPhase(phase) {
          ReactDebugCurrentFiber.phase = phase;
        }

        var ReactDebugCurrentFiber = {
          current: null,
          phase: null,
          resetCurrentFiber: resetCurrentFiber,
          setCurrentFiber: setCurrentFiber,
          setCurrentPhase: setCurrentPhase,
          getCurrentFiberOwnerName: getCurrentFiberOwnerName$1,
          getCurrentFiberStackAddendum: getCurrentFiberStackAddendum$1
        }; // A reserved attribute.
        // It is handled by React separately and shouldn't be written to the DOM.

        var RESERVED = 0; // A simple string attribute.
        // Attributes that aren't in the whitelist are presumed to have this type.

        var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
        // "enumerated" attributes with "true" and "false" as possible values.
        // When true, it should be set to a "true" string.
        // When false, it should be set to a "false" string.

        var BOOLEANISH_STRING = 2; // A real boolean attribute.
        // When true, it should be present (set either to an empty string or its name).
        // When false, it should be omitted.

        var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
        // When true, it should be present (set either to an empty string or its name).
        // When false, it should be omitted.
        // For any other value, should be present with that value.

        var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
        // When falsy, it should be removed.

        var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
        // When falsy, it should be removed.

        var POSITIVE_NUMERIC = 6;
        /* eslint-disable max-len */

        var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
        /* eslint-enable max-len */

        var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
        var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
        var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var illegalAttributeNameCache = {};
        var validatedAttributeNameCache = {};

        function isAttributeNameSafe(attributeName) {
          if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
            return true;
          }

          if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
            return false;
          }

          if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
          }

          illegalAttributeNameCache[attributeName] = true;
          {
            warning(false, 'Invalid attribute name: `%s`', attributeName);
          }
          return false;
        }

        function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null) {
            return propertyInfo.type === RESERVED;
          }

          if (isCustomComponentTag) {
            return false;
          }

          if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
            return true;
          }

          return false;
        }

        function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null && propertyInfo.type === RESERVED) {
            return false;
          }

          switch (typeof value) {
            case 'function': // $FlowIssue symbol is perfectly valid here

            case 'symbol':
              // eslint-disable-line
              return true;

            case 'boolean':
              {
                if (isCustomComponentTag) {
                  return false;
                }

                if (propertyInfo !== null) {
                  return !propertyInfo.acceptsBooleans;
                } else {
                  var prefix = name.toLowerCase().slice(0, 5);
                  return prefix !== 'data-' && prefix !== 'aria-';
                }
              }

            default:
              return false;
          }
        }

        function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
          if (value === null || typeof value === 'undefined') {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
            return true;
          }

          if (isCustomComponentTag) {
            return false;
          }

          if (propertyInfo !== null) {
            switch (propertyInfo.type) {
              case BOOLEAN:
                return !value;

              case OVERLOADED_BOOLEAN:
                return value === false;

              case NUMERIC:
                return isNaN(value);

              case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
            }
          }

          return false;
        }

        function getPropertyInfo(name) {
          return properties.hasOwnProperty(name) ? properties[name] : null;
        }

        function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace) {
          this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
          this.attributeName = attributeName;
          this.attributeNamespace = attributeNamespace;
          this.mustUseProperty = mustUseProperty;
          this.propertyName = name;
          this.type = type;
        } // When adding attributes to this list, be sure to also add them to
        // the `possibleStandardNames` module to ensure casing and incorrect
        // name warnings.


        var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

        ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
          name, // attributeName
          null);
        } // attributeNamespace
        ); // A few React string attributes have a different name.
        // This is a mapping from React prop names to the attribute names.

        [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
          var name = _ref[0],
              attributeName = _ref[1];
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, // attributeName
          null);
        } // attributeNamespace
        ); // These are "enumerated" HTML attributes that accept "true" and "false".
        // In React, we let users pass `true` and `false` even though technically
        // these aren't boolean attributes (they are coerced to strings).

        ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are "enumerated" SVG attributes that accept "true" and "false".
        // In React, we let users pass `true` and `false` even though technically
        // these aren't boolean attributes (they are coerced to strings).
        // Since these are SVG attributes, their attribute names are case-sensitive.

        ['autoReverse', 'externalResourcesRequired', 'preserveAlpha'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
          name, // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML boolean attributes.

        ['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
        'itemScope'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are the few React props that we set as DOM properties
        // rather than attributes. These are all booleans.

        ['checked', // Note: `option.selected` is not updated if `select.multiple` is
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple', 'muted', 'selected'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML attributes that are "overloaded booleans": they behave like
        // booleans, but can also accept a string value.

        ['capture', 'download'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML attributes that must be positive numbers.

        ['cols', 'rows', 'size', 'span'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML attributes that must be numbers.

        ['rowSpan', 'start'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        );
        var CAMELIZE = /[\-\:]([a-z])/g;

        var capitalize = function capitalize(token) {
          return token[1].toUpperCase();
        }; // This is a list of all SVG attributes that need special casing, namespacing,
        // or boolean value assignment. Regular attributes that just accept strings
        // and have the same names are omitted, just like in the HTML whitelist.
        // Some of these attributes can be hard to find. This list was created by
        // scrapping the MDN documentation.


        ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, null);
        } // attributeNamespace
        ); // String SVG attributes with the xlink namespace.

        ['xlink:actuate', 'xlink:arcrole', 'xlink:href', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, 'http://www.w3.org/1999/xlink');
        }); // String SVG attributes with the xml namespace.

        ['xml:base', 'xml:lang', 'xml:space'].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, 'http://www.w3.org/XML/1998/namespace');
        }); // Special case: this attribute exists both in HTML and SVG.
        // Its "tabindex" attribute name is case-sensitive in SVG so we can't just use
        // its React `tabIndex` name, like we do for attributes that exist only in HTML.

        properties.tabIndex = new PropertyInfoRecord('tabIndex', STRING, false, // mustUseProperty
        'tabindex', // attributeName
        null);
        /**
         * Get the value for a property on a node. Only used in DEV for SSR validation.
         * The "expected" argument is used as a hint of what the expected value is.
         * Some properties have multiple equivalent values.
         */

        function getValueForProperty(node, name, expected, propertyInfo) {
          {
            if (propertyInfo.mustUseProperty) {
              var propertyName = propertyInfo.propertyName;
              return node[propertyName];
            } else {
              var attributeName = propertyInfo.attributeName;
              var stringValue = null;

              if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                  var value = node.getAttribute(attributeName);

                  if (value === '') {
                    return true;
                  }

                  if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                    return value;
                  }

                  if (value === '' + expected) {
                    return expected;
                  }

                  return value;
                }
              } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  // We had an attribute but shouldn't have had one, so read it
                  // for the error message.
                  return node.getAttribute(attributeName);
                }

                if (propertyInfo.type === BOOLEAN) {
                  // If this was a boolean, it doesn't matter what the value is
                  // the fact that we have it is the same as the expected.
                  return expected;
                } // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.


                stringValue = node.getAttribute(attributeName);
              }

              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                return stringValue === null ? expected : stringValue;
              } else if (stringValue === '' + expected) {
                return expected;
              } else {
                return stringValue;
              }
            }
          }
        }
        /**
         * Get the value for a attribute on a node. Only used in DEV for SSR validation.
         * The third argument is used as a hint of what the expected value is. Some
         * attributes have multiple equivalent values.
         */


        function getValueForAttribute(node, name, expected) {
          {
            if (!isAttributeNameSafe(name)) {
              return;
            }

            if (!node.hasAttribute(name)) {
              return expected === undefined ? undefined : null;
            }

            var value = node.getAttribute(name);

            if (value === '' + expected) {
              return expected;
            }

            return value;
          }
        }
        /**
         * Sets the value for a property on a node.
         *
         * @param {DOMElement} node
         * @param {string} name
         * @param {*} value
         */


        function setValueForProperty(node, name, value, isCustomComponentTag) {
          var propertyInfo = getPropertyInfo(name);

          if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
            return;
          }

          if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
            value = null;
          } // If the prop isn't in the special list, treat it as a simple attribute.


          if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
              var _attributeName = name;

              if (value === null) {
                node.removeAttribute(_attributeName);
              } else {
                node.setAttribute(_attributeName, '' + value);
              }
            }

            return;
          }

          var mustUseProperty = propertyInfo.mustUseProperty;

          if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;

            if (value === null) {
              var type = propertyInfo.type;
              node[propertyName] = type === BOOLEAN ? false : '';
            } else {
              // Contrary to `setAttribute`, object properties are properly
              // `toString`ed by IE8/9.
              node[propertyName] = value;
            }

            return;
          } // The rest are treated as attributes with special cases.


          var attributeName = propertyInfo.attributeName,
              attributeNamespace = propertyInfo.attributeNamespace;

          if (value === null) {
            node.removeAttribute(attributeName);
          } else {
            var _type = propertyInfo.type;
            var attributeValue = void 0;

            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
              attributeValue = '';
            } else {
              // `setAttribute` with objects becomes only `[object]` in IE8/9,
              // ('' + value) makes it output the correct toString()-value.
              attributeValue = '' + value;
            }

            if (attributeNamespace) {
              node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            } else {
              node.setAttribute(attributeName, attributeValue);
            }
          }
        }

        var ReactControlledValuePropTypes = {
          checkPropTypes: null
        };
        {
          var hasReadOnlyValue = {
            button: true,
            checkbox: true,
            image: true,
            hidden: true,
            radio: true,
            reset: true,
            submit: true
          };
          var propTypes = {
            value: function value(props, propName, componentName) {
              if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
                return null;
              }

              return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
            },
            checked: function checked(props, propName, componentName) {
              if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
                return null;
              }

              return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
            }
          };
          /**
           * Provide a linked `value` attribute for controlled forms. You should not use
           * this outside of the ReactDOM controlled form components.
           */

          ReactControlledValuePropTypes.checkPropTypes = function (tagName, props, getStack) {
            checkPropTypes(propTypes, props, 'prop', tagName, getStack);
          };
        } // TODO: direct imports like some-package/src/* are bad. Fix me.

        var getCurrentFiberOwnerName = ReactDebugCurrentFiber.getCurrentFiberOwnerName;
        var getCurrentFiberStackAddendum = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var didWarnValueDefaultValue = false;
        var didWarnCheckedDefaultChecked = false;
        var didWarnControlledToUncontrolled = false;
        var didWarnUncontrolledToControlled = false;

        function isControlled(props) {
          var usesChecked = props.type === 'checkbox' || props.type === 'radio';
          return usesChecked ? props.checked != null : props.value != null;
        }
        /**
         * Implements an <input> host component that allows setting these optional
         * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
         *
         * If `checked` or `value` are not supplied (or null/undefined), user actions
         * that affect the checked state or value will trigger updates to the element.
         *
         * If they are supplied (and not null/undefined), the rendered element will not
         * trigger updates to the element. Instead, the props must change in order for
         * the rendered element to be updated.
         *
         * The rendered element will be initialized as unchecked (or `defaultChecked`)
         * with an empty value (or `defaultValue`).
         *
         * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
         */


        function getHostProps(element, props) {
          var node = element;
          var checked = props.checked;

          var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
          });

          return hostProps;
        }

        function initWrapperState(element, props) {
          {
            ReactControlledValuePropTypes.checkPropTypes('input', props, getCurrentFiberStackAddendum);

            if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
              warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerName() || 'A component', props.type);
              didWarnCheckedDefaultChecked = true;
            }

            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
              warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerName() || 'A component', props.type);
              didWarnValueDefaultValue = true;
            }
          }
          var node = element;
          var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
          node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getSafeValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
          };
        }

        function updateChecked(element, props) {
          var node = element;
          var checked = props.checked;

          if (checked != null) {
            setValueForProperty(node, 'checked', checked, false);
          }
        }

        function updateWrapper(element, props) {
          var node = element;
          {
            var _controlled = isControlled(props);

            if (!node._wrapperState.controlled && _controlled && !didWarnUncontrolledToControlled) {
              warning(false, 'A component is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components%s', props.type, getCurrentFiberStackAddendum());
              didWarnUncontrolledToControlled = true;
            }

            if (node._wrapperState.controlled && !_controlled && !didWarnControlledToUncontrolled) {
              warning(false, 'A component is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components%s', props.type, getCurrentFiberStackAddendum());
              didWarnControlledToUncontrolled = true;
            }
          }
          updateChecked(element, props);
          var value = getSafeValue(props.value);

          if (value != null) {
            if (props.type === 'number') {
              if (value === 0 && node.value === '' || // eslint-disable-next-line
              node.value != value) {
                node.value = '' + value;
              }
            } else if (node.value !== '' + value) {
              node.value = '' + value;
            }
          }

          if (props.hasOwnProperty('value')) {
            setDefaultValue(node, props.type, value);
          } else if (props.hasOwnProperty('defaultValue')) {
            setDefaultValue(node, props.type, getSafeValue(props.defaultValue));
          }

          if (props.checked == null && props.defaultChecked != null) {
            node.defaultChecked = !!props.defaultChecked;
          }
        }

        function postMountWrapper(element, props) {
          var node = element;

          if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (node.value === '') {
              node.value = '' + node._wrapperState.initialValue;
            } // value must be assigned before defaultValue. This fixes an issue where the
            // visually displayed value of date inputs disappears on mobile Safari and Chrome:
            // https://github.com/facebook/react/issues/7233


            node.defaultValue = '' + node._wrapperState.initialValue;
          } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
          // this is needed to work around a chrome bug where setting defaultChecked
          // will sometimes influence the value of checked (even after detachment).
          // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
          // We need to temporarily unset name to avoid disrupting radio button groups.


          var name = node.name;

          if (name !== '') {
            node.name = '';
          }

          node.defaultChecked = !node.defaultChecked;
          node.defaultChecked = !node.defaultChecked;

          if (name !== '') {
            node.name = name;
          }
        }

        function restoreControlledState(element, props) {
          var node = element;
          updateWrapper(node, props);
          updateNamedCousins(node, props);
        }

        function updateNamedCousins(rootNode, props) {
          var name = props.name;

          if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;

            while (queryRoot.parentNode) {
              queryRoot = queryRoot.parentNode;
            } // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.


            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

            for (var i = 0; i < group.length; i++) {
              var otherNode = group[i];

              if (otherNode === rootNode || otherNode.form !== rootNode.form) {
                continue;
              } // This will throw if radio buttons rendered by different copies of React
              // and the same name are rendered into the same form (same as #1939).
              // That's probably okay; we don't support it just as we don't support
              // mixing React radio buttons with non-React ones.


              var otherProps = getFiberCurrentPropsFromNode$1(otherNode);
              !otherProps ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : void 0; // We need update the tracked value on the named cousin since the value
              // was changed but the input saw no event or value set

              updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
              // was previously checked to update will cause it to be come re-checked
              // as appropriate.

              updateWrapper(otherNode, otherProps);
            }
          }
        } // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253


        function setDefaultValue(node, type, value) {
          if ( // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
          type !== 'number' || node.ownerDocument.activeElement !== node) {
            if (value == null) {
              node.defaultValue = '' + node._wrapperState.initialValue;
            } else if (node.defaultValue !== '' + value) {
              node.defaultValue = '' + value;
            }
          }
        }

        function getSafeValue(value) {
          switch (typeof value) {
            case 'boolean':
            case 'number':
            case 'object':
            case 'string':
            case 'undefined':
              return value;

            default:
              // function, symbol are assigned as empty strings
              return '';
          }
        }

        var eventTypes$1 = {
          change: {
            phasedRegistrationNames: {
              bubbled: 'onChange',
              captured: 'onChangeCapture'
            },
            dependencies: [TOP_BLUR, TOP_CHANGE, TOP_CLICK, TOP_FOCUS, TOP_INPUT, TOP_KEY_DOWN, TOP_KEY_UP, TOP_SELECTION_CHANGE]
          }
        };

        function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
          var event = SyntheticEvent$1.getPooled(eventTypes$1.change, inst, nativeEvent, target);
          event.type = 'change'; // Flag this event loop as needing state restore.

          enqueueStateRestore(target);
          accumulateTwoPhaseDispatches(event);
          return event;
        }
        /**
         * For IE shims
         */


        var activeElement = null;
        var activeElementInst = null;
        /**
         * SECTION: handle `change` event
         */

        function shouldUseChangeEvent(elem) {
          var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
        }

        function manualDispatchChangeEvent(nativeEvent) {
          var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
          // other events and have it go through ReactBrowserEventEmitter. Since it
          // doesn't, we manually listen for the events and so we have to enqueue and
          // process the abstract event manually.
          //
          // Batching is necessary here in order to ensure that all event handlers run
          // before the next rerender (including event handlers attached to ancestor
          // elements instead of directly on the input). Without this, controlled
          // components don't work properly in conjunction with event bubbling because
          // the component is rerendered and the value reverted before all the event
          // handlers can run. See https://github.com/facebook/react/issues/708.

          batchedUpdates(runEventInBatch, event);
        }

        function runEventInBatch(event) {
          runEventsInBatch(event, false);
        }

        function getInstIfValueChanged(targetInst) {
          var targetNode = getNodeFromInstance$1(targetInst);

          if (updateValueIfChanged(targetNode)) {
            return targetInst;
          }
        }

        function getTargetInstForChangeEvent(topLevelType, targetInst) {
          if (topLevelType === TOP_CHANGE) {
            return targetInst;
          }
        }
        /**
         * SECTION: handle `input` event
         */


        var isInputEventSupported = false;

        if (ExecutionEnvironment.canUseDOM) {
          // IE9 claims to support the input event but fails to trigger it when
          // deleting text, so we ignore its input events.
          isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
        }
        /**
         * (For IE <=9) Starts tracking propertychange events on the passed-in element
         * and override the value property so that we can distinguish user events from
         * value changes in JS.
         */


        function startWatchingForValueChange(target, targetInst) {
          activeElement = target;
          activeElementInst = targetInst;
          activeElement.attachEvent('onpropertychange', handlePropertyChange);
        }
        /**
         * (For IE <=9) Removes the event listeners from the currently-tracked element,
         * if any exists.
         */


        function stopWatchingForValueChange() {
          if (!activeElement) {
            return;
          }

          activeElement.detachEvent('onpropertychange', handlePropertyChange);
          activeElement = null;
          activeElementInst = null;
        }
        /**
         * (For IE <=9) Handles a propertychange event, sending a `change` event if
         * the value of the active element has changed.
         */


        function handlePropertyChange(nativeEvent) {
          if (nativeEvent.propertyName !== 'value') {
            return;
          }

          if (getInstIfValueChanged(activeElementInst)) {
            manualDispatchChangeEvent(nativeEvent);
          }
        }

        function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
          if (topLevelType === TOP_FOCUS) {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
          } else if (topLevelType === TOP_BLUR) {
            stopWatchingForValueChange();
          }
        } // For IE8 and IE9.


        function getTargetInstForInputEventPolyfill(topLevelType, targetInst) {
          if (topLevelType === TOP_SELECTION_CHANGE || topLevelType === TOP_KEY_UP || topLevelType === TOP_KEY_DOWN) {
            // On the selectionchange event, the target is just document which isn't
            // helpful for us so just check activeElement instead.
            //
            // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
            // propertychange on the first input event after setting `value` from a
            // script and fires only keydown, keypress, keyup. Catching keyup usually
            // gets it and catching keydown lets us fire an event for the first
            // keystroke if user does a key repeat (it'll be a little delayed: right
            // before the second keystroke). Other input methods (e.g., paste) seem to
            // fire selectionchange normally.
            return getInstIfValueChanged(activeElementInst);
          }
        }
        /**
         * SECTION: handle `click` event
         */


        function shouldUseClickEvent(elem) {
          // Use the `click` event to detect changes to checkbox and radio inputs.
          // This approach works across all browsers, whereas `change` does not fire
          // until `blur` in IE8.
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
        }

        function getTargetInstForClickEvent(topLevelType, targetInst) {
          if (topLevelType === TOP_CLICK) {
            return getInstIfValueChanged(targetInst);
          }
        }

        function getTargetInstForInputOrChangeEvent(topLevelType, targetInst) {
          if (topLevelType === TOP_INPUT || topLevelType === TOP_CHANGE) {
            return getInstIfValueChanged(targetInst);
          }
        }

        function handleControlledInputBlur(inst, node) {
          // TODO: In IE, inst is occasionally null. Why?
          if (inst == null) {
            return;
          } // Fiber and ReactDOM keep wrapper state in separate places


          var state = inst._wrapperState || node._wrapperState;

          if (!state || !state.controlled || node.type !== 'number') {
            return;
          } // If controlled, assign the value attribute to the current value on blur


          setDefaultValue(node, 'number', node.value);
        }
        /**
         * This plugin creates an `onChange` event that normalizes change events
         * across form elements. This event fires at a time when it's possible to
         * change the element's value without seeing a flicker.
         *
         * Supported elements are:
         * - input (see `isTextInputElement`)
         * - textarea
         * - select
         */


        var ChangeEventPlugin = {
          eventTypes: eventTypes$1,
          _isInputEventSupported: isInputEventSupported,
          extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
            var getTargetInstFunc = void 0,
                handleEventFunc = void 0;

            if (shouldUseChangeEvent(targetNode)) {
              getTargetInstFunc = getTargetInstForChangeEvent;
            } else if (isTextInputElement(targetNode)) {
              if (isInputEventSupported) {
                getTargetInstFunc = getTargetInstForInputOrChangeEvent;
              } else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
              }
            } else if (shouldUseClickEvent(targetNode)) {
              getTargetInstFunc = getTargetInstForClickEvent;
            }

            if (getTargetInstFunc) {
              var inst = getTargetInstFunc(topLevelType, targetInst);

              if (inst) {
                var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
                return event;
              }
            }

            if (handleEventFunc) {
              handleEventFunc(topLevelType, targetNode, targetInst);
            } // When blurring, set the value attribute for number inputs


            if (topLevelType === TOP_BLUR) {
              handleControlledInputBlur(targetInst, targetNode);
            }
          }
        };
        /**
         * Module that is injectable into `EventPluginHub`, that specifies a
         * deterministic ordering of `EventPlugin`s. A convenient way to reason about
         * plugins, without having to package every one of them. This is better than
         * having plugins be ordered in the same order that they are injected because
         * that ordering would be influenced by the packaging order.
         * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
         * preventing default on events is convenient in `SimpleEventPlugin` handlers.
         */

        var DOMEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
        var SyntheticUIEvent = SyntheticEvent$1.extend({
          view: null,
          detail: null
        });
        /**
         * Translation from modifier key to the associated property in the event.
         * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
         */

        var modifierKeyToProp = {
          Alt: 'altKey',
          Control: 'ctrlKey',
          Meta: 'metaKey',
          Shift: 'shiftKey'
        }; // IE8 does not implement getModifierState so we simply map it to the only
        // modifier keys exposed by the event itself, does not support Lock-keys.
        // Currently, all major browsers except Chrome seems to support Lock-keys.

        function modifierStateGetter(keyArg) {
          var syntheticEvent = this;
          var nativeEvent = syntheticEvent.nativeEvent;

          if (nativeEvent.getModifierState) {
            return nativeEvent.getModifierState(keyArg);
          }

          var keyProp = modifierKeyToProp[keyArg];
          return keyProp ? !!nativeEvent[keyProp] : false;
        }

        function getEventModifierState(nativeEvent) {
          return modifierStateGetter;
        }
        /**
         * @interface MouseEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */


        var SyntheticMouseEvent = SyntheticUIEvent.extend({
          screenX: null,
          screenY: null,
          clientX: null,
          clientY: null,
          pageX: null,
          pageY: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          getModifierState: getEventModifierState,
          button: null,
          buttons: null,
          relatedTarget: function relatedTarget(event) {
            return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
          }
        });
        /**
         * @interface PointerEvent
         * @see http://www.w3.org/TR/pointerevents/
         */

        var SyntheticPointerEvent = SyntheticMouseEvent.extend({
          pointerId: null,
          width: null,
          height: null,
          pressure: null,
          tiltX: null,
          tiltY: null,
          pointerType: null,
          isPrimary: null
        });
        var eventTypes$2 = {
          mouseEnter: {
            registrationName: 'onMouseEnter',
            dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
          },
          mouseLeave: {
            registrationName: 'onMouseLeave',
            dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
          },
          pointerEnter: {
            registrationName: 'onPointerEnter',
            dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
          },
          pointerLeave: {
            registrationName: 'onPointerLeave',
            dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
          }
        };
        var EnterLeaveEventPlugin = {
          eventTypes: eventTypes$2,

          /**
           * For almost every interaction we care about, there will be both a top-level
           * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
           * we do not extract duplicate events. However, moving the mouse into the
           * browser from outside will not fire a `mouseout` event. In this case, we use
           * the `mouseover` top-level event.
           */
          extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
            var isOverEvent = topLevelType === TOP_MOUSE_OVER || topLevelType === TOP_POINTER_OVER;
            var isOutEvent = topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_POINTER_OUT;

            if (isOverEvent && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
              return null;
            }

            if (!isOutEvent && !isOverEvent) {
              // Must not be a mouse or pointer in or out - ignoring.
              return null;
            }

            var win = void 0;

            if (nativeEventTarget.window === nativeEventTarget) {
              // `nativeEventTarget` is probably a window object.
              win = nativeEventTarget;
            } else {
              // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
              var doc = nativeEventTarget.ownerDocument;

              if (doc) {
                win = doc.defaultView || doc.parentWindow;
              } else {
                win = window;
              }
            }

            var from = void 0;
            var to = void 0;

            if (isOutEvent) {
              from = targetInst;
              var related = nativeEvent.relatedTarget || nativeEvent.toElement;
              to = related ? getClosestInstanceFromNode(related) : null;
            } else {
              // Moving to a node from outside the window.
              from = null;
              to = targetInst;
            }

            if (from === to) {
              // Nothing pertains to our managed components.
              return null;
            }

            var eventInterface = void 0,
                leaveEventType = void 0,
                enterEventType = void 0,
                eventTypePrefix = void 0;

            if (topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_MOUSE_OVER) {
              eventInterface = SyntheticMouseEvent;
              leaveEventType = eventTypes$2.mouseLeave;
              enterEventType = eventTypes$2.mouseEnter;
              eventTypePrefix = 'mouse';
            } else if (topLevelType === TOP_POINTER_OUT || topLevelType === TOP_POINTER_OVER) {
              eventInterface = SyntheticPointerEvent;
              leaveEventType = eventTypes$2.pointerLeave;
              enterEventType = eventTypes$2.pointerEnter;
              eventTypePrefix = 'pointer';
            }

            var fromNode = from == null ? win : getNodeFromInstance$1(from);
            var toNode = to == null ? win : getNodeFromInstance$1(to);
            var leave = eventInterface.getPooled(leaveEventType, from, nativeEvent, nativeEventTarget);
            leave.type = eventTypePrefix + 'leave';
            leave.target = fromNode;
            leave.relatedTarget = toNode;
            var enter = eventInterface.getPooled(enterEventType, to, nativeEvent, nativeEventTarget);
            enter.type = eventTypePrefix + 'enter';
            enter.target = toNode;
            enter.relatedTarget = fromNode;
            accumulateEnterLeaveDispatches(leave, enter, from, to);
            return [leave, enter];
          }
        };
        /**
         * `ReactInstanceMap` maintains a mapping from a public facing stateful
         * instance (key) and the internal representation (value). This allows public
         * methods to accept the user facing instance as an argument and map them back
         * to internal methods.
         *
         * Note that this module is currently shared and assumed to be stateless.
         * If this becomes an actual Map, that will break.
         */

        /**
         * This API should be called `delete` but we'd have to make sure to always
         * transform these to strings for IE support. When this transform is fully
         * supported we can rename it.
         */

        function get(key) {
          return key._reactInternalFiber;
        }

        function has(key) {
          return key._reactInternalFiber !== undefined;
        }

        function set(key, value) {
          key._reactInternalFiber = value;
        } // Don't change these two values. They're used by React Dev Tools.


        var NoEffect =
        /*              */
        0;
        var PerformedWork =
        /*         */
        1; // You can change the rest (and add more).

        var Placement =
        /*             */
        2;
        var Update =
        /*                */
        4;
        var PlacementAndUpdate =
        /*    */
        6;
        var Deletion =
        /*              */
        8;
        var ContentReset =
        /*          */
        16;
        var Callback =
        /*              */
        32;
        var DidCapture =
        /*            */
        64;
        var Ref =
        /*                   */
        128;
        var Snapshot =
        /*              */
        256; // Union of all host effects

        var HostEffectMask =
        /*        */
        511;
        var Incomplete =
        /*            */
        512;
        var ShouldCapture =
        /*         */
        1024;
        var MOUNTING = 1;
        var MOUNTED = 2;
        var UNMOUNTED = 3;

        function isFiberMountedImpl(fiber) {
          var node = fiber;

          if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            if ((node.effectTag & Placement) !== NoEffect) {
              return MOUNTING;
            }

            while (node.return) {
              node = node.return;

              if ((node.effectTag & Placement) !== NoEffect) {
                return MOUNTING;
              }
            }
          } else {
            while (node.return) {
              node = node.return;
            }
          }

          if (node.tag === HostRoot) {
            // TODO: Check if this was a nested HostRoot when used with
            // renderContainerIntoSubtree.
            return MOUNTED;
          } // If we didn't hit the root, that means that we're in an disconnected tree
          // that has been unmounted.


          return UNMOUNTED;
        }

        function isFiberMounted(fiber) {
          return isFiberMountedImpl(fiber) === MOUNTED;
        }

        function isMounted(component) {
          {
            var owner = ReactCurrentOwner.current;

            if (owner !== null && owner.tag === ClassComponent) {
              var ownerFiber = owner;
              var instance = ownerFiber.stateNode;
              !instance._warnedAboutRefsInRender ? warning(false, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber) || 'A component') : void 0;
              instance._warnedAboutRefsInRender = true;
            }
          }
          var fiber = get(component);

          if (!fiber) {
            return false;
          }

          return isFiberMountedImpl(fiber) === MOUNTED;
        }

        function assertIsMounted(fiber) {
          !(isFiberMountedImpl(fiber) === MOUNTED) ? invariant(false, 'Unable to find node on an unmounted component.') : void 0;
        }

        function findCurrentFiberUsingSlowPath(fiber) {
          var alternate = fiber.alternate;

          if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var state = isFiberMountedImpl(fiber);
            !(state !== UNMOUNTED) ? invariant(false, 'Unable to find node on an unmounted component.') : void 0;

            if (state === MOUNTING) {
              return null;
            }

            return fiber;
          } // If we have two possible branches, we'll walk backwards up to the root
          // to see what path the root points to. On the way we may hit one of the
          // special cases and we'll deal with them.


          var a = fiber;
          var b = alternate;

          while (true) {
            var parentA = a.return;
            var parentB = parentA ? parentA.alternate : null;

            if (!parentA || !parentB) {
              // We're at the root.
              break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.


            if (parentA.child === parentB.child) {
              var child = parentA.child;

              while (child) {
                if (child === a) {
                  // We've determined that A is the current branch.
                  assertIsMounted(parentA);
                  return fiber;
                }

                if (child === b) {
                  // We've determined that B is the current branch.
                  assertIsMounted(parentA);
                  return alternate;
                }

                child = child.sibling;
              } // We should never have an alternate for any mounting node. So the only
              // way this could possibly happen is if this was unmounted, if at all.


              invariant(false, 'Unable to find node on an unmounted component.');
            }

            if (a.return !== b.return) {
              // The return pointer of A and the return pointer of B point to different
              // fibers. We assume that return pointers never criss-cross, so A must
              // belong to the child set of A.return, and B must belong to the child
              // set of B.return.
              a = parentA;
              b = parentB;
            } else {
              // The return pointers point to the same fiber. We'll have to use the
              // default, slow path: scan the child sets of each parent alternate to see
              // which child belongs to which set.
              //
              // Search parent A's child set
              var didFindChild = false;
              var _child = parentA.child;

              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentA;
                  b = parentB;
                  break;
                }

                if (_child === b) {
                  didFindChild = true;
                  b = parentA;
                  a = parentB;
                  break;
                }

                _child = _child.sibling;
              }

              if (!didFindChild) {
                // Search parent B's child set
                _child = parentB.child;

                while (_child) {
                  if (_child === a) {
                    didFindChild = true;
                    a = parentB;
                    b = parentA;
                    break;
                  }

                  if (_child === b) {
                    didFindChild = true;
                    b = parentB;
                    a = parentA;
                    break;
                  }

                  _child = _child.sibling;
                }

                !didFindChild ? invariant(false, 'Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.') : void 0;
              }
            }

            !(a.alternate === b) ? invariant(false, 'Return fibers should always be each others\' alternates. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          } // If the root is not a host container, we're in a disconnected tree. I.e.
          // unmounted.


          !(a.tag === HostRoot) ? invariant(false, 'Unable to find node on an unmounted component.') : void 0;

          if (a.stateNode.current === a) {
            // We've determined that A is the current branch.
            return fiber;
          } // Otherwise B has to be current branch.


          return alternate;
        }

        function findCurrentHostFiber(parent) {
          var currentParent = findCurrentFiberUsingSlowPath(parent);

          if (!currentParent) {
            return null;
          } // Next we'll drill down this component to find the first HostComponent/Text.


          var node = currentParent;

          while (true) {
            if (node.tag === HostComponent || node.tag === HostText) {
              return node;
            } else if (node.child) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === currentParent) {
              return null;
            }

            while (!node.sibling) {
              if (!node.return || node.return === currentParent) {
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          } // Flow needs the return null here, but ESLint complains about it.
          // eslint-disable-next-line no-unreachable


          return null;
        }

        function findCurrentHostFiberWithNoPortals(parent) {
          var currentParent = findCurrentFiberUsingSlowPath(parent);

          if (!currentParent) {
            return null;
          } // Next we'll drill down this component to find the first HostComponent/Text.


          var node = currentParent;

          while (true) {
            if (node.tag === HostComponent || node.tag === HostText) {
              return node;
            } else if (node.child && node.tag !== HostPortal) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === currentParent) {
              return null;
            }

            while (!node.sibling) {
              if (!node.return || node.return === currentParent) {
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          } // Flow needs the return null here, but ESLint complains about it.
          // eslint-disable-next-line no-unreachable


          return null;
        }

        function addEventBubbleListener(element, eventType, listener) {
          element.addEventListener(eventType, listener, false);
        }

        function addEventCaptureListener(element, eventType, listener) {
          element.addEventListener(eventType, listener, true);
        }
        /**
         * @interface Event
         * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
         * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
         */


        var SyntheticAnimationEvent = SyntheticEvent$1.extend({
          animationName: null,
          elapsedTime: null,
          pseudoElement: null
        });
        /**
         * @interface Event
         * @see http://www.w3.org/TR/clipboard-apis/
         */

        var SyntheticClipboardEvent = SyntheticEvent$1.extend({
          clipboardData: function clipboardData(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
          }
        });
        /**
         * @interface FocusEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var SyntheticFocusEvent = SyntheticUIEvent.extend({
          relatedTarget: null
        });
        /**
         * `charCode` represents the actual "character code" and is safe to use with
         * `String.fromCharCode`. As such, only keys that correspond to printable
         * characters produce a valid `charCode`, the only exception to this is Enter.
         * The Tab-key is considered non-printable and does not have a `charCode`,
         * presumably because it does not produce a tab-character in browsers.
         *
         * @param {object} nativeEvent Native browser event.
         * @return {number} Normalized `charCode` property.
         */

        function getEventCharCode(nativeEvent) {
          var charCode = void 0;
          var keyCode = nativeEvent.keyCode;

          if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

            if (charCode === 0 && keyCode === 13) {
              charCode = 13;
            }
          } else {
            // IE8 does not implement `charCode`, but `keyCode` has the correct value.
            charCode = keyCode;
          } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
          // report Enter as charCode 10 when ctrl is pressed.


          if (charCode === 10) {
            charCode = 13;
          } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
          // Must not discard the (non-)printable Enter-key.


          if (charCode >= 32 || charCode === 13) {
            return charCode;
          }

          return 0;
        }
        /**
         * Normalization of deprecated HTML5 `key` values
         * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
         */


        var normalizeKey = {
          Esc: 'Escape',
          Spacebar: ' ',
          Left: 'ArrowLeft',
          Up: 'ArrowUp',
          Right: 'ArrowRight',
          Down: 'ArrowDown',
          Del: 'Delete',
          Win: 'OS',
          Menu: 'ContextMenu',
          Apps: 'ContextMenu',
          Scroll: 'ScrollLock',
          MozPrintableKey: 'Unidentified'
        };
        /**
         * Translation from legacy `keyCode` to HTML5 `key`
         * Only special keys supported, all others depend on keyboard layout or browser
         * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
         */

        var translateToKey = {
          '8': 'Backspace',
          '9': 'Tab',
          '12': 'Clear',
          '13': 'Enter',
          '16': 'Shift',
          '17': 'Control',
          '18': 'Alt',
          '19': 'Pause',
          '20': 'CapsLock',
          '27': 'Escape',
          '32': ' ',
          '33': 'PageUp',
          '34': 'PageDown',
          '35': 'End',
          '36': 'Home',
          '37': 'ArrowLeft',
          '38': 'ArrowUp',
          '39': 'ArrowRight',
          '40': 'ArrowDown',
          '45': 'Insert',
          '46': 'Delete',
          '112': 'F1',
          '113': 'F2',
          '114': 'F3',
          '115': 'F4',
          '116': 'F5',
          '117': 'F6',
          '118': 'F7',
          '119': 'F8',
          '120': 'F9',
          '121': 'F10',
          '122': 'F11',
          '123': 'F12',
          '144': 'NumLock',
          '145': 'ScrollLock',
          '224': 'Meta'
        };
        /**
         * @param {object} nativeEvent Native browser event.
         * @return {string} Normalized `key` property.
         */

        function getEventKey(nativeEvent) {
          if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

            if (key !== 'Unidentified') {
              return key;
            }
          } // Browser does not implement `key`, polyfill as much of it as we can.


          if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.

            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
          }

          if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
            // While user keyboard layout determines the actual meaning of each
            // `keyCode` value, almost all function keys have a universal value.
            return translateToKey[nativeEvent.keyCode] || 'Unidentified';
          }

          return '';
        }
        /**
         * @interface KeyboardEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */


        var SyntheticKeyboardEvent = SyntheticUIEvent.extend({
          key: getEventKey,
          location: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          repeat: null,
          locale: null,
          getModifierState: getEventModifierState,
          // Legacy Interface
          charCode: function charCode(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') {
              return getEventCharCode(event);
            }

            return 0;
          },
          keyCode: function keyCode(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') {
              return event.keyCode;
            }

            return 0;
          },
          which: function which(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') {
              return getEventCharCode(event);
            }

            if (event.type === 'keydown' || event.type === 'keyup') {
              return event.keyCode;
            }

            return 0;
          }
        });
        /**
         * @interface DragEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var SyntheticDragEvent = SyntheticMouseEvent.extend({
          dataTransfer: null
        });
        /**
         * @interface TouchEvent
         * @see http://www.w3.org/TR/touch-events/
         */

        var SyntheticTouchEvent = SyntheticUIEvent.extend({
          touches: null,
          targetTouches: null,
          changedTouches: null,
          altKey: null,
          metaKey: null,
          ctrlKey: null,
          shiftKey: null,
          getModifierState: getEventModifierState
        });
        /**
         * @interface Event
         * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
         * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
         */

        var SyntheticTransitionEvent = SyntheticEvent$1.extend({
          propertyName: null,
          elapsedTime: null,
          pseudoElement: null
        });
        /**
         * @interface WheelEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var SyntheticWheelEvent = SyntheticMouseEvent.extend({
          deltaX: function deltaX(event) {
            return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
            'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
          },
          deltaY: function deltaY(event) {
            return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
            'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            'wheelDelta' in event ? -event.wheelDelta : 0;
          },
          deltaZ: null,
          // Browsers without "deltaMode" is reporting in raw wheel delta where one
          // notch on the scroll is always +/- 120, roughly equivalent to pixels.
          // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
          // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
          deltaMode: null
        });
        /**
         * Turns
         * ['abort', ...]
         * into
         * eventTypes = {
         *   'abort': {
         *     phasedRegistrationNames: {
         *       bubbled: 'onAbort',
         *       captured: 'onAbortCapture',
         *     },
         *     dependencies: [TOP_ABORT],
         *   },
         *   ...
         * };
         * topLevelEventsToDispatchConfig = new Map([
         *   [TOP_ABORT, { sameConfig }],
         * ]);
         */

        var interactiveEventTypeNames = [[TOP_BLUR, 'blur'], [TOP_CANCEL, 'cancel'], [TOP_CLICK, 'click'], [TOP_CLOSE, 'close'], [TOP_CONTEXT_MENU, 'contextMenu'], [TOP_COPY, 'copy'], [TOP_CUT, 'cut'], [TOP_DOUBLE_CLICK, 'doubleClick'], [TOP_DRAG_END, 'dragEnd'], [TOP_DRAG_START, 'dragStart'], [TOP_DROP, 'drop'], [TOP_FOCUS, 'focus'], [TOP_INPUT, 'input'], [TOP_INVALID, 'invalid'], [TOP_KEY_DOWN, 'keyDown'], [TOP_KEY_PRESS, 'keyPress'], [TOP_KEY_UP, 'keyUp'], [TOP_MOUSE_DOWN, 'mouseDown'], [TOP_MOUSE_UP, 'mouseUp'], [TOP_PASTE, 'paste'], [TOP_PAUSE, 'pause'], [TOP_PLAY, 'play'], [TOP_POINTER_CANCEL, 'pointerCancel'], [TOP_POINTER_DOWN, 'pointerDown'], [TOP_POINTER_UP, 'pointerUp'], [TOP_RATE_CHANGE, 'rateChange'], [TOP_RESET, 'reset'], [TOP_SEEKED, 'seeked'], [TOP_SUBMIT, 'submit'], [TOP_TOUCH_CANCEL, 'touchCancel'], [TOP_TOUCH_END, 'touchEnd'], [TOP_TOUCH_START, 'touchStart'], [TOP_VOLUME_CHANGE, 'volumeChange']];
        var nonInteractiveEventTypeNames = [[TOP_ABORT, 'abort'], [TOP_ANIMATION_END, 'animationEnd'], [TOP_ANIMATION_ITERATION, 'animationIteration'], [TOP_ANIMATION_START, 'animationStart'], [TOP_CAN_PLAY, 'canPlay'], [TOP_CAN_PLAY_THROUGH, 'canPlayThrough'], [TOP_DRAG, 'drag'], [TOP_DRAG_ENTER, 'dragEnter'], [TOP_DRAG_EXIT, 'dragExit'], [TOP_DRAG_LEAVE, 'dragLeave'], [TOP_DRAG_OVER, 'dragOver'], [TOP_DURATION_CHANGE, 'durationChange'], [TOP_EMPTIED, 'emptied'], [TOP_ENCRYPTED, 'encrypted'], [TOP_ENDED, 'ended'], [TOP_ERROR, 'error'], [TOP_GOT_POINTER_CAPTURE, 'gotPointerCapture'], [TOP_LOAD, 'load'], [TOP_LOADED_DATA, 'loadedData'], [TOP_LOADED_METADATA, 'loadedMetadata'], [TOP_LOAD_START, 'loadStart'], [TOP_LOST_POINTER_CAPTURE, 'lostPointerCapture'], [TOP_MOUSE_MOVE, 'mouseMove'], [TOP_MOUSE_OUT, 'mouseOut'], [TOP_MOUSE_OVER, 'mouseOver'], [TOP_PLAYING, 'playing'], [TOP_POINTER_MOVE, 'pointerMove'], [TOP_POINTER_OUT, 'pointerOut'], [TOP_POINTER_OVER, 'pointerOver'], [TOP_PROGRESS, 'progress'], [TOP_SCROLL, 'scroll'], [TOP_SEEKING, 'seeking'], [TOP_STALLED, 'stalled'], [TOP_SUSPEND, 'suspend'], [TOP_TIME_UPDATE, 'timeUpdate'], [TOP_TOGGLE, 'toggle'], [TOP_TOUCH_MOVE, 'touchMove'], [TOP_TRANSITION_END, 'transitionEnd'], [TOP_WAITING, 'waiting'], [TOP_WHEEL, 'wheel']];
        var eventTypes$4 = {};
        var topLevelEventsToDispatchConfig = {};

        function addEventTypeNameToConfig(_ref, isInteractive) {
          var topEvent = _ref[0],
              event = _ref[1];
          var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
          var onEvent = 'on' + capitalizedEvent;
          var type = {
            phasedRegistrationNames: {
              bubbled: onEvent,
              captured: onEvent + 'Capture'
            },
            dependencies: [topEvent],
            isInteractive: isInteractive
          };
          eventTypes$4[event] = type;
          topLevelEventsToDispatchConfig[topEvent] = type;
        }

        interactiveEventTypeNames.forEach(function (eventTuple) {
          addEventTypeNameToConfig(eventTuple, true);
        });
        nonInteractiveEventTypeNames.forEach(function (eventTuple) {
          addEventTypeNameToConfig(eventTuple, false);
        }); // Only used in DEV for exhaustiveness validation.

        var knownHTMLTopLevelTypes = [TOP_ABORT, TOP_CANCEL, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_CLOSE, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_INPUT, TOP_INVALID, TOP_LOAD, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_RESET, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUBMIT, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_TOGGLE, TOP_VOLUME_CHANGE, TOP_WAITING];
        var SimpleEventPlugin = {
          eventTypes: eventTypes$4,
          isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(topLevelType) {
            var config = topLevelEventsToDispatchConfig[topLevelType];
            return config !== undefined && config.isInteractive === true;
          },
          extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
            var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];

            if (!dispatchConfig) {
              return null;
            }

            var EventConstructor = void 0;

            switch (topLevelType) {
              case TOP_KEY_PRESS:
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) {
                  return null;
                }

              /* falls through */

              case TOP_KEY_DOWN:
              case TOP_KEY_UP:
                EventConstructor = SyntheticKeyboardEvent;
                break;

              case TOP_BLUR:
              case TOP_FOCUS:
                EventConstructor = SyntheticFocusEvent;
                break;

              case TOP_CLICK:
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) {
                  return null;
                }

              /* falls through */

              case TOP_DOUBLE_CLICK:
              case TOP_MOUSE_DOWN:
              case TOP_MOUSE_MOVE:
              case TOP_MOUSE_UP: // TODO: Disabled elements should not respond to mouse events

              /* falls through */

              case TOP_MOUSE_OUT:
              case TOP_MOUSE_OVER:
              case TOP_CONTEXT_MENU:
                EventConstructor = SyntheticMouseEvent;
                break;

              case TOP_DRAG:
              case TOP_DRAG_END:
              case TOP_DRAG_ENTER:
              case TOP_DRAG_EXIT:
              case TOP_DRAG_LEAVE:
              case TOP_DRAG_OVER:
              case TOP_DRAG_START:
              case TOP_DROP:
                EventConstructor = SyntheticDragEvent;
                break;

              case TOP_TOUCH_CANCEL:
              case TOP_TOUCH_END:
              case TOP_TOUCH_MOVE:
              case TOP_TOUCH_START:
                EventConstructor = SyntheticTouchEvent;
                break;

              case TOP_ANIMATION_END:
              case TOP_ANIMATION_ITERATION:
              case TOP_ANIMATION_START:
                EventConstructor = SyntheticAnimationEvent;
                break;

              case TOP_TRANSITION_END:
                EventConstructor = SyntheticTransitionEvent;
                break;

              case TOP_SCROLL:
                EventConstructor = SyntheticUIEvent;
                break;

              case TOP_WHEEL:
                EventConstructor = SyntheticWheelEvent;
                break;

              case TOP_COPY:
              case TOP_CUT:
              case TOP_PASTE:
                EventConstructor = SyntheticClipboardEvent;
                break;

              case TOP_GOT_POINTER_CAPTURE:
              case TOP_LOST_POINTER_CAPTURE:
              case TOP_POINTER_CANCEL:
              case TOP_POINTER_DOWN:
              case TOP_POINTER_MOVE:
              case TOP_POINTER_OUT:
              case TOP_POINTER_OVER:
              case TOP_POINTER_UP:
                EventConstructor = SyntheticPointerEvent;
                break;

              default:
                {
                  if (knownHTMLTopLevelTypes.indexOf(topLevelType) === -1) {
                    warning(false, 'SimpleEventPlugin: Unhandled event type, `%s`. This warning ' + 'is likely caused by a bug in React. Please file an issue.', topLevelType);
                  }
                } // HTML Events
                // @see http://www.w3.org/TR/html5/index.html#events-0

                EventConstructor = SyntheticEvent$1;
                break;
            }

            var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
            accumulateTwoPhaseDispatches(event);
            return event;
          }
        };
        var isInteractiveTopLevelEventType = SimpleEventPlugin.isInteractiveTopLevelEventType;
        var CALLBACK_BOOKKEEPING_POOL_SIZE = 10;
        var callbackBookkeepingPool = [];
        /**
         * Find the deepest React component completely containing the root of the
         * passed-in instance (for use when entire React trees are nested within each
         * other). If React trees are not nested, returns null.
         */

        function findRootContainerNode(inst) {
          // TODO: It may be a good idea to cache this to prevent unnecessary DOM
          // traversal, but caching is difficult to do correctly without using a
          // mutation observer to listen for all DOM changes.
          while (inst.return) {
            inst = inst.return;
          }

          if (inst.tag !== HostRoot) {
            // This can happen if we're in a detached tree.
            return null;
          }

          return inst.stateNode.containerInfo;
        } // Used to store ancestor hierarchy in top level callback


        function getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst) {
          if (callbackBookkeepingPool.length) {
            var instance = callbackBookkeepingPool.pop();
            instance.topLevelType = topLevelType;
            instance.nativeEvent = nativeEvent;
            instance.targetInst = targetInst;
            return instance;
          }

          return {
            topLevelType: topLevelType,
            nativeEvent: nativeEvent,
            targetInst: targetInst,
            ancestors: []
          };
        }

        function releaseTopLevelCallbackBookKeeping(instance) {
          instance.topLevelType = null;
          instance.nativeEvent = null;
          instance.targetInst = null;
          instance.ancestors.length = 0;

          if (callbackBookkeepingPool.length < CALLBACK_BOOKKEEPING_POOL_SIZE) {
            callbackBookkeepingPool.push(instance);
          }
        }

        function handleTopLevel(bookKeeping) {
          var targetInst = bookKeeping.targetInst; // Loop through the hierarchy, in case there's any nested components.
          // It's important that we build the array of ancestors before calling any
          // event handlers, because event handlers can modify the DOM, leading to
          // inconsistencies with ReactMount's node cache. See #1105.

          var ancestor = targetInst;

          do {
            if (!ancestor) {
              bookKeeping.ancestors.push(ancestor);
              break;
            }

            var root = findRootContainerNode(ancestor);

            if (!root) {
              break;
            }

            bookKeeping.ancestors.push(ancestor);
            ancestor = getClosestInstanceFromNode(root);
          } while (ancestor);

          for (var i = 0; i < bookKeeping.ancestors.length; i++) {
            targetInst = bookKeeping.ancestors[i];
            runExtractedEventsInBatch(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
          }
        } // TODO: can we stop exporting these?


        var _enabled = true;

        function setEnabled(enabled) {
          _enabled = !!enabled;
        }

        function isEnabled() {
          return _enabled;
        }
        /**
         * Traps top-level events by using event bubbling.
         *
         * @param {number} topLevelType Number from `TopLevelEventTypes`.
         * @param {object} element Element on which to attach listener.
         * @return {?object} An object with a remove function which will forcefully
         *                  remove the listener.
         * @internal
         */


        function trapBubbledEvent(topLevelType, element) {
          if (!element) {
            return null;
          }

          var dispatch = isInteractiveTopLevelEventType(topLevelType) ? dispatchInteractiveEvent : dispatchEvent;
          addEventBubbleListener(element, getRawEventName(topLevelType), // Check if interactive and wrap in interactiveUpdates
          dispatch.bind(null, topLevelType));
        }
        /**
         * Traps a top-level event by using event capturing.
         *
         * @param {number} topLevelType Number from `TopLevelEventTypes`.
         * @param {object} element Element on which to attach listener.
         * @return {?object} An object with a remove function which will forcefully
         *                  remove the listener.
         * @internal
         */


        function trapCapturedEvent(topLevelType, element) {
          if (!element) {
            return null;
          }

          var dispatch = isInteractiveTopLevelEventType(topLevelType) ? dispatchInteractiveEvent : dispatchEvent;
          addEventCaptureListener(element, getRawEventName(topLevelType), // Check if interactive and wrap in interactiveUpdates
          dispatch.bind(null, topLevelType));
        }

        function dispatchInteractiveEvent(topLevelType, nativeEvent) {
          interactiveUpdates(dispatchEvent, topLevelType, nativeEvent);
        }

        function dispatchEvent(topLevelType, nativeEvent) {
          if (!_enabled) {
            return;
          }

          var nativeEventTarget = getEventTarget(nativeEvent);
          var targetInst = getClosestInstanceFromNode(nativeEventTarget);

          if (targetInst !== null && typeof targetInst.tag === 'number' && !isFiberMounted(targetInst)) {
            // If we get an event (ex: img onload) before committing that
            // component's mount, ignore it for now (that is, treat it as if it was an
            // event on a non-React tree). We might also consider queueing events and
            // dispatching them after the mount.
            targetInst = null;
          }

          var bookKeeping = getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst);

          try {
            // Event queue being processed in the same cycle allows
            // `preventDefault`.
            batchedUpdates(handleTopLevel, bookKeeping);
          } finally {
            releaseTopLevelCallbackBookKeeping(bookKeeping);
          }
        }

        var ReactDOMEventListener = Object.freeze({
          get _enabled() {
            return _enabled;
          },

          setEnabled: setEnabled,
          isEnabled: isEnabled,
          trapBubbledEvent: trapBubbledEvent,
          trapCapturedEvent: trapCapturedEvent,
          dispatchEvent: dispatchEvent
        });
        /**
         * Summary of `ReactBrowserEventEmitter` event handling:
         *
         *  - Top-level delegation is used to trap most native browser events. This
         *    may only occur in the main thread and is the responsibility of
         *    ReactDOMEventListener, which is injected and can therefore support
         *    pluggable event sources. This is the only work that occurs in the main
         *    thread.
         *
         *  - We normalize and de-duplicate events to account for browser quirks. This
         *    may be done in the worker thread.
         *
         *  - Forward these native events (with the associated top-level type used to
         *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
         *    to extract any synthetic events.
         *
         *  - The `EventPluginHub` will then process each event by annotating them with
         *    "dispatches", a sequence of listeners and IDs that care about that event.
         *
         *  - The `EventPluginHub` then dispatches the events.
         *
         * Overview of React and the event system:
         *
         * +------------+    .
         * |    DOM     |    .
         * +------------+    .
         *       |           .
         *       v           .
         * +------------+    .
         * | ReactEvent |    .
         * |  Listener  |    .
         * +------------+    .                         +-----------+
         *       |           .               +--------+|SimpleEvent|
         *       |           .               |         |Plugin     |
         * +-----|------+    .               v         +-----------+
         * |     |      |    .    +--------------+                    +------------+
         * |     +-----------.--->|EventPluginHub|                    |    Event   |
         * |            |    .    |              |     +-----------+  | Propagators|
         * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
         * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
         * |            |    .    |              |     +-----------+  |  utilities |
         * |     +-----------.--->|              |                    +------------+
         * |     |      |    .    +--------------+
         * +-----|------+    .                ^        +-----------+
         *       |           .                |        |Enter/Leave|
         *       +           .                +-------+|Plugin     |
         * +-------------+   .                         +-----------+
         * | application |   .
         * |-------------|   .
         * |             |   .
         * |             |   .
         * +-------------+   .
         *                   .
         *    React Core     .  General Purpose Event Plugin System
         */

        var alreadyListeningTo = {};
        var reactTopListenersCounter = 0;
        /**
         * To ensure no conflicts with other potential React instances on the page
         */

        var topListenersIDKey = '_reactListenersID' + ('' + Math.random()).slice(2);

        function getListeningForDocument(mountAt) {
          // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
          // directly.
          if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
            mountAt[topListenersIDKey] = reactTopListenersCounter++;
            alreadyListeningTo[mountAt[topListenersIDKey]] = {};
          }

          return alreadyListeningTo[mountAt[topListenersIDKey]];
        }
        /**
         * We listen for bubbled touch events on the document object.
         *
         * Firefox v8.01 (and possibly others) exhibited strange behavior when
         * mounting `onmousemove` events at some node that was not the document
         * element. The symptoms were that if your mouse is not moving over something
         * contained within that mount point (for example on the background) the
         * top-level listeners for `onmousemove` won't be called. However, if you
         * register the `mousemove` on the document object, then it will of course
         * catch all `mousemove`s. This along with iOS quirks, justifies restricting
         * top-level listeners to the document object only, at least for these
         * movement types of events and possibly all events.
         *
         * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
         *
         * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
         * they bubble to document.
         *
         * @param {string} registrationName Name of listener (e.g. `onClick`).
         * @param {object} mountAt Container where to mount the listener
         */


        function listenTo(registrationName, mountAt) {
          var isListening = getListeningForDocument(mountAt);
          var dependencies = registrationNameDependencies[registrationName];

          for (var i = 0; i < dependencies.length; i++) {
            var dependency = dependencies[i];

            if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
              switch (dependency) {
                case TOP_SCROLL:
                  trapCapturedEvent(TOP_SCROLL, mountAt);
                  break;

                case TOP_FOCUS:
                case TOP_BLUR:
                  trapCapturedEvent(TOP_FOCUS, mountAt);
                  trapCapturedEvent(TOP_BLUR, mountAt); // We set the flag for a single dependency later in this function,
                  // but this ensures we mark both as attached rather than just one.

                  isListening[TOP_BLUR] = true;
                  isListening[TOP_FOCUS] = true;
                  break;

                case TOP_CANCEL:
                case TOP_CLOSE:
                  if (isEventSupported(getRawEventName(dependency), true)) {
                    trapCapturedEvent(dependency, mountAt);
                  }

                  break;

                case TOP_INVALID:
                case TOP_SUBMIT:
                case TOP_RESET:
                  // We listen to them on the target DOM elements.
                  // Some of them bubble so we don't want them to fire twice.
                  break;

                default:
                  // By default, listen on the top level to all non-media events.
                  // Media events don't bubble so adding the listener wouldn't do anything.
                  var isMediaEvent = mediaEventTypes.indexOf(dependency) !== -1;

                  if (!isMediaEvent) {
                    trapBubbledEvent(dependency, mountAt);
                  }

                  break;
              }

              isListening[dependency] = true;
            }
          }
        }

        function isListeningToAllDependencies(registrationName, mountAt) {
          var isListening = getListeningForDocument(mountAt);
          var dependencies = registrationNameDependencies[registrationName];

          for (var i = 0; i < dependencies.length; i++) {
            var dependency = dependencies[i];

            if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
              return false;
            }
          }

          return true;
        }
        /**
         * Given any node return the first leaf node without children.
         *
         * @param {DOMElement|DOMTextNode} node
         * @return {DOMElement|DOMTextNode}
         */


        function getLeafNode(node) {
          while (node && node.firstChild) {
            node = node.firstChild;
          }

          return node;
        }
        /**
         * Get the next sibling within a container. This will walk up the
         * DOM if a node's siblings have been exhausted.
         *
         * @param {DOMElement|DOMTextNode} node
         * @return {?DOMElement|DOMTextNode}
         */


        function getSiblingNode(node) {
          while (node) {
            if (node.nextSibling) {
              return node.nextSibling;
            }

            node = node.parentNode;
          }
        }
        /**
         * Get object describing the nodes which contain characters at offset.
         *
         * @param {DOMElement|DOMTextNode} root
         * @param {number} offset
         * @return {?object}
         */


        function getNodeForCharacterOffset(root, offset) {
          var node = getLeafNode(root);
          var nodeStart = 0;
          var nodeEnd = 0;

          while (node) {
            if (node.nodeType === TEXT_NODE) {
              nodeEnd = nodeStart + node.textContent.length;

              if (nodeStart <= offset && nodeEnd >= offset) {
                return {
                  node: node,
                  offset: offset - nodeStart
                };
              }

              nodeStart = nodeEnd;
            }

            node = getLeafNode(getSiblingNode(node));
          }
        }
        /**
         * @param {DOMElement} outerNode
         * @return {?object}
         */


        function getOffsets(outerNode) {
          var selection = window.getSelection && window.getSelection();

          if (!selection || selection.rangeCount === 0) {
            return null;
          }

          var anchorNode = selection.anchorNode,
              anchorOffset = selection.anchorOffset,
              focusNode = selection.focusNode,
              focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
          // up/down buttons on an <input type="number">. Anonymous divs do not seem to
          // expose properties, triggering a "Permission denied error" if any of its
          // properties are accessed. The only seemingly possible way to avoid erroring
          // is to access a property that typically works for non-anonymous divs and
          // catch any error that may otherwise arise. See
          // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

          try {
            /* eslint-disable no-unused-expressions */
            anchorNode.nodeType;
            focusNode.nodeType;
            /* eslint-enable no-unused-expressions */
          } catch (e) {
            return null;
          }

          return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
        }
        /**
         * Returns {start, end} where `start` is the character/codepoint index of
         * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
         * `end` is the index of (focusNode, focusOffset).
         *
         * Returns null if you pass in garbage input but we should probably just crash.
         *
         * Exported only for testing.
         */


        function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
          var length = 0;
          var start = -1;
          var end = -1;
          var indexWithinAnchor = 0;
          var indexWithinFocus = 0;
          var node = outerNode;
          var parentNode = null;

          outer: while (true) {
            var next = null;

            while (true) {
              if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
                start = length + anchorOffset;
              }

              if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
                end = length + focusOffset;
              }

              if (node.nodeType === TEXT_NODE) {
                length += node.nodeValue.length;
              }

              if ((next = node.firstChild) === null) {
                break;
              } // Moving from `node` to its first child `next`.


              parentNode = node;
              node = next;
            }

            while (true) {
              if (node === outerNode) {
                // If `outerNode` has children, this is always the second time visiting
                // it. If it has no children, this is still the first loop, and the only
                // valid selection is anchorNode and focusNode both equal to this node
                // and both offsets 0, in which case we will have handled above.
                break outer;
              }

              if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
                start = length;
              }

              if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
                end = length;
              }

              if ((next = node.nextSibling) !== null) {
                break;
              }

              node = parentNode;
              parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.


            node = next;
          }

          if (start === -1 || end === -1) {
            // This should never happen. (Would happen if the anchor/focus nodes aren't
            // actually inside the passed-in node.)
            return null;
          }

          return {
            start: start,
            end: end
          };
        }
        /**
         * In modern non-IE browsers, we can support both forward and backward
         * selections.
         *
         * Note: IE10+ supports the Selection object, but it does not support
         * the `extend` method, which means that even in modern IE, it's not possible
         * to programmatically create a backward selection. Thus, for all IE
         * versions, we use the old IE API to create our selections.
         *
         * @param {DOMElement|DOMTextNode} node
         * @param {object} offsets
         */


        function setOffsets(node, offsets) {
          if (!window.getSelection) {
            return;
          }

          var selection = window.getSelection();
          var length = node[getTextContentAccessor()].length;
          var start = Math.min(offsets.start, length);
          var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
          // Flip backward selections, so we can set with a single range.

          if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
          }

          var startMarker = getNodeForCharacterOffset(node, start);
          var endMarker = getNodeForCharacterOffset(node, end);

          if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
              return;
            }

            var range = document.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();

            if (start > end) {
              selection.addRange(range);
              selection.extend(endMarker.node, endMarker.offset);
            } else {
              range.setEnd(endMarker.node, endMarker.offset);
              selection.addRange(range);
            }
          }
        }

        function isInDocument(node) {
          return containsNode(document.documentElement, node);
        }
        /**
         * @ReactInputSelection: React input selection module. Based on Selection.js,
         * but modified to be suitable for react and has a couple of bug fixes (doesn't
         * assume buttons have range selections allowed).
         * Input selection module for React.
         */


        function hasSelectionCapabilities(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
        }

        function getSelectionInformation() {
          var focusedElem = getActiveElement();
          return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection$1(focusedElem) : null
          };
        }
        /**
         * @restoreSelection: If any selection information was potentially lost,
         * restore it. This is useful when performing operations that could remove dom
         * nodes and place them back in, resulting in focus being lost.
         */


        function restoreSelection(priorSelectionInformation) {
          var curFocusedElem = getActiveElement();
          var priorFocusedElem = priorSelectionInformation.focusedElem;
          var priorSelectionRange = priorSelectionInformation.selectionRange;

          if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (hasSelectionCapabilities(priorFocusedElem)) {
              setSelection(priorFocusedElem, priorSelectionRange);
            } // Focusing a node can change the scroll position, which is undesirable


            var ancestors = [];
            var ancestor = priorFocusedElem;

            while (ancestor = ancestor.parentNode) {
              if (ancestor.nodeType === ELEMENT_NODE) {
                ancestors.push({
                  element: ancestor,
                  left: ancestor.scrollLeft,
                  top: ancestor.scrollTop
                });
              }
            }

            priorFocusedElem.focus();

            for (var i = 0; i < ancestors.length; i++) {
              var info = ancestors[i];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
        }
        /**
         * @getSelection: Gets the selection bounds of a focused textarea, input or
         * contentEditable node.
         * -@input: Look up selection bounds of this input
         * -@return {start: selectionStart, end: selectionEnd}
         */


        function getSelection$1(input) {
          var selection = void 0;

          if ('selectionStart' in input) {
            // Modern browser with input or textarea.
            selection = {
              start: input.selectionStart,
              end: input.selectionEnd
            };
          } else {
            // Content editable or old IE textarea.
            selection = getOffsets(input);
          }

          return selection || {
            start: 0,
            end: 0
          };
        }
        /**
         * @setSelection: Sets the selection bounds of a textarea or input and focuses
         * the input.
         * -@input     Set selection bounds of this input or textarea
         * -@offsets   Object of same form that is returned from get*
         */


        function setSelection(input, offsets) {
          var start = offsets.start,
              end = offsets.end;

          if (end === undefined) {
            end = start;
          }

          if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
          } else {
            setOffsets(input, offsets);
          }
        }

        var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
        var eventTypes$3 = {
          select: {
            phasedRegistrationNames: {
              bubbled: 'onSelect',
              captured: 'onSelectCapture'
            },
            dependencies: [TOP_BLUR, TOP_CONTEXT_MENU, TOP_FOCUS, TOP_KEY_DOWN, TOP_KEY_UP, TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_SELECTION_CHANGE]
          }
        };
        var activeElement$1 = null;
        var activeElementInst$1 = null;
        var lastSelection = null;
        var mouseDown = false;
        /**
         * Get an object which is a unique representation of the current selection.
         *
         * The return value will not be consistent across nodes or browsers, but
         * two identical selections on the same node will return identical objects.
         *
         * @param {DOMElement} node
         * @return {object}
         */

        function getSelection(node) {
          if ('selectionStart' in node && hasSelectionCapabilities(node)) {
            return {
              start: node.selectionStart,
              end: node.selectionEnd
            };
          } else if (window.getSelection) {
            var selection = window.getSelection();
            return {
              anchorNode: selection.anchorNode,
              anchorOffset: selection.anchorOffset,
              focusNode: selection.focusNode,
              focusOffset: selection.focusOffset
            };
          }
        }
        /**
         * Poll selection to see whether it's changed.
         *
         * @param {object} nativeEvent
         * @return {?SyntheticEvent}
         */


        function constructSelectEvent(nativeEvent, nativeEventTarget) {
          // Ensure we have the right element, and that the user is not dragging a
          // selection (this matches native `select` event behavior). In HTML5, select
          // fires only on input and textarea thus if there's no focused element we
          // won't dispatch.
          if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement()) {
            return null;
          } // Only fire when selection has actually changed.


          var currentSelection = getSelection(activeElement$1);

          if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var syntheticEvent = SyntheticEvent$1.getPooled(eventTypes$3.select, activeElementInst$1, nativeEvent, nativeEventTarget);
            syntheticEvent.type = 'select';
            syntheticEvent.target = activeElement$1;
            accumulateTwoPhaseDispatches(syntheticEvent);
            return syntheticEvent;
          }

          return null;
        }
        /**
         * This plugin creates an `onSelect` event that normalizes select events
         * across form elements.
         *
         * Supported elements are:
         * - input (see `isTextInputElement`)
         * - textarea
         * - contentEditable
         *
         * This differs from native browser implementations in the following ways:
         * - Fires on contentEditable fields as well as inputs.
         * - Fires for collapsed selection.
         * - Fires after user input.
         */


        var SelectEventPlugin = {
          eventTypes: eventTypes$3,
          extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
            var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : nativeEventTarget.nodeType === DOCUMENT_NODE ? nativeEventTarget : nativeEventTarget.ownerDocument; // Track whether all listeners exists for this plugin. If none exist, we do
            // not extract events. See #3639.

            if (!doc || !isListeningToAllDependencies('onSelect', doc)) {
              return null;
            }

            var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;

            switch (topLevelType) {
              // Track the input node that has focus.
              case TOP_FOCUS:
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                  activeElement$1 = targetNode;
                  activeElementInst$1 = targetInst;
                  lastSelection = null;
                }

                break;

              case TOP_BLUR:
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
              // Don't fire the event while the user is dragging. This matches the
              // semantics of the native select event.

              case TOP_MOUSE_DOWN:
                mouseDown = true;
                break;

              case TOP_CONTEXT_MENU:
              case TOP_MOUSE_UP:
                mouseDown = false;
                return constructSelectEvent(nativeEvent, nativeEventTarget);
              // Chrome and IE fire non-standard event when selection is changed (and
              // sometimes when it hasn't). IE's event fires out of order with respect
              // to key and input events on deletion, so we discard it.
              //
              // Firefox doesn't support selectionchange, so check selection status
              // after each key entry. The selection changes after keydown and before
              // keyup, but we check on keydown as well in the case of holding down a
              // key, when multiple keydown events are fired but only one keyup is.
              // This is also our approach for IE handling, for the reason above.

              case TOP_SELECTION_CHANGE:
                if (skipSelectionChangeEvent) {
                  break;
                }

              // falls through

              case TOP_KEY_DOWN:
              case TOP_KEY_UP:
                return constructSelectEvent(nativeEvent, nativeEventTarget);
            }

            return null;
          }
        };
        /**
         * Inject modules for resolving DOM hierarchy and plugin ordering.
         */

        injection.injectEventPluginOrder(DOMEventPluginOrder);
        injection$1.injectComponentTree(ReactDOMComponentTree);
        /**
         * Some important event plugins included by default (without having to require
         * them).
         */

        injection.injectEventPluginsByName({
          SimpleEventPlugin: SimpleEventPlugin,
          EnterLeaveEventPlugin: EnterLeaveEventPlugin,
          ChangeEventPlugin: ChangeEventPlugin,
          SelectEventPlugin: SelectEventPlugin,
          BeforeInputEventPlugin: BeforeInputEventPlugin
        });
        {
          if (ExecutionEnvironment.canUseDOM && typeof requestAnimationFrame !== 'function') {
            warning(false, 'React depends on requestAnimationFrame. Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }
        }
        /**
         * A scheduling library to allow scheduling work with more granular priority and
         * control than requestAnimationFrame and requestIdleCallback.
         * Current TODO items:
         * X- Pull out the scheduleWork polyfill built into React
         * X- Initial test coverage
         * X- Support for multiple callbacks
         * - Support for two priorities; serial and deferred
         * - Better test coverage
         * - Better docblock
         * - Polish documentation, API
         */
        // This is a built-in polyfill for requestIdleCallback. It works by scheduling
        // a requestAnimationFrame, storing the time for the start of the frame, then
        // scheduling a postMessage which gets scheduled after paint. Within the
        // postMessage handler do as much work as possible until time + frame rate.
        // By separating the idle call into a separate event tick we ensure that
        // layout, paint and other browser work is counted against the available time.
        // The frame rate is dynamically adjusted.

        var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
        var now$1 = void 0;

        if (hasNativePerformanceNow) {
          now$1 = function now$1() {
            return performance.now();
          };
        } else {
          now$1 = function now$1() {
            return Date.now();
          };
        } // TODO: There's no way to cancel, because Fiber doesn't atm.


        var scheduleWork = void 0;
        var cancelScheduledWork = void 0;

        if (!ExecutionEnvironment.canUseDOM) {
          var callbackIdCounter = 0; // Timeouts are objects in Node.
          // For consistency, we'll use numbers in the public API anyway.

          var timeoutIds = {};

          scheduleWork = function scheduleWork(callback, options) {
            var callbackId = callbackIdCounter++;
            var timeoutId = setTimeout(function () {
              callback({
                timeRemaining: function timeRemaining() {
                  return Infinity;
                },
                didTimeout: false
              });
            });
            timeoutIds[callbackId] = timeoutId;
            return callbackId;
          };

          cancelScheduledWork = function cancelScheduledWork(callbackId) {
            var timeoutId = timeoutIds[callbackId];
            delete timeoutIds[callbackId];
            clearTimeout(timeoutId);
          };
        } else {
          // We keep callbacks in a queue.
          // Calling scheduleWork will push in a new callback at the end of the queue.
          // When we get idle time, callbacks are removed from the front of the queue
          var pendingCallbacks = [];
          var _callbackIdCounter = 0;

          var getCallbackId = function getCallbackId() {
            _callbackIdCounter++;
            return _callbackIdCounter;
          }; // When a callback is scheduled, we register it by adding it's id to this
          // object.
          // If the user calls 'cancelScheduledWork' with the id of that callback, it will be
          // unregistered by removing the id from this object.
          // Then we skip calling any callback which is not registered.
          // This means cancelling is an O(1) time complexity instead of O(n).


          var registeredCallbackIds = {}; // We track what the next soonest timeoutTime is, to be able to quickly tell
          // if none of the scheduled callbacks have timed out.

          var nextSoonestTimeoutTime = -1;
          var isIdleScheduled = false;
          var isAnimationFrameScheduled = false;
          var frameDeadline = 0; // We start out assuming that we run at 30fps but then the heuristic tracking
          // will adjust this value to a faster fps if we get more frequent animation
          // frames.

          var previousFrameTime = 33;
          var activeFrameTime = 33;
          var frameDeadlineObject = {
            didTimeout: false,
            timeRemaining: function timeRemaining() {
              var remaining = frameDeadline - now$1();
              return remaining > 0 ? remaining : 0;
            }
          };

          var safelyCallScheduledCallback = function safelyCallScheduledCallback(callback, callbackId) {
            if (!registeredCallbackIds[callbackId]) {
              // ignore cancelled callbacks
              return;
            }

            try {
              callback(frameDeadlineObject); // Avoid using 'catch' to keep errors easy to debug
            } finally {
              // always clean up the callbackId, even if the callback throws
              delete registeredCallbackIds[callbackId];
            }
          };
          /**
           * Checks for timed out callbacks, runs them, and then checks again to see if
           * any more have timed out.
           * Keeps doing this until there are none which have currently timed out.
           */


          var callTimedOutCallbacks = function callTimedOutCallbacks() {
            if (pendingCallbacks.length === 0) {
              return;
            }

            var currentTime = now$1(); // TODO: this would be more efficient if deferred callbacks are stored in
            // min heap.
            // Or in a linked list with links for both timeoutTime order and insertion
            // order.
            // For now an easy compromise is the current approach:
            // Keep a pointer to the soonest timeoutTime, and check that first.
            // If it has not expired, we can skip traversing the whole list.
            // If it has expired, then we step through all the callbacks.

            if (nextSoonestTimeoutTime === -1 || nextSoonestTimeoutTime > currentTime) {
              // We know that none of them have timed out yet.
              return;
            }

            nextSoonestTimeoutTime = -1; // we will reset it below
            // keep checking until we don't find any more timed out callbacks

            frameDeadlineObject.didTimeout = true;

            for (var i = 0, len = pendingCallbacks.length; i < len; i++) {
              var currentCallbackConfig = pendingCallbacks[i];
              var _timeoutTime = currentCallbackConfig.timeoutTime;

              if (_timeoutTime !== -1 && _timeoutTime <= currentTime) {
                // it has timed out!
                // call it
                var _callback = currentCallbackConfig.scheduledCallback;
                safelyCallScheduledCallback(_callback, currentCallbackConfig.callbackId);
              } else {
                if (_timeoutTime !== -1 && (nextSoonestTimeoutTime === -1 || _timeoutTime < nextSoonestTimeoutTime)) {
                  nextSoonestTimeoutTime = _timeoutTime;
                }
              }
            }
          }; // We use the postMessage trick to defer idle work until after the repaint.


          var messageKey = '__reactIdleCallback$' + Math.random().toString(36).slice(2);

          var idleTick = function idleTick(event) {
            if (event.source !== window || event.data !== messageKey) {
              return;
            }

            isIdleScheduled = false;

            if (pendingCallbacks.length === 0) {
              return;
            } // First call anything which has timed out, until we have caught up.


            callTimedOutCallbacks();
            var currentTime = now$1(); // Next, as long as we have idle time, try calling more callbacks.

            while (frameDeadline - currentTime > 0 && pendingCallbacks.length > 0) {
              var latestCallbackConfig = pendingCallbacks.shift();
              frameDeadlineObject.didTimeout = false;
              var latestCallback = latestCallbackConfig.scheduledCallback;
              var newCallbackId = latestCallbackConfig.callbackId;
              safelyCallScheduledCallback(latestCallback, newCallbackId);
              currentTime = now$1();
            }

            if (pendingCallbacks.length > 0) {
              if (!isAnimationFrameScheduled) {
                // Schedule another animation callback so we retry later.
                isAnimationFrameScheduled = true;
                requestAnimationFrame(animationTick);
              }
            }
          }; // Assumes that we have addEventListener in this environment. Might need
          // something better for old IE.


          window.addEventListener('message', idleTick, false);

          var animationTick = function animationTick(rafTime) {
            isAnimationFrameScheduled = false;
            var nextFrameTime = rafTime - frameDeadline + activeFrameTime;

            if (nextFrameTime < activeFrameTime && previousFrameTime < activeFrameTime) {
              if (nextFrameTime < 8) {
                // Defensive coding. We don't support higher frame rates than 120hz.
                // If we get lower than that, it is probably a bug.
                nextFrameTime = 8;
              } // If one frame goes long, then the next one can be short to catch up.
              // If two frames are short in a row, then that's an indication that we
              // actually have a higher frame rate than what we're currently optimizing.
              // We adjust our heuristic dynamically accordingly. For example, if we're
              // running on 120hz display or 90hz VR display.
              // Take the max of the two in case one of them was an anomaly due to
              // missed frame deadlines.


              activeFrameTime = nextFrameTime < previousFrameTime ? previousFrameTime : nextFrameTime;
            } else {
              previousFrameTime = nextFrameTime;
            }

            frameDeadline = rafTime + activeFrameTime;

            if (!isIdleScheduled) {
              isIdleScheduled = true;
              window.postMessage(messageKey, '*');
            }
          };

          scheduleWork = function scheduleWork(callback, options) {
            var timeoutTime = -1;

            if (options != null && typeof options.timeout === 'number') {
              timeoutTime = now$1() + options.timeout;
            }

            if (nextSoonestTimeoutTime === -1 || timeoutTime !== -1 && timeoutTime < nextSoonestTimeoutTime) {
              nextSoonestTimeoutTime = timeoutTime;
            }

            var newCallbackId = getCallbackId();
            var scheduledCallbackConfig = {
              scheduledCallback: callback,
              callbackId: newCallbackId,
              timeoutTime: timeoutTime
            };
            pendingCallbacks.push(scheduledCallbackConfig);
            registeredCallbackIds[newCallbackId] = true;

            if (!isAnimationFrameScheduled) {
              // If rAF didn't already schedule one, we need to schedule a frame.
              // TODO: If this rAF doesn't materialize because the browser throttles, we
              // might want to still have setTimeout trigger scheduleWork as a backup to ensure
              // that we keep performing work.
              isAnimationFrameScheduled = true;
              requestAnimationFrame(animationTick);
            }

            return newCallbackId;
          };

          cancelScheduledWork = function cancelScheduledWork(callbackId) {
            delete registeredCallbackIds[callbackId];
          };
        }

        var didWarnSelectedSetOnOption = false;

        function flattenChildren(children) {
          var content = ''; // Flatten children and warn if they aren't strings or numbers;
          // invalid types are ignored.
          // We can silently skip them because invalid DOM nesting warning
          // catches these cases in Fiber.

          React.Children.forEach(children, function (child) {
            if (child == null) {
              return;
            }

            if (typeof child === 'string' || typeof child === 'number') {
              content += child;
            }
          });
          return content;
        }
        /**
         * Implements an <option> host component that warns when `selected` is set.
         */


        function validateProps(element, props) {
          // TODO (yungsters): Remove support for `selected` in <option>.
          {
            if (props.selected != null && !didWarnSelectedSetOnOption) {
              warning(false, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
              didWarnSelectedSetOnOption = true;
            }
          }
        }

        function postMountWrapper$1(element, props) {
          // value="" should make a value attribute (#6219)
          if (props.value != null) {
            element.setAttribute('value', props.value);
          }
        }

        function getHostProps$1(element, props) {
          var hostProps = _assign({
            children: undefined
          }, props);

          var content = flattenChildren(props.children);

          if (content) {
            hostProps.children = content;
          }

          return hostProps;
        } // TODO: direct imports like some-package/src/* are bad. Fix me.


        var getCurrentFiberOwnerName$3 = ReactDebugCurrentFiber.getCurrentFiberOwnerName;
        var getCurrentFiberStackAddendum$3 = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var didWarnValueDefaultValue$1 = void 0;
        {
          didWarnValueDefaultValue$1 = false;
        }

        function getDeclarationErrorAddendum() {
          var ownerName = getCurrentFiberOwnerName$3();

          if (ownerName) {
            return '\n\nCheck the render method of `' + ownerName + '`.';
          }

          return '';
        }

        var valuePropNames = ['value', 'defaultValue'];
        /**
         * Validation function for `value` and `defaultValue`.
         */

        function checkSelectPropTypes(props) {
          ReactControlledValuePropTypes.checkPropTypes('select', props, getCurrentFiberStackAddendum$3);

          for (var i = 0; i < valuePropNames.length; i++) {
            var propName = valuePropNames[i];

            if (props[propName] == null) {
              continue;
            }

            var isArray = Array.isArray(props[propName]);

            if (props.multiple && !isArray) {
              warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
            } else if (!props.multiple && isArray) {
              warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
            }
          }
        }

        function updateOptions(node, multiple, propValue, setDefaultSelected) {
          var options = node.options;

          if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};

            for (var i = 0; i < selectedValues.length; i++) {
              // Prefix to avoid chaos with special keys.
              selectedValue['$' + selectedValues[i]] = true;
            }

            for (var _i = 0; _i < options.length; _i++) {
              var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

              if (options[_i].selected !== selected) {
                options[_i].selected = selected;
              }

              if (selected && setDefaultSelected) {
                options[_i].defaultSelected = true;
              }
            }
          } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = '' + propValue;

            var defaultSelected = null;

            for (var _i2 = 0; _i2 < options.length; _i2++) {
              if (options[_i2].value === _selectedValue) {
                options[_i2].selected = true;

                if (setDefaultSelected) {
                  options[_i2].defaultSelected = true;
                }

                return;
              }

              if (defaultSelected === null && !options[_i2].disabled) {
                defaultSelected = options[_i2];
              }
            }

            if (defaultSelected !== null) {
              defaultSelected.selected = true;
            }
          }
        }
        /**
         * Implements a <select> host component that allows optionally setting the
         * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
         * stringable. If `multiple` is true, the prop must be an array of stringables.
         *
         * If `value` is not supplied (or null/undefined), user actions that change the
         * selected option will trigger updates to the rendered options.
         *
         * If it is supplied (and not null/undefined), the rendered options will not
         * update in response to user actions. Instead, the `value` prop must change in
         * order for the rendered options to update.
         *
         * If `defaultValue` is provided, any options with the supplied values will be
         * selected.
         */


        function getHostProps$2(element, props) {
          return _assign({}, props, {
            value: undefined
          });
        }

        function initWrapperState$1(element, props) {
          var node = element;
          {
            checkSelectPropTypes(props);
          }
          var value = props.value;
          node._wrapperState = {
            initialValue: value != null ? value : props.defaultValue,
            wasMultiple: !!props.multiple
          };
          {
            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
              warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
              didWarnValueDefaultValue$1 = true;
            }
          }
        }

        function postMountWrapper$2(element, props) {
          var node = element;
          node.multiple = !!props.multiple;
          var value = props.value;

          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          } else if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          }
        }

        function postUpdateWrapper(element, props) {
          var node = element; // After the initial mount, we control selected-ness manually so don't pass
          // this value down

          node._wrapperState.initialValue = undefined;
          var wasMultiple = node._wrapperState.wasMultiple;
          node._wrapperState.wasMultiple = !!props.multiple;
          var value = props.value;

          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          } else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) {
              updateOptions(node, !!props.multiple, props.defaultValue, true);
            } else {
              // Revert the select back to its default unselected state.
              updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
            }
          }
        }

        function restoreControlledState$2(element, props) {
          var node = element;
          var value = props.value;

          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          }
        } // TODO: direct imports like some-package/src/* are bad. Fix me.


        var getCurrentFiberStackAddendum$4 = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var didWarnValDefaultVal = false;
        /**
         * Implements a <textarea> host component that allows setting `value`, and
         * `defaultValue`. This differs from the traditional DOM API because value is
         * usually set as PCDATA children.
         *
         * If `value` is not supplied (or null/undefined), user actions that affect the
         * value will trigger updates to the element.
         *
         * If `value` is supplied (and not null/undefined), the rendered element will
         * not trigger updates to the element. Instead, the `value` prop must change in
         * order for the rendered element to be updated.
         *
         * The rendered element will be initialized with an empty value, the prop
         * `defaultValue` if specified, or the children content (deprecated).
         */

        function getHostProps$3(element, props) {
          var node = element;
          !(props.dangerouslySetInnerHTML == null) ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : void 0; // Always set children to the same thing. In IE9, the selection range will
          // get reset if `textContent` is mutated.  We could add a check in setTextContent
          // to only set the value if/when the value differs from the node value (which would
          // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
          // solution. The value can be a boolean or object so that's why it's forced
          // to be a string.

          var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: '' + node._wrapperState.initialValue
          });

          return hostProps;
        }

        function initWrapperState$2(element, props) {
          var node = element;
          {
            ReactControlledValuePropTypes.checkPropTypes('textarea', props, getCurrentFiberStackAddendum$4);

            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
              warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
              didWarnValDefaultVal = true;
            }
          }
          var initialValue = props.value; // Only bother fetching default value if we're going to use it

          if (initialValue == null) {
            var defaultValue = props.defaultValue; // TODO (yungsters): Remove support for children content in <textarea>.

            var children = props.children;

            if (children != null) {
              {
                warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
              }
              !(defaultValue == null) ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : void 0;

              if (Array.isArray(children)) {
                !(children.length <= 1) ? invariant(false, '<textarea> can only have at most one child.') : void 0;
                children = children[0];
              }

              defaultValue = '' + children;
            }

            if (defaultValue == null) {
              defaultValue = '';
            }

            initialValue = defaultValue;
          }

          node._wrapperState = {
            initialValue: '' + initialValue
          };
        }

        function updateWrapper$1(element, props) {
          var node = element;
          var value = props.value;

          if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = '' + value; // To avoid side effects (such as losing text selection), only set value if changed

            if (newValue !== node.value) {
              node.value = newValue;
            }

            if (props.defaultValue == null) {
              node.defaultValue = newValue;
            }
          }

          if (props.defaultValue != null) {
            node.defaultValue = props.defaultValue;
          }
        }

        function postMountWrapper$3(element, props) {
          var node = element; // This is in postMount because we need access to the DOM node, which is not
          // available until after the component has mounted.

          var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
          // initial value. In IE10/IE11 there is a bug where the placeholder attribute
          // will populate textContent as well.
          // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

          if (textContent === node._wrapperState.initialValue) {
            node.value = textContent;
          }
        }

        function restoreControlledState$3(element, props) {
          // DOM component is still mounted; update
          updateWrapper$1(element, props);
        }

        var HTML_NAMESPACE$1 = 'http://www.w3.org/1999/xhtml';
        var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var Namespaces = {
          html: HTML_NAMESPACE$1,
          mathml: MATH_NAMESPACE,
          svg: SVG_NAMESPACE
        }; // Assumes there is no parent namespace.

        function getIntrinsicNamespace(type) {
          switch (type) {
            case 'svg':
              return SVG_NAMESPACE;

            case 'math':
              return MATH_NAMESPACE;

            default:
              return HTML_NAMESPACE$1;
          }
        }

        function getChildNamespace(parentNamespace, type) {
          if (parentNamespace == null || parentNamespace === HTML_NAMESPACE$1) {
            // No (or default) parent namespace: potential entry point.
            return getIntrinsicNamespace(type);
          }

          if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
            // We're leaving SVG.
            return HTML_NAMESPACE$1;
          } // By default, pass namespace below.


          return parentNamespace;
        }
        /* globals MSApp */

        /**
         * Create a function which has 'unsafe' privileges (required by windows8 apps)
         */


        var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
          if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
            return function (arg0, arg1, arg2, arg3) {
              MSApp.execUnsafeLocalFunction(function () {
                return func(arg0, arg1, arg2, arg3);
              });
            };
          } else {
            return func;
          }
        }; // SVG temp container for IE lacking innerHTML


        var reusableSVGContainer = void 0;
        /**
         * Set the innerHTML property of a node
         *
         * @param {DOMElement} node
         * @param {string} html
         * @internal
         */

        var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
          // IE does not have innerHTML for SVG nodes, so instead we inject the
          // new markup in a temp node and then move the child nodes across into
          // the target node
          if (node.namespaceURI === Namespaces.svg && !('innerHTML' in node)) {
            reusableSVGContainer = reusableSVGContainer || document.createElement('div');
            reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
            var svgNode = reusableSVGContainer.firstChild;

            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }

            while (svgNode.firstChild) {
              node.appendChild(svgNode.firstChild);
            }
          } else {
            node.innerHTML = html;
          }
        });
        /**
         * Set the textContent property of a node. For text updates, it's faster
         * to set the `nodeValue` of the Text node directly instead of using
         * `.textContent` which will remove the existing node and create a new one.
         *
         * @param {DOMElement} node
         * @param {string} text
         * @internal
         */

        var setTextContent = function setTextContent(node, text) {
          if (text) {
            var firstChild = node.firstChild;

            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
              firstChild.nodeValue = text;
              return;
            }
          }

          node.textContent = text;
        };
        /**
         * CSS properties which accept numbers but are not in units of "px".
         */


        var isUnitlessNumber = {
          animationIterationCount: true,
          borderImageOutset: true,
          borderImageSlice: true,
          borderImageWidth: true,
          boxFlex: true,
          boxFlexGroup: true,
          boxOrdinalGroup: true,
          columnCount: true,
          columns: true,
          flex: true,
          flexGrow: true,
          flexPositive: true,
          flexShrink: true,
          flexNegative: true,
          flexOrder: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowSpan: true,
          gridRowStart: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnSpan: true,
          gridColumnStart: true,
          fontWeight: true,
          lineClamp: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          tabSize: true,
          widows: true,
          zIndex: true,
          zoom: true,
          // SVG-related properties
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeDasharray: true,
          strokeDashoffset: true,
          strokeMiterlimit: true,
          strokeOpacity: true,
          strokeWidth: true
        };
        /**
         * @param {string} prefix vendor-specific prefix, eg: Webkit
         * @param {string} key style name, eg: transitionDuration
         * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
         * WebkitTransitionDuration
         */

        function prefixKey(prefix, key) {
          return prefix + key.charAt(0).toUpperCase() + key.substring(1);
        }
        /**
         * Support style names that may come passed in prefixed by adding permutations
         * of vendor prefixes.
         */


        var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
        // infinite loop, because it iterates over the newly added props too.

        Object.keys(isUnitlessNumber).forEach(function (prop) {
          prefixes.forEach(function (prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
          });
        });
        /**
         * Convert a value into the proper css writable value. The style name `name`
         * should be logical (no hyphens), as specified
         * in `CSSProperty.isUnitlessNumber`.
         *
         * @param {string} name CSS property name such as `topMargin`.
         * @param {*} value CSS property value such as `10px`.
         * @return {string} Normalized style value with dimensions applied.
         */

        function dangerousStyleValue(name, value, isCustomProperty) {
          // Note that we've removed escapeTextForBrowser() calls here since the
          // whole string will be escaped when the attribute is injected into
          // the markup. If you provide unsafe user data here they can inject
          // arbitrary CSS which may be problematic (I couldn't repro this):
          // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
          // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
          // This is not an XSS hole but instead a potential CSS injection issue
          // which has lead to a greater discussion about how we're going to
          // trust URLs moving forward. See #2115901
          var isEmpty = value == null || typeof value === 'boolean' || value === '';

          if (isEmpty) {
            return '';
          }

          if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
            return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
          }

          return ('' + value).trim();
        }

        var warnValidStyle = emptyFunction;
        {
          // 'msTransform' is correct, but the other prefixes should be capitalized
          var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/; // style values shouldn't contain a semicolon

          var badStyleValueWithSemicolonPattern = /;\s*$/;
          var warnedStyleNames = {};
          var warnedStyleValues = {};
          var warnedForNaNValue = false;
          var warnedForInfinityValue = false;

          var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, getStack) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }

            warnedStyleNames[name] = true;
            warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), getStack());
          };

          var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, getStack) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }

            warnedStyleNames[name] = true;
            warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), getStack());
          };

          var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, getStack) {
            if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
              return;
            }

            warnedStyleValues[value] = true;
            warning(false, "Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.%s', name, value.replace(badStyleValueWithSemicolonPattern, ''), getStack());
          };

          var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, getStack) {
            if (warnedForNaNValue) {
              return;
            }

            warnedForNaNValue = true;
            warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, getStack());
          };

          var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value, getStack) {
            if (warnedForInfinityValue) {
              return;
            }

            warnedForInfinityValue = true;
            warning(false, '`Infinity` is an invalid value for the `%s` css style property.%s', name, getStack());
          };

          warnValidStyle = function warnValidStyle(name, value, getStack) {
            if (name.indexOf('-') > -1) {
              warnHyphenatedStyleName(name, getStack);
            } else if (badVendoredStyleNamePattern.test(name)) {
              warnBadVendoredStyleName(name, getStack);
            } else if (badStyleValueWithSemicolonPattern.test(value)) {
              warnStyleValueWithSemicolon(name, value, getStack);
            }

            if (typeof value === 'number') {
              if (isNaN(value)) {
                warnStyleValueIsNaN(name, value, getStack);
              } else if (!isFinite(value)) {
                warnStyleValueIsInfinity(name, value, getStack);
              }
            }
          };
        }
        var warnValidStyle$1 = warnValidStyle;
        /**
         * Operations for dealing with CSS properties.
         */

        /**
         * This creates a string that is expected to be equivalent to the style
         * attribute generated by server-side rendering. It by-passes warnings and
         * security checks so it's not safe to use this value for anything other than
         * comparison. It is only used in DEV for SSR validation.
         */

        function createDangerousStringForStyles(styles) {
          {
            var serialized = '';
            var delimiter = '';

            for (var styleName in styles) {
              if (!styles.hasOwnProperty(styleName)) {
                continue;
              }

              var styleValue = styles[styleName];

              if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + hyphenateStyleName(styleName) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
              }
            }

            return serialized || null;
          }
        }
        /**
         * Sets the value for multiple styles on a node.  If a value is specified as
         * '' (empty string), the corresponding style property will be unset.
         *
         * @param {DOMElement} node
         * @param {object} styles
         */


        function setValueForStyles(node, styles, getStack) {
          var style = node.style;

          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }

            var isCustomProperty = styleName.indexOf('--') === 0;
            {
              if (!isCustomProperty) {
                warnValidStyle$1(styleName, styles[styleName], getStack);
              }
            }
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

            if (styleName === 'float') {
              styleName = 'cssFloat';
            }

            if (isCustomProperty) {
              style.setProperty(styleName, styleValue);
            } else {
              style[styleName] = styleValue;
            }
          }
        } // For HTML, certain tags should omit their close tag. We keep a whitelist for
        // those special-case tags.


        var omittedCloseTags = {
          area: true,
          base: true,
          br: true,
          col: true,
          embed: true,
          hr: true,
          img: true,
          input: true,
          keygen: true,
          link: true,
          meta: true,
          param: true,
          source: true,
          track: true,
          wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

        }; // For HTML, certain tags cannot have children. This has the same purpose as
        // `omittedCloseTags` except that `menuitem` should still have its closing tag.

        var voidElementTags = _assign({
          menuitem: true
        }, omittedCloseTags);

        var HTML$1 = '__html';

        function assertValidProps(tag, props, getStack) {
          if (!props) {
            return;
          } // Note the use of `==` which checks for null or undefined.


          if (voidElementTags[tag]) {
            !(props.children == null && props.dangerouslySetInnerHTML == null) ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', tag, getStack()) : void 0;
          }

          if (props.dangerouslySetInnerHTML != null) {
            !(props.children == null) ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : void 0;
            !(typeof props.dangerouslySetInnerHTML === 'object' && HTML$1 in props.dangerouslySetInnerHTML) ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : void 0;
          }

          {
            !(props.suppressContentEditableWarning || !props.contentEditable || props.children == null) ? warning(false, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.%s', getStack()) : void 0;
          }
          !(props.style == null || typeof props.style === 'object') ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getStack()) : void 0;
        }

        function isCustomComponent(tagName, props) {
          if (tagName.indexOf('-') === -1) {
            return typeof props.is === 'string';
          }

          switch (tagName) {
            // These are reserved SVG and MathML elements.
            // We don't mind this whitelist too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return false;

            default:
              return true;
          }
        } // When adding attributes to the HTML or SVG whitelist, be sure to
        // also add them to this module to ensure casing and incorrect name
        // warnings.


        var possibleStandardNames = {
          // HTML
          accept: 'accept',
          acceptcharset: 'acceptCharset',
          'accept-charset': 'acceptCharset',
          accesskey: 'accessKey',
          action: 'action',
          allowfullscreen: 'allowFullScreen',
          alt: 'alt',
          as: 'as',
          async: 'async',
          autocapitalize: 'autoCapitalize',
          autocomplete: 'autoComplete',
          autocorrect: 'autoCorrect',
          autofocus: 'autoFocus',
          autoplay: 'autoPlay',
          autosave: 'autoSave',
          capture: 'capture',
          cellpadding: 'cellPadding',
          cellspacing: 'cellSpacing',
          challenge: 'challenge',
          charset: 'charSet',
          checked: 'checked',
          children: 'children',
          cite: 'cite',
          class: 'className',
          classid: 'classID',
          classname: 'className',
          cols: 'cols',
          colspan: 'colSpan',
          content: 'content',
          contenteditable: 'contentEditable',
          contextmenu: 'contextMenu',
          controls: 'controls',
          controlslist: 'controlsList',
          coords: 'coords',
          crossorigin: 'crossOrigin',
          dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
          data: 'data',
          datetime: 'dateTime',
          default: 'default',
          defaultchecked: 'defaultChecked',
          defaultvalue: 'defaultValue',
          defer: 'defer',
          dir: 'dir',
          disabled: 'disabled',
          download: 'download',
          draggable: 'draggable',
          enctype: 'encType',
          for: 'htmlFor',
          form: 'form',
          formmethod: 'formMethod',
          formaction: 'formAction',
          formenctype: 'formEncType',
          formnovalidate: 'formNoValidate',
          formtarget: 'formTarget',
          frameborder: 'frameBorder',
          headers: 'headers',
          height: 'height',
          hidden: 'hidden',
          high: 'high',
          href: 'href',
          hreflang: 'hrefLang',
          htmlfor: 'htmlFor',
          httpequiv: 'httpEquiv',
          'http-equiv': 'httpEquiv',
          icon: 'icon',
          id: 'id',
          innerhtml: 'innerHTML',
          inputmode: 'inputMode',
          integrity: 'integrity',
          is: 'is',
          itemid: 'itemID',
          itemprop: 'itemProp',
          itemref: 'itemRef',
          itemscope: 'itemScope',
          itemtype: 'itemType',
          keyparams: 'keyParams',
          keytype: 'keyType',
          kind: 'kind',
          label: 'label',
          lang: 'lang',
          list: 'list',
          loop: 'loop',
          low: 'low',
          manifest: 'manifest',
          marginwidth: 'marginWidth',
          marginheight: 'marginHeight',
          max: 'max',
          maxlength: 'maxLength',
          media: 'media',
          mediagroup: 'mediaGroup',
          method: 'method',
          min: 'min',
          minlength: 'minLength',
          multiple: 'multiple',
          muted: 'muted',
          name: 'name',
          nomodule: 'noModule',
          nonce: 'nonce',
          novalidate: 'noValidate',
          open: 'open',
          optimum: 'optimum',
          pattern: 'pattern',
          placeholder: 'placeholder',
          playsinline: 'playsInline',
          poster: 'poster',
          preload: 'preload',
          profile: 'profile',
          radiogroup: 'radioGroup',
          readonly: 'readOnly',
          referrerpolicy: 'referrerPolicy',
          rel: 'rel',
          required: 'required',
          reversed: 'reversed',
          role: 'role',
          rows: 'rows',
          rowspan: 'rowSpan',
          sandbox: 'sandbox',
          scope: 'scope',
          scoped: 'scoped',
          scrolling: 'scrolling',
          seamless: 'seamless',
          selected: 'selected',
          shape: 'shape',
          size: 'size',
          sizes: 'sizes',
          span: 'span',
          spellcheck: 'spellCheck',
          src: 'src',
          srcdoc: 'srcDoc',
          srclang: 'srcLang',
          srcset: 'srcSet',
          start: 'start',
          step: 'step',
          style: 'style',
          summary: 'summary',
          tabindex: 'tabIndex',
          target: 'target',
          title: 'title',
          type: 'type',
          usemap: 'useMap',
          value: 'value',
          width: 'width',
          wmode: 'wmode',
          wrap: 'wrap',
          // SVG
          about: 'about',
          accentheight: 'accentHeight',
          'accent-height': 'accentHeight',
          accumulate: 'accumulate',
          additive: 'additive',
          alignmentbaseline: 'alignmentBaseline',
          'alignment-baseline': 'alignmentBaseline',
          allowreorder: 'allowReorder',
          alphabetic: 'alphabetic',
          amplitude: 'amplitude',
          arabicform: 'arabicForm',
          'arabic-form': 'arabicForm',
          ascent: 'ascent',
          attributename: 'attributeName',
          attributetype: 'attributeType',
          autoreverse: 'autoReverse',
          azimuth: 'azimuth',
          basefrequency: 'baseFrequency',
          baselineshift: 'baselineShift',
          'baseline-shift': 'baselineShift',
          baseprofile: 'baseProfile',
          bbox: 'bbox',
          begin: 'begin',
          bias: 'bias',
          by: 'by',
          calcmode: 'calcMode',
          capheight: 'capHeight',
          'cap-height': 'capHeight',
          clip: 'clip',
          clippath: 'clipPath',
          'clip-path': 'clipPath',
          clippathunits: 'clipPathUnits',
          cliprule: 'clipRule',
          'clip-rule': 'clipRule',
          color: 'color',
          colorinterpolation: 'colorInterpolation',
          'color-interpolation': 'colorInterpolation',
          colorinterpolationfilters: 'colorInterpolationFilters',
          'color-interpolation-filters': 'colorInterpolationFilters',
          colorprofile: 'colorProfile',
          'color-profile': 'colorProfile',
          colorrendering: 'colorRendering',
          'color-rendering': 'colorRendering',
          contentscripttype: 'contentScriptType',
          contentstyletype: 'contentStyleType',
          cursor: 'cursor',
          cx: 'cx',
          cy: 'cy',
          d: 'd',
          datatype: 'datatype',
          decelerate: 'decelerate',
          descent: 'descent',
          diffuseconstant: 'diffuseConstant',
          direction: 'direction',
          display: 'display',
          divisor: 'divisor',
          dominantbaseline: 'dominantBaseline',
          'dominant-baseline': 'dominantBaseline',
          dur: 'dur',
          dx: 'dx',
          dy: 'dy',
          edgemode: 'edgeMode',
          elevation: 'elevation',
          enablebackground: 'enableBackground',
          'enable-background': 'enableBackground',
          end: 'end',
          exponent: 'exponent',
          externalresourcesrequired: 'externalResourcesRequired',
          fill: 'fill',
          fillopacity: 'fillOpacity',
          'fill-opacity': 'fillOpacity',
          fillrule: 'fillRule',
          'fill-rule': 'fillRule',
          filter: 'filter',
          filterres: 'filterRes',
          filterunits: 'filterUnits',
          floodopacity: 'floodOpacity',
          'flood-opacity': 'floodOpacity',
          floodcolor: 'floodColor',
          'flood-color': 'floodColor',
          focusable: 'focusable',
          fontfamily: 'fontFamily',
          'font-family': 'fontFamily',
          fontsize: 'fontSize',
          'font-size': 'fontSize',
          fontsizeadjust: 'fontSizeAdjust',
          'font-size-adjust': 'fontSizeAdjust',
          fontstretch: 'fontStretch',
          'font-stretch': 'fontStretch',
          fontstyle: 'fontStyle',
          'font-style': 'fontStyle',
          fontvariant: 'fontVariant',
          'font-variant': 'fontVariant',
          fontweight: 'fontWeight',
          'font-weight': 'fontWeight',
          format: 'format',
          from: 'from',
          fx: 'fx',
          fy: 'fy',
          g1: 'g1',
          g2: 'g2',
          glyphname: 'glyphName',
          'glyph-name': 'glyphName',
          glyphorientationhorizontal: 'glyphOrientationHorizontal',
          'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
          glyphorientationvertical: 'glyphOrientationVertical',
          'glyph-orientation-vertical': 'glyphOrientationVertical',
          glyphref: 'glyphRef',
          gradienttransform: 'gradientTransform',
          gradientunits: 'gradientUnits',
          hanging: 'hanging',
          horizadvx: 'horizAdvX',
          'horiz-adv-x': 'horizAdvX',
          horizoriginx: 'horizOriginX',
          'horiz-origin-x': 'horizOriginX',
          ideographic: 'ideographic',
          imagerendering: 'imageRendering',
          'image-rendering': 'imageRendering',
          in2: 'in2',
          in: 'in',
          inlist: 'inlist',
          intercept: 'intercept',
          k1: 'k1',
          k2: 'k2',
          k3: 'k3',
          k4: 'k4',
          k: 'k',
          kernelmatrix: 'kernelMatrix',
          kernelunitlength: 'kernelUnitLength',
          kerning: 'kerning',
          keypoints: 'keyPoints',
          keysplines: 'keySplines',
          keytimes: 'keyTimes',
          lengthadjust: 'lengthAdjust',
          letterspacing: 'letterSpacing',
          'letter-spacing': 'letterSpacing',
          lightingcolor: 'lightingColor',
          'lighting-color': 'lightingColor',
          limitingconeangle: 'limitingConeAngle',
          local: 'local',
          markerend: 'markerEnd',
          'marker-end': 'markerEnd',
          markerheight: 'markerHeight',
          markermid: 'markerMid',
          'marker-mid': 'markerMid',
          markerstart: 'markerStart',
          'marker-start': 'markerStart',
          markerunits: 'markerUnits',
          markerwidth: 'markerWidth',
          mask: 'mask',
          maskcontentunits: 'maskContentUnits',
          maskunits: 'maskUnits',
          mathematical: 'mathematical',
          mode: 'mode',
          numoctaves: 'numOctaves',
          offset: 'offset',
          opacity: 'opacity',
          operator: 'operator',
          order: 'order',
          orient: 'orient',
          orientation: 'orientation',
          origin: 'origin',
          overflow: 'overflow',
          overlineposition: 'overlinePosition',
          'overline-position': 'overlinePosition',
          overlinethickness: 'overlineThickness',
          'overline-thickness': 'overlineThickness',
          paintorder: 'paintOrder',
          'paint-order': 'paintOrder',
          panose1: 'panose1',
          'panose-1': 'panose1',
          pathlength: 'pathLength',
          patterncontentunits: 'patternContentUnits',
          patterntransform: 'patternTransform',
          patternunits: 'patternUnits',
          pointerevents: 'pointerEvents',
          'pointer-events': 'pointerEvents',
          points: 'points',
          pointsatx: 'pointsAtX',
          pointsaty: 'pointsAtY',
          pointsatz: 'pointsAtZ',
          prefix: 'prefix',
          preservealpha: 'preserveAlpha',
          preserveaspectratio: 'preserveAspectRatio',
          primitiveunits: 'primitiveUnits',
          property: 'property',
          r: 'r',
          radius: 'radius',
          refx: 'refX',
          refy: 'refY',
          renderingintent: 'renderingIntent',
          'rendering-intent': 'renderingIntent',
          repeatcount: 'repeatCount',
          repeatdur: 'repeatDur',
          requiredextensions: 'requiredExtensions',
          requiredfeatures: 'requiredFeatures',
          resource: 'resource',
          restart: 'restart',
          result: 'result',
          results: 'results',
          rotate: 'rotate',
          rx: 'rx',
          ry: 'ry',
          scale: 'scale',
          security: 'security',
          seed: 'seed',
          shaperendering: 'shapeRendering',
          'shape-rendering': 'shapeRendering',
          slope: 'slope',
          spacing: 'spacing',
          specularconstant: 'specularConstant',
          specularexponent: 'specularExponent',
          speed: 'speed',
          spreadmethod: 'spreadMethod',
          startoffset: 'startOffset',
          stddeviation: 'stdDeviation',
          stemh: 'stemh',
          stemv: 'stemv',
          stitchtiles: 'stitchTiles',
          stopcolor: 'stopColor',
          'stop-color': 'stopColor',
          stopopacity: 'stopOpacity',
          'stop-opacity': 'stopOpacity',
          strikethroughposition: 'strikethroughPosition',
          'strikethrough-position': 'strikethroughPosition',
          strikethroughthickness: 'strikethroughThickness',
          'strikethrough-thickness': 'strikethroughThickness',
          string: 'string',
          stroke: 'stroke',
          strokedasharray: 'strokeDasharray',
          'stroke-dasharray': 'strokeDasharray',
          strokedashoffset: 'strokeDashoffset',
          'stroke-dashoffset': 'strokeDashoffset',
          strokelinecap: 'strokeLinecap',
          'stroke-linecap': 'strokeLinecap',
          strokelinejoin: 'strokeLinejoin',
          'stroke-linejoin': 'strokeLinejoin',
          strokemiterlimit: 'strokeMiterlimit',
          'stroke-miterlimit': 'strokeMiterlimit',
          strokewidth: 'strokeWidth',
          'stroke-width': 'strokeWidth',
          strokeopacity: 'strokeOpacity',
          'stroke-opacity': 'strokeOpacity',
          suppresscontenteditablewarning: 'suppressContentEditableWarning',
          suppresshydrationwarning: 'suppressHydrationWarning',
          surfacescale: 'surfaceScale',
          systemlanguage: 'systemLanguage',
          tablevalues: 'tableValues',
          targetx: 'targetX',
          targety: 'targetY',
          textanchor: 'textAnchor',
          'text-anchor': 'textAnchor',
          textdecoration: 'textDecoration',
          'text-decoration': 'textDecoration',
          textlength: 'textLength',
          textrendering: 'textRendering',
          'text-rendering': 'textRendering',
          to: 'to',
          transform: 'transform',
          typeof: 'typeof',
          u1: 'u1',
          u2: 'u2',
          underlineposition: 'underlinePosition',
          'underline-position': 'underlinePosition',
          underlinethickness: 'underlineThickness',
          'underline-thickness': 'underlineThickness',
          unicode: 'unicode',
          unicodebidi: 'unicodeBidi',
          'unicode-bidi': 'unicodeBidi',
          unicoderange: 'unicodeRange',
          'unicode-range': 'unicodeRange',
          unitsperem: 'unitsPerEm',
          'units-per-em': 'unitsPerEm',
          unselectable: 'unselectable',
          valphabetic: 'vAlphabetic',
          'v-alphabetic': 'vAlphabetic',
          values: 'values',
          vectoreffect: 'vectorEffect',
          'vector-effect': 'vectorEffect',
          version: 'version',
          vertadvy: 'vertAdvY',
          'vert-adv-y': 'vertAdvY',
          vertoriginx: 'vertOriginX',
          'vert-origin-x': 'vertOriginX',
          vertoriginy: 'vertOriginY',
          'vert-origin-y': 'vertOriginY',
          vhanging: 'vHanging',
          'v-hanging': 'vHanging',
          videographic: 'vIdeographic',
          'v-ideographic': 'vIdeographic',
          viewbox: 'viewBox',
          viewtarget: 'viewTarget',
          visibility: 'visibility',
          vmathematical: 'vMathematical',
          'v-mathematical': 'vMathematical',
          vocab: 'vocab',
          widths: 'widths',
          wordspacing: 'wordSpacing',
          'word-spacing': 'wordSpacing',
          writingmode: 'writingMode',
          'writing-mode': 'writingMode',
          x1: 'x1',
          x2: 'x2',
          x: 'x',
          xchannelselector: 'xChannelSelector',
          xheight: 'xHeight',
          'x-height': 'xHeight',
          xlinkactuate: 'xlinkActuate',
          'xlink:actuate': 'xlinkActuate',
          xlinkarcrole: 'xlinkArcrole',
          'xlink:arcrole': 'xlinkArcrole',
          xlinkhref: 'xlinkHref',
          'xlink:href': 'xlinkHref',
          xlinkrole: 'xlinkRole',
          'xlink:role': 'xlinkRole',
          xlinkshow: 'xlinkShow',
          'xlink:show': 'xlinkShow',
          xlinktitle: 'xlinkTitle',
          'xlink:title': 'xlinkTitle',
          xlinktype: 'xlinkType',
          'xlink:type': 'xlinkType',
          xmlbase: 'xmlBase',
          'xml:base': 'xmlBase',
          xmllang: 'xmlLang',
          'xml:lang': 'xmlLang',
          xmlns: 'xmlns',
          'xml:space': 'xmlSpace',
          xmlnsxlink: 'xmlnsXlink',
          'xmlns:xlink': 'xmlnsXlink',
          xmlspace: 'xmlSpace',
          y1: 'y1',
          y2: 'y2',
          y: 'y',
          ychannelselector: 'yChannelSelector',
          z: 'z',
          zoomandpan: 'zoomAndPan'
        };
        var ariaProperties = {
          'aria-current': 0,
          // state
          'aria-details': 0,
          'aria-disabled': 0,
          // state
          'aria-hidden': 0,
          // state
          'aria-invalid': 0,
          // state
          'aria-keyshortcuts': 0,
          'aria-label': 0,
          'aria-roledescription': 0,
          // Widget Attributes
          'aria-autocomplete': 0,
          'aria-checked': 0,
          'aria-expanded': 0,
          'aria-haspopup': 0,
          'aria-level': 0,
          'aria-modal': 0,
          'aria-multiline': 0,
          'aria-multiselectable': 0,
          'aria-orientation': 0,
          'aria-placeholder': 0,
          'aria-pressed': 0,
          'aria-readonly': 0,
          'aria-required': 0,
          'aria-selected': 0,
          'aria-sort': 0,
          'aria-valuemax': 0,
          'aria-valuemin': 0,
          'aria-valuenow': 0,
          'aria-valuetext': 0,
          // Live Region Attributes
          'aria-atomic': 0,
          'aria-busy': 0,
          'aria-live': 0,
          'aria-relevant': 0,
          // Drag-and-Drop Attributes
          'aria-dropeffect': 0,
          'aria-grabbed': 0,
          // Relationship Attributes
          'aria-activedescendant': 0,
          'aria-colcount': 0,
          'aria-colindex': 0,
          'aria-colspan': 0,
          'aria-controls': 0,
          'aria-describedby': 0,
          'aria-errormessage': 0,
          'aria-flowto': 0,
          'aria-labelledby': 0,
          'aria-owns': 0,
          'aria-posinset': 0,
          'aria-rowcount': 0,
          'aria-rowindex': 0,
          'aria-rowspan': 0,
          'aria-setsize': 0
        };
        var warnedProperties = {};
        var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        function getStackAddendum() {
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          return stack != null ? stack : '';
        }

        function validateProperty(tagName, name) {
          if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }

          if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (correctName == null) {
              warning(false, 'Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.%s', name, getStackAddendum());
              warnedProperties[name] = true;
              return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.


            if (name !== correctName) {
              warning(false, 'Invalid ARIA attribute `%s`. Did you mean `%s`?%s', name, correctName, getStackAddendum());
              warnedProperties[name] = true;
              return true;
            }
          }

          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.


            if (name !== standardName) {
              warning(false, 'Unknown ARIA attribute `%s`. Did you mean `%s`?%s', name, standardName, getStackAddendum());
              warnedProperties[name] = true;
              return true;
            }
          }

          return true;
        }

        function warnInvalidARIAProps(type, props) {
          var invalidProps = [];

          for (var key in props) {
            var isValid = validateProperty(type, key);

            if (!isValid) {
              invalidProps.push(key);
            }
          }

          var unknownPropString = invalidProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (invalidProps.length === 1) {
            warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, type, getStackAddendum());
          } else if (invalidProps.length > 1) {
            warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, type, getStackAddendum());
          }
        }

        function validateProperties(type, props) {
          if (isCustomComponent(type, props)) {
            return;
          }

          warnInvalidARIAProps(type, props);
        }

        var didWarnValueNull = false;

        function getStackAddendum$1() {
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          return stack != null ? stack : '';
        }

        function validateProperties$1(type, props) {
          if (type !== 'input' && type !== 'textarea' && type !== 'select') {
            return;
          }

          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;

            if (type === 'select' && props.multiple) {
              warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.%s', type, getStackAddendum$1());
            } else {
              warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', type, getStackAddendum$1());
            }
          }
        }

        function getStackAddendum$2() {
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          return stack != null ? stack : '';
        }

        var validateProperty$1 = function validateProperty$1() {};

        {
          var warnedProperties$1 = {};
          var _hasOwnProperty = Object.prototype.hasOwnProperty;
          var EVENT_NAME_REGEX = /^on./;
          var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
          var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
          var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

          validateProperty$1 = function validateProperty$1(tagName, name, value, canUseEventSystem) {
            if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
              return true;
            }

            var lowerCasedName = name.toLowerCase();

            if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
              warning(false, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
              warnedProperties$1[name] = true;
              return true;
            } // We can't rely on the event system being injected on the server.


            if (canUseEventSystem) {
              if (registrationNameModules.hasOwnProperty(name)) {
                return true;
              }

              var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

              if (registrationName != null) {
                warning(false, 'Invalid event handler property `%s`. Did you mean `%s`?%s', name, registrationName, getStackAddendum$2());
                warnedProperties$1[name] = true;
                return true;
              }

              if (EVENT_NAME_REGEX.test(name)) {
                warning(false, 'Unknown event handler property `%s`. It will be ignored.%s', name, getStackAddendum$2());
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (EVENT_NAME_REGEX.test(name)) {
              // If no event plugins have been injected, we are in a server environment.
              // So we can't tell if the event name is correct for sure, but we can filter
              // out known bad ones like `onclick`. We can't suggest a specific replacement though.
              if (INVALID_EVENT_NAME_REGEX.test(name)) {
                warning(false, 'Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.%s', name, getStackAddendum$2());
              }

              warnedProperties$1[name] = true;
              return true;
            } // Let the ARIA attribute hook validate ARIA attributes


            if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
              return true;
            }

            if (lowerCasedName === 'innerhtml') {
              warning(false, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
              warnedProperties$1[name] = true;
              return true;
            }

            if (lowerCasedName === 'aria') {
              warning(false, 'The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
              warnedProperties$1[name] = true;
              return true;
            }

            if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
              warning(false, 'Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.%s', typeof value, getStackAddendum$2());
              warnedProperties$1[name] = true;
              return true;
            }

            if (typeof value === 'number' && isNaN(value)) {
              warning(false, 'Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.%s', name, getStackAddendum$2());
              warnedProperties$1[name] = true;
              return true;
            }

            var propertyInfo = getPropertyInfo(name);
            var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

            if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              var standardName = possibleStandardNames[lowerCasedName];

              if (standardName !== name) {
                warning(false, 'Invalid DOM property `%s`. Did you mean `%s`?%s', name, standardName, getStackAddendum$2());
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (!isReserved && name !== lowerCasedName) {
              // Unknown attributes should have lowercase casing since that's how they
              // will be cased anyway with server rendering.
              warning(false, 'React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.%s', name, lowerCasedName, getStackAddendum$2());
              warnedProperties$1[name] = true;
              return true;
            }

            if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              if (value) {
                warning(false, 'Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.%s', value, name, name, value, name, getStackAddendum$2());
              } else {
                warning(false, 'Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.%s', value, name, name, value, name, name, name, getStackAddendum$2());
              }

              warnedProperties$1[name] = true;
              return true;
            } // Now that we've validated casing, do not validate
            // data types for reserved props


            if (isReserved) {
              return true;
            } // Warn when a known attribute is a bad type


            if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              warnedProperties$1[name] = true;
              return false;
            }

            return true;
          };
        }

        var warnUnknownProperties = function warnUnknownProperties(type, props, canUseEventSystem) {
          var unknownProps = [];

          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);

            if (!isValid) {
              unknownProps.push(key);
            }
          }

          var unknownPropString = unknownProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (unknownProps.length === 1) {
            warning(false, 'Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior%s', unknownPropString, type, getStackAddendum$2());
          } else if (unknownProps.length > 1) {
            warning(false, 'Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior%s', unknownPropString, type, getStackAddendum$2());
          }
        };

        function validateProperties$2(type, props, canUseEventSystem) {
          if (isCustomComponent(type, props)) {
            return;
          }

          warnUnknownProperties(type, props, canUseEventSystem);
        } // TODO: direct imports like some-package/src/* are bad. Fix me.


        var getCurrentFiberOwnerName$2 = ReactDebugCurrentFiber.getCurrentFiberOwnerName;
        var getCurrentFiberStackAddendum$2 = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var didWarnInvalidHydration = false;
        var didWarnShadyDOM = false;
        var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
        var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
        var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
        var AUTOFOCUS = 'autoFocus';
        var CHILDREN = 'children';
        var STYLE = 'style';
        var HTML = '__html';
        var HTML_NAMESPACE = Namespaces.html;
        var getStack = emptyFunction.thatReturns('');
        var warnedUnknownTags = void 0;
        var suppressHydrationWarning = void 0;
        var validatePropertiesInDevelopment = void 0;
        var warnForTextDifference = void 0;
        var warnForPropDifference = void 0;
        var warnForExtraAttributes = void 0;
        var warnForInvalidEventListener = void 0;
        var normalizeMarkupForTextOrAttribute = void 0;
        var normalizeHTML = void 0;
        {
          getStack = getCurrentFiberStackAddendum$2;
          warnedUnknownTags = {
            // Chrome is the only major browser not shipping <time>. But as of July
            // 2017 it intends to ship it due to widespread usage. We intentionally
            // *don't* warn for <time> even if it's unrecognized by Chrome because
            // it soon will be, and many apps have been using it anyway.
            time: true,
            // There are working polyfills for <dialog>. Let people use it.
            dialog: true
          };

          validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
            validateProperties(type, props);
            validateProperties$1(type, props);
            validateProperties$2(type, props,
            /* canUseEventSystem */
            true);
          }; // HTML parsing normalizes CR and CRLF to LF.
          // It also can turn \u0000 into \uFFFD inside attributes.
          // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
          // If we have a mismatch, it might be caused by that.
          // We will still patch up in this case but not fire the warning.


          var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
          var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

          normalizeMarkupForTextOrAttribute = function normalizeMarkupForTextOrAttribute(markup) {
            var markupString = typeof markup === 'string' ? markup : '' + markup;
            return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
          };

          warnForTextDifference = function warnForTextDifference(serverText, clientText) {
            if (didWarnInvalidHydration) {
              return;
            }

            var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
            var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

            if (normalizedServerText === normalizedClientText) {
              return;
            }

            didWarnInvalidHydration = true;
            warning(false, 'Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
          };

          warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
            if (didWarnInvalidHydration) {
              return;
            }

            var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
            var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

            if (normalizedServerValue === normalizedClientValue) {
              return;
            }

            didWarnInvalidHydration = true;
            warning(false, 'Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
          };

          warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            var names = [];
            attributeNames.forEach(function (name) {
              names.push(name);
            });
            warning(false, 'Extra attributes from the server: %s', names);
          };

          warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
            if (listener === false) {
              warning(false, 'Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.%s', registrationName, registrationName, registrationName, getCurrentFiberStackAddendum$2());
            } else {
              warning(false, 'Expected `%s` listener to be a function, instead got a value of `%s` type.%s', registrationName, typeof listener, getCurrentFiberStackAddendum$2());
            }
          }; // Parse the HTML and read it back to normalize the HTML string so that it
          // can be used for comparison.


          normalizeHTML = function normalizeHTML(parent, html) {
            // We could have created a separate document here to avoid
            // re-initializing custom elements if they exist. But this breaks
            // how <noscript> is being handled. So we use the same document.
            // See the discussion in https://github.com/facebook/react/pull/11157.
            var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
            testElement.innerHTML = html;
            return testElement.innerHTML;
          };
        }

        function ensureListeningTo(rootContainerElement, registrationName) {
          var isDocumentOrFragment = rootContainerElement.nodeType === DOCUMENT_NODE || rootContainerElement.nodeType === DOCUMENT_FRAGMENT_NODE;
          var doc = isDocumentOrFragment ? rootContainerElement : rootContainerElement.ownerDocument;
          listenTo(registrationName, doc);
        }

        function getOwnerDocumentFromRootContainer(rootContainerElement) {
          return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
        }

        function trapClickOnNonInteractiveElement(node) {
          // Mobile Safari does not fire properly bubble click events on
          // non-interactive elements, which means delegated click listeners do not
          // fire. The workaround for this bug involves attaching an empty click
          // listener on the target node.
          // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
          // Just set it using the onclick property so that we don't have to manage any
          // bookkeeping for it. Not sure if we need to clear it when the listener is
          // removed.
          // TODO: Only do this for the relevant Safaris maybe?
          node.onclick = emptyFunction;
        }

        function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
          for (var propKey in nextProps) {
            if (!nextProps.hasOwnProperty(propKey)) {
              continue;
            }

            var nextProp = nextProps[propKey];

            if (propKey === STYLE) {
              {
                if (nextProp) {
                  // Freeze the next style object so that we can assume it won't be
                  // mutated. We have already warned for this in the past.
                  Object.freeze(nextProp);
                }
              } // Relies on `updateStylesByID` not mutating `styleUpdates`.

              setValueForStyles(domElement, nextProp, getStack);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML] : undefined;

              if (nextHtml != null) {
                setInnerHTML(domElement, nextHtml);
              }
            } else if (propKey === CHILDREN) {
              if (typeof nextProp === 'string') {
                // Avoid setting initial textContent when the text is empty. In IE11 setting
                // textContent on a <textarea> will cause the placeholder to not
                // show within the <textarea> until it has been focused and blurred again.
                // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                var canSetTextContent = tag !== 'textarea' || nextProp !== '';

                if (canSetTextContent) {
                  setTextContent(domElement, nextProp);
                }
              } else if (typeof nextProp === 'number') {
                setTextContent(domElement, '' + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING$1) {// Noop
            } else if (propKey === AUTOFOCUS) {// We polyfill it separately on the client during commit.
              // We blacklist it here rather than in the property list because we emit it in SSR.
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (true && typeof nextProp !== 'function') {
                  warnForInvalidEventListener(propKey, nextProp);
                }

                ensureListeningTo(rootContainerElement, propKey);
              }
            } else if (nextProp != null) {
              setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
            }
          }
        }

        function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
          // TODO: Handle wasCustomComponentTag
          for (var i = 0; i < updatePayload.length; i += 2) {
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];

            if (propKey === STYLE) {
              setValueForStyles(domElement, propValue, getStack);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              setInnerHTML(domElement, propValue);
            } else if (propKey === CHILDREN) {
              setTextContent(domElement, propValue);
            } else {
              setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
            }
          }
        }

        function createElement$1(type, props, rootContainerElement, parentNamespace) {
          var isCustomComponentTag = void 0; // We create tags in the namespace of their parent container, except HTML
          // tags get no namespace.

          var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
          var domElement = void 0;
          var namespaceURI = parentNamespace;

          if (namespaceURI === HTML_NAMESPACE) {
            namespaceURI = getIntrinsicNamespace(type);
          }

          if (namespaceURI === HTML_NAMESPACE) {
            {
              isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
              // allow <SVG> or <mATH>.

              !(isCustomComponentTag || type === type.toLowerCase()) ? warning(false, '<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type) : void 0;
            }

            if (type === 'script') {
              // Create the script via .innerHTML so its "parser-inserted" flag is
              // set to true and it does not execute
              var div = ownerDocument.createElement('div');
              div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
              // This is guaranteed to yield a script element.

              var firstChild = div.firstChild;
              domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') {
              // $FlowIssue `createElement` should be updated for Web Components
              domElement = ownerDocument.createElement(type, {
                is: props.is
              });
            } else {
              // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
              // See discussion in https://github.com/facebook/react/pull/6896
              // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
              domElement = ownerDocument.createElement(type);
            }
          } else {
            domElement = ownerDocument.createElementNS(namespaceURI, type);
          }

          {
            if (namespaceURI === HTML_NAMESPACE) {
              if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                warning(false, 'The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
              }
            }
          }
          return domElement;
        }

        function createTextNode$1(text, rootContainerElement) {
          return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
        }

        function setInitialProperties$1(domElement, tag, rawProps, rootContainerElement) {
          var isCustomComponentTag = isCustomComponent(tag, rawProps);
          {
            validatePropertiesInDevelopment(tag, rawProps);

            if (isCustomComponentTag && !didWarnShadyDOM && domElement.shadyRoot) {
              warning(false, '%s is using shady DOM. Using shady DOM with React can ' + 'cause things to break subtly.', getCurrentFiberOwnerName$2() || 'A component');
              didWarnShadyDOM = true;
            }
          } // TODO: Make sure that we check isMounted before firing any of these events.

          var props = void 0;

          switch (tag) {
            case 'iframe':
            case 'object':
              trapBubbledEvent(TOP_LOAD, domElement);
              props = rawProps;
              break;

            case 'video':
            case 'audio':
              // Create listener for each media event
              for (var i = 0; i < mediaEventTypes.length; i++) {
                trapBubbledEvent(mediaEventTypes[i], domElement);
              }

              props = rawProps;
              break;

            case 'source':
              trapBubbledEvent(TOP_ERROR, domElement);
              props = rawProps;
              break;

            case 'img':
            case 'image':
            case 'link':
              trapBubbledEvent(TOP_ERROR, domElement);
              trapBubbledEvent(TOP_LOAD, domElement);
              props = rawProps;
              break;

            case 'form':
              trapBubbledEvent(TOP_RESET, domElement);
              trapBubbledEvent(TOP_SUBMIT, domElement);
              props = rawProps;
              break;

            case 'details':
              trapBubbledEvent(TOP_TOGGLE, domElement);
              props = rawProps;
              break;

            case 'input':
              initWrapperState(domElement, rawProps);
              props = getHostProps(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
              // to onChange. Even if there is no listener.

              ensureListeningTo(rootContainerElement, 'onChange');
              break;

            case 'option':
              validateProps(domElement, rawProps);
              props = getHostProps$1(domElement, rawProps);
              break;

            case 'select':
              initWrapperState$1(domElement, rawProps);
              props = getHostProps$2(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
              // to onChange. Even if there is no listener.

              ensureListeningTo(rootContainerElement, 'onChange');
              break;

            case 'textarea':
              initWrapperState$2(domElement, rawProps);
              props = getHostProps$3(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
              // to onChange. Even if there is no listener.

              ensureListeningTo(rootContainerElement, 'onChange');
              break;

            default:
              props = rawProps;
          }

          assertValidProps(tag, props, getStack);
          setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

          switch (tag) {
            case 'input':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper(domElement, rawProps);
              break;

            case 'textarea':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper$3(domElement, rawProps);
              break;

            case 'option':
              postMountWrapper$1(domElement, rawProps);
              break;

            case 'select':
              postMountWrapper$2(domElement, rawProps);
              break;

            default:
              if (typeof props.onClick === 'function') {
                // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
              }

              break;
          }
        } // Calculate the diff between the two objects.


        function diffProperties$1(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
          {
            validatePropertiesInDevelopment(tag, nextRawProps);
          }
          var updatePayload = null;
          var lastProps = void 0;
          var nextProps = void 0;

          switch (tag) {
            case 'input':
              lastProps = getHostProps(domElement, lastRawProps);
              nextProps = getHostProps(domElement, nextRawProps);
              updatePayload = [];
              break;

            case 'option':
              lastProps = getHostProps$1(domElement, lastRawProps);
              nextProps = getHostProps$1(domElement, nextRawProps);
              updatePayload = [];
              break;

            case 'select':
              lastProps = getHostProps$2(domElement, lastRawProps);
              nextProps = getHostProps$2(domElement, nextRawProps);
              updatePayload = [];
              break;

            case 'textarea':
              lastProps = getHostProps$3(domElement, lastRawProps);
              nextProps = getHostProps$3(domElement, nextRawProps);
              updatePayload = [];
              break;

            default:
              lastProps = lastRawProps;
              nextProps = nextRawProps;

              if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
                // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
              }

              break;
          }

          assertValidProps(tag, nextProps, getStack);
          var propKey = void 0;
          var styleName = void 0;
          var styleUpdates = null;

          for (propKey in lastProps) {
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
              continue;
            }

            if (propKey === STYLE) {
              var lastStyle = lastProps[propKey];

              for (styleName in lastStyle) {
                if (lastStyle.hasOwnProperty(styleName)) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }

                  styleUpdates[styleName] = '';
                }
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) {// Noop. This is handled by the clear text mechanism.
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING$1) {// Noop
            } else if (propKey === AUTOFOCUS) {// Noop. It doesn't work on updates anyway.
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
              // This is a special case. If any listener updates we need to ensure
              // that the "current" fiber pointer gets updated so we need a commit
              // to update this element.
              if (!updatePayload) {
                updatePayload = [];
              }
            } else {
              // For all other deleted properties we add it to the queue. We use
              // the whitelist in the commit phase instead.
              (updatePayload = updatePayload || []).push(propKey, null);
            }
          }

          for (propKey in nextProps) {
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;

            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
              continue;
            }

            if (propKey === STYLE) {
              {
                if (nextProp) {
                  // Freeze the next style object so that we can assume it won't be
                  // mutated. We have already warned for this in the past.
                  Object.freeze(nextProp);
                }
              }

              if (lastProp) {
                // Unset styles on `lastProp` but not on `nextProp`.
                for (styleName in lastProp) {
                  if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }

                    styleUpdates[styleName] = '';
                  }
                } // Update styles that changed since `lastProp`.


                for (styleName in nextProp) {
                  if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }

                    styleUpdates[styleName] = nextProp[styleName];
                  }
                }
              } else {
                // Relies on `updateStylesByID` not mutating `styleUpdates`.
                if (!styleUpdates) {
                  if (!updatePayload) {
                    updatePayload = [];
                  }

                  updatePayload.push(propKey, styleUpdates);
                }

                styleUpdates = nextProp;
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML] : undefined;
              var lastHtml = lastProp ? lastProp[HTML] : undefined;

              if (nextHtml != null) {
                if (lastHtml !== nextHtml) {
                  (updatePayload = updatePayload || []).push(propKey, '' + nextHtml);
                }
              } else {// TODO: It might be too late to clear this if we have children
                // inserted already.
              }
            } else if (propKey === CHILDREN) {
              if (lastProp !== nextProp && (typeof nextProp === 'string' || typeof nextProp === 'number')) {
                (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING$1) {// Noop
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                // We eagerly listen to this even though we haven't committed yet.
                if (true && typeof nextProp !== 'function') {
                  warnForInvalidEventListener(propKey, nextProp);
                }

                ensureListeningTo(rootContainerElement, propKey);
              }

              if (!updatePayload && lastProp !== nextProp) {
                // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
              }
            } else {
              // For any other property we always add it to the queue and then we
              // filter it out using the whitelist during the commit.
              (updatePayload = updatePayload || []).push(propKey, nextProp);
            }
          }

          if (styleUpdates) {
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
          }

          return updatePayload;
        } // Apply the diff.


        function updateProperties$1(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
          // Update checked *before* name.
          // In the middle of an update, it is possible to have multiple checked.
          // When a checked radio tries to change name, browser makes another radio's checked false.
          if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
            updateChecked(domElement, nextRawProps);
          }

          var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
          var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

          updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
          // changed.

          switch (tag) {
            case 'input':
              // Update the wrapper around inputs *after* updating props. This has to
              // happen after `updateDOMProperties`. Otherwise HTML5 input validations
              // raise warnings and prevent the new value from being assigned.
              updateWrapper(domElement, nextRawProps);
              break;

            case 'textarea':
              updateWrapper$1(domElement, nextRawProps);
              break;

            case 'select':
              // <select> value update needs to occur after <option> children
              // reconciliation
              postUpdateWrapper(domElement, nextRawProps);
              break;
          }
        }

        function getPossibleStandardName(propName) {
          {
            var lowerCasedName = propName.toLowerCase();

            if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              return null;
            }

            return possibleStandardNames[lowerCasedName] || null;
          }
          return null;
        }

        function diffHydratedProperties$1(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
          var isCustomComponentTag = void 0;
          var extraAttributeNames = void 0;
          {
            suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING$1] === true;
            isCustomComponentTag = isCustomComponent(tag, rawProps);
            validatePropertiesInDevelopment(tag, rawProps);

            if (isCustomComponentTag && !didWarnShadyDOM && domElement.shadyRoot) {
              warning(false, '%s is using shady DOM. Using shady DOM with React can ' + 'cause things to break subtly.', getCurrentFiberOwnerName$2() || 'A component');
              didWarnShadyDOM = true;
            }
          } // TODO: Make sure that we check isMounted before firing any of these events.

          switch (tag) {
            case 'iframe':
            case 'object':
              trapBubbledEvent(TOP_LOAD, domElement);
              break;

            case 'video':
            case 'audio':
              // Create listener for each media event
              for (var i = 0; i < mediaEventTypes.length; i++) {
                trapBubbledEvent(mediaEventTypes[i], domElement);
              }

              break;

            case 'source':
              trapBubbledEvent(TOP_ERROR, domElement);
              break;

            case 'img':
            case 'image':
            case 'link':
              trapBubbledEvent(TOP_ERROR, domElement);
              trapBubbledEvent(TOP_LOAD, domElement);
              break;

            case 'form':
              trapBubbledEvent(TOP_RESET, domElement);
              trapBubbledEvent(TOP_SUBMIT, domElement);
              break;

            case 'details':
              trapBubbledEvent(TOP_TOGGLE, domElement);
              break;

            case 'input':
              initWrapperState(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
              // to onChange. Even if there is no listener.

              ensureListeningTo(rootContainerElement, 'onChange');
              break;

            case 'option':
              validateProps(domElement, rawProps);
              break;

            case 'select':
              initWrapperState$1(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
              // to onChange. Even if there is no listener.

              ensureListeningTo(rootContainerElement, 'onChange');
              break;

            case 'textarea':
              initWrapperState$2(domElement, rawProps);
              trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
              // to onChange. Even if there is no listener.

              ensureListeningTo(rootContainerElement, 'onChange');
              break;
          }

          assertValidProps(tag, rawProps, getStack);
          {
            extraAttributeNames = new Set();
            var attributes = domElement.attributes;

            for (var _i = 0; _i < attributes.length; _i++) {
              var name = attributes[_i].name.toLowerCase();

              switch (name) {
                // Built-in SSR attribute is whitelisted
                case 'data-reactroot':
                  break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.

                case 'value':
                  break;

                case 'checked':
                  break;

                case 'selected':
                  break;

                default:
                  // Intentionally use the original name.
                  // See discussion in https://github.com/facebook/react/pull/10676.
                  extraAttributeNames.add(attributes[_i].name);
              }
            }
          }
          var updatePayload = null;

          for (var propKey in rawProps) {
            if (!rawProps.hasOwnProperty(propKey)) {
              continue;
            }

            var nextProp = rawProps[propKey];

            if (propKey === CHILDREN) {
              // For text content children we compare against textContent. This
              // might match additional HTML that is hidden when we read it using
              // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
              // satisfies our requirement. Our requirement is not to produce perfect
              // HTML and attributes. Ideally we should preserve structure but it's
              // ok not to if the visible content is still enough to indicate what
              // even listeners these nodes might be wired up to.
              // TODO: Warn if there is more than a single textNode as a child.
              // TODO: Should we use domElement.firstChild.nodeValue to compare?
              if (typeof nextProp === 'string') {
                if (domElement.textContent !== nextProp) {
                  if (true && !suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }

                  updatePayload = [CHILDREN, nextProp];
                }
              } else if (typeof nextProp === 'number') {
                if (domElement.textContent !== '' + nextProp) {
                  if (true && !suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }

                  updatePayload = [CHILDREN, '' + nextProp];
                }
              }
            } else if (registrationNameModules.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (true && typeof nextProp !== 'function') {
                  warnForInvalidEventListener(propKey, nextProp);
                }

                ensureListeningTo(rootContainerElement, propKey);
              }
            } else if (true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === 'boolean') {
              // Validate that the properties correspond to their expected values.
              var serverValue = void 0;
              var propertyInfo = getPropertyInfo(propKey);

              if (suppressHydrationWarning) {// Don't bother comparing. We're ignoring all these warnings.
              } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING$1 || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              propKey === 'value' || propKey === 'checked' || propKey === 'selected') {// Noop
              } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var rawHtml = nextProp ? nextProp[HTML] || '' : '';
                var serverHTML = domElement.innerHTML;
                var expectedHTML = normalizeHTML(domElement, rawHtml);

                if (expectedHTML !== serverHTML) {
                  warnForPropDifference(propKey, serverHTML, expectedHTML);
                }
              } else if (propKey === STYLE) {
                // $FlowFixMe - Should be inferred as not undefined.
                extraAttributeNames.delete(propKey);
                var expectedStyle = createDangerousStringForStyles(nextProp);
                serverValue = domElement.getAttribute('style');

                if (expectedStyle !== serverValue) {
                  warnForPropDifference(propKey, serverValue, expectedStyle);
                }
              } else if (isCustomComponentTag) {
                // $FlowFixMe - Should be inferred as not undefined.
                extraAttributeNames.delete(propKey.toLowerCase());
                serverValue = getValueForAttribute(domElement, propKey, nextProp);

                if (nextProp !== serverValue) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                var isMismatchDueToBadCasing = false;

                if (propertyInfo !== null) {
                  // $FlowFixMe - Should be inferred as not undefined.
                  extraAttributeNames.delete(propertyInfo.attributeName);
                  serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                } else {
                  var ownNamespace = parentNamespace;

                  if (ownNamespace === HTML_NAMESPACE) {
                    ownNamespace = getIntrinsicNamespace(tag);
                  }

                  if (ownNamespace === HTML_NAMESPACE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                  } else {
                    var standardName = getPossibleStandardName(propKey);

                    if (standardName !== null && standardName !== propKey) {
                      // If an SVG prop is supplied with bad casing, it will
                      // be successfully parsed from HTML, but will produce a mismatch
                      // (and would be incorrectly rendered on the client).
                      // However, we already warn about bad casing elsewhere.
                      // So we'll skip the misleading extra mismatch warning in this case.
                      isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

                      extraAttributeNames.delete(standardName);
                    } // $FlowFixMe - Should be inferred as not undefined.


                    extraAttributeNames.delete(propKey);
                  }

                  serverValue = getValueForAttribute(domElement, propKey, nextProp);
                }

                if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              }
            }
          }

          {
            // $FlowFixMe - Should be inferred as not undefined.
            if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
              // $FlowFixMe - Should be inferred as not undefined.
              warnForExtraAttributes(extraAttributeNames);
            }
          }

          switch (tag) {
            case 'input':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper(domElement, rawProps);
              break;

            case 'textarea':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper$3(domElement, rawProps);
              break;

            case 'select':
            case 'option':
              // For input and textarea we current always set the value property at
              // post mount to force it to diverge from attributes. However, for
              // option and select we don't quite do the same thing and select
              // is not resilient to the DOM state changing so we don't do that here.
              // TODO: Consider not doing this for input and textarea.
              break;

            default:
              if (typeof rawProps.onClick === 'function') {
                // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
              }

              break;
          }

          return updatePayload;
        }

        function diffHydratedText$1(textNode, text) {
          var isDifferent = textNode.nodeValue !== text;
          return isDifferent;
        }

        function warnForUnmatchedText$1(textNode, text) {
          {
            warnForTextDifference(textNode.nodeValue, text);
          }
        }

        function warnForDeletedHydratableElement$1(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            warning(false, 'Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
          }
        }

        function warnForDeletedHydratableText$1(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            warning(false, 'Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
          }
        }

        function warnForInsertedHydratedElement$1(parentNode, tag, props) {
          {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            warning(false, 'Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
          }
        }

        function warnForInsertedHydratedText$1(parentNode, text) {
          {
            if (text === '') {
              // We expect to insert empty text nodes since they're not represented in
              // the HTML.
              // TODO: Remove this special case if we can just avoid inserting empty
              // text nodes.
              return;
            }

            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            warning(false, 'Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
          }
        }

        function restoreControlledState$1(domElement, tag, props) {
          switch (tag) {
            case 'input':
              restoreControlledState(domElement, props);
              return;

            case 'textarea':
              restoreControlledState$3(domElement, props);
              return;

            case 'select':
              restoreControlledState$2(domElement, props);
              return;
          }
        }

        var ReactDOMFiberComponent = Object.freeze({
          createElement: createElement$1,
          createTextNode: createTextNode$1,
          setInitialProperties: setInitialProperties$1,
          diffProperties: diffProperties$1,
          updateProperties: updateProperties$1,
          diffHydratedProperties: diffHydratedProperties$1,
          diffHydratedText: diffHydratedText$1,
          warnForUnmatchedText: warnForUnmatchedText$1,
          warnForDeletedHydratableElement: warnForDeletedHydratableElement$1,
          warnForDeletedHydratableText: warnForDeletedHydratableText$1,
          warnForInsertedHydratedElement: warnForInsertedHydratedElement$1,
          warnForInsertedHydratedText: warnForInsertedHydratedText$1,
          restoreControlledState: restoreControlledState$1
        }); // TODO: direct imports like some-package/src/* are bad. Fix me.

        var getCurrentFiberStackAddendum$5 = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var validateDOMNesting = emptyFunction;
        {
          // This validation code was written based on the HTML5 parsing spec:
          // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
          //
          // Note: this does not catch all invalid nesting, nor does it try to (as it's
          // not clear what practical benefit doing so provides); instead, we warn only
          // for cases where the parser will give a parse tree differing from what React
          // intended. For example, <b><div></div></b> is invalid but we don't warn
          // because it still parses correctly; we do warn for other cases like nested
          // <p> tags where the beginning of the second element implicitly closes the
          // first, causing a confusing mess.
          // https://html.spec.whatwg.org/multipage/syntax.html#special
          var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

          var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
          // TODO: Distinguish by namespace here -- for <title>, including it here
          // errs on the side of fewer warnings
          'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

          var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

          var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
          var emptyAncestorInfo = {
            current: null,
            formTag: null,
            aTagInScope: null,
            buttonTagInScope: null,
            nobrTagInScope: null,
            pTagInButtonScope: null,
            listItemTagAutoclosing: null,
            dlItemTagAutoclosing: null
          };

          var updatedAncestorInfo$1 = function updatedAncestorInfo$1(oldInfo, tag, instance) {
            var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);

            var info = {
              tag: tag,
              instance: instance
            };

            if (inScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.aTagInScope = null;
              ancestorInfo.buttonTagInScope = null;
              ancestorInfo.nobrTagInScope = null;
            }

            if (buttonScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.pTagInButtonScope = null;
            } // See rules for 'li', 'dd', 'dt' start tags in
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


            if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
              ancestorInfo.listItemTagAutoclosing = null;
              ancestorInfo.dlItemTagAutoclosing = null;
            }

            ancestorInfo.current = info;

            if (tag === 'form') {
              ancestorInfo.formTag = info;
            }

            if (tag === 'a') {
              ancestorInfo.aTagInScope = info;
            }

            if (tag === 'button') {
              ancestorInfo.buttonTagInScope = info;
            }

            if (tag === 'nobr') {
              ancestorInfo.nobrTagInScope = info;
            }

            if (tag === 'p') {
              ancestorInfo.pTagInButtonScope = info;
            }

            if (tag === 'li') {
              ancestorInfo.listItemTagAutoclosing = info;
            }

            if (tag === 'dd' || tag === 'dt') {
              ancestorInfo.dlItemTagAutoclosing = info;
            }

            return ancestorInfo;
          };
          /**
           * Returns whether
           */


          var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
            // First, let's check if we're in an unusual parsing mode...
            switch (parentTag) {
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
              case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';

              case 'optgroup':
                return tag === 'option' || tag === '#text';
              // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
              // but

              case 'option':
                return tag === '#text';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
              // No special behavior since these rules fall back to "in body" mode for
              // all except special table nodes which cause bad parsing behavior anyway.
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

              case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

              case 'tbody':
              case 'thead':
              case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

              case 'colgroup':
                return tag === 'col' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

              case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

              case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

              case 'html':
                return tag === 'head' || tag === 'body';

              case '#document':
                return tag === 'html';
            } // Probably in the "in body" parsing mode, so we outlaw only tag combos
            // where the parsing rules cause implicit opens or closes to be added.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


            switch (tag) {
              case 'h1':
              case 'h2':
              case 'h3':
              case 'h4':
              case 'h5':
              case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

              case 'rp':
              case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;

              case 'body':
              case 'caption':
              case 'col':
              case 'colgroup':
              case 'frame':
              case 'head':
              case 'html':
              case 'tbody':
              case 'td':
              case 'tfoot':
              case 'th':
              case 'thead':
              case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
            }

            return true;
          };
          /**
           * Returns whether
           */


          var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
            switch (tag) {
              case 'address':
              case 'article':
              case 'aside':
              case 'blockquote':
              case 'center':
              case 'details':
              case 'dialog':
              case 'dir':
              case 'div':
              case 'dl':
              case 'fieldset':
              case 'figcaption':
              case 'figure':
              case 'footer':
              case 'header':
              case 'hgroup':
              case 'main':
              case 'menu':
              case 'nav':
              case 'ol':
              case 'p':
              case 'section':
              case 'summary':
              case 'ul':
              case 'pre':
              case 'listing':
              case 'table':
              case 'hr':
              case 'xmp':
              case 'h1':
              case 'h2':
              case 'h3':
              case 'h4':
              case 'h5':
              case 'h6':
                return ancestorInfo.pTagInButtonScope;

              case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

              case 'li':
                return ancestorInfo.listItemTagAutoclosing;

              case 'dd':
              case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;

              case 'button':
                return ancestorInfo.buttonTagInScope;

              case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;

              case 'nobr':
                return ancestorInfo.nobrTagInScope;
            }

            return null;
          };

          var didWarn = {};

          validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
            ancestorInfo = ancestorInfo || emptyAncestorInfo;
            var parentInfo = ancestorInfo.current;
            var parentTag = parentInfo && parentInfo.tag;

            if (childText != null) {
              !(childTag == null) ? warning(false, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
              childTag = '#text';
            }

            var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
            var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
            var invalidParentOrAncestor = invalidParent || invalidAncestor;

            if (!invalidParentOrAncestor) {
              return;
            }

            var ancestorTag = invalidParentOrAncestor.tag;
            var addendum = getCurrentFiberStackAddendum$5();
            var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + addendum;

            if (didWarn[warnKey]) {
              return;
            }

            didWarn[warnKey] = true;
            var tagDisplayName = childTag;
            var whitespaceInfo = '';

            if (childTag === '#text') {
              if (/\S/.test(childText)) {
                tagDisplayName = 'Text nodes';
              } else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
              }
            } else {
              tagDisplayName = '<' + childTag + '>';
            }

            if (invalidParent) {
              var info = '';

              if (ancestorTag === 'table' && childTag === 'tr') {
                info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
              }

              warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info, addendum);
            } else {
              warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.%s', tagDisplayName, ancestorTag, addendum);
            }
          }; // TODO: turn this into a named export


          validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo$1;
        }
        var validateDOMNesting$1 = validateDOMNesting; // Renderers that don't support persistence
        // can re-export everything from this module.

        function shim() {
          invariant(false, 'The current renderer does not support persistence. This error is likely caused by a bug in React. Please file an issue.');
        } // Persistence (when unsupported)


        var supportsPersistence = false;
        var cloneInstance = shim;
        var createContainerChildSet = shim;
        var appendChildToContainerChildSet = shim;
        var finalizeContainerChildren = shim;
        var replaceContainerChildren = shim; // Unused

        var createElement = createElement$1;
        var createTextNode = createTextNode$1;
        var setInitialProperties = setInitialProperties$1;
        var diffProperties = diffProperties$1;
        var updateProperties = updateProperties$1;
        var diffHydratedProperties = diffHydratedProperties$1;
        var diffHydratedText = diffHydratedText$1;
        var warnForUnmatchedText = warnForUnmatchedText$1;
        var warnForDeletedHydratableElement = warnForDeletedHydratableElement$1;
        var warnForDeletedHydratableText = warnForDeletedHydratableText$1;
        var warnForInsertedHydratedElement = warnForInsertedHydratedElement$1;
        var warnForInsertedHydratedText = warnForInsertedHydratedText$1;
        var updatedAncestorInfo = validateDOMNesting$1.updatedAncestorInfo;
        var precacheFiberNode$1 = precacheFiberNode;
        var updateFiberProps$1 = updateFiberProps;
        var SUPPRESS_HYDRATION_WARNING = void 0;
        {
          SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
        }
        var eventsEnabled = null;
        var selectionInformation = null;

        function shouldAutoFocusHostComponent(type, props) {
          switch (type) {
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
              return !!props.autoFocus;
          }

          return false;
        }

        function getRootHostContext(rootContainerInstance) {
          var type = void 0;
          var namespace = void 0;
          var nodeType = rootContainerInstance.nodeType;

          switch (nodeType) {
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
              {
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
              }

            default:
              {
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
              }
          }

          {
            var validatedTag = type.toLowerCase();

            var _ancestorInfo = updatedAncestorInfo(null, validatedTag, null);

            return {
              namespace: namespace,
              ancestorInfo: _ancestorInfo
            };
          }
          return namespace;
        }

        function getChildHostContext(parentHostContext, type, rootContainerInstance) {
          {
            var parentHostContextDev = parentHostContext;

            var _namespace = getChildNamespace(parentHostContextDev.namespace, type);

            var _ancestorInfo2 = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type, null);

            return {
              namespace: _namespace,
              ancestorInfo: _ancestorInfo2
            };
          }
          var parentNamespace = parentHostContext;
          return getChildNamespace(parentNamespace, type);
        }

        function getPublicInstance(instance) {
          return instance;
        }

        function prepareForCommit(containerInfo) {
          eventsEnabled = isEnabled();
          selectionInformation = getSelectionInformation();
          setEnabled(false);
        }

        function resetAfterCommit(containerInfo) {
          restoreSelection(selectionInformation);
          selectionInformation = null;
          setEnabled(eventsEnabled);
          eventsEnabled = null;
        }

        function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          var parentNamespace = void 0;
          {
            // TODO: take namespace into account when validating.
            var hostContextDev = hostContext;
            validateDOMNesting$1(type, null, hostContextDev.ancestorInfo);

            if (typeof props.children === 'string' || typeof props.children === 'number') {
              var string = '' + props.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type, null);
              validateDOMNesting$1(null, string, ownAncestorInfo);
            }

            parentNamespace = hostContextDev.namespace;
          }
          var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
          precacheFiberNode$1(internalInstanceHandle, domElement);
          updateFiberProps$1(domElement, props);
          return domElement;
        }

        function appendInitialChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }

        function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
          setInitialProperties(domElement, type, props, rootContainerInstance);
          return shouldAutoFocusHostComponent(type, props);
        }

        function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
          {
            var hostContextDev = hostContext;

            if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
              var string = '' + newProps.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type, null);
              validateDOMNesting$1(null, string, ownAncestorInfo);
            }
          }
          return diffProperties(domElement, type, oldProps, newProps, rootContainerInstance);
        }

        function shouldSetTextContent(type, props) {
          return type === 'textarea' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && typeof props.dangerouslySetInnerHTML.__html === 'string';
        }

        function shouldDeprioritizeSubtree(type, props) {
          return !!props.hidden;
        }

        function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
          {
            var hostContextDev = hostContext;
            validateDOMNesting$1(null, text, hostContextDev.ancestorInfo);
          }
          var textNode = createTextNode(text, rootContainerInstance);
          precacheFiberNode$1(internalInstanceHandle, textNode);
          return textNode;
        }

        var now = now$1;
        var isPrimaryRenderer = true;
        var scheduleDeferredCallback = scheduleWork;
        var cancelDeferredCallback = cancelScheduledWork; // -------------------
        //     Mutation
        // -------------------

        var supportsMutation = true;

        function commitMount(domElement, type, newProps, internalInstanceHandle) {
          // Despite the naming that might imply otherwise, this method only
          // fires if there is an `Update` effect scheduled during mounting.
          // This happens if `finalizeInitialChildren` returns `true` (which it
          // does to implement the `autoFocus` attribute on the client). But
          // there are also other cases when this might happen (such as patching
          // up text content during hydration mismatch). So we'll check this again.
          if (shouldAutoFocusHostComponent(type, newProps)) {
            domElement.focus();
          }
        }

        function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
          // Update the props handle so that we know which props are the ones with
          // with current event handlers.
          updateFiberProps$1(domElement, newProps); // Apply the diff to the DOM node.

          updateProperties(domElement, updatePayload, type, oldProps, newProps);
        }

        function resetTextContent(domElement) {
          setTextContent(domElement, '');
        }

        function commitTextUpdate(textInstance, oldText, newText) {
          textInstance.nodeValue = newText;
        }

        function appendChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }

        function appendChildToContainer(container, child) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.insertBefore(child, container);
          } else {
            container.appendChild(child);
          }
        }

        function insertBefore(parentInstance, child, beforeChild) {
          parentInstance.insertBefore(child, beforeChild);
        }

        function insertInContainerBefore(container, child, beforeChild) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.insertBefore(child, beforeChild);
          } else {
            container.insertBefore(child, beforeChild);
          }
        }

        function removeChild(parentInstance, child) {
          parentInstance.removeChild(child);
        }

        function removeChildFromContainer(container, child) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.removeChild(child);
          } else {
            container.removeChild(child);
          }
        } // -------------------
        //     Hydration
        // -------------------


        var supportsHydration = true;

        function canHydrateInstance(instance, type, props) {
          if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
            return null;
          } // This has now been refined to an element node.


          return instance;
        }

        function canHydrateTextInstance(instance, text) {
          if (text === '' || instance.nodeType !== TEXT_NODE) {
            // Empty strings are not parsed by HTML so there won't be a correct match here.
            return null;
          } // This has now been refined to a text node.


          return instance;
        }

        function getNextHydratableSibling(instance) {
          var node = instance.nextSibling; // Skip non-hydratable nodes.

          while (node && node.nodeType !== ELEMENT_NODE && node.nodeType !== TEXT_NODE) {
            node = node.nextSibling;
          }

          return node;
        }

        function getFirstHydratableChild(parentInstance) {
          var next = parentInstance.firstChild; // Skip non-hydratable nodes.

          while (next && next.nodeType !== ELEMENT_NODE && next.nodeType !== TEXT_NODE) {
            next = next.nextSibling;
          }

          return next;
        }

        function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          precacheFiberNode$1(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
          // get attached.

          updateFiberProps$1(instance, props);
          var parentNamespace = void 0;
          {
            var hostContextDev = hostContext;
            parentNamespace = hostContextDev.namespace;
          }
          return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance);
        }

        function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
          precacheFiberNode$1(internalInstanceHandle, textInstance);
          return diffHydratedText(textInstance, text);
        }

        function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
          {
            warnForUnmatchedText(textInstance, text);
          }
        }

        function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
          if (true && parentProps[SUPPRESS_HYDRATION_WARNING] !== true) {
            warnForUnmatchedText(textInstance, text);
          }
        }

        function didNotHydrateContainerInstance(parentContainer, instance) {
          {
            if (instance.nodeType === 1) {
              warnForDeletedHydratableElement(parentContainer, instance);
            } else {
              warnForDeletedHydratableText(parentContainer, instance);
            }
          }
        }

        function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
          if (true && parentProps[SUPPRESS_HYDRATION_WARNING] !== true) {
            if (instance.nodeType === 1) {
              warnForDeletedHydratableElement(parentInstance, instance);
            } else {
              warnForDeletedHydratableText(parentInstance, instance);
            }
          }
        }

        function didNotFindHydratableContainerInstance(parentContainer, type, props) {
          {
            warnForInsertedHydratedElement(parentContainer, type, props);
          }
        }

        function didNotFindHydratableContainerTextInstance(parentContainer, text) {
          {
            warnForInsertedHydratedText(parentContainer, text);
          }
        }

        function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
          if (true && parentProps[SUPPRESS_HYDRATION_WARNING] !== true) {
            warnForInsertedHydratedElement(parentInstance, type, props);
          }
        }

        function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
          if (true && parentProps[SUPPRESS_HYDRATION_WARNING] !== true) {
            warnForInsertedHydratedText(parentInstance, text);
          }
        } // Exports ReactDOM.createRoot


        var enableUserTimingAPI = true; // Experimental error-boundary API that can recover from errors within a single
        // render phase

        var enableGetDerivedStateFromCatch = false; // Suspense

        var enableSuspense = false; // Helps identify side effects in begin-phase lifecycle hooks and setState reducers:

        var debugRenderPhaseSideEffects = false; // In some cases, StrictMode should also double-render lifecycles.
        // This can be confusing for tests though,
        // And it can be bad for performance in production.
        // This feature flag can be used to control the behavior:

        var debugRenderPhaseSideEffectsForStrictMode = true; // To preserve the "Pause on caught exceptions" behavior of the debugger, we
        // replay the begin phase of a failed component inside invokeGuardedCallback.

        var replayFailedUnitOfWorkWithInvokeGuardedCallback = true; // Warn about deprecated, async-unsafe lifecycles; relates to RFC #6:

        var warnAboutDeprecatedLifecycles = false; // Warn about legacy context API

        var warnAboutLegacyContextAPI = false; // Gather advanced timing metrics for Profiler subtrees.

        var enableProfilerTimer = true; // Fires getDerivedStateFromProps for state *or* props changes

        var fireGetDerivedStateFromPropsOnStateUpdates = true; // Only used in www builds.
        // Prefix measurements so that it's possible to filter them.
        // Longer prefixes are hard to read in DevTools.

        var reactEmoji = "\u269B";
        var warningEmoji = "\u26D4";
        var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
        // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?

        var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
        // Reusing `currentFiber` would be confusing for this because user code fiber
        // can change during commit phase too, but we don't need to unwind it (since
        // lifecycles in the commit phase don't resemble a tree).

        var currentPhase = null;
        var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
        // so we will keep track of it, and include it in the report.
        // Track commits caused by cascading updates.

        var isCommitting = false;
        var hasScheduledUpdateInCurrentCommit = false;
        var hasScheduledUpdateInCurrentPhase = false;
        var commitCountInCurrentWorkLoop = 0;
        var effectCountInCurrentCommit = 0;
        var isWaitingForCallback = false; // During commits, we only show a measurement once per method name
        // to avoid stretch the commit phase with measurement overhead.

        var labelsInCurrentCommit = new Set();

        var formatMarkName = function formatMarkName(markName) {
          return reactEmoji + ' ' + markName;
        };

        var formatLabel = function formatLabel(label, warning$$1) {
          var prefix = warning$$1 ? warningEmoji + ' ' : reactEmoji + ' ';
          var suffix = warning$$1 ? ' Warning: ' + warning$$1 : '';
          return '' + prefix + label + suffix;
        };

        var beginMark = function beginMark(markName) {
          performance.mark(formatMarkName(markName));
        };

        var clearMark = function clearMark(markName) {
          performance.clearMarks(formatMarkName(markName));
        };

        var endMark = function endMark(label, markName, warning$$1) {
          var formattedMarkName = formatMarkName(markName);
          var formattedLabel = formatLabel(label, warning$$1);

          try {
            performance.measure(formattedLabel, formattedMarkName);
          } catch (err) {} // If previous mark was missing for some reason, this will throw.
          // This could only happen if React crashed in an unexpected place earlier.
          // Don't pile on with more errors.
          // Clear marks immediately to avoid growing buffer.


          performance.clearMarks(formattedMarkName);
          performance.clearMeasures(formattedLabel);
        };

        var getFiberMarkName = function getFiberMarkName(label, debugID) {
          return label + ' (#' + debugID + ')';
        };

        var getFiberLabel = function getFiberLabel(componentName, isMounted, phase) {
          if (phase === null) {
            // These are composite component total time measurements.
            return componentName + ' [' + (isMounted ? 'update' : 'mount') + ']';
          } else {
            // Composite component methods.
            return componentName + '.' + phase;
          }
        };

        var beginFiberMark = function beginFiberMark(fiber, phase) {
          var componentName = getComponentName(fiber) || 'Unknown';
          var debugID = fiber._debugID;
          var isMounted = fiber.alternate !== null;
          var label = getFiberLabel(componentName, isMounted, phase);

          if (isCommitting && labelsInCurrentCommit.has(label)) {
            // During the commit phase, we don't show duplicate labels because
            // there is a fixed overhead for every measurement, and we don't
            // want to stretch the commit phase beyond necessary.
            return false;
          }

          labelsInCurrentCommit.add(label);
          var markName = getFiberMarkName(label, debugID);
          beginMark(markName);
          return true;
        };

        var clearFiberMark = function clearFiberMark(fiber, phase) {
          var componentName = getComponentName(fiber) || 'Unknown';
          var debugID = fiber._debugID;
          var isMounted = fiber.alternate !== null;
          var label = getFiberLabel(componentName, isMounted, phase);
          var markName = getFiberMarkName(label, debugID);
          clearMark(markName);
        };

        var endFiberMark = function endFiberMark(fiber, phase, warning$$1) {
          var componentName = getComponentName(fiber) || 'Unknown';
          var debugID = fiber._debugID;
          var isMounted = fiber.alternate !== null;
          var label = getFiberLabel(componentName, isMounted, phase);
          var markName = getFiberMarkName(label, debugID);
          endMark(label, markName, warning$$1);
        };

        var shouldIgnoreFiber = function shouldIgnoreFiber(fiber) {
          // Host components should be skipped in the timeline.
          // We could check typeof fiber.type, but does this work with RN?
          switch (fiber.tag) {
            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
            case Fragment:
            case ContextProvider:
            case ContextConsumer:
            case Mode:
              return true;

            default:
              return false;
          }
        };

        var clearPendingPhaseMeasurement = function clearPendingPhaseMeasurement() {
          if (currentPhase !== null && currentPhaseFiber !== null) {
            clearFiberMark(currentPhaseFiber, currentPhase);
          }

          currentPhaseFiber = null;
          currentPhase = null;
          hasScheduledUpdateInCurrentPhase = false;
        };

        var pauseTimers = function pauseTimers() {
          // Stops all currently active measurements so that they can be resumed
          // if we continue in a later deferred loop from the same unit of work.
          var fiber = currentFiber;

          while (fiber) {
            if (fiber._debugIsCurrentlyTiming) {
              endFiberMark(fiber, null, null);
            }

            fiber = fiber.return;
          }
        };

        var resumeTimersRecursively = function resumeTimersRecursively(fiber) {
          if (fiber.return !== null) {
            resumeTimersRecursively(fiber.return);
          }

          if (fiber._debugIsCurrentlyTiming) {
            beginFiberMark(fiber, null);
          }
        };

        var resumeTimers = function resumeTimers() {
          // Resumes all measurements that were active during the last deferred loop.
          if (currentFiber !== null) {
            resumeTimersRecursively(currentFiber);
          }
        };

        function recordEffect() {
          if (enableUserTimingAPI) {
            effectCountInCurrentCommit++;
          }
        }

        function recordScheduleUpdate() {
          if (enableUserTimingAPI) {
            if (isCommitting) {
              hasScheduledUpdateInCurrentCommit = true;
            }

            if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') {
              hasScheduledUpdateInCurrentPhase = true;
            }
          }
        }

        function startRequestCallbackTimer() {
          if (enableUserTimingAPI) {
            if (supportsUserTiming && !isWaitingForCallback) {
              isWaitingForCallback = true;
              beginMark('(Waiting for async callback...)');
            }
          }
        }

        function stopRequestCallbackTimer(didExpire, expirationTime) {
          if (enableUserTimingAPI) {
            if (supportsUserTiming) {
              isWaitingForCallback = false;
              var warning$$1 = didExpire ? 'React was blocked by main thread' : null;
              endMark('(Waiting for async callback... will force flush in ' + expirationTime + ' ms)', '(Waiting for async callback...)', warning$$1);
            }
          }
        }

        function startWorkTimer(fiber) {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            } // If we pause, this is the fiber to unwind from.


            currentFiber = fiber;

            if (!beginFiberMark(fiber, null)) {
              return;
            }

            fiber._debugIsCurrentlyTiming = true;
          }
        }

        function cancelWorkTimer(fiber) {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            } // Remember we shouldn't complete measurement for this fiber.
            // Otherwise flamechart will be deep even for small updates.


            fiber._debugIsCurrentlyTiming = false;
            clearFiberMark(fiber, null);
          }
        }

        function stopWorkTimer(fiber) {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            } // If we pause, its parent is the fiber to unwind from.


            currentFiber = fiber.return;

            if (!fiber._debugIsCurrentlyTiming) {
              return;
            }

            fiber._debugIsCurrentlyTiming = false;
            endFiberMark(fiber, null, null);
          }
        }

        function stopFailedWorkTimer(fiber) {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
              return;
            } // If we pause, its parent is the fiber to unwind from.


            currentFiber = fiber.return;

            if (!fiber._debugIsCurrentlyTiming) {
              return;
            }

            fiber._debugIsCurrentlyTiming = false;
            var warning$$1 = 'An error was thrown inside this error boundary';
            endFiberMark(fiber, null, warning$$1);
          }
        }

        function startPhaseTimer(fiber, phase) {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            clearPendingPhaseMeasurement();

            if (!beginFiberMark(fiber, phase)) {
              return;
            }

            currentPhaseFiber = fiber;
            currentPhase = phase;
          }
        }

        function stopPhaseTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            if (currentPhase !== null && currentPhaseFiber !== null) {
              var warning$$1 = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
              endFiberMark(currentPhaseFiber, currentPhase, warning$$1);
            }

            currentPhase = null;
            currentPhaseFiber = null;
          }
        }

        function startWorkLoopTimer(nextUnitOfWork) {
          if (enableUserTimingAPI) {
            currentFiber = nextUnitOfWork;

            if (!supportsUserTiming) {
              return;
            }

            commitCountInCurrentWorkLoop = 0; // This is top level call.
            // Any other measurements are performed within.

            beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.

            resumeTimers();
          }
        }

        function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            var warning$$1 = null;

            if (interruptedBy !== null) {
              if (interruptedBy.tag === HostRoot) {
                warning$$1 = 'A top-level update interrupted the previous render';
              } else {
                var componentName = getComponentName(interruptedBy) || 'Unknown';
                warning$$1 = 'An update to ' + componentName + ' interrupted the previous render';
              }
            } else if (commitCountInCurrentWorkLoop > 1) {
              warning$$1 = 'There were cascading updates';
            }

            commitCountInCurrentWorkLoop = 0;
            var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.

            pauseTimers();
            endMark(label, '(React Tree Reconciliation)', warning$$1);
          }
        }

        function startCommitTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            isCommitting = true;
            hasScheduledUpdateInCurrentCommit = false;
            labelsInCurrentCommit.clear();
            beginMark('(Committing Changes)');
          }
        }

        function stopCommitTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            var warning$$1 = null;

            if (hasScheduledUpdateInCurrentCommit) {
              warning$$1 = 'Lifecycle hook scheduled a cascading update';
            } else if (commitCountInCurrentWorkLoop > 0) {
              warning$$1 = 'Caused by a cascading update in earlier commit';
            }

            hasScheduledUpdateInCurrentCommit = false;
            commitCountInCurrentWorkLoop++;
            isCommitting = false;
            labelsInCurrentCommit.clear();
            endMark('(Committing Changes)', '(Committing Changes)', warning$$1);
          }
        }

        function startCommitSnapshotEffectsTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            effectCountInCurrentCommit = 0;
            beginMark('(Committing Snapshot Effects)');
          }
        }

        function stopCommitSnapshotEffectsTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark('(Committing Snapshot Effects: ' + count + ' Total)', '(Committing Snapshot Effects)', null);
          }
        }

        function startCommitHostEffectsTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            effectCountInCurrentCommit = 0;
            beginMark('(Committing Host Effects)');
          }
        }

        function stopCommitHostEffectsTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark('(Committing Host Effects: ' + count + ' Total)', '(Committing Host Effects)', null);
          }
        }

        function startCommitLifeCyclesTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            effectCountInCurrentCommit = 0;
            beginMark('(Calling Lifecycle Methods)');
          }
        }

        function stopCommitLifeCyclesTimer() {
          if (enableUserTimingAPI) {
            if (!supportsUserTiming) {
              return;
            }

            var count = effectCountInCurrentCommit;
            effectCountInCurrentCommit = 0;
            endMark('(Calling Lifecycle Methods: ' + count + ' Total)', '(Calling Lifecycle Methods)', null);
          }
        }

        var valueStack = [];
        var fiberStack = void 0;
        {
          fiberStack = [];
        }
        var index = -1;

        function createCursor(defaultValue) {
          return {
            current: defaultValue
          };
        }

        function pop(cursor, fiber) {
          if (index < 0) {
            {
              warning(false, 'Unexpected pop.');
            }
            return;
          }

          {
            if (fiber !== fiberStack[index]) {
              warning(false, 'Unexpected Fiber popped.');
            }
          }
          cursor.current = valueStack[index];
          valueStack[index] = null;
          {
            fiberStack[index] = null;
          }
          index--;
        }

        function push(cursor, value, fiber) {
          index++;
          valueStack[index] = cursor.current;
          {
            fiberStack[index] = fiber;
          }
          cursor.current = value;
        }

        function checkThatStackIsEmpty() {
          {
            if (index !== -1) {
              warning(false, 'Expected an empty stack. Something was not reset properly.');
            }
          }
        }

        function resetStackAfterFatalErrorInDev() {
          {
            index = -1;
            valueStack.length = 0;
            fiberStack.length = 0;
          }
        }

        var warnedAboutMissingGetChildContext = void 0;
        {
          warnedAboutMissingGetChildContext = {};
        } // A cursor to the current merged context object on the stack.

        var contextStackCursor = createCursor(emptyObject); // A cursor to a boolean indicating whether the context has changed.

        var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
        // We use this to get access to the parent context after we have already
        // pushed the next context provider, and now need to merge their contexts.

        var previousContext = emptyObject;

        function getUnmaskedContext(workInProgress) {
          var hasOwnContext = isContextProvider(workInProgress);

          if (hasOwnContext) {
            // If the fiber is a context provider itself, when we read its context
            // we have already pushed its own child context on the stack. A context
            // provider should not "see" its own child context. Therefore we read the
            // previous (parent) context instead for a context provider.
            return previousContext;
          }

          return contextStackCursor.current;
        }

        function cacheContext(workInProgress, unmaskedContext, maskedContext) {
          var instance = workInProgress.stateNode;
          instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }

        function getMaskedContext(workInProgress, unmaskedContext) {
          var type = workInProgress.type;
          var contextTypes = type.contextTypes;

          if (!contextTypes) {
            return emptyObject;
          } // Avoid recreating masked context unless unmasked context has changed.
          // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
          // This may trigger infinite loops if componentWillReceiveProps calls setState.


          var instance = workInProgress.stateNode;

          if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance.__reactInternalMemoizedMaskedChildContext;
          }

          var context = {};

          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }

          {
            var name = getComponentName(workInProgress) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name, ReactDebugCurrentFiber.getCurrentFiberStackAddendum);
          } // Cache unmasked context so we can avoid recreating masked context unless necessary.
          // Context is created before the class component is instantiated so check for instance.

          if (instance) {
            cacheContext(workInProgress, unmaskedContext, context);
          }

          return context;
        }

        function hasContextChanged() {
          return didPerformWorkStackCursor.current;
        }

        function isContextConsumer(fiber) {
          return fiber.tag === ClassComponent && fiber.type.contextTypes != null;
        }

        function isContextProvider(fiber) {
          return fiber.tag === ClassComponent && fiber.type.childContextTypes != null;
        }

        function popContextProvider(fiber) {
          if (!isContextProvider(fiber)) {
            return;
          }

          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }

        function popTopLevelContextObject(fiber) {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }

        function pushTopLevelContextObject(fiber, context, didChange) {
          !(contextStackCursor.current === emptyObject) ? invariant(false, 'Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          push(contextStackCursor, context, fiber);
          push(didPerformWorkStackCursor, didChange, fiber);
        }

        function processChildContext(fiber, parentContext) {
          var instance = fiber.stateNode;
          var childContextTypes = fiber.type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
          // It has only been added in Fiber to match the (unintentional) behavior in Stack.

          if (typeof instance.getChildContext !== 'function') {
            {
              var componentName = getComponentName(fiber) || 'Unknown';

              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                warning(false, '%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
              }
            }
            return parentContext;
          }

          var childContext = void 0;
          {
            ReactDebugCurrentFiber.setCurrentPhase('getChildContext');
          }
          startPhaseTimer(fiber, 'getChildContext');
          childContext = instance.getChildContext();
          stopPhaseTimer();
          {
            ReactDebugCurrentFiber.setCurrentPhase(null);
          }

          for (var contextKey in childContext) {
            !(contextKey in childContextTypes) ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', getComponentName(fiber) || 'Unknown', contextKey) : void 0;
          }

          {
            var name = getComponentName(fiber) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name, // In practice, there is one case in which we won't get a stack. It's when
            // somebody calls unstable_renderSubtreeIntoContainer() and we process
            // context from the parent component instance. The stack will be missing
            // because it's outside of the reconciliation, and so the pointer has not
            // been set. This is rare and doesn't matter. We'll also remove that API.
            ReactDebugCurrentFiber.getCurrentFiberStackAddendum);
          }
          return _assign({}, parentContext, childContext);
        }

        function pushContextProvider(workInProgress) {
          if (!isContextProvider(workInProgress)) {
            return false;
          }

          var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
          // If the instance does not exist yet, we will push null at first,
          // and replace it on the stack later when invalidating the context.

          var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyObject; // Remember the parent context so we can merge with it later.
          // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

          previousContext = contextStackCursor.current;
          push(contextStackCursor, memoizedMergedChildContext, workInProgress);
          push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
          return true;
        }

        function invalidateContextProvider(workInProgress, didChange) {
          var instance = workInProgress.stateNode;
          !instance ? invariant(false, 'Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.') : void 0;

          if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.

            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          }
        }

        function findCurrentUnmaskedContext(fiber) {
          // Currently this is only used with renderSubtreeIntoContainer; not sure if it
          // makes sense elsewhere
          !(isFiberMounted(fiber) && fiber.tag === ClassComponent) ? invariant(false, 'Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          var node = fiber;

          while (node.tag !== HostRoot) {
            if (isContextProvider(node)) {
              return node.stateNode.__reactInternalMemoizedMergedChildContext;
            }

            var parent = node.return;
            !parent ? invariant(false, 'Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.') : void 0;
            node = parent;
          }

          return node.stateNode.context;
        } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
        // Math.pow(2, 30) - 1
        // 0b111111111111111111111111111111


        var MAX_SIGNED_31_BIT_INT = 1073741823; // TODO: Use an opaque type once ESLint et al support the syntax

        var NoWork = 0;
        var Sync = 1;
        var Never = MAX_SIGNED_31_BIT_INT;
        var UNIT_SIZE = 10;
        var MAGIC_NUMBER_OFFSET = 2; // 1 unit of expiration time represents 10ms.

        function msToExpirationTime(ms) {
          // Always add an offset so that we don't clash with the magic number for NoWork.
          return (ms / UNIT_SIZE | 0) + MAGIC_NUMBER_OFFSET;
        }

        function expirationTimeToMs(expirationTime) {
          return (expirationTime - MAGIC_NUMBER_OFFSET) * UNIT_SIZE;
        }

        function ceiling(num, precision) {
          return ((num / precision | 0) + 1) * precision;
        }

        function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
          return MAGIC_NUMBER_OFFSET + ceiling(currentTime - MAGIC_NUMBER_OFFSET + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
        }

        var NoContext = 0;
        var AsyncMode = 1;
        var StrictMode = 2;
        var ProfileMode = 4;
        var hasBadMapPolyfill = void 0;
        {
          hasBadMapPolyfill = false;

          try {
            var nonExtensibleObject = Object.preventExtensions({});
            var testMap = new Map([[nonExtensibleObject, null]]);
            var testSet = new Set([nonExtensibleObject]); // This is necessary for Rollup to not consider these unused.
            // https://github.com/rollup/rollup/issues/1771
            // TODO: we can remove these if Rollup fixes the bug.

            testMap.set(0, 0);
            testSet.add(0);
          } catch (e) {
            // TODO: Consider warning about bad polyfills
            hasBadMapPolyfill = true;
          }
        } // A Fiber is work on a Component that needs to be done or was done. There can
        // be more than one per component.

        var debugCounter = void 0;
        {
          debugCounter = 1;
        }

        function FiberNode(tag, pendingProps, key, mode) {
          // Instance
          this.tag = tag;
          this.key = key;
          this.type = null;
          this.stateNode = null; // Fiber

          this.return = null;
          this.child = null;
          this.sibling = null;
          this.index = 0;
          this.ref = null;
          this.pendingProps = pendingProps;
          this.memoizedProps = null;
          this.updateQueue = null;
          this.memoizedState = null;
          this.mode = mode; // Effects

          this.effectTag = NoEffect;
          this.nextEffect = null;
          this.firstEffect = null;
          this.lastEffect = null;
          this.expirationTime = NoWork;
          this.alternate = null;

          if (enableProfilerTimer) {
            this.selfBaseTime = 0;
            this.treeBaseTime = 0;
          }

          {
            this._debugID = debugCounter++;
            this._debugSource = null;
            this._debugOwner = null;
            this._debugIsCurrentlyTiming = false;

            if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
              Object.preventExtensions(this);
            }
          }
        } // This is a constructor function, rather than a POJO constructor, still
        // please ensure we do the following:
        // 1) Nobody should add any instance methods on this. Instance methods can be
        //    more difficult to predict when they get optimized and they are almost
        //    never inlined properly in static compilers.
        // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
        //    always know when it is a fiber.
        // 3) We might want to experiment with using numeric keys since they are easier
        //    to optimize in a non-JIT environment.
        // 4) We can easily go from a constructor to a createFiber object literal if that
        //    is faster.
        // 5) It should be easy to port this to a C struct and keep a C implementation
        //    compatible.


        var createFiber = function createFiber(tag, pendingProps, key, mode) {
          // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
          return new FiberNode(tag, pendingProps, key, mode);
        };

        function shouldConstruct(Component) {
          return !!(Component.prototype && Component.prototype.isReactComponent);
        } // This is used to create an alternate fiber to do work on.


        function createWorkInProgress(current, pendingProps, expirationTime) {
          var workInProgress = current.alternate;

          if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            {
              // DEV-only fields
              workInProgress._debugID = current._debugID;
              workInProgress._debugSource = current._debugSource;
              workInProgress._debugOwner = current._debugOwner;
            }
            workInProgress.alternate = current;
            current.alternate = workInProgress;
          } else {
            workInProgress.pendingProps = pendingProps; // We already have an alternate.
            // Reset the effect tag.

            workInProgress.effectTag = NoEffect; // The effect list is no longer valid.

            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
          }

          workInProgress.expirationTime = expirationTime;
          workInProgress.child = current.child;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue; // These will be overridden during the parent's reconciliation

          workInProgress.sibling = current.sibling;
          workInProgress.index = current.index;
          workInProgress.ref = current.ref;

          if (enableProfilerTimer) {
            workInProgress.selfBaseTime = current.selfBaseTime;
            workInProgress.treeBaseTime = current.treeBaseTime;
          }

          return workInProgress;
        }

        function createHostRootFiber(isAsync) {
          var mode = isAsync ? AsyncMode | StrictMode : NoContext;
          return createFiber(HostRoot, null, null, mode);
        }

        function createFiberFromElement(element, mode, expirationTime) {
          var owner = null;
          {
            owner = element._owner;
          }
          var fiber = void 0;
          var type = element.type;
          var key = element.key;
          var pendingProps = element.props;
          var fiberTag = void 0;

          if (typeof type === 'function') {
            fiberTag = shouldConstruct(type) ? ClassComponent : IndeterminateComponent;
          } else if (typeof type === 'string') {
            fiberTag = HostComponent;
          } else {
            switch (type) {
              case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);

              case REACT_ASYNC_MODE_TYPE:
                fiberTag = Mode;
                mode |= AsyncMode | StrictMode;
                break;

              case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;

              case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, expirationTime, key);

              case REACT_TIMEOUT_TYPE:
                fiberTag = TimeoutComponent; // Suspense does not require async, but its children should be strict
                // mode compatible.

                mode |= StrictMode;
                break;

              default:
                fiberTag = getFiberTagFromObjectType(type, owner);
                break;
            }
          }

          fiber = createFiber(fiberTag, pendingProps, key, mode);
          fiber.type = type;
          fiber.expirationTime = expirationTime;
          {
            fiber._debugSource = element._source;
            fiber._debugOwner = element._owner;
          }
          return fiber;
        }

        function getFiberTagFromObjectType(type, owner) {
          var $$typeof = typeof type === 'object' && type !== null ? type.$$typeof : null;

          switch ($$typeof) {
            case REACT_PROVIDER_TYPE:
              return ContextProvider;

            case REACT_CONTEXT_TYPE:
              // This is a consumer
              return ContextConsumer;

            case REACT_FORWARD_REF_TYPE:
              return ForwardRef;

            default:
              {
                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }

                  var ownerName = owner ? getComponentName(owner) : null;

                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info);
              }
          }
        }

        function createFiberFromFragment(elements, mode, expirationTime, key) {
          var fiber = createFiber(Fragment, elements, key, mode);
          fiber.expirationTime = expirationTime;
          return fiber;
        }

        function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
          {
            if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') {
              invariant(false, 'Profiler must specify an "id" string and "onRender" function as props');
            }
          }
          var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
          fiber.type = REACT_PROFILER_TYPE;
          fiber.expirationTime = expirationTime;

          if (enableProfilerTimer) {
            fiber.stateNode = {
              elapsedPauseTimeAtStart: 0,
              duration: 0,
              startTime: 0
            };
          }

          return fiber;
        }

        function createFiberFromText(content, mode, expirationTime) {
          var fiber = createFiber(HostText, content, null, mode);
          fiber.expirationTime = expirationTime;
          return fiber;
        }

        function createFiberFromHostInstanceForDeletion() {
          var fiber = createFiber(HostComponent, null, null, NoContext);
          fiber.type = 'DELETED';
          return fiber;
        }

        function createFiberFromPortal(portal, mode, expirationTime) {
          var pendingProps = portal.children !== null ? portal.children : [];
          var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
          fiber.expirationTime = expirationTime;
          fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
          };
          return fiber;
        } // Used for stashing WIP properties to replay failed work in DEV.


        function assignFiberPropertiesInDEV(target, source) {
          if (target === null) {
            // This Fiber's initial properties will always be overwritten.
            // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
            target = createFiber(IndeterminateComponent, null, null, NoContext);
          } // This is intentionally written as a list of all properties.
          // We tried to use Object.assign() instead but this is called in
          // the hottest path, and Object.assign() was too slow:
          // https://github.com/facebook/react/issues/12502
          // This code is DEV-only so size is not a concern.


          target.tag = source.tag;
          target.key = source.key;
          target.type = source.type;
          target.stateNode = source.stateNode;
          target.return = source.return;
          target.child = source.child;
          target.sibling = source.sibling;
          target.index = source.index;
          target.ref = source.ref;
          target.pendingProps = source.pendingProps;
          target.memoizedProps = source.memoizedProps;
          target.updateQueue = source.updateQueue;
          target.memoizedState = source.memoizedState;
          target.mode = source.mode;
          target.effectTag = source.effectTag;
          target.nextEffect = source.nextEffect;
          target.firstEffect = source.firstEffect;
          target.lastEffect = source.lastEffect;
          target.expirationTime = source.expirationTime;
          target.alternate = source.alternate;

          if (enableProfilerTimer) {
            target.selfBaseTime = source.selfBaseTime;
            target.treeBaseTime = source.treeBaseTime;
          }

          target._debugID = source._debugID;
          target._debugSource = source._debugSource;
          target._debugOwner = source._debugOwner;
          target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
          return target;
        } // TODO: This should be lifted into the renderer.


        function createFiberRoot(containerInfo, isAsync, hydrate) {
          // Cyclic construction. This cheats the type system right now because
          // stateNode is any.
          var uninitializedFiber = createHostRootFiber(isAsync);
          var root = {
            current: uninitializedFiber,
            containerInfo: containerInfo,
            pendingChildren: null,
            earliestPendingTime: NoWork,
            latestPendingTime: NoWork,
            earliestSuspendedTime: NoWork,
            latestSuspendedTime: NoWork,
            latestPingedTime: NoWork,
            pendingCommitExpirationTime: NoWork,
            finishedWork: null,
            context: null,
            pendingContext: null,
            hydrate: hydrate,
            remainingExpirationTime: NoWork,
            firstBatch: null,
            nextScheduledRoot: null
          };
          uninitializedFiber.stateNode = root;
          return root;
        }

        var onCommitFiberRoot = null;
        var onCommitFiberUnmount = null;
        var hasLoggedError = false;

        function catchErrors(fn) {
          return function (arg) {
            try {
              return fn(arg);
            } catch (err) {
              if (true && !hasLoggedError) {
                hasLoggedError = true;
                warning(false, 'React DevTools encountered an error: %s', err);
              }
            }
          };
        }

        function injectInternals(internals) {
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
            // No DevTools
            return false;
          }

          var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

          if (hook.isDisabled) {
            // This isn't a real property on the hook, but it can be set to opt out
            // of DevTools integration and associated warnings and logs.
            // https://github.com/facebook/react/issues/3877
            return true;
          }

          if (!hook.supportsFiber) {
            {
              warning(false, 'The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://fb.me/react-devtools');
            } // DevTools exists, even though it doesn't support Fiber.

            return true;
          }

          try {
            var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

            onCommitFiberRoot = catchErrors(function (root) {
              return hook.onCommitFiberRoot(rendererID, root);
            });
            onCommitFiberUnmount = catchErrors(function (fiber) {
              return hook.onCommitFiberUnmount(rendererID, fiber);
            });
          } catch (err) {
            // Catch all errors because it is unsafe to throw during initialization.
            {
              warning(false, 'React DevTools encountered an error: %s.', err);
            }
          } // DevTools exists


          return true;
        }

        function onCommitRoot(root) {
          if (typeof onCommitFiberRoot === 'function') {
            onCommitFiberRoot(root);
          }
        }

        function onCommitUnmount(fiber) {
          if (typeof onCommitFiberUnmount === 'function') {
            onCommitFiberUnmount(fiber);
          }
        }
        /**
         * Forked from fbjs/warning:
         * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
         *
         * Only change is we use console.warn instead of console.error,
         * and do nothing when 'console' is not supported.
         * This really simplifies the code.
         * ---
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */


        var lowPriorityWarning = function lowPriorityWarning() {};

        {
          var printWarning = function printWarning(format) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });

            if (typeof console !== 'undefined') {
              console.warn(message);
            }

            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };

          lowPriorityWarning = function lowPriorityWarning(condition, format) {
            if (format === undefined) {
              throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
            }

            if (!condition) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
              }

              printWarning.apply(undefined, [format].concat(args));
            }
          };
        }
        var lowPriorityWarning$1 = lowPriorityWarning;
        var ReactStrictModeWarnings = {
          discardPendingWarnings: function discardPendingWarnings() {},
          flushPendingDeprecationWarnings: function flushPendingDeprecationWarnings() {},
          flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
          recordDeprecationWarnings: function recordDeprecationWarnings(fiber, instance) {},
          recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
          recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
          flushLegacyContextWarning: function flushLegacyContextWarning() {}
        };
        {
          var LIFECYCLE_SUGGESTIONS = {
            UNSAFE_componentWillMount: 'componentDidMount',
            UNSAFE_componentWillReceiveProps: 'static getDerivedStateFromProps',
            UNSAFE_componentWillUpdate: 'componentDidUpdate'
          };
          var pendingComponentWillMountWarnings = [];
          var pendingComponentWillReceivePropsWarnings = [];
          var pendingComponentWillUpdateWarnings = [];
          var pendingUnsafeLifecycleWarnings = new Map();
          var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

          var didWarnAboutDeprecatedLifecycles = new Set();
          var didWarnAboutUnsafeLifecycles = new Set();
          var didWarnAboutLegacyContext = new Set();

          var setToSortedString = function setToSortedString(set) {
            var array = [];
            set.forEach(function (value) {
              array.push(value);
            });
            return array.sort().join(', ');
          };

          ReactStrictModeWarnings.discardPendingWarnings = function () {
            pendingComponentWillMountWarnings = [];
            pendingComponentWillReceivePropsWarnings = [];
            pendingComponentWillUpdateWarnings = [];
            pendingUnsafeLifecycleWarnings = new Map();
            pendingLegacyContextWarning = new Map();
          };

          ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
            pendingUnsafeLifecycleWarnings.forEach(function (lifecycleWarningsMap, strictRoot) {
              var lifecyclesWarningMesages = [];
              Object.keys(lifecycleWarningsMap).forEach(function (lifecycle) {
                var lifecycleWarnings = lifecycleWarningsMap[lifecycle];

                if (lifecycleWarnings.length > 0) {
                  var componentNames = new Set();
                  lifecycleWarnings.forEach(function (fiber) {
                    componentNames.add(getComponentName(fiber) || 'Component');
                    didWarnAboutUnsafeLifecycles.add(fiber.type);
                  });
                  var formatted = lifecycle.replace('UNSAFE_', '');
                  var suggestion = LIFECYCLE_SUGGESTIONS[lifecycle];
                  var sortedComponentNames = setToSortedString(componentNames);
                  lifecyclesWarningMesages.push(formatted + ': Please update the following components to use ' + (suggestion + ' instead: ' + sortedComponentNames));
                }
              });

              if (lifecyclesWarningMesages.length > 0) {
                var strictRootComponentStack = getStackAddendumByWorkInProgressFiber(strictRoot);
                warning(false, 'Unsafe lifecycle methods were found within a strict-mode tree:%s' + '\n\n%s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-strict-mode-warnings', strictRootComponentStack, lifecyclesWarningMesages.join('\n\n'));
              }
            });
            pendingUnsafeLifecycleWarnings = new Map();
          };

          var findStrictRoot = function findStrictRoot(fiber) {
            var maybeStrictRoot = null;
            var node = fiber;

            while (node !== null) {
              if (node.mode & StrictMode) {
                maybeStrictRoot = node;
              }

              node = node.return;
            }

            return maybeStrictRoot;
          };

          ReactStrictModeWarnings.flushPendingDeprecationWarnings = function () {
            if (pendingComponentWillMountWarnings.length > 0) {
              var uniqueNames = new Set();
              pendingComponentWillMountWarnings.forEach(function (fiber) {
                uniqueNames.add(getComponentName(fiber) || 'Component');
                didWarnAboutDeprecatedLifecycles.add(fiber.type);
              });
              var sortedNames = setToSortedString(uniqueNames);
              lowPriorityWarning$1(false, 'componentWillMount is deprecated and will be removed in the next major version. ' + 'Use componentDidMount instead. As a temporary workaround, ' + 'you can rename to UNSAFE_componentWillMount.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-async-component-lifecycle-hooks', sortedNames);
              pendingComponentWillMountWarnings = [];
            }

            if (pendingComponentWillReceivePropsWarnings.length > 0) {
              var _uniqueNames = new Set();

              pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
                _uniqueNames.add(getComponentName(fiber) || 'Component');

                didWarnAboutDeprecatedLifecycles.add(fiber.type);
              });

              var _sortedNames = setToSortedString(_uniqueNames);

              lowPriorityWarning$1(false, 'componentWillReceiveProps is deprecated and will be removed in the next major version. ' + 'Use static getDerivedStateFromProps instead.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-async-component-lifecycle-hooks', _sortedNames);
              pendingComponentWillReceivePropsWarnings = [];
            }

            if (pendingComponentWillUpdateWarnings.length > 0) {
              var _uniqueNames2 = new Set();

              pendingComponentWillUpdateWarnings.forEach(function (fiber) {
                _uniqueNames2.add(getComponentName(fiber) || 'Component');

                didWarnAboutDeprecatedLifecycles.add(fiber.type);
              });

              var _sortedNames2 = setToSortedString(_uniqueNames2);

              lowPriorityWarning$1(false, 'componentWillUpdate is deprecated and will be removed in the next major version. ' + 'Use componentDidUpdate instead. As a temporary workaround, ' + 'you can rename to UNSAFE_componentWillUpdate.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-async-component-lifecycle-hooks', _sortedNames2);
              pendingComponentWillUpdateWarnings = [];
            }
          };

          ReactStrictModeWarnings.recordDeprecationWarnings = function (fiber, instance) {
            // Dedup strategy: Warn once per component.
            if (didWarnAboutDeprecatedLifecycles.has(fiber.type)) {
              return;
            } // Don't warn about react-lifecycles-compat polyfilled components.


            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              pendingComponentWillMountWarnings.push(fiber);
            }

            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              pendingComponentWillReceivePropsWarnings.push(fiber);
            }

            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              pendingComponentWillUpdateWarnings.push(fiber);
            }
          };

          ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
            var strictRoot = findStrictRoot(fiber);

            if (strictRoot === null) {
              warning(false, 'Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
              return;
            } // Dedup strategy: Warn once per component.
            // This is difficult to track any other way since component names
            // are often vague and are likely to collide between 3rd party libraries.
            // An expand property is probably okay to use here since it's DEV-only,
            // and will only be set in the event of serious warnings.


            if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
              return;
            }

            var warningsForRoot = void 0;

            if (!pendingUnsafeLifecycleWarnings.has(strictRoot)) {
              warningsForRoot = {
                UNSAFE_componentWillMount: [],
                UNSAFE_componentWillReceiveProps: [],
                UNSAFE_componentWillUpdate: []
              };
              pendingUnsafeLifecycleWarnings.set(strictRoot, warningsForRoot);
            } else {
              warningsForRoot = pendingUnsafeLifecycleWarnings.get(strictRoot);
            }

            var unsafeLifecycles = [];

            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true || typeof instance.UNSAFE_componentWillMount === 'function') {
              unsafeLifecycles.push('UNSAFE_componentWillMount');
            }

            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true || typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              unsafeLifecycles.push('UNSAFE_componentWillReceiveProps');
            }

            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true || typeof instance.UNSAFE_componentWillUpdate === 'function') {
              unsafeLifecycles.push('UNSAFE_componentWillUpdate');
            }

            if (unsafeLifecycles.length > 0) {
              unsafeLifecycles.forEach(function (lifecycle) {
                warningsForRoot[lifecycle].push(fiber);
              });
            }
          };

          ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
            var strictRoot = findStrictRoot(fiber);

            if (strictRoot === null) {
              warning(false, 'Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
              return;
            } // Dedup strategy: Warn once per component.


            if (didWarnAboutLegacyContext.has(fiber.type)) {
              return;
            }

            var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

            if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
              if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
              }

              warningsForRoot.push(fiber);
            }
          };

          ReactStrictModeWarnings.flushLegacyContextWarning = function () {
            pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
              var uniqueNames = new Set();
              fiberArray.forEach(function (fiber) {
                uniqueNames.add(getComponentName(fiber) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
              });
              var sortedNames = setToSortedString(uniqueNames);
              var strictRootComponentStack = getStackAddendumByWorkInProgressFiber(strictRoot);
              warning(false, 'Legacy context API has been detected within a strict-mode tree: %s' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-strict-mode-warnings', strictRootComponentStack, sortedNames);
            });
          };
        } // This lets us hook into Fiber to debug what it's doing.
        // See https://github.com/facebook/react/pull/8033.
        // This is not part of the public API, not even for React DevTools.
        // You may only inject a debugTool if you work on React Fiber itself.

        var ReactFiberInstrumentation = {
          debugTool: null
        };
        var ReactFiberInstrumentation_1 = ReactFiberInstrumentation; // TODO: Offscreen updates

        function markPendingPriorityLevel(root, expirationTime) {
          if (enableSuspense) {
            // Update the latest and earliest pending times
            var earliestPendingTime = root.earliestPendingTime;

            if (earliestPendingTime === NoWork) {
              // No other pending updates.
              root.earliestPendingTime = root.latestPendingTime = expirationTime;
            } else {
              if (earliestPendingTime > expirationTime) {
                // This is the earliest pending update.
                root.earliestPendingTime = expirationTime;
              } else {
                var latestPendingTime = root.latestPendingTime;

                if (latestPendingTime < expirationTime) {
                  // This is the latest pending update
                  root.latestPendingTime = expirationTime;
                }
              }
            }
          }
        }

        function markCommittedPriorityLevels(root, currentTime, earliestRemainingTime) {
          if (enableSuspense) {
            if (earliestRemainingTime === NoWork) {
              // Fast path. There's no remaining work. Clear everything.
              root.earliestPendingTime = NoWork;
              root.latestPendingTime = NoWork;
              root.earliestSuspendedTime = NoWork;
              root.latestSuspendedTime = NoWork;
              root.latestPingedTime = NoWork;
              return;
            } // Let's see if the previous latest known pending level was just flushed.


            var latestPendingTime = root.latestPendingTime;

            if (latestPendingTime !== NoWork) {
              if (latestPendingTime < earliestRemainingTime) {
                // We've flushed all the known pending levels.
                root.earliestPendingTime = root.latestPendingTime = NoWork;
              } else {
                var earliestPendingTime = root.earliestPendingTime;

                if (earliestPendingTime < earliestRemainingTime) {
                  // We've flushed the earliest known pending level. Set this to the
                  // latest pending time.
                  root.earliestPendingTime = root.latestPendingTime;
                }
              }
            } // Now let's handle the earliest remaining level in the whole tree. We need to
            // decide whether to treat it as a pending level or as suspended. Check
            // it falls within the range of known suspended levels.


            var earliestSuspendedTime = root.earliestSuspendedTime;

            if (earliestSuspendedTime === NoWork) {
              // There's no suspended work. Treat the earliest remaining level as a
              // pending level.
              markPendingPriorityLevel(root, earliestRemainingTime);
              return;
            }

            var latestSuspendedTime = root.latestSuspendedTime;

            if (earliestRemainingTime > latestSuspendedTime) {
              // The earliest remaining level is later than all the suspended work. That
              // means we've flushed all the suspended work.
              root.earliestSuspendedTime = NoWork;
              root.latestSuspendedTime = NoWork;
              root.latestPingedTime = NoWork; // There's no suspended work. Treat the earliest remaining level as a
              // pending level.

              markPendingPriorityLevel(root, earliestRemainingTime);
              return;
            }

            if (earliestRemainingTime < earliestSuspendedTime) {
              // The earliest remaining time is earlier than all the suspended work.
              // Treat it as a pending update.
              markPendingPriorityLevel(root, earliestRemainingTime);
              return;
            } // The earliest remaining time falls within the range of known suspended
            // levels. We should treat this as suspended work.

          }
        }

        function markSuspendedPriorityLevel(root, suspendedTime) {
          if (enableSuspense) {
            // First, check the known pending levels and update them if needed.
            var earliestPendingTime = root.earliestPendingTime;
            var latestPendingTime = root.latestPendingTime;

            if (earliestPendingTime === suspendedTime) {
              if (latestPendingTime === suspendedTime) {
                // Both known pending levels were suspended. Clear them.
                root.earliestPendingTime = root.latestPendingTime = NoWork;
              } else {
                // The earliest pending level was suspended. Clear by setting it to the
                // latest pending level.
                root.earliestPendingTime = latestPendingTime;
              }
            } else if (latestPendingTime === suspendedTime) {
              // The latest pending level was suspended. Clear by setting it to the
              // latest pending level.
              root.latestPendingTime = earliestPendingTime;
            } // Next, if we're working on the lowest known suspended level, clear the ping.
            // TODO: What if a promise suspends and pings before the root completes?


            var latestSuspendedTime = root.latestSuspendedTime;

            if (latestSuspendedTime === suspendedTime) {
              root.latestPingedTime = NoWork;
            } // Finally, update the known suspended levels.


            var earliestSuspendedTime = root.earliestSuspendedTime;

            if (earliestSuspendedTime === NoWork) {
              // No other suspended levels.
              root.earliestSuspendedTime = root.latestSuspendedTime = suspendedTime;
            } else {
              if (earliestSuspendedTime > suspendedTime) {
                // This is the earliest suspended level.
                root.earliestSuspendedTime = suspendedTime;
              } else if (latestSuspendedTime < suspendedTime) {
                // This is the latest suspended level
                root.latestSuspendedTime = suspendedTime;
              }
            }
          }
        }

        function markPingedPriorityLevel(root, pingedTime) {
          if (enableSuspense) {
            var latestSuspendedTime = root.latestSuspendedTime;

            if (latestSuspendedTime !== NoWork && latestSuspendedTime <= pingedTime) {
              var latestPingedTime = root.latestPingedTime;

              if (latestPingedTime === NoWork || latestPingedTime < pingedTime) {
                root.latestPingedTime = pingedTime;
              }
            }
          }
        }

        function findNextPendingPriorityLevel(root) {
          if (enableSuspense) {
            var earliestSuspendedTime = root.earliestSuspendedTime;
            var earliestPendingTime = root.earliestPendingTime;

            if (earliestSuspendedTime === NoWork) {
              // Fast path. There's no suspended work.
              return earliestPendingTime;
            } // First, check if there's known pending work.


            if (earliestPendingTime !== NoWork) {
              return earliestPendingTime;
            } // Finally, if a suspended level was pinged, work on that. Otherwise there's
            // nothing to work on.


            return root.latestPingedTime;
          } else {
            return root.current.expirationTime;
          }
        } // UpdateQueue is a linked list of prioritized updates.
        //
        // Like fibers, update queues come in pairs: a current queue, which represents
        // the visible state of the screen, and a work-in-progress queue, which is
        // can be mutated and processed asynchronously before it is committed — a form
        // of double buffering. If a work-in-progress render is discarded before
        // finishing, we create a new work-in-progress by cloning the current queue.
        //
        // Both queues share a persistent, singly-linked list structure. To schedule an
        // update, we append it to the end of both queues. Each queue maintains a
        // pointer to first update in the persistent list that hasn't been processed.
        // The work-in-progress pointer always has a position equal to or greater than
        // the current queue, since we always work on that one. The current queue's
        // pointer is only updated during the commit phase, when we swap in the
        // work-in-progress.
        //
        // For example:
        //
        //   Current pointer:           A - B - C - D - E - F
        //   Work-in-progress pointer:              D - E - F
        //                                          ^
        //                                          The work-in-progress queue has
        //                                          processed more updates than current.
        //
        // The reason we append to both queues is because otherwise we might drop
        // updates without ever processing them. For example, if we only add updates to
        // the work-in-progress queue, some updates could be lost whenever a work-in
        // -progress render restarts by cloning from current. Similarly, if we only add
        // updates to the current queue, the updates will be lost whenever an already
        // in-progress queue commits and swaps with the current queue. However, by
        // adding to both queues, we guarantee that the update will be part of the next
        // work-in-progress. (And because the work-in-progress queue becomes the
        // current queue once it commits, there's no danger of applying the same
        // update twice.)
        //
        // Prioritization
        // --------------
        //
        // Updates are not sorted by priority, but by insertion; new updates are always
        // appended to the end of the list.
        //
        // The priority is still important, though. When processing the update queue
        // during the render phase, only the updates with sufficient priority are
        // included in the result. If we skip an update because it has insufficient
        // priority, it remains in the queue to be processed later, during a lower
        // priority render. Crucially, all updates subsequent to a skipped update also
        // remain in the queue *regardless of their priority*. That means high priority
        // updates are sometimes processed twice, at two separate priorities. We also
        // keep track of a base state, that represents the state before the first
        // update in the queue is applied.
        //
        // For example:
        //
        //   Given a base state of '', and the following queue of updates
        //
        //     A1 - B2 - C1 - D2
        //
        //   where the number indicates the priority, and the update is applied to the
        //   previous state by appending a letter, React will process these updates as
        //   two separate renders, one per distinct priority level:
        //
        //   First render, at priority 1:
        //     Base state: ''
        //     Updates: [A1, C1]
        //     Result state: 'AC'
        //
        //   Second render, at priority 2:
        //     Base state: 'A'            <-  The base state does not include C1,
        //                                    because B2 was skipped.
        //     Updates: [B2, C1, D2]      <-  C1 was rebased on top of B2
        //     Result state: 'ABCD'
        //
        // Because we process updates in insertion order, and rebase high priority
        // updates when preceding updates are skipped, the final result is deterministic
        // regardless of priority. Intermediate state may vary according to system
        // resources, but the final state is always the same.


        var UpdateState = 0;
        var ReplaceState = 1;
        var ForceUpdate = 2;
        var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
        // It should only be read right after calling `processUpdateQueue`, via
        // `checkHasForceUpdateAfterProcessing`.

        var hasForceUpdate = false;
        var didWarnUpdateInsideUpdate = void 0;
        var currentlyProcessingQueue = void 0;
        var resetCurrentlyProcessingQueue = void 0;
        {
          didWarnUpdateInsideUpdate = false;
          currentlyProcessingQueue = null;

          resetCurrentlyProcessingQueue = function resetCurrentlyProcessingQueue() {
            currentlyProcessingQueue = null;
          };
        }

        function createUpdateQueue(baseState) {
          var queue = {
            expirationTime: NoWork,
            baseState: baseState,
            firstUpdate: null,
            lastUpdate: null,
            firstCapturedUpdate: null,
            lastCapturedUpdate: null,
            firstEffect: null,
            lastEffect: null,
            firstCapturedEffect: null,
            lastCapturedEffect: null
          };
          return queue;
        }

        function cloneUpdateQueue(currentQueue) {
          var queue = {
            expirationTime: currentQueue.expirationTime,
            baseState: currentQueue.baseState,
            firstUpdate: currentQueue.firstUpdate,
            lastUpdate: currentQueue.lastUpdate,
            // TODO: With resuming, if we bail out and resuse the child tree, we should
            // keep these effects.
            firstCapturedUpdate: null,
            lastCapturedUpdate: null,
            firstEffect: null,
            lastEffect: null,
            firstCapturedEffect: null,
            lastCapturedEffect: null
          };
          return queue;
        }

        function createUpdate(expirationTime) {
          return {
            expirationTime: expirationTime,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null,
            nextEffect: null
          };
        }

        function appendUpdateToQueue(queue, update, expirationTime) {
          // Append the update to the end of the list.
          if (queue.lastUpdate === null) {
            // Queue is empty
            queue.firstUpdate = queue.lastUpdate = update;
          } else {
            queue.lastUpdate.next = update;
            queue.lastUpdate = update;
          }

          if (queue.expirationTime === NoWork || queue.expirationTime > expirationTime) {
            // The incoming update has the earliest expiration of any update in the
            // queue. Update the queue's expiration time.
            queue.expirationTime = expirationTime;
          }
        }

        function enqueueUpdate(fiber, update, expirationTime) {
          // Update queues are created lazily.
          var alternate = fiber.alternate;
          var queue1 = void 0;
          var queue2 = void 0;

          if (alternate === null) {
            // There's only one fiber.
            queue1 = fiber.updateQueue;
            queue2 = null;

            if (queue1 === null) {
              queue1 = fiber.updateQueue = createUpdateQueue(fiber.memoizedState);
            }
          } else {
            // There are two owners.
            queue1 = fiber.updateQueue;
            queue2 = alternate.updateQueue;

            if (queue1 === null) {
              if (queue2 === null) {
                // Neither fiber has an update queue. Create new ones.
                queue1 = fiber.updateQueue = createUpdateQueue(fiber.memoizedState);
                queue2 = alternate.updateQueue = createUpdateQueue(alternate.memoizedState);
              } else {
                // Only one fiber has an update queue. Clone to create a new one.
                queue1 = fiber.updateQueue = cloneUpdateQueue(queue2);
              }
            } else {
              if (queue2 === null) {
                // Only one fiber has an update queue. Clone to create a new one.
                queue2 = alternate.updateQueue = cloneUpdateQueue(queue1);
              } else {// Both owners have an update queue.
              }
            }
          }

          if (queue2 === null || queue1 === queue2) {
            // There's only a single queue.
            appendUpdateToQueue(queue1, update, expirationTime);
          } else {
            // There are two queues. We need to append the update to both queues,
            // while accounting for the persistent structure of the list — we don't
            // want the same update to be added multiple times.
            if (queue1.lastUpdate === null || queue2.lastUpdate === null) {
              // One of the queues is not empty. We must add the update to both queues.
              appendUpdateToQueue(queue1, update, expirationTime);
              appendUpdateToQueue(queue2, update, expirationTime);
            } else {
              // Both queues are non-empty. The last update is the same in both lists,
              // because of structural sharing. So, only append to one of the lists.
              appendUpdateToQueue(queue1, update, expirationTime); // But we still need to update the `lastUpdate` pointer of queue2.

              queue2.lastUpdate = update;
            }
          }

          {
            if (fiber.tag === ClassComponent && (currentlyProcessingQueue === queue1 || queue2 !== null && currentlyProcessingQueue === queue2) && !didWarnUpdateInsideUpdate) {
              warning(false, 'An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
              didWarnUpdateInsideUpdate = true;
            }
          }
        }

        function enqueueCapturedUpdate(workInProgress, update, renderExpirationTime) {
          // Captured updates go into a separate list, and only on the work-in-
          // progress queue.
          var workInProgressQueue = workInProgress.updateQueue;

          if (workInProgressQueue === null) {
            workInProgressQueue = workInProgress.updateQueue = createUpdateQueue(workInProgress.memoizedState);
          } else {
            // TODO: I put this here rather than createWorkInProgress so that we don't
            // clone the queue unnecessarily. There's probably a better way to
            // structure this.
            workInProgressQueue = ensureWorkInProgressQueueIsAClone(workInProgress, workInProgressQueue);
          } // Append the update to the end of the list.


          if (workInProgressQueue.lastCapturedUpdate === null) {
            // This is the first render phase update
            workInProgressQueue.firstCapturedUpdate = workInProgressQueue.lastCapturedUpdate = update;
          } else {
            workInProgressQueue.lastCapturedUpdate.next = update;
            workInProgressQueue.lastCapturedUpdate = update;
          }

          if (workInProgressQueue.expirationTime === NoWork || workInProgressQueue.expirationTime > renderExpirationTime) {
            // The incoming update has the earliest expiration of any update in the
            // queue. Update the queue's expiration time.
            workInProgressQueue.expirationTime = renderExpirationTime;
          }
        }

        function ensureWorkInProgressQueueIsAClone(workInProgress, queue) {
          var current = workInProgress.alternate;

          if (current !== null) {
            // If the work-in-progress queue is equal to the current queue,
            // we need to clone it first.
            if (queue === current.updateQueue) {
              queue = workInProgress.updateQueue = cloneUpdateQueue(queue);
            }
          }

          return queue;
        }

        function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
          switch (update.tag) {
            case ReplaceState:
              {
                var _payload = update.payload;

                if (typeof _payload === 'function') {
                  // Updater function
                  {
                    if (debugRenderPhaseSideEffects || debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) {
                      _payload.call(instance, prevState, nextProps);
                    }
                  }
                  return _payload.call(instance, prevState, nextProps);
                } // State object


                return _payload;
              }

            case CaptureUpdate:
              {
                workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
              }
            // Intentional fallthrough

            case UpdateState:
              {
                var _payload2 = update.payload;
                var partialState = void 0;

                if (typeof _payload2 === 'function') {
                  // Updater function
                  {
                    if (debugRenderPhaseSideEffects || debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) {
                      _payload2.call(instance, prevState, nextProps);
                    }
                  }
                  partialState = _payload2.call(instance, prevState, nextProps);
                } else {
                  // Partial state object
                  partialState = _payload2;
                }

                if (partialState === null || partialState === undefined) {
                  // Null and undefined are treated as no-ops.
                  return prevState;
                } // Merge the partial state and the previous state.


                return _assign({}, prevState, partialState);
              }

            case ForceUpdate:
              {
                hasForceUpdate = true;
                return prevState;
              }
          }

          return prevState;
        }

        function processUpdateQueue(workInProgress, queue, props, instance, renderExpirationTime) {
          hasForceUpdate = false;

          if (queue.expirationTime === NoWork || queue.expirationTime > renderExpirationTime) {
            // Insufficient priority. Bailout.
            return;
          }

          queue = ensureWorkInProgressQueueIsAClone(workInProgress, queue);
          {
            currentlyProcessingQueue = queue;
          } // These values may change as we process the queue.

          var newBaseState = queue.baseState;
          var newFirstUpdate = null;
          var newExpirationTime = NoWork; // Iterate through the list of updates to compute the result.

          var update = queue.firstUpdate;
          var resultState = newBaseState;

          while (update !== null) {
            var updateExpirationTime = update.expirationTime;

            if (updateExpirationTime > renderExpirationTime) {
              // This update does not have sufficient priority. Skip it.
              if (newFirstUpdate === null) {
                // This is the first skipped update. It will be the first update in
                // the new list.
                newFirstUpdate = update; // Since this is the first update that was skipped, the current result
                // is the new base state.

                newBaseState = resultState;
              } // Since this update will remain in the list, update the remaining
              // expiration time.


              if (newExpirationTime === NoWork || newExpirationTime > updateExpirationTime) {
                newExpirationTime = updateExpirationTime;
              }
            } else {
              // This update does have sufficient priority. Process it and compute
              // a new result.
              resultState = getStateFromUpdate(workInProgress, queue, update, resultState, props, instance);
              var _callback = update.callback;

              if (_callback !== null) {
                workInProgress.effectTag |= Callback; // Set this to null, in case it was mutated during an aborted render.

                update.nextEffect = null;

                if (queue.lastEffect === null) {
                  queue.firstEffect = queue.lastEffect = update;
                } else {
                  queue.lastEffect.nextEffect = update;
                  queue.lastEffect = update;
                }
              }
            } // Continue to the next update.


            update = update.next;
          } // Separately, iterate though the list of captured updates.


          var newFirstCapturedUpdate = null;
          update = queue.firstCapturedUpdate;

          while (update !== null) {
            var _updateExpirationTime = update.expirationTime;

            if (_updateExpirationTime > renderExpirationTime) {
              // This update does not have sufficient priority. Skip it.
              if (newFirstCapturedUpdate === null) {
                // This is the first skipped captured update. It will be the first
                // update in the new list.
                newFirstCapturedUpdate = update; // If this is the first update that was skipped, the current result is
                // the new base state.

                if (newFirstUpdate === null) {
                  newBaseState = resultState;
                }
              } // Since this update will remain in the list, update the remaining
              // expiration time.


              if (newExpirationTime === NoWork || newExpirationTime > _updateExpirationTime) {
                newExpirationTime = _updateExpirationTime;
              }
            } else {
              // This update does have sufficient priority. Process it and compute
              // a new result.
              resultState = getStateFromUpdate(workInProgress, queue, update, resultState, props, instance);
              var _callback2 = update.callback;

              if (_callback2 !== null) {
                workInProgress.effectTag |= Callback; // Set this to null, in case it was mutated during an aborted render.

                update.nextEffect = null;

                if (queue.lastCapturedEffect === null) {
                  queue.firstCapturedEffect = queue.lastCapturedEffect = update;
                } else {
                  queue.lastCapturedEffect.nextEffect = update;
                  queue.lastCapturedEffect = update;
                }
              }
            }

            update = update.next;
          }

          if (newFirstUpdate === null) {
            queue.lastUpdate = null;
          }

          if (newFirstCapturedUpdate === null) {
            queue.lastCapturedUpdate = null;
          } else {
            workInProgress.effectTag |= Callback;
          }

          if (newFirstUpdate === null && newFirstCapturedUpdate === null) {
            // We processed every update, without skipping. That means the new base
            // state is the same as the result state.
            newBaseState = resultState;
          }

          queue.baseState = newBaseState;
          queue.firstUpdate = newFirstUpdate;
          queue.firstCapturedUpdate = newFirstCapturedUpdate;
          queue.expirationTime = newExpirationTime;
          workInProgress.memoizedState = resultState;
          {
            currentlyProcessingQueue = null;
          }
        }

        function callCallback(callback, context) {
          !(typeof callback === 'function') ? invariant(false, 'Invalid argument passed as callback. Expected a function. Instead received: %s', callback) : void 0;
          callback.call(context);
        }

        function resetHasForceUpdateBeforeProcessing() {
          hasForceUpdate = false;
        }

        function checkHasForceUpdateAfterProcessing() {
          return hasForceUpdate;
        }

        function commitUpdateQueue(finishedWork, finishedQueue, instance, renderExpirationTime) {
          // If the finished render included captured updates, and there are still
          // lower priority updates left over, we need to keep the captured updates
          // in the queue so that they are rebased and not dropped once we process the
          // queue again at the lower priority.
          if (finishedQueue.firstCapturedUpdate !== null) {
            // Join the captured update list to the end of the normal list.
            if (finishedQueue.lastUpdate !== null) {
              finishedQueue.lastUpdate.next = finishedQueue.firstCapturedUpdate;
              finishedQueue.lastUpdate = finishedQueue.lastCapturedUpdate;
            } // Clear the list of captured updates.


            finishedQueue.firstCapturedUpdate = finishedQueue.lastCapturedUpdate = null;
          } // Commit the effects


          var effect = finishedQueue.firstEffect;
          finishedQueue.firstEffect = finishedQueue.lastEffect = null;

          while (effect !== null) {
            var _callback3 = effect.callback;

            if (_callback3 !== null) {
              effect.callback = null;
              callCallback(_callback3, instance);
            }

            effect = effect.nextEffect;
          }

          effect = finishedQueue.firstCapturedEffect;
          finishedQueue.firstCapturedEffect = finishedQueue.lastCapturedEffect = null;

          while (effect !== null) {
            var _callback4 = effect.callback;

            if (_callback4 !== null) {
              effect.callback = null;
              callCallback(_callback4, instance);
            }

            effect = effect.nextEffect;
          }
        }

        function createCapturedValue(value, source) {
          // If the value is an error, call this function immediately after it is thrown
          // so the stack is accurate.
          return {
            value: value,
            source: source,
            stack: getStackAddendumByWorkInProgressFiber(source)
          };
        }

        var providerCursor = createCursor(null);
        var valueCursor = createCursor(null);
        var changedBitsCursor = createCursor(0);
        var rendererSigil = void 0;
        {
          // Use this to detect multiple renderers using the same context
          rendererSigil = {};
        }

        function pushProvider(providerFiber) {
          var context = providerFiber.type._context;

          if (isPrimaryRenderer) {
            push(changedBitsCursor, context._changedBits, providerFiber);
            push(valueCursor, context._currentValue, providerFiber);
            push(providerCursor, providerFiber, providerFiber);
            context._currentValue = providerFiber.pendingProps.value;
            context._changedBits = providerFiber.stateNode;
            {
              !(context._currentRenderer === undefined || context._currentRenderer === null || context._currentRenderer === rendererSigil) ? warning(false, 'Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.') : void 0;
              context._currentRenderer = rendererSigil;
            }
          } else {
            push(changedBitsCursor, context._changedBits2, providerFiber);
            push(valueCursor, context._currentValue2, providerFiber);
            push(providerCursor, providerFiber, providerFiber);
            context._currentValue2 = providerFiber.pendingProps.value;
            context._changedBits2 = providerFiber.stateNode;
            {
              !(context._currentRenderer2 === undefined || context._currentRenderer2 === null || context._currentRenderer2 === rendererSigil) ? warning(false, 'Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.') : void 0;
              context._currentRenderer2 = rendererSigil;
            }
          }
        }

        function popProvider(providerFiber) {
          var changedBits = changedBitsCursor.current;
          var currentValue = valueCursor.current;
          pop(providerCursor, providerFiber);
          pop(valueCursor, providerFiber);
          pop(changedBitsCursor, providerFiber);
          var context = providerFiber.type._context;

          if (isPrimaryRenderer) {
            context._currentValue = currentValue;
            context._changedBits = changedBits;
          } else {
            context._currentValue2 = currentValue;
            context._changedBits2 = changedBits;
          }
        }

        function getContextCurrentValue(context) {
          return isPrimaryRenderer ? context._currentValue : context._currentValue2;
        }

        function getContextChangedBits(context) {
          return isPrimaryRenderer ? context._changedBits : context._changedBits2;
        }

        var NO_CONTEXT = {};
        var contextStackCursor$1 = createCursor(NO_CONTEXT);
        var contextFiberStackCursor = createCursor(NO_CONTEXT);
        var rootInstanceStackCursor = createCursor(NO_CONTEXT);

        function requiredContext(c) {
          !(c !== NO_CONTEXT) ? invariant(false, 'Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          return c;
        }

        function getRootHostContainer() {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          return rootInstance;
        }

        function pushHostContainer(fiber, nextRootInstance) {
          // Push current root instance onto the stack;
          // This allows us to reset root when portals are popped.
          push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
          // This enables us to pop only Fibers that provide unique contexts.

          push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
          // However, we can't just call getRootHostContext() and push it because
          // we'd have a different number of entries on the stack depending on
          // whether getRootHostContext() throws somewhere in renderer code or not.
          // So we push an empty value first. This lets us safely unwind on errors.

          push(contextStackCursor$1, NO_CONTEXT, fiber);
          var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

          pop(contextStackCursor$1, fiber);
          push(contextStackCursor$1, nextRootContext, fiber);
        }

        function popHostContainer(fiber) {
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
          pop(rootInstanceStackCursor, fiber);
        }

        function getHostContext() {
          var context = requiredContext(contextStackCursor$1.current);
          return context;
        }

        function pushHostContext(fiber) {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          var context = requiredContext(contextStackCursor$1.current);
          var nextContext = getChildHostContext(context, fiber.type, rootInstance); // Don't push this Fiber's context unless it's unique.

          if (context === nextContext) {
            return;
          } // Track the context and the Fiber that provided it.
          // This enables us to pop only Fibers that provide unique contexts.


          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, nextContext, fiber);
        }

        function popHostContext(fiber) {
          // Do not pop unless this Fiber provided the current context.
          // pushHostContext() only pushes Fibers that provide unique contexts.
          if (contextFiberStackCursor.current !== fiber) {
            return;
          }

          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
        }

        var commitTime = 0;

        function getCommitTime() {
          return commitTime;
        }

        function recordCommitTime() {
          if (!enableProfilerTimer) {
            return;
          }

          commitTime = now();
        }
        /**
         * The "actual" render time is total time required to render the descendants of a Profiler component.
         * This time is stored as a stack, since Profilers can be nested.
         * This time is started during the "begin" phase and stopped during the "complete" phase.
         * It is paused (and accumulated) in the event of an interruption or an aborted render.
         */


        var fiberStack$1 = void 0;
        {
          fiberStack$1 = [];
        }
        var timerPausedAt = 0;
        var totalElapsedPauseTime = 0;

        function checkActualRenderTimeStackEmpty() {
          if (!enableProfilerTimer) {
            return;
          }

          {
            !(fiberStack$1.length === 0) ? warning(false, 'Expected an empty stack. Something was not reset properly.') : void 0;
          }
        }

        function markActualRenderTimeStarted(fiber) {
          if (!enableProfilerTimer) {
            return;
          }

          {
            fiberStack$1.push(fiber);
          }
          var stateNode = fiber.stateNode;
          stateNode.elapsedPauseTimeAtStart = totalElapsedPauseTime;
          stateNode.startTime = now();
        }

        function pauseActualRenderTimerIfRunning() {
          if (!enableProfilerTimer) {
            return;
          }

          if (timerPausedAt === 0) {
            timerPausedAt = now();
          }
        }

        function recordElapsedActualRenderTime(fiber) {
          if (!enableProfilerTimer) {
            return;
          }

          {
            !(fiber === fiberStack$1.pop()) ? warning(false, 'Unexpected Fiber popped.') : void 0;
          }
          var stateNode = fiber.stateNode;
          stateNode.duration += now() - (totalElapsedPauseTime - stateNode.elapsedPauseTimeAtStart) - stateNode.startTime;
        }

        function resetActualRenderTimer() {
          if (!enableProfilerTimer) {
            return;
          }

          totalElapsedPauseTime = 0;
        }

        function resumeActualRenderTimerIfPaused() {
          if (!enableProfilerTimer) {
            return;
          }

          if (timerPausedAt > 0) {
            totalElapsedPauseTime += now() - timerPausedAt;
            timerPausedAt = 0;
          }
        }
        /**
         * The "base" render time is the duration of the “begin” phase of work for a particular fiber.
         * This time is measured and stored on each fiber.
         * The time for all sibling fibers are accumulated and stored on their parent during the "complete" phase.
         * If a fiber bails out (sCU false) then its "base" timer is cancelled and the fiber is not updated.
         */


        var baseStartTime = -1;

        function recordElapsedBaseRenderTimeIfRunning(fiber) {
          if (!enableProfilerTimer) {
            return;
          }

          if (baseStartTime !== -1) {
            fiber.selfBaseTime = now() - baseStartTime;
          }
        }

        function startBaseRenderTimer() {
          if (!enableProfilerTimer) {
            return;
          }

          {
            if (baseStartTime !== -1) {
              warning(false, 'Cannot start base timer that is already running. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
            }
          }
          baseStartTime = now();
        }

        function stopBaseRenderTimerIfRunning() {
          if (!enableProfilerTimer) {
            return;
          }

          baseStartTime = -1;
        }

        var fakeInternalInstance = {};
        var isArray = Array.isArray;
        var didWarnAboutStateAssignmentForComponent = void 0;
        var didWarnAboutUninitializedState = void 0;
        var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = void 0;
        var didWarnAboutLegacyLifecyclesAndDerivedState = void 0;
        var didWarnAboutUndefinedDerivedState = void 0;
        var warnOnUndefinedDerivedState = void 0;
        var warnOnInvalidCallback$1 = void 0;
        {
          didWarnAboutStateAssignmentForComponent = new Set();
          didWarnAboutUninitializedState = new Set();
          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
          didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
          didWarnAboutUndefinedDerivedState = new Set();
          var didWarnOnInvalidCallback = new Set();

          warnOnInvalidCallback$1 = function warnOnInvalidCallback$1(callback, callerName) {
            if (callback === null || typeof callback === 'function') {
              return;
            }

            var key = callerName + '_' + callback;

            if (!didWarnOnInvalidCallback.has(key)) {
              didWarnOnInvalidCallback.add(key);
              warning(false, '%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
            }
          };

          warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(workInProgress, partialState) {
            if (partialState === undefined) {
              var componentName = getComponentName(workInProgress) || 'Component';

              if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                warning(false, '%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
              }
            }
          }; // This is so gross but it's at least non-critical and can be removed if
          // it causes problems. This is meant to give a nicer error message for
          // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
          // ...)) which otherwise throws a "_processChildContext is not a function"
          // exception.


          Object.defineProperty(fakeInternalInstance, '_processChildContext', {
            enumerable: false,
            value: function value() {
              invariant(false, '_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn\'t supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).');
            }
          });
          Object.freeze(fakeInternalInstance);
        }

        function applyDerivedStateFromProps(workInProgress, getDerivedStateFromProps, nextProps) {
          var prevState = workInProgress.memoizedState;
          {
            if (debugRenderPhaseSideEffects || debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) {
              // Invoke the function an extra time to help detect side-effects.
              getDerivedStateFromProps(nextProps, prevState);
            }
          }
          var partialState = getDerivedStateFromProps(nextProps, prevState);
          {
            warnOnUndefinedDerivedState(workInProgress, partialState);
          } // Merge the partial state and the previous state.

          var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
          workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
          // base state.

          var updateQueue = workInProgress.updateQueue;

          if (updateQueue !== null && updateQueue.expirationTime === NoWork) {
            updateQueue.baseState = memoizedState;
          }
        }

        var classComponentUpdater = {
          isMounted: isMounted,
          enqueueSetState: function enqueueSetState(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = recalculateCurrentTime();
            var expirationTime = computeExpirationForFiber(currentTime, fiber);
            var update = createUpdate(expirationTime);
            update.payload = payload;

            if (callback !== undefined && callback !== null) {
              {
                warnOnInvalidCallback$1(callback, 'setState');
              }
              update.callback = callback;
            }

            enqueueUpdate(fiber, update, expirationTime);
            scheduleWork$1(fiber, expirationTime);
          },
          enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
            var fiber = get(inst);
            var currentTime = recalculateCurrentTime();
            var expirationTime = computeExpirationForFiber(currentTime, fiber);
            var update = createUpdate(expirationTime);
            update.tag = ReplaceState;
            update.payload = payload;

            if (callback !== undefined && callback !== null) {
              {
                warnOnInvalidCallback$1(callback, 'replaceState');
              }
              update.callback = callback;
            }

            enqueueUpdate(fiber, update, expirationTime);
            scheduleWork$1(fiber, expirationTime);
          },
          enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
            var fiber = get(inst);
            var currentTime = recalculateCurrentTime();
            var expirationTime = computeExpirationForFiber(currentTime, fiber);
            var update = createUpdate(expirationTime);
            update.tag = ForceUpdate;

            if (callback !== undefined && callback !== null) {
              {
                warnOnInvalidCallback$1(callback, 'forceUpdate');
              }
              update.callback = callback;
            }

            enqueueUpdate(fiber, update, expirationTime);
            scheduleWork$1(fiber, expirationTime);
          }
        };

        function checkShouldComponentUpdate(workInProgress, oldProps, newProps, oldState, newState, newContext) {
          var instance = workInProgress.stateNode;
          var ctor = workInProgress.type;

          if (typeof instance.shouldComponentUpdate === 'function') {
            startPhaseTimer(workInProgress, 'shouldComponentUpdate');
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, newContext);
            stopPhaseTimer();
            {
              !(shouldUpdate !== undefined) ? warning(false, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(workInProgress) || 'Component') : void 0;
            }
            return shouldUpdate;
          }

          if (ctor.prototype && ctor.prototype.isPureReactComponent) {
            return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
          }

          return true;
        }

        function checkClassInstance(workInProgress) {
          var instance = workInProgress.stateNode;
          var type = workInProgress.type;
          {
            var name = getComponentName(workInProgress) || 'Component';
            var renderPresent = instance.render;

            if (!renderPresent) {
              if (type.prototype && typeof type.prototype.render === 'function') {
                warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
              } else {
                warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
              }
            }

            var noGetInitialStateOnES6 = !instance.getInitialState || instance.getInitialState.isReactClassApproved || instance.state;
            !noGetInitialStateOnES6 ? warning(false, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name) : void 0;
            var noGetDefaultPropsOnES6 = !instance.getDefaultProps || instance.getDefaultProps.isReactClassApproved;
            !noGetDefaultPropsOnES6 ? warning(false, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name) : void 0;
            var noInstancePropTypes = !instance.propTypes;
            !noInstancePropTypes ? warning(false, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name) : void 0;
            var noInstanceContextTypes = !instance.contextTypes;
            !noInstanceContextTypes ? warning(false, 'contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name) : void 0;
            var noComponentShouldUpdate = typeof instance.componentShouldUpdate !== 'function';
            !noComponentShouldUpdate ? warning(false, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name) : void 0;

            if (type.prototype && type.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
              warning(false, '%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(workInProgress) || 'A pure component');
            }

            var noComponentDidUnmount = typeof instance.componentDidUnmount !== 'function';
            !noComponentDidUnmount ? warning(false, '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name) : void 0;
            var noComponentDidReceiveProps = typeof instance.componentDidReceiveProps !== 'function';
            !noComponentDidReceiveProps ? warning(false, '%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name) : void 0;
            var noComponentWillRecieveProps = typeof instance.componentWillRecieveProps !== 'function';
            !noComponentWillRecieveProps ? warning(false, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name) : void 0;
            var noUnsafeComponentWillRecieveProps = typeof instance.UNSAFE_componentWillRecieveProps !== 'function';
            !noUnsafeComponentWillRecieveProps ? warning(false, '%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name) : void 0;
            var hasMutatedProps = instance.props !== workInProgress.pendingProps;
            !(instance.props === undefined || !hasMutatedProps) ? warning(false, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name) : void 0;
            var noInstanceDefaultProps = !instance.defaultProps;
            !noInstanceDefaultProps ? warning(false, 'Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name) : void 0;

            if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(type)) {
              didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(type);
              warning(false, '%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(workInProgress));
            }

            var noInstanceGetDerivedStateFromProps = typeof instance.getDerivedStateFromProps !== 'function';
            !noInstanceGetDerivedStateFromProps ? warning(false, '%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name) : void 0;
            var noInstanceGetDerivedStateFromCatch = typeof instance.getDerivedStateFromCatch !== 'function';
            !noInstanceGetDerivedStateFromCatch ? warning(false, '%s: getDerivedStateFromCatch() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name) : void 0;
            var noStaticGetSnapshotBeforeUpdate = typeof type.getSnapshotBeforeUpdate !== 'function';
            !noStaticGetSnapshotBeforeUpdate ? warning(false, '%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name) : void 0;
            var _state = instance.state;

            if (_state && (typeof _state !== 'object' || isArray(_state))) {
              warning(false, '%s.state: must be set to an object or null', name);
            }

            if (typeof instance.getChildContext === 'function') {
              !(typeof type.childContextTypes === 'object') ? warning(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name) : void 0;
            }
          }
        }

        function adoptClassInstance(workInProgress, instance) {
          instance.updater = classComponentUpdater;
          workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

          set(instance, workInProgress);
          {
            instance._reactInternalInstance = fakeInternalInstance;
          }
        }

        function constructClassInstance(workInProgress, props, renderExpirationTime) {
          var ctor = workInProgress.type;
          var unmaskedContext = getUnmaskedContext(workInProgress);
          var needsContext = isContextConsumer(workInProgress);
          var context = needsContext ? getMaskedContext(workInProgress, unmaskedContext) : emptyObject; // Instantiate twice to help detect side-effects.

          {
            if (debugRenderPhaseSideEffects || debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) {
              new ctor(props, context); // eslint-disable-line no-new
            }
          }
          var instance = new ctor(props, context);
          var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
          adoptClassInstance(workInProgress, instance);
          {
            if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
              var componentName = getComponentName(workInProgress) || 'Component';

              if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                warning(false, '%s: Did not properly initialize state during construction. ' + 'Expected state to be an object, but it was %s.', componentName, instance.state === null ? 'null' : 'undefined');
              }
            } // If new component APIs are defined, "unsafe" lifecycles won't be called.
            // Warn about these lifecycles if they are present.
            // Don't warn about react-lifecycles-compat polyfilled methods though.


            if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
              var foundWillMountName = null;
              var foundWillReceivePropsName = null;
              var foundWillUpdateName = null;

              if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                foundWillMountName = 'componentWillMount';
              } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
                foundWillMountName = 'UNSAFE_componentWillMount';
              }

              if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                foundWillReceivePropsName = 'componentWillReceiveProps';
              } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
                foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
              }

              if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                foundWillUpdateName = 'componentWillUpdate';
              } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
                foundWillUpdateName = 'UNSAFE_componentWillUpdate';
              }

              if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(workInProgress) || 'Component';

                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                  didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                  warning(false, 'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks', _componentName, newApiName, foundWillMountName !== null ? '\n  ' + foundWillMountName : '', foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '', foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '');
                }
              }
            }
          } // Cache unmasked context so we can avoid recreating masked context unless necessary.
          // ReactFiberContext usually updates this cache but can't for newly-created instances.

          if (needsContext) {
            cacheContext(workInProgress, unmaskedContext, context);
          }

          return instance;
        }

        function callComponentWillMount(workInProgress, instance) {
          startPhaseTimer(workInProgress, 'componentWillMount');
          var oldState = instance.state;

          if (typeof instance.componentWillMount === 'function') {
            instance.componentWillMount();
          }

          if (typeof instance.UNSAFE_componentWillMount === 'function') {
            instance.UNSAFE_componentWillMount();
          }

          stopPhaseTimer();

          if (oldState !== instance.state) {
            {
              warning(false, '%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress) || 'Component');
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }

        function callComponentWillReceiveProps(workInProgress, instance, newProps, newContext) {
          var oldState = instance.state;
          startPhaseTimer(workInProgress, 'componentWillReceiveProps');

          if (typeof instance.componentWillReceiveProps === 'function') {
            instance.componentWillReceiveProps(newProps, newContext);
          }

          if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            instance.UNSAFE_componentWillReceiveProps(newProps, newContext);
          }

          stopPhaseTimer();

          if (instance.state !== oldState) {
            {
              var componentName = getComponentName(workInProgress) || 'Component';

              if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                warning(false, '%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
              }
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        } // Invokes the mount life-cycles on a previously never rendered instance.


        function mountClassInstance(workInProgress, renderExpirationTime) {
          var ctor = workInProgress.type;
          {
            checkClassInstance(workInProgress);
          }
          var instance = workInProgress.stateNode;
          var props = workInProgress.pendingProps;
          var unmaskedContext = getUnmaskedContext(workInProgress);
          instance.props = props;
          instance.state = workInProgress.memoizedState;
          instance.refs = emptyObject;
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
          {
            if (workInProgress.mode & StrictMode) {
              ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
            }

            if (warnAboutDeprecatedLifecycles) {
              ReactStrictModeWarnings.recordDeprecationWarnings(workInProgress, instance);
            }
          }
          var updateQueue = workInProgress.updateQueue;

          if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, props, instance, renderExpirationTime);
            instance.state = workInProgress.memoizedState;
          }

          var getDerivedStateFromProps = workInProgress.type.getDerivedStateFromProps;

          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, getDerivedStateFromProps, props);
            instance.state = workInProgress.memoizedState;
          } // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.


          if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.

            updateQueue = workInProgress.updateQueue;

            if (updateQueue !== null) {
              processUpdateQueue(workInProgress, updateQueue, props, instance, renderExpirationTime);
              instance.state = workInProgress.memoizedState;
            }
          }

          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
        }

        function resumeMountClassInstance(workInProgress, renderExpirationTime) {
          var ctor = workInProgress.type;
          var instance = workInProgress.stateNode;
          var oldProps = workInProgress.memoizedProps;
          var newProps = workInProgress.pendingProps;
          instance.props = oldProps;
          var oldContext = instance.context;
          var newUnmaskedContext = getUnmaskedContext(workInProgress);
          var newContext = getMaskedContext(workInProgress, newUnmaskedContext);
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
          // ever the previously attempted to render - not the "current". However,
          // during componentDidUpdate we pass the "current" props.
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.

          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== newContext) {
              callComponentWillReceiveProps(workInProgress, instance, newProps, newContext);
            }
          }

          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress.memoizedState;
          var newState = instance.state = oldState;
          var updateQueue = workInProgress.updateQueue;

          if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
            newState = workInProgress.memoizedState;
          }

          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
              workInProgress.effectTag |= Update;
            }

            return false;
          }

          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
          }

          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, oldProps, newProps, oldState, newState, newContext);

          if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
              startPhaseTimer(workInProgress, 'componentWillMount');

              if (typeof instance.componentWillMount === 'function') {
                instance.componentWillMount();
              }

              if (typeof instance.UNSAFE_componentWillMount === 'function') {
                instance.UNSAFE_componentWillMount();
              }

              stopPhaseTimer();
            }

            if (typeof instance.componentDidMount === 'function') {
              workInProgress.effectTag |= Update;
            }
          } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
              workInProgress.effectTag |= Update;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.


            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
          } // Update the existing instance's state, props, and context pointers even
          // if shouldComponentUpdate returns false.


          instance.props = newProps;
          instance.state = newState;
          instance.context = newContext;
          return shouldUpdate;
        } // Invokes the update life-cycles and returns false if it shouldn't rerender.


        function updateClassInstance(current, workInProgress, renderExpirationTime) {
          var ctor = workInProgress.type;
          var instance = workInProgress.stateNode;
          var oldProps = workInProgress.memoizedProps;
          var newProps = workInProgress.pendingProps;
          instance.props = oldProps;
          var oldContext = instance.context;
          var newUnmaskedContext = getUnmaskedContext(workInProgress);
          var newContext = getMaskedContext(workInProgress, newUnmaskedContext);
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
          // ever the previously attempted to render - not the "current". However,
          // during componentDidUpdate we pass the "current" props.
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.

          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== newContext) {
              callComponentWillReceiveProps(workInProgress, instance, newProps, newContext);
            }
          }

          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress.memoizedState;
          var newState = instance.state = oldState;
          var updateQueue = workInProgress.updateQueue;

          if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
            newState = workInProgress.memoizedState;
          }

          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
              if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.effectTag |= Update;
              }
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
              if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.effectTag |= Snapshot;
              }
            }

            return false;
          }

          if (typeof getDerivedStateFromProps === 'function') {
            if (fireGetDerivedStateFromPropsOnStateUpdates || oldProps !== newProps) {
              applyDerivedStateFromProps(workInProgress, getDerivedStateFromProps, newProps);
              newState = workInProgress.memoizedState;
            }
          }

          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, oldProps, newProps, oldState, newState, newContext);

          if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
              startPhaseTimer(workInProgress, 'componentWillUpdate');

              if (typeof instance.componentWillUpdate === 'function') {
                instance.componentWillUpdate(newProps, newState, newContext);
              }

              if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
                instance.UNSAFE_componentWillUpdate(newProps, newState, newContext);
              }

              stopPhaseTimer();
            }

            if (typeof instance.componentDidUpdate === 'function') {
              workInProgress.effectTag |= Update;
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
              workInProgress.effectTag |= Snapshot;
            }
          } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
              if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.effectTag |= Update;
              }
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
              if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.effectTag |= Snapshot;
              }
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.


            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
          } // Update the existing instance's state, props, and context pointers even
          // if shouldComponentUpdate returns false.


          instance.props = newProps;
          instance.state = newState;
          instance.context = newContext;
          return shouldUpdate;
        }

        var getCurrentFiberStackAddendum$7 = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var didWarnAboutMaps = void 0;
        var didWarnAboutStringRefInStrictMode = void 0;
        var ownerHasKeyUseWarning = void 0;
        var ownerHasFunctionTypeWarning = void 0;

        var warnForMissingKey = function warnForMissingKey(child) {};

        {
          didWarnAboutMaps = false;
          didWarnAboutStringRefInStrictMode = {};
          /**
           * Warn if there's no key explicitly set on dynamic arrays of children or
           * object keys are not valid. This allows us to keep track of children between
           * updates.
           */

          ownerHasKeyUseWarning = {};
          ownerHasFunctionTypeWarning = {};

          warnForMissingKey = function warnForMissingKey(child) {
            if (child === null || typeof child !== 'object') {
              return;
            }

            if (!child._store || child._store.validated || child.key != null) {
              return;
            }

            !(typeof child._store === 'object') ? invariant(false, 'React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.') : void 0;
            child._store.validated = true;
            var currentComponentErrorInfo = 'Each child in an array or iterator should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.' + (getCurrentFiberStackAddendum$7() || '');

            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }

            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            warning(false, 'Each child in an array or iterator should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.%s', getCurrentFiberStackAddendum$7());
          };
        }
        var isArray$1 = Array.isArray;

        function coerceRef(returnFiber, current, element) {
          var mixedRef = element.ref;

          if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            {
              if (returnFiber.mode & StrictMode) {
                var componentName = getComponentName(returnFiber) || 'Component';

                if (!didWarnAboutStringRefInStrictMode[componentName]) {
                  warning(false, 'A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using createRef() instead.' + '\n%s' + '\n\nLearn more about using refs safely here:' + '\nhttps://fb.me/react-strict-mode-string-ref', mixedRef, getStackAddendumByWorkInProgressFiber(returnFiber));
                  didWarnAboutStringRefInStrictMode[componentName] = true;
                }
              }
            }

            if (element._owner) {
              var owner = element._owner;
              var inst = void 0;

              if (owner) {
                var ownerFiber = owner;
                !(ownerFiber.tag === ClassComponent) ? invariant(false, 'Stateless function components cannot have refs.') : void 0;
                inst = ownerFiber.stateNode;
              }

              !inst ? invariant(false, 'Missing owner for string ref %s. This error is likely caused by a bug in React. Please file an issue.', mixedRef) : void 0;
              var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

              if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
                return current.ref;
              }

              var ref = function ref(value) {
                var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;

                if (value === null) {
                  delete refs[stringRef];
                } else {
                  refs[stringRef] = value;
                }
              };

              ref._stringRef = stringRef;
              return ref;
            } else {
              !(typeof mixedRef === 'string') ? invariant(false, 'Expected ref to be a function or a string.') : void 0;
              !element._owner ? invariant(false, 'Element ref was specified as a string (%s) but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a functional component\n2. You may be adding a ref to a component that was not created inside a component\'s render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.', mixedRef) : void 0;
            }
          }

          return mixedRef;
        }

        function throwOnInvalidObjectType(returnFiber, newChild) {
          if (returnFiber.type !== 'textarea') {
            var addendum = '';
            {
              addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + (getCurrentFiberStackAddendum$7() || '');
            }
            invariant(false, 'Objects are not valid as a React child (found: %s).%s', Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild, addendum);
          }
        }

        function warnOnFunctionType() {
          var currentComponentErrorInfo = 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.' + (getCurrentFiberStackAddendum$7() || '');

          if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
          warning(false, 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.%s', getCurrentFiberStackAddendum$7() || '');
        } // This wrapper function exists because I expect to clone the code in each path
        // to be able to optimize each path individually by branching early. This needs
        // a compiler or we can do it manually. Helpers that don't need this branching
        // live outside of this function.


        function ChildReconciler(shouldTrackSideEffects) {
          function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) {
              // Noop.
              return;
            } // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.


            var last = returnFiber.lastEffect;

            if (last !== null) {
              last.nextEffect = childToDelete;
              returnFiber.lastEffect = childToDelete;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            }

            childToDelete.nextEffect = null;
            childToDelete.effectTag = Deletion;
          }

          function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) {
              // Noop.
              return null;
            } // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.


            var childToDelete = currentFirstChild;

            while (childToDelete !== null) {
              deleteChild(returnFiber, childToDelete);
              childToDelete = childToDelete.sibling;
            }

            return null;
          }

          function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            var existingChildren = new Map();
            var existingChild = currentFirstChild;

            while (existingChild !== null) {
              if (existingChild.key !== null) {
                existingChildren.set(existingChild.key, existingChild);
              } else {
                existingChildren.set(existingChild.index, existingChild);
              }

              existingChild = existingChild.sibling;
            }

            return existingChildren;
          }

          function useFiber(fiber, pendingProps, expirationTime) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps, expirationTime);
            clone.index = 0;
            clone.sibling = null;
            return clone;
          }

          function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;

            if (!shouldTrackSideEffects) {
              // Noop.
              return lastPlacedIndex;
            }

            var current = newFiber.alternate;

            if (current !== null) {
              var oldIndex = current.index;

              if (oldIndex < lastPlacedIndex) {
                // This is a move.
                newFiber.effectTag = Placement;
                return lastPlacedIndex;
              } else {
                // This item can stay in place.
                return oldIndex;
              }
            } else {
              // This is an insertion.
              newFiber.effectTag = Placement;
              return lastPlacedIndex;
            }
          }

          function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) {
              newFiber.effectTag = Placement;
            }

            return newFiber;
          }

          function updateTextNode(returnFiber, current, textContent, expirationTime) {
            if (current === null || current.tag !== HostText) {
              // Insert
              var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
              created.return = returnFiber;
              return created;
            } else {
              // Update
              var existing = useFiber(current, textContent, expirationTime);
              existing.return = returnFiber;
              return existing;
            }
          }

          function updateElement(returnFiber, current, element, expirationTime) {
            if (current !== null && current.type === element.type) {
              // Move based on index
              var existing = useFiber(current, element.props, expirationTime);
              existing.ref = coerceRef(returnFiber, current, element);
              existing.return = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            } else {
              // Insert
              var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
              created.ref = coerceRef(returnFiber, current, element);
              created.return = returnFiber;
              return created;
            }
          }

          function updatePortal(returnFiber, current, portal, expirationTime) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
              // Insert
              var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
              created.return = returnFiber;
              return created;
            } else {
              // Update
              var existing = useFiber(current, portal.children || [], expirationTime);
              existing.return = returnFiber;
              return existing;
            }
          }

          function updateFragment(returnFiber, current, fragment, expirationTime, key) {
            if (current === null || current.tag !== Fragment) {
              // Insert
              var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
              created.return = returnFiber;
              return created;
            } else {
              // Update
              var existing = useFiber(current, fragment, expirationTime);
              existing.return = returnFiber;
              return existing;
            }
          }

          function createChild(returnFiber, newChild, expirationTime) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
              // Text nodes don't have keys. If the previous node is implicitly keyed
              // we can continue to replace it without aborting even if it is not a text
              // node.
              var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
              created.return = returnFiber;
              return created;
            }

            if (typeof newChild === 'object' && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  {
                    var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);

                    _created.ref = coerceRef(returnFiber, null, newChild);
                    _created.return = returnFiber;
                    return _created;
                  }

                case REACT_PORTAL_TYPE:
                  {
                    var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);

                    _created2.return = returnFiber;
                    return _created2;
                  }
              }

              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);

                _created3.return = returnFiber;
                return _created3;
              }

              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType();
              }
            }
            return null;
          }

          function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;

            if (typeof newChild === 'string' || typeof newChild === 'number') {
              // Text nodes don't have keys. If the previous node is implicitly keyed
              // we can continue to replace it without aborting even if it is not a text
              // node.
              if (key !== null) {
                return null;
              }

              return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
            }

            if (typeof newChild === 'object' && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  {
                    if (newChild.key === key) {
                      if (newChild.type === REACT_FRAGMENT_TYPE) {
                        return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                      }

                      return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                    } else {
                      return null;
                    }
                  }

                case REACT_PORTAL_TYPE:
                  {
                    if (newChild.key === key) {
                      return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                    } else {
                      return null;
                    }
                  }
              }

              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                if (key !== null) {
                  return null;
                }

                return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
              }

              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType();
              }
            }
            return null;
          }

          function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
              // Text nodes don't have keys, so we neither have to check the old nor
              // new node for the key. If both are text nodes, they match.
              var matchedFiber = existingChildren.get(newIdx) || null;
              return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
            }

            if (typeof newChild === 'object' && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  {
                    var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                    }

                    return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                  }

                case REACT_PORTAL_TYPE:
                  {
                    var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                    return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                  }
              }

              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _matchedFiber3 = existingChildren.get(newIdx) || null;

                return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
              }

              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType();
              }
            }
            return null;
          }
          /**
           * Warns if there is a duplicate or missing key
           */


          function warnOnInvalidKey(child, knownKeys) {
            {
              if (typeof child !== 'object' || child === null) {
                return knownKeys;
              }

              switch (child.$$typeof) {
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                  warnForMissingKey(child);
                  var key = child.key;

                  if (typeof key !== 'string') {
                    break;
                  }

                  if (knownKeys === null) {
                    knownKeys = new Set();
                    knownKeys.add(key);
                    break;
                  }

                  if (!knownKeys.has(key)) {
                    knownKeys.add(key);
                    break;
                  }

                  warning(false, 'Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.%s', key, getCurrentFiberStackAddendum$7());
                  break;

                default:
                  break;
              }
            }
            return knownKeys;
          }

          function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
            // This algorithm can't optimize by searching from boths ends since we
            // don't have backpointers on fibers. I'm trying to see how far we can get
            // with that model. If it ends up not being worth the tradeoffs, we can
            // add it later.
            // Even with a two ended optimization, we'd want to optimize for the case
            // where there are few changes and brute force the comparison instead of
            // going for the Map. It'd like to explore hitting that path first in
            // forward-only mode and only go for the Map once we notice that we need
            // lots of look ahead. This doesn't handle reversal as well as two ended
            // search but that's unusual. Besides, for the two ended optimization to
            // work on Iterables, we'd need to copy the whole set.
            // In this first iteration, we'll just live with hitting the bad case
            // (adding everything to a Map) in for every insert/move.
            // If you change this code, also update reconcileChildrenIterator() which
            // uses the same algorithm.
            {
              // First, validate keys.
              var knownKeys = null;

              for (var i = 0; i < newChildren.length; i++) {
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys);
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;

            for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }

              var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);

              if (newFiber === null) {
                // TODO: This breaks on empty slots like null children. That's
                // unfortunate because it triggers the slow path all the time. We need
                // a better way to communicate whether this was a miss or null,
                // boolean, undefined, etc.
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }

                break;
              }

              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  // We matched the slot, but we didn't reuse the existing fiber, so we
                  // need to delete the existing child.
                  deleteChild(returnFiber, oldFiber);
                }
              }

              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
              } else {
                // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
              }

              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }

            if (newIdx === newChildren.length) {
              // We've reached the end of the new children. We can delete the rest.
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }

            if (oldFiber === null) {
              // If we don't have any more existing children we can choose a fast path
              // since the rest will all be insertions.
              for (; newIdx < newChildren.length; newIdx++) {
                var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);

                if (!_newFiber) {
                  continue;
                }

                lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  // TODO: Move out of the loop. This only happens for the first run.
                  resultingFirstChild = _newFiber;
                } else {
                  previousNewFiber.sibling = _newFiber;
                }

                previousNewFiber = _newFiber;
              }

              return resultingFirstChild;
            } // Add all children to a key map for quick lookups.


            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);

              if (_newFiber2) {
                if (shouldTrackSideEffects) {
                  if (_newFiber2.alternate !== null) {
                    // The new fiber is a work in progress, but if there exists a
                    // current, that means that we reused the fiber. We need to delete
                    // it from the child list so that we don't add it to the deletion
                    // list.
                    existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                  }
                }

                lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber2;
                } else {
                  previousNewFiber.sibling = _newFiber2;
                }

                previousNewFiber = _newFiber2;
              }
            }

            if (shouldTrackSideEffects) {
              // Any existing children that weren't consumed above were deleted. We need
              // to add them to the deletion list.
              existingChildren.forEach(function (child) {
                return deleteChild(returnFiber, child);
              });
            }

            return resultingFirstChild;
          }

          function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            !(typeof iteratorFn === 'function') ? invariant(false, 'An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.') : void 0;
            {
              // Warn about using Maps as children
              if (newChildrenIterable.entries === iteratorFn) {
                !didWarnAboutMaps ? warning(false, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.%s', getCurrentFiberStackAddendum$7()) : void 0;
                didWarnAboutMaps = true;
              } // First, validate keys.
              // We'll get a different iterator later for the main pass.


              var _newChildren = iteratorFn.call(newChildrenIterable);

              if (_newChildren) {
                var knownKeys = null;

                var _step = _newChildren.next();

                for (; !_step.done; _step = _newChildren.next()) {
                  var child = _step.value;
                  knownKeys = warnOnInvalidKey(child, knownKeys);
                }
              }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            !(newChildren != null) ? invariant(false, 'An iterable object provided no iterator.') : void 0;
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();

            for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }

              var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);

              if (newFiber === null) {
                // TODO: This breaks on empty slots like null children. That's
                // unfortunate because it triggers the slow path all the time. We need
                // a better way to communicate whether this was a miss or null,
                // boolean, undefined, etc.
                if (!oldFiber) {
                  oldFiber = nextOldFiber;
                }

                break;
              }

              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  // We matched the slot, but we didn't reuse the existing fiber, so we
                  // need to delete the existing child.
                  deleteChild(returnFiber, oldFiber);
                }
              }

              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
              } else {
                // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
              }

              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }

            if (step.done) {
              // We've reached the end of the new children. We can delete the rest.
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }

            if (oldFiber === null) {
              // If we don't have any more existing children we can choose a fast path
              // since the rest will all be insertions.
              for (; !step.done; newIdx++, step = newChildren.next()) {
                var _newFiber3 = createChild(returnFiber, step.value, expirationTime);

                if (_newFiber3 === null) {
                  continue;
                }

                lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  // TODO: Move out of the loop. This only happens for the first run.
                  resultingFirstChild = _newFiber3;
                } else {
                  previousNewFiber.sibling = _newFiber3;
                }

                previousNewFiber = _newFiber3;
              }

              return resultingFirstChild;
            } // Add all children to a key map for quick lookups.


            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);

              if (_newFiber4 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber4.alternate !== null) {
                    // The new fiber is a work in progress, but if there exists a
                    // current, that means that we reused the fiber. We need to delete
                    // it from the child list so that we don't add it to the deletion
                    // list.
                    existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                  }
                }

                lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber4;
                } else {
                  previousNewFiber.sibling = _newFiber4;
                }

                previousNewFiber = _newFiber4;
              }
            }

            if (shouldTrackSideEffects) {
              // Any existing children that weren't consumed above were deleted. We need
              // to add them to the deletion list.
              existingChildren.forEach(function (child) {
                return deleteChild(returnFiber, child);
              });
            }

            return resultingFirstChild;
          }

          function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
              // We already have an existing node so let's just update it and delete
              // the rest.
              deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
              var existing = useFiber(currentFirstChild, textContent, expirationTime);
              existing.return = returnFiber;
              return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.


            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }

          function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
            var key = element.key;
            var child = currentFirstChild;

            while (child !== null) {
              // TODO: If key === null and child.key === null, then this only applies to
              // the first item in the list.
              if (child.key === key) {
                if (child.tag === Fragment ? element.type === REACT_FRAGMENT_TYPE : child.type === element.type) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, element.type === REACT_FRAGMENT_TYPE ? element.props.children : element.props, expirationTime);
                  existing.ref = coerceRef(returnFiber, child, element);
                  existing.return = returnFiber;
                  {
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                  }
                  return existing;
                } else {
                  deleteRemainingChildren(returnFiber, child);
                  break;
                }
              } else {
                deleteChild(returnFiber, child);
              }

              child = child.sibling;
            }

            if (element.type === REACT_FRAGMENT_TYPE) {
              var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
              created.return = returnFiber;
              return created;
            } else {
              var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);

              _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
              _created4.return = returnFiber;
              return _created4;
            }
          }

          function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
            var key = portal.key;
            var child = currentFirstChild;

            while (child !== null) {
              // TODO: If key === null and child.key === null, then this only applies to
              // the first item in the list.
              if (child.key === key) {
                if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, portal.children || [], expirationTime);
                  existing.return = returnFiber;
                  return existing;
                } else {
                  deleteRemainingChildren(returnFiber, child);
                  break;
                }
              } else {
                deleteChild(returnFiber, child);
              }

              child = child.sibling;
            }

            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } // This API will tag the children with the side-effect of the reconciliation
          // itself. They will be added to the side-effect list as we pass through the
          // children and the parent.


          function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            if (typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null) {
              newChild = newChild.props.children;
            } // Handle object types


            var isObject = typeof newChild === 'object' && newChild !== null;

            if (isObject) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));

                case REACT_PORTAL_TYPE:
                  return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
              }
            }

            if (typeof newChild === 'string' || typeof newChild === 'number') {
              return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
            }

            if (isArray$1(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
            }

            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
            }

            if (isObject) {
              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType();
              }
            }

            if (typeof newChild === 'undefined') {
              // If the new child is undefined, and the return fiber is a composite
              // component, throw an error. If Fiber return types are disabled,
              // we already threw above.
              switch (returnFiber.tag) {
                case ClassComponent:
                  {
                    {
                      var instance = returnFiber.stateNode;

                      if (instance.render._isMockFunction) {
                        // We allow auto-mocks to proceed as if they're returning null.
                        break;
                      }
                    }
                  }
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough

                case FunctionalComponent:
                  {
                    var Component = returnFiber.type;
                    invariant(false, '%s(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.', Component.displayName || Component.name || 'Component');
                  }
              }
            } // Remaining cases are all treated as empty.


            return deleteRemainingChildren(returnFiber, currentFirstChild);
          }

          return reconcileChildFibers;
        }

        var reconcileChildFibers = ChildReconciler(true);
        var mountChildFibers = ChildReconciler(false);

        function cloneChildFibers(current, workInProgress) {
          !(current === null || workInProgress.child === current.child) ? invariant(false, 'Resuming work not yet implemented.') : void 0;

          if (workInProgress.child === null) {
            return;
          }

          var currentChild = workInProgress.child;
          var newChild = createWorkInProgress(currentChild, currentChild.pendingProps, currentChild.expirationTime);
          workInProgress.child = newChild;
          newChild.return = workInProgress;

          while (currentChild.sibling !== null) {
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps, currentChild.expirationTime);
            newChild.return = workInProgress;
          }

          newChild.sibling = null;
        } // The deepest Fiber on the stack involved in a hydration context.
        // This may have been an insertion or a hydration.


        var hydrationParentFiber = null;
        var nextHydratableInstance = null;
        var isHydrating = false;

        function enterHydrationState(fiber) {
          if (!supportsHydration) {
            return false;
          }

          var parentInstance = fiber.stateNode.containerInfo;
          nextHydratableInstance = getFirstHydratableChild(parentInstance);
          hydrationParentFiber = fiber;
          isHydrating = true;
          return true;
        }

        function deleteHydratableInstance(returnFiber, instance) {
          {
            switch (returnFiber.tag) {
              case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;

              case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
            }
          }
          var childToDelete = createFiberFromHostInstanceForDeletion();
          childToDelete.stateNode = instance;
          childToDelete.return = returnFiber;
          childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
          // these children are not part of the reconciliation list of children.
          // Even if we abort and rereconcile the children, that will try to hydrate
          // again and the nodes are still in the host tree so these will be
          // recreated.

          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
        }

        function insertNonHydratedInstance(returnFiber, fiber) {
          fiber.effectTag |= Placement;
          {
            switch (returnFiber.tag) {
              case HostRoot:
                {
                  var parentContainer = returnFiber.stateNode.containerInfo;

                  switch (fiber.tag) {
                    case HostComponent:
                      var type = fiber.type;
                      var props = fiber.pendingProps;
                      didNotFindHydratableContainerInstance(parentContainer, type, props);
                      break;

                    case HostText:
                      var text = fiber.pendingProps;
                      didNotFindHydratableContainerTextInstance(parentContainer, text);
                      break;
                  }

                  break;
                }

              case HostComponent:
                {
                  var parentType = returnFiber.type;
                  var parentProps = returnFiber.memoizedProps;
                  var parentInstance = returnFiber.stateNode;

                  switch (fiber.tag) {
                    case HostComponent:
                      var _type = fiber.type;
                      var _props = fiber.pendingProps;
                      didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props);
                      break;

                    case HostText:
                      var _text = fiber.pendingProps;
                      didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                      break;
                  }

                  break;
                }

              default:
                return;
            }
          }
        }

        function tryHydrate(fiber, nextInstance) {
          switch (fiber.tag) {
            case HostComponent:
              {
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type, props);

                if (instance !== null) {
                  fiber.stateNode = instance;
                  return true;
                }

                return false;
              }

            case HostText:
              {
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);

                if (textInstance !== null) {
                  fiber.stateNode = textInstance;
                  return true;
                }

                return false;
              }

            default:
              return false;
          }
        }

        function tryToClaimNextHydratableInstance(fiber) {
          if (!isHydrating) {
            return;
          }

          var nextInstance = nextHydratableInstance;

          if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }

          var firstAttemptedInstance = nextInstance;

          if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);

            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
              // Nothing to hydrate. Make it an insertion.
              insertNonHydratedInstance(hydrationParentFiber, fiber);
              isHydrating = false;
              hydrationParentFiber = fiber;
              return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.


            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
          }

          hydrationParentFiber = fiber;
          nextHydratableInstance = getFirstHydratableChild(nextInstance);
        }

        function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
          if (!supportsHydration) {
            invariant(false, 'Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.');
          }

          var instance = fiber.stateNode;
          var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

          fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
          // is a new ref we mark this as an update.

          if (updatePayload !== null) {
            return true;
          }

          return false;
        }

        function prepareToHydrateHostTextInstance(fiber) {
          if (!supportsHydration) {
            invariant(false, 'Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.');
          }

          var textInstance = fiber.stateNode;
          var textContent = fiber.memoizedProps;
          var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
          {
            if (shouldUpdate) {
              // We assume that prepareToHydrateHostTextInstance is called in a context where the
              // hydration parent is the parent host component of this host text.
              var returnFiber = hydrationParentFiber;

              if (returnFiber !== null) {
                switch (returnFiber.tag) {
                  case HostRoot:
                    {
                      var parentContainer = returnFiber.stateNode.containerInfo;
                      didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                      break;
                    }

                  case HostComponent:
                    {
                      var parentType = returnFiber.type;
                      var parentProps = returnFiber.memoizedProps;
                      var parentInstance = returnFiber.stateNode;
                      didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                      break;
                    }
                }
              }
            }
          }
          return shouldUpdate;
        }

        function popToNextHostParent(fiber) {
          var parent = fiber.return;

          while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot) {
            parent = parent.return;
          }

          hydrationParentFiber = parent;
        }

        function popHydrationState(fiber) {
          if (!supportsHydration) {
            return false;
          }

          if (fiber !== hydrationParentFiber) {
            // We're deeper than the current hydration context, inside an inserted
            // tree.
            return false;
          }

          if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
          }

          var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
          // We only do this deeper than head and body since they tend to have random
          // other nodes in them. We also ignore components with pure text content in
          // side of them.
          // TODO: Better heuristic.

          if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;

            while (nextInstance) {
              deleteHydratableInstance(fiber, nextInstance);
              nextInstance = getNextHydratableSibling(nextInstance);
            }
          }

          popToNextHostParent(fiber);
          nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
          return true;
        }

        function resetHydrationState() {
          if (!supportsHydration) {
            return;
          }

          hydrationParentFiber = null;
          nextHydratableInstance = null;
          isHydrating = false;
        }

        var getCurrentFiberStackAddendum$6 = ReactDebugCurrentFiber.getCurrentFiberStackAddendum;
        var didWarnAboutBadClass = void 0;
        var didWarnAboutGetDerivedStateOnFunctionalComponent = void 0;
        var didWarnAboutStatelessRefs = void 0;
        {
          didWarnAboutBadClass = {};
          didWarnAboutGetDerivedStateOnFunctionalComponent = {};
          didWarnAboutStatelessRefs = {};
        } // TODO: Remove this and use reconcileChildrenAtExpirationTime directly.

        function reconcileChildren(current, workInProgress, nextChildren) {
          reconcileChildrenAtExpirationTime(current, workInProgress, nextChildren, workInProgress.expirationTime);
        }

        function reconcileChildrenAtExpirationTime(current, workInProgress, nextChildren, renderExpirationTime) {
          if (current === null) {
            // If this is a fresh new component that hasn't been rendered yet, we
            // won't update its child set by applying minimal side-effects. Instead,
            // we will add them all to the child before it gets rendered. That means
            // we can optimize this reconciliation pass by not tracking side-effects.
            workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
          } else {
            // If the current child is the same as the work in progress, it means that
            // we haven't yet started any work on these children. Therefore, we use
            // the clone algorithm to create a copy of all the current children.
            // If we had any progressed work already, that is invalid at this point so
            // let's throw it out.
            workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderExpirationTime);
          }
        }

        function updateForwardRef(current, workInProgress) {
          var render = workInProgress.type.render;
          var nextProps = workInProgress.pendingProps;
          var ref = workInProgress.ref;

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (workInProgress.memoizedProps === nextProps) {
            var currentRef = current !== null ? current.ref : null;

            if (ref === currentRef) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress);
            }
          }

          var nextChildren = void 0;
          {
            ReactCurrentOwner.current = workInProgress;
            ReactDebugCurrentFiber.setCurrentPhase('render');
            nextChildren = render(nextProps, ref);
            ReactDebugCurrentFiber.setCurrentPhase(null);
          }
          reconcileChildren(current, workInProgress, nextChildren);
          memoizeProps(workInProgress, nextProps);
          return workInProgress.child;
        }

        function updateFragment(current, workInProgress) {
          var nextChildren = workInProgress.pendingProps;

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (workInProgress.memoizedProps === nextChildren) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          reconcileChildren(current, workInProgress, nextChildren);
          memoizeProps(workInProgress, nextChildren);
          return workInProgress.child;
        }

        function updateMode(current, workInProgress) {
          var nextChildren = workInProgress.pendingProps.children;

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (nextChildren === null || workInProgress.memoizedProps === nextChildren) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          reconcileChildren(current, workInProgress, nextChildren);
          memoizeProps(workInProgress, nextChildren);
          return workInProgress.child;
        }

        function updateProfiler(current, workInProgress) {
          var nextProps = workInProgress.pendingProps;

          if (enableProfilerTimer) {
            // Start render timer here and push start time onto queue
            markActualRenderTimeStarted(workInProgress); // Let the "complete" phase know to stop the timer,
            // And the scheduler to record the measured time.

            workInProgress.effectTag |= Update;
          }

          if (workInProgress.memoizedProps === nextProps) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          var nextChildren = nextProps.children;
          reconcileChildren(current, workInProgress, nextChildren);
          memoizeProps(workInProgress, nextProps);
          return workInProgress.child;
        }

        function markRef(current, workInProgress) {
          var ref = workInProgress.ref;

          if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.effectTag |= Ref;
          }
        }

        function updateFunctionalComponent(current, workInProgress) {
          var fn = workInProgress.type;
          var nextProps = workInProgress.pendingProps;

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else {
            if (workInProgress.memoizedProps === nextProps) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress);
            } // TODO: consider bringing fn.shouldComponentUpdate() back.
            // It used to be here.

          }

          var unmaskedContext = getUnmaskedContext(workInProgress);
          var context = getMaskedContext(workInProgress, unmaskedContext);
          var nextChildren = void 0;
          {
            ReactCurrentOwner.current = workInProgress;
            ReactDebugCurrentFiber.setCurrentPhase('render');
            nextChildren = fn(nextProps, context);
            ReactDebugCurrentFiber.setCurrentPhase(null);
          } // React DevTools reads this flag.

          workInProgress.effectTag |= PerformedWork;
          reconcileChildren(current, workInProgress, nextChildren);
          memoizeProps(workInProgress, nextProps);
          return workInProgress.child;
        }

        function updateClassComponent(current, workInProgress, renderExpirationTime) {
          // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.
          var hasContext = pushContextProvider(workInProgress);
          var shouldUpdate = void 0;

          if (current === null) {
            if (workInProgress.stateNode === null) {
              // In the initial pass we might need to construct the instance.
              constructClassInstance(workInProgress, workInProgress.pendingProps, renderExpirationTime);
              mountClassInstance(workInProgress, renderExpirationTime);
              shouldUpdate = true;
            } else {
              // In a resume, we'll already have an instance we can reuse.
              shouldUpdate = resumeMountClassInstance(workInProgress, renderExpirationTime);
            }
          } else {
            shouldUpdate = updateClassInstance(current, workInProgress, renderExpirationTime);
          }

          return finishClassComponent(current, workInProgress, shouldUpdate, hasContext, renderExpirationTime);
        }

        function finishClassComponent(current, workInProgress, shouldUpdate, hasContext, renderExpirationTime) {
          // Refs should update even if shouldComponentUpdate returns false
          markRef(current, workInProgress);
          var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;

          if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) {
              invalidateContextProvider(workInProgress, false);
            }

            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          var ctor = workInProgress.type;
          var instance = workInProgress.stateNode; // Rerender

          ReactCurrentOwner.current = workInProgress;
          var nextChildren = void 0;

          if (didCaptureError && (!enableGetDerivedStateFromCatch || typeof ctor.getDerivedStateFromCatch !== 'function')) {
            // If we captured an error, but getDerivedStateFrom catch is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;

            if (enableProfilerTimer) {
              stopBaseRenderTimerIfRunning();
            }
          } else {
            {
              ReactDebugCurrentFiber.setCurrentPhase('render');
              nextChildren = instance.render();

              if (debugRenderPhaseSideEffects || debugRenderPhaseSideEffectsForStrictMode && workInProgress.mode & StrictMode) {
                instance.render();
              }

              ReactDebugCurrentFiber.setCurrentPhase(null);
            }
          } // React DevTools reads this flag.


          workInProgress.effectTag |= PerformedWork;

          if (didCaptureError) {
            // If we're recovering from an error, reconcile twice: first to delete
            // all the existing children.
            reconcileChildrenAtExpirationTime(current, workInProgress, null, renderExpirationTime);
            workInProgress.child = null; // Now we can continue reconciling like normal. This has the effect of
            // remounting all children regardless of whether their their
            // identity matches.
          }

          reconcileChildrenAtExpirationTime(current, workInProgress, nextChildren, renderExpirationTime); // Memoize props and state using the values we just used to render.
          // TODO: Restructure so we never read values from the instance.

          memoizeState(workInProgress, instance.state);
          memoizeProps(workInProgress, instance.props); // The context might have changed so we need to recalculate it.

          if (hasContext) {
            invalidateContextProvider(workInProgress, true);
          }

          return workInProgress.child;
        }

        function pushHostRootContext(workInProgress) {
          var root = workInProgress.stateNode;

          if (root.pendingContext) {
            pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
          } else if (root.context) {
            // Should always be set
            pushTopLevelContextObject(workInProgress, root.context, false);
          }

          pushHostContainer(workInProgress, root.containerInfo);
        }

        function updateHostRoot(current, workInProgress, renderExpirationTime) {
          pushHostRootContext(workInProgress);
          var updateQueue = workInProgress.updateQueue;

          if (updateQueue !== null) {
            var nextProps = workInProgress.pendingProps;
            var prevState = workInProgress.memoizedState;
            var prevChildren = prevState !== null ? prevState.element : null;
            processUpdateQueue(workInProgress, updateQueue, nextProps, null, renderExpirationTime);
            var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
            // being called "element".

            var nextChildren = nextState.element;

            if (nextChildren === prevChildren) {
              // If the state is the same as before, that's a bailout because we had
              // no work that expires at this time.
              resetHydrationState();
              return bailoutOnAlreadyFinishedWork(current, workInProgress);
            }

            var root = workInProgress.stateNode;

            if ((current === null || current.child === null) && root.hydrate && enterHydrationState(workInProgress)) {
              // If we don't have any current children this might be the first pass.
              // We always try to hydrate. If this isn't a hydration pass there won't
              // be any children to hydrate which is effectively the same thing as
              // not hydrating.
              // This is a bit of a hack. We track the host root as a placement to
              // know that we're currently in a mounting state. That way isMounted
              // works as expected. We must reset this before committing.
              // TODO: Delete this when we delete isMounted and findDOMNode.
              workInProgress.effectTag |= Placement; // Ensure that children mount into this root without tracking
              // side-effects. This ensures that we don't store Placement effects on
              // nodes that will be hydrated.

              workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
            } else {
              // Otherwise reset hydration state in case we aborted and resumed another
              // root.
              resetHydrationState();
              reconcileChildren(current, workInProgress, nextChildren);
            }

            return workInProgress.child;
          }

          resetHydrationState(); // If there is no update queue, that's a bailout because the root has no props.

          return bailoutOnAlreadyFinishedWork(current, workInProgress);
        }

        function updateHostComponent(current, workInProgress, renderExpirationTime) {
          pushHostContext(workInProgress);

          if (current === null) {
            tryToClaimNextHydratableInstance(workInProgress);
          }

          var type = workInProgress.type;
          var memoizedProps = workInProgress.memoizedProps;
          var nextProps = workInProgress.pendingProps;
          var prevProps = current !== null ? current.memoizedProps : null;

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (memoizedProps === nextProps) {
            var isHidden = workInProgress.mode & AsyncMode && shouldDeprioritizeSubtree(type, nextProps);

            if (isHidden) {
              // Before bailing out, make sure we've deprioritized a hidden component.
              workInProgress.expirationTime = Never;
            }

            if (!isHidden || renderExpirationTime !== Never) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress);
            } // If we're rendering a hidden node at hidden priority, don't bailout. The
            // parent is complete, but the children may not be.

          }

          var nextChildren = nextProps.children;
          var isDirectTextChild = shouldSetTextContent(type, nextProps);

          if (isDirectTextChild) {
            // We special case a direct text child of a host node. This is a common
            // case. We won't handle it as a reified child. We will instead handle
            // this in the host environment that also have access to this prop. That
            // avoids allocating another HostText fiber and traversing it.
            nextChildren = null;
          } else if (prevProps && shouldSetTextContent(type, prevProps)) {
            // If we're switching from a direct text child to a normal child, or to
            // empty, we need to schedule the text content to be reset.
            workInProgress.effectTag |= ContentReset;
          }

          markRef(current, workInProgress); // Check the host config to see if the children are offscreen/hidden.

          if (renderExpirationTime !== Never && workInProgress.mode & AsyncMode && shouldDeprioritizeSubtree(type, nextProps)) {
            // Down-prioritize the children.
            workInProgress.expirationTime = Never; // Bailout and come back to this fiber later.

            workInProgress.memoizedProps = nextProps;
            return null;
          }

          reconcileChildren(current, workInProgress, nextChildren);
          memoizeProps(workInProgress, nextProps);
          return workInProgress.child;
        }

        function updateHostText(current, workInProgress) {
          if (current === null) {
            tryToClaimNextHydratableInstance(workInProgress);
          }

          var nextProps = workInProgress.pendingProps;
          memoizeProps(workInProgress, nextProps); // Nothing to do here. This is terminal. We'll do the completion step
          // immediately after.

          return null;
        }

        function mountIndeterminateComponent(current, workInProgress, renderExpirationTime) {
          !(current === null) ? invariant(false, 'An indeterminate component should never have mounted. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          var fn = workInProgress.type;
          var props = workInProgress.pendingProps;
          var unmaskedContext = getUnmaskedContext(workInProgress);
          var context = getMaskedContext(workInProgress, unmaskedContext);
          var value = void 0;
          {
            if (fn.prototype && typeof fn.prototype.render === 'function') {
              var componentName = getComponentName(workInProgress) || 'Unknown';

              if (!didWarnAboutBadClass[componentName]) {
                warning(false, "The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
              }
            }

            if (workInProgress.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
            }

            ReactCurrentOwner.current = workInProgress;
            value = fn(props, context);
          } // React DevTools reads this flag.

          workInProgress.effectTag |= PerformedWork;

          if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var Component = workInProgress.type; // Proceed under the assumption that this is a class instance

            workInProgress.tag = ClassComponent;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;

            if (typeof getDerivedStateFromProps === 'function') {
              applyDerivedStateFromProps(workInProgress, getDerivedStateFromProps, props);
            } // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.


            var hasContext = pushContextProvider(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, renderExpirationTime);
            return finishClassComponent(current, workInProgress, true, hasContext, renderExpirationTime);
          } else {
            // Proceed under the assumption that this is a functional component
            workInProgress.tag = FunctionalComponent;
            {
              var _Component = workInProgress.type;

              if (_Component) {
                !!_Component.childContextTypes ? warning(false, '%s(...): childContextTypes cannot be defined on a functional component.', _Component.displayName || _Component.name || 'Component') : void 0;
              }

              if (workInProgress.ref !== null) {
                var info = '';
                var ownerName = ReactDebugCurrentFiber.getCurrentFiberOwnerName();

                if (ownerName) {
                  info += '\n\nCheck the render method of `' + ownerName + '`.';
                }

                var warningKey = ownerName || workInProgress._debugID || '';
                var debugSource = workInProgress._debugSource;

                if (debugSource) {
                  warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
                }

                if (!didWarnAboutStatelessRefs[warningKey]) {
                  didWarnAboutStatelessRefs[warningKey] = true;
                  warning(false, 'Stateless function components cannot be given refs. ' + 'Attempts to access this ref will fail.%s%s', info, ReactDebugCurrentFiber.getCurrentFiberStackAddendum());
                }
              }

              if (typeof fn.getDerivedStateFromProps === 'function') {
                var _componentName = getComponentName(workInProgress) || 'Unknown';

                if (!didWarnAboutGetDerivedStateOnFunctionalComponent[_componentName]) {
                  warning(false, '%s: Stateless functional components do not support getDerivedStateFromProps.', _componentName);
                  didWarnAboutGetDerivedStateOnFunctionalComponent[_componentName] = true;
                }
              }
            }
            reconcileChildren(current, workInProgress, value);
            memoizeProps(workInProgress, props);
            return workInProgress.child;
          }
        }

        function updateTimeoutComponent(current, workInProgress, renderExpirationTime) {
          if (enableSuspense) {
            var nextProps = workInProgress.pendingProps;
            var prevProps = workInProgress.memoizedProps;
            var prevDidTimeout = workInProgress.memoizedState; // Check if we already attempted to render the normal state. If we did,
            // and we timed out, render the placeholder state.

            var alreadyCaptured = (workInProgress.effectTag & DidCapture) === NoEffect;
            var nextDidTimeout = !alreadyCaptured;

            if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
              // we don't do the bailout and we have to reuse existing props instead.
            } else if (nextProps === prevProps && nextDidTimeout === prevDidTimeout) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress);
            }

            var render = nextProps.children;
            var nextChildren = render(nextDidTimeout);
            workInProgress.memoizedProps = nextProps;
            workInProgress.memoizedState = nextDidTimeout;
            reconcileChildren(current, workInProgress, nextChildren);
            return workInProgress.child;
          } else {
            return null;
          }
        }

        function updatePortalComponent(current, workInProgress, renderExpirationTime) {
          pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
          var nextChildren = workInProgress.pendingProps;

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (workInProgress.memoizedProps === nextChildren) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          if (current === null) {
            // Portals are special because we don't append the children during mount
            // but at commit. Therefore we need to track insertions which the normal
            // flow doesn't do during mount. This doesn't happen at the root because
            // the root always starts with a "current" with a null child.
            // TODO: Consider unifying this with how the root works.
            workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
            memoizeProps(workInProgress, nextChildren);
          } else {
            reconcileChildren(current, workInProgress, nextChildren);
            memoizeProps(workInProgress, nextChildren);
          }

          return workInProgress.child;
        }

        function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
          var fiber = workInProgress.child;

          if (fiber !== null) {
            // Set the return pointer of the child to the work-in-progress fiber.
            fiber.return = workInProgress;
          }

          while (fiber !== null) {
            var nextFiber = void 0; // Visit this fiber.

            switch (fiber.tag) {
              case ContextConsumer:
                // Check if the context matches.
                var observedBits = fiber.stateNode | 0;

                if (fiber.type === context && (observedBits & changedBits) !== 0) {
                  // Update the expiration time of all the ancestors, including
                  // the alternates.
                  var node = fiber;

                  while (node !== null) {
                    var alternate = node.alternate;

                    if (node.expirationTime === NoWork || node.expirationTime > renderExpirationTime) {
                      node.expirationTime = renderExpirationTime;

                      if (alternate !== null && (alternate.expirationTime === NoWork || alternate.expirationTime > renderExpirationTime)) {
                        alternate.expirationTime = renderExpirationTime;
                      }
                    } else if (alternate !== null && (alternate.expirationTime === NoWork || alternate.expirationTime > renderExpirationTime)) {
                      alternate.expirationTime = renderExpirationTime;
                    } else {
                      // Neither alternate was updated, which means the rest of the
                      // ancestor path already has sufficient priority.
                      break;
                    }

                    node = node.return;
                  } // Don't scan deeper than a matching consumer. When we render the
                  // consumer, we'll continue scanning from that point. This way the
                  // scanning work is time-sliced.


                  nextFiber = null;
                } else {
                  // Traverse down.
                  nextFiber = fiber.child;
                }

                break;

              case ContextProvider:
                // Don't scan deeper if this is a matching provider
                nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
                break;

              default:
                // Traverse down.
                nextFiber = fiber.child;
                break;
            }

            if (nextFiber !== null) {
              // Set the return pointer of the child to the work-in-progress fiber.
              nextFiber.return = fiber;
            } else {
              // No child. Traverse to next sibling.
              nextFiber = fiber;

              while (nextFiber !== null) {
                if (nextFiber === workInProgress) {
                  // We're back to the root of this subtree. Exit.
                  nextFiber = null;
                  break;
                }

                var sibling = nextFiber.sibling;

                if (sibling !== null) {
                  // Set the return pointer of the sibling to the work-in-progress fiber.
                  sibling.return = nextFiber.return;
                  nextFiber = sibling;
                  break;
                } // No more siblings. Traverse up.


                nextFiber = nextFiber.return;
              }
            }

            fiber = nextFiber;
          }
        }

        function updateContextProvider(current, workInProgress, renderExpirationTime) {
          var providerType = workInProgress.type;
          var context = providerType._context;
          var newProps = workInProgress.pendingProps;
          var oldProps = workInProgress.memoizedProps;
          var canBailOnProps = true;

          if (hasContextChanged()) {
            canBailOnProps = false; // Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (oldProps === newProps) {
            workInProgress.stateNode = 0;
            pushProvider(workInProgress);
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          var newValue = newProps.value;
          workInProgress.memoizedProps = newProps;
          {
            var providerPropTypes = workInProgress.type.propTypes;

            if (providerPropTypes) {
              checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackAddendum$6);
            }
          }
          var changedBits = void 0;

          if (oldProps === null) {
            // Initial render
            changedBits = MAX_SIGNED_31_BIT_INT;
          } else {
            if (oldProps.value === newProps.value) {
              // No change. Bailout early if children are the same.
              if (oldProps.children === newProps.children && canBailOnProps) {
                workInProgress.stateNode = 0;
                pushProvider(workInProgress);
                return bailoutOnAlreadyFinishedWork(current, workInProgress);
              }

              changedBits = 0;
            } else {
              var oldValue = oldProps.value; // Use Object.is to compare the new context value to the old value.
              // Inlined Object.is polyfill.
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is

              if (oldValue === newValue && (oldValue !== 0 || 1 / oldValue === 1 / newValue) || oldValue !== oldValue && newValue !== newValue // eslint-disable-line no-self-compare
              ) {
                  // No change. Bailout early if children are the same.
                  if (oldProps.children === newProps.children && canBailOnProps) {
                    workInProgress.stateNode = 0;
                    pushProvider(workInProgress);
                    return bailoutOnAlreadyFinishedWork(current, workInProgress);
                  }

                  changedBits = 0;
                } else {
                changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                {
                  !((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits) ? warning(false, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits) : void 0;
                }
                changedBits |= 0;

                if (changedBits === 0) {
                  // No change. Bailout early if children are the same.
                  if (oldProps.children === newProps.children && canBailOnProps) {
                    workInProgress.stateNode = 0;
                    pushProvider(workInProgress);
                    return bailoutOnAlreadyFinishedWork(current, workInProgress);
                  }
                } else {
                  propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
                }
              }
            }
          }

          workInProgress.stateNode = changedBits;
          pushProvider(workInProgress);
          var newChildren = newProps.children;
          reconcileChildren(current, workInProgress, newChildren);
          return workInProgress.child;
        }

        function updateContextConsumer(current, workInProgress, renderExpirationTime) {
          var context = workInProgress.type;
          var newProps = workInProgress.pendingProps;
          var oldProps = workInProgress.memoizedProps;
          var newValue = getContextCurrentValue(context);
          var changedBits = getContextChangedBits(context);

          if (hasContextChanged()) {// Normally we can bail out on props equality but if context has changed
            // we don't do the bailout and we have to reuse existing props instead.
          } else if (changedBits === 0 && oldProps === newProps) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          }

          workInProgress.memoizedProps = newProps;
          var observedBits = newProps.unstable_observedBits;

          if (observedBits === undefined || observedBits === null) {
            // Subscribe to all changes by default
            observedBits = MAX_SIGNED_31_BIT_INT;
          } // Store the observedBits on the fiber's stateNode for quick access.


          workInProgress.stateNode = observedBits;

          if ((changedBits & observedBits) !== 0) {
            // Context change propagation stops at matching consumers, for time-
            // slicing. Continue the propagation here.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
          } else if (oldProps === newProps) {
            // Skip over a memoized parent with a bitmask bailout even
            // if we began working on it because of a deeper matching child.
            return bailoutOnAlreadyFinishedWork(current, workInProgress);
          } // There is no bailout on `children` equality because we expect people
          // to often pass a bound method as a child, but it may reference
          // `this.state` or `this.props` (and thus needs to re-render on `setState`).


          var render = newProps.children;
          {
            !(typeof render === 'function') ? warning(false, 'A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.') : void 0;
          }
          var newChildren = void 0;
          {
            ReactCurrentOwner.current = workInProgress;
            ReactDebugCurrentFiber.setCurrentPhase('render');
            newChildren = render(newValue);
            ReactDebugCurrentFiber.setCurrentPhase(null);
          } // React DevTools reads this flag.

          workInProgress.effectTag |= PerformedWork;
          reconcileChildren(current, workInProgress, newChildren);
          return workInProgress.child;
        }
        /*
          function reuseChildrenEffects(returnFiber : Fiber, firstChild : Fiber) {
            let child = firstChild;
            do {
              // Ensure that the first and last effect of the parent corresponds
              // to the children's first and last effect.
              if (!returnFiber.firstEffect) {
                returnFiber.firstEffect = child.firstEffect;
              }
              if (child.lastEffect) {
                if (returnFiber.lastEffect) {
                  returnFiber.lastEffect.nextEffect = child.firstEffect;
                }
                returnFiber.lastEffect = child.lastEffect;
              }
            } while (child = child.sibling);
          }
          */


        function bailoutOnAlreadyFinishedWork(current, workInProgress) {
          cancelWorkTimer(workInProgress);

          if (enableProfilerTimer) {
            // Don't update "base" render times for bailouts.
            stopBaseRenderTimerIfRunning();
          } // TODO: We should ideally be able to bail out early if the children have no
          // more work to do. However, since we don't have a separation of this
          // Fiber's priority and its children yet - we don't know without doing lots
          // of the same work we do anyway. Once we have that separation we can just
          // bail out here if the children has no more work at this priority level.
          // if (workInProgress.priorityOfChildren <= priorityLevel) {
          //   // If there are side-effects in these children that have not yet been
          //   // committed we need to ensure that they get properly transferred up.
          //   if (current && current.child !== workInProgress.child) {
          //     reuseChildrenEffects(workInProgress, child);
          //   }
          //   return null;
          // }


          cloneChildFibers(current, workInProgress);
          return workInProgress.child;
        }

        function bailoutOnLowPriority(current, workInProgress) {
          cancelWorkTimer(workInProgress);

          if (enableProfilerTimer) {
            // Don't update "base" render times for bailouts.
            stopBaseRenderTimerIfRunning();
          } // TODO: Handle HostComponent tags here as well and call pushHostContext()?
          // See PR 8590 discussion for context


          switch (workInProgress.tag) {
            case HostRoot:
              pushHostRootContext(workInProgress);
              break;

            case ClassComponent:
              pushContextProvider(workInProgress);
              break;

            case HostPortal:
              pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
              break;

            case ContextProvider:
              pushProvider(workInProgress);
              break;

            case Profiler:
              if (enableProfilerTimer) {
                markActualRenderTimeStarted(workInProgress);
              }

              break;
          } // TODO: What if this is currently in progress?
          // How can that happen? How is this not being cloned?


          return null;
        } // TODO: Delete memoizeProps/State and move to reconcile/bailout instead


        function memoizeProps(workInProgress, nextProps) {
          workInProgress.memoizedProps = nextProps;
        }

        function memoizeState(workInProgress, nextState) {
          workInProgress.memoizedState = nextState; // Don't reset the updateQueue, in case there are pending updates. Resetting
          // is handled by processUpdateQueue.
        }

        function beginWork(current, workInProgress, renderExpirationTime) {
          if (workInProgress.expirationTime === NoWork || workInProgress.expirationTime > renderExpirationTime) {
            return bailoutOnLowPriority(current, workInProgress);
          }

          switch (workInProgress.tag) {
            case IndeterminateComponent:
              return mountIndeterminateComponent(current, workInProgress, renderExpirationTime);

            case FunctionalComponent:
              return updateFunctionalComponent(current, workInProgress);

            case ClassComponent:
              return updateClassComponent(current, workInProgress, renderExpirationTime);

            case HostRoot:
              return updateHostRoot(current, workInProgress, renderExpirationTime);

            case HostComponent:
              return updateHostComponent(current, workInProgress, renderExpirationTime);

            case HostText:
              return updateHostText(current, workInProgress);

            case TimeoutComponent:
              return updateTimeoutComponent(current, workInProgress, renderExpirationTime);

            case HostPortal:
              return updatePortalComponent(current, workInProgress, renderExpirationTime);

            case ForwardRef:
              return updateForwardRef(current, workInProgress);

            case Fragment:
              return updateFragment(current, workInProgress);

            case Mode:
              return updateMode(current, workInProgress);

            case Profiler:
              return updateProfiler(current, workInProgress);

            case ContextProvider:
              return updateContextProvider(current, workInProgress, renderExpirationTime);

            case ContextConsumer:
              return updateContextConsumer(current, workInProgress, renderExpirationTime);

            default:
              invariant(false, 'Unknown unit of work tag. This error is likely caused by a bug in React. Please file an issue.');
          }
        }

        function markUpdate(workInProgress) {
          // Tag the fiber with an update effect. This turns a Placement into
          // a PlacementAndUpdate.
          workInProgress.effectTag |= Update;
        }

        function markRef$1(workInProgress) {
          workInProgress.effectTag |= Ref;
        }

        function appendAllChildren(parent, workInProgress) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;

          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) {// If we have a portal child, then we don't want to traverse
              // down its children. Instead, we'll get insertions from each child in
              // the portal directly.
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        var updateHostContainer = void 0;
        var updateHostComponent$1 = void 0;
        var updateHostText$1 = void 0;

        if (supportsMutation) {
          // Mutation mode
          updateHostContainer = function updateHostContainer(workInProgress) {// Noop
          };

          updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, updatePayload, type, oldProps, newProps, rootContainerInstance, currentHostContext) {
            // TODO: Type this specific to this type of component.
            workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
            // is a new ref we mark this as an update. All the work is done in commitWork.

            if (updatePayload) {
              markUpdate(workInProgress);
            }
          };

          updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
            // If the text differs, mark it as an update. All the work in done in commitWork.
            if (oldText !== newText) {
              markUpdate(workInProgress);
            }
          };
        } else if (supportsPersistence) {
          // Persistent host tree mode
          // An unfortunate fork of appendAllChildren because we have two different parent types.
          var appendAllChildrenToContainer = function appendAllChildrenToContainer(containerChildSet, workInProgress) {
            // We only have the top Fiber that was created but we need recurse down its
            // children to find all the terminal nodes.
            var node = workInProgress.child;

            while (node !== null) {
              if (node.tag === HostComponent || node.tag === HostText) {
                appendChildToContainerChildSet(containerChildSet, node.stateNode);
              } else if (node.tag === HostPortal) {// If we have a portal child, then we don't want to traverse
                // down its children. Instead, we'll get insertions from each child in
                // the portal directly.
              } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }

              if (node === workInProgress) {
                return;
              }

              while (node.sibling === null) {
                if (node.return === null || node.return === workInProgress) {
                  return;
                }

                node = node.return;
              }

              node.sibling.return = node.return;
              node = node.sibling;
            }
          };

          updateHostContainer = function updateHostContainer(workInProgress) {
            var portalOrRoot = workInProgress.stateNode;
            var childrenUnchanged = workInProgress.firstEffect === null;

            if (childrenUnchanged) {// No changes, just reuse the existing instance.
            } else {
              var container = portalOrRoot.containerInfo;
              var newChildSet = createContainerChildSet(container); // If children might have changed, we have to add them all to the set.

              appendAllChildrenToContainer(newChildSet, workInProgress);
              portalOrRoot.pendingChildren = newChildSet; // Schedule an update on the container to swap out the container.

              markUpdate(workInProgress);
              finalizeContainerChildren(container, newChildSet);
            }
          };

          updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, updatePayload, type, oldProps, newProps, rootContainerInstance, currentHostContext) {
            // If there are no effects associated with this node, then none of our children had any updates.
            // This guarantees that we can reuse all of them.
            var childrenUnchanged = workInProgress.firstEffect === null;
            var currentInstance = current.stateNode;

            if (childrenUnchanged && updatePayload === null) {
              // No changes, just reuse the existing instance.
              // Note that this might release a previous clone.
              workInProgress.stateNode = currentInstance;
            } else {
              var recyclableInstance = workInProgress.stateNode;
              var newInstance = cloneInstance(currentInstance, updatePayload, type, oldProps, newProps, workInProgress, childrenUnchanged, recyclableInstance);

              if (finalizeInitialChildren(newInstance, type, newProps, rootContainerInstance, currentHostContext)) {
                markUpdate(workInProgress);
              }

              workInProgress.stateNode = newInstance;

              if (childrenUnchanged) {
                // If there are no other effects in this tree, we need to flag this node as having one.
                // Even though we're not going to use it for anything.
                // Otherwise parents won't know that there are new children to propagate upwards.
                markUpdate(workInProgress);
              } else {
                // If children might have changed, we have to add them all to the set.
                appendAllChildren(newInstance, workInProgress);
              }
            }
          };

          updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
            if (oldText !== newText) {
              // If the text content differs, we'll create a new text instance for it.
              var rootContainerInstance = getRootHostContainer();
              var currentHostContext = getHostContext();
              workInProgress.stateNode = createTextInstance(newText, rootContainerInstance, currentHostContext, workInProgress); // We'll have to mark it as having an effect, even though we won't use the effect for anything.
              // This lets the parents know that at least one of their children has changed.

              markUpdate(workInProgress);
            }
          };
        } else {
          // No host operations
          updateHostContainer = function updateHostContainer(workInProgress) {// Noop
          };

          updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, updatePayload, type, oldProps, newProps, rootContainerInstance, currentHostContext) {// Noop
          };

          updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {// Noop
          };
        }

        function completeWork(current, workInProgress, renderExpirationTime) {
          var newProps = workInProgress.pendingProps;

          switch (workInProgress.tag) {
            case FunctionalComponent:
              return null;

            case ClassComponent:
              {
                // We are leaving this subtree, so pop context if any.
                popContextProvider(workInProgress);
                return null;
              }

            case HostRoot:
              {
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var fiberRoot = workInProgress.stateNode;

                if (fiberRoot.pendingContext) {
                  fiberRoot.context = fiberRoot.pendingContext;
                  fiberRoot.pendingContext = null;
                }

                if (current === null || current.child === null) {
                  // If we hydrated, pop so that we can delete any remaining children
                  // that weren't hydrated.
                  popHydrationState(workInProgress); // This resets the hacky state to fix isMounted before committing.
                  // TODO: Delete this when we delete isMounted and findDOMNode.

                  workInProgress.effectTag &= ~Placement;
                }

                updateHostContainer(workInProgress);
                return null;
              }

            case HostComponent:
              {
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;

                if (current !== null && workInProgress.stateNode != null) {
                  // If we have an alternate, that means this is an update and we need to
                  // schedule a side-effect to do the updates.
                  var oldProps = current.memoizedProps; // If we get updated because one of our children updated, we don't
                  // have newProps so we'll have to reuse them.
                  // TODO: Split the update API as separate for the props vs. children.
                  // Even better would be if children weren't special cased at all tho.

                  var instance = workInProgress.stateNode;
                  var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
                  // component is hitting the resume path. Figure out why. Possibly
                  // related to `hidden`.

                  var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
                  updateHostComponent$1(current, workInProgress, updatePayload, type, oldProps, newProps, rootContainerInstance, currentHostContext);

                  if (current.ref !== workInProgress.ref) {
                    markRef$1(workInProgress);
                  }
                } else {
                  if (!newProps) {
                    !(workInProgress.stateNode !== null) ? invariant(false, 'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.') : void 0; // This can happen when we abort work.

                    return null;
                  }

                  var _currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                  // "stack" as the parent. Then append children as we go in beginWork
                  // or completeWork depending on we want to add then top->down or
                  // bottom->up. Top->down is faster in IE11.


                  var wasHydrated = popHydrationState(workInProgress);

                  if (wasHydrated) {
                    // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, _currentHostContext)) {
                      // If changes to the hydrated node needs to be applied at the
                      // commit-phase we mark this as such.
                      markUpdate(workInProgress);
                    }
                  } else {
                    var _instance = createInstance(type, newProps, rootContainerInstance, _currentHostContext, workInProgress);

                    appendAllChildren(_instance, workInProgress); // Certain renderers require commit-time effects for initial mount.
                    // (eg DOM renderer supports auto-focus for certain elements).
                    // Make sure such renderers get scheduled for later work.

                    if (finalizeInitialChildren(_instance, type, newProps, rootContainerInstance, _currentHostContext)) {
                      markUpdate(workInProgress);
                    }

                    workInProgress.stateNode = _instance;
                  }

                  if (workInProgress.ref !== null) {
                    // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                  }
                }

                return null;
              }

            case HostText:
              {
                var newText = newProps;

                if (current && workInProgress.stateNode != null) {
                  var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                  // to schedule a side-effect to do the updates.

                  updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                  if (typeof newText !== 'string') {
                    !(workInProgress.stateNode !== null) ? invariant(false, 'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.') : void 0; // This can happen when we abort work.

                    return null;
                  }

                  var _rootContainerInstance = getRootHostContainer();

                  var _currentHostContext2 = getHostContext();

                  var _wasHydrated = popHydrationState(workInProgress);

                  if (_wasHydrated) {
                    if (prepareToHydrateHostTextInstance(workInProgress)) {
                      markUpdate(workInProgress);
                    }
                  } else {
                    workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext2, workInProgress);
                  }
                }

                return null;
              }

            case ForwardRef:
              return null;

            case TimeoutComponent:
              return null;

            case Fragment:
              return null;

            case Mode:
              return null;

            case Profiler:
              if (enableProfilerTimer) {
                recordElapsedActualRenderTime(workInProgress);
              }

              return null;

            case HostPortal:
              popHostContainer(workInProgress);
              updateHostContainer(workInProgress);
              return null;

            case ContextProvider:
              // Pop provider fiber
              popProvider(workInProgress);
              return null;

            case ContextConsumer:
              return null;
            // Error cases

            case IndeterminateComponent:
              invariant(false, 'An indeterminate component should have become determinate before completing. This error is likely caused by a bug in React. Please file an issue.');
            // eslint-disable-next-line no-fallthrough

            default:
              invariant(false, 'Unknown unit of work tag. This error is likely caused by a bug in React. Please file an issue.');
          }
        } // This module is forked in different environments.
        // By default, return `true` to log errors to the console.
        // Forks can return `false` if this isn't desirable.


        function showErrorDialog(capturedError) {
          return true;
        }

        function logCapturedError(capturedError) {
          var logError = showErrorDialog(capturedError); // Allow injected showErrorDialog() to prevent default console.error logging.
          // This enables renderers like ReactNative to better manage redbox behavior.

          if (logError === false) {
            return;
          }

          var error = capturedError.error;
          var suppressLogging = error && error.suppressReactErrorLogging;

          if (suppressLogging) {
            return;
          }

          {
            var componentName = capturedError.componentName,
                componentStack = capturedError.componentStack,
                errorBoundaryName = capturedError.errorBoundaryName,
                errorBoundaryFound = capturedError.errorBoundaryFound,
                willRetry = capturedError.willRetry;
            var componentNameMessage = componentName ? 'The above error occurred in the <' + componentName + '> component:' : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage = void 0; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.

            if (errorBoundaryFound && errorBoundaryName) {
              if (willRetry) {
                errorBoundaryMessage = 'React will try to recreate this component tree from scratch ' + ('using the error boundary you provided, ' + errorBoundaryName + '.');
              } else {
                errorBoundaryMessage = 'This error was initially handled by the error boundary ' + errorBoundaryName + '.\n' + 'Recreating the tree from scratch failed so React will unmount the tree.';
              }
            } else {
              errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://fb.me/react-error-boundaries to learn more about error boundaries.';
            }

            var combinedMessage = '' + componentNameMessage + componentStack + '\n\n' + ('' + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

            console.error(combinedMessage);
          }
        }

        var invokeGuardedCallback$3 = ReactErrorUtils.invokeGuardedCallback;
        var hasCaughtError$1 = ReactErrorUtils.hasCaughtError;
        var clearCaughtError$1 = ReactErrorUtils.clearCaughtError;
        var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
        {
          didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
        }

        function logError(boundary, errorInfo) {
          var source = errorInfo.source;
          var stack = errorInfo.stack;

          if (stack === null && source !== null) {
            stack = getStackAddendumByWorkInProgressFiber(source);
          }

          var capturedError = {
            componentName: source !== null ? getComponentName(source) : null,
            componentStack: stack !== null ? stack : '',
            error: errorInfo.value,
            errorBoundary: null,
            errorBoundaryName: null,
            errorBoundaryFound: false,
            willRetry: false
          };

          if (boundary !== null && boundary.tag === ClassComponent) {
            capturedError.errorBoundary = boundary.stateNode;
            capturedError.errorBoundaryName = getComponentName(boundary);
            capturedError.errorBoundaryFound = true;
            capturedError.willRetry = true;
          }

          try {
            logCapturedError(capturedError);
          } catch (e) {
            // Prevent cycle if logCapturedError() throws.
            // A cycle may still occur if logCapturedError renders a component that throws.
            var suppressLogging = e && e.suppressReactErrorLogging;

            if (!suppressLogging) {
              console.error(e);
            }
          }
        }

        var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
          startPhaseTimer(current, 'componentWillUnmount');
          instance.props = current.memoizedProps;
          instance.state = current.memoizedState;
          instance.componentWillUnmount();
          stopPhaseTimer();
        }; // Capture errors so they don't interrupt unmounting.


        function safelyCallComponentWillUnmount(current, instance) {
          {
            invokeGuardedCallback$3(null, callComponentWillUnmountWithTimer, null, current, instance);

            if (hasCaughtError$1()) {
              var unmountError = clearCaughtError$1();
              captureCommitPhaseError(current, unmountError);
            }
          }
        }

        function safelyDetachRef(current) {
          var ref = current.ref;

          if (ref !== null) {
            if (typeof ref === 'function') {
              {
                invokeGuardedCallback$3(null, ref, null, null);

                if (hasCaughtError$1()) {
                  var refError = clearCaughtError$1();
                  captureCommitPhaseError(current, refError);
                }
              }
            } else {
              ref.current = null;
            }
          }
        }

        function commitBeforeMutationLifeCycles(current, finishedWork) {
          switch (finishedWork.tag) {
            case ClassComponent:
              {
                if (finishedWork.effectTag & Snapshot) {
                  if (current !== null) {
                    var prevProps = current.memoizedProps;
                    var prevState = current.memoizedState;
                    startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                    var instance = finishedWork.stateNode;
                    instance.props = finishedWork.memoizedProps;
                    instance.state = finishedWork.memoizedState;
                    var snapshot = instance.getSnapshotBeforeUpdate(prevProps, prevState);
                    {
                      var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

                      if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                        didWarnSet.add(finishedWork.type);
                        warning(false, '%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork));
                      }
                    }
                    instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    stopPhaseTimer();
                  }
                }

                return;
              }

            case HostRoot:
            case HostComponent:
            case HostText:
            case HostPortal:
              // Nothing to do for these component types
              return;

            default:
              {
                invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
              }
          }
        }

        function commitLifeCycles(finishedRoot, current, finishedWork, currentTime, committedExpirationTime) {
          switch (finishedWork.tag) {
            case ClassComponent:
              {
                var instance = finishedWork.stateNode;

                if (finishedWork.effectTag & Update) {
                  if (current === null) {
                    startPhaseTimer(finishedWork, 'componentDidMount');
                    instance.props = finishedWork.memoizedProps;
                    instance.state = finishedWork.memoizedState;
                    instance.componentDidMount();
                    stopPhaseTimer();
                  } else {
                    var prevProps = current.memoizedProps;
                    var prevState = current.memoizedState;
                    startPhaseTimer(finishedWork, 'componentDidUpdate');
                    instance.props = finishedWork.memoizedProps;
                    instance.state = finishedWork.memoizedState;
                    instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                    stopPhaseTimer();
                  }
                }

                var updateQueue = finishedWork.updateQueue;

                if (updateQueue !== null) {
                  instance.props = finishedWork.memoizedProps;
                  instance.state = finishedWork.memoizedState;
                  commitUpdateQueue(finishedWork, updateQueue, instance, committedExpirationTime);
                }

                return;
              }

            case HostRoot:
              {
                var _updateQueue = finishedWork.updateQueue;

                if (_updateQueue !== null) {
                  var _instance = null;

                  if (finishedWork.child !== null) {
                    switch (finishedWork.child.tag) {
                      case HostComponent:
                        _instance = getPublicInstance(finishedWork.child.stateNode);
                        break;

                      case ClassComponent:
                        _instance = finishedWork.child.stateNode;
                        break;
                    }
                  }

                  commitUpdateQueue(finishedWork, _updateQueue, _instance, committedExpirationTime);
                }

                return;
              }

            case HostComponent:
              {
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.

                if (current === null && finishedWork.effectTag & Update) {
                  var type = finishedWork.type;
                  var props = finishedWork.memoizedProps;
                  commitMount(_instance2, type, props, finishedWork);
                }

                return;
              }

            case HostText:
              {
                // We have no life-cycles associated with text.
                return;
              }

            case HostPortal:
              {
                // We have no life-cycles associated with portals.
                return;
              }

            case Profiler:
              {
                // We have no life-cycles associated with Profiler.
                return;
              }

            case TimeoutComponent:
              {
                // We have no life-cycles associated with Timeouts.
                return;
              }

            default:
              {
                invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
              }
          }
        }

        function commitAttachRef(finishedWork) {
          var ref = finishedWork.ref;

          if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse = void 0;

            switch (finishedWork.tag) {
              case HostComponent:
                instanceToUse = getPublicInstance(instance);
                break;

              default:
                instanceToUse = instance;
            }

            if (typeof ref === 'function') {
              ref(instanceToUse);
            } else {
              {
                if (!ref.hasOwnProperty('current')) {
                  warning(false, 'Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().%s', getComponentName(finishedWork), getStackAddendumByWorkInProgressFiber(finishedWork));
                }
              }
              ref.current = instanceToUse;
            }
          }
        }

        function commitDetachRef(current) {
          var currentRef = current.ref;

          if (currentRef !== null) {
            if (typeof currentRef === 'function') {
              currentRef(null);
            } else {
              currentRef.current = null;
            }
          }
        } // User-originating errors (lifecycles and refs) should not interrupt
        // deletion, so don't let them throw. Host-originating errors should
        // interrupt deletion, so it's okay


        function commitUnmount(current) {
          if (typeof onCommitUnmount === 'function') {
            onCommitUnmount(current);
          }

          switch (current.tag) {
            case ClassComponent:
              {
                safelyDetachRef(current);
                var instance = current.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(current, instance);
                }

                return;
              }

            case HostComponent:
              {
                safelyDetachRef(current);
                return;
              }

            case HostPortal:
              {
                // TODO: this is recursive.
                // We are also not using this parent because
                // the portal will get pushed immediately.
                if (supportsMutation) {
                  unmountHostComponents(current);
                } else if (supportsPersistence) {
                  emptyPortalContainer(current);
                }

                return;
              }
          }
        }

        function commitNestedUnmounts(root) {
          // While we're inside a removed host node we don't want to call
          // removeChild on the inner nodes because they're removed by the top
          // call anyway. We also want to call componentWillUnmount on all
          // composites before this host node is removed from the tree. Therefore
          var node = root;

          while (true) {
            commitUnmount(node); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.

            if (node.child !== null && ( // If we use mutation we drill down into portals using commitUnmount above.
            // If we don't use mutation we drill down into portals here instead.
            !supportsMutation || node.tag !== HostPortal)) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === root) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === root) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        function detachFiber(current) {
          // Cut off the return pointers to disconnect it from the tree. Ideally, we
          // should clear the child pointer of the parent alternate to let this
          // get GC:ed but we don't know which for sure which parent is the current
          // one so we'll settle for GC:ing the subtree of this child. This child
          // itself will be GC:ed when the parent updates the next time.
          current.return = null;
          current.child = null;

          if (current.alternate) {
            current.alternate.child = null;
            current.alternate.return = null;
          }
        }

        function emptyPortalContainer(current) {
          if (!supportsPersistence) {
            return;
          }

          var portal = current.stateNode;
          var containerInfo = portal.containerInfo;
          var emptyChildSet = createContainerChildSet(containerInfo);
          replaceContainerChildren(containerInfo, emptyChildSet);
        }

        function commitContainer(finishedWork) {
          if (!supportsPersistence) {
            return;
          }

          switch (finishedWork.tag) {
            case ClassComponent:
              {
                return;
              }

            case HostComponent:
              {
                return;
              }

            case HostText:
              {
                return;
              }

            case HostRoot:
            case HostPortal:
              {
                var portalOrRoot = finishedWork.stateNode;
                var containerInfo = portalOrRoot.containerInfo,
                    _pendingChildren = portalOrRoot.pendingChildren;
                replaceContainerChildren(containerInfo, _pendingChildren);
                return;
              }

            default:
              {
                invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
              }
          }
        }

        function getHostParentFiber(fiber) {
          var parent = fiber.return;

          while (parent !== null) {
            if (isHostParent(parent)) {
              return parent;
            }

            parent = parent.return;
          }

          invariant(false, 'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.');
        }

        function isHostParent(fiber) {
          return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
        }

        function getHostSibling(fiber) {
          // We're going to search forward into the tree until we find a sibling host
          // node. Unfortunately, if multiple insertions are done in a row we have to
          // search past them. This leads to exponential search for the next sibling.
          var node = fiber;

          siblings: while (true) {
            // If we didn't find anything, let's try the next sibling.
            while (node.sibling === null) {
              if (node.return === null || isHostParent(node.return)) {
                // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;

            while (node.tag !== HostComponent && node.tag !== HostText) {
              // If it is not host node and, we might have a host node inside it.
              // Try to search down until we find one.
              if (node.effectTag & Placement) {
                // If we don't have a child, try the siblings instead.
                continue siblings;
              } // If we don't have a child, try the siblings instead.
              // We also skip portals because they are not part of this host tree.


              if (node.child === null || node.tag === HostPortal) {
                continue siblings;
              } else {
                node.child.return = node;
                node = node.child;
              }
            } // Check if this host node is stable or about to be placed.


            if (!(node.effectTag & Placement)) {
              // Found it!
              return node.stateNode;
            }
          }
        }

        function commitPlacement(finishedWork) {
          if (!supportsMutation) {
            return;
          } // Recursively insert all host nodes into the parent.


          var parentFiber = getHostParentFiber(finishedWork);
          var parent = void 0;
          var isContainer = void 0;

          switch (parentFiber.tag) {
            case HostComponent:
              parent = parentFiber.stateNode;
              isContainer = false;
              break;

            case HostRoot:
              parent = parentFiber.stateNode.containerInfo;
              isContainer = true;
              break;

            case HostPortal:
              parent = parentFiber.stateNode.containerInfo;
              isContainer = true;
              break;

            default:
              invariant(false, 'Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.');
          }

          if (parentFiber.effectTag & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag

            parentFiber.effectTag &= ~ContentReset;
          }

          var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need recurse down its
          // children to find all the terminal nodes.

          var node = finishedWork;

          while (true) {
            if (node.tag === HostComponent || node.tag === HostText) {
              if (before) {
                if (isContainer) {
                  insertInContainerBefore(parent, node.stateNode, before);
                } else {
                  insertBefore(parent, node.stateNode, before);
                }
              } else {
                if (isContainer) {
                  appendChildToContainer(parent, node.stateNode);
                } else {
                  appendChild(parent, node.stateNode);
                }
              }
            } else if (node.tag === HostPortal) {// If the insertion itself is a portal, then we don't want to traverse
              // down its children. Instead, we'll get insertions from each child in
              // the portal directly.
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === finishedWork) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === finishedWork) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        function unmountHostComponents(current) {
          // We only have the top Fiber that was inserted but we need recurse down its
          var node = current; // Each iteration, currentParent is populated with node's host parent if not
          // currentParentIsValid.

          var currentParentIsValid = false;
          var currentParent = void 0;
          var currentParentIsContainer = void 0;

          while (true) {
            if (!currentParentIsValid) {
              var parent = node.return;

              findParent: while (true) {
                !(parent !== null) ? invariant(false, 'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.') : void 0;

                switch (parent.tag) {
                  case HostComponent:
                    currentParent = parent.stateNode;
                    currentParentIsContainer = false;
                    break findParent;

                  case HostRoot:
                    currentParent = parent.stateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;

                  case HostPortal:
                    currentParent = parent.stateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;
                }

                parent = parent.return;
              }

              currentParentIsValid = true;
            }

            if (node.tag === HostComponent || node.tag === HostText) {
              commitNestedUnmounts(node); // After all the children have unmounted, it is now safe to remove the
              // node from the tree.

              if (currentParentIsContainer) {
                removeChildFromContainer(currentParent, node.stateNode);
              } else {
                removeChild(currentParent, node.stateNode);
              } // Don't visit children because we already visited them.

            } else if (node.tag === HostPortal) {
              // When we go into a portal, it becomes the parent to remove from.
              // We will reassign it back when we pop the portal on the way up.
              currentParent = node.stateNode.containerInfo; // Visit children because portals might contain host components.

              if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
            } else {
              commitUnmount(node); // Visit children because we may find more host components below.

              if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
            }

            if (node === current) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === current) {
                return;
              }

              node = node.return;

              if (node.tag === HostPortal) {
                // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
              }
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        function commitDeletion(current) {
          if (supportsMutation) {
            // Recursively delete all host nodes from the parent.
            // Detach refs and call componentWillUnmount() on the whole subtree.
            unmountHostComponents(current);
          } else {
            // Detach refs and call componentWillUnmount() on the whole subtree.
            commitNestedUnmounts(current);
          }

          detachFiber(current);
        }

        function commitWork(current, finishedWork) {
          if (!supportsMutation) {
            commitContainer(finishedWork);
            return;
          }

          switch (finishedWork.tag) {
            case ClassComponent:
              {
                return;
              }

            case HostComponent:
              {
                var instance = finishedWork.stateNode;

                if (instance != null) {
                  // Commit the work prepared earlier.
                  var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                  // as the newProps. The updatePayload will contain the real change in
                  // this case.

                  var oldProps = current !== null ? current.memoizedProps : newProps;
                  var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

                  var updatePayload = finishedWork.updateQueue;
                  finishedWork.updateQueue = null;

                  if (updatePayload !== null) {
                    commitUpdate(instance, updatePayload, type, oldProps, newProps, finishedWork);
                  }
                }

                return;
              }

            case HostText:
              {
                !(finishedWork.stateNode !== null) ? invariant(false, 'This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.') : void 0;
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.

                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
              }

            case HostRoot:
              {
                return;
              }

            case Profiler:
              {
                if (enableProfilerTimer) {
                  var onRender = finishedWork.memoizedProps.onRender;
                  onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.stateNode.duration, finishedWork.treeBaseTime, finishedWork.stateNode.startTime, getCommitTime()); // Reset actualTime after successful commit.
                  // By default, we append to this time to account for errors and pauses.

                  finishedWork.stateNode.duration = 0;
                }

                return;
              }

            case TimeoutComponent:
              {
                return;
              }

            default:
              {
                invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
              }
          }
        }

        function commitResetTextContent(current) {
          if (!supportsMutation) {
            return;
          }

          resetTextContent(current.stateNode);
        }

        function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
          var update = createUpdate(expirationTime); // Unmount the root by rendering null.

          update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
          // being called "element".

          update.payload = {
            element: null
          };
          var error = errorInfo.value;

          update.callback = function () {
            onUncaughtError(error);
            logError(fiber, errorInfo);
          };

          return update;
        }

        function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
          var update = createUpdate(expirationTime);
          update.tag = CaptureUpdate;
          var getDerivedStateFromCatch = fiber.type.getDerivedStateFromCatch;

          if (enableGetDerivedStateFromCatch && typeof getDerivedStateFromCatch === 'function') {
            var error = errorInfo.value;

            update.payload = function () {
              return getDerivedStateFromCatch(error);
            };
          }

          var inst = fiber.stateNode;

          if (inst !== null && typeof inst.componentDidCatch === 'function') {
            update.callback = function callback() {
              if (!enableGetDerivedStateFromCatch || getDerivedStateFromCatch !== 'function') {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromCatch is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this);
              }

              var error = errorInfo.value;
              var stack = errorInfo.stack;
              logError(fiber, errorInfo);
              this.componentDidCatch(error, {
                componentStack: stack !== null ? stack : ''
              });
            };
          }

          return update;
        }

        function schedulePing(finishedWork) {
          // Once the promise resolves, we should try rendering the non-
          // placeholder state again.
          var currentTime = recalculateCurrentTime();
          var expirationTime = computeExpirationForFiber(currentTime, finishedWork);
          var recoveryUpdate = createUpdate(expirationTime);
          enqueueUpdate(finishedWork, recoveryUpdate, expirationTime);
          scheduleWork$1(finishedWork, expirationTime);
        }

        function throwException(root, returnFiber, sourceFiber, value, renderIsExpired, renderExpirationTime, currentTimeMs) {
          // The source fiber did not complete.
          sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.

          sourceFiber.firstEffect = sourceFiber.lastEffect = null;

          if (enableSuspense && value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a thenable.
            var thenable = value;
            var expirationTimeMs = expirationTimeToMs(renderExpirationTime);
            var startTimeMs = expirationTimeMs - 5000;
            var elapsedMs = currentTimeMs - startTimeMs;

            if (elapsedMs < 0) {
              elapsedMs = 0;
            }

            var remainingTimeMs = expirationTimeMs - currentTimeMs; // Find the earliest timeout of all the timeouts in the ancestor path.
            // TODO: Alternatively, we could store the earliest timeout on the context
            // stack, rather than searching on every suspend.

            var _workInProgress = returnFiber;
            var earliestTimeoutMs = -1;

            searchForEarliestTimeout: do {
              if (_workInProgress.tag === TimeoutComponent) {
                var current = _workInProgress.alternate;

                if (current !== null && current.memoizedState === true) {
                  // A parent Timeout already committed in a placeholder state. We
                  // need to handle this promise immediately. In other words, we
                  // should never suspend inside a tree that already expired.
                  earliestTimeoutMs = 0;
                  break searchForEarliestTimeout;
                }

                var timeoutPropMs = _workInProgress.pendingProps.ms;

                if (typeof timeoutPropMs === 'number') {
                  if (timeoutPropMs <= 0) {
                    earliestTimeoutMs = 0;
                    break searchForEarliestTimeout;
                  } else if (earliestTimeoutMs === -1 || timeoutPropMs < earliestTimeoutMs) {
                    earliestTimeoutMs = timeoutPropMs;
                  }
                } else if (earliestTimeoutMs === -1) {
                  earliestTimeoutMs = remainingTimeMs;
                }
              }

              _workInProgress = _workInProgress.return;
            } while (_workInProgress !== null); // Compute the remaining time until the timeout.


            var msUntilTimeout = earliestTimeoutMs - elapsedMs;

            if (renderExpirationTime === Never || msUntilTimeout > 0) {
              // There's still time remaining.
              suspendRoot(root, thenable, msUntilTimeout, renderExpirationTime);

              var onResolveOrReject = function onResolveOrReject() {
                retrySuspendedRoot(root, renderExpirationTime);
              };

              thenable.then(onResolveOrReject, onResolveOrReject);
              return;
            } else {
              // No time remaining. Need to fallback to placeholder.
              // Find the nearest timeout that can be retried.
              _workInProgress = returnFiber;

              do {
                switch (_workInProgress.tag) {
                  case HostRoot:
                    {
                      // The root expired, but no fallback was provided. Throw a
                      // helpful error.
                      var message = renderExpirationTime === Sync ? 'A synchronous update was suspended, but no fallback UI ' + 'was provided.' : 'An update was suspended for longer than the timeout, ' + 'but no fallback UI was provided.';
                      value = new Error(message);
                      break;
                    }

                  case TimeoutComponent:
                    {
                      if ((_workInProgress.effectTag & DidCapture) === NoEffect) {
                        _workInProgress.effectTag |= ShouldCapture;

                        var _onResolveOrReject = schedulePing.bind(null, _workInProgress);

                        thenable.then(_onResolveOrReject, _onResolveOrReject);
                        return;
                      } // Already captured during this render. Continue to the next
                      // Timeout ancestor.


                      break;
                    }
                }

                _workInProgress = _workInProgress.return;
              } while (_workInProgress !== null);
            }
          } // We didn't find a boundary that could handle this type of exception. Start
          // over and traverse parent path again, this time treating the exception
          // as an error.


          value = createCapturedValue(value, sourceFiber);
          var workInProgress = returnFiber;

          do {
            switch (workInProgress.tag) {
              case HostRoot:
                {
                  var _errorInfo = value;
                  workInProgress.effectTag |= ShouldCapture;
                  var update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                  enqueueCapturedUpdate(workInProgress, update, renderExpirationTime);
                  return;
                }

              case ClassComponent:
                // Capture and retry
                var errorInfo = value;
                var ctor = workInProgress.type;
                var instance = workInProgress.stateNode;

                if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromCatch === 'function' && enableGetDerivedStateFromCatch || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                  workInProgress.effectTag |= ShouldCapture; // Schedule the error boundary to re-render using updated state

                  var _update = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);

                  enqueueCapturedUpdate(workInProgress, _update, renderExpirationTime);
                  return;
                }

                break;

              default:
                break;
            }

            workInProgress = workInProgress.return;
          } while (workInProgress !== null);
        }

        function unwindWork(workInProgress, renderIsExpired, renderExpirationTime) {
          switch (workInProgress.tag) {
            case ClassComponent:
              {
                popContextProvider(workInProgress);
                var effectTag = workInProgress.effectTag;

                if (effectTag & ShouldCapture) {
                  workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                  return workInProgress;
                }

                return null;
              }

            case HostRoot:
              {
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                var _effectTag = workInProgress.effectTag;

                if (_effectTag & ShouldCapture) {
                  workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
                  return workInProgress;
                }

                return null;
              }

            case HostComponent:
              {
                popHostContext(workInProgress);
                return null;
              }

            case TimeoutComponent:
              {
                var _effectTag2 = workInProgress.effectTag;

                if (_effectTag2 & ShouldCapture) {
                  workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture;
                  return workInProgress;
                }

                return null;
              }

            case HostPortal:
              popHostContainer(workInProgress);
              return null;

            case ContextProvider:
              popProvider(workInProgress);
              return null;

            default:
              return null;
          }
        }

        function unwindInterruptedWork(interruptedWork) {
          switch (interruptedWork.tag) {
            case ClassComponent:
              {
                popContextProvider(interruptedWork);
                break;
              }

            case HostRoot:
              {
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                break;
              }

            case HostComponent:
              {
                popHostContext(interruptedWork);
                break;
              }

            case HostPortal:
              popHostContainer(interruptedWork);
              break;

            case ContextProvider:
              popProvider(interruptedWork);
              break;

            case Profiler:
              if (enableProfilerTimer) {
                // Resume in case we're picking up on work that was paused.
                resumeActualRenderTimerIfPaused();
                recordElapsedActualRenderTime(interruptedWork);
              }

              break;

            default:
              break;
          }
        }

        var invokeGuardedCallback$2 = ReactErrorUtils.invokeGuardedCallback;
        var hasCaughtError = ReactErrorUtils.hasCaughtError;
        var clearCaughtError = ReactErrorUtils.clearCaughtError;
        var didWarnAboutStateTransition = void 0;
        var didWarnSetStateChildContext = void 0;
        var warnAboutUpdateOnUnmounted = void 0;
        var warnAboutInvalidUpdates = void 0;
        {
          didWarnAboutStateTransition = false;
          didWarnSetStateChildContext = false;
          var didWarnStateUpdateForUnmountedComponent = {};

          warnAboutUpdateOnUnmounted = function warnAboutUpdateOnUnmounted(fiber) {
            // We show the whole stack but dedupe on the top component's name because
            // the problematic code almost always lies inside that component.
            var componentName = getComponentName(fiber) || 'ReactClass';

            if (didWarnStateUpdateForUnmountedComponent[componentName]) {
              return;
            }

            warning(false, "Can't call setState (or forceUpdate) on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in the ' + 'componentWillUnmount method.%s', getStackAddendumByWorkInProgressFiber(fiber));
            didWarnStateUpdateForUnmountedComponent[componentName] = true;
          };

          warnAboutInvalidUpdates = function warnAboutInvalidUpdates(instance) {
            switch (ReactDebugCurrentFiber.phase) {
              case 'getChildContext':
                if (didWarnSetStateChildContext) {
                  return;
                }

                warning(false, 'setState(...): Cannot call setState() inside getChildContext()');
                didWarnSetStateChildContext = true;
                break;

              case 'render':
                if (didWarnAboutStateTransition) {
                  return;
                }

                warning(false, 'Cannot update during an existing state transition (such as within ' + "`render` or another component's constructor). Render methods should " + 'be a pure function of props and state; constructor side-effects are ' + 'an anti-pattern, but can be moved to `componentWillMount`.');
                didWarnAboutStateTransition = true;
                break;
            }
          };
        } // Represents the current time in ms.

        var originalStartTimeMs = now();
        var mostRecentCurrentTime = msToExpirationTime(0);
        var mostRecentCurrentTimeMs = originalStartTimeMs; // Used to ensure computeUniqueAsyncExpiration is monotonically increases.

        var lastUniqueAsyncExpiration = 0; // Represents the expiration time that incoming updates should use. (If this
        // is NoWork, use the default strategy: async updates in async mode, sync
        // updates in sync mode.)

        var expirationContext = NoWork;
        var isWorking = false; // The next work in progress fiber that we're currently working on.

        var nextUnitOfWork = null;
        var nextRoot = null; // The time at which we're currently rendering work.

        var nextRenderExpirationTime = NoWork;
        var nextLatestTimeoutMs = -1;
        var nextRenderIsExpired = false; // The next fiber with an effect that we're currently committing.

        var nextEffect = null;
        var isCommitting$1 = false;
        var isRootReadyForCommit = false;
        var legacyErrorBoundariesThatAlreadyFailed = null; // Used for performance tracking.

        var interruptedBy = null;
        var stashedWorkInProgressProperties = void 0;
        var replayUnitOfWork = void 0;
        var isReplayingFailedUnitOfWork = void 0;
        var originalReplayError = void 0;
        var rethrowOriginalError = void 0;

        if (true && replayFailedUnitOfWorkWithInvokeGuardedCallback) {
          stashedWorkInProgressProperties = null;
          isReplayingFailedUnitOfWork = false;
          originalReplayError = null;

          replayUnitOfWork = function replayUnitOfWork(failedUnitOfWork, thrownValue, isAsync) {
            if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
              // Don't replay promises. Treat everything else like an error.
              // TODO: Need to figure out a different strategy if/when we add
              // support for catching other types.
              return;
            } // Restore the original state of the work-in-progress


            if (stashedWorkInProgressProperties === null) {
              // This should never happen. Don't throw because this code is DEV-only.
              warning(false, 'Could not replay rendering after an error. This is likely a bug in React. ' + 'Please file an issue.');
              return;
            }

            assignFiberPropertiesInDEV(failedUnitOfWork, stashedWorkInProgressProperties);

            switch (failedUnitOfWork.tag) {
              case HostRoot:
                popHostContainer(failedUnitOfWork);
                popTopLevelContextObject(failedUnitOfWork);
                break;

              case HostComponent:
                popHostContext(failedUnitOfWork);
                break;

              case ClassComponent:
                popContextProvider(failedUnitOfWork);
                break;

              case HostPortal:
                popHostContainer(failedUnitOfWork);
                break;

              case ContextProvider:
                popProvider(failedUnitOfWork);
                break;
            } // Replay the begin phase.


            isReplayingFailedUnitOfWork = true;
            originalReplayError = thrownValue;
            invokeGuardedCallback$2(null, workLoop, null, isAsync);
            isReplayingFailedUnitOfWork = false;
            originalReplayError = null;

            if (hasCaughtError()) {
              clearCaughtError();

              if (enableProfilerTimer) {
                // Stop "base" render timer again (after the re-thrown error).
                stopBaseRenderTimerIfRunning();
              }
            } else {
              // If the begin phase did not fail the second time, set this pointer
              // back to the original value.
              nextUnitOfWork = failedUnitOfWork;
            }
          };

          rethrowOriginalError = function rethrowOriginalError() {
            throw originalReplayError;
          };
        }

        function resetStack() {
          if (nextUnitOfWork !== null) {
            var interruptedWork = nextUnitOfWork.return;

            while (interruptedWork !== null) {
              unwindInterruptedWork(interruptedWork);
              interruptedWork = interruptedWork.return;
            }
          }

          {
            ReactStrictModeWarnings.discardPendingWarnings();
            checkThatStackIsEmpty();
          }
          nextRoot = null;
          nextRenderExpirationTime = NoWork;
          nextLatestTimeoutMs = -1;
          nextRenderIsExpired = false;
          nextUnitOfWork = null;
          isRootReadyForCommit = false;
        }

        function commitAllHostEffects() {
          while (nextEffect !== null) {
            {
              ReactDebugCurrentFiber.setCurrentFiber(nextEffect);
            }
            recordEffect();
            var effectTag = nextEffect.effectTag;

            if (effectTag & ContentReset) {
              commitResetTextContent(nextEffect);
            }

            if (effectTag & Ref) {
              var current = nextEffect.alternate;

              if (current !== null) {
                commitDetachRef(current);
              }
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every
            // possible bitmap value, we remove the secondary effects from the
            // effect tag and switch on that value.


            var primaryEffectTag = effectTag & (Placement | Update | Deletion);

            switch (primaryEffectTag) {
              case Placement:
                {
                  commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is inserted, before
                  // any life-cycles like componentDidMount gets called.
                  // TODO: findDOMNode doesn't rely on this any more but isMounted
                  // does and isMounted is deprecated anyway so we should be able
                  // to kill this.

                  nextEffect.effectTag &= ~Placement;
                  break;
                }

              case PlacementAndUpdate:
                {
                  // Placement
                  commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is inserted, before
                  // any life-cycles like componentDidMount gets called.

                  nextEffect.effectTag &= ~Placement; // Update

                  var _current = nextEffect.alternate;
                  commitWork(_current, nextEffect);
                  break;
                }

              case Update:
                {
                  var _current2 = nextEffect.alternate;
                  commitWork(_current2, nextEffect);
                  break;
                }

              case Deletion:
                {
                  commitDeletion(nextEffect);
                  break;
                }
            }

            nextEffect = nextEffect.nextEffect;
          }

          {
            ReactDebugCurrentFiber.resetCurrentFiber();
          }
        }

        function commitBeforeMutationLifecycles() {
          while (nextEffect !== null) {
            var effectTag = nextEffect.effectTag;

            if (effectTag & Snapshot) {
              recordEffect();
              var current = nextEffect.alternate;
              commitBeforeMutationLifeCycles(current, nextEffect);
            } // Don't cleanup effects yet;
            // This will be done by commitAllLifeCycles()


            nextEffect = nextEffect.nextEffect;
          }
        }

        function commitAllLifeCycles(finishedRoot, currentTime, committedExpirationTime) {
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();

            if (warnAboutDeprecatedLifecycles) {
              ReactStrictModeWarnings.flushPendingDeprecationWarnings();
            }

            if (warnAboutLegacyContextAPI) {
              ReactStrictModeWarnings.flushLegacyContextWarning();
            }
          }

          while (nextEffect !== null) {
            var effectTag = nextEffect.effectTag;

            if (effectTag & (Update | Callback)) {
              recordEffect();
              var current = nextEffect.alternate;
              commitLifeCycles(finishedRoot, current, nextEffect, currentTime, committedExpirationTime);
            }

            if (effectTag & Ref) {
              recordEffect();
              commitAttachRef(nextEffect);
            }

            var next = nextEffect.nextEffect; // Ensure that we clean these up so that we don't accidentally keep them.
            // I'm not actually sure this matters because we can't reset firstEffect
            // and lastEffect since they're on every node, not just the effectful
            // ones. So we have to clean everything as we reuse nodes anyway.

            nextEffect.nextEffect = null; // Ensure that we reset the effectTag here so that we can rely on effect
            // tags to reason about the current life-cycle.

            nextEffect = next;
          }
        }

        function isAlreadyFailedLegacyErrorBoundary(instance) {
          return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
        }

        function markLegacyErrorBoundaryAsFailed(instance) {
          if (legacyErrorBoundariesThatAlreadyFailed === null) {
            legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
          } else {
            legacyErrorBoundariesThatAlreadyFailed.add(instance);
          }
        }

        function commitRoot(finishedWork) {
          isWorking = true;
          isCommitting$1 = true;
          startCommitTimer();
          var root = finishedWork.stateNode;
          !(root.current !== finishedWork) ? invariant(false, 'Cannot commit the same tree as before. This is probably a bug related to the return field. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          var committedExpirationTime = root.pendingCommitExpirationTime;
          !(committedExpirationTime !== NoWork) ? invariant(false, 'Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          root.pendingCommitExpirationTime = NoWork;
          var currentTime = recalculateCurrentTime(); // Reset this to null before calling lifecycles

          ReactCurrentOwner.current = null;
          var firstEffect = void 0;

          if (finishedWork.effectTag > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if
            // it had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
              finishedWork.lastEffect.nextEffect = finishedWork;
              firstEffect = finishedWork.firstEffect;
            } else {
              firstEffect = finishedWork;
            }
          } else {
            // There is no effect on the root.
            firstEffect = finishedWork.firstEffect;
          }

          prepareForCommit(root.containerInfo); // Invoke instances of getSnapshotBeforeUpdate before mutation.

          nextEffect = firstEffect;
          startCommitSnapshotEffectsTimer();

          while (nextEffect !== null) {
            var didError = false;
            var error = void 0;
            {
              invokeGuardedCallback$2(null, commitBeforeMutationLifecycles, null);

              if (hasCaughtError()) {
                didError = true;
                error = clearCaughtError();
              }
            }

            if (didError) {
              !(nextEffect !== null) ? invariant(false, 'Should have next effect. This error is likely caused by a bug in React. Please file an issue.') : void 0;
              captureCommitPhaseError(nextEffect, error); // Clean-up

              if (nextEffect !== null) {
                nextEffect = nextEffect.nextEffect;
              }
            }
          }

          stopCommitSnapshotEffectsTimer();

          if (enableProfilerTimer) {
            recordCommitTime();
          } // Commit all the side-effects within a tree. We'll do this in two passes.
          // The first pass performs all the host insertions, updates, deletions and
          // ref unmounts.


          nextEffect = firstEffect;
          startCommitHostEffectsTimer();

          while (nextEffect !== null) {
            var _didError = false;

            var _error = void 0;

            {
              invokeGuardedCallback$2(null, commitAllHostEffects, null);

              if (hasCaughtError()) {
                _didError = true;
                _error = clearCaughtError();
              }
            }

            if (_didError) {
              !(nextEffect !== null) ? invariant(false, 'Should have next effect. This error is likely caused by a bug in React. Please file an issue.') : void 0;
              captureCommitPhaseError(nextEffect, _error); // Clean-up

              if (nextEffect !== null) {
                nextEffect = nextEffect.nextEffect;
              }
            }
          }

          stopCommitHostEffectsTimer();
          resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
          // the first pass of the commit phase, so that the previous tree is still
          // current during componentWillUnmount, but before the second pass, so that
          // the finished work is current during componentDidMount/Update.

          root.current = finishedWork; // In the second pass we'll perform all life-cycles and ref callbacks.
          // Life-cycles happen as a separate pass so that all placements, updates,
          // and deletions in the entire tree have already been invoked.
          // This pass also triggers any renderer-specific initial effects.

          nextEffect = firstEffect;
          startCommitLifeCyclesTimer();

          while (nextEffect !== null) {
            var _didError2 = false;

            var _error2 = void 0;

            {
              invokeGuardedCallback$2(null, commitAllLifeCycles, null, root, currentTime, committedExpirationTime);

              if (hasCaughtError()) {
                _didError2 = true;
                _error2 = clearCaughtError();
              }
            }

            if (_didError2) {
              !(nextEffect !== null) ? invariant(false, 'Should have next effect. This error is likely caused by a bug in React. Please file an issue.') : void 0;
              captureCommitPhaseError(nextEffect, _error2);

              if (nextEffect !== null) {
                nextEffect = nextEffect.nextEffect;
              }
            }
          }

          if (enableProfilerTimer) {
            {
              checkActualRenderTimeStackEmpty();
            }
            resetActualRenderTimer();
          }

          isCommitting$1 = false;
          isWorking = false;
          stopCommitLifeCyclesTimer();
          stopCommitTimer();

          if (typeof onCommitRoot === 'function') {
            onCommitRoot(finishedWork.stateNode);
          }

          if (true && ReactFiberInstrumentation_1.debugTool) {
            ReactFiberInstrumentation_1.debugTool.onCommitWork(finishedWork);
          }

          markCommittedPriorityLevels(root, currentTime, root.current.expirationTime);
          var remainingTime = findNextPendingPriorityLevel(root);

          if (remainingTime === NoWork) {
            // If there's no remaining work, we can clear the set of already failed
            // error boundaries.
            legacyErrorBoundariesThatAlreadyFailed = null;
          }

          return remainingTime;
        }

        function resetExpirationTime(workInProgress, renderTime) {
          if (renderTime !== Never && workInProgress.expirationTime === Never) {
            // The children of this component are hidden. Don't bubble their
            // expiration times.
            return;
          } // Check for pending updates.


          var newExpirationTime = NoWork;

          switch (workInProgress.tag) {
            case HostRoot:
            case ClassComponent:
              {
                var updateQueue = workInProgress.updateQueue;

                if (updateQueue !== null) {
                  newExpirationTime = updateQueue.expirationTime;
                }
              }
          } // TODO: Calls need to visit stateNode
          // Bubble up the earliest expiration time.
          // (And "base" render timers if that feature flag is enabled)


          if (enableProfilerTimer && workInProgress.mode & ProfileMode) {
            var treeBaseTime = workInProgress.selfBaseTime;
            var child = workInProgress.child;

            while (child !== null) {
              treeBaseTime += child.treeBaseTime;

              if (child.expirationTime !== NoWork && (newExpirationTime === NoWork || newExpirationTime > child.expirationTime)) {
                newExpirationTime = child.expirationTime;
              }

              child = child.sibling;
            }

            workInProgress.treeBaseTime = treeBaseTime;
          } else {
            var _child = workInProgress.child;

            while (_child !== null) {
              if (_child.expirationTime !== NoWork && (newExpirationTime === NoWork || newExpirationTime > _child.expirationTime)) {
                newExpirationTime = _child.expirationTime;
              }

              _child = _child.sibling;
            }
          }

          workInProgress.expirationTime = newExpirationTime;
        }

        function completeUnitOfWork(workInProgress) {
          // Attempt to complete the current unit of work, then move to the
          // next sibling. If there are no more siblings, return to the
          // parent fiber.
          while (true) {
            // The current, flushed, state of this fiber is the alternate.
            // Ideally nothing should rely on this, but relying on it here
            // means that we don't need an additional field on the work in
            // progress.
            var current = workInProgress.alternate;
            {
              ReactDebugCurrentFiber.setCurrentFiber(workInProgress);
            }
            var returnFiber = workInProgress.return;
            var siblingFiber = workInProgress.sibling;

            if ((workInProgress.effectTag & Incomplete) === NoEffect) {
              // This fiber completed.
              var next = completeWork(current, workInProgress, nextRenderExpirationTime);
              stopWorkTimer(workInProgress);
              resetExpirationTime(workInProgress, nextRenderExpirationTime);
              {
                ReactDebugCurrentFiber.resetCurrentFiber();
              }

              if (next !== null) {
                stopWorkTimer(workInProgress);

                if (true && ReactFiberInstrumentation_1.debugTool) {
                  ReactFiberInstrumentation_1.debugTool.onCompleteWork(workInProgress);
                } // If completing this work spawned new work, do that next. We'll come
                // back here again.


                return next;
              }

              if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
              (returnFiber.effectTag & Incomplete) === NoEffect) {
                // Append all the effects of the subtree and this fiber onto the effect
                // list of the parent. The completion order of the children affects the
                // side-effect order.
                if (returnFiber.firstEffect === null) {
                  returnFiber.firstEffect = workInProgress.firstEffect;
                }

                if (workInProgress.lastEffect !== null) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                  }

                  returnFiber.lastEffect = workInProgress.lastEffect;
                } // If this fiber had side-effects, we append it AFTER the children's
                // side-effects. We can perform certain side-effects earlier if
                // needed, by doing multiple passes over the effect list. We don't want
                // to schedule our own side-effect on our own list because if end up
                // reusing children we'll schedule this effect onto itself since we're
                // at the end.


                var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect list.
                // PerformedWork effect is read by React DevTools but shouldn't be committed.

                if (effectTag > PerformedWork) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = workInProgress;
                  } else {
                    returnFiber.firstEffect = workInProgress;
                  }

                  returnFiber.lastEffect = workInProgress;
                }
              }

              if (true && ReactFiberInstrumentation_1.debugTool) {
                ReactFiberInstrumentation_1.debugTool.onCompleteWork(workInProgress);
              }

              if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                return siblingFiber;
              } else if (returnFiber !== null) {
                // If there's no more work in this returnFiber. Complete the returnFiber.
                workInProgress = returnFiber;
                continue;
              } else {
                // We've reached the root.
                isRootReadyForCommit = true;
                return null;
              }
            } else {
              // This fiber did not complete because something threw. Pop values off
              // the stack without entering the complete phase. If this is a boundary,
              // capture values if possible.
              var _next = unwindWork(workInProgress, nextRenderIsExpired, nextRenderExpirationTime); // Because this fiber did not complete, don't reset its expiration time.


              if (workInProgress.effectTag & DidCapture) {
                // Restarting an error boundary
                stopFailedWorkTimer(workInProgress);
              } else {
                stopWorkTimer(workInProgress);
              }

              {
                ReactDebugCurrentFiber.resetCurrentFiber();
              }

              if (_next !== null) {
                stopWorkTimer(workInProgress);

                if (true && ReactFiberInstrumentation_1.debugTool) {
                  ReactFiberInstrumentation_1.debugTool.onCompleteWork(workInProgress);
                } // If completing this work spawned new work, do that next. We'll come
                // back here again.
                // Since we're restarting, remove anything that is not a host effect
                // from the effect tag.


                _next.effectTag &= HostEffectMask;
                return _next;
              }

              if (returnFiber !== null) {
                // Mark the parent fiber as incomplete and clear its effect list.
                returnFiber.firstEffect = returnFiber.lastEffect = null;
                returnFiber.effectTag |= Incomplete;
              }

              if (true && ReactFiberInstrumentation_1.debugTool) {
                ReactFiberInstrumentation_1.debugTool.onCompleteWork(workInProgress);
              }

              if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                return siblingFiber;
              } else if (returnFiber !== null) {
                // If there's no more work in this returnFiber. Complete the returnFiber.
                workInProgress = returnFiber;
                continue;
              } else {
                return null;
              }
            }
          } // Without this explicit null return Flow complains of invalid return type
          // TODO Remove the above while(true) loop
          // eslint-disable-next-line no-unreachable


          return null;
        }

        function performUnitOfWork(workInProgress) {
          // The current, flushed, state of this fiber is the alternate.
          // Ideally nothing should rely on this, but relying on it here
          // means that we don't need an additional field on the work in
          // progress.
          var current = workInProgress.alternate; // See if beginning this work spawns more work.

          startWorkTimer(workInProgress);
          {
            ReactDebugCurrentFiber.setCurrentFiber(workInProgress);
          }

          if (true && replayFailedUnitOfWorkWithInvokeGuardedCallback) {
            stashedWorkInProgressProperties = assignFiberPropertiesInDEV(stashedWorkInProgressProperties, workInProgress);
          }

          var next = void 0;

          if (enableProfilerTimer) {
            if (workInProgress.mode & ProfileMode) {
              startBaseRenderTimer();
            }

            next = beginWork(current, workInProgress, nextRenderExpirationTime);

            if (workInProgress.mode & ProfileMode) {
              // Update "base" time if the render wasn't bailed out on.
              recordElapsedBaseRenderTimeIfRunning(workInProgress);
              stopBaseRenderTimerIfRunning();
            }
          } else {
            next = beginWork(current, workInProgress, nextRenderExpirationTime);
          }

          {
            ReactDebugCurrentFiber.resetCurrentFiber();

            if (isReplayingFailedUnitOfWork) {
              // Currently replaying a failed unit of work. This should be unreachable,
              // because the render phase is meant to be idempotent, and it should
              // have thrown again. Since it didn't, rethrow the original error, so
              // React's internal stack is not misaligned.
              rethrowOriginalError();
            }
          }

          if (true && ReactFiberInstrumentation_1.debugTool) {
            ReactFiberInstrumentation_1.debugTool.onBeginWork(workInProgress);
          }

          if (next === null) {
            // If this doesn't spawn new work, complete the current work.
            next = completeUnitOfWork(workInProgress);
          }

          ReactCurrentOwner.current = null;
          return next;
        }

        function workLoop(isAsync) {
          if (!isAsync) {
            // Flush all expired work.
            while (nextUnitOfWork !== null) {
              nextUnitOfWork = performUnitOfWork(nextUnitOfWork);
            }
          } else {
            // Flush asynchronous work until the deadline runs out of time.
            while (nextUnitOfWork !== null && !shouldYield()) {
              nextUnitOfWork = performUnitOfWork(nextUnitOfWork);
            }

            if (enableProfilerTimer) {
              // If we didn't finish, pause the "actual" render timer.
              // We'll restart it when we resume work.
              pauseActualRenderTimerIfRunning();
            }
          }
        }

        function renderRoot(root, expirationTime, isAsync) {
          !!isWorking ? invariant(false, 'renderRoot was called recursively. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          isWorking = true; // Check if we're starting from a fresh stack, or if we're resuming from
          // previously yielded work.

          if (expirationTime !== nextRenderExpirationTime || root !== nextRoot || nextUnitOfWork === null) {
            // Reset the stack and start working from the root.
            resetStack();
            nextRoot = root;
            nextRenderExpirationTime = expirationTime;
            nextLatestTimeoutMs = -1;
            nextUnitOfWork = createWorkInProgress(nextRoot.current, null, nextRenderExpirationTime);
            root.pendingCommitExpirationTime = NoWork;
          }

          var didFatal = false;
          nextRenderIsExpired = !isAsync || nextRenderExpirationTime <= mostRecentCurrentTime;
          startWorkLoopTimer(nextUnitOfWork);

          do {
            try {
              workLoop(isAsync);
            } catch (thrownValue) {
              if (enableProfilerTimer) {
                // Stop "base" render timer in the event of an error.
                stopBaseRenderTimerIfRunning();
              }

              if (nextUnitOfWork === null) {
                // This is a fatal error.
                didFatal = true;
                onUncaughtError(thrownValue);
              } else {
                {
                  // Reset global debug state
                  // We assume this is defined in DEV
                  resetCurrentlyProcessingQueue();
                }
                var failedUnitOfWork = nextUnitOfWork;

                if (true && replayFailedUnitOfWorkWithInvokeGuardedCallback) {
                  replayUnitOfWork(failedUnitOfWork, thrownValue, isAsync);
                } // TODO: we already know this isn't true in some cases.
                // At least this shows a nicer error message until we figure out the cause.
                // https://github.com/facebook/react/issues/12449#issuecomment-386727431


                !(nextUnitOfWork !== null) ? invariant(false, 'Failed to replay rendering after an error. This is likely caused by a bug in React. Please file an issue with a reproducing case to help us find it.') : void 0;
                var sourceFiber = nextUnitOfWork;
                var returnFiber = sourceFiber.return;

                if (returnFiber === null) {
                  // This is the root. The root could capture its own errors. However,
                  // we don't know if it errors before or after we pushed the host
                  // context. This information is needed to avoid a stack mismatch.
                  // Because we're not sure, treat this as a fatal error. We could track
                  // which phase it fails in, but doesn't seem worth it. At least
                  // for now.
                  didFatal = true;
                  onUncaughtError(thrownValue);
                  break;
                }

                throwException(root, returnFiber, sourceFiber, thrownValue, nextRenderIsExpired, nextRenderExpirationTime, mostRecentCurrentTimeMs);
                nextUnitOfWork = completeUnitOfWork(sourceFiber);
              }
            }

            break;
          } while (true); // We're done performing work. Time to clean up.


          var didCompleteRoot = false;
          isWorking = false; // Yield back to main thread.

          if (didFatal) {
            stopWorkLoopTimer(interruptedBy, didCompleteRoot);
            interruptedBy = null; // There was a fatal error.

            {
              resetStackAfterFatalErrorInDev();
            }
            return null;
          } else if (nextUnitOfWork === null) {
            // We reached the root.
            if (isRootReadyForCommit) {
              didCompleteRoot = true;
              stopWorkLoopTimer(interruptedBy, didCompleteRoot);
              interruptedBy = null; // The root successfully completed. It's ready for commit.

              root.pendingCommitExpirationTime = expirationTime;
              var finishedWork = root.current.alternate;
              return finishedWork;
            } else {
              // The root did not complete.
              stopWorkLoopTimer(interruptedBy, didCompleteRoot);
              interruptedBy = null;
              !!nextRenderIsExpired ? invariant(false, 'Expired work should have completed. This error is likely caused by a bug in React. Please file an issue.') : void 0;
              markSuspendedPriorityLevel(root, expirationTime);

              if (nextLatestTimeoutMs >= 0) {
                setTimeout(function () {
                  retrySuspendedRoot(root, expirationTime);
                }, nextLatestTimeoutMs);
              }

              var firstUnblockedExpirationTime = findNextPendingPriorityLevel(root);
              onBlock(firstUnblockedExpirationTime);
              return null;
            }
          } else {
            stopWorkLoopTimer(interruptedBy, didCompleteRoot);
            interruptedBy = null; // There's more work to do, but we ran out of time. Yield back to
            // the renderer.

            return null;
          }
        }

        function dispatch(sourceFiber, value, expirationTime) {
          !(!isWorking || isCommitting$1) ? invariant(false, 'dispatch: Cannot dispatch during the render phase.') : void 0;
          var fiber = sourceFiber.return;

          while (fiber !== null) {
            switch (fiber.tag) {
              case ClassComponent:
                var ctor = fiber.type;
                var instance = fiber.stateNode;

                if (typeof ctor.getDerivedStateFromCatch === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                  var errorInfo = createCapturedValue(value, sourceFiber);
                  var update = createClassErrorUpdate(fiber, errorInfo, expirationTime);
                  enqueueUpdate(fiber, update, expirationTime);
                  scheduleWork$1(fiber, expirationTime);
                  return;
                }

                break;

              case HostRoot:
                {
                  var _errorInfo = createCapturedValue(value, sourceFiber);

                  var _update = createRootErrorUpdate(fiber, _errorInfo, expirationTime);

                  enqueueUpdate(fiber, _update, expirationTime);
                  scheduleWork$1(fiber, expirationTime);
                  return;
                }
            }

            fiber = fiber.return;
          }

          if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            var rootFiber = sourceFiber;

            var _errorInfo2 = createCapturedValue(value, rootFiber);

            var _update2 = createRootErrorUpdate(rootFiber, _errorInfo2, expirationTime);

            enqueueUpdate(rootFiber, _update2, expirationTime);
            scheduleWork$1(rootFiber, expirationTime);
          }
        }

        function captureCommitPhaseError(fiber, error) {
          return dispatch(fiber, error, Sync);
        }

        function computeAsyncExpiration(currentTime) {
          // Given the current clock time, returns an expiration time. We use rounding
          // to batch like updates together.
          // Should complete within ~1000ms. 1200ms max.
          var expirationMs = 5000;
          var bucketSizeMs = 250;
          return computeExpirationBucket(currentTime, expirationMs, bucketSizeMs);
        }

        function computeInteractiveExpiration(currentTime) {
          var expirationMs = void 0; // We intentionally set a higher expiration time for interactive updates in
          // dev than in production.
          // If the main thread is being blocked so long that you hit the expiration,
          // it's a problem that could be solved with better scheduling.
          // People will be more likely to notice this and fix it with the long
          // expiration time in development.
          // In production we opt for better UX at the risk of masking scheduling
          // problems, by expiring fast.

          {
            // Should complete within ~500ms. 600ms max.
            expirationMs = 500;
          }
          var bucketSizeMs = 100;
          return computeExpirationBucket(currentTime, expirationMs, bucketSizeMs);
        } // Creates a unique async expiration time.


        function computeUniqueAsyncExpiration() {
          var currentTime = recalculateCurrentTime();
          var result = computeAsyncExpiration(currentTime);

          if (result <= lastUniqueAsyncExpiration) {
            // Since we assume the current time monotonically increases, we only hit
            // this branch when computeUniqueAsyncExpiration is fired multiple times
            // within a 200ms window (or whatever the async bucket size is).
            result = lastUniqueAsyncExpiration + 1;
          }

          lastUniqueAsyncExpiration = result;
          return lastUniqueAsyncExpiration;
        }

        function computeExpirationForFiber(currentTime, fiber) {
          var expirationTime = void 0;

          if (expirationContext !== NoWork) {
            // An explicit expiration context was set;
            expirationTime = expirationContext;
          } else if (isWorking) {
            if (isCommitting$1) {
              // Updates that occur during the commit phase should have sync priority
              // by default.
              expirationTime = Sync;
            } else {
              // Updates during the render phase should expire at the same time as
              // the work that is being rendered.
              expirationTime = nextRenderExpirationTime;
            }
          } else {
            // No explicit expiration context was set, and we're not currently
            // performing work. Calculate a new expiration time.
            if (fiber.mode & AsyncMode) {
              if (isBatchingInteractiveUpdates) {
                // This is an interactive update
                expirationTime = computeInteractiveExpiration(currentTime);
              } else {
                // This is an async update
                expirationTime = computeAsyncExpiration(currentTime);
              }
            } else {
              // This is a sync update
              expirationTime = Sync;
            }
          }

          if (isBatchingInteractiveUpdates) {
            // This is an interactive update. Keep track of the lowest pending
            // interactive expiration time. This allows us to synchronously flush
            // all interactive updates when needed.
            if (lowestPendingInteractiveExpirationTime === NoWork || expirationTime > lowestPendingInteractiveExpirationTime) {
              lowestPendingInteractiveExpirationTime = expirationTime;
            }
          }

          return expirationTime;
        } // TODO: Rename this to scheduleTimeout or something


        function suspendRoot(root, thenable, timeoutMs, suspendedTime) {
          // Schedule the timeout.
          if (timeoutMs >= 0 && nextLatestTimeoutMs < timeoutMs) {
            nextLatestTimeoutMs = timeoutMs;
          }
        }

        function retrySuspendedRoot(root, suspendedTime) {
          markPingedPriorityLevel(root, suspendedTime);
          var retryTime = findNextPendingPriorityLevel(root);

          if (retryTime !== NoWork) {
            requestRetry(root, retryTime);
          }
        }

        function scheduleWork$1(fiber, expirationTime) {
          recordScheduleUpdate();
          {
            if (fiber.tag === ClassComponent) {
              var instance = fiber.stateNode;
              warnAboutInvalidUpdates(instance);
            }
          }
          var node = fiber;

          while (node !== null) {
            // Walk the parent path to the root and update each node's
            // expiration time.
            if (node.expirationTime === NoWork || node.expirationTime > expirationTime) {
              node.expirationTime = expirationTime;
            }

            if (node.alternate !== null) {
              if (node.alternate.expirationTime === NoWork || node.alternate.expirationTime > expirationTime) {
                node.alternate.expirationTime = expirationTime;
              }
            }

            if (node.return === null) {
              if (node.tag === HostRoot) {
                var root = node.stateNode;

                if (!isWorking && nextRenderExpirationTime !== NoWork && expirationTime < nextRenderExpirationTime) {
                  // This is an interruption. (Used for performance tracking.)
                  interruptedBy = fiber;
                  resetStack();
                }

                markPendingPriorityLevel(root, expirationTime);
                var nextExpirationTimeToWorkOn = findNextPendingPriorityLevel(root);

                if ( // If we're in the render phase, we don't need to schedule this root
                // for an update, because we'll do it before we exit...
                !isWorking || isCommitting$1 || // ...unless this is a different root than the one we're rendering.
                nextRoot !== root) {
                  requestWork(root, nextExpirationTimeToWorkOn);
                }

                if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
                  invariant(false, 'Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.');
                }
              } else {
                {
                  if (fiber.tag === ClassComponent) {
                    warnAboutUpdateOnUnmounted(fiber);
                  }
                }
                return;
              }
            }

            node = node.return;
          }
        }

        function recalculateCurrentTime() {
          // Subtract initial time so it fits inside 32bits
          mostRecentCurrentTimeMs = now() - originalStartTimeMs;
          mostRecentCurrentTime = msToExpirationTime(mostRecentCurrentTimeMs);
          return mostRecentCurrentTime;
        }

        function deferredUpdates(fn) {
          var previousExpirationContext = expirationContext;
          var currentTime = recalculateCurrentTime();
          expirationContext = computeAsyncExpiration(currentTime);

          try {
            return fn();
          } finally {
            expirationContext = previousExpirationContext;
          }
        }

        function syncUpdates(fn, a, b, c, d) {
          var previousExpirationContext = expirationContext;
          expirationContext = Sync;

          try {
            return fn(a, b, c, d);
          } finally {
            expirationContext = previousExpirationContext;
          }
        } // TODO: Everything below this is written as if it has been lifted to the
        // renderers. I'll do this in a follow-up.
        // Linked-list of roots


        var firstScheduledRoot = null;
        var lastScheduledRoot = null;
        var callbackExpirationTime = NoWork;
        var callbackID = -1;
        var isRendering = false;
        var nextFlushedRoot = null;
        var nextFlushedExpirationTime = NoWork;
        var lowestPendingInteractiveExpirationTime = NoWork;
        var deadlineDidExpire = false;
        var hasUnhandledError = false;
        var unhandledError = null;
        var deadline = null;
        var isBatchingUpdates = false;
        var isUnbatchingUpdates = false;
        var isBatchingInteractiveUpdates = false;
        var completedBatches = null; // Use these to prevent an infinite loop of nested updates

        var NESTED_UPDATE_LIMIT = 1000;
        var nestedUpdateCount = 0;
        var timeHeuristicForUnitOfWork = 1;

        function scheduleCallbackWithExpiration(expirationTime) {
          if (callbackExpirationTime !== NoWork) {
            // A callback is already scheduled. Check its expiration time (timeout).
            if (expirationTime > callbackExpirationTime) {
              // Existing callback has sufficient timeout. Exit.
              return;
            } else {
              // Existing callback has insufficient timeout. Cancel and schedule a
              // new one.
              cancelDeferredCallback(callbackID);
            } // The request callback timer is already running. Don't start a new one.

          } else {
            startRequestCallbackTimer();
          } // Compute a timeout for the given expiration time.


          var currentMs = now() - originalStartTimeMs;
          var expirationMs = expirationTimeToMs(expirationTime);
          var timeout = expirationMs - currentMs;
          callbackExpirationTime = expirationTime;
          callbackID = scheduleDeferredCallback(performAsyncWork, {
            timeout: timeout
          });
        }

        function requestRetry(root, expirationTime) {
          if (root.remainingExpirationTime === NoWork || root.remainingExpirationTime < expirationTime) {
            // For a retry, only update the remaining expiration time if it has a
            // *lower priority* than the existing value. This is because, on a retry,
            // we should attempt to coalesce as much as possible.
            requestWork(root, expirationTime);
          }
        } // requestWork is called by the scheduler whenever a root receives an update.
        // It's up to the renderer to call renderRoot at some point in the future.


        function requestWork(root, expirationTime) {
          addRootToSchedule(root, expirationTime);

          if (isRendering) {
            // Prevent reentrancy. Remaining work will be scheduled at the end of
            // the currently rendering batch.
            return;
          }

          if (isBatchingUpdates) {
            // Flush work at the end of the batch.
            if (isUnbatchingUpdates) {
              // ...unless we're inside unbatchedUpdates, in which case we should
              // flush it now.
              nextFlushedRoot = root;
              nextFlushedExpirationTime = Sync;
              performWorkOnRoot(root, Sync, false);
            }

            return;
          } // TODO: Get rid of Sync and use current time?


          if (expirationTime === Sync) {
            performSyncWork();
          } else {
            scheduleCallbackWithExpiration(expirationTime);
          }
        }

        function addRootToSchedule(root, expirationTime) {
          // Add the root to the schedule.
          // Check if this root is already part of the schedule.
          if (root.nextScheduledRoot === null) {
            // This root is not already scheduled. Add it.
            root.remainingExpirationTime = expirationTime;

            if (lastScheduledRoot === null) {
              firstScheduledRoot = lastScheduledRoot = root;
              root.nextScheduledRoot = root;
            } else {
              lastScheduledRoot.nextScheduledRoot = root;
              lastScheduledRoot = root;
              lastScheduledRoot.nextScheduledRoot = firstScheduledRoot;
            }
          } else {
            // This root is already scheduled, but its priority may have increased.
            var remainingExpirationTime = root.remainingExpirationTime;

            if (remainingExpirationTime === NoWork || expirationTime < remainingExpirationTime) {
              // Update the priority.
              root.remainingExpirationTime = expirationTime;
            }
          }
        }

        function findHighestPriorityRoot() {
          var highestPriorityWork = NoWork;
          var highestPriorityRoot = null;

          if (lastScheduledRoot !== null) {
            var previousScheduledRoot = lastScheduledRoot;
            var root = firstScheduledRoot;

            while (root !== null) {
              var remainingExpirationTime = root.remainingExpirationTime;

              if (remainingExpirationTime === NoWork) {
                // This root no longer has work. Remove it from the scheduler.
                // TODO: This check is redudant, but Flow is confused by the branch
                // below where we set lastScheduledRoot to null, even though we break
                // from the loop right after.
                !(previousScheduledRoot !== null && lastScheduledRoot !== null) ? invariant(false, 'Should have a previous and last root. This error is likely caused by a bug in React. Please file an issue.') : void 0;

                if (root === root.nextScheduledRoot) {
                  // This is the only root in the list.
                  root.nextScheduledRoot = null;
                  firstScheduledRoot = lastScheduledRoot = null;
                  break;
                } else if (root === firstScheduledRoot) {
                  // This is the first root in the list.
                  var next = root.nextScheduledRoot;
                  firstScheduledRoot = next;
                  lastScheduledRoot.nextScheduledRoot = next;
                  root.nextScheduledRoot = null;
                } else if (root === lastScheduledRoot) {
                  // This is the last root in the list.
                  lastScheduledRoot = previousScheduledRoot;
                  lastScheduledRoot.nextScheduledRoot = firstScheduledRoot;
                  root.nextScheduledRoot = null;
                  break;
                } else {
                  previousScheduledRoot.nextScheduledRoot = root.nextScheduledRoot;
                  root.nextScheduledRoot = null;
                }

                root = previousScheduledRoot.nextScheduledRoot;
              } else {
                if (highestPriorityWork === NoWork || remainingExpirationTime < highestPriorityWork) {
                  // Update the priority, if it's higher
                  highestPriorityWork = remainingExpirationTime;
                  highestPriorityRoot = root;
                }

                if (root === lastScheduledRoot) {
                  break;
                }

                previousScheduledRoot = root;
                root = root.nextScheduledRoot;
              }
            }
          } // If the next root is the same as the previous root, this is a nested
          // update. To prevent an infinite loop, increment the nested update count.


          var previousFlushedRoot = nextFlushedRoot;

          if (previousFlushedRoot !== null && previousFlushedRoot === highestPriorityRoot && highestPriorityWork === Sync) {
            nestedUpdateCount++;
          } else {
            // Reset whenever we switch roots.
            nestedUpdateCount = 0;
          }

          nextFlushedRoot = highestPriorityRoot;
          nextFlushedExpirationTime = highestPriorityWork;
        }

        function performAsyncWork(dl) {
          performWork(NoWork, true, dl);
        }

        function performSyncWork() {
          performWork(Sync, false, null);
        }

        function performWork(minExpirationTime, isAsync, dl) {
          deadline = dl; // Keep working on roots until there's no more work, or until the we reach
          // the deadline.

          findHighestPriorityRoot();

          if (enableProfilerTimer) {
            resumeActualRenderTimerIfPaused();
          }

          if (enableUserTimingAPI && deadline !== null) {
            var didExpire = nextFlushedExpirationTime < recalculateCurrentTime();
            var timeout = expirationTimeToMs(nextFlushedExpirationTime);
            stopRequestCallbackTimer(didExpire, timeout);
          }

          if (isAsync) {
            while (nextFlushedRoot !== null && nextFlushedExpirationTime !== NoWork && (minExpirationTime === NoWork || minExpirationTime >= nextFlushedExpirationTime) && (!deadlineDidExpire || recalculateCurrentTime() >= nextFlushedExpirationTime)) {
              recalculateCurrentTime();
              performWorkOnRoot(nextFlushedRoot, nextFlushedExpirationTime, !deadlineDidExpire);
              findHighestPriorityRoot();
            }
          } else {
            while (nextFlushedRoot !== null && nextFlushedExpirationTime !== NoWork && (minExpirationTime === NoWork || minExpirationTime >= nextFlushedExpirationTime)) {
              performWorkOnRoot(nextFlushedRoot, nextFlushedExpirationTime, false);
              findHighestPriorityRoot();
            }
          } // We're done flushing work. Either we ran out of time in this callback,
          // or there's no more work left with sufficient priority.
          // If we're inside a callback, set this to false since we just completed it.


          if (deadline !== null) {
            callbackExpirationTime = NoWork;
            callbackID = -1;
          } // If there's work left over, schedule a new callback.


          if (nextFlushedExpirationTime !== NoWork) {
            scheduleCallbackWithExpiration(nextFlushedExpirationTime);
          } // Clean-up.


          deadline = null;
          deadlineDidExpire = false;
          finishRendering();
        }

        function flushRoot(root, expirationTime) {
          !!isRendering ? invariant(false, 'work.commit(): Cannot commit while already rendering. This likely means you attempted to commit from inside a lifecycle method.') : void 0; // Perform work on root as if the given expiration time is the current time.
          // This has the effect of synchronously flushing all work up to and
          // including the given time.

          nextFlushedRoot = root;
          nextFlushedExpirationTime = expirationTime;
          performWorkOnRoot(root, expirationTime, false); // Flush any sync work that was scheduled by lifecycles

          performSyncWork();
          finishRendering();
        }

        function finishRendering() {
          nestedUpdateCount = 0;

          if (completedBatches !== null) {
            var batches = completedBatches;
            completedBatches = null;

            for (var i = 0; i < batches.length; i++) {
              var batch = batches[i];

              try {
                batch._onComplete();
              } catch (error) {
                if (!hasUnhandledError) {
                  hasUnhandledError = true;
                  unhandledError = error;
                }
              }
            }
          }

          if (hasUnhandledError) {
            var error = unhandledError;
            unhandledError = null;
            hasUnhandledError = false;
            throw error;
          }
        }

        function performWorkOnRoot(root, expirationTime, isAsync) {
          !!isRendering ? invariant(false, 'performWorkOnRoot was called recursively. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          isRendering = true; // Check if this is async work or sync/expired work.

          if (!isAsync) {
            // Flush sync work.
            var finishedWork = root.finishedWork;

            if (finishedWork !== null) {
              // This root is already complete. We can commit it.
              completeRoot(root, finishedWork, expirationTime);
            } else {
              root.finishedWork = null;
              finishedWork = renderRoot(root, expirationTime, false);

              if (finishedWork !== null) {
                // We've completed the root. Commit it.
                completeRoot(root, finishedWork, expirationTime);
              }
            }
          } else {
            // Flush async work.
            var _finishedWork = root.finishedWork;

            if (_finishedWork !== null) {
              // This root is already complete. We can commit it.
              completeRoot(root, _finishedWork, expirationTime);
            } else {
              root.finishedWork = null;
              _finishedWork = renderRoot(root, expirationTime, true);

              if (_finishedWork !== null) {
                // We've completed the root. Check the deadline one more time
                // before committing.
                if (!shouldYield()) {
                  // Still time left. Commit the root.
                  completeRoot(root, _finishedWork, expirationTime);
                } else {
                  // There's no time left. Mark this root as complete. We'll come
                  // back and commit it later.
                  root.finishedWork = _finishedWork;

                  if (enableProfilerTimer) {
                    // If we didn't finish, pause the "actual" render timer.
                    // We'll restart it when we resume work.
                    pauseActualRenderTimerIfRunning();
                  }
                }
              }
            }
          }

          isRendering = false;
        }

        function completeRoot(root, finishedWork, expirationTime) {
          // Check if there's a batch that matches this expiration time.
          var firstBatch = root.firstBatch;

          if (firstBatch !== null && firstBatch._expirationTime <= expirationTime) {
            if (completedBatches === null) {
              completedBatches = [firstBatch];
            } else {
              completedBatches.push(firstBatch);
            }

            if (firstBatch._defer) {
              // This root is blocked from committing by a batch. Unschedule it until
              // we receive another update.
              root.finishedWork = finishedWork;
              root.remainingExpirationTime = NoWork;
              return;
            }
          } // Commit the root.


          root.finishedWork = null;
          root.remainingExpirationTime = commitRoot(finishedWork);
        } // When working on async work, the reconciler asks the renderer if it should
        // yield execution. For DOM, we implement this with requestIdleCallback.


        function shouldYield() {
          if (deadline === null) {
            return false;
          }

          if (deadline.timeRemaining() > timeHeuristicForUnitOfWork) {
            // Disregard deadline.didTimeout. Only expired work should be flushed
            // during a timeout. This path is only hit for non-expired work.
            return false;
          }

          deadlineDidExpire = true;
          return true;
        }

        function onUncaughtError(error) {
          !(nextFlushedRoot !== null) ? invariant(false, 'Should be working on a root. This error is likely caused by a bug in React. Please file an issue.') : void 0; // Unschedule this root so we don't work on it again until there's
          // another update.

          nextFlushedRoot.remainingExpirationTime = NoWork;

          if (!hasUnhandledError) {
            hasUnhandledError = true;
            unhandledError = error;
          }
        }

        function onBlock(remainingExpirationTime) {
          !(nextFlushedRoot !== null) ? invariant(false, 'Should be working on a root. This error is likely caused by a bug in React. Please file an issue.') : void 0; // This root was blocked. Unschedule it until there's another update.

          nextFlushedRoot.remainingExpirationTime = remainingExpirationTime;
        } // TODO: Batching should be implemented at the renderer level, not inside
        // the reconciler.


        function batchedUpdates$1(fn, a) {
          var previousIsBatchingUpdates = isBatchingUpdates;
          isBatchingUpdates = true;

          try {
            return fn(a);
          } finally {
            isBatchingUpdates = previousIsBatchingUpdates;

            if (!isBatchingUpdates && !isRendering) {
              performSyncWork();
            }
          }
        } // TODO: Batching should be implemented at the renderer level, not inside
        // the reconciler.


        function unbatchedUpdates(fn, a) {
          if (isBatchingUpdates && !isUnbatchingUpdates) {
            isUnbatchingUpdates = true;

            try {
              return fn(a);
            } finally {
              isUnbatchingUpdates = false;
            }
          }

          return fn(a);
        } // TODO: Batching should be implemented at the renderer level, not within
        // the reconciler.


        function flushSync(fn, a) {
          !!isRendering ? invariant(false, 'flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.') : void 0;
          var previousIsBatchingUpdates = isBatchingUpdates;
          isBatchingUpdates = true;

          try {
            return syncUpdates(fn, a);
          } finally {
            isBatchingUpdates = previousIsBatchingUpdates;
            performSyncWork();
          }
        }

        function interactiveUpdates$1(fn, a, b) {
          if (isBatchingInteractiveUpdates) {
            return fn(a, b);
          } // If there are any pending interactive updates, synchronously flush them.
          // This needs to happen before we read any handlers, because the effect of
          // the previous event may influence which handlers are called during
          // this event.


          if (!isBatchingUpdates && !isRendering && lowestPendingInteractiveExpirationTime !== NoWork) {
            // Synchronously flush pending interactive updates.
            performWork(lowestPendingInteractiveExpirationTime, false, null);
            lowestPendingInteractiveExpirationTime = NoWork;
          }

          var previousIsBatchingInteractiveUpdates = isBatchingInteractiveUpdates;
          var previousIsBatchingUpdates = isBatchingUpdates;
          isBatchingInteractiveUpdates = true;
          isBatchingUpdates = true;

          try {
            return fn(a, b);
          } finally {
            isBatchingInteractiveUpdates = previousIsBatchingInteractiveUpdates;
            isBatchingUpdates = previousIsBatchingUpdates;

            if (!isBatchingUpdates && !isRendering) {
              performSyncWork();
            }
          }
        }

        function flushInteractiveUpdates$1() {
          if (!isRendering && lowestPendingInteractiveExpirationTime !== NoWork) {
            // Synchronously flush pending interactive updates.
            performWork(lowestPendingInteractiveExpirationTime, false, null);
            lowestPendingInteractiveExpirationTime = NoWork;
          }
        }

        function flushControlled(fn) {
          var previousIsBatchingUpdates = isBatchingUpdates;
          isBatchingUpdates = true;

          try {
            syncUpdates(fn);
          } finally {
            isBatchingUpdates = previousIsBatchingUpdates;

            if (!isBatchingUpdates && !isRendering) {
              performWork(Sync, false, null);
            }
          }
        } // 0 is PROD, 1 is DEV.
        // Might add PROFILE later.


        var didWarnAboutNestedUpdates = void 0;
        {
          didWarnAboutNestedUpdates = false;
        }

        function getContextForSubtree(parentComponent) {
          if (!parentComponent) {
            return emptyObject;
          }

          var fiber = get(parentComponent);
          var parentContext = findCurrentUnmaskedContext(fiber);
          return isContextProvider(fiber) ? processChildContext(fiber, parentContext) : parentContext;
        }

        function scheduleRootUpdate(current, element, expirationTime, callback) {
          {
            if (ReactDebugCurrentFiber.phase === 'render' && ReactDebugCurrentFiber.current !== null && !didWarnAboutNestedUpdates) {
              didWarnAboutNestedUpdates = true;
              warning(false, 'Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(ReactDebugCurrentFiber.current) || 'Unknown');
            }
          }
          var update = createUpdate(expirationTime); // Caution: React DevTools currently depends on this property
          // being called "element".

          update.payload = {
            element: element
          };
          callback = callback === undefined ? null : callback;

          if (callback !== null) {
            !(typeof callback === 'function') ? warning(false, 'render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback) : void 0;
            update.callback = callback;
          }

          enqueueUpdate(current, update, expirationTime);
          scheduleWork$1(current, expirationTime);
          return expirationTime;
        }

        function updateContainerAtExpirationTime(element, container, parentComponent, expirationTime, callback) {
          // TODO: If this is a nested container, this won't be the root.
          var current = container.current;
          {
            if (ReactFiberInstrumentation_1.debugTool) {
              if (current.alternate === null) {
                ReactFiberInstrumentation_1.debugTool.onMountContainer(container);
              } else if (element === null) {
                ReactFiberInstrumentation_1.debugTool.onUnmountContainer(container);
              } else {
                ReactFiberInstrumentation_1.debugTool.onUpdateContainer(container);
              }
            }
          }
          var context = getContextForSubtree(parentComponent);

          if (container.context === null) {
            container.context = context;
          } else {
            container.pendingContext = context;
          }

          return scheduleRootUpdate(current, element, expirationTime, callback);
        }

        function findHostInstance(component) {
          var fiber = get(component);

          if (fiber === undefined) {
            if (typeof component.render === 'function') {
              invariant(false, 'Unable to find node on an unmounted component.');
            } else {
              invariant(false, 'Argument appears to not be a ReactComponent. Keys: %s', Object.keys(component));
            }
          }

          var hostFiber = findCurrentHostFiber(fiber);

          if (hostFiber === null) {
            return null;
          }

          return hostFiber.stateNode;
        }

        function createContainer(containerInfo, isAsync, hydrate) {
          return createFiberRoot(containerInfo, isAsync, hydrate);
        }

        function updateContainer(element, container, parentComponent, callback) {
          var current = container.current;
          var currentTime = recalculateCurrentTime();
          var expirationTime = computeExpirationForFiber(currentTime, current);
          return updateContainerAtExpirationTime(element, container, parentComponent, expirationTime, callback);
        }

        function getPublicRootInstance(container) {
          var containerFiber = container.current;

          if (!containerFiber.child) {
            return null;
          }

          switch (containerFiber.child.tag) {
            case HostComponent:
              return getPublicInstance(containerFiber.child.stateNode);

            default:
              return containerFiber.child.stateNode;
          }
        }

        function findHostInstanceWithNoPortals(fiber) {
          var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

          if (hostFiber === null) {
            return null;
          }

          return hostFiber.stateNode;
        }

        function injectIntoDevTools(devToolsConfig) {
          var _findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
          return injectInternals(_assign({}, devToolsConfig, {
            findHostInstanceByFiber: function findHostInstanceByFiber(fiber) {
              var hostFiber = findCurrentHostFiber(fiber);

              if (hostFiber === null) {
                return null;
              }

              return hostFiber.stateNode;
            },
            findFiberByHostInstance: function findFiberByHostInstance(instance) {
              if (!_findFiberByHostInstance) {
                // Might not be implemented by the renderer.
                return null;
              }

              return _findFiberByHostInstance(instance);
            }
          }));
        } // This file intentionally does *not* have the Flow annotation.
        // Don't add it. See `./inline-typed.js` for an explanation.


        var DOMRenderer = Object.freeze({
          updateContainerAtExpirationTime: updateContainerAtExpirationTime,
          createContainer: createContainer,
          updateContainer: updateContainer,
          flushRoot: flushRoot,
          requestWork: requestWork,
          computeUniqueAsyncExpiration: computeUniqueAsyncExpiration,
          batchedUpdates: batchedUpdates$1,
          unbatchedUpdates: unbatchedUpdates,
          deferredUpdates: deferredUpdates,
          syncUpdates: syncUpdates,
          interactiveUpdates: interactiveUpdates$1,
          flushInteractiveUpdates: flushInteractiveUpdates$1,
          flushControlled: flushControlled,
          flushSync: flushSync,
          getPublicRootInstance: getPublicRootInstance,
          findHostInstance: findHostInstance,
          findHostInstanceWithNoPortals: findHostInstanceWithNoPortals,
          injectIntoDevTools: injectIntoDevTools
        });

        function createPortal$1(children, containerInfo, // TODO: figure out the API for cross-renderer implementation.
        implementation) {
          var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
          };
        } // TODO: this is special because it gets imported during build.


        var ReactVersion = '16.4.0'; // TODO: This type is shared between the reconciler and ReactDOM, but will
        // eventually be lifted out to the renderer.

        var topLevelUpdateWarnings = void 0;
        var warnOnInvalidCallback = void 0;
        var didWarnAboutUnstableCreatePortal = false;
        {
          if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
          Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
          Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
            warning(false, 'React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }

          topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
            if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);

              if (hostInstance) {
                !(hostInstance.parentNode === container) ? warning(false, 'render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.') : void 0;
              }
            }

            var isRootRenderedBySomeReact = !!container._reactRootContainer;
            var rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(rootEl && getInstanceFromNode$1(rootEl));
            !(!hasNonRootReactChild || isRootRenderedBySomeReact) ? warning(false, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
            !(container.nodeType !== ELEMENT_NODE || !container.tagName || container.tagName.toUpperCase() !== 'BODY') ? warning(false, 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
          };

          warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
            !(callback === null || typeof callback === 'function') ? warning(false, '%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback) : void 0;
          };
        }
        injection$2.injectFiberControlledHostComponent(ReactDOMFiberComponent);

        function ReactBatch(root) {
          var expirationTime = computeUniqueAsyncExpiration();
          this._expirationTime = expirationTime;
          this._root = root;
          this._next = null;
          this._callbacks = null;
          this._didComplete = false;
          this._hasChildren = false;
          this._children = null;
          this._defer = true;
        }

        ReactBatch.prototype.render = function (children) {
          !this._defer ? invariant(false, 'batch.render: Cannot render a batch that already committed.') : void 0;
          this._hasChildren = true;
          this._children = children;
          var internalRoot = this._root._internalRoot;
          var expirationTime = this._expirationTime;
          var work = new ReactWork();
          updateContainerAtExpirationTime(children, internalRoot, null, expirationTime, work._onCommit);
          return work;
        };

        ReactBatch.prototype.then = function (onComplete) {
          if (this._didComplete) {
            onComplete();
            return;
          }

          var callbacks = this._callbacks;

          if (callbacks === null) {
            callbacks = this._callbacks = [];
          }

          callbacks.push(onComplete);
        };

        ReactBatch.prototype.commit = function () {
          var internalRoot = this._root._internalRoot;
          var firstBatch = internalRoot.firstBatch;
          !(this._defer && firstBatch !== null) ? invariant(false, 'batch.commit: Cannot commit a batch multiple times.') : void 0;

          if (!this._hasChildren) {
            // This batch is empty. Return.
            this._next = null;
            this._defer = false;
            return;
          }

          var expirationTime = this._expirationTime; // Ensure this is the first batch in the list.

          if (firstBatch !== this) {
            // This batch is not the earliest batch. We need to move it to the front.
            // Update its expiration time to be the expiration time of the earliest
            // batch, so that we can flush it without flushing the other batches.
            if (this._hasChildren) {
              expirationTime = this._expirationTime = firstBatch._expirationTime; // Rendering this batch again ensures its children will be the final state
              // when we flush (updates are processed in insertion order: last
              // update wins).
              // TODO: This forces a restart. Should we print a warning?

              this.render(this._children);
            } // Remove the batch from the list.


            var previous = null;
            var batch = firstBatch;

            while (batch !== this) {
              previous = batch;
              batch = batch._next;
            }

            !(previous !== null) ? invariant(false, 'batch.commit: Cannot commit a batch multiple times.') : void 0;
            previous._next = batch._next; // Add it to the front.

            this._next = firstBatch;
            firstBatch = internalRoot.firstBatch = this;
          } // Synchronously flush all the work up to this batch's expiration time.


          this._defer = false;
          flushRoot(internalRoot, expirationTime); // Pop the batch from the list.

          var next = this._next;
          this._next = null;
          firstBatch = internalRoot.firstBatch = next; // Append the next earliest batch's children to the update queue.

          if (firstBatch !== null && firstBatch._hasChildren) {
            firstBatch.render(firstBatch._children);
          }
        };

        ReactBatch.prototype._onComplete = function () {
          if (this._didComplete) {
            return;
          }

          this._didComplete = true;
          var callbacks = this._callbacks;

          if (callbacks === null) {
            return;
          } // TODO: Error handling.


          for (var i = 0; i < callbacks.length; i++) {
            var _callback = callbacks[i];

            _callback();
          }
        };

        function ReactWork() {
          this._callbacks = null;
          this._didCommit = false; // TODO: Avoid need to bind by replacing callbacks in the update queue with
          // list of Work objects.

          this._onCommit = this._onCommit.bind(this);
        }

        ReactWork.prototype.then = function (onCommit) {
          if (this._didCommit) {
            onCommit();
            return;
          }

          var callbacks = this._callbacks;

          if (callbacks === null) {
            callbacks = this._callbacks = [];
          }

          callbacks.push(onCommit);
        };

        ReactWork.prototype._onCommit = function () {
          if (this._didCommit) {
            return;
          }

          this._didCommit = true;
          var callbacks = this._callbacks;

          if (callbacks === null) {
            return;
          } // TODO: Error handling.


          for (var i = 0; i < callbacks.length; i++) {
            var _callback2 = callbacks[i];
            !(typeof _callback2 === 'function') ? invariant(false, 'Invalid argument passed as callback. Expected a function. Instead received: %s', _callback2) : void 0;

            _callback2();
          }
        };

        function ReactRoot(container, isAsync, hydrate) {
          var root = createContainer(container, isAsync, hydrate);
          this._internalRoot = root;
        }

        ReactRoot.prototype.render = function (children, callback) {
          var root = this._internalRoot;
          var work = new ReactWork();
          callback = callback === undefined ? null : callback;
          {
            warnOnInvalidCallback(callback, 'render');
          }

          if (callback !== null) {
            work.then(callback);
          }

          updateContainer(children, root, null, work._onCommit);
          return work;
        };

        ReactRoot.prototype.unmount = function (callback) {
          var root = this._internalRoot;
          var work = new ReactWork();
          callback = callback === undefined ? null : callback;
          {
            warnOnInvalidCallback(callback, 'render');
          }

          if (callback !== null) {
            work.then(callback);
          }

          updateContainer(null, root, null, work._onCommit);
          return work;
        };

        ReactRoot.prototype.legacy_renderSubtreeIntoContainer = function (parentComponent, children, callback) {
          var root = this._internalRoot;
          var work = new ReactWork();
          callback = callback === undefined ? null : callback;
          {
            warnOnInvalidCallback(callback, 'render');
          }

          if (callback !== null) {
            work.then(callback);
          }

          updateContainer(children, root, parentComponent, work._onCommit);
          return work;
        };

        ReactRoot.prototype.createBatch = function () {
          var batch = new ReactBatch(this);
          var expirationTime = batch._expirationTime;
          var internalRoot = this._internalRoot;
          var firstBatch = internalRoot.firstBatch;

          if (firstBatch === null) {
            internalRoot.firstBatch = batch;
            batch._next = null;
          } else {
            // Insert sorted by expiration time then insertion order
            var insertAfter = null;
            var insertBefore = firstBatch;

            while (insertBefore !== null && insertBefore._expirationTime <= expirationTime) {
              insertAfter = insertBefore;
              insertBefore = insertBefore._next;
            }

            batch._next = insertBefore;

            if (insertAfter !== null) {
              insertAfter._next = batch;
            }
          }

          return batch;
        };
        /**
         * True if the supplied DOM node is a valid node element.
         *
         * @param {?DOMElement} node The candidate DOM node.
         * @return {boolean} True if the DOM is a valid DOM node.
         * @internal
         */


        function isValidContainer(node) {
          return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
        }

        function getReactRootElementInContainer(container) {
          if (!container) {
            return null;
          }

          if (container.nodeType === DOCUMENT_NODE) {
            return container.documentElement;
          } else {
            return container.firstChild;
          }
        }

        function shouldHydrateDueToLegacyHeuristic(container) {
          var rootElement = getReactRootElementInContainer(container);
          return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
        }

        injection$3.injectRenderer(DOMRenderer);
        var warnedAboutHydrateAPI = false;

        function legacyCreateRootFromDOMContainer(container, forceHydrate) {
          var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

          if (!shouldHydrate) {
            var warned = false;
            var rootSibling = void 0;

            while (rootSibling = container.lastChild) {
              {
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                  warned = true;
                  warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
                }
              }
              container.removeChild(rootSibling);
            }
          }

          {
            if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
              warnedAboutHydrateAPI = true;
              lowPriorityWarning$1(false, 'render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v17. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
            }
          } // Legacy roots are not async by default.

          var isAsync = false;
          return new ReactRoot(container, isAsync, shouldHydrate);
        }

        function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
          // TODO: Ensure all entry points contain this check
          !isValidContainer(container) ? invariant(false, 'Target container is not a DOM element.') : void 0;
          {
            topLevelUpdateWarnings(container);
          } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
          // member of intersection type." Whyyyyyy.

          var root = container._reactRootContainer;

          if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);

            if (typeof callback === 'function') {
              var originalCallback = callback;

              callback = function callback() {
                var instance = getPublicRootInstance(root._internalRoot);
                originalCallback.call(instance);
              };
            } // Initial mount should not be batched.


            unbatchedUpdates(function () {
              if (parentComponent != null) {
                root.legacy_renderSubtreeIntoContainer(parentComponent, children, callback);
              } else {
                root.render(children, callback);
              }
            });
          } else {
            if (typeof callback === 'function') {
              var _originalCallback = callback;

              callback = function callback() {
                var instance = getPublicRootInstance(root._internalRoot);

                _originalCallback.call(instance);
              };
            } // Update


            if (parentComponent != null) {
              root.legacy_renderSubtreeIntoContainer(parentComponent, children, callback);
            } else {
              root.render(children, callback);
            }
          }

          return getPublicRootInstance(root._internalRoot);
        }

        function createPortal(children, container) {
          var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          !isValidContainer(container) ? invariant(false, 'Target container is not a DOM element.') : void 0; // TODO: pass ReactDOM portal implementation as third argument

          return createPortal$1(children, container, null, key);
        }

        var ReactDOM = {
          createPortal: createPortal,
          findDOMNode: function findDOMNode(componentOrElement) {
            {
              var owner = ReactCurrentOwner.current;

              if (owner !== null && owner.stateNode !== null) {
                var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
                !warnedAboutRefsInRender ? warning(false, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner) || 'A component') : void 0;
                owner.stateNode._warnedAboutRefsInRender = true;
              }
            }

            if (componentOrElement == null) {
              return null;
            }

            if (componentOrElement.nodeType === ELEMENT_NODE) {
              return componentOrElement;
            }

            return findHostInstance(componentOrElement);
          },
          hydrate: function hydrate(element, container, callback) {
            // TODO: throw or warn if we couldn't hydrate?
            return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
          },
          render: function render(element, container, callback) {
            return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
          },
          unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
            !(parentComponent != null && has(parentComponent)) ? invariant(false, 'parentComponent must be a valid React Component') : void 0;
            return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
          },
          unmountComponentAtNode: function unmountComponentAtNode(container) {
            !isValidContainer(container) ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : void 0;

            if (container._reactRootContainer) {
              {
                var rootEl = getReactRootElementInContainer(container);
                var renderedByDifferentReact = rootEl && !getInstanceFromNode$1(rootEl);
                !!renderedByDifferentReact ? warning(false, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
              } // Unmount should not be batched.

              unbatchedUpdates(function () {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
                  container._reactRootContainer = null;
                });
              }); // If you call unmountComponentAtNode twice in quick succession, you'll
              // get `true` twice. That's probably fine?

              return true;
            } else {
              {
                var _rootEl = getReactRootElementInContainer(container);

                var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode$1(_rootEl)); // Check if the container itself is a React root node.

                var isContainerReactRoot = container.nodeType === 1 && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
                !!hasNonRootReactChild ? warning(false, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
              }
              return false;
            }
          },
          // Temporary alias since we already shipped React 16 RC with it.
          // TODO: remove in React 17.
          unstable_createPortal: function unstable_createPortal() {
            if (!didWarnAboutUnstableCreatePortal) {
              didWarnAboutUnstableCreatePortal = true;
              lowPriorityWarning$1(false, 'The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
            }

            return createPortal.apply(undefined, arguments);
          },
          unstable_batchedUpdates: batchedUpdates$1,
          unstable_deferredUpdates: deferredUpdates,
          flushSync: flushSync,
          unstable_flushControlled: flushControlled,
          __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
            // For TapEventPlugin which is popular in open source
            EventPluginHub: EventPluginHub,
            // Used by test-utils
            EventPluginRegistry: EventPluginRegistry,
            EventPropagators: EventPropagators,
            ReactControlledComponent: ReactControlledComponent,
            ReactDOMComponentTree: ReactDOMComponentTree,
            ReactDOMEventListener: ReactDOMEventListener
          }
        };

        ReactDOM.unstable_createRoot = function createRoot(container, options) {
          var hydrate = options != null && options.hydrate === true;
          return new ReactRoot(container, true, hydrate);
        };

        var foundDevTools = injectIntoDevTools({
          findFiberByHostInstance: getClosestInstanceFromNode,
          bundleType: 1,
          version: ReactVersion,
          rendererPackageName: 'react-dom'
        });
        {
          if (!foundDevTools && ExecutionEnvironment.canUseDOM && window.top === window.self) {
            // If we're in Chrome or Firefox, provide a download link if not installed.
            if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
              var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

              if (/^(https?|file):$/.test(protocol)) {
                console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://fb.me/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://fb.me/react-devtools-faq' : ''), 'font-weight:bold');
              }
            }
          }
        }
        var ReactDOM$2 = Object.freeze({
          default: ReactDOM
        });
        var ReactDOM$3 = ReactDOM$2 && ReactDOM || ReactDOM$2; // TODO: decide on the top-level export form.
        // This is hacky but makes it work with both Rollup and Jest.

        var reactDom = ReactDOM$3.default ? ReactDOM$3.default : ReactDOM$3;
        module.exports = reactDom;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 510 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  var _uppercasePattern = /([A-Z])/g;
  /**
   * Hyphenates a camelcased string, for example:
   *
   *   > hyphenate('backgroundColor')
   *   < "background-color"
   *
   * For CSS style names, use `hyphenateStyleName` instead which works properly
   * with all vendor prefixes, including `ms`.
   *
   * @param {string} string
   * @return {string}
   */

  function hyphenate(string) {
    return string.replace(_uppercasePattern, '-$1').toLowerCase();
  }

  module.exports = hyphenate;
  /***/
},
/* 511 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   */

  var _hyphenPattern = /-(.)/g;
  /**
   * Camelcases a hyphenated string, for example:
   *
   *   > camelize('background-color')
   *   < "backgroundColor"
   *
   * @param {string} string
   * @return {string}
   */

  function camelize(string) {
    return string.replace(_hyphenPattern, function (_, character) {
      return character.toUpperCase();
    });
  }

  module.exports = camelize;
  /***/
},
/* 512 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0
    },
    trackStyle: {},
    trackWidth: 0
  };
  exports.default = initialState;
  /***/
},
/* 513 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**
    * lodash (Custom Build) <https://lodash.com/>
    * Build: `lodash modularize exports="npm" -o ./`
    * Copyright jQuery Foundation and other contributors <https://jquery.org/>
    * Released under MIT license <https://lodash.com/license>
    * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
    * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    */

    /** Used as the `TypeError` message for "Functions" methods. */
    var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as references for various `Number` constants. */

    var NAN = 0 / 0;
    /** `Object#toString` result references. */

    var symbolTag = '[object Symbol]';
    /** Used to match leading and trailing whitespace. */

    var reTrim = /^\s+|\s+$/g;
    /** Used to detect bad signed hexadecimal string values. */

    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */

    var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */

    var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */

    var freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */

    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */

    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */

    var root = freeGlobal || freeSelf || Function('return this')();
    /** Used for built-in method references. */

    var objectProto = Object.prototype;
    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */

    var objectToString = objectProto.toString;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeMax = Math.max,
        nativeMin = Math.min;
    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */

    var now = function now() {
      return root.Date.now();
    };
    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */


    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }

      wait = toNumber(wait) || 0;

      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time; // Start the timer for the trailing edge.

        timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.

        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }

      function timerExpired() {
        var time = now();

        if (shouldInvoke(time)) {
          return trailingEdge(time);
        } // Restart the timer.


        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.

        if (trailing && lastArgs) {
          return invokeFunc(time);
        }

        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }

        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }

          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }

        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }

        return result;
      }

      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */


    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */


    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */


    function isSymbol(value) {
      return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */


    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }

      if (isSymbol(value)) {
        return NAN;
      }

      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
      }

      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }

      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }

    module.exports = debounce;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(56));
  /***/
},
/* 514 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.Track = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _classnames = __webpack_require__(90);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _innerSliderUtils = __webpack_require__(91);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } // given specifications/props for a slide, fetch all the classes that need to be applied to the slide


  var getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;

    if (spec.rtl) {
      index = spec.slideCount - 1 - spec.index;
    } else {
      index = spec.index;
    }

    slickCloned = index < 0 || index >= spec.slideCount;

    if (spec.centerMode) {
      centerOffset = Math.floor(spec.slidesToShow / 2);
      slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

      if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
        slickActive = true;
      }
    } else {
      slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    }

    var slickCurrent = index === spec.currentSlide;
    return {
      "slick-slide": true,
      "slick-active": slickActive,
      "slick-center": slickCenter,
      "slick-cloned": slickCloned,
      "slick-current": slickCurrent // dubious in case of RTL

    };
  };

  var getSlideStyle = function getSlideStyle(spec) {
    var style = {};

    if (spec.variableWidth === undefined || spec.variableWidth === false) {
      style.width = spec.slideWidth;
    }

    if (spec.fade) {
      style.position = "relative";

      if (spec.vertical) {
        style.top = -spec.index * parseInt(spec.slideHeight);
      } else {
        style.left = -spec.index * parseInt(spec.slideWidth);
      }

      style.opacity = spec.currentSlide === spec.index ? 1 : 0;
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
      style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }

    return style;
  };

  var getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
  };

  var renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];

    var childrenCount = _react2.default.Children.count(spec.children);

    var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
    var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

    _react2.default.Children.forEach(spec.children, function (elem, index) {
      var child = void 0;
      var childOnClickOptions = {
        message: "children",
        index: index,
        slidesToScroll: spec.slidesToScroll,
        currentSlide: spec.currentSlide
      }; // in case of lazyLoad, whether or not we want to fetch the slide

      if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
        child = elem;
      } else {
        child = _react2.default.createElement("div", null);
      }

      var childStyle = getSlideStyle(_extends({}, spec, {
        index: index
      }));
      var slideClass = child.props.className || "";
      var slideClasses = getSlideClasses(_extends({}, spec, {
        index: index
      })); // push a cloned element of the desired slide

      slides.push(_react2.default.cloneElement(child, {
        key: "original" + getKey(child, index),
        "data-index": index,
        className: (0, _classnames2.default)(slideClasses, slideClass),
        tabIndex: "-1",
        "aria-hidden": !slideClasses["slick-active"],
        style: _extends({
          outline: "none"
        }, child.props.style || {}, childStyle),
        onClick: function onClick(e) {
          child.props && child.props.onClick && child.props.onClick(e);

          if (spec.focusOnSelect) {
            spec.focusOnSelect(childOnClickOptions);
          }
        }
      })); // if slide needs to be precloned or postcloned

      if (spec.infinite && spec.fade === false) {
        var preCloneNo = childrenCount - index;

        if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
          key = -preCloneNo;

          if (key >= startIndex) {
            child = elem;
          }

          slideClasses = getSlideClasses(_extends({}, spec, {
            index: key
          }));
          preCloneSlides.push(_react2.default.cloneElement(child, {
            key: "precloned" + getKey(child, key),
            "data-index": key,
            tabIndex: "-1",
            className: (0, _classnames2.default)(slideClasses, slideClass),
            "aria-hidden": !slideClasses["slick-active"],
            style: _extends({}, child.props.style || {}, childStyle),
            onClick: function onClick(e) {
              child.props && child.props.onClick && child.props.onClick(e);

              if (spec.focusOnSelect) {
                spec.focusOnSelect(childOnClickOptions);
              }
            }
          }));
        }

        if (childrenCount !== spec.slidesToShow) {
          key = childrenCount + index;

          if (key < endIndex) {
            child = elem;
          }

          slideClasses = getSlideClasses(_extends({}, spec, {
            index: key
          }));
          postCloneSlides.push(_react2.default.cloneElement(child, {
            key: "postcloned" + getKey(child, key),
            "data-index": key,
            tabIndex: "-1",
            className: (0, _classnames2.default)(slideClasses, slideClass),
            "aria-hidden": !slideClasses["slick-active"],
            style: _extends({}, child.props.style || {}, childStyle),
            onClick: function onClick(e) {
              child.props && child.props.onClick && child.props.onClick(e);

              if (spec.focusOnSelect) {
                spec.focusOnSelect(childOnClickOptions);
              }
            }
          }));
        }
      }
    });

    if (spec.rtl) {
      return preCloneSlides.concat(slides, postCloneSlides).reverse();
    } else {
      return preCloneSlides.concat(slides, postCloneSlides);
    }
  };

  var Track = exports.Track = function (_React$PureComponent) {
    _inherits(Track, _React$PureComponent);

    function Track() {
      _classCallCheck(this, Track);

      return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    Track.prototype.render = function render() {
      var slides = renderSlides(this.props);
      var _props = this.props,
          onMouseEnter = _props.onMouseEnter,
          onMouseOver = _props.onMouseOver,
          onMouseLeave = _props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return _react2.default.createElement("div", _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    };

    return Track;
  }(_react2.default.PureComponent);
  /***/

},
/* 515 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.Dots = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _classnames = __webpack_require__(90);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var getDotCount = function getDotCount(spec) {
    var dots;

    if (spec.infinite) {
      dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    } else {
      dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    }

    return dots;
  };

  var Dots = exports.Dots = function (_React$PureComponent) {
    _inherits(Dots, _React$PureComponent);

    function Dots() {
      _classCallCheck(this, Dots);

      return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    Dots.prototype.clickHandler = function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    };

    Dots.prototype.render = function render() {
      var _this2 = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll,
        slidesToShow: this.props.slidesToShow,
        infinite: this.props.infinite
      }); // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458

      var _props = this.props,
          onMouseEnter = _props.onMouseEnter,
          onMouseOver = _props.onMouseOver,
          onMouseLeave = _props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
        var leftBound = i * _this2.props.slidesToScroll;
        var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
        var className = (0, _classnames2.default)({
          "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: _this2.props.slidesToScroll,
          currentSlide: _this2.props.currentSlide
        };

        var onClick = _this2.clickHandler.bind(_this2, dotOptions);

        return _react2.default.createElement("li", {
          key: i,
          className: className
        }, _react2.default.cloneElement(_this2.props.customPaging(i), {
          onClick: onClick
        }));
      });
      return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
        className: this.props.dotsClass
      }, mouseEvents));
    };

    return Dots;
  }(_react2.default.PureComponent);
  /***/

},
/* 516 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.NextArrow = exports.PrevArrow = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _classnames = __webpack_require__(90);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _innerSliderUtils = __webpack_require__(91);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
    _inherits(PrevArrow, _React$PureComponent);

    function PrevArrow() {
      _classCallCheck(this, PrevArrow);

      return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    };

    PrevArrow.prototype.render = function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames2.default)(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow = void 0;

      if (this.props.prevArrow) {
        prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
      } else {
        prevArrow = _react2.default.createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    };

    return PrevArrow;
  }(_react2.default.PureComponent);

  var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
    _inherits(NextArrow, _React$PureComponent2);

    function NextArrow() {
      _classCallCheck(this, NextArrow);

      return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
    }

    NextArrow.prototype.clickHandler = function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    };

    NextArrow.prototype.render = function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames2.default)(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow = void 0;

      if (this.props.nextArrow) {
        nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
      } else {
        nextArrow = _react2.default.createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    };

    return NextArrow;
  }(_react2.default.PureComponent);
  /***/

},
/* 517 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* WEBPACK VAR INJECTION */

  (function (global) {
    /**
    * A collection of shims that provide minimal functionality of the ES6 collections.
    *
    * These implementations are not meant to be used outside of the ResizeObserver
    * modules as they cover only a limited range of use cases.
    */

    /* eslint-disable require-jsdoc, valid-jsdoc */
    var MapShim = function () {
      if (typeof Map !== 'undefined') {
        return Map;
      }
      /**
       * Returns index in provided array that matches the specified key.
       *
       * @param {Array<Array>} arr
       * @param {*} key
       * @returns {number}
       */


      function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
          if (entry[0] === key) {
            result = index;
            return true;
          }

          return false;
        });
        return result;
      }

      return function () {
        function anonymous() {
          this.__entries__ = [];
        }

        var prototypeAccessors = {
          size: {
            configurable: true
          }
        };
        /**
         * @returns {boolean}
         */

        prototypeAccessors.size.get = function () {
          return this.__entries__.length;
        };
        /**
         * @param {*} key
         * @returns {*}
         */


        anonymous.prototype.get = function (key) {
          var index = getIndex(this.__entries__, key);
          var entry = this.__entries__[index];
          return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */


        anonymous.prototype.set = function (key, value) {
          var index = getIndex(this.__entries__, key);

          if (~index) {
            this.__entries__[index][1] = value;
          } else {
            this.__entries__.push([key, value]);
          }
        };
        /**
         * @param {*} key
         * @returns {void}
         */


        anonymous.prototype.delete = function (key) {
          var entries = this.__entries__;
          var index = getIndex(entries, key);

          if (~index) {
            entries.splice(index, 1);
          }
        };
        /**
         * @param {*} key
         * @returns {void}
         */


        anonymous.prototype.has = function (key) {
          return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */


        anonymous.prototype.clear = function () {
          this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */


        anonymous.prototype.forEach = function (callback, ctx) {
          var this$1 = this;
          if (ctx === void 0) ctx = null;

          for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
            var entry = list[i];
            callback.call(ctx, entry[1], entry[0]);
          }
        };

        Object.defineProperties(anonymous.prototype, prototypeAccessors);
        return anonymous;
      }();
    }();
    /**
     * Detects whether window and document objects are available in current environment.
     */


    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

    var global$1 = function () {
      if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
      }

      if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
      }

      if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
      } // eslint-disable-next-line no-new-func


      return Function('return this')();
    }();
    /**
     * A shim for the requestAnimationFrame which falls back to the setTimeout if
     * first one is not supported.
     *
     * @returns {number} Requests' identifier.
     */


    var requestAnimationFrame$1 = function () {
      if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
      }

      return function (callback) {
        return setTimeout(function () {
          return callback(Date.now());
        }, 1000 / 60);
      };
    }(); // Defines minimum timeout before adding a trailing call.


    var trailingTimeout = 2;
    /**
     * Creates a wrapper function which ensures that provided callback will be
     * invoked only once during the specified delay period.
     *
     * @param {Function} callback - Function to be invoked after the delay period.
     * @param {number} delay - Delay after which to invoke callback.
     * @returns {Function}
     */

    var throttle = function throttle(callback, delay) {
      var leadingCall = false,
          trailingCall = false,
          lastCallTime = 0;
      /**
       * Invokes the original callback function and schedules new invocation if
       * the "proxy" was called during current request.
       *
       * @returns {void}
       */

      function resolvePending() {
        if (leadingCall) {
          leadingCall = false;
          callback();
        }

        if (trailingCall) {
          proxy();
        }
      }
      /**
       * Callback invoked after the specified delay. It will further postpone
       * invocation of the original function delegating it to the
       * requestAnimationFrame.
       *
       * @returns {void}
       */


      function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
      }
      /**
       * Schedules invocation of the original function.
       *
       * @returns {void}
       */


      function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
          // Reject immediately following calls.
          if (timeStamp - lastCallTime < trailingTimeout) {
            return;
          } // Schedule new call to be in invoked when the pending one is resolved.
          // This is important for "transitions" which never actually start
          // immediately so there is a chance that we might miss one if change
          // happens amids the pending invocation.


          trailingCall = true;
        } else {
          leadingCall = true;
          trailingCall = false;
          setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
      }

      return proxy;
    }; // Minimum delay before invoking the update of observers.


    var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
    // might affect dimensions of observed elements.

    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
    /**
     * Singleton controller class which handles updates of ResizeObserver instances.
     */

    var ResizeObserverController = function ResizeObserverController() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    };
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */

    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */

    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */

    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */


    ResizeObserverController.prototype.addObserver = function (observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      } // Add listeners if they haven't been added yet.


      if (!this.connected_) {
        this.connect_();
      }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */


    ResizeObserverController.prototype.removeObserver = function (observer) {
      var observers = this.observers_;
      var index = observers.indexOf(observer); // Remove observer if it's present in registry.

      if (~index) {
        observers.splice(index, 1);
      } // Remove listeners if controller has no connected observers.


      if (!observers.length && this.connected_) {
        this.disconnect_();
      }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */


    ResizeObserverController.prototype.refresh = function () {
      var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
      // be future ones caused by CSS transitions.

      if (changesDetected) {
        this.refresh();
      }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *  dimensions of it's elements.
     */


    ResizeObserverController.prototype.updateObservers_ = function () {
      // Collect observers that have active observations.
      var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
      }); // Deliver notifications in a separate cycle in order to avoid any
      // collisions between observers, e.g. when multiple instances of
      // ResizeObserver are tracking the same element and the callback of one
      // of them changes content dimensions of the observed target. Sometimes
      // this may result in notifications being blocked for the rest of observers.

      activeObservers.forEach(function (observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */


    ResizeObserverController.prototype.connect_ = function () {
      // Do nothing if running in a non-browser environment or if listeners
      // have been already added.
      if (!isBrowser || this.connected_) {
        return;
      } // Subscription to the "Transitionend" event is used as a workaround for
      // delayed transitions. This way it's possible to capture at least the
      // final state of an element.


      document.addEventListener('transitionend', this.onTransitionEnd_);
      window.addEventListener('resize', this.refresh);

      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);
        this.mutationEventsAdded_ = true;
      }

      this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */


    ResizeObserverController.prototype.disconnect_ = function () {
      // Do nothing if running in a non-browser environment or if listeners
      // have been already removed.
      if (!isBrowser || !this.connected_) {
        return;
      }

      document.removeEventListener('transitionend', this.onTransitionEnd_);
      window.removeEventListener('resize', this.refresh);

      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }

      if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
      }

      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */


    ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
      var propertyName = ref.propertyName;
      if (propertyName === void 0) propertyName = ''; // Detect whether transition may affect dimensions of an element.

      var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
      });

      if (isReflowProperty) {
        this.refresh();
      }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */


    ResizeObserverController.getInstance = function () {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
      }

      return this.instance_;
    };

    ResizeObserverController.instance_ = null;
    /**
     * Defines non-writable/enumerable properties of the provided target object.
     *
     * @param {Object} target - Object for which to define properties.
     * @param {Object} props - Properties to be defined.
     * @returns {Object} Target object.
     */

    var defineConfigurable = function defineConfigurable(target, props) {
      for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];
        Object.defineProperty(target, key, {
          value: props[key],
          enumerable: false,
          writable: false,
          configurable: true
        });
      }

      return target;
    };
    /**
     * Returns the global object associated with provided element.
     *
     * @param {Object} target
     * @returns {Object}
     */


    var getWindowOf = function getWindowOf(target) {
      // Assume that the element is an instance of Node, which means that it
      // has the "ownerDocument" property from which we can retrieve a
      // corresponding global object.
      var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
      // provided element.

      return ownerGlobal || global$1;
    }; // Placeholder of an empty content rectangle.


    var emptyRect = createRectInit(0, 0, 0, 0);
    /**
     * Converts provided string to a number.
     *
     * @param {number|string} value
     * @returns {number}
     */

    function toFloat(value) {
      return parseFloat(value) || 0;
    }
    /**
     * Extracts borders size from provided styles.
     *
     * @param {CSSStyleDeclaration} styles
     * @param {...string} positions - Borders positions (top, right, ...)
     * @returns {number}
     */


    function getBordersSize(styles) {
      var positions = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        positions[len] = arguments[len + 1];
      }

      return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
      }, 0);
    }
    /**
     * Extracts paddings sizes from provided styles.
     *
     * @param {CSSStyleDeclaration} styles
     * @returns {Object} Paddings box.
     */


    function getPaddings(styles) {
      var positions = ['top', 'right', 'bottom', 'left'];
      var paddings = {};

      for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
      }

      return paddings;
    }
    /**
     * Calculates content rectangle of provided SVG element.
     *
     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
     *      to be calculated.
     * @returns {DOMRectInit}
     */


    function getSVGContentRect(target) {
      var bbox = target.getBBox();
      return createRectInit(0, 0, bbox.width, bbox.height);
    }
    /**
     * Calculates content rectangle of provided HTMLElement.
     *
     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
     * @returns {DOMRectInit}
     */


    function getHTMLElementContentRect(target) {
      // Client width & height properties can't be
      // used exclusively as they provide rounded values.
      var clientWidth = target.clientWidth;
      var clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
      // detached elements. Though elements with width & height properties less
      // than 0.5 will be discarded as well.
      //
      // Without it we would need to implement separate methods for each of
      // those cases and it's not possible to perform a precise and performance
      // effective test for hidden elements. E.g. even jQuery's ':visible' filter
      // gives wrong results for elements with width & height less than 0.5.

      if (!clientWidth && !clientHeight) {
        return emptyRect;
      }

      var styles = getWindowOf(target).getComputedStyle(target);
      var paddings = getPaddings(styles);
      var horizPad = paddings.left + paddings.right;
      var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
      // only dimensions available to JS that contain non-rounded values. It could
      // be possible to utilize the getBoundingClientRect if only it's data wasn't
      // affected by CSS transformations let alone paddings, borders and scroll bars.

      var width = toFloat(styles.width),
          height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
      // model is applied (except for IE).

      if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
          width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
          height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
      } // Following steps can't be applied to the document's root element as its
      // client[Width/Height] properties represent viewport area of the window.
      // Besides, it's as well not necessary as the <html> itself neither has
      // rendered scroll bars nor it can be clipped.


      if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.

        if (Math.abs(vertScrollbar) !== 1) {
          width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
          height -= horizScrollbar;
        }
      }

      return createRectInit(paddings.left, paddings.top, width, height);
    }
    /**
     * Checks whether provided element is an instance of the SVGGraphicsElement.
     *
     * @param {Element} target - Element to be checked.
     * @returns {boolean}
     */


    var isSVGGraphicsElement = function () {
      // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
      // interface.
      if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
          return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
      } // If it's so, then check that element is at least an instance of the
      // SVGElement and that it has the "getBBox" method.
      // eslint-disable-next-line no-extra-parens


      return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
      };
    }();
    /**
     * Checks whether provided element is a document element (<html>).
     *
     * @param {Element} target - Element to be checked.
     * @returns {boolean}
     */


    function isDocumentElement(target) {
      return target === getWindowOf(target).document.documentElement;
    }
    /**
     * Calculates an appropriate content rectangle for provided html or svg element.
     *
     * @param {Element} target - Element content rectangle of which needs to be calculated.
     * @returns {DOMRectInit}
     */


    function getContentRect(target) {
      if (!isBrowser) {
        return emptyRect;
      }

      if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
      }

      return getHTMLElementContentRect(target);
    }
    /**
     * Creates rectangle with an interface of the DOMRectReadOnly.
     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
     *
     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
     * @returns {DOMRectReadOnly}
     */


    function createReadOnlyRect(ref) {
      var x = ref.x;
      var y = ref.y;
      var width = ref.width;
      var height = ref.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

      var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
      var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

      defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
      });
      return rect;
    }
    /**
     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
     *
     * @param {number} x - X coordinate.
     * @param {number} y - Y coordinate.
     * @param {number} width - Rectangle's width.
     * @param {number} height - Rectangle's height.
     * @returns {DOMRectInit}
     */


    function createRectInit(x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    }
    /**
     * Class that is responsible for computations of the content rectangle of
     * provided DOM element and for keeping track of it's changes.
     */


    var ResizeObservation = function ResizeObservation(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    };
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */

    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */

    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */


    ResizeObservation.prototype.isActive = function () {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */


    ResizeObservation.prototype.broadcastRect = function () {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };

    var ResizeObserverEntry = function ResizeObserverEntry(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
      // and are also not enumerable in the native implementation.
      //
      // Property accessors are not being used as they'd require to define a
      // private WeakMap storage which may cause memory leaks in browsers that
      // don't support this type of collections.

      defineConfigurable(this, {
        target: target,
        contentRect: contentRect
      });
    };

    var ResizeObserverSPI = function ResizeObserverSPI(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();

      if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
      }

      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    };
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */

    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */

    /**
     * Public ResizeObserver instance which will be passed to the callback
     * function and used as a value of it's "this" binding.
     *
     * @private {ResizeObserver}
     */

    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */


    ResizeObserverSPI.prototype.observe = function (target) {
      if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
      } // Do nothing if current environment doesn't have the Element interface.


      if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
      }

      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }

      var observations = this.observations_; // Do nothing if element is already being observed.

      if (observations.has(target)) {
        return;
      }

      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this); // Force the update of observations.

      this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */


    ResizeObserverSPI.prototype.unobserve = function (target) {
      if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
      } // Do nothing if current environment doesn't have the Element interface.


      if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
      }

      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }

      var observations = this.observations_; // Do nothing if element is not being observed.

      if (!observations.has(target)) {
        return;
      }

      observations.delete(target);

      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */


    ResizeObserverSPI.prototype.disconnect = function () {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */


    ResizeObserverSPI.prototype.gatherActive = function () {
      var this$1 = this;
      this.clearActive();
      this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
          this$1.activeObservations_.push(observation);
        }
      });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */


    ResizeObserverSPI.prototype.broadcastActive = function () {
      // Do nothing if observer doesn't have active observations.
      if (!this.hasActive()) {
        return;
      }

      var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

      var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */


    ResizeObserverSPI.prototype.clearActive = function () {
      this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */


    ResizeObserverSPI.prototype.hasActive = function () {
      return this.activeObservations_.length > 0;
    }; // Registry of internal observers. If WeakMap is not available use current shim
    // for the Map collection as it has all required methods and because WeakMap
    // can't be fully polyfilled anyway.


    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
    /**
     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
     * exposing only those methods and properties that are defined in the spec.
     */

    var ResizeObserver = function ResizeObserver(callback) {
      if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
      }

      if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
      }

      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }; // Expose public methods of ResizeObserver.


    ['observe', 'unobserve', 'disconnect'].forEach(function (method) {
      ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
      };
    });

    var index = function () {
      // Export existing implementation if available.
      if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
      }

      return ResizeObserver;
    }();
    /* harmony default export */


    __webpack_exports__["default"] = index;
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(56));
  /***/
},
/* 518 */

/***/
function (module, exports, __webpack_require__) {
  var camel2hyphen = __webpack_require__(519);

  var isDimension = function isDimension(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
  };

  var obj2mq = function obj2mq(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function (feature, index) {
      var value = obj[feature];
      feature = camel2hyphen(feature); // Add px to dimension features

      if (isDimension(feature) && typeof value === 'number') {
        value = value + 'px';
      }

      if (value === true) {
        mq += feature;
      } else if (value === false) {
        mq += 'not ' + feature;
      } else {
        mq += '(' + feature + ': ' + value + ')';
      }

      if (index < features.length - 1) {
        mq += ' and ';
      }
    });
    return mq;
  };

  var json2mq = function json2mq(query) {
    var mq = '';

    if (typeof query === 'string') {
      return query;
    } // Handling array of media queries


    if (query instanceof Array) {
      query.forEach(function (q, index) {
        mq += obj2mq(q);

        if (index < query.length - 1) {
          mq += ', ';
        }
      });
      return mq;
    } // Handling single media query


    return obj2mq(query);
  };

  module.exports = json2mq;
  /***/
},
/* 519 */

/***/
function (module, exports) {
  var camel2hyphen = function camel2hyphen(str) {
    return str.replace(/[A-Z]/g, function (match) {
      return '-' + match.toLowerCase();
    }).toLowerCase();
  };

  module.exports = camel2hyphen;
  /***/
},
/* 520 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
      return _react2.default.createElement("ul", {
        style: {
          display: "block"
        }
      }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
      return _react2.default.createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true
  };
  exports.default = defaultProps;
  /***/
},
/* 521 */

/***/
function (module, exports, __webpack_require__) {
  var MediaQueryDispatch = __webpack_require__(522);

  module.exports = new MediaQueryDispatch();
  /***/
},
/* 522 */

/***/
function (module, exports, __webpack_require__) {
  var MediaQuery = __webpack_require__(523);

  var Util = __webpack_require__(183);

  var each = Util.each;
  var isFunction = Util.isFunction;
  var isArray = Util.isArray;
  /**
   * Allows for registration of query handlers.
   * Manages the query handler's state and is responsible for wiring up browser events
   *
   * @constructor
   */

  function MediaQueryDispatch() {
    if (!window.matchMedia) {
      throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
  }

  MediaQueryDispatch.prototype = {
    constructor: MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register: function register(q, options, shouldDegrade) {
      var queries = this.queries,
          isUnconditional = shouldDegrade && this.browserIsIncapable;

      if (!queries[q]) {
        queries[q] = new MediaQuery(q, isUnconditional);
      } //normalise to object in an array


      if (isFunction(options)) {
        options = {
          match: options
        };
      }

      if (!isArray(options)) {
        options = [options];
      }

      each(options, function (handler) {
        if (isFunction(handler)) {
          handler = {
            match: handler
          };
        }

        queries[q].addHandler(handler);
      });
      return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister: function unregister(q, handler) {
      var query = this.queries[q];

      if (query) {
        if (handler) {
          query.removeHandler(handler);
        } else {
          query.clear();
          delete this.queries[q];
        }
      }

      return this;
    }
  };
  module.exports = MediaQueryDispatch;
  /***/
},
/* 523 */

/***/
function (module, exports, __webpack_require__) {
  var QueryHandler = __webpack_require__(524);

  var each = __webpack_require__(183).each;
  /**
   * Represents a single media query, manages it's state and registered handlers for this query
   *
   * @constructor
   * @param {string} query the media query string
   * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
   */


  function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;

    this.listener = function (mql) {
      // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
      self.mql = mql.currentTarget || mql;
      self.assess();
    };

    this.mql.addListener(this.listener);
  }

  MediaQuery.prototype = {
    constuctor: MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler: function addHandler(handler) {
      var qh = new QueryHandler(handler);
      this.handlers.push(qh);
      this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler: function removeHandler(handler) {
      var handlers = this.handlers;
      each(handlers, function (h, i) {
        if (h.equals(handler)) {
          h.destroy();
          return !handlers.splice(i, 1); //remove from array and exit each early
        }
      });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches: function matches() {
      return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear: function clear() {
      each(this.handlers, function (handler) {
        handler.destroy();
      });
      this.mql.removeListener(this.listener);
      this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess: function assess() {
      var action = this.matches() ? 'on' : 'off';
      each(this.handlers, function (handler) {
        handler[action]();
      });
    }
  };
  module.exports = MediaQuery;
  /***/
},
/* 524 */

/***/
function (module, exports) {
  /**
   * Delegate to handle a media query being matched and unmatched.
   *
   * @param {object} options
   * @param {function} options.match callback for when the media query is matched
   * @param {function} [options.unmatch] callback for when the media query is unmatched
   * @param {function} [options.setup] one-time callback triggered the first time a query is matched
   * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
   * @constructor
   */
  function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
  }

  QueryHandler.prototype = {
    constructor: QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup: function setup() {
      if (this.options.setup) {
        this.options.setup();
      }

      this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on: function on() {
      !this.initialised && this.setup();
      this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off: function off() {
      this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy: function destroy() {
      this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals: function equals(target) {
      return this.options === target || this.options.match === target;
    }
  };
  module.exports = QueryHandler;
  /***/
},
/* 525 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(526);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../css-loader/index.js??ref--1-1!./slick.css", function () {
      var newContent = require("!!../../css-loader/index.js??ref--1-1!./slick.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 526 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, "/* Slider */\n.slick-slider\n{\n    position: relative;\n\n    display: block;\n    box-sizing: border-box;\n\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-touch-action: pan-y;\n        touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list\n{\n    position: relative;\n\n    display: block;\n    overflow: hidden;\n\n    margin: 0;\n    padding: 0;\n}\n.slick-list:focus\n{\n    outline: none;\n}\n.slick-list.dragging\n{\n    cursor: pointer;\n    cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list\n{\n    -webkit-transform: translate3d(0, 0, 0);\n       -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n         -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n\n.slick-track\n{\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.slick-track:before,\n.slick-track:after\n{\n    display: table;\n\n    content: '';\n}\n.slick-track:after\n{\n    clear: both;\n}\n.slick-loading .slick-track\n{\n    visibility: hidden;\n}\n\n.slick-slide\n{\n    display: none;\n    float: left;\n\n    height: 100%;\n    min-height: 1px;\n}\n[dir='rtl'] .slick-slide\n{\n    float: right;\n}\n.slick-slide img\n{\n    display: block;\n}\n.slick-slide.slick-loading img\n{\n    display: none;\n}\n.slick-slide.dragging img\n{\n    pointer-events: none;\n}\n.slick-initialized .slick-slide\n{\n    display: block;\n}\n.slick-loading .slick-slide\n{\n    visibility: hidden;\n}\n.slick-vertical .slick-slide\n{\n    display: block;\n\n    height: auto;\n\n    border: 1px solid transparent;\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n", ""]); // exports

  /***/
},
/* 527 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Arrow = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(184);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Arrow = exports.Arrow = function Arrow(_ref) {
    var onClick = _ref.onClick,
        type = _ref.type,
        plainDesign = _ref.plainDesign,
        heroDesign = _ref.heroDesign;
    return _react2.default.createElement('button', {
      className: 'gr-carousel__navigation\n      ' + (type === 'next' ? 'gr-carousel__navigation--next' : 'gr-carousel__navigation--prev') + '\n      ' + (plainDesign ? 'gr-carousel__navigation--plain' : '') + '\n      ' + (heroDesign ? 'gr-carousel__navigation--hero' : ''),
      onClick: onClick
    }, _react2.default.createElement('i', {
      'aria-hidden': 'true',
      className: 'gr-icon ' + (type === 'next' ? 'icon-chevron-right' : 'icon-chevron-left')
    }));
  };

  Arrow.propTypes = {
    plainDesign: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    type: _propTypes2.default.string,
    heroDesign: _propTypes2.default.bool
  };
  Arrow.defaultProps = {
    plainDesign: false,
    onClick: null,
    type: null,
    heroDesign: false
  };
  exports.default = Arrow;
  /***/
},
/* 528 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-carousel {\n  overflow: hidden;\n  position: relative; }\n  .gr-carousel__slide {\n    text-align: center;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-carousel__slide {\n        padding: 0 5px; }\n        .gr-carousel__slide--full-width {\n          padding: 0; } }\n    .gr-carousel__slide img {\n      display: block; }\n  .gr-carousel__dots {\n    position: absolute;\n    top: 15px;\n    left: 0;\n    right: 0;\n    padding: 0;\n    margin: 0;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-carousel__dots {\n        right: auto;\n        top: 20px; } }\n    @media all and (min-width: 992px) {\n      .gr-carousel__dots {\n        top: 30px; } }\n    .gr-carousel__dots li {\n      display: inline-block; }\n      @media all and (min-width: 768px) {\n        .gr-carousel__dots li:first-child .gr-carousel__dot {\n          margin-left: 0; } }\n  .gr-carousel__dot {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    margin: 0 5px;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: 0;\n    background-color: #FFFFFF;\n    border: 1px solid #7C7C7B; }\n    .gr-carousel__dot:hover, .gr-carousel__dot:focus {\n      outline: none; }\n  .gr-carousel__dots .slick-active .gr-carousel__dot {\n    background-color: #4E8382;\n    border-color: #4E8382; }\n  .gr-carousel__navigation {\n    position: absolute;\n    top: 0;\n    bottom: 5px;\n    width: 30px;\n    background-color: rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    color: #FFFFFF;\n    font-size: 30px;\n    border: none;\n    cursor: pointer;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: 0;\n    transition: background-color .3s linear; }\n    @media all and (min-width: 768px) {\n      .gr-carousel__navigation {\n        width: 50px;\n        font-size: 50px; } }\n    .gr-carousel__navigation:hover, .gr-carousel__navigation:focus {\n      background-color: rgba(0, 0, 0, 0.5);\n      transition: background-color ease .1s;\n      outline: none; }\n    .gr-carousel__navigation--plain {\n      background-color: transparent;\n      color: #000000;\n      transition: color ease .1s; }\n      .gr-carousel__navigation--plain:hover, .gr-carousel__navigation--plain:focus {\n        background-color: transparent;\n        color: #62B1AD;\n        transition: color ease .1s; }\n    .gr-carousel__navigation--prev {\n      left: 0; }\n    .gr-carousel__navigation--next {\n      right: 0; }\n    .gr-carousel__navigation--hero {\n      border-radius: 50%;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 60px;\n      height: 60px; }\n      @media all and (min-width: 992px) {\n        .gr-carousel__navigation--hero {\n          width: 80px;\n          height: 80px; } }\n    .gr-carousel__navigation--hero.gr-carousel__navigation--next {\n      display: none; }\n      @media all and (min-width: 768px) {\n        .gr-carousel__navigation--hero.gr-carousel__navigation--next {\n          right: 15px;\n          font-size: 45px;\n          display: block;\n          transition: background-color .1s linear; }\n          .gr-carousel__navigation--hero.gr-carousel__navigation--next:hover, .gr-carousel__navigation--hero.gr-carousel__navigation--next:focus {\n            background-color: #F36F4A; }\n          .gr-carousel__navigation--hero.gr-carousel__navigation--next .gr-icon {\n            vertical-align: middle;\n            display: block; } }\n      @media all and (min-width: 992px) {\n        .gr-carousel__navigation--hero.gr-carousel__navigation--next {\n          font-size: 55px;\n          right: 30px; } }\n    .gr-carousel__navigation--hero.gr-carousel__navigation--prev {\n      display: none; }\n", ""]); // exports

  /***/
},
/* 529 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Modal = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(530);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Modal = exports.Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal(props) {
      _classCallCheck(this, Modal);

      var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

      _this.handleClick = _this.handleClick.bind(_this);
      _this.onModalClose = _this.onModalClose.bind(_this);
      _this.setRef = _this.setRef.bind(_this);
      return _this;
    }

    _createClass(Modal, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        document.addEventListener('click', this.handleClick);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        document.addEventListener('keyup', function (e) {
          if (e.defaultPrevented || !_this2.props.isModalOpen) {
            return;
          }

          var KEY = e.key || e.keyCode;

          if (KEY === 'Escape' || KEY === 'Esc' || KEY === 27) {
            _this2.onModalClose();
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClick);
      }
    }, {
      key: 'onModalClose',
      value: function onModalClose() {
        this.props.onModalClose();
      }
    }, {
      key: 'setRef',
      value: function setRef(node) {
        this.modal = node;
      }
    }, {
      key: 'handleClick',
      value: function handleClick(e) {
        if (this.props.isModalOpen && !this.modal.contains(e.target) && !this.props.modalTrigger.contains(e.target)) {
          this.onModalClose();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return this.props.isModalOpen ? this.props.isModalOpen && _react2.default.createElement('div', {
          className: 'gr-modal',
          role: 'dialog',
          'aria-modal': 'true'
        }, _react2.default.createElement('div', {
          className: 'gr-modal__content',
          ref: this.setRef
        }, _react2.default.createElement('div', {
          className: 'gr-modal__inner'
        }, _react2.default.createElement('button', {
          onClick: this.onModalClose,
          className: 'gr-modal__close'
        }, _react2.default.createElement('span', {
          className: 'gr-modal__close-bar'
        })), this.props.children))) : null;
      }
    }]);

    return Modal;
  }(_react.Component);

  Modal.propTypes = {
    isModalOpen: _propTypes2.default.bool,
    onModalClose: _propTypes2.default.func,
    modalTrigger: _propTypes2.default.node,
    children: _propTypes2.default.shape()
  };
  Modal.defaultProps = {
    isModalOpen: false,
    onModalClose: null,
    modalTrigger: null,
    children: null
  };
  exports.default = Modal;
  /***/
},
/* 530 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(531);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Modal.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Modal.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 531 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  overflow: hidden;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  @media all and (min-width: 768px) {\n    .gr-modal {\n      background-color: rgba(255, 255, 255, 0.9); } }\n  .gr-modal__content {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: hidden;\n    max-width: 100%;\n    max-height: 100%;\n    display: flex;\n    align-items: center;\n    width: 1920px; }\n  .gr-modal__inner {\n    background-color: #FFFFFF;\n    position: absolute;\n    width: 100%;\n    font-weight: 300;\n    padding-top: 2em;\n    overflow: scroll;\n    z-index: 2000;\n    display: flex;\n    align-items: center; }\n  .gr-modal__close {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    z-index: 2;\n    padding: 0;\n    background-color: #FFFFFF;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: inline-flex;\n    align-content: center;\n    justify-content: center;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 30px;\n    height: 30px;\n    font-size: 15px; }\n    @media all and (min-width: 768px) {\n      .gr-modal__close {\n        width: 60px;\n        height: 60px;\n        font-size: 45px; } }\n    .gr-modal__close:hover, .gr-modal__close:focus {\n      border-color: #000000;\n      outline: none; }\n      .gr-modal__close:hover .gr-modal__close-bar::before,\n      .gr-modal__close:hover .gr-modal__close-bar::after, .gr-modal__close:focus .gr-modal__close-bar::before,\n      .gr-modal__close:focus .gr-modal__close-bar::after {\n        background-color: #000000;\n        transition: background-color linear .1s; }\n  .gr-modal__close-bar {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%); }\n    @media all and (min-width: 768px) {\n      .gr-modal__close-bar {\n        width: 45px;\n        height: 45px; } }\n    .gr-modal__close-bar::before, .gr-modal__close-bar::after {\n      content: '';\n      position: absolute;\n      width: 15px;\n      height: 2px;\n      background-color: #979797;\n      transition: background-color linear .1s; }\n      @media all and (min-width: 768px) {\n        .gr-modal__close-bar::before, .gr-modal__close-bar::after {\n          width: 45px; } }\n    .gr-modal__close-bar::before {\n      transform: rotate(45deg);\n      left: 0; }\n    .gr-modal__close-bar::after {\n      transform: rotate(-45deg);\n      right: 0; }\n  .gr-modal .gr-carousel__navigation:hover, .gr-modal .gr-carousel__navigation:focus {\n    background-color: #000000; }\n  .gr-modal .gr-carousel__navigation--hero {\n    width: 35px;\n    height: 35px;\n    font-size: 30px;\n    color: #FFFFFF; }\n    @media all and (min-width: 768px) {\n      .gr-modal .gr-carousel__navigation--hero {\n        width: 60px;\n        height: 60px;\n        font-size: 45px; } }\n    @media all and (min-width: 992px) {\n      .gr-modal .gr-carousel__navigation--hero {\n        width: 80px;\n        height: 80px;\n        font-size: 55px; } }\n  .gr-modal .gr-carousel__navigation--next {\n    right: 10px;\n    display: block; }\n  .gr-modal .gr-carousel__navigation--prev {\n    display: block;\n    left: 10px; }\n    .gr-modal .gr-carousel__navigation--prev .gr-icon {\n      vertical-align: middle;\n      display: block; }\n", ""]); // exports

  /***/
},
/* 532 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(533);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./FloorPlans.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./FloorPlans.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 533 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-floorplan {\n  margin: 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-floorplan {\n      margin-top: 40px;\n      margin-bottom: -40px;\n      padding-bottom: 40px; } }\n  @media all and (min-width: 992px) {\n    .gr-floorplan {\n      margin-top: 60px;\n      padding-bottom: 60px;\n      margin-bottom: -60px; } }\n  .gr-floorplan__container {\n    margin: 0 auto;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__container {\n        max-width: 1200px;\n        padding: 0 15px 30px; } }\n    @media all and (min-width: 992px) {\n      .gr-floorplan__container {\n        padding-bottom: 50px; } }\n  .gr-floorplan__figure {\n    margin: 0; }\n  .gr-floorplan__image {\n    height: auto; }\n  .gr-floorplan__image-description {\n    padding: 10px 40px;\n    margin: 0;\n    color: #FFFFFF;\n    background: #979797; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__image-description {\n        padding: 10px 60px;\n        background: rgba(0, 0, 0, 0.5);\n        font-size: 18px;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0; } }\n  .gr-floorplan__view {\n    text-decoration: underline; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__view {\n        font-size: 20px;\n        margin-top: -10px;\n        display: block; } }\n    @media all and (min-width: 992px) {\n      .gr-floorplan__view {\n        font-size: 26px;\n        margin-top: -30px; } }\n  .gr-floorplan__text {\n    padding: 0 15px;\n    max-width: 100%; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__text {\n        padding-right: 0;\n        margin-top: 25px; } }\n    @media all and (min-width: 992px) {\n      .gr-floorplan__text {\n        padding-left: 30px;\n        margin-top: 35px; } }\n  .gr-floorplan__floorplan-image {\n    max-height: 100%;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__floorplan-image {\n        height: 500px; } }\n  .gr-floorplan__floorplan-description {\n    margin-bottom: 0;\n    text-align: center;\n    padding: 5px 30px;\n    color: #63666A;\n    background-color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 700; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__floorplan-description {\n        font-size: 16px;\n        padding: 10px 30px; } }\n  .gr-floorplan__button-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 15px;\n    margin: 20px 0; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__button-wrapper {\n        padding-right: 0; } }\n    @media all and (min-width: 992px) {\n      .gr-floorplan__button-wrapper {\n        padding-left: 20px; } }\n  .gr-floorplan__button {\n    text-align: left;\n    margin: 0;\n    display: inline-flex;\n    align-items: center;\n    border: none;\n    text-decoration: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background: #979797; }\n    .gr-floorplan__button:hover, .gr-floorplan__button:focus {\n      outline: none; }\n  .gr-floorplan__icon {\n    font-size: 18px;\n    margin-left: 10px; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__icon {\n        margin-left: 15px; } }\n  .gr-floorplan__icon-large {\n    font-size: 50px;\n    margin-right: 15px;\n    width: 50px; }\n  .gr-floorplan__right-sail {\n    display: none;\n    width: 300px;\n    height: 400px;\n    position: absolute;\n    transform: rotate(-15deg);\n    right: -150px;\n    bottom: 20px;\n    z-index: -1; }\n    @media all and (min-width: 768px) {\n      .gr-floorplan__right-sail {\n        display: block; } }\n    @media all and (min-width: 992px) {\n      .gr-floorplan__right-sail {\n        right: -90px;\n        width: 350px;\n        bottom: 40px; } }\n", ""]); // exports

  /***/
},
/* 534 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Gallery = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Carousel = __webpack_require__(68);

  var _Img = __webpack_require__(30);

  var _generic = __webpack_require__(10);

  __webpack_require__(535);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Gallery = exports.Gallery = function Gallery(_ref) {
    var images = _ref.images;
    return _react2.default.createElement('div', {
      className: 'gr-gallery'
    }, images.length && _react2.default.createElement(_Carousel.Carousel, {
      fullWidth: 2.5
    }, images.map(function (image) {
      return _react2.default.createElement(_Img.Img, {
        key: (0, _generic.randomStr)(),
        src: image.imageurl,
        isFluid: true
      });
    })));
  };

  Gallery.propTypes = {
    images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      imageurl: _propTypes2.default.string
    }))
  };
  Gallery.defaultProps = {
    images: []
  };
  exports.default = Gallery;
  /***/
},
/* 535 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(536);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Gallery.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Gallery.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 536 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-gallery {\n  margin: 0 0 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-gallery {\n      margin: 0 0 50px 0; } }\n", ""]); // exports

  /***/
},
/* 537 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Links = __webpack_require__(37);

  var _Img = __webpack_require__(30);

  __webpack_require__(538);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var GraingerAward = function GraingerAward(_ref) {
    var title = _ref.title,
        image = _ref.image,
        description = _ref.description,
        cta = _ref.cta;
    return _react2.default.createElement('div', {
      className: 'gr-grainger-award'
    }, _react2.default.createElement('div', {
      className: 'container'
    }, _react2.default.createElement('div', {
      className: 'gr-grainger-award__content'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-grainger-award__title'
    }, title), _react2.default.createElement('div', {
      className: 'row gr-grainger-award__row'
    }, _react2.default.createElement('div', {
      className: 'col-sm col-md-3'
    }, image && _react2.default.createElement(_Img.Img, {
      src: image,
      alt: 'Grainger award',
      isFluid: true
    })), description && _react2.default.createElement('div', {
      className: 'col-md-9 gr-grainger-award__description',
      dangerouslySetInnerHTML: {
        __html: description
      }
    })), _react2.default.createElement('div', {
      className: 'gr-grainger-award__link'
    }, cta && cta.url && cta.text && _react2.default.createElement(_Links.Links, {
      location: cta.url,
      text: cta.text,
      isExternal: cta.isExternal,
      showExternalIcon: true,
      className: 'gr-cta gr-grainger-award__cta'
    })))));
  };

  GraingerAward.propTypes = {
    title: _propTypes2.default.string,
    image: _propTypes2.default.string,
    description: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    })
  };
  GraingerAward.defaultProps = {
    cta: null,
    image: null,
    description: null,
    title: null
  };
  exports.default = GraingerAward;
  /***/
},
/* 538 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(539);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./GraingerAward.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./GraingerAward.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 539 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-grainger-award {\n  margin: 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-grainger-award {\n      margin: 40px 0; } }\n  .gr-grainger-award__content {\n    padding: 15px;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-award__content {\n        padding: 35px 0;\n        max-width: 700px;\n        margin: 0 auto; } }\n  @media all and (min-width: 768px) {\n    .gr-grainger-award__row {\n      max-width: 550px;\n      margin: 0 auto; } }\n  .gr-grainger-award__title {\n    font-size: 20px;\n    text-align: center;\n    line-height: 28px;\n    color: #4E8382;\n    margin-bottom: 15px; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-award__title {\n        font-size: 28px;\n        line-height: 38px;\n        margin-bottom: 25px; } }\n  .gr-grainger-award__description {\n    padding-left: 0; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-award__description {\n        padding-left: 10px; } }\n  .gr-grainger-award__link {\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-award__link {\n        margin-top: 10px; } }\n  .gr-grainger-award__cta {\n    margin-bottom: 0;\n    margin-top: 20px; }\n  .gr-grainger-award__left-sail {\n    position: absolute;\n    z-index: -1;\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-award__left-sail {\n        display: block;\n        width: 400px;\n        height: 440px;\n        bottom: -70px;\n        left: -315px;\n        transform: rotate(90deg); } }\n  .gr-grainger-award__leaf--container {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-award__leaf--container {\n        position: absolute;\n        display: block;\n        z-index: -1;\n        right: 0; } }\n", ""]); // exports

  /***/
},
/* 540 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.GraingerBar = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactInlinesvg = __webpack_require__(541);

  var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

  var _graingerLogo = __webpack_require__(552);

  var _graingerLogo2 = _interopRequireDefault(_graingerLogo);

  __webpack_require__(553);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var GraingerBar = exports.GraingerBar = function GraingerBar(_ref) {
    var link = _ref.link;
    return _react2.default.createElement('div', {
      className: 'gr-grainger-bar'
    }, _react2.default.createElement('div', {
      className: 'gr-grainger-bar__container'
    }, _react2.default.createElement('a', {
      href: link && link.url,
      target: link && link.isExternal ? '_blank' : '_self',
      rel: 'noopener noreferrer',
      className: 'gr-grainger-bar__link'
    }, _react2.default.createElement(_reactInlinesvg2.default, {
      className: 'gr-grainger-bar__logo',
      src: _graingerLogo2.default
    }), link && link.text && _react2.default.createElement('span', {
      className: 'gr-grainger-bar__text'
    }, link.text))));
  };

  GraingerBar.propTypes = {
    link: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    })
  };
  GraingerBar.defaultProps = {
    link: null
  };
  exports.default = GraingerBar;
  /***/
},
/* 541 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_httpplease__ = __webpack_require__(542);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_httpplease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_httpplease__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain__ = __webpack_require__(547);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(549);

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var http = __WEBPACK_IMPORTED_MODULE_2_httpplease___default.a.use(__WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain___default.a);

  var Status = {
    PENDING: 'pending',
    LOADING: 'loading',
    LOADED: 'loaded',
    FAILED: 'failed',
    UNSUPPORTED: 'unsupported'
  };
  var getRequestsByUrl = {};
  var loadedIcons = {};

  var InlineSVG = function (_React$PureComponent) {
    _inherits(InlineSVG, _React$PureComponent);

    function InlineSVG(props) {
      _classCallCheck(this, InlineSVG);

      var _this = _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).call(this, props));

      _this.handleLoad = function (err, res) {
        var isCached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _this$props = _this.props,
            onLoad = _this$props.onLoad,
            src = _this$props.src;

        if (err) {
          _this.fail(err);

          return;
        }

        if (_this.isActive) {
          _this.setState({
            loadedText: res.text,
            status: Status.LOADED
          }, function () {
            onLoad(src, isCached);
          });
        }
      };

      _this.state = {
        status: Status.PENDING
      };
      _this.isActive = false;
      return _this;
    }

    _createClass(InlineSVG, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.isActive = true;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var status = this.state.status;
        var _props = this.props,
            src = _props.src,
            supportTest = _props.supportTest;
        /* istanbul ignore else */

        if (status === Status.PENDING) {
          if (supportTest()) {
            if (src) {
              this.startLoad();
              return;
            }

            this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a"
            /* configurationError */
            ])('Missing source'));
            return;
          }

          this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e"
          /* unsupportedBrowserError */
          ])());
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var src = this.props.src;

        if (prevProps.src !== src) {
          if (src) {
            this.startLoad();
            return;
          }

          this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a"
          /* configurationError */
          ])('Missing source'));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.isActive = false;
      }
    }, {
      key: 'getFile',
      value: function getFile(callback) {
        var _this2 = this;

        var _props2 = this.props,
            cacheGetRequests = _props2.cacheGetRequests,
            src = _props2.src;

        if (cacheGetRequests) {
          if (loadedIcons[src]) {
            var _loadedIcons$src = _slicedToArray(loadedIcons[src], 2),
                err = _loadedIcons$src[0],
                res = _loadedIcons$src[1];

            callback(err, res, true);
          }

          if (!getRequestsByUrl[src]) {
            getRequestsByUrl[src] = [];
            http.get(src, function (err, res) {
              getRequestsByUrl[src].forEach(function (cb) {
                var currentSrc = _this2.props.src;
                loadedIcons[src] = [err, res];

                if (src === currentSrc) {
                  cb(err, res);
                }
              });
            });
          }

          getRequestsByUrl[src].push(callback);
        } else {
          http.get(src, function (err, res) {
            var currentSrc = _this2.props.src;

            if (src === currentSrc) {
              callback(err, res);
            }
          });
        }
      }
    }, {
      key: 'fail',
      value: function fail(error) {
        var onError = this.props.onError;
        var status = error.isUnsupportedBrowserError ? Status.UNSUPPORTED : Status.FAILED;
        /* istanbul ignore else */

        if (this.isActive) {
          this.setState({
            status: status
          }, function () {
            if (typeof onError === 'function') {
              onError(error);
            }
          });
        }
      }
    }, {
      key: 'startLoad',
      value: function startLoad() {
        /* istanbul ignore else */
        if (this.isActive) {
          this.setState({
            status: Status.LOADING
          }, this.load);
        }
      }
    }, {
      key: 'load',
      value: function load() {
        var src = this.props.src;
        var match = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);

        if (match) {
          return this.handleLoad(null, {
            text: match[1] ? atob(match[2]) : decodeURIComponent(match[2])
          });
        }

        return this.getFile(this.handleLoad);
      }
    }, {
      key: 'getClassName',
      value: function getClassName() {
        var status = this.state.status;
        var className = this.props.className;
        var nextClassName = 'isvg ' + status;

        if (className) {
          nextClassName += ' ' + className;
        }

        return nextClassName;
      }
    }, {
      key: 'processSVG',
      value: function processSVG(svgText) {
        var _props3 = this.props,
            uniquifyIDs = _props3.uniquifyIDs,
            uniqueHash = _props3.uniqueHash,
            baseURL = _props3.baseURL;

        if (uniquifyIDs) {
          return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d"
          /* uniquifySVGIDs */
          ])(svgText, uniqueHash || Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c"
          /* randomString */
          ])(), baseURL);
        }

        return svgText;
      }
    }, {
      key: 'renderContents',
      value: function renderContents() {
        var status = this.state.status;
        var _props4 = this.props,
            children = _props4.children,
            preloader = _props4.preloader;

        switch (status) {
          case Status.UNSUPPORTED:
          case Status.FAILED:
            return children;

          default:
            return preloader;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var loadedText = this.state.loadedText;
        var _props5 = this.props,
            style = _props5.style,
            wrapper = _props5.wrapper;
        var content = void 0;
        var html = void 0;

        if (loadedText) {
          html = {
            __html: this.processSVG(loadedText)
          };
        } else {
          content = this.renderContents();
        }

        return wrapper({
          style: style,
          className: this.getClassName(),
          dangerouslySetInnerHTML: html
        }, content);
      }
    }]);

    return InlineSVG;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

  InlineSVG.propTypes = {
    baseURL: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    cacheGetRequests: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    preloader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    supportTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    uniqueHash: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    uniquifyIDs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    wrapper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };
  InlineSVG.defaultProps = {
    baseURL: '',
    cacheGetRequests: false,
    onLoad: function onLoad() {},
    supportTest: __WEBPACK_IMPORTED_MODULE_4__utils__["b"
    /* isSupportedEnvironment */
    ],
    uniquifyIDs: true,
    wrapper: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createFactory('span')
  };
  /* harmony default export */

  __webpack_exports__["default"] = InlineSVG;
  /***/
},
/* 542 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var cleanURL = __webpack_require__(543),
      XHR = __webpack_require__(544),
      delay = __webpack_require__(545),
      RequestError = __webpack_require__(546),
      Response = __webpack_require__(185),
      Request = __webpack_require__(186),
      extend = __webpack_require__(129),
      once = __webpack_require__(188);

  var i,
      createError = RequestError.create;

  function factory(defaults, plugins) {
    defaults = defaults || {};
    plugins = plugins || [];

    function http(req, cb) {
      var xhr, plugin, done, k, timeoutId, supportsLoadAndErrorEvents;
      req = new Request(extend(defaults, req));

      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];

        if (plugin.processRequest) {
          plugin.processRequest(req);
        }
      } // Give the plugins a chance to create the XHR object


      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];

        if (plugin.createXHR) {
          xhr = plugin.createXHR(req);
          break; // First come, first serve
        }
      }

      xhr = xhr || new XHR();
      req.xhr = xhr; // Use a single completion callback. This can be called with or without
      // an error. If no error is passed, the request will be examined to see
      // if it was successful.

      done = once(delay(function (rawError) {
        clearTimeout(timeoutId);
        xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = xhr.ontimeout = xhr.onprogress = null;
        var err = getError(req, rawError);
        var res = err || Response.fromRequest(req);

        for (i = 0; i < plugins.length; i++) {
          plugin = plugins[i];

          if (plugin.processResponse) {
            plugin.processResponse(res);
          }
        } // Invoke callbacks


        if (err && req.onerror) req.onerror(err);
        if (!err && req.onload) req.onload(res);
        if (cb) cb(err, err ? undefined : res);
      }));
      supportsLoadAndErrorEvents = 'onload' in xhr && 'onerror' in xhr;

      xhr.onload = function () {
        done();
      };

      xhr.onerror = done;

      xhr.onabort = function () {
        done();
      }; // We'd rather use `onload`, `onerror`, and `onabort` since they're the
      // only way to reliably detect successes and failures but, if they
      // aren't available, we fall back to using `onreadystatechange`.


      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        if (req.aborted) return done();

        if (!supportsLoadAndErrorEvents) {
          // Assume a status of 0 is an error. This could be a false
          // positive, but there's no way to tell when using
          // `onreadystatechange` ):
          // See matthewwithanm/react-inlinesvg#10.
          // Some browsers don't like you reading XHR properties when the
          // XHR has been aborted. In case we've gotten here as a result
          // of that (either our calling `about()` in the timeout handler
          // or the user calling it directly even though they shouldn't),
          // be careful about accessing it.
          var status;

          try {
            status = xhr.status;
          } catch (err) {}

          var err = status === 0 ? new Error('Internal XHR Error') : null;
          return done(err);
        }
      }; // IE sometimes fails if you don't specify every handler.
      // See http://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment


      xhr.ontimeout = function () {
        /* noop */
      };

      xhr.onprogress = function () {
        /* noop */
      };

      xhr.open(req.method, req.url);

      if (req.timeout) {
        // If we use the normal XHR timeout mechanism (`xhr.timeout` and
        // `xhr.ontimeout`), `onreadystatechange` will be triggered before
        // `ontimeout`. There's no way to recognize that it was triggered by
        // a timeout, and we'd be unable to dispatch the right error.
        timeoutId = setTimeout(function () {
          req.timedOut = true;
          done();

          try {
            xhr.abort();
          } catch (err) {}
        }, req.timeout);
      }

      for (k in req.headers) {
        if (req.headers.hasOwnProperty(k)) {
          xhr.setRequestHeader(k, req.headers[k]);
        }
      }

      xhr.send(req.body);
      return req;
    }

    var method,
        methods = ['get', 'post', 'put', 'head', 'patch', 'delete'],
        verb = function verb(method) {
      return function (req, cb) {
        req = new Request(req);
        req.method = method;
        return http(req, cb);
      };
    };

    for (i = 0; i < methods.length; i++) {
      method = methods[i];
      http[method] = verb(method);
    }

    http.plugins = function () {
      return plugins;
    };

    http.defaults = function (newValues) {
      if (newValues) {
        return factory(extend(defaults, newValues), plugins);
      }

      return defaults;
    };

    http.use = function () {
      var newPlugins = Array.prototype.slice.call(arguments, 0);
      return factory(defaults, plugins.concat(newPlugins));
    };

    http.bare = function () {
      return factory();
    };

    http.Request = Request;
    http.Response = Response;
    http.RequestError = RequestError;
    return http;
  }

  module.exports = factory({}, [cleanURL]);
  /**
   * Analyze the request to see if it represents an error. If so, return it! An
   * original error object can be passed as a hint.
   */

  function getError(req, err) {
    if (req.aborted) return createError('Request aborted', req, {
      name: 'Abort'
    });
    if (req.timedOut) return createError('Request timeout', req, {
      name: 'Timeout'
    });
    var xhr = req.xhr;
    var type = Math.floor(xhr.status / 100);
    var kind;

    switch (type) {
      case 0:
      case 2:
        // These don't represent errors unless the function was passed an
        // error object explicitly.
        if (!err) return;
        return createError(err.message, req);

      case 4:
        // Sometimes 4XX statuses aren't errors.
        if (xhr.status === 404 && !req.errorOn404) return;
        kind = 'Client';
        break;

      case 5:
        kind = 'Server';
        break;

      default:
        kind = 'HTTP';
    }

    var msg = kind + ' Error: ' + 'The server returned a status of ' + xhr.status + ' for the request "' + req.method.toUpperCase() + ' ' + req.url + '"';
    return createError(msg, req);
  }
  /***/

},
/* 543 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  module.exports = {
    processRequest: function processRequest(req) {
      req.url = req.url.replace(/[^%]+/g, function (s) {
        return encodeURI(s);
      });
    }
  };
  /***/
},
/* 544 */

/***/
function (module, exports) {
  module.exports = window.XMLHttpRequest;
  /***/
},
/* 545 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // Wrap a function in a `setTimeout` call. This is used to guarantee async
  // behavior, which can avoid unexpected errors.

  module.exports = function (fn) {
    return function () {
      var args = Array.prototype.slice.call(arguments, 0),
          newFunc = function newFunc() {
        return fn.apply(null, args);
      };

      setTimeout(newFunc, 0);
    };
  };
  /***/

},
/* 546 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var Response = __webpack_require__(185);

  var extractResponseProps = __webpack_require__(187);

  var extend = __webpack_require__(129);

  function RequestError(message, props) {
    var err = new Error(message);
    err.name = 'RequestError';
    this.name = err.name;
    this.message = err.message;

    if (err.stack) {
      this.stack = err.stack;
    }

    this.toString = function () {
      return this.message;
    };

    for (var k in props) {
      if (props.hasOwnProperty(k)) {
        this[k] = props[k];
      }
    }
  }

  RequestError.prototype = extend(Error.prototype);
  RequestError.prototype.constructor = RequestError;

  RequestError.create = function (message, req, props) {
    var err = new RequestError(message, props);
    Response.call(err, extractResponseProps(req));
    return err;
  };

  module.exports = RequestError;
  /***/
},
/* 547 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var urllite = __webpack_require__(548),
      once = __webpack_require__(188);

  var warningShown = false;
  var supportsXHR = once(function () {
    return typeof window !== 'undefined' && window !== null && window.XMLHttpRequest && 'withCredentials' in new window.XMLHttpRequest();
  }); // This plugin creates a Microsoft `XDomainRequest` in supporting browsers when
  // the URL being requested is on a different domain. This is necessary to
  // support IE9, which only supports CORS via its proprietary `XDomainRequest`
  // object. We need to check the URL because `XDomainRequest` *doesn't* work for
  // same domain requests (unless your server sends CORS headers).
  // `XDomainRequest` also has other limitations (no custom headers), so we try to
  // catch those and error.

  module.exports = {
    createXHR: function createXHR(req) {
      var a, b, k;

      if (typeof window === 'undefined' || window === null) {
        return;
      }

      a = urllite(req.url);
      b = urllite(window.location.href); // Don't do anything for same-domain requests.

      if (!a.host) {
        return;
      }

      if (a.protocol === b.protocol && a.host === b.host && a.port === b.port) {
        return;
      } // Show a warning if there are custom headers. We do this even in
      // browsers that won't use XDomainRequest so that users know there's an
      // issue right away, instead of if/when they test in IE9.


      if (!warningShown && req.headers) {
        for (k in req.headers) {
          if (req.headers.hasOwnProperty(k)) {
            warningShown = true;

            if (window && window.console && window.console.warn) {
              window.console.warn('Request headers are ignored in old IE when using the oldiexdomain plugin.');
            }

            break;
          }
        }
      } // Don't do anything if we can't do anything (:
      // Don't do anything if the browser supports proper XHR.


      if (window.XDomainRequest && !supportsXHR()) {
        // We've come this far. Might as well make an XDomainRequest.
        var xdr = new window.XDomainRequest();

        xdr.setRequestHeader = function () {}; // Ignore request headers.


        return xdr;
      }
    }
  };
  /***/
},
/* 548 */

/***/
function (module, exports) {
  (function () {
    var URL,
        URL_PATTERN,
        defaults,
        _urllite,
        __hasProp = {}.hasOwnProperty;

    URL_PATTERN = /^(?:(?:([^:\/?\#]+:)\/+|(\/\/))(?:([a-z0-9-\._~%]+)(?::([a-z0-9-\._~%]+))?@)?(([a-z0-9-\._~%!$&'()*+,;=]+)(?::([0-9]+))?)?)?([^?\#]*?)(\?[^\#]*)?(\#.*)?$/;

    _urllite = function urllite(raw, opts) {
      return _urllite.URL.parse(raw, opts);
    };

    _urllite.URL = URL = function () {
      function URL(props) {
        var k, v, _ref;

        for (k in defaults) {
          if (!__hasProp.call(defaults, k)) continue;
          v = defaults[k];
          this[k] = (_ref = props[k]) != null ? _ref : v;
        }

        this.host || (this.host = this.hostname && this.port ? "" + this.hostname + ":" + this.port : this.hostname ? this.hostname : '');
        this.origin || (this.origin = this.protocol ? "" + this.protocol + "//" + this.host : '');
        this.isAbsolutePathRelative = !this.host && this.pathname.charAt(0) === '/';
        this.isPathRelative = !this.host && this.pathname.charAt(0) !== '/';
        this.isRelative = this.isSchemeRelative || this.isAbsolutePathRelative || this.isPathRelative;
        this.isAbsolute = !this.isRelative;
      }

      URL.parse = function (raw) {
        var m, pathname, protocol;
        m = raw.toString().match(URL_PATTERN);
        pathname = m[8] || '';
        protocol = m[1];
        return new _urllite.URL({
          protocol: protocol,
          username: m[3],
          password: m[4],
          hostname: m[6],
          port: m[7],
          pathname: protocol && pathname.charAt(0) !== '/' ? "/" + pathname : pathname,
          search: m[9],
          hash: m[10],
          isSchemeRelative: m[2] != null
        });
      };

      return URL;
    }();

    defaults = {
      protocol: '',
      username: '',
      password: '',
      host: '',
      hostname: '',
      port: '',
      pathname: '',
      search: '',
      hash: '',
      origin: '',
      isSchemeRelative: false
    };
    module.exports = _urllite;
  }).call(this);
  /***/
},
/* 549 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export supportsInlineSVG */

  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return isSupportedEnvironment;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return randomString;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return uniquifySVGIDs;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return unsupportedBrowserError;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return configurationError;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_once__ = __webpack_require__(550);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_once__);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsInlineSVG = __WEBPACK_IMPORTED_MODULE_0_once___default()(function () {
    /* istanbul ignore next */
    if (!document) {
      return false;
    }

    var div = document.createElement('div');
    div.innerHTML = '<svg />';
    return div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
  });

  var isSupportedEnvironment = __WEBPACK_IMPORTED_MODULE_0_once___default()(function () {
    return supportsInlineSVG() && typeof window !== 'undefined' && window !== null ? window.XMLHttpRequest || window.XDomainRequest : false;
  });

  var randomString = function randomString() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    var letters = 'abcdefghijklmnopqrstuvwxyz';
    var numbers = '1234567890';
    var charset = letters + letters.toUpperCase() + numbers;

    var randomCharacter = function randomCharacter(array) {
      return array[Math.floor(Math.random() * array.length)];
    };

    var R = '';

    for (var i = 0; i < length; i++) {
      R += randomCharacter(charset);
    }

    return R;
  };

  var uniquifySVGIDs = function () {
    var mkAttributePattern = function mkAttributePattern(attr) {
      return '(?:(?:\\s|\\:)' + attr + ')';
    };

    var idPattern = new RegExp('(?:(' + mkAttributePattern('id') + ')="([^"]+)")|(?:(' + mkAttributePattern('href') + '|' + mkAttributePattern('role') + '|' + mkAttributePattern('arcrole') + ')="\\#([^"]+)")|(?:="url\\(\\#([^\\)]+)\\)")|(?:url\\(\\#([^\\)]+)\\))', 'g');
    return function (svgText, svgID, baseURL) {
      var uniquifyID = function uniquifyID(id) {
        return id + '___' + svgID;
      };

      return svgText.replace(idPattern, function (m, p1, p2, p3, p4, p5, p6) {
        //eslint-disable-line consistent-return

        /* istanbul ignore else */
        if (p2) {
          return p1 + '="' + uniquifyID(p2) + '"';
        }

        if (p4) {
          return p3 + '="' + baseURL + '#' + uniquifyID(p4) + '"';
        }

        if (p5) {
          return '="url(' + baseURL + '#' + uniquifyID(p5) + ')"';
        }

        if (p6) {
          return 'url(' + baseURL + '#' + uniquifyID(p6) + ')';
        }
      });
    };
  }();

  var InlineSVGError = function (_Error) {
    _inherits(InlineSVGError, _Error);

    function InlineSVGError(message) {
      var _ret;

      _classCallCheck(this, InlineSVGError);

      var _this = _possibleConstructorReturn(this, (InlineSVGError.__proto__ || Object.getPrototypeOf(InlineSVGError)).call(this));

      _this.name = 'InlineSVGError';
      _this.isSupportedBrowser = true;
      _this.isConfigurationError = false;
      _this.isUnsupportedBrowserError = false;
      _this.message = message;
      return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    return InlineSVGError;
  }(Error);

  var createError = function createError(message, attrs) {
    var err = new InlineSVGError(message);
    return _extends({}, err, attrs);
  };

  var unsupportedBrowserError = function unsupportedBrowserError(message) {
    var newMessage = message;
    /* istanbul ignore else */

    if (!newMessage) {
      newMessage = 'Unsupported Browser';
    }

    return createError(newMessage, {
      isSupportedBrowser: false,
      isUnsupportedBrowserError: true
    });
  };

  var configurationError = function configurationError(message) {
    return createError(message, {
      isConfigurationError: true
    });
  };
  /***/

},
/* 550 */

/***/
function (module, exports, __webpack_require__) {
  var wrappy = __webpack_require__(551);

  module.exports = wrappy(once);
  module.exports.strict = wrappy(onceStrict);
  once.proto = once(function () {
    Object.defineProperty(Function.prototype, 'once', {
      value: function value() {
        return once(this);
      },
      configurable: true
    });
    Object.defineProperty(Function.prototype, 'onceStrict', {
      value: function value() {
        return onceStrict(this);
      },
      configurable: true
    });
  });

  function once(fn) {
    var f = function f() {
      if (f.called) return f.value;
      f.called = true;
      return f.value = fn.apply(this, arguments);
    };

    f.called = false;
    return f;
  }

  function onceStrict(fn) {
    var f = function f() {
      if (f.called) throw new Error(f.onceError);
      f.called = true;
      return f.value = fn.apply(this, arguments);
    };

    var name = fn.name || 'Function wrapped with `once`';
    f.onceError = name + " shouldn't be called more than once";
    f.called = false;
    return f;
  }
  /***/

},
/* 551 */

/***/
function (module, exports) {
  // Returns a wrapper function that returns a wrapped callback
  // The wrapper function should do some stuff, and return a
  // presumably different callback function.
  // This makes sure that own properties are retained, so that
  // decorations and such are not lost along the way.
  module.exports = wrappy;

  function wrappy(fn, cb) {
    if (fn && cb) return wrappy(fn)(cb);
    if (typeof fn !== 'function') throw new TypeError('need wrapper function');
    Object.keys(fn).forEach(function (k) {
      wrapper[k] = fn[k];
    });
    return wrapper;

    function wrapper() {
      var args = new Array(arguments.length);

      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      var ret = fn.apply(this, args);
      var cb = args[args.length - 1];

      if (typeof ret === 'function' && ret !== cb) {
        Object.keys(cb).forEach(function (k) {
          ret[k] = cb[k];
        });
      }

      return ret;
    }
  }
  /***/

},
/* 552 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/9e8725bf97d5693e39b2249ae1719b7c.svg";
  /***/
},
/* 553 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(554);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./GraingerBar.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./GraingerBar.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 554 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-grainger-bar {\n  padding-top: 8px; }\n  .gr-grainger-bar__container {\n    max-width: 1920px;\n    margin: 0 auto;\n    padding: 0 15px; }\n    @media all and (min-width: 992px) {\n      .gr-grainger-bar__container {\n        padding: 0 30px; } }\n  .gr-grainger-bar__logo {\n    max-width: 25px;\n    margin-right: 10px;\n    vertical-align: bottom; }\n  .gr-grainger-bar__logo svg {\n    max-width: 25px;\n    position: relative;\n    vertical-align: middle;\n    background-color: #FFFFFF; }\n  .gr-grainger-bar__link {\n    text-decoration: none; }\n  .gr-grainger-bar__text {\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: bold;\n    vertical-align: middle; }\n    .gr-grainger-bar__text:hover, .gr-grainger-bar__text:focus {\n      text-decoration: underline; }\n", ""]); // exports

  /***/
},
/* 555 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HeroBanner = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  var _Carousel = __webpack_require__(68);

  var _Links = __webpack_require__(37);

  __webpack_require__(556);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var HeroBanner = exports.HeroBanner = function HeroBanner(_ref) {
    var items = _ref.items;
    return _react2.default.createElement('div', {
      className: 'gr-herobanner'
    }, _react2.default.createElement('div', {
      className: 'gr-herobanner__carousel'
    }, items.length && _react2.default.createElement(_Carousel.Carousel, {
      fullWidth: true,
      centerMode: false,
      autoPlaySpeed: 11000,
      arrows: true,
      dots: true,
      heroDesign: true
    }, items.map(function (item) {
      return _react2.default.createElement('div', {
        className: 'gr-herobanner__item row no-gutters',
        key: (0, _generic.randomStr)(item.title || '')
      }, _react2.default.createElement('div', {
        className: 'col-md-5'
      }, _react2.default.createElement('div', {
        className: 'gr-herobanner__content\n                  ' + (items.length === 1 ? 'gr-herobanner__content--no-dots' : '')
      }, item.tagline && _react2.default.createElement('div', {
        className: 'gr-herobanner__tagline ',
        dangerouslySetInnerHTML: {
          __html: item.tagline
        }
      }), item.title && _react2.default.createElement('div', {
        className: 'gr-herobanner__title '
      }, item.title), item.text && _react2.default.createElement('div', {
        className: 'gr-herobanner__text ',
        dangerouslySetInnerHTML: {
          __html: item.text
        }
      }), item.subtext && _react2.default.createElement('div', {
        className: 'gr-herobanner__subtext ',
        dangerouslySetInnerHTML: {
          __html: item.subtext
        }
      }), item.cta && item.cta.url && item.cta.text && _react2.default.createElement(_Links.Links, {
        text: item.cta.text,
        location: item.cta.url,
        isExternal: item.cta.isExternal,
        className: 'gr-cta gr-herobanner__cta '
      }))), _react2.default.createElement('div', {
        className: 'col-md-7'
      }, item.imageUrl && _react2.default.createElement('div', {
        className: 'gr-herobanner__image'
      }, _react2.default.createElement('svg', {
        width: '100%',
        height: '100%',
        x: '0',
        y: '0'
      }, _react2.default.createElement('image', {
        'aria-hidden': 'true',
        xlinkHref: item.imageUrl,
        x: '0',
        y: '0',
        width: '100%',
        height: '100%',
        preserveAspectRatio: 'xMinYMid slice',
        className: 'gr-herobanner__svg-image'
      })))));
    }))), _react2.default.createElement('svg', {
      width: '0',
      height: '0'
    }, _react2.default.createElement('defs', null, _react2.default.createElement('clipPath', {
      id: 'gr-herobanner-clippath-small',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 .15, 1 1, 0 1'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-herobanner-clippath-large',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '.16 0, 1 0, 1 1, 0 1'
    })))));
  };

  HeroBanner.propTypes = {
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      tagline: _propTypes2.default.string,
      title: _propTypes2.default.string,
      text: _propTypes2.default.string,
      subtext: _propTypes2.default.string,
      cta: _propTypes2.default.shape({
        url: _propTypes2.default.string,
        text: _propTypes2.default.string,
        isExternal: _propTypes2.default.bool
      }),
      imageUrl: _propTypes2.default.string
    }))
  };
  HeroBanner.defaultProps = {
    items: []
  };
  exports.default = HeroBanner;
  /***/
},
/* 556 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(557);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./HeroBanner.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./HeroBanner.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 557 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-herobanner {\n  margin-bottom: 25px;\n  max-width: 1920px; }\n  .gr-herobanner svg {\n    display: block; }\n  @media all and (min-width: 768px) {\n    .gr-herobanner__tagline, .gr-herobanner__title, .gr-herobanner__text {\n      opacity: 0;\n      animation-name: fadeIn;\n      -webkit-animation: fadeIn;\n      -moz-animation: fadeIn;\n      -ms-animation: fadeIn;\n      -o-animation: fadeIn;\n      animation-fill-mode: forwards;\n      animation-duration: 2s; } }\n  @media all and (min-width: 768px) {\n    .gr-herobanner__cta, .gr-herobanner__subtext {\n      opacity: 0;\n      animation-name: fadeInUp;\n      -webkit-animation: fadeInUp;\n      -moz-animation: fadeInUp;\n      -ms-animation: fadeInUp;\n      -o-animation: fadeInUp;\n      animation-fill-mode: forwards;\n      animation-duration: 1s; } }\n  @media all and (min-width: 768px) {\n    .gr-herobanner__text, .gr-herobanner__cta, .gr-herobanner__subtext {\n      animation-delay: .5s; } }\n  .gr-herobanner__carousel {\n    width: 90%;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__carousel {\n        padding: 0 15px; } }\n  .gr-herobanner .gr-carousel__dots {\n    top: calc(330px + 20px); }\n    @media all and (min-width: 768px) {\n      .gr-herobanner .gr-carousel__dots {\n        top: 20px; } }\n  .gr-herobanner .gr-carousel__navigation--hero {\n    top: 18em; }\n  .gr-herobanner .gr-carousel__navigation--next {\n    display: block;\n    right: -1.5rem; }\n  .gr-herobanner .gr-carousel__navigation--prev {\n    display: block;\n    left: -1.5rem; }\n  @media all and (min-width: 768px) {\n    .gr-herobanner .gr-carousel__navigation--hero {\n      top: 50%; }\n    .gr-herobanner .gr-carousel__navigation--next {\n      right: 30px; }\n    .gr-herobanner .gr-carousel__navigation--prev {\n      display: none; } }\n  .gr-herobanner__item {\n    flex-wrap: wrap-reverse !important;\n    clip-path: none; }\n    @media all and (min-width: 992px) {\n      .gr-herobanner__item {\n        flex-wrap: wrap !important; } }\n  .gr-herobanner__content {\n    padding: 0 15px;\n    margin-top: 50px; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__content {\n        margin-right: -15px;\n        padding: 0;\n        text-align: left;\n        margin-top: 55px; } }\n    @media all and (min-width: 992px) {\n      .gr-herobanner__content {\n        font-size: 18px;\n        margin-top: 70px; } }\n    .gr-herobanner__content--no-dots {\n      margin-top: 20px; }\n      @media all and (min-width: 768px) {\n        .gr-herobanner__content--no-dots {\n          margin-top: 30px; } }\n  .gr-herobanner__image {\n    height: 330px; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__image {\n        height: 600px; } }\n  @media all and (min-width: 992px) {\n    .gr-herobanner__svg-image {\n      clip-path: url(\"#gr-herobanner-clippath-small\");\n      -webkit-transform: translateZ(0);\n      transform: translateZ(0); } }\n  @media all and (min-width: 768px) {\n    .gr-herobanner__svg-image {\n      clip-path: url(\"#gr-herobanner-clippath-large\"); } }\n  .gr-herobanner__tagline {\n    font-size: 22px;\n    margin-bottom: -12px;\n    text-transform: uppercase; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__tagline {\n        font-size: 25px;\n        margin-bottom: -13px; } }\n  .gr-herobanner__title {\n    text-transform: uppercase;\n    font-size: 40px;\n    line-height: 42px;\n    margin-bottom: 25px;\n    font-family: \"fs_elliotbold\"; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__title {\n        font-size: 46px;\n        line-height: 48px;\n        margin-bottom: 20px; } }\n    @media all and (min-width: 992px) {\n      .gr-herobanner__title {\n        font-size: 48px;\n        line-height: 50px;\n        margin-bottom: 30px; } }\n  .gr-herobanner__text, .gr-herobanner__subtext {\n    font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__text, .gr-herobanner__subtext {\n        text-align: left; } }\n  .gr-herobanner__cta {\n    background-color: #7C7C7B;\n    margin: 20px 0 15px;\n    font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif; }\n    @media all and (min-width: 768px) {\n      .gr-herobanner__cta {\n        margin-top: 10px; } }\n  .gr-herobanner .slick-slide {\n    opacity: 0;\n    transition: opacity 1s ease; }\n  .gr-herobanner .slick-active {\n    opacity: 1; }\n  .gr-herobanner .slick-cloned {\n    opacity: 1; }\n\n@-webkit-keyframes fadeIn {\n  @media all and (min-width: 768px) {\n    from {\n      opacity: 0; }\n    to {\n      opacity: 1; } } }\n\n@-moz-keyframes fadeIn {\n  @media all and (min-width: 768px) {\n    from {\n      opacity: 0; }\n    to {\n      opacity: 1; } } }\n\n@-ms-keyframes fadeIn {\n  @media all and (min-width: 768px) {\n    from {\n      opacity: 0; }\n    to {\n      opacity: 1; } } }\n\n@-o-keyframes fadeIn {\n  @media all and (min-width: 768px) {\n    from {\n      opacity: 0; }\n    to {\n      opacity: 1; } } }\n\n@keyframes fadeIn {\n  @media all and (min-width: 768px) {\n    from {\n      opacity: 0; }\n    to {\n      opacity: 1; } } }\n\n@-webkit-keyframes fadeInUp {\n  @media all and (min-width: 768px) {\n    0% {\n      opacity: 0;\n      transform: translateY(40px); }\n    100% {\n      opacity: 1;\n      transform: translateY(0); } } }\n\n@-moz-keyframes fadeInUp {\n  @media all and (min-width: 768px) {\n    0% {\n      opacity: 0;\n      transform: translateY(40px); }\n    100% {\n      opacity: 1;\n      transform: translateY(0); } } }\n\n@-ms-keyframes fadeInUp {\n  @media all and (min-width: 768px) {\n    0% {\n      opacity: 0;\n      transform: translateY(40px); }\n    100% {\n      opacity: 1;\n      transform: translateY(0); } } }\n\n@-o-keyframes fadeInUp {\n  @media all and (min-width: 768px) {\n    0% {\n      opacity: 0;\n      transform: translateY(40px); }\n    100% {\n      opacity: 1;\n      transform: translateY(0); } } }\n\n@keyframes fadeInUp {\n  @media all and (min-width: 768px) {\n    0% {\n      opacity: 0;\n      transform: translateY(40px); }\n    100% {\n      opacity: 1;\n      transform: translateY(0); } } }\n", ""]); // exports

  /***/
},
/* 558 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(559);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var HeroBox = function (_Component) {
    _inherits(HeroBox, _Component);

    function HeroBox(props) {
      _classCallCheck(this, HeroBox);

      var _this = _possibleConstructorReturn(this, (HeroBox.__proto__ || Object.getPrototypeOf(HeroBox)).call(this, props));

      _this.scroll = _this.scroll.bind(_this);
      _this.setRef = _this.setRef.bind(_this);
      return _this;
    }

    _createClass(HeroBox, [{
      key: 'setRef',
      value: function setRef(node) {
        this.hero = node;
      }
    }, {
      key: 'scroll',
      value: function scroll(e) {
        e.preventDefault();

        if (this.hero) {
          var stepper = 50;
          var height = this.hero.clientHeight;
          var heroTopPos = this.hero.getBoundingClientRect().top + document.documentElement.scrollTop;
          var scrollDist = heroTopPos + height;
          var i = document.documentElement.scrollTop;
          var int = setInterval(function () {
            window.scrollTo(0, i);
            i += stepper;
            if (i >= scrollDist) clearInterval(int);
          }, 15);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            backgroundImage = _props.backgroundImage,
            title = _props.title,
            subtitle = _props.subtitle,
            isFiltered = _props.isFiltered;
        return _react2.default.createElement('div', {
          className: 'gr-herobox',
          ref: this.setRef,
          style: backgroundImage ? {
            backgroundImage: 'url(' + backgroundImage + ')'
          } : null
        }, _react2.default.createElement('div', {
          className: 'gr-herobox__wrapper ' + (isFiltered ? 'filtered' : '')
        }, _react2.default.createElement('div', {
          className: 'gr-herobox__content'
        }, title && _react2.default.createElement('div', {
          className: 'gr-herobox__title',
          dangerouslySetInnerHTML: {
            __html: title
          }
        }), subtitle && _react2.default.createElement('div', {
          className: 'gr-herobox__subtitle',
          dangerouslySetInnerHTML: {
            __html: subtitle
          }
        }), _react2.default.createElement('a', {
          href: '#',
          className: 'gr-herobox__button',
          onClick: function onClick(e) {
            return _this2.scroll(e);
          }
        }, _react2.default.createElement('span', {
          className: 'sr-only'
        }, 'Click to scroll down'), _react2.default.createElement('i', {
          className: 'gr-icon icon-chevron-down gr-herobox__icon',
          'aria-hidden': 'true'
        })))));
      }
    }]);

    return HeroBox;
  }(_react.Component);

  exports.default = HeroBox;
  HeroBox.propTypes = {
    backgroundImage: _propTypes2.default.string,
    title: _propTypes2.default.string,
    subtitle: _propTypes2.default.string,
    isFiltered: _propTypes2.default.bool
  };
  HeroBox.defaultProps = {
    backgroundImage: null,
    title: null,
    subtitle: null,
    isFiltered: false
  };
  /***/
},
/* 559 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(560);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Herobox.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Herobox.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 560 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-herobox {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 400px;\n  margin-bottom: 20px;\n  max-width: 1920px; }\n  @media all and (min-width: 768px) {\n    .gr-herobox {\n      height: 800px;\n      margin-bottom: 60px; } }\n  .gr-herobox__wrapper {\n    height: 100%; }\n    .gr-herobox__wrapper.filtered {\n      background-image: linear-gradient(rgba(20, 63, 92, 0.7), rgba(98, 177, 173, 0.7)); }\n  .gr-herobox__content {\n    color: #FFFFFF;\n    position: relative;\n    height: 100%;\n    padding: 30px 15px;\n    max-width: 75%;\n    margin: 0 auto;\n    text-align: center;\n    font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif; }\n    @media all and (min-width: 768px) {\n      .gr-herobox__content {\n        max-width: 1920px;\n        text-align: left;\n        padding-top: 50px; } }\n  .gr-herobox__title {\n    font-size: 35px;\n    line-height: 40px;\n    text-shadow: 0.3px 0.3px #63666A;\n    margin-bottom: -5px;\n    text-transform: uppercase; }\n    .gr-herobox__title p {\n      margin-top: 0.5em;\n      margin-bottom: 0; }\n    @media all and (min-width: 768px) {\n      .gr-herobox__title {\n        font-size: 45px;\n        line-height: 50px;\n        margin-left: -3px;\n        margin-bottom: -12px; } }\n    @media all and (min-width: 992px) {\n      .gr-herobox__title {\n        font-size: 50px;\n        line-height: 55px; } }\n  .gr-herobox__subtitle {\n    text-shadow: 0.3px 0.3px #63666A; }\n    @media all and (min-width: 768px) {\n      .gr-herobox__subtitle {\n        font-size: 20px; } }\n    @media all and (min-width: 992px) {\n      .gr-herobox__subtitle {\n        font-size: 22px; } }\n  .gr-herobox__button {\n    display: none;\n    background-color: #4E8382;\n    border: none;\n    color: #FFFFFF;\n    padding: 0;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 50%;\n    bottom: 170px;\n    transform: translateX(-50%);\n    transition: background-color .1s linear;\n    text-decoration: none; }\n    @media all and (min-width: 768px) {\n      .gr-herobox__button {\n        display: inline-flex; }\n        .gr-herobox__button:hover, .gr-herobox__button:focus {\n          text-decoration: none;\n          color: #FFFFFF;\n          background-color: #F36F4A; } }\n    @media all and (min-width: 992px) {\n      .gr-herobox__button {\n        width: 80px;\n        height: 80px; } }\n  .gr-herobox__icon {\n    font-size: 45px;\n    vertical-align: middle; }\n    @media all and (min-width: 992px) {\n      .gr-herobox__icon {\n        font-size: 55px; } }\n", ""]); // exports

  /***/
},
/* 561 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(562);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /* eslint-disable jsx-a11y/media-has-caption, jsx-a11y/anchor-is-valid */


  var HeroVideo = function (_Component) {
    _inherits(HeroVideo, _Component);

    function HeroVideo(props) {
      _classCallCheck(this, HeroVideo);

      var _this = _possibleConstructorReturn(this, (HeroVideo.__proto__ || Object.getPrototypeOf(HeroVideo)).call(this, props));

      _this.handleAutoplay = _this.handleAutoplay.bind(_this);
      _this.handleFullScreenVideo = _this.handleFullScreenVideo.bind(_this);
      _this.scroll = _this.scroll.bind(_this);
      _this.playVideo = _this.playVideo.bind(_this);
      _this.setHero = _this.setHero.bind(_this);
      _this.setVideo = _this.setVideo.bind(_this);
      _this.state = {
        paused: true
      };
      return _this;
    }

    _createClass(HeroVideo, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('load', this.handleAutoplay);
        this.video.addEventListener('webkitendfullscreen', this.handleFullScreenVideo);
      }
    }, {
      key: 'setHero',
      value: function setHero(node) {
        this.hero = node;
      }
    }, {
      key: 'setVideo',
      value: function setVideo(node) {
        this.video = node;
      }
    }, {
      key: 'handleAutoplay',
      value: function handleAutoplay() {
        this.setState({
          paused: this.video.paused
        });
      }
    }, {
      key: 'handleFullScreenVideo',
      value: function handleFullScreenVideo() {
        this.setState({
          paused: true
        });
      }
    }, {
      key: 'scroll',
      value: function scroll(e) {
        var stepper = 50;
        var height = this.hero.clientHeight + 100;
        e.preventDefault();

        if (this.hero) {
          var i = stepper;
          var int = setInterval(function () {
            window.scrollTo(0, i);
            i += stepper;
            if (i >= height) clearInterval(int);
          }, 15);
        }
      }
    }, {
      key: 'playVideo',
      value: function playVideo(e) {
        e.preventDefault();

        if (this.state.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }

        this.setState({
          paused: this.video.paused
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            video = _props.video,
            title = _props.title;
        return _react2.default.createElement('div', {
          className: 'gr-herovideo',
          ref: this.setHero,
          style: video ? {
            video: 'url(' + video + ')'
          } : null
        }, _react2.default.createElement('div', {
          className: 'gr-herovideo__container'
        }, _react2.default.createElement('div', {
          className: 'gr-herovideo__wrapper'
        }, video && _react2.default.createElement('video', {
          loop: true,
          autoPlay: true,
          muted: true,
          className: 'gr-herovideo__video',
          ref: this.setVideo
        }, _react2.default.createElement('source', {
          src: video,
          type: 'video/mp4'
        }), _react2.default.createElement('source', {
          src: video,
          type: 'video/ogg'
        }), _react2.default.createElement('source', {
          src: video,
          type: 'video/webm'
        }), 'Your browser does not support the video element,', _react2.default.createElement('a', {
          href: video,
          download: ''
        }, 'download the video'), ' to view it.'), _react2.default.createElement('div', {
          className: 'gr-herovideo__content'
        }, title && _react2.default.createElement('div', {
          className: 'gr-herovideo__title',
          dangerouslySetInnerHTML: {
            __html: title
          }
        }), this.state.paused && video && _react2.default.createElement('a', {
          href: '#',
          className: 'gr-herovideo__control',
          onClick: function onClick(e) {
            return _this2.playVideo(e);
          }
        }, _react2.default.createElement('span', {
          className: 'sr-only'
        }, 'Click to play the video'), _react2.default.createElement('i', {
          className: 'gr-icon icon-play gr-herovideo__play',
          'aria-hidden': 'true'
        })))), _react2.default.createElement('a', {
          href: '#',
          className: 'gr-herovideo__button',
          onClick: function onClick(e) {
            return _this2.scroll(e);
          }
        }, _react2.default.createElement('span', {
          className: 'sr-only'
        }, 'Click to scroll down'), _react2.default.createElement('i', {
          className: 'gr-icon icon-chevron-down gr-herovideo__icon',
          'aria-hidden': 'true'
        }))));
      }
    }]);

    return HeroVideo;
  }(_react.Component);

  exports.default = HeroVideo;
  HeroVideo.propTypes = {
    video: _propTypes2.default.string,
    title: _propTypes2.default.string
  };
  HeroVideo.defaultProps = {
    video: null,
    title: null
  };
  /***/
},
/* 562 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(563);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./HeroVideo.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./HeroVideo.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 563 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-herovideo {\n  height: 320px; }\n  @media all and (min-width: 576px) {\n    .gr-herovideo {\n      height: auto;\n      margin-bottom: 60px; } }\n  .gr-herovideo__container {\n    max-width: 1920px;\n    margin: 0 auto;\n    height: 100%;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-herovideo__container {\n        padding: 0 15px; } }\n  .gr-herovideo__wrapper {\n    overflow: hidden;\n    height: 100%;\n    position: relative;\n    display: flex;\n    justify-content: center; }\n    @media all and (min-width: 768px) {\n      .gr-herovideo__wrapper {\n        display: block;\n        justify-content: unset; } }\n  .gr-herovideo__video {\n    height: 100%; }\n    @media all and (min-width: 576px) {\n      .gr-herovideo__video {\n        width: 100%; } }\n  .gr-herovideo__content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    padding: 25px 15px;\n    height: 100%;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-herovideo__content {\n        padding: 35px 20px 15px;\n        text-align: left; } }\n    @media all and (min-width: 992px) {\n      .gr-herovideo__content {\n        padding: 50px 30px 15px; } }\n  .gr-herovideo__title {\n    font-size: 32px;\n    line-height: 37px;\n    text-shadow: 0.3px 0.3px #63666A;\n    text-align: center;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    max-width: 300px;\n    margin: 0 auto 20px auto;\n    display: none; }\n    @media all and (min-width: 576px) {\n      .gr-herovideo__title {\n        display: block; } }\n    @media all and (min-width: 768px) {\n      .gr-herovideo__title {\n        margin: 0;\n        text-align: left;\n        font-weight: 700; } }\n  .gr-herovideo__control {\n    display: inline-flex;\n    width: 70px;\n    height: 70px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 50%;\n    color: #FFFFFF;\n    align-items: center;\n    justify-content: center;\n    font-size: 30px;\n    transition: background-color .2s linear; }\n    .gr-herovideo__control:hover, .gr-herovideo__control:focus {\n      color: #FFFFFF;\n      text-decoration: none; }\n    @media all and (min-width: 768px) {\n      .gr-herovideo__control {\n        display: none; } }\n  .gr-herovideo__play {\n    margin-left: 5px; }\n  .gr-herovideo__button {\n    display: none;\n    background-color: rgba(151, 151, 151, 0.8);\n    border: none;\n    color: #FFFFFF;\n    padding: 0;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 50%;\n    bottom: -30px;\n    transform: translateX(-50%);\n    transition: background-color .2s linear;\n    text-decoration: none; }\n    @media all and (min-width: 768px) {\n      .gr-herovideo__button {\n        display: inline-flex; }\n        .gr-herovideo__button:hover, .gr-herovideo__button:focus {\n          text-decoration: none;\n          color: #FFFFFF;\n          background-color: #979797; } }\n    @media all and (min-width: 992px) {\n      .gr-herovideo__button {\n        width: 80px;\n        height: 80px;\n        bottom: -40px; } }\n  .gr-herovideo__icon {\n    font-size: 45px;\n    vertical-align: middle; }\n    @media all and (min-width: 992px) {\n      .gr-herovideo__icon {\n        font-size: 55px; } }\n", ""]); // exports

  /***/
},
/* 564 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LandingPage = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Links = __webpack_require__(37);

  var _Img = __webpack_require__(30);

  __webpack_require__(565);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var LandingPage = exports.LandingPage = function LandingPage(_ref) {
    var title = _ref.title,
        subtitle = _ref.subtitle,
        subtext = _ref.subtext,
        backgroundimage = _ref.backgroundimage,
        logo = _ref.logo,
        cta = _ref.cta,
        isFiltered = _ref.isFiltered;
    return _react2.default.createElement('section', {
      className: 'gr-landingpage',
      style: backgroundimage ? {
        backgroundImage: 'url(' + backgroundimage + ')'
      } : null
    }, _react2.default.createElement('div', {
      className: 'gr-landingpage__wrapper ' + (isFiltered ? 'gr-landingpage__wrapper--filtered' : '')
    }, _react2.default.createElement('div', {
      className: 'gr-landingpage__content'
    }, title && _react2.default.createElement('div', {
      className: 'gr-landingpage__title',
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), subtitle && _react2.default.createElement('div', {
      className: 'gr-landingpage__subtitle',
      dangerouslySetInnerHTML: {
        __html: subtitle
      }
    }), _react2.default.createElement('div', {
      className: 'gr-landingpage__logowrapper'
    }, logo && _react2.default.createElement(_Img.Img, {
      src: logo,
      alt: 'logo',
      isFluid: true,
      className: 'gr-landingpage__logo'
    }), subtext && _react2.default.createElement('div', {
      className: 'gr-landingpage__text',
      dangerouslySetInnerHTML: {
        __html: subtext
      }
    }), cta && cta.url && cta.text && _react2.default.createElement(_Links.Links, {
      location: cta.url,
      text: cta.text,
      isExternal: cta.isExternal,
      className: 'gr-cta gr-landingpage__cta'
    })))));
  };

  LandingPage.propTypes = {
    title: _propTypes2.default.string,
    subtitle: _propTypes2.default.string,
    subtext: _propTypes2.default.string,
    backgroundimage: _propTypes2.default.string,
    logo: _propTypes2.default.string,
    isFiltered: _propTypes2.default.bool,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    })
  };
  LandingPage.defaultProps = {
    title: null,
    subtitle: null,
    subtext: null,
    backgroundimage: null,
    logo: null,
    cta: null,
    isFiltered: false
  };
  exports.default = LandingPage;
  /***/
},
/* 565 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(566);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./LandingPage.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./LandingPage.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 566 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-landingpage {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  max-width: 1920px;\n  margin: 0 auto 20px;\n  height: auto; }\n  @media all and (min-width: 768px) {\n    .gr-landingpage {\n      height: 800px;\n      margin-bottom: 60px; } }\n  .gr-landingpage__wrapper {\n    height: 100%; }\n    .gr-landingpage__wrapper--filtered {\n      background-color: rgba(51, 51, 51, 0.3); }\n  .gr-landingpage__content {\n    color: #FFFFFF;\n    position: relative;\n    height: 100%;\n    padding: 30px 15px;\n    max-width: 75%;\n    margin: 0 auto;\n    text-align: center;\n    font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif; }\n    @media all and (min-width: 768px) {\n      .gr-landingpage__content {\n        max-width: 1920px;\n        text-align: left;\n        padding-top: 50px; } }\n  .gr-landingpage__title {\n    font-size: 35px;\n    line-height: 40px;\n    text-shadow: 0.3px 0.3px #63666A;\n    margin-bottom: -5px;\n    text-transform: uppercase; }\n    .gr-landingpage__title p {\n      margin-top: 0.5em;\n      margin-bottom: 0; }\n    @media all and (min-width: 768px) {\n      .gr-landingpage__title {\n        font-size: 45px;\n        line-height: 50px;\n        margin-left: -3px;\n        margin-bottom: -12px; } }\n    @media all and (min-width: 992px) {\n      .gr-landingpage__title {\n        font-size: 50px;\n        line-height: 55px; } }\n  .gr-landingpage__subtitle {\n    text-shadow: 0.3px 0.3px #63666A; }\n    @media all and (min-width: 768px) {\n      .gr-landingpage__subtitle {\n        font-size: 20px; } }\n    @media all and (min-width: 992px) {\n      .gr-landingpage__subtitle {\n        font-size: 22px; } }\n  .gr-landingpage__text {\n    font-size: 16px; }\n    @media all and (min-width: 768px) {\n      .gr-landingpage__text {\n        font-size: 20px; } }\n  .gr-landingpage__logo {\n    height: 100px; }\n    @media all and (min-width: 768px) {\n      .gr-landingpage__logo {\n        height: auto; } }\n  .gr-landingpage__logowrapper {\n    text-align: center;\n    padding-top: 30px; }\n    @media all and (min-width: 768px) {\n      .gr-landingpage__logowrapper {\n        padding-top: 250px; } }\n  .gr-landingpage__cta {\n    background-color: #303E4A; }\n", ""]); // exports

  /***/
},
/* 567 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Links = __webpack_require__(37);

  __webpack_require__(568);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Use the PriceBox component to display a price over an image with an actionable button.
   * The PriceBox component will take the width of it's parent container by default.
   *
   * @version 0.1.0
   */


  var PriceBox = function PriceBox(_ref) {
    var backgroundImage = _ref.backgroundImage,
        title = _ref.title,
        price = _ref.price,
        description = _ref.description,
        cta = _ref.cta,
        flipPriceBox = _ref.flipPriceBox;
    return _react2.default.createElement('div', {
      className: 'gr-pricebox'
    }, _react2.default.createElement('div', {
      className: 'gr-pricebox__container'
    }, _react2.default.createElement('div', {
      className: 'row no-gutters gr-pricebox__row ' + (flipPriceBox ? 'gr-pricebox__row--flipped' : '') + ' '
    }, _react2.default.createElement('div', {
      className: 'col-md-7 col-lg-9'
    }, backgroundImage && _react2.default.createElement('div', {
      className: 'gr-pricebox__image ' + (flipPriceBox ? 'gr-pricebox__image--flipped' : '') + ' '
    }, _react2.default.createElement('svg', {
      width: '0',
      height: '0',
      className: 'gr-pricebox__svg'
    }, _react2.default.createElement('defs', null, _react2.default.createElement('clipPath', {
      id: 'gr-pricebox-image-clippath-small',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 0, 1 .9, 0 1'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-pricebox-image-clippath-large',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 0, .86 1, 0 1'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-pricebox-image-clippath-large-flipped',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 0, 1 1, .14 1'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-pricebox-image-clippath-large-mirror',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '.14 0, 1 0, 1 1, 0 1'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-pricebox-image-clippath-large-default',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, .86 0, 1 1, 0 1'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-pricebox-image-clippath-small-default',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 0, 1 1, 0 1'
    }))), _react2.default.createElement('image', {
      'aria-hidden': 'true',
      xlinkHref: backgroundImage,
      x: '0',
      y: '0',
      width: '100%',
      height: '100%',
      preserveAspectRatio: 'xMinYMid slice',
      className: 'gr-pricebox__svg-image'
    })))), _react2.default.createElement('div', {
      className: 'col-md-5 col-lg-3'
    }, _react2.default.createElement('div', {
      className: 'gr-pricebox__content'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-pricebox__title'
    }, title), description && _react2.default.createElement('div', {
      className: 'gr-pricebox__description',
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), price && _react2.default.createElement('p', {
      className: 'gr-pricebox__price-text'
    }, _react2.default.createElement('span', {
      className: 'gr-pricebox__from'
    }, 'from'), _react2.default.createElement('span', {
      className: 'gr-pricebox__price'
    }, '\xA3', price), _react2.default.createElement('span', {
      className: 'gr-pricebox__pcm'
    }, 'pcm')), cta && cta.url && cta.text && _react2.default.createElement('div', {
      className: 'gr-pricebox__button'
    }, _react2.default.createElement(_Links.Links, {
      location: cta.url,
      text: cta.text,
      isExternal: cta.isExternal,
      className: 'gr-cta gr-pricebox__cta'
    })))))));
  };

  PriceBox.propTypes = {
    backgroundImage: _propTypes2.default.string,
    title: _propTypes2.default.string,
    price: _propTypes2.default.string,
    description: _propTypes2.default.string,
    cta: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    }),
    flipPriceBox: _propTypes2.default.bool
  };
  PriceBox.defaultProps = {
    cta: null,
    backgroundImage: null,
    title: null,
    price: null,
    description: null,
    flipPriceBox: false
  };
  exports.default = PriceBox;
  /***/
},
/* 568 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(569);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./PriceBox.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./PriceBox.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 569 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-pricebox {\n  max-width: 1920px;\n  font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif;\n  margin: 30px auto; }\n  @media all and (min-width: 768px) {\n    .gr-pricebox {\n      margin-top: 40px;\n      margin-bottom: 0;\n      padding-bottom: 50px; } }\n  @media all and (min-width: 992px) {\n    .gr-pricebox {\n      margin-top: 50px;\n      padding-bottom: 60px; } }\n  .gr-pricebox__container {\n    max-width: 90%;\n    margin: 0 auto;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__container {\n        padding: 0 15px; } }\n  .gr-pricebox__leaf--container {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__leaf--container {\n        position: absolute;\n        bottom: 10px;\n        right: -90px;\n        display: block; } }\n    .gr-pricebox__leaf--container--flipped {\n      display: none; }\n  .gr-pricebox__svg-image {\n    clip-path: url(\"#gr-pricebox-image-clippath-small\");\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0); }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__svg-image {\n        clip-path: url(\"#gr-pricebox-image-clippath-large\"); } }\n  .gr-pricebox__image {\n    height: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__image {\n        height: 600px; }\n        .gr-pricebox__image--flipped .gr-pricebox__svg-image {\n          clip-path: url(\"#gr-pricebox-image-clippath-large-flipped\"); } }\n  @media all and (min-width: 768px) {\n    .gr-pricebox__row {\n      align-items: center; }\n      .gr-pricebox__row--flipped {\n        flex-direction: row-reverse; } }\n  .gr-pricebox__content {\n    padding: 20px 15px; }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__content {\n        padding: 20px 10px; } }\n    @media all and (min-width: 992px) {\n      .gr-pricebox__content {\n        max-width: 280px; } }\n  .gr-pricebox__title {\n    text-transform: uppercase;\n    font-size: 18px;\n    color: #4E8382;\n    margin-bottom: 20px; }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__title {\n        font-size: 30px;\n        line-height: 32px; } }\n  .gr-pricebox__description {\n    margin-bottom: 20px; }\n  .gr-pricebox__price-text {\n    margin: 20px 0; }\n  .gr-pricebox__from {\n    display: block;\n    text-transform: uppercase;\n    margin-bottom: -18px;\n    font-weight: 700; }\n  .gr-pricebox__price {\n    font-size: 65px;\n    font-weight: 700;\n    color: #4E8382; }\n    @media all and (min-width: 992px) {\n      .gr-pricebox__price {\n        font-size: 60px; } }\n  .gr-pricebox__pcm {\n    font-size: 40px;\n    font-weight: 700;\n    color: #4E8382; }\n    @media all and (min-width: 992px) {\n      .gr-pricebox__pcm {\n        font-size: 30px; } }\n  .gr-pricebox__button {\n    text-align: center;\n    margin: 20px 0 0; }\n    .gr-pricebox__button:hover {\n      background-color: #62B1AD; }\n  .gr-pricebox__cta {\n    margin: 0; }\n  .gr-pricebox__left-sail {\n    display: none;\n    position: absolute;\n    left: -55px;\n    bottom: -125px;\n    width: 400px;\n    height: 440px;\n    transform: rotate(95deg);\n    z-index: -1; }\n    .gr-pricebox__left-sail--flipped {\n      left: auto;\n      bottom: -275px;\n      right: -55px;\n      transform: scaleX(-1) rotate(95deg); }\n    @media all and (min-width: 768px) {\n      .gr-pricebox__left-sail {\n        display: block; } }\n  .gr-pricebox__svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; }\n", ""]); // exports

  /***/
},
/* 570 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Img = __webpack_require__(30);

  var _Carousel = __webpack_require__(68);

  var _generic = __webpack_require__(10);

  __webpack_require__(571);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ImageLinks = function ImageLinks(_ref) {
    var title = _ref.title,
        subtitle = _ref.subtitle,
        links = _ref.links;
    return _react2.default.createElement('div', {
      className: 'gr-imagelinks'
    }, (title || subtitle) && _react2.default.createElement('div', {
      className: 'gr-imagelinks__container'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-imagelinks__title'
    }, title), subtitle && _react2.default.createElement('p', {
      className: 'gr-imagelinks__subtitle'
    }, subtitle)), links.length && _react2.default.createElement('div', {
      className: 'gr-imagelinks__image-container'
    }, _react2.default.createElement(_Carousel.Carousel, {
      centerMode: false,
      fullWidth: 3
    }, links.map(function (link) {
      return _react2.default.createElement('div', {
        className: 'gr-imagelinks__item',
        key: (0, _generic.randomStr)(link.text)
      }, _react2.default.createElement('a', {
        key: (0, _generic.randomStr)(link.text),
        target: '_blank',
        rel: 'noopener noreferrer',
        href: link.link,
        className: 'gr-imagelinks__link'
      }, _react2.default.createElement(_Img.Img, {
        src: link.imageurl,
        isFluid: true,
        className: 'gr-imagelinks__link-image'
      }), _react2.default.createElement('span', {
        className: 'gr-imagelinks__link-text'
      }, link.text, _react2.default.createElement('span', {
        className: 'sr-only'
      }, '(Opens in new window)'), _react2.default.createElement('i', {
        className: 'gr-icon icon-leave-site gr-imagelinks__icon',
        'aria-hidden': 'true'
      }))));
    }))));
  };

  exports.default = ImageLinks;
  ImageLinks.propTypes = {
    title: _propTypes2.default.string,
    subtitle: _propTypes2.default.string,
    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      imageurl: _propTypes2.default.string,
      text: _propTypes2.default.string,
      link: _propTypes2.default.string
    }))
  };
  ImageLinks.defaultProps = {
    title: null,
    subtitle: null,
    links: []
  };
  /***/
},
/* 571 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(572);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./ImageLinks.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./ImageLinks.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 572 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-imagelinks {\n  font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif;\n  max-width: 1920px;\n  background-color: #F2F2F2;\n  margin: 0 auto;\n  padding: 25px 0; }\n  @media all and (min-width: 768px) {\n    .gr-imagelinks {\n      padding: 65px 0; } }\n  .gr-imagelinks__container {\n    max-width: 90%;\n    padding: 0 35px;\n    margin: 0 auto 15px;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-imagelinks__container {\n        padding: 0 15px;\n        margin: 0 auto 35px; } }\n  .gr-imagelinks__image-container {\n    max-width: 90%;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-imagelinks__image-container {\n        padding: 0 15px; } }\n  .gr-imagelinks__title {\n    text-transform: uppercase;\n    font-size: 18px;\n    color: #62B1AD;\n    margin-bottom: 0; }\n    @media all and (min-width: 768px) {\n      .gr-imagelinks__title {\n        font-size: 26px; } }\n  .gr-imagelinks__subtitle {\n    color: #4E8382;\n    font-size: 16px;\n    margin-bottom: 0; }\n    @media all and (min-width: 768px) {\n      .gr-imagelinks__subtitle {\n        font-size: 18px; } }\n  @media all and (min-width: 768px) {\n    .gr-imagelinks__item {\n      padding: 0 5px; } }\n  .gr-imagelinks__link {\n    display: inline-block;\n    position: relative;\n    width: auto;\n    max-width: 100%;\n    overflow: hidden;\n    font-weight: bold; }\n    .gr-imagelinks__link:hover .gr-imagelinks__link-text, .gr-imagelinks__link:focus .gr-imagelinks__link-text {\n      background-color: #62B1AD; }\n    .gr-imagelinks__link:hover .gr-imagelinks__link-image, .gr-imagelinks__link:focus .gr-imagelinks__link-image {\n      transform: scale(1.1);\n      transition: transform .2s linear; }\n  .gr-imagelinks__link-text {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    position: absolute;\n    right: 15px;\n    bottom: 15px;\n    margin-left: 15px;\n    line-height: normal;\n    text-transform: uppercase;\n    font-size: 14px;\n    z-index: 1;\n    width: auto;\n    padding: 7px 20px;\n    border-radius: 40px;\n    background: #4E8382;\n    color: #FFFFFF;\n    text-align: right;\n    transition: background-color .1s linear; }\n    @media all and (min-width: 992px) {\n      .gr-imagelinks__link-text {\n        padding: 10px 20px; } }\n  .gr-imagelinks__icon {\n    margin-left: 8px; }\n    @media all and (min-width: 992px) {\n      .gr-imagelinks__icon {\n        margin-left: 12px; } }\n  @media all and (min-width: 768px) {\n    .gr-imagelinks .slick-list {\n      margin: 0 -10px; } }\n  .gr-imagelinks__link-image {\n    transform: scale(1);\n    transition: transform .2s linear; }\n", ""]); // exports

  /***/
},
/* 573 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactRouterDom = __webpack_require__(87);

  var _NavLinks = __webpack_require__(574);

  var _NavLinks2 = _interopRequireDefault(_NavLinks);

  __webpack_require__(189);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /* eslint-disable jsx-a11y/anchor-is-valid */


  var IS_IE11 = !!window.MSInputMethodContext && !!document.documentMode;

  var Navigation = function (_Component) {
    _inherits(Navigation, _Component);

    function Navigation(props) {
      _classCallCheck(this, Navigation);

      var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

      _this.state = {
        isMobileMenuOpen: false,
        isNavSticky: false,
        routes: props.routes
      };
      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    _createClass(Navigation, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.navigation = document.querySelector('.js-gr-navigation');
        document.addEventListener('keyup', function (e) {
          if (e.defaultPrevented || !_this2.state.isMobileMenuOpen) {
            return;
          }

          var KEY = e.key || e.keyCode;

          if (KEY === 'Escape' || KEY === 'Esc' || KEY === 27) {
            _this2.toggle();
          }
        });
        window.addEventListener('scroll', function () {
          if (_this2.navigation) {
            _this2.setState({
              isNavSticky: window.pageYOffset > _this2.navigation.clientHeight
            });
          }
        });
        window.addEventListener('resize', function () {
          if (window.innerWidth > 991) {
            document.body.classList.remove('gr-body-fixed');
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.body.classList.remove('gr-body-fixed');
      }
    }, {
      key: 'toggle',
      value: function toggle() {
        this.setState({
          isMobileMenuOpen: !this.state.isMobileMenuOpen
        }, function () {
          document.body.classList.toggle('gr-body-fixed');
        });
      }
    }, {
      key: 'render',
      value: function render() {
        /*
         * StickyLogo is just the logo's text , no image
         * logo is the used only in burger menu
         */
        var _props = this.props,
            logo = _props.logo,
            stickyLogo = _props.stickyLogo,
            alt = _props.alt;
        var _state = this.state,
            isNavSticky = _state.isNavSticky,
            isMobileMenuOpen = _state.isMobileMenuOpen;
        return _react2.default.createElement('div', {
          className: 'gr-navigation'
        }, _react2.default.createElement('div', {
          className: 'js-gr-navigation gr-navigation__wrapper\n          ' + (isNavSticky ? 'gr-navigation__wrapper--sticky' : '') + '\n          ' + (isMobileMenuOpen ? 'gr-navigation__wrapper--menu' : '')
        }, _react2.default.createElement('div', {
          className: 'gr-navigation__container'
        }, _react2.default.createElement(_reactRouterDom.NavLink, {
          exact: true,
          to: '/',
          className: 'gr-navigation__brand ' + (isNavSticky ? 'gr-navigation__brand--sticky' : '') + ' '
        }, isNavSticky ? _react2.default.createElement('img', {
          alt: alt,
          src: stickyLogo,
          className: 'gr-navigation__logo gr-navigation__logo--sticky'
        }) : _react2.default.createElement('div', {
          className: 'gr-navigation__logo ' + (IS_IE11 ? 'gr-navigation__logo--ie' : '')
        }, _react2.default.createElement('img', {
          src: logo,
          alt: alt
        }))), _react2.default.createElement('button', {
          className: 'gr-navigation__burger ' + (isMobileMenuOpen ? 'gr-navigation__burger--active' : '') + ' ',
          onClick: this.toggle
        }, _react2.default.createElement('span', {
          className: 'gr-navigation__bar ' + (isMobileMenuOpen ? 'gr-navigation__bar--active' : '') + ' '
        }), _react2.default.createElement('span', {
          className: 'sr-only'
        }, isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu')), _react2.default.createElement('div', {
          className: 'js-gr-navigation-menu gr-navigation__menu\n                ' + (isMobileMenuOpen ? 'gr-navigation__menu--open' : '') + ' '
        }, _react2.default.createElement('nav', {
          className: 'gr-navigation__nav'
        }, _react2.default.createElement('img', {
          alt: alt,
          src: logo,
          className: 'gr-navigation__menu-logo'
        }), _react2.default.createElement('ul', {
          className: 'gr-navigation__items'
        }, _react2.default.createElement('li', {
          className: 'gr-navigation__item'
        }, _react2.default.createElement(_reactRouterDom.NavLink, {
          exact: true,
          to: '/',
          className: 'gr-navigation__link',
          activeClassName: 'gr-navigation__link--active'
        }, 'Home')), _react2.default.createElement(_NavLinks2.default, {
          routes: this.state.routes
        })))))), isMobileMenuOpen && _react2.default.createElement('div', {
          role: 'button',
          className: 'gr-navigation__background',
          onKeyUp: function onKeyUp() {
            return false;
          },
          onClick: this.toggle,
          tabIndex: -1
        }));
      }
    }]);

    return Navigation;
  }(_react.Component);

  exports.default = Navigation;
  Navigation.propTypes = {
    logo: _propTypes2.default.string,
    stickyLogo: _propTypes2.default.string,
    alt: _propTypes2.default.string,
    routes: _propTypes2.default.array // eslint-disable-line react/forbid-prop-types

  };
  Navigation.defaultProps = {
    logo: null,
    stickyLogo: null,
    alt: null,
    routes: []
  };
  /***/
},
/* 574 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactRouterDom = __webpack_require__(87);

  var _generic = __webpack_require__(10);

  __webpack_require__(189);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var NavLinks = function NavLinks(_ref) {
    var routes = _ref.routes;
    return routes.map(function (route) {
      var isSameRoute = route.url === window.location.pathname;
      var linkAttrs = {
        to: route.url,
        className: route.isButton ? 'gr-cta gr-navigation__cta' : 'gr-navigation__link'
      };

      if (isSameRoute) {
        linkAttrs.to = null;
        linkAttrs.className += route.isButton ? ' gr-navigation__cta--active' : ' gr-navigation__link--active';
      }

      return _react2.default.createElement('li', {
        className: 'gr-navigation__item',
        key: (0, _generic.randomStr)(route.title)
      }, isSameRoute && _react2.default.createElement('span', linkAttrs, route.title), !isSameRoute && _react2.default.createElement(_reactRouterDom.Link, linkAttrs, _react2.default.createElement('span', {
        className: '' + (route.isButton ? 'gr-cta__text' : '')
      }, route.title)));
    });
  };

  NavLinks.propTypes = {
    routes: _propTypes2.default.array // eslint-disable-line react/forbid-prop-types

  };
  NavLinks.defaultProps = {
    routes: []
  };
  exports.default = NavLinks;
  /***/
},
/* 575 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-navigation {\n  max-width: 1920px;\n  margin: 0 auto; }\n  .gr-navigation__background {\n    z-index: 6;\n    position: absolute;\n    background-color: transparent;\n    width: 100%;\n    height: 100%;\n    transition: background-color .2s ease;\n    visibility: hidden; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__background {\n        display: none; } }\n  .gr-navigation__burger {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 25px;\n    height: 25px;\n    background-color: transparent;\n    border: none;\n    padding: 25px;\n    z-index: 4; }\n    .gr-navigation__burger--active {\n      border: 1px solid #7C7C7B;\n      border-radius: 50%;\n      top: 10px;\n      right: 10px;\n      padding: 15px; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__burger {\n        display: none; } }\n  .gr-navigation__wrapper {\n    position: relative;\n    text-align: center;\n    z-index: 7;\n    width: 100%;\n    padding: 12px 0;\n    background-color: rgba(255, 255, 255, 0.9);\n    font-family: \"fs_elliotbold\";\n    box-shadow: 0 3px 4px 0 rgba(124, 124, 123, 0.1); }\n    .gr-navigation__wrapper.gr-navigation__wrapper--menu {\n      box-shadow: none; }\n    .gr-navigation__wrapper::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: transparent;\n      transition: background-color .2s ease;\n      pointer-events: none;\n      z-index: 1; }\n      @media all and (min-width: 992px) {\n        .gr-navigation__wrapper::before {\n          display: none; } }\n    @media all and (min-width: 992px) {\n      .gr-navigation__wrapper {\n        padding: 15px 0; } }\n    .gr-navigation__wrapper--sticky {\n      position: fixed;\n      text-align: center;\n      top: 0;\n      left: 0;\n      right: 0;\n      transform: translateY(-100%);\n      animation-name: sticky;\n      -webkit-animation: sticky;\n      -moz-animation: sticky;\n      -ms-animation: sticky;\n      -o-animation: sticky;\n      animation-fill-mode: forwards;\n      animation-delay: .4s;\n      animation-duration: .6s; }\n      .gr-navigation__wrapper--sticky .gr-navigation__burger {\n        align-self: center; }\n    .gr-navigation__wrapper--menu::before {\n      background-color: white;\n      transition: background-color .3s ease; }\n    .gr-navigation__wrapper--menu + .gr-navigation__background {\n      background-color: white;\n      visibility: visible; }\n  .gr-navigation__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 90%;\n    margin: 0 auto;\n    padding: 0 15px; }\n  .gr-navigation__brand {\n    margin: 0 auto;\n    width: 150px;\n    height: 100%;\n    max-width: 100%;\n    display: inline-block;\n    position: relative; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__brand {\n        margin: 0;\n        left: 0;\n        max-width: 160px; } }\n    .gr-navigation__brand--sticky {\n      width: 120px;\n      margin: 0;\n      padding: 5px 0;\n      float: left;\n      left: 0; }\n      @media all and (min-width: 992px) {\n        .gr-navigation__brand--sticky {\n          width: 140px;\n          padding: 0; } }\n  .gr-navigation__logo {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    position: relative; }\n    .gr-navigation__logo .item {\n      fill-opacity: 0;\n      animation-name: fade;\n      -webkit-animation: fade;\n      -moz-animation: fade;\n      -ms-animation: fade;\n      -o-animation: fade;\n      animation-fill-mode: in UK ;\n      animation-delay: 1s;\n      animation-duration: .3s;\n      animation-iteration-count: 1;\n      animation-timing-function: ease-in-out; }\n      .gr-navigation__logo .item--words {\n        animation-delay: 1.6s;\n        animation-duration: .7s; }\n    .gr-navigation__logo--ie {\n      opacity: 0;\n      animation-name: slide-in;\n      -webkit-animation: slide-in;\n      -moz-animation: slide-in;\n      -ms-animation: slide-in;\n      -o-animation: slide-in;\n      animation-fill-mode: forwards;\n      animation-duration: .3s; }\n      .gr-navigation__logo--ie .item {\n        fill-opacity: 1; }\n    .gr-navigation__logo .item--0 {\n      animation-delay: 1s; }\n    .gr-navigation__logo .item--1 {\n      animation-delay: 1.1s; }\n    .gr-navigation__logo .item--2 {\n      animation-delay: 1.2s; }\n    .gr-navigation__logo .item--3 {\n      animation-delay: 1.3s; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__logo {\n        margin-left: 0; } }\n    .gr-navigation__logo--sticky {\n      margin-left: 0; }\n  .gr-navigation__bar {\n    position: absolute;\n    background-color: #000000;\n    border-radius: 2px;\n    height: 3px;\n    left: 50%;\n    width: 25px;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    display: inherit;\n    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    transition-duration: 75ms; }\n    .gr-navigation__bar--active {\n      height: 1px;\n      width: 15px;\n      background-color: #7C7C7B;\n      transition-delay: .12s;\n      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n      transform: translate(-50%, -25%) rotate(45deg); }\n    .gr-navigation__bar::before, .gr-navigation__bar::after {\n      content: '';\n      position: absolute;\n      left: 0;\n      width: 100%;\n      height: inherit;\n      background-color: inherit;\n      border-radius: inherit; }\n    .gr-navigation__bar::before {\n      top: -8px;\n      transition: top 75ms ease .12s, opacity 75ms ease; }\n    .gr-navigation__bar--active::before {\n      top: 0;\n      transition: top 75ms ease, opacity 75ms ease .12s;\n      opacity: 0; }\n    .gr-navigation__bar::after {\n      bottom: -8px;\n      transition: bottom 75ms ease 0.12s, transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19); }\n    .gr-navigation__bar--active::after {\n      bottom: 0;\n      transition: bottom 75ms ease, transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;\n      transform: rotate(-90deg); }\n  .gr-navigation__nav {\n    position: relative;\n    padding-top: 65px;\n    padding-right: 15px;\n    text-align: center; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__nav {\n        padding: 0;\n        float: none; } }\n  .gr-navigation__menu {\n    position: absolute;\n    top: 0;\n    right: -100%;\n    z-index: 1;\n    transition: right .8s ease; }\n    .gr-navigation__menu--open {\n      right: 0;\n      width: 100%; }\n      .gr-navigation__menu--open .gr-navigation__nav {\n        display: block; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__menu {\n        position: relative;\n        display: inline-block;\n        width: auto;\n        top: auto;\n        right: auto;\n        filter: none;\n        margin-left: auto; } }\n  .gr-navigation__menu-rect {\n    fill: #FFFFFF;\n    clip-path: url(\"#gr-navigation-clippath\");\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0); }\n    @media all and (min-width: 992px) {\n      .gr-navigation__menu-rect {\n        display: none; } }\n  .gr-navigation__menu-logo {\n    width: 145px; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__menu-logo {\n        display: none; } }\n  .gr-navigation__items {\n    list-style: none;\n    padding: 0;\n    margin: 20px 0 0; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__items {\n        margin: 0; } }\n  .gr-navigation__item {\n    position: relative; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__item {\n        display: inline-block;\n        vertical-align: middle;\n        margin: 0 15px; }\n        .gr-navigation__item:first-child {\n          display: none;\n          margin-left: 0; }\n        .gr-navigation__item:last-child {\n          margin-right: 0; } }\n  .gr-navigation__link {\n    color: #000000;\n    font-size: 16px;\n    display: block;\n    padding: 20px 0;\n    text-transform: uppercase;\n    position: relative;\n    line-height: initial;\n    text-decoration: none; }\n    .gr-navigation__link::after {\n      content: '';\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      right: 0;\n      height: 2px;\n      transition: background-color .3s ease, left .3s ease, right .3s ease; }\n      @media all and (min-width: 992px) {\n        .gr-navigation__link::after {\n          left: 30%;\n          right: 30%; } }\n    .gr-navigation__link--active {\n      text-decoration: none;\n      transition: color .3s ease; }\n      .gr-navigation__link--active::after {\n        left: 0;\n        right: 0;\n        transition: background-color .3s ease, left .3s ease, right .3s ease; }\n    .gr-navigation__link:hover, .gr-navigation__link:focus {\n      text-decoration: none;\n      transition: color .3s ease;\n      outline: none; }\n      .gr-navigation__link:hover::after, .gr-navigation__link:focus::after {\n        left: 0;\n        right: 0;\n        transition: background-color .3s ease, left .3s ease, right .3s ease; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__link {\n        padding: 0;\n        display: inline-block;\n        max-width: 115px;\n        min-width: 115px;\n        font-size: 15px;\n        padding-bottom: 5px; } }\n  .gr-navigation__cta {\n    max-width: 200px;\n    line-height: initial; }\n    .gr-navigation__cta--active {\n      background-color: #FFFFFF; }\n    @media all and (min-width: 992px) {\n      .gr-navigation__cta {\n        margin: 0;\n        font-size: 15px; } }\n    .gr-navigation__cta:hover, .gr-navigation__cta:focus {\n      background-color: #FFFFFF; }\n  @media all and (min-width: 992px) {\n    .gr-navigation--sticky .gr-navigation__cta {\n      width: 235px; } }\n  .gr-navigation__svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1; }\n    .gr-navigation__svg--shadow {\n      padding-left: 6px;\n      padding-bottom: 20px;\n      height: calc(100% + 20px); }\n      @media all and (min-width: 992px) {\n        .gr-navigation__svg--shadow {\n          display: none; } }\n  .gr-navigation__nav-angle {\n    position: absolute;\n    left: -75px;\n    top: 0;\n    width: 75px;\n    height: 100%;\n    background: linear-gradient(to left top, #FFFFFF 49.5%, transparent 50%); }\n    @media all and (min-width: 992px) {\n      .gr-navigation__nav-angle {\n        display: none; } }\n\n@-webkit-keyframes slide-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes slide-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes slide-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes slide-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes slide-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes sticky {\n  from {\n    transform: translateY(-100%);\n    opacity: 0; }\n  to {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@-moz-keyframes sticky {\n  from {\n    transform: translateY(-100%);\n    opacity: 0; }\n  to {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@-ms-keyframes sticky {\n  from {\n    transform: translateY(-100%);\n    opacity: 0; }\n  to {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@-o-keyframes sticky {\n  from {\n    transform: translateY(-100%);\n    opacity: 0; }\n  to {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@keyframes sticky {\n  from {\n    transform: translateY(-100%);\n    opacity: 0; }\n  to {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@-webkit-keyframes fade {\n  from {\n    fill-opacity: 0; }\n  to {\n    fill-opacity: 1; } }\n\n@-moz-keyframes fade {\n  from {\n    fill-opacity: 0; }\n  to {\n    fill-opacity: 1; } }\n\n@-ms-keyframes fade {\n  from {\n    fill-opacity: 0; }\n  to {\n    fill-opacity: 1; } }\n\n@-o-keyframes fade {\n  from {\n    fill-opacity: 0; }\n  to {\n    fill-opacity: 1; } }\n\n@keyframes fade {\n  from {\n    fill-opacity: 0; }\n  to {\n    fill-opacity: 1; } }\n", ""]); // exports

  /***/
},
/* 576 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Links = __webpack_require__(37);

  __webpack_require__(577);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var NotFound = function NotFound(_ref) {
    var pageText = _ref.pageText;
    return _react2.default.createElement('section', {
      className: 'gr-not-found'
    }, _react2.default.createElement('div', {
      className: 'container'
    }, pageText.title && _react2.default.createElement('p', {
      className: 'gr-not-found__category'
    }, pageText.title), pageText.heading && _react2.default.createElement('h2', {
      className: 'gr-not-found__title'
    }, pageText.heading), pageText.description && _react2.default.createElement('p', {
      className: 'gr-not-found__text',
      dangerouslySetInnerHTML: {
        __html: pageText.description
      }
    }), _react2.default.createElement(_Links.Links, {
      text: 'Home',
      location: '/',
      className: 'gr-cta gr-not-found__cta'
    })));
  };

  NotFound.propTypes = {
    pageText: _propTypes2.default.shape({
      title: _propTypes2.default.string,
      heading: _propTypes2.default.string,
      description: _propTypes2.default.string
    })
  };
  NotFound.defaultProps = {
    pageText: {
      title: '404: Page not found',
      heading: 'Lost?',
      description: 'You seem to have reached a page that doesn&#39;t exist. \n      Don&#39;t worry, we&#39;ll help you find your way...'
    }
  };
  exports.default = NotFound;
  /***/
},
/* 577 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(578);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./NotFound.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./NotFound.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 578 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-not-found {\n  background-color: #00627B;\n  color: #FFFFFF;\n  position: relative;\n  padding: 40px 0; }\n  .gr-not-found--finzels {\n    height: 100vh;\n    background-color: #00627B; }\n  @media all and (min-width: 992px) {\n    .gr-not-found {\n      padding: 70px 0 40px; } }\n  .gr-not-found::after {\n    content: '';\n    background-color: #00627B;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    bottom: 0; }\n    @media all and (min-width: 768px) {\n      .gr-not-found::after {\n        bottom: -190px; } }\n    @media all and (min-width: 992px) {\n      .gr-not-found::after {\n        bottom: -240px; } }\n  .gr-not-found__category {\n    font-size: 20px;\n    margin: 0 0 35px;\n    padding-bottom: 10px;\n    border-bottom: 3px solid #FFFFFF; }\n    @media all and (min-width: 992px) {\n      .gr-not-found__category {\n        font-size: 30px;\n        margin-bottom: 48px; } }\n  .gr-not-found__title {\n    font-size: 30px;\n    margin: 0 0 15px;\n    text-transform: uppercase; }\n    @media all and (min-width: 992px) {\n      .gr-not-found__title {\n        font-size: 60px;\n        margin-bottom: 20px; } }\n  .gr-not-found__text {\n    font-size: 18px;\n    margin: 0 0 15px;\n    max-width: 600px; }\n    @media all and (min-width: 992px) {\n      .gr-not-found__text {\n        font-size: 20px;\n        margin-bottom: 20px; } }\n  .gr-not-found__cta {\n    background-color: #62B1AD;\n    color: #FFFFFF; }\n", ""]); // exports

  /***/
},
/* 579 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PropertyManagers = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _ListPropertyManagers = __webpack_require__(580);

  __webpack_require__(190);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PropertyManagers = exports.PropertyManagers = function PropertyManagers(_ref) {
    var title = _ref.title,
        subtitle = _ref.subtitle,
        managers = _ref.managers;
    return _react2.default.createElement('div', {
      className: 'gr-property-managers'
    }, _react2.default.createElement('div', {
      className: 'container'
    }, _react2.default.createElement('div', {
      className: 'gr-property-managers__content'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-property-managers__title'
    }, title), subtitle && _react2.default.createElement('div', {
      className: 'gr-property-managers__subtitle',
      dangerouslySetInnerHTML: {
        __html: subtitle
      }
    }), managers && _react2.default.createElement(_ListPropertyManagers.ListPropertyManagers, {
      managers: managers
    }))));
  };

  PropertyManagers.propTypes = {
    title: _propTypes2.default.string,
    subtitle: _propTypes2.default.string,
    managers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      name: _propTypes2.default.string,
      role: _propTypes2.default.string,
      image: _propTypes2.default.shape({
        url: _propTypes2.default.string
      })
    }))
  };
  PropertyManagers.defaultProps = {
    title: null,
    subtitle: null,
    managers: null
  };
  exports.default = PropertyManagers;
  /***/
},
/* 580 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ListPropertyManagers = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _List = __webpack_require__(61);

  var _generic = __webpack_require__(10);

  __webpack_require__(190);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ListPropertyManagers = exports.ListPropertyManagers = function ListPropertyManagers(_ref) {
    var managers = _ref.managers;
    return _react2.default.createElement(_List.List, {
      isUnstyled: true,
      isInline: true,
      className: 'gr-property-managers__managers row'
    }, managers.map(function (manager) {
      return _react2.default.createElement('li', {
        className: 'gr-property-managers__manager',
        key: (0, _generic.randomStr)(manager.name)
      }, _react2.default.createElement('figure', {
        className: 'gr-property-managers__figure'
      }, _react2.default.createElement('div', {
        className: 'gr-property-managers__image',
        style: manager.image.url ? {
          backgroundImage: 'url(' + manager.image.url + ')'
        } : null
      }), _react2.default.createElement('figcaption', null, manager.name && _react2.default.createElement('span', {
        className: 'gr-property-managers__name'
      }, manager.name), manager.role && _react2.default.createElement('span', {
        className: 'gr-property-managers__role'
      }, manager.role))));
    }));
  };

  ListPropertyManagers.propTypes = {
    managers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      name: _propTypes2.default.string,
      role: _propTypes2.default.string,
      image: _propTypes2.default.shape({
        url: _propTypes2.default.string
      })
    }))
  };
  ListPropertyManagers.defaultProps = {
    managers: null
  };
  exports.default = ListPropertyManagers;
  /***/
},
/* 581 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-property-managers {\n  margin: 30px 0; }\n  @media all and (min-width: 768px) {\n    .gr-property-managers {\n      max-width: 1920px;\n      margin: 50px 0; } }\n  .gr-property-managers__content {\n    max-width: 400px;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-property-managers__content {\n        text-align: center;\n        max-width: 800px; } }\n  .gr-property-managers__title {\n    font-size: 22px;\n    line-height: 32px;\n    color: #4E8382; }\n    @media all and (min-width: 768px) {\n      .gr-property-managers__title {\n        font-size: 30px;\n        line-height: 42px; } }\n  .gr-property-managers__subtitle {\n    margin-top: 15px; }\n    @media all and (min-width: 768px) {\n      .gr-property-managers__subtitle {\n        margin-top: 20px;\n        font-size: 20px;\n        font-weight: 700; } }\n  .gr-property-managers__managers {\n    margin-top: 25px;\n    justify-content: center; }\n    .gr-property-managers__managers li {\n      margin-right: 0; }\n    @media all and (min-width: 768px) {\n      .gr-property-managers__managers {\n        margin-top: 30px; } }\n  .gr-property-managers__figure {\n    margin: 0; }\n  .gr-property-managers__manager {\n    margin-bottom: 20px;\n    text-align: center;\n    display: inline-block;\n    flex: 0 0 50%;\n    max-width: 50%;\n    padding: 0 10px; }\n    @media all and (min-width: 768px) {\n      .gr-property-managers__manager {\n        flex: 0 0 25%;\n        max-width: 25%;\n        padding: 0 15px;\n        margin-bottom: 25px; } }\n    @media all and (min-width: 992px) {\n      .gr-property-managers__manager {\n        font-size: 18px;\n        margin-bottom: 30px; } }\n  .gr-property-managers__image {\n    border: 1px solid #7C7C7B;\n    border-radius: 50%;\n    width: 130px;\n    height: 130px;\n    margin: 0 auto;\n    margin-bottom: 10px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center; }\n    @media all and (min-width: 768px) {\n      .gr-property-managers__image {\n        width: 135px;\n        height: 135px; } }\n    @media all and (min-width: 992px) {\n      .gr-property-managers__image {\n        width: 145px;\n        height: 145px;\n        margin-bottom: 15px; } }\n  .gr-property-managers__name {\n    display: block;\n    font-weight: 700; }\n", ""]); // exports

  /***/
},
/* 582 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.QuoteBlock = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _FloatMe = __webpack_require__(583);

  __webpack_require__(586);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Component = function Component(props) {
    return _react2.default.createElement('div', {
      className: 'gr-quote-block\n      ' + (props.isDarkTheme ? 'gr-quote-block--dark-theme' : 'gr-quote-block') + '\n      ' + (props.isFloated ? 'gr-quote-block--floated' : '')
    }, _react2.default.createElement('div', {
      className: 'gr-quote-block__container'
    }, _react2.default.createElement('div', {
      className: 'gr-quote-block__content'
    }, props.quote && _react2.default.createElement('blockquote', {
      className: 'gr-quote-block__quote ' + (props.isDarkTheme ? 'gr-quote-block--dark-theme' : '')
    }, props.quote), props.author && _react2.default.createElement('p', {
      className: 'gr-quote-block__author'
    }, props.author))));
  };

  var QuoteBlock = exports.QuoteBlock = function QuoteBlock(props) {
    if (!props.isFloated) {
      return _react2.default.createElement(Component, props);
    }

    var FloatedComponent = (0, _FloatMe.FloatMe)(Component);
    return _react2.default.createElement(FloatedComponent, props);
  };

  QuoteBlock.propTypes = {
    quote: _propTypes2.default.string,
    author: _propTypes2.default.string,
    isFloated: _propTypes2.default.bool,
    isDarkTheme: _propTypes2.default.bool
  };
  QuoteBlock.defaultProps = {
    quote: null,
    author: null,
    isFloated: false,
    isDarkTheme: _propTypes2.default.bool
  };
  Component.propTypes = {
    quote: _propTypes2.default.string,
    author: _propTypes2.default.string,
    isFloated: _propTypes2.default.bool,
    isDarkTheme: _propTypes2.default.bool
  };
  Component.defaultProps = {
    quote: null,
    author: null,
    isFloated: false,
    isDarkTheme: false
  };
  exports.default = QuoteBlock;
  /***/
},
/* 583 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FloatMe = undefined;

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  __webpack_require__(584);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FloatMe = exports.FloatMe = function FloatMe(WrappedComponent) {
    return function (props) {
      return _react2.default.createElement('div', {
        className: 'gr-float-me'
      }, _react2.default.createElement('div', {
        className: 'gr-float-me__content'
      }, _react2.default.createElement(WrappedComponent, props)));
    };
  };

  exports.default = FloatMe;
  /***/
},
/* 584 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(585);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./FloatMe.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./FloatMe.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 585 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-float-me {\n  position: relative;\n  z-index: 1; }\n  .gr-float-me__content {\n    background: rgba(255, 255, 255, 0.9);\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n    padding: 20px; }\n    @media all and (min-width: 768px) {\n      .gr-float-me__content {\n        max-width: 950px;\n        position: absolute;\n        bottom: 45px;\n        left: 100px;\n        right: 100px;\n        margin: 0 auto;\n        padding: 15px 30px; } }\n", ""]); // exports

  /***/
},
/* 586 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(587);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./QuoteBlock.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./QuoteBlock.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 587 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-quote-block {\n  text-align: center;\n  margin: 40px 0;\n  padding: 0 15px;\n  font-family: \"fs_elliotbold\"; }\n  @media all and (min-width: 768px) {\n    .gr-quote-block {\n      margin: 70px 0; } }\n  .gr-quote-block--floated {\n    padding: 0; }\n  .gr-quote-block__content {\n    position: relative;\n    max-width: 330px;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-quote-block__content {\n        max-width: 1920px; } }\n  .gr-quote-block__quote {\n    text-transform: uppercase;\n    color: #62B1AD;\n    font-size: 18px;\n    max-width: 350px;\n    margin: 0 auto; }\n    .gr-quote-block__quote::before, .gr-quote-block__quote::after {\n      content: '\"'; }\n    @media all and (min-width: 768px) {\n      .gr-quote-block__quote {\n        font-size: 24px;\n        max-width: 740px; } }\n  .gr-quote-block__author {\n    position: relative;\n    padding-top: 30px;\n    font-size: 16px;\n    margin: 0; }\n    @media all and (min-width: 768px) {\n      .gr-quote-block__author {\n        font-size: 20px;\n        padding-top: 50px; } }\n    .gr-quote-block__author::before {\n      content: '';\n      width: 75px;\n      height: 2px;\n      background-color: #7C7C7B;\n      position: absolute;\n      top: 15px;\n      left: 50%;\n      transform: translateX(-50%); }\n      @media all and (min-width: 768px) {\n        .gr-quote-block__author::before {\n          width: 120px;\n          top: 25px; } }\n  .gr-quote-block__right-sail {\n    display: none;\n    width: 330px;\n    height: 400px;\n    position: absolute;\n    transform: rotate(-8deg);\n    right: -100px;\n    top: -80px;\n    z-index: -1; }\n    @media all and (min-width: 768px) {\n      .gr-quote-block__right-sail {\n        display: block; } }\n", ""]); // exports

  /***/
},
/* 588 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.POIMap = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _googleMapsReact = __webpack_require__(191);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Place = __webpack_require__(602);

  var _Place2 = _interopRequireDefault(_Place);

  var _Tab = __webpack_require__(603);

  var _Tab2 = _interopRequireDefault(_Tab);

  var _graingerMapPin = __webpack_require__(194);

  var _graingerMapPin2 = _interopRequireDefault(_graingerMapPin);

  var _generic = __webpack_require__(10);

  var _GoogleApiComponent = __webpack_require__(606);

  var _GoogleApiComponent2 = _interopRequireDefault(_GoogleApiComponent);

  var _Carousel = __webpack_require__(68);

  __webpack_require__(609);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /**
   * POI (Point of Interest) Map component displays a tab-navigable selection of local
   * points of interest.
   */


  var POIMap = exports.POIMap = function (_Component) {
    _inherits(POIMap, _Component);

    function POIMap(props) {
      _classCallCheck(this, POIMap);

      var _this = _possibleConstructorReturn(this, (POIMap.__proto__ || Object.getPrototypeOf(POIMap)).call(this, props));

      _this.state = {
        items: _this.props.items,
        colours: _this.props.colours,
        locationCenter: _this.props.locationCenter,
        isAccordionOpen: false,
        currentMarker: null,
        currentItem: null,
        desktop: window.innerWidth >= 768
      };
      _this.setCurrentCategory = _this.setCurrentCategory.bind(_this);
      _this.openAccordion = _this.openAccordion.bind(_this);
      _this.loadPlaces = _this.loadPlaces.bind(_this);
      _this.setIsDesktop = _this.setIsDesktop.bind(_this);
      window.addEventListener('resize', _this.setIsDesktop);
      return _this;
    }

    _createClass(POIMap, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        if (prevProps.map !== this.props.map) {
          var FIRST_CATEGORY = Object.keys(this.props.items)[0];
          var PROMISES = this.props.items[FIRST_CATEGORY].map(this.loadPlaces);
          Promise.all(PROMISES).then(function (data) {
            var OBJ = {};
            OBJ[FIRST_CATEGORY] = data;

            _this2.setState({
              items: _extends({}, _this2.state.items, OBJ),
              currentItem: FIRST_CATEGORY,
              currentColor: _this2.state.colours[FIRST_CATEGORY],
              isAccordionOpen: false,
              currentMarker: data[0].placeId
            });
          });
        }
      }
      /**
       * Sets the current category to display points of interest related
       *
       * @param {object} Event recieved from node
       * @param {string} current category name clicked
       * @public
       */

    }, {
      key: 'setCurrentCategory',
      value: function setCurrentCategory(event, category) {
        var _this3 = this;

        var promises = this.state.items[category].map(function (item) {
          return _this3.loadPlaces(item);
        });
        Promise.all(promises).then(function (data) {
          var obj = {};
          obj[category] = data;

          _this3.setState({
            items: _extends({}, _this3.state.items, obj),
            currentItem: category,
            currentColor: _this3.state.colours[category],
            isAccordionOpen: false,
            currentMarker: _this3.state.desktop ? null : data[0].placeId
          });
        });
        event.preventDefault();
      }
      /**
       * Sets whether the user is a window >= 768, identified as 'desktop'
       *
       * @public
       */

    }, {
      key: 'setIsDesktop',
      value: function setIsDesktop() {
        this.setState({
          desktop: window.innerWidth >= 768
        });
      }
      /**
       * Toggles the isAccordionOpen state if called
       *
       * @param {object} Event recieved from node, default behaviour is prevented
       * @public
       */

    }, {
      key: 'openAccordion',
      value: function openAccordion(event) {
        event.preventDefault();
        this.setState({
          isAccordionOpen: !this.state.isAccordionOpen
        });
      }
      /**
       * Loads a place from the google places api
       *
       * @param {object} Current place to be loaded
       * @public
       */

    }, {
      key: 'loadPlaces',
      value: function loadPlaces(place) {
        var _this4 = this;

        var service = new this.props.google.maps.places.PlacesService(this.props.map);
        return new Promise(function (resolve) {
          if (place.name) {
            resolve(place);
          } else {
            if (_this4.props.env === 'development') {
              resolve({
                placeId: place.placeId,
                website: 'https://www.google.co.uk',
                name: 'Place name',
                displayName: place.displayName || 'This is a name',
                description: place.description || 'This is a description',
                position: {
                  lat: 1234567,
                  lng: -1234567
                }
              });
            }

            service.getDetails(place, function (placeData, status) {
              if (status === _this4.props.google.maps.places.PlacesServiceStatus.OK) {
                resolve({
                  placeId: place.placeId,
                  website: placeData.website || '',
                  name: placeData.name,
                  displayName: place.displayName || '',
                  description: place.description || '',
                  position: {
                    lat: placeData.geometry.location.lat(),
                    lng: placeData.geometry.location.lng()
                  }
                });
              }

              resolve(place);
            });
          }
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this5 = this;

        return !this.props.loaded ? _react2.default.createElement('div', null, 'Loading...') : _react2.default.createElement('div', {
          className: 'js-gr-poi-map gr-poi-map'
        }, _react2.default.createElement('h2', {
          className: 'sr-only'
        }, 'Point of Interest Map'), _react2.default.createElement('div', {
          className: 'gr-poi-map__map'
        }, _react2.default.createElement('div', {
          className: 'gr-map',
          id: 'map',
          ref: this.props.wrappedRef,
          style: {
            width: '100%',
            height: '100%'
          }
        }, 'Loading map...', _react2.default.createElement(_googleMapsReact.Marker, {
          position: this.state.locationCenter,
          map: this.props.map,
          google: this.props.google,
          icon: {
            url: _graingerMapPin2.default
          }
        }), this.state.currentItem && this.state.items[this.state.currentItem].map(function (item, index) {
          var isCurrentMarker = _this5.state.currentMarker === item.placeId;
          return _react2.default.createElement(_googleMapsReact.Marker, {
            key: (0, _generic.randomStr)(item.name),
            title: item.displayName || item.name,
            position: item.position,
            map: _this5.props.map,
            google: _this5.props.google,
            onClick: function onClick() {
              return _this5.setState({
                currentMarker: item.placeId
              });
            },
            icon: {
              path: 'M16.4545455,23 L11,33 L5.54545455,23 L0,23 L0,0 L23,0 L23,23 L16.4545455,23 Z',
              fillColor: isCurrentMarker || _this5.state.desktop ? _this5.state.currentColor : '#4A4A4A',
              fillOpacity: 1,
              strokeColor: isCurrentMarker || _this5.state.desktop ? _this5.state.currentColor : '#4A4A4A',
              strokeWeight: 1,
              scale: 1,
              labelOrigin: new _this5.props.google.maps.Point(12, 12),
              anchor: new _this5.props.google.maps.Point(0, 40)
            },
            label: {
              color: '#FFFFFF',
              fontFamily: 'fs_elliotregular',
              text: '' + (index + 1)
            }
          });
        })), _react2.default.createElement('div', {
          className: 'gr-poi-map__accordion'
        }, _react2.default.createElement(_Tab2.default, {
          action: function action(e) {
            return _this5.openAccordion(e);
          },
          link: this.state.currentItem || 'open',
          className: 'gr-poi-map-tab--selected',
          color: this.state.currentColor,
          currentItem: true,
          open: this.state.isAccordionOpen
        }), _react2.default.createElement('ul', {
          className: 'list list--unstyled gr-poi-map__accordion-dropdown\n                ' + (this.state.isAccordionOpen ? 'gr-poi-map__accordion-dropdown--open' : '')
        }, Object.keys(this.state.items).map(function (link) {
          return _react2.default.createElement('li', {
            key: (0, _generic.randomStr)(link),
            className: 'gr-poi-map__tab-item\n                      ' + (_this5.state.currentItem === link ? 'gr-poi-map__tab--active' : '')
          }, _react2.default.createElement(_Tab2.default, {
            key: (0, _generic.randomStr)(),
            link: link,
            color: _this5.state.colours[link],
            action: function action(e) {
              return _this5.setCurrentCategory(e, link);
            }
          }));
        })))), _react2.default.createElement('div', {
          className: 'gr-poi-map__tab'
        }, _react2.default.createElement('ul', {
          className: 'list list--unstyled gr-poi-map__tabs',
          style: {
            borderColor: this.state.currentColor
          }
        }, Object.keys(this.state.items).map(function (link) {
          return _react2.default.createElement('li', {
            key: (0, _generic.randomStr)(link)
          }, _react2.default.createElement(_Tab2.default, {
            key: (0, _generic.randomStr)(),
            link: link,
            color: _this5.state.colours[link],
            action: function action(e) {
              return _this5.setCurrentCategory(e, link);
            },
            className: _this5.state.currentItem === link ? 'gr-poi-map-tab--selected' : ''
          }));
        }))), _react2.default.createElement('div', {
          className: 'gr-poi-map__tab-body ' + (this.state.currentItem ? 'gr-poi-map__tab-body--active' : '')
        }, this.state.currentItem && this.state.items[this.state.currentItem].length > 4 && _react2.default.createElement(_Carousel.Carousel, {
          centerMode: false,
          fullWidth: 4,
          infinite: false,
          plainDesign: true
        }, this.state.currentItem && this.state.items[this.state.currentItem].map(function (item, index) {
          return _react2.default.createElement(_Place2.default, {
            key: (0, _generic.randomStr)(item.name),
            item: item,
            index: String(index + 1),
            currentColor: _this5.state.currentColor,
            currentMarker: !_this5.state.currentMarker ? _this5.state.items[_this5.state.currentItem][0].name === item.name : _this5.state.currentMarker === item.placeId
          });
        })), _react2.default.createElement('div', {
          className: 'row ' + (this.state.currentItem && this.state.items[this.state.currentItem].length > 4 ? 'gr-poi-map__tab-body-row--desktop-hide' : '')
        }, this.state.currentItem && this.state.items[this.state.currentItem].map(function (item, index) {
          return _react2.default.createElement(_Place2.default, {
            key: (0, _generic.randomStr)(item.name),
            item: item,
            index: String(index + 1),
            className: 'col-md-3',
            currentColor: _this5.state.currentColor,
            currentMarker: !_this5.state.currentMarker ? _this5.state.items[_this5.state.currentItem][0].name === item.name : _this5.state.currentMarker === item.placeId
          });
        }))));
      }
    }]);

    return POIMap;
  }(_react.Component);

  POIMap.propTypes = {
    /** Name of the category of point of interests. */
    items: _propTypes2.default.shape({
      /** Object containing placeId, optional description and displayName */
      item: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        placeId: _propTypes2.default.string,
        description: _propTypes2.default.string,
        displayName: _propTypes2.default.string
      }))
    }),

    /** The location where all the points of interest relate to */
    locationCenter: _propTypes2.default.shape({
      /** The latitude of the location */
      lat: _propTypes2.default.number,

      /** The longitude of the location */
      lng: _propTypes2.default.number
    }),

    /** Colours of the tabs. Key must be same as 'items' name. */
    colours: _propTypes2.default.shape(),

    /** Whether the map has loaded or not. Passed in from HOC */
    loaded: _propTypes2.default.bool,

    /** Function to load the ref of map. Passed in from HOC */
    wrappedRef: _propTypes2.default.func,

    /** Node of the map. Passed in from HOC */
    map: _propTypes2.default.shape(),

    /** Object of the google maps api. Passed in from HOC */
    google: _propTypes2.default.shape(),
    env: _propTypes2.default.string
  };
  POIMap.defaultProps = {
    items: null,
    colours: null,
    locationCenter: null,
    loaded: false,
    wrappedRef: null,
    map: null,
    google: null,
    env: 'development'
  };
  exports.default = (0, _GoogleApiComponent2.default)({
    apiKey: 'AIzaSyBQRegyJHQpbPx9F3BYJOOGG1qryZkJfZ4'
  })(POIMap);
  /***/
},
/* 589 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(55), __webpack_require__(590), __webpack_require__(592)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('react'), require('react-dom'), require('./lib/ScriptCache'), require('./lib/GoogleApi'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.react, global.reactDom, global.ScriptCache, global.GoogleApi);
      global.GoogleApiComponent = mod.exports;
    }
  })(this, function (exports, _react, _reactDom, _ScriptCache, _GoogleApi) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.wrapper = undefined;

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var defaultMapConfig = {};

    var serialize = function serialize(obj) {
      return JSON.stringify(obj);
    };

    var isSame = function isSame(obj1, obj2) {
      return obj1 === obj2 || serialize(obj1) === serialize(obj2);
    };

    var defaultCreateCache = function defaultCreateCache(options) {
      options = options || {};
      var apiKey = options.apiKey;
      var libraries = options.libraries || ['places'];
      var version = options.version || '3';
      var language = options.language || 'en';
      var url = options.url;
      var client = options.client;
      return (0, _ScriptCache.ScriptCache)({
        google: (0, _GoogleApi2.default)({
          apiKey: apiKey,
          language: language,
          libraries: libraries,
          version: version,
          url: url,
          client: client
        })
      });
    };

    var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
      return _react2.default.createElement('div', null, 'Loading...');
    };

    var wrapper = exports.wrapper = function wrapper(input) {
      return function (WrappedComponent) {
        var Wrapper = function (_React$Component) {
          _inherits(Wrapper, _React$Component);

          function Wrapper(props, context) {
            _classCallCheck(this, Wrapper); // Build options from input


            var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

            var options = typeof input === 'function' ? input(props) : input; // Initialize required Google scripts and other configured options

            _this.initialize(options);

            _this.state = {
              loaded: false,
              map: null,
              google: null,
              options: options
            };
            return _this;
          }

          _createClass(Wrapper, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(props) {
              // Do not update input if it's not dynamic
              if (typeof input !== 'function') {
                return;
              } // Get options to compare


              var prevOptions = this.state.options;
              var options = typeof input === 'function' ? input(props) : input; // Ignore when options are not changed

              if (isSame(options, prevOptions)) {
                return;
              } // Initialize with new options


              this.initialize(options); // Save new options in component state,
              // and remove information about previous API handlers

              this.setState({
                options: options,
                loaded: false,
                google: null
              });
            }
          }, {
            key: 'initialize',
            value: function initialize(options) {
              // Avoid race condition: remove previous 'load' listener
              if (this.unregisterLoadHandler) {
                this.unregisterLoadHandler();
                this.unregisterLoadHandler = null;
              } // Load cache factory


              var createCache = options.createCache || defaultCreateCache; // Build script

              this.scriptCache = createCache(options);
              this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this)); // Store information about loading container

              this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
            }
          }, {
            key: 'onLoad',
            value: function onLoad(err, tag) {
              this._gapi = window.google;
              this.setState({
                loaded: true,
                google: this._gapi
              });
            }
          }, {
            key: 'render',
            value: function render() {
              var LoadingContainer = this.LoadingContainer;

              if (!this.state.loaded) {
                return _react2.default.createElement(LoadingContainer, null);
              }

              var props = Object.assign({}, this.props, {
                loaded: this.state.loaded,
                google: window.google
              });
              return _react2.default.createElement('div', null, _react2.default.createElement(WrappedComponent, props), _react2.default.createElement('div', {
                ref: 'map'
              }));
            }
          }]);

          return Wrapper;
        }(_react2.default.Component);

        return Wrapper;
      };
    };

    exports.default = wrapper;
  });
  /***/

},
/* 590 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(591)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('./windowOrGlobal'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.windowOrGlobal);
      global.ScriptCache = mod.exports;
    }
  })(this, function (exports, window) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== 'undefined' && window._scriptMap || new Map();

    var ScriptCache = exports.ScriptCache = function (global) {
      global._scriptMap = global._scriptMap || scriptMap;
      return function ScriptCache(scripts) {
        var Cache = {};

        Cache._onLoad = function (key) {
          return function (cb) {
            var registered = true;

            function unregister() {
              registered = false;
            }

            var stored = scriptMap.get(key);

            if (stored) {
              stored.promise.then(function () {
                if (registered) {
                  stored.error ? cb(stored.error) : cb(null, stored);
                }

                return stored;
              });
            } else {// TODO:
            }

            return unregister;
          };
        };

        Cache._scriptTag = function (key, src) {
          if (!scriptMap.has(key)) {
            // Server side rendering environments don't always have access to the `document` global.
            // In these cases, we're not going to be able to return a script tag, so just return null.
            if (typeof document === 'undefined') return null;
            var tag = document.createElement('script');
            var promise = new Promise(function (resolve, reject) {
              var resolved = false,
                  errored = false,
                  body = document.getElementsByTagName('body')[0];
              tag.type = 'text/javascript';
              tag.async = false; // Load in order

              var cbName = 'loaderCB' + counter++ + Date.now();
              var cb = void 0;

              var handleResult = function handleResult(state) {
                return function (evt) {
                  var stored = scriptMap.get(key);

                  if (state === 'loaded') {
                    stored.resolved = true;
                    resolve(src); // stored.handlers.forEach(h => h.call(null, stored))
                    // stored.handlers = []
                  } else if (state === 'error') {
                    stored.errored = true; // stored.handlers.forEach(h => h.call(null, stored))
                    // stored.handlers = [];

                    reject(evt);
                  }

                  stored.loaded = true;
                  cleanup();
                };
              };

              var cleanup = function cleanup() {
                if (global[cbName] && typeof global[cbName] === 'function') {
                  global[cbName] = null;
                  delete global[cbName];
                }
              };

              tag.onload = handleResult('loaded');
              tag.onerror = handleResult('error');

              tag.onreadystatechange = function () {
                handleResult(tag.readyState);
              }; // Pick off callback, if there is one


              if (src.match(/callback=CALLBACK_NAME/)) {
                src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
                cb = window[cbName] = tag.onload;
              } else {
                tag.addEventListener('load', tag.onload);
              }

              tag.addEventListener('error', tag.onerror);
              tag.src = src;
              body.appendChild(tag);
              return tag;
            });
            var initialState = {
              loaded: false,
              error: false,
              promise: promise,
              tag: tag
            };
            scriptMap.set(key, initialState);
          }

          return scriptMap.get(key);
        }; // let scriptTags = document.querySelectorAll('script')
        //
        // NodeList.prototype.filter = Array.prototype.filter;
        // NodeList.prototype.map = Array.prototype.map;
        // const initialScripts = scriptTags
        //   .filter(s => !!s.src)
        //   .map(s => s.src.split('?')[0])
        //   .reduce((memo, script) => {
        //     memo[script] = script;
        //     return memo;
        //   }, {});


        Object.keys(scripts).forEach(function (key) {
          var script = scripts[key];
          var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);
          Cache[key] = {
            tag: tag,
            onLoad: Cache._onLoad(key)
          };
        });
        return Cache;
      };
    }(window);

    exports.default = ScriptCache;
  });
  /***/

},
/* 591 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

    (function (global, factory) {
      if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else if (typeof exports !== "undefined") {
        factory(module);
      } else {
        var mod = {
          exports: {}
        };
        factory(mod);
        global.windowOrGlobal = mod.exports;
      }
    })(this, function (module) {
      'use strict';

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      module.exports = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;
    });
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(56));
  /***/
},
/* 592 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports);
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports);
      global.GoogleApi = mod.exports;
    }
  })(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
      opts = opts || {};

      if (!opts.hasOwnProperty('apiKey')) {
        throw new Error('You must pass an apiKey to use GoogleApi');
      }

      var apiKey = opts.apiKey;
      var libraries = opts.libraries || ['places'];
      var client = opts.client;
      var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';
      var googleVersion = opts.version || '3.31';
      var script = null;
      var google = typeof window !== 'undefined' && window.google || null;
      var loading = false;
      var channel = null;
      var language = opts.language;
      var region = opts.region || null;
      var onLoadEvents = [];

      var url = function url() {
        var url = URL;
        var params = {
          key: apiKey,
          callback: 'CALLBACK_NAME',
          libraries: libraries.join(','),
          client: client,
          v: googleVersion,
          channel: channel,
          language: language,
          region: region
        };
        var paramStr = Object.keys(params).filter(function (k) {
          return !!params[k];
        }).map(function (k) {
          return k + '=' + params[k];
        }).join('&');
        return url + '?' + paramStr;
      };

      return url();
    };

    exports.default = GoogleApi;
  });
  /***/

},
/* 593 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('react'), require('prop-types'), require('../lib/String'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.react, global.propTypes, global.String);
      global.Marker = mod.exports;
    }
  })(this, function (exports, _react, _propTypes, _String) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Marker = undefined;

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

    var wrappedPromise = function wrappedPromise() {
      var wrappedPromise = {},
          promise = new Promise(function (resolve, reject) {
        wrappedPromise.resolve = resolve;
        wrappedPromise.reject = reject;
      });
      wrappedPromise.then = promise.then.bind(promise);
      wrappedPromise.catch = promise.catch.bind(promise);
      wrappedPromise.promise = promise;
      return wrappedPromise;
    };

    var Marker = exports.Marker = function (_React$Component) {
      _inherits(Marker, _React$Component);

      function Marker() {
        _classCallCheck(this, Marker);

        return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
      }

      _createClass(Marker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.markerPromise = wrappedPromise();
          this.renderMarker();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
            if (this.marker) {
              this.marker.setMap(null);
            }

            this.renderMarker();
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.marker) {
            this.marker.setMap(null);
          }
        }
      }, {
        key: 'renderMarker',
        value: function renderMarker() {
          var _this2 = this;

          var _props = this.props,
              map = _props.map,
              google = _props.google,
              position = _props.position,
              mapCenter = _props.mapCenter,
              icon = _props.icon,
              label = _props.label,
              draggable = _props.draggable,
              title = _props.title,
              props = _objectWithoutProperties(_props, ['map', 'google', 'position', 'mapCenter', 'icon', 'label', 'draggable', 'title']);

          if (!google) {
            return null;
          }

          var pos = position || mapCenter;

          if (!(pos instanceof google.maps.LatLng)) {
            pos = new google.maps.LatLng(pos.lat, pos.lng);
          }

          var pref = _extends({
            map: map,
            position: pos,
            icon: icon,
            label: label,
            title: title,
            draggable: draggable
          }, props);

          this.marker = new google.maps.Marker(pref);
          evtNames.forEach(function (e) {
            _this2.marker.addListener(e, _this2.handleEvent(e));
          });
          this.markerPromise.resolve(this.marker);
        }
      }, {
        key: 'getMarker',
        value: function getMarker() {
          return this.markerPromise;
        }
      }, {
        key: 'handleEvent',
        value: function handleEvent(evt) {
          var _this3 = this;

          return function (e) {
            var evtName = 'on' + (0, _String.camelize)(evt);

            if (_this3.props[evtName]) {
              _this3.props[evtName](_this3.props, _this3.marker, e);
            }
          };
        }
      }, {
        key: 'render',
        value: function render() {
          return null;
        }
      }]);

      return Marker;
    }(_react2.default.Component);

    Marker.propTypes = {
      position: _propTypes2.default.object,
      map: _propTypes2.default.object
    };
    evtNames.forEach(function (e) {
      return Marker.propTypes[e] = _propTypes2.default.func;
    });
    Marker.defaultProps = {
      name: 'Marker'
    };
    exports.default = Marker;
  });
  /***/

},
/* 594 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(55), __webpack_require__(595)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-dom/server'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.react, global.propTypes, global.reactDom, global.server);
      global.InfoWindow = mod.exports;
    }
  })(this, function (exports, _react, _propTypes, _reactDom, _server) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.InfoWindow = undefined;

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _server2 = _interopRequireDefault(_server);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var InfoWindow = exports.InfoWindow = function (_React$Component) {
      _inherits(InfoWindow, _React$Component);

      function InfoWindow() {
        _classCallCheck(this, InfoWindow);

        return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
      }

      _createClass(InfoWindow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.renderInfoWindow();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          var _props = this.props,
              google = _props.google,
              map = _props.map;

          if (!google || !map) {
            return;
          }

          if (map !== prevProps.map) {
            this.renderInfoWindow();
          }

          if (this.props.position !== prevProps.position) {
            this.updatePosition();
          }

          if (this.props.children !== prevProps.children) {
            this.updateContent();
          }

          if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) {
            this.props.visible ? this.openWindow() : this.closeWindow();
          }
        }
      }, {
        key: 'renderInfoWindow',
        value: function renderInfoWindow() {
          var _props2 = this.props,
              map = _props2.map,
              google = _props2.google,
              mapCenter = _props2.mapCenter,
              props = _objectWithoutProperties(_props2, ['map', 'google', 'mapCenter']);

          if (!google || !google.maps) {
            return;
          }

          var iw = this.infowindow = new google.maps.InfoWindow(_extends({
            content: ''
          }, props));
          google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
          google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
        }
      }, {
        key: 'onOpen',
        value: function onOpen() {
          if (this.props.onOpen) {
            this.props.onOpen();
          }
        }
      }, {
        key: 'onClose',
        value: function onClose() {
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
      }, {
        key: 'openWindow',
        value: function openWindow() {
          this.infowindow.open(this.props.map, this.props.marker);
        }
      }, {
        key: 'updatePosition',
        value: function updatePosition() {
          var pos = this.props.position;

          if (!(pos instanceof google.maps.LatLng)) {
            pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
          }

          this.infowindow.setPosition(pos);
        }
      }, {
        key: 'updateContent',
        value: function updateContent() {
          var content = this.renderChildren();
          this.infowindow.setContent(content);
        }
      }, {
        key: 'closeWindow',
        value: function closeWindow() {
          this.infowindow.close();
        }
      }, {
        key: 'renderChildren',
        value: function renderChildren() {
          var children = this.props.children;
          return _server2.default.renderToString(children);
        }
      }, {
        key: 'render',
        value: function render() {
          return null;
        }
      }]);

      return InfoWindow;
    }(_react2.default.Component);

    InfoWindow.propTypes = {
      children: _propTypes2.default.element.isRequired,
      map: _propTypes2.default.object,
      marker: _propTypes2.default.object,
      position: _propTypes2.default.object,
      visible: _propTypes2.default.bool,
      // callbacks
      onClose: _propTypes2.default.func,
      onOpen: _propTypes2.default.func
    };
    InfoWindow.defaultProps = {
      visible: false
    };
    exports.default = InfoWindow;
  });
  /***/

},
/* 595 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(596);
    } else {
      module.exports = __webpack_require__(597);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 596 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v16.4.0
   * react-dom-server.browser.production.min.js
   *
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var p = __webpack_require__(54),
      r = __webpack_require__(65),
      t = __webpack_require__(1),
      w = __webpack_require__(53),
      x = __webpack_require__(89),
      y = __webpack_require__(128),
      z = __webpack_require__(192);

  function A(a) {
    for (var b = arguments.length - 1, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++) {
      d += "&args[]=" + encodeURIComponent(arguments[c + 1]);
    }

    p(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", d);
  }

  var C = "function" === typeof Symbol && Symbol.for,
      aa = C ? Symbol.for("react.portal") : 60106,
      E = C ? Symbol.for("react.fragment") : 60107,
      ba = C ? Symbol.for("react.strict_mode") : 60108,
      ca = C ? Symbol.for("react.profiler") : 60114,
      F = C ? Symbol.for("react.provider") : 60109,
      da = C ? Symbol.for("react.context") : 60110,
      ea = C ? Symbol.for("react.async_mode") : 60111,
      fa = C ? Symbol.for("react.forward_ref") : 60112,
      ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      G = {},
      H = {};

  function ia(a) {
    if (H.hasOwnProperty(a)) return !0;
    if (G.hasOwnProperty(a)) return !1;
    if (ha.test(a)) return H[a] = !0;
    G[a] = !0;
    return !1;
  }

  function ja(a, b, d, c) {
    if (null !== d && 0 === d.type) return !1;

    switch (typeof b) {
      case "function":
      case "symbol":
        return !0;

      case "boolean":
        if (c) return !1;
        if (null !== d) return !d.acceptsBooleans;
        a = a.toLowerCase().slice(0, 5);
        return "data-" !== a && "aria-" !== a;

      default:
        return !1;
    }
  }

  function ka(a, b, d, c) {
    if (null === b || "undefined" === typeof b || ja(a, b, d, c)) return !0;
    if (c) return !1;
    if (null !== d) switch (d.type) {
      case 3:
        return !b;

      case 4:
        return !1 === b;

      case 5:
        return isNaN(b);

      case 6:
        return isNaN(b) || 1 > b;
    }
    return !1;
  }

  function I(a, b, d, c, k) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = c;
    this.attributeNamespace = k;
    this.mustUseProperty = d;
    this.propertyName = a;
    this.type = b;
  }

  var J = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
    J[a] = new I(a, 0, !1, a, null);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
    var b = a[0];
    J[b] = new I(b, 1, !1, a[1], null);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
    J[a] = new I(a, 2, !1, a.toLowerCase(), null);
  });
  ["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
    J[a] = new I(a, 2, !1, a, null);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
    J[a] = new I(a, 3, !1, a.toLowerCase(), null);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function (a) {
    J[a] = new I(a, 3, !0, a.toLowerCase(), null);
  });
  ["capture", "download"].forEach(function (a) {
    J[a] = new I(a, 4, !1, a.toLowerCase(), null);
  });
  ["cols", "rows", "size", "span"].forEach(function (a) {
    J[a] = new I(a, 6, !1, a.toLowerCase(), null);
  });
  ["rowSpan", "start"].forEach(function (a) {
    J[a] = new I(a, 5, !1, a.toLowerCase(), null);
  });
  var K = /[\-:]([a-z])/g;

  function L(a) {
    return a[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
    var b = a.replace(K, L);
    J[b] = new I(b, 1, !1, a, null);
  });
  "xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
    var b = a.replace(K, L);
    J[b] = new I(b, 1, !1, a, "http://www.w3.org/1999/xlink");
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
    var b = a.replace(K, L);
    J[b] = new I(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
  });
  J.tabIndex = new I("tabIndex", 1, !1, "tabindex", null);
  var la = /["'&<>]/;

  function M(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = la.exec(a);

    if (b) {
      var d = "",
          c,
          k = 0;

      for (c = b.index; c < a.length; c++) {
        switch (a.charCodeAt(c)) {
          case 34:
            b = "&quot;";
            break;

          case 38:
            b = "&amp;";
            break;

          case 39:
            b = "&#x27;";
            break;

          case 60:
            b = "&lt;";
            break;

          case 62:
            b = "&gt;";
            break;

          default:
            continue;
        }

        k !== c && (d += a.substring(k, c));
        k = c + 1;
        d += b;
      }

      a = k !== c ? d + a.substring(k, c) : d;
    }

    return a;
  }

  var N = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
  };

  function O(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";

      case "math":
        return "http://www.w3.org/1998/Math/MathML";

      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }

  var P = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  },
      ma = r({
    menuitem: !0
  }, P),
      Q = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
      na = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Q).forEach(function (a) {
    na.forEach(function (b) {
      b = b + a.charAt(0).toUpperCase() + a.substring(1);
      Q[b] = Q[a];
    });
  });
  var R = t.Children.toArray,
      S = w.thatReturns("");
  w.thatReturns("");
  var oa = {
    listing: !0,
    pre: !0,
    textarea: !0
  };

  function T(a) {
    return "string" === typeof a ? a : "function" === typeof a ? a.displayName || a.name : null;
  }

  var pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
      U = {},
      qa = z(function (a) {
    return y(a);
  });

  function ra(a) {
    var b = "";
    t.Children.forEach(a, function (a) {
      null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
    });
    return b;
  }

  function sa(a, b) {
    if (a = a.contextTypes) {
      var d = {},
          c;

      for (c in a) {
        d[c] = b[c];
      }

      b = d;
    } else b = x;

    return b;
  }

  var ta = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
  };

  function V(a, b) {
    void 0 === a && A("152", T(b) || "Component");
  }

  function ua(a, b) {
    function d(c, k) {
      var d = sa(k, b),
          f = [],
          h = !1,
          g = {
        isMounted: function isMounted() {
          return !1;
        },
        enqueueForceUpdate: function enqueueForceUpdate() {
          if (null === f) return null;
        },
        enqueueReplaceState: function enqueueReplaceState(a, b) {
          h = !0;
          f = [b];
        },
        enqueueSetState: function enqueueSetState(a, b) {
          if (null === f) return null;
          f.push(b);
        }
      },
          e = void 0;

      if (k.prototype && k.prototype.isReactComponent) {
        if (e = new k(c.props, d, g), "function" === typeof k.getDerivedStateFromProps) {
          var v = k.getDerivedStateFromProps.call(null, c.props, e.state);
          null != v && (e.state = r({}, e.state, v));
        }
      } else if (e = k(c.props, d, g), null == e || null == e.render) {
        a = e;
        V(a, k);
        return;
      }

      e.props = c.props;
      e.context = d;
      e.updater = g;
      g = e.state;
      void 0 === g && (e.state = g = null);
      if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) if ("function" === typeof e.componentWillMount && "function" !== typeof k.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof k.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), f.length) {
        g = f;
        var u = h;
        f = null;
        h = !1;
        if (u && 1 === g.length) e.state = g[0];else {
          v = u ? g[0] : e.state;
          var m = !0;

          for (u = u ? 1 : 0; u < g.length; u++) {
            var n = g[u];
            n = "function" === typeof n ? n.call(e, v, c.props, d) : n;
            null != n && (m ? (m = !1, v = r({}, v, n)) : r(v, n));
          }

          e.state = v;
        }
      } else f = null;
      a = e.render();
      V(a, k);
      c = void 0;

      if ("function" === typeof e.getChildContext && (d = k.childContextTypes, "object" === typeof d)) {
        c = e.getChildContext();

        for (var q in c) {
          q in d ? void 0 : A("108", T(k) || "Unknown", q);
        }
      }

      c && (b = r({}, b, c));
    }

    for (; t.isValidElement(a);) {
      var c = a,
          k = c.type;
      if ("function" !== typeof k) break;
      d(c, k);
    }

    return {
      child: a,
      context: b
    };
  }

  var W = function () {
    function a(b, d) {
      if (!(this instanceof a)) throw new TypeError("Cannot call a class as a function");
      t.isValidElement(b) ? b.type !== E ? b = [b] : (b = b.props.children, b = t.isValidElement(b) ? [b] : R(b)) : b = R(b);
      this.stack = [{
        type: null,
        domNamespace: N.html,
        children: b,
        childIndex: 0,
        context: x,
        footer: ""
      }];
      this.exhausted = !1;
      this.currentSelectValue = null;
      this.previousWasTextNode = !1;
      this.makeStaticMarkup = d;
      this.providerStack = [];
      this.providerIndex = -1;
    }

    a.prototype.pushProvider = function (a) {
      this.providerIndex += 1;
      this.providerStack[this.providerIndex] = a;
      a.type._context._currentValue = a.props.value;
    };

    a.prototype.popProvider = function (a) {
      this.providerStack[this.providerIndex] = null;
      --this.providerIndex;
      a = a.type._context;
      a._currentValue = 0 > this.providerIndex ? a._defaultValue : this.providerStack[this.providerIndex].props.value;
    };

    a.prototype.read = function (a) {
      if (this.exhausted) return null;

      for (var b = ""; b.length < a;) {
        if (0 === this.stack.length) {
          this.exhausted = !0;
          break;
        }

        var c = this.stack[this.stack.length - 1];

        if (c.childIndex >= c.children.length) {
          var k = c.footer;
          b += k;
          "" !== k && (this.previousWasTextNode = !1);
          this.stack.pop();
          "select" === c.type ? this.currentSelectValue = null : null != c.type && null != c.type.type && c.type.type.$$typeof === F && this.popProvider(c.type);
        } else k = c.children[c.childIndex++], b += this.render(k, c.context, c.domNamespace);
      }

      return b;
    };

    a.prototype.render = function (a, d, c) {
      if ("string" === typeof a || "number" === typeof a) {
        c = "" + a;
        if ("" === c) return "";
        if (this.makeStaticMarkup) return M(c);
        if (this.previousWasTextNode) return "\x3c!-- --\x3e" + M(c);
        this.previousWasTextNode = !0;
        return M(c);
      }

      d = ua(a, d);
      a = d.child;
      d = d.context;
      if (null === a || !1 === a) return "";

      if (!t.isValidElement(a)) {
        if (null != a && null != a.$$typeof) {
          var b = a.$$typeof;
          b === aa ? A("257") : void 0;
          A("258", b.toString());
        }

        a = R(a);
        this.stack.push({
          type: null,
          domNamespace: c,
          children: a,
          childIndex: 0,
          context: d,
          footer: ""
        });
        return "";
      }

      b = a.type;
      if ("string" === typeof b) return this.renderDOM(a, d, c);

      switch (b) {
        case ba:
        case ea:
        case ca:
        case E:
          return a = R(a.props.children), this.stack.push({
            type: null,
            domNamespace: c,
            children: a,
            childIndex: 0,
            context: d,
            footer: ""
          }), "";
      }

      if ("object" === typeof b && null !== b) switch (b.$$typeof) {
        case fa:
          return a = R(b.render(a.props, a.ref)), this.stack.push({
            type: null,
            domNamespace: c,
            children: a,
            childIndex: 0,
            context: d,
            footer: ""
          }), "";

        case F:
          return b = R(a.props.children), c = {
            type: a,
            domNamespace: c,
            children: b,
            childIndex: 0,
            context: d,
            footer: ""
          }, this.pushProvider(a), this.stack.push(c), "";

        case da:
          return b = R(a.props.children(a.type._currentValue)), this.stack.push({
            type: a,
            domNamespace: c,
            children: b,
            childIndex: 0,
            context: d,
            footer: ""
          }), "";
      }
      A("130", null == b ? b : typeof b, "");
    };

    a.prototype.renderDOM = function (a, d, c) {
      var b = a.type.toLowerCase();
      c === N.html && O(b);
      U.hasOwnProperty(b) || (pa.test(b) ? void 0 : A("65", b), U[b] = !0);
      var f = a.props;
      if ("input" === b) f = r({
        type: void 0
      }, f, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: null != f.value ? f.value : f.defaultValue,
        checked: null != f.checked ? f.checked : f.defaultChecked
      });else if ("textarea" === b) {
        var h = f.value;

        if (null == h) {
          h = f.defaultValue;
          var l = f.children;
          null != l && (null != h ? A("92") : void 0, Array.isArray(l) && (1 >= l.length ? void 0 : A("93"), l = l[0]), h = "" + l);
          null == h && (h = "");
        }

        f = r({}, f, {
          value: void 0,
          children: "" + h
        });
      } else if ("select" === b) this.currentSelectValue = null != f.value ? f.value : f.defaultValue, f = r({}, f, {
        value: void 0
      });else if ("option" === b) {
        l = this.currentSelectValue;
        var D = ra(f.children);

        if (null != l) {
          var B = null != f.value ? f.value + "" : D;
          h = !1;
          if (Array.isArray(l)) for (var g = 0; g < l.length; g++) {
            if ("" + l[g] === B) {
              h = !0;
              break;
            }
          } else h = "" + l === B;
          f = r({
            selected: void 0,
            children: void 0
          }, f, {
            selected: h,
            children: D
          });
        }
      }
      if (h = f) ma[b] && (null != h.children || null != h.dangerouslySetInnerHTML ? A("137", b, S()) : void 0), null != h.dangerouslySetInnerHTML && (null != h.children ? A("60") : void 0, "object" === typeof h.dangerouslySetInnerHTML && "__html" in h.dangerouslySetInnerHTML ? void 0 : A("61")), null != h.style && "object" !== typeof h.style ? A("62", S()) : void 0;
      h = f;
      l = this.makeStaticMarkup;
      D = 1 === this.stack.length;
      B = "<" + a.type;

      for (q in h) {
        if (h.hasOwnProperty(q)) {
          var e = h[q];

          if (null != e) {
            if ("style" === q) {
              g = void 0;
              var v = "",
                  u = "";

              for (g in e) {
                if (e.hasOwnProperty(g)) {
                  var m = 0 === g.indexOf("--"),
                      n = e[g];
                  null != n && (v += u + qa(g) + ":", u = g, m = null == n || "boolean" === typeof n || "" === n ? "" : m || "number" !== typeof n || 0 === n || Q.hasOwnProperty(u) && Q[u] ? ("" + n).trim() : n + "px", v += m, u = ";");
                }
              }

              e = v || null;
            }

            g = null;

            b: if (m = b, n = h, -1 === m.indexOf("-")) m = "string" === typeof n.is;else switch (m) {
              case "annotation-xml":
              case "color-profile":
              case "font-face":
              case "font-face-src":
              case "font-face-uri":
              case "font-face-format":
              case "font-face-name":
              case "missing-glyph":
                m = !1;
                break b;

              default:
                m = !0;
            }

            if (m) ta.hasOwnProperty(q) || (g = q, g = ia(g) && null != e ? g + "=" + ('"' + M(e) + '"') : "");else {
              m = q;
              g = e;
              e = J.hasOwnProperty(m) ? J[m] : null;
              if (n = "style" !== m) n = null !== e ? 0 === e.type : !(2 < m.length) || "o" !== m[0] && "O" !== m[0] || "n" !== m[1] && "N" !== m[1] ? !1 : !0;
              n || ka(m, g, e, !1) ? g = "" : null !== e ? (m = e.attributeName, e = e.type, g = 3 === e || 4 === e && !0 === g ? m + '=""' : m + "=" + ('"' + M(g) + '"')) : g = m + "=" + ('"' + M(g) + '"');
            }
            g && (B += " " + g);
          }
        }
      }

      l || D && (B += ' data-reactroot=""');
      var q = B;
      h = "";
      P.hasOwnProperty(b) ? q += "/>" : (q += ">", h = "</" + a.type + ">");

      a: {
        l = f.dangerouslySetInnerHTML;

        if (null != l) {
          if (null != l.__html) {
            l = l.__html;
            break a;
          }
        } else if (l = f.children, "string" === typeof l || "number" === typeof l) {
          l = M(l);
          break a;
        }

        l = null;
      }

      null != l ? (f = [], oa[b] && "\n" === l.charAt(0) && (q += "\n"), q += l) : f = R(f.children);
      a = a.type;
      c = null == c || "http://www.w3.org/1999/xhtml" === c ? O(a) : "http://www.w3.org/2000/svg" === c && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : c;
      this.stack.push({
        domNamespace: c,
        type: b,
        children: f,
        childIndex: 0,
        context: d,
        footer: h
      });
      this.previousWasTextNode = !1;
      return q;
    };

    return a;
  }(),
      X = {
    renderToString: function renderToString(a) {
      return new W(a, !1).read(Infinity);
    },
    renderToStaticMarkup: function renderToStaticMarkup(a) {
      return new W(a, !0).read(Infinity);
    },
    renderToNodeStream: function renderToNodeStream() {
      A("207");
    },
    renderToStaticNodeStream: function renderToStaticNodeStream() {
      A("208");
    },
    version: "16.4.0"
  },
      Y = {
    default: X
  },
      Z = Y && X || Y;

  module.exports = Z.default ? Z.default : Z;
  /***/
},
/* 597 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v16.4.0
    * react-dom-server.browser.development.js
    *
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict';

        var invariant = __webpack_require__(54);

        var _assign = __webpack_require__(65);

        var React = __webpack_require__(1);

        var emptyFunction = __webpack_require__(53);

        var emptyObject = __webpack_require__(89);

        var hyphenateStyleName = __webpack_require__(128);

        var memoizeStringOnly = __webpack_require__(192);

        var warning = __webpack_require__(85);

        var checkPropTypes = __webpack_require__(119);

        var camelizeStyleName = __webpack_require__(182); // Relying on the `invariant()` implementation lets us
        // have preserve the format and params in the www builds.
        // TODO: this is special because it gets imported during build.


        var ReactVersion = '16.4.0';
        /**
         * Forked from fbjs/warning:
         * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
         *
         * Only change is we use console.warn instead of console.error,
         * and do nothing when 'console' is not supported.
         * This really simplifies the code.
         * ---
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */

        var lowPriorityWarning = function lowPriorityWarning() {};

        {
          var printWarning = function printWarning(format) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });

            if (typeof console !== 'undefined') {
              console.warn(message);
            }

            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };

          lowPriorityWarning = function lowPriorityWarning(condition, format) {
            if (format === undefined) {
              throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
            }

            if (!condition) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
              }

              printWarning.apply(undefined, [format].concat(args));
            }
          };
        }
        var lowPriorityWarning$1 = lowPriorityWarning;

        var describeComponentFrame = function describeComponentFrame(name, source, ownerName) {
          return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
        };

        var ReactInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        var ReactCurrentOwner = ReactInternals.ReactCurrentOwner;
        var ReactDebugCurrentFrame = ReactInternals.ReactDebugCurrentFrame; // Exports ReactDOM.createRoot
        // Experimental error-boundary API that can recover from errors within a single
        // render phase
        // Suspense
        // Helps identify side effects in begin-phase lifecycle hooks and setState reducers:
        // In some cases, StrictMode should also double-render lifecycles.
        // This can be confusing for tests though,
        // And it can be bad for performance in production.
        // This feature flag can be used to control the behavior:
        // To preserve the "Pause on caught exceptions" behavior of the debugger, we
        // replay the begin phase of a failed component inside invokeGuardedCallback.
        // Warn about deprecated, async-unsafe lifecycles; relates to RFC #6:

        var warnAboutDeprecatedLifecycles = false; // Warn about legacy context API
        // Gather advanced timing metrics for Profiler subtrees.
        // Fires getDerivedStateFromProps for state *or* props changes
        // Only used in www builds.
        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0; // A reserved attribute.
        // It is handled by React separately and shouldn't be written to the DOM.

        var RESERVED = 0; // A simple string attribute.
        // Attributes that aren't in the whitelist are presumed to have this type.

        var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
        // "enumerated" attributes with "true" and "false" as possible values.
        // When true, it should be set to a "true" string.
        // When false, it should be set to a "false" string.

        var BOOLEANISH_STRING = 2; // A real boolean attribute.
        // When true, it should be present (set either to an empty string or its name).
        // When false, it should be omitted.

        var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
        // When true, it should be present (set either to an empty string or its name).
        // When false, it should be omitted.
        // For any other value, should be present with that value.

        var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
        // When falsy, it should be removed.

        var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
        // When falsy, it should be removed.

        var POSITIVE_NUMERIC = 6;
        /* eslint-disable max-len */

        var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
        /* eslint-enable max-len */

        var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
        var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
        var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var illegalAttributeNameCache = {};
        var validatedAttributeNameCache = {};

        function isAttributeNameSafe(attributeName) {
          if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
            return true;
          }

          if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
            return false;
          }

          if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
          }

          illegalAttributeNameCache[attributeName] = true;
          {
            warning(false, 'Invalid attribute name: `%s`', attributeName);
          }
          return false;
        }

        function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null) {
            return propertyInfo.type === RESERVED;
          }

          if (isCustomComponentTag) {
            return false;
          }

          if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
            return true;
          }

          return false;
        }

        function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null && propertyInfo.type === RESERVED) {
            return false;
          }

          switch (typeof value) {
            case 'function': // $FlowIssue symbol is perfectly valid here

            case 'symbol':
              // eslint-disable-line
              return true;

            case 'boolean':
              {
                if (isCustomComponentTag) {
                  return false;
                }

                if (propertyInfo !== null) {
                  return !propertyInfo.acceptsBooleans;
                } else {
                  var prefix = name.toLowerCase().slice(0, 5);
                  return prefix !== 'data-' && prefix !== 'aria-';
                }
              }

            default:
              return false;
          }
        }

        function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
          if (value === null || typeof value === 'undefined') {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
            return true;
          }

          if (isCustomComponentTag) {
            return false;
          }

          if (propertyInfo !== null) {
            switch (propertyInfo.type) {
              case BOOLEAN:
                return !value;

              case OVERLOADED_BOOLEAN:
                return value === false;

              case NUMERIC:
                return isNaN(value);

              case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
            }
          }

          return false;
        }

        function getPropertyInfo(name) {
          return properties.hasOwnProperty(name) ? properties[name] : null;
        }

        function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace) {
          this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
          this.attributeName = attributeName;
          this.attributeNamespace = attributeNamespace;
          this.mustUseProperty = mustUseProperty;
          this.propertyName = name;
          this.type = type;
        } // When adding attributes to this list, be sure to also add them to
        // the `possibleStandardNames` module to ensure casing and incorrect
        // name warnings.


        var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

        ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
          name, // attributeName
          null);
        } // attributeNamespace
        ); // A few React string attributes have a different name.
        // This is a mapping from React prop names to the attribute names.

        [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
          var name = _ref[0],
              attributeName = _ref[1];
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, // attributeName
          null);
        } // attributeNamespace
        ); // These are "enumerated" HTML attributes that accept "true" and "false".
        // In React, we let users pass `true` and `false` even though technically
        // these aren't boolean attributes (they are coerced to strings).

        ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are "enumerated" SVG attributes that accept "true" and "false".
        // In React, we let users pass `true` and `false` even though technically
        // these aren't boolean attributes (they are coerced to strings).
        // Since these are SVG attributes, their attribute names are case-sensitive.

        ['autoReverse', 'externalResourcesRequired', 'preserveAlpha'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
          name, // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML boolean attributes.

        ['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
        'itemScope'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are the few React props that we set as DOM properties
        // rather than attributes. These are all booleans.

        ['checked', // Note: `option.selected` is not updated if `select.multiple` is
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple', 'muted', 'selected'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML attributes that are "overloaded booleans": they behave like
        // booleans, but can also accept a string value.

        ['capture', 'download'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML attributes that must be positive numbers.

        ['cols', 'rows', 'size', 'span'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        ); // These are HTML attributes that must be numbers.

        ['rowSpan', 'start'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null);
        } // attributeNamespace
        );
        var CAMELIZE = /[\-\:]([a-z])/g;

        var capitalize = function capitalize(token) {
          return token[1].toUpperCase();
        }; // This is a list of all SVG attributes that need special casing, namespacing,
        // or boolean value assignment. Regular attributes that just accept strings
        // and have the same names are omitted, just like in the HTML whitelist.
        // Some of these attributes can be hard to find. This list was created by
        // scrapping the MDN documentation.


        ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, null);
        } // attributeNamespace
        ); // String SVG attributes with the xlink namespace.

        ['xlink:actuate', 'xlink:arcrole', 'xlink:href', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, 'http://www.w3.org/1999/xlink');
        }); // String SVG attributes with the xml namespace.

        ['xml:base', 'xml:lang', 'xml:space'].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, 'http://www.w3.org/XML/1998/namespace');
        }); // Special case: this attribute exists both in HTML and SVG.
        // Its "tabindex" attribute name is case-sensitive in SVG so we can't just use
        // its React `tabIndex` name, like we do for attributes that exist only in HTML.

        properties.tabIndex = new PropertyInfoRecord('tabIndex', STRING, false, // mustUseProperty
        'tabindex', // attributeName
        null); // code copied and modified from escape-html

        /**
         * Module variables.
         * @private
         */

        var matchHtmlRegExp = /["'&<>]/;
        /**
         * Escapes special characters and HTML entities in a given html string.
         *
         * @param  {string} string HTML string to escape for later insertion
         * @return {string}
         * @public
         */

        function escapeHtml(string) {
          var str = '' + string;
          var match = matchHtmlRegExp.exec(str);

          if (!match) {
            return str;
          }

          var escape = void 0;
          var html = '';
          var index = 0;
          var lastIndex = 0;

          for (index = match.index; index < str.length; index++) {
            switch (str.charCodeAt(index)) {
              case 34:
                // "
                escape = '&quot;';
                break;

              case 38:
                // &
                escape = '&amp;';
                break;

              case 39:
                // '
                escape = '&#x27;'; // modified from escape-html; used to be '&#39'

                break;

              case 60:
                // <
                escape = '&lt;';
                break;

              case 62:
                // >
                escape = '&gt;';
                break;

              default:
                continue;
            }

            if (lastIndex !== index) {
              html += str.substring(lastIndex, index);
            }

            lastIndex = index + 1;
            html += escape;
          }

          return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
        } // end code copied and modified from escape-html

        /**
         * Escapes text to prevent scripting attacks.
         *
         * @param {*} text Text value to escape.
         * @return {string} An escaped string.
         */


        function escapeTextForBrowser(text) {
          if (typeof text === 'boolean' || typeof text === 'number') {
            // this shortcircuit helps perf for types that we know will never have
            // special characters, especially given that this function is used often
            // for numeric dom ids.
            return '' + text;
          }

          return escapeHtml(text);
        }
        /**
         * Escapes attribute value to prevent scripting attacks.
         *
         * @param {*} value Value to escape.
         * @return {string} An escaped string.
         */


        function quoteAttributeValueForBrowser(value) {
          return '"' + escapeTextForBrowser(value) + '"';
        }
        /**
         * Operations for dealing with DOM properties.
         */

        /**
         * Creates markup for the ID property.
         *
         * @param {string} id Unescaped ID.
         * @return {string} Markup string.
         */


        function createMarkupForRoot() {
          return ROOT_ATTRIBUTE_NAME + '=""';
        }
        /**
         * Creates markup for a property.
         *
         * @param {string} name
         * @param {*} value
         * @return {?string} Markup string, or null if the property was invalid.
         */


        function createMarkupForProperty(name, value) {
          var propertyInfo = getPropertyInfo(name);

          if (name !== 'style' && shouldIgnoreAttribute(name, propertyInfo, false)) {
            return '';
          }

          if (shouldRemoveAttribute(name, value, propertyInfo, false)) {
            return '';
          }

          if (propertyInfo !== null) {
            var attributeName = propertyInfo.attributeName;
            var type = propertyInfo.type;

            if (type === BOOLEAN || type === OVERLOADED_BOOLEAN && value === true) {
              return attributeName + '=""';
            } else {
              return attributeName + '=' + quoteAttributeValueForBrowser(value);
            }
          } else {
            return name + '=' + quoteAttributeValueForBrowser(value);
          }
        }
        /**
         * Creates markup for a custom property.
         *
         * @param {string} name
         * @param {*} value
         * @return {string} Markup string, or empty string if the property was invalid.
         */


        function createMarkupForCustomAttribute(name, value) {
          if (!isAttributeNameSafe(name) || value == null) {
            return '';
          }

          return name + '=' + quoteAttributeValueForBrowser(value);
        }

        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var Namespaces = {
          html: HTML_NAMESPACE,
          mathml: MATH_NAMESPACE,
          svg: SVG_NAMESPACE
        }; // Assumes there is no parent namespace.

        function getIntrinsicNamespace(type) {
          switch (type) {
            case 'svg':
              return SVG_NAMESPACE;

            case 'math':
              return MATH_NAMESPACE;

            default:
              return HTML_NAMESPACE;
          }
        }

        function getChildNamespace(parentNamespace, type) {
          if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
            // No (or default) parent namespace: potential entry point.
            return getIntrinsicNamespace(type);
          }

          if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
            // We're leaving SVG.
            return HTML_NAMESPACE;
          } // By default, pass namespace below.


          return parentNamespace;
        }

        var ReactControlledValuePropTypes = {
          checkPropTypes: null
        };
        {
          var hasReadOnlyValue = {
            button: true,
            checkbox: true,
            image: true,
            hidden: true,
            radio: true,
            reset: true,
            submit: true
          };
          var propTypes = {
            value: function value(props, propName, componentName) {
              if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
                return null;
              }

              return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
            },
            checked: function checked(props, propName, componentName) {
              if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
                return null;
              }

              return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
            }
          };
          /**
           * Provide a linked `value` attribute for controlled forms. You should not use
           * this outside of the ReactDOM controlled form components.
           */

          ReactControlledValuePropTypes.checkPropTypes = function (tagName, props, getStack) {
            checkPropTypes(propTypes, props, 'prop', tagName, getStack);
          };
        } // For HTML, certain tags should omit their close tag. We keep a whitelist for
        // those special-case tags.

        var omittedCloseTags = {
          area: true,
          base: true,
          br: true,
          col: true,
          embed: true,
          hr: true,
          img: true,
          input: true,
          keygen: true,
          link: true,
          meta: true,
          param: true,
          source: true,
          track: true,
          wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

        }; // For HTML, certain tags cannot have children. This has the same purpose as
        // `omittedCloseTags` except that `menuitem` should still have its closing tag.

        var voidElementTags = _assign({
          menuitem: true
        }, omittedCloseTags);

        var HTML = '__html';

        function assertValidProps(tag, props, getStack) {
          if (!props) {
            return;
          } // Note the use of `==` which checks for null or undefined.


          if (voidElementTags[tag]) {
            !(props.children == null && props.dangerouslySetInnerHTML == null) ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', tag, getStack()) : void 0;
          }

          if (props.dangerouslySetInnerHTML != null) {
            !(props.children == null) ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : void 0;
            !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : void 0;
          }

          {
            !(props.suppressContentEditableWarning || !props.contentEditable || props.children == null) ? warning(false, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.%s', getStack()) : void 0;
          }
          !(props.style == null || typeof props.style === 'object') ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getStack()) : void 0;
        }
        /**
         * CSS properties which accept numbers but are not in units of "px".
         */


        var isUnitlessNumber = {
          animationIterationCount: true,
          borderImageOutset: true,
          borderImageSlice: true,
          borderImageWidth: true,
          boxFlex: true,
          boxFlexGroup: true,
          boxOrdinalGroup: true,
          columnCount: true,
          columns: true,
          flex: true,
          flexGrow: true,
          flexPositive: true,
          flexShrink: true,
          flexNegative: true,
          flexOrder: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowSpan: true,
          gridRowStart: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnSpan: true,
          gridColumnStart: true,
          fontWeight: true,
          lineClamp: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          tabSize: true,
          widows: true,
          zIndex: true,
          zoom: true,
          // SVG-related properties
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeDasharray: true,
          strokeDashoffset: true,
          strokeMiterlimit: true,
          strokeOpacity: true,
          strokeWidth: true
        };
        /**
         * @param {string} prefix vendor-specific prefix, eg: Webkit
         * @param {string} key style name, eg: transitionDuration
         * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
         * WebkitTransitionDuration
         */

        function prefixKey(prefix, key) {
          return prefix + key.charAt(0).toUpperCase() + key.substring(1);
        }
        /**
         * Support style names that may come passed in prefixed by adding permutations
         * of vendor prefixes.
         */


        var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
        // infinite loop, because it iterates over the newly added props too.

        Object.keys(isUnitlessNumber).forEach(function (prop) {
          prefixes.forEach(function (prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
          });
        });
        /**
         * Convert a value into the proper css writable value. The style name `name`
         * should be logical (no hyphens), as specified
         * in `CSSProperty.isUnitlessNumber`.
         *
         * @param {string} name CSS property name such as `topMargin`.
         * @param {*} value CSS property value such as `10px`.
         * @return {string} Normalized style value with dimensions applied.
         */

        function dangerousStyleValue(name, value, isCustomProperty) {
          // Note that we've removed escapeTextForBrowser() calls here since the
          // whole string will be escaped when the attribute is injected into
          // the markup. If you provide unsafe user data here they can inject
          // arbitrary CSS which may be problematic (I couldn't repro this):
          // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
          // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
          // This is not an XSS hole but instead a potential CSS injection issue
          // which has lead to a greater discussion about how we're going to
          // trust URLs moving forward. See #2115901
          var isEmpty = value == null || typeof value === 'boolean' || value === '';

          if (isEmpty) {
            return '';
          }

          if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
            return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
          }

          return ('' + value).trim();
        }

        function isCustomComponent(tagName, props) {
          if (tagName.indexOf('-') === -1) {
            return typeof props.is === 'string';
          }

          switch (tagName) {
            // These are reserved SVG and MathML elements.
            // We don't mind this whitelist too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return false;

            default:
              return true;
          }
        }

        var warnValidStyle = emptyFunction;
        {
          // 'msTransform' is correct, but the other prefixes should be capitalized
          var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/; // style values shouldn't contain a semicolon

          var badStyleValueWithSemicolonPattern = /;\s*$/;
          var warnedStyleNames = {};
          var warnedStyleValues = {};
          var warnedForNaNValue = false;
          var warnedForInfinityValue = false;

          var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, getStack) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }

            warnedStyleNames[name] = true;
            warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), getStack());
          };

          var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, getStack) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }

            warnedStyleNames[name] = true;
            warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), getStack());
          };

          var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, getStack) {
            if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
              return;
            }

            warnedStyleValues[value] = true;
            warning(false, "Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.%s', name, value.replace(badStyleValueWithSemicolonPattern, ''), getStack());
          };

          var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, getStack) {
            if (warnedForNaNValue) {
              return;
            }

            warnedForNaNValue = true;
            warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, getStack());
          };

          var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value, getStack) {
            if (warnedForInfinityValue) {
              return;
            }

            warnedForInfinityValue = true;
            warning(false, '`Infinity` is an invalid value for the `%s` css style property.%s', name, getStack());
          };

          warnValidStyle = function warnValidStyle(name, value, getStack) {
            if (name.indexOf('-') > -1) {
              warnHyphenatedStyleName(name, getStack);
            } else if (badVendoredStyleNamePattern.test(name)) {
              warnBadVendoredStyleName(name, getStack);
            } else if (badStyleValueWithSemicolonPattern.test(value)) {
              warnStyleValueWithSemicolon(name, value, getStack);
            }

            if (typeof value === 'number') {
              if (isNaN(value)) {
                warnStyleValueIsNaN(name, value, getStack);
              } else if (!isFinite(value)) {
                warnStyleValueIsInfinity(name, value, getStack);
              }
            }
          };
        }
        var warnValidStyle$1 = warnValidStyle;
        var ariaProperties = {
          'aria-current': 0,
          // state
          'aria-details': 0,
          'aria-disabled': 0,
          // state
          'aria-hidden': 0,
          // state
          'aria-invalid': 0,
          // state
          'aria-keyshortcuts': 0,
          'aria-label': 0,
          'aria-roledescription': 0,
          // Widget Attributes
          'aria-autocomplete': 0,
          'aria-checked': 0,
          'aria-expanded': 0,
          'aria-haspopup': 0,
          'aria-level': 0,
          'aria-modal': 0,
          'aria-multiline': 0,
          'aria-multiselectable': 0,
          'aria-orientation': 0,
          'aria-placeholder': 0,
          'aria-pressed': 0,
          'aria-readonly': 0,
          'aria-required': 0,
          'aria-selected': 0,
          'aria-sort': 0,
          'aria-valuemax': 0,
          'aria-valuemin': 0,
          'aria-valuenow': 0,
          'aria-valuetext': 0,
          // Live Region Attributes
          'aria-atomic': 0,
          'aria-busy': 0,
          'aria-live': 0,
          'aria-relevant': 0,
          // Drag-and-Drop Attributes
          'aria-dropeffect': 0,
          'aria-grabbed': 0,
          // Relationship Attributes
          'aria-activedescendant': 0,
          'aria-colcount': 0,
          'aria-colindex': 0,
          'aria-colspan': 0,
          'aria-controls': 0,
          'aria-describedby': 0,
          'aria-errormessage': 0,
          'aria-flowto': 0,
          'aria-labelledby': 0,
          'aria-owns': 0,
          'aria-posinset': 0,
          'aria-rowcount': 0,
          'aria-rowindex': 0,
          'aria-rowspan': 0,
          'aria-setsize': 0
        };
        var warnedProperties = {};
        var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        function getStackAddendum$1() {
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          return stack != null ? stack : '';
        }

        function validateProperty(tagName, name) {
          if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }

          if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (correctName == null) {
              warning(false, 'Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.%s', name, getStackAddendum$1());
              warnedProperties[name] = true;
              return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.


            if (name !== correctName) {
              warning(false, 'Invalid ARIA attribute `%s`. Did you mean `%s`?%s', name, correctName, getStackAddendum$1());
              warnedProperties[name] = true;
              return true;
            }
          }

          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.


            if (name !== standardName) {
              warning(false, 'Unknown ARIA attribute `%s`. Did you mean `%s`?%s', name, standardName, getStackAddendum$1());
              warnedProperties[name] = true;
              return true;
            }
          }

          return true;
        }

        function warnInvalidARIAProps(type, props) {
          var invalidProps = [];

          for (var key in props) {
            var isValid = validateProperty(type, key);

            if (!isValid) {
              invalidProps.push(key);
            }
          }

          var unknownPropString = invalidProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (invalidProps.length === 1) {
            warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, type, getStackAddendum$1());
          } else if (invalidProps.length > 1) {
            warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, type, getStackAddendum$1());
          }
        }

        function validateProperties(type, props) {
          if (isCustomComponent(type, props)) {
            return;
          }

          warnInvalidARIAProps(type, props);
        }

        var didWarnValueNull = false;

        function getStackAddendum$2() {
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          return stack != null ? stack : '';
        }

        function validateProperties$1(type, props) {
          if (type !== 'input' && type !== 'textarea' && type !== 'select') {
            return;
          }

          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;

            if (type === 'select' && props.multiple) {
              warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.%s', type, getStackAddendum$2());
            } else {
              warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', type, getStackAddendum$2());
            }
          }
        }
        /**
         * Registers plugins so that they can extract and dispatch events.
         *
         * @see {EventPluginHub}
         */

        /**
         * Ordered list of injected plugins.
         */

        /**
         * Mapping from event name to dispatch config
         */

        /**
         * Mapping from registration name to plugin module
         */


        var registrationNameModules = {};
        /**
         * Mapping from registration name to event name
         */

        /**
         * Mapping from lowercase registration names to the properly cased version,
         * used to warn in the case of missing event handlers. Available
         * only in true.
         * @type {Object}
         */

        var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true

        /**
         * Injects an ordering of plugins (by plugin name). This allows the ordering
         * to be decoupled from injection of the actual plugins so that ordering is
         * always deterministic regardless of packaging, on-the-fly injection, etc.
         *
         * @param {array} InjectedEventPluginOrder
         * @internal
         * @see {EventPluginHub.injection.injectEventPluginOrder}
         */

        /**
         * Injects plugins to be used by `EventPluginHub`. The plugin names must be
         * in the ordering injected by `injectEventPluginOrder`.
         *
         * Plugins can be injected as part of page initialization or on-the-fly.
         *
         * @param {object} injectedNamesToPlugins Map from names to plugin modules.
         * @internal
         * @see {EventPluginHub.injection.injectEventPluginsByName}
         */
        // When adding attributes to the HTML or SVG whitelist, be sure to
        // also add them to this module to ensure casing and incorrect name
        // warnings.

        var possibleStandardNames = {
          // HTML
          accept: 'accept',
          acceptcharset: 'acceptCharset',
          'accept-charset': 'acceptCharset',
          accesskey: 'accessKey',
          action: 'action',
          allowfullscreen: 'allowFullScreen',
          alt: 'alt',
          as: 'as',
          async: 'async',
          autocapitalize: 'autoCapitalize',
          autocomplete: 'autoComplete',
          autocorrect: 'autoCorrect',
          autofocus: 'autoFocus',
          autoplay: 'autoPlay',
          autosave: 'autoSave',
          capture: 'capture',
          cellpadding: 'cellPadding',
          cellspacing: 'cellSpacing',
          challenge: 'challenge',
          charset: 'charSet',
          checked: 'checked',
          children: 'children',
          cite: 'cite',
          class: 'className',
          classid: 'classID',
          classname: 'className',
          cols: 'cols',
          colspan: 'colSpan',
          content: 'content',
          contenteditable: 'contentEditable',
          contextmenu: 'contextMenu',
          controls: 'controls',
          controlslist: 'controlsList',
          coords: 'coords',
          crossorigin: 'crossOrigin',
          dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
          data: 'data',
          datetime: 'dateTime',
          default: 'default',
          defaultchecked: 'defaultChecked',
          defaultvalue: 'defaultValue',
          defer: 'defer',
          dir: 'dir',
          disabled: 'disabled',
          download: 'download',
          draggable: 'draggable',
          enctype: 'encType',
          for: 'htmlFor',
          form: 'form',
          formmethod: 'formMethod',
          formaction: 'formAction',
          formenctype: 'formEncType',
          formnovalidate: 'formNoValidate',
          formtarget: 'formTarget',
          frameborder: 'frameBorder',
          headers: 'headers',
          height: 'height',
          hidden: 'hidden',
          high: 'high',
          href: 'href',
          hreflang: 'hrefLang',
          htmlfor: 'htmlFor',
          httpequiv: 'httpEquiv',
          'http-equiv': 'httpEquiv',
          icon: 'icon',
          id: 'id',
          innerhtml: 'innerHTML',
          inputmode: 'inputMode',
          integrity: 'integrity',
          is: 'is',
          itemid: 'itemID',
          itemprop: 'itemProp',
          itemref: 'itemRef',
          itemscope: 'itemScope',
          itemtype: 'itemType',
          keyparams: 'keyParams',
          keytype: 'keyType',
          kind: 'kind',
          label: 'label',
          lang: 'lang',
          list: 'list',
          loop: 'loop',
          low: 'low',
          manifest: 'manifest',
          marginwidth: 'marginWidth',
          marginheight: 'marginHeight',
          max: 'max',
          maxlength: 'maxLength',
          media: 'media',
          mediagroup: 'mediaGroup',
          method: 'method',
          min: 'min',
          minlength: 'minLength',
          multiple: 'multiple',
          muted: 'muted',
          name: 'name',
          nomodule: 'noModule',
          nonce: 'nonce',
          novalidate: 'noValidate',
          open: 'open',
          optimum: 'optimum',
          pattern: 'pattern',
          placeholder: 'placeholder',
          playsinline: 'playsInline',
          poster: 'poster',
          preload: 'preload',
          profile: 'profile',
          radiogroup: 'radioGroup',
          readonly: 'readOnly',
          referrerpolicy: 'referrerPolicy',
          rel: 'rel',
          required: 'required',
          reversed: 'reversed',
          role: 'role',
          rows: 'rows',
          rowspan: 'rowSpan',
          sandbox: 'sandbox',
          scope: 'scope',
          scoped: 'scoped',
          scrolling: 'scrolling',
          seamless: 'seamless',
          selected: 'selected',
          shape: 'shape',
          size: 'size',
          sizes: 'sizes',
          span: 'span',
          spellcheck: 'spellCheck',
          src: 'src',
          srcdoc: 'srcDoc',
          srclang: 'srcLang',
          srcset: 'srcSet',
          start: 'start',
          step: 'step',
          style: 'style',
          summary: 'summary',
          tabindex: 'tabIndex',
          target: 'target',
          title: 'title',
          type: 'type',
          usemap: 'useMap',
          value: 'value',
          width: 'width',
          wmode: 'wmode',
          wrap: 'wrap',
          // SVG
          about: 'about',
          accentheight: 'accentHeight',
          'accent-height': 'accentHeight',
          accumulate: 'accumulate',
          additive: 'additive',
          alignmentbaseline: 'alignmentBaseline',
          'alignment-baseline': 'alignmentBaseline',
          allowreorder: 'allowReorder',
          alphabetic: 'alphabetic',
          amplitude: 'amplitude',
          arabicform: 'arabicForm',
          'arabic-form': 'arabicForm',
          ascent: 'ascent',
          attributename: 'attributeName',
          attributetype: 'attributeType',
          autoreverse: 'autoReverse',
          azimuth: 'azimuth',
          basefrequency: 'baseFrequency',
          baselineshift: 'baselineShift',
          'baseline-shift': 'baselineShift',
          baseprofile: 'baseProfile',
          bbox: 'bbox',
          begin: 'begin',
          bias: 'bias',
          by: 'by',
          calcmode: 'calcMode',
          capheight: 'capHeight',
          'cap-height': 'capHeight',
          clip: 'clip',
          clippath: 'clipPath',
          'clip-path': 'clipPath',
          clippathunits: 'clipPathUnits',
          cliprule: 'clipRule',
          'clip-rule': 'clipRule',
          color: 'color',
          colorinterpolation: 'colorInterpolation',
          'color-interpolation': 'colorInterpolation',
          colorinterpolationfilters: 'colorInterpolationFilters',
          'color-interpolation-filters': 'colorInterpolationFilters',
          colorprofile: 'colorProfile',
          'color-profile': 'colorProfile',
          colorrendering: 'colorRendering',
          'color-rendering': 'colorRendering',
          contentscripttype: 'contentScriptType',
          contentstyletype: 'contentStyleType',
          cursor: 'cursor',
          cx: 'cx',
          cy: 'cy',
          d: 'd',
          datatype: 'datatype',
          decelerate: 'decelerate',
          descent: 'descent',
          diffuseconstant: 'diffuseConstant',
          direction: 'direction',
          display: 'display',
          divisor: 'divisor',
          dominantbaseline: 'dominantBaseline',
          'dominant-baseline': 'dominantBaseline',
          dur: 'dur',
          dx: 'dx',
          dy: 'dy',
          edgemode: 'edgeMode',
          elevation: 'elevation',
          enablebackground: 'enableBackground',
          'enable-background': 'enableBackground',
          end: 'end',
          exponent: 'exponent',
          externalresourcesrequired: 'externalResourcesRequired',
          fill: 'fill',
          fillopacity: 'fillOpacity',
          'fill-opacity': 'fillOpacity',
          fillrule: 'fillRule',
          'fill-rule': 'fillRule',
          filter: 'filter',
          filterres: 'filterRes',
          filterunits: 'filterUnits',
          floodopacity: 'floodOpacity',
          'flood-opacity': 'floodOpacity',
          floodcolor: 'floodColor',
          'flood-color': 'floodColor',
          focusable: 'focusable',
          fontfamily: 'fontFamily',
          'font-family': 'fontFamily',
          fontsize: 'fontSize',
          'font-size': 'fontSize',
          fontsizeadjust: 'fontSizeAdjust',
          'font-size-adjust': 'fontSizeAdjust',
          fontstretch: 'fontStretch',
          'font-stretch': 'fontStretch',
          fontstyle: 'fontStyle',
          'font-style': 'fontStyle',
          fontvariant: 'fontVariant',
          'font-variant': 'fontVariant',
          fontweight: 'fontWeight',
          'font-weight': 'fontWeight',
          format: 'format',
          from: 'from',
          fx: 'fx',
          fy: 'fy',
          g1: 'g1',
          g2: 'g2',
          glyphname: 'glyphName',
          'glyph-name': 'glyphName',
          glyphorientationhorizontal: 'glyphOrientationHorizontal',
          'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
          glyphorientationvertical: 'glyphOrientationVertical',
          'glyph-orientation-vertical': 'glyphOrientationVertical',
          glyphref: 'glyphRef',
          gradienttransform: 'gradientTransform',
          gradientunits: 'gradientUnits',
          hanging: 'hanging',
          horizadvx: 'horizAdvX',
          'horiz-adv-x': 'horizAdvX',
          horizoriginx: 'horizOriginX',
          'horiz-origin-x': 'horizOriginX',
          ideographic: 'ideographic',
          imagerendering: 'imageRendering',
          'image-rendering': 'imageRendering',
          in2: 'in2',
          in: 'in',
          inlist: 'inlist',
          intercept: 'intercept',
          k1: 'k1',
          k2: 'k2',
          k3: 'k3',
          k4: 'k4',
          k: 'k',
          kernelmatrix: 'kernelMatrix',
          kernelunitlength: 'kernelUnitLength',
          kerning: 'kerning',
          keypoints: 'keyPoints',
          keysplines: 'keySplines',
          keytimes: 'keyTimes',
          lengthadjust: 'lengthAdjust',
          letterspacing: 'letterSpacing',
          'letter-spacing': 'letterSpacing',
          lightingcolor: 'lightingColor',
          'lighting-color': 'lightingColor',
          limitingconeangle: 'limitingConeAngle',
          local: 'local',
          markerend: 'markerEnd',
          'marker-end': 'markerEnd',
          markerheight: 'markerHeight',
          markermid: 'markerMid',
          'marker-mid': 'markerMid',
          markerstart: 'markerStart',
          'marker-start': 'markerStart',
          markerunits: 'markerUnits',
          markerwidth: 'markerWidth',
          mask: 'mask',
          maskcontentunits: 'maskContentUnits',
          maskunits: 'maskUnits',
          mathematical: 'mathematical',
          mode: 'mode',
          numoctaves: 'numOctaves',
          offset: 'offset',
          opacity: 'opacity',
          operator: 'operator',
          order: 'order',
          orient: 'orient',
          orientation: 'orientation',
          origin: 'origin',
          overflow: 'overflow',
          overlineposition: 'overlinePosition',
          'overline-position': 'overlinePosition',
          overlinethickness: 'overlineThickness',
          'overline-thickness': 'overlineThickness',
          paintorder: 'paintOrder',
          'paint-order': 'paintOrder',
          panose1: 'panose1',
          'panose-1': 'panose1',
          pathlength: 'pathLength',
          patterncontentunits: 'patternContentUnits',
          patterntransform: 'patternTransform',
          patternunits: 'patternUnits',
          pointerevents: 'pointerEvents',
          'pointer-events': 'pointerEvents',
          points: 'points',
          pointsatx: 'pointsAtX',
          pointsaty: 'pointsAtY',
          pointsatz: 'pointsAtZ',
          prefix: 'prefix',
          preservealpha: 'preserveAlpha',
          preserveaspectratio: 'preserveAspectRatio',
          primitiveunits: 'primitiveUnits',
          property: 'property',
          r: 'r',
          radius: 'radius',
          refx: 'refX',
          refy: 'refY',
          renderingintent: 'renderingIntent',
          'rendering-intent': 'renderingIntent',
          repeatcount: 'repeatCount',
          repeatdur: 'repeatDur',
          requiredextensions: 'requiredExtensions',
          requiredfeatures: 'requiredFeatures',
          resource: 'resource',
          restart: 'restart',
          result: 'result',
          results: 'results',
          rotate: 'rotate',
          rx: 'rx',
          ry: 'ry',
          scale: 'scale',
          security: 'security',
          seed: 'seed',
          shaperendering: 'shapeRendering',
          'shape-rendering': 'shapeRendering',
          slope: 'slope',
          spacing: 'spacing',
          specularconstant: 'specularConstant',
          specularexponent: 'specularExponent',
          speed: 'speed',
          spreadmethod: 'spreadMethod',
          startoffset: 'startOffset',
          stddeviation: 'stdDeviation',
          stemh: 'stemh',
          stemv: 'stemv',
          stitchtiles: 'stitchTiles',
          stopcolor: 'stopColor',
          'stop-color': 'stopColor',
          stopopacity: 'stopOpacity',
          'stop-opacity': 'stopOpacity',
          strikethroughposition: 'strikethroughPosition',
          'strikethrough-position': 'strikethroughPosition',
          strikethroughthickness: 'strikethroughThickness',
          'strikethrough-thickness': 'strikethroughThickness',
          string: 'string',
          stroke: 'stroke',
          strokedasharray: 'strokeDasharray',
          'stroke-dasharray': 'strokeDasharray',
          strokedashoffset: 'strokeDashoffset',
          'stroke-dashoffset': 'strokeDashoffset',
          strokelinecap: 'strokeLinecap',
          'stroke-linecap': 'strokeLinecap',
          strokelinejoin: 'strokeLinejoin',
          'stroke-linejoin': 'strokeLinejoin',
          strokemiterlimit: 'strokeMiterlimit',
          'stroke-miterlimit': 'strokeMiterlimit',
          strokewidth: 'strokeWidth',
          'stroke-width': 'strokeWidth',
          strokeopacity: 'strokeOpacity',
          'stroke-opacity': 'strokeOpacity',
          suppresscontenteditablewarning: 'suppressContentEditableWarning',
          suppresshydrationwarning: 'suppressHydrationWarning',
          surfacescale: 'surfaceScale',
          systemlanguage: 'systemLanguage',
          tablevalues: 'tableValues',
          targetx: 'targetX',
          targety: 'targetY',
          textanchor: 'textAnchor',
          'text-anchor': 'textAnchor',
          textdecoration: 'textDecoration',
          'text-decoration': 'textDecoration',
          textlength: 'textLength',
          textrendering: 'textRendering',
          'text-rendering': 'textRendering',
          to: 'to',
          transform: 'transform',
          typeof: 'typeof',
          u1: 'u1',
          u2: 'u2',
          underlineposition: 'underlinePosition',
          'underline-position': 'underlinePosition',
          underlinethickness: 'underlineThickness',
          'underline-thickness': 'underlineThickness',
          unicode: 'unicode',
          unicodebidi: 'unicodeBidi',
          'unicode-bidi': 'unicodeBidi',
          unicoderange: 'unicodeRange',
          'unicode-range': 'unicodeRange',
          unitsperem: 'unitsPerEm',
          'units-per-em': 'unitsPerEm',
          unselectable: 'unselectable',
          valphabetic: 'vAlphabetic',
          'v-alphabetic': 'vAlphabetic',
          values: 'values',
          vectoreffect: 'vectorEffect',
          'vector-effect': 'vectorEffect',
          version: 'version',
          vertadvy: 'vertAdvY',
          'vert-adv-y': 'vertAdvY',
          vertoriginx: 'vertOriginX',
          'vert-origin-x': 'vertOriginX',
          vertoriginy: 'vertOriginY',
          'vert-origin-y': 'vertOriginY',
          vhanging: 'vHanging',
          'v-hanging': 'vHanging',
          videographic: 'vIdeographic',
          'v-ideographic': 'vIdeographic',
          viewbox: 'viewBox',
          viewtarget: 'viewTarget',
          visibility: 'visibility',
          vmathematical: 'vMathematical',
          'v-mathematical': 'vMathematical',
          vocab: 'vocab',
          widths: 'widths',
          wordspacing: 'wordSpacing',
          'word-spacing': 'wordSpacing',
          writingmode: 'writingMode',
          'writing-mode': 'writingMode',
          x1: 'x1',
          x2: 'x2',
          x: 'x',
          xchannelselector: 'xChannelSelector',
          xheight: 'xHeight',
          'x-height': 'xHeight',
          xlinkactuate: 'xlinkActuate',
          'xlink:actuate': 'xlinkActuate',
          xlinkarcrole: 'xlinkArcrole',
          'xlink:arcrole': 'xlinkArcrole',
          xlinkhref: 'xlinkHref',
          'xlink:href': 'xlinkHref',
          xlinkrole: 'xlinkRole',
          'xlink:role': 'xlinkRole',
          xlinkshow: 'xlinkShow',
          'xlink:show': 'xlinkShow',
          xlinktitle: 'xlinkTitle',
          'xlink:title': 'xlinkTitle',
          xlinktype: 'xlinkType',
          'xlink:type': 'xlinkType',
          xmlbase: 'xmlBase',
          'xml:base': 'xmlBase',
          xmllang: 'xmlLang',
          'xml:lang': 'xmlLang',
          xmlns: 'xmlns',
          'xml:space': 'xmlSpace',
          xmlnsxlink: 'xmlnsXlink',
          'xmlns:xlink': 'xmlnsXlink',
          xmlspace: 'xmlSpace',
          y1: 'y1',
          y2: 'y2',
          y: 'y',
          ychannelselector: 'yChannelSelector',
          z: 'z',
          zoomandpan: 'zoomAndPan'
        };

        function getStackAddendum$3() {
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          return stack != null ? stack : '';
        }

        var validateProperty$1 = function validateProperty$1() {};

        {
          var warnedProperties$1 = {};
          var _hasOwnProperty = Object.prototype.hasOwnProperty;
          var EVENT_NAME_REGEX = /^on./;
          var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
          var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
          var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

          validateProperty$1 = function validateProperty$1(tagName, name, value, canUseEventSystem) {
            if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
              return true;
            }

            var lowerCasedName = name.toLowerCase();

            if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
              warning(false, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
              warnedProperties$1[name] = true;
              return true;
            } // We can't rely on the event system being injected on the server.


            if (canUseEventSystem) {
              if (registrationNameModules.hasOwnProperty(name)) {
                return true;
              }

              var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

              if (registrationName != null) {
                warning(false, 'Invalid event handler property `%s`. Did you mean `%s`?%s', name, registrationName, getStackAddendum$3());
                warnedProperties$1[name] = true;
                return true;
              }

              if (EVENT_NAME_REGEX.test(name)) {
                warning(false, 'Unknown event handler property `%s`. It will be ignored.%s', name, getStackAddendum$3());
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (EVENT_NAME_REGEX.test(name)) {
              // If no event plugins have been injected, we are in a server environment.
              // So we can't tell if the event name is correct for sure, but we can filter
              // out known bad ones like `onclick`. We can't suggest a specific replacement though.
              if (INVALID_EVENT_NAME_REGEX.test(name)) {
                warning(false, 'Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.%s', name, getStackAddendum$3());
              }

              warnedProperties$1[name] = true;
              return true;
            } // Let the ARIA attribute hook validate ARIA attributes


            if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
              return true;
            }

            if (lowerCasedName === 'innerhtml') {
              warning(false, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
              warnedProperties$1[name] = true;
              return true;
            }

            if (lowerCasedName === 'aria') {
              warning(false, 'The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
              warnedProperties$1[name] = true;
              return true;
            }

            if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
              warning(false, 'Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.%s', typeof value, getStackAddendum$3());
              warnedProperties$1[name] = true;
              return true;
            }

            if (typeof value === 'number' && isNaN(value)) {
              warning(false, 'Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.%s', name, getStackAddendum$3());
              warnedProperties$1[name] = true;
              return true;
            }

            var propertyInfo = getPropertyInfo(name);
            var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

            if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              var standardName = possibleStandardNames[lowerCasedName];

              if (standardName !== name) {
                warning(false, 'Invalid DOM property `%s`. Did you mean `%s`?%s', name, standardName, getStackAddendum$3());
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (!isReserved && name !== lowerCasedName) {
              // Unknown attributes should have lowercase casing since that's how they
              // will be cased anyway with server rendering.
              warning(false, 'React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.%s', name, lowerCasedName, getStackAddendum$3());
              warnedProperties$1[name] = true;
              return true;
            }

            if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              if (value) {
                warning(false, 'Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.%s', value, name, name, value, name, getStackAddendum$3());
              } else {
                warning(false, 'Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.%s', value, name, name, value, name, name, name, getStackAddendum$3());
              }

              warnedProperties$1[name] = true;
              return true;
            } // Now that we've validated casing, do not validate
            // data types for reserved props


            if (isReserved) {
              return true;
            } // Warn when a known attribute is a bad type


            if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              warnedProperties$1[name] = true;
              return false;
            }

            return true;
          };
        }

        var warnUnknownProperties = function warnUnknownProperties(type, props, canUseEventSystem) {
          var unknownProps = [];

          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);

            if (!isValid) {
              unknownProps.push(key);
            }
          }

          var unknownPropString = unknownProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (unknownProps.length === 1) {
            warning(false, 'Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior%s', unknownPropString, type, getStackAddendum$3());
          } else if (unknownProps.length > 1) {
            warning(false, 'Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior%s', unknownPropString, type, getStackAddendum$3());
          }
        };

        function validateProperties$2(type, props, canUseEventSystem) {
          if (isCustomComponent(type, props)) {
            return;
          }

          warnUnknownProperties(type, props, canUseEventSystem);
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        } // Based on reading the React.Children implementation. TODO: type this somewhere?


        var toArray = React.Children.toArray;
        var currentDebugStack = void 0;
        var currentDebugElementStack = void 0;
        var getStackAddendum = emptyFunction.thatReturns('');
        var describeStackFrame = emptyFunction.thatReturns('');

        var validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {};

        var setCurrentDebugStack = function setCurrentDebugStack(stack) {};

        var pushElementToDebugStack = function pushElementToDebugStack(element) {};

        var resetCurrentDebugStack = function resetCurrentDebugStack() {};

        {
          validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
            validateProperties(type, props);
            validateProperties$1(type, props);
            validateProperties$2(type, props,
            /* canUseEventSystem */
            false);
          };

          describeStackFrame = function describeStackFrame(element) {
            var source = element._source;
            var type = element.type;
            var name = getComponentName(type);
            var ownerName = null;
            return describeComponentFrame(name, source, ownerName);
          };

          currentDebugStack = null;
          currentDebugElementStack = null;

          setCurrentDebugStack = function setCurrentDebugStack(stack) {
            var frame = stack[stack.length - 1];
            currentDebugElementStack = frame.debugElementStack; // We are about to enter a new composite stack, reset the array.

            currentDebugElementStack.length = 0;
            currentDebugStack = stack;
            ReactDebugCurrentFrame.getCurrentStack = getStackAddendum;
          };

          pushElementToDebugStack = function pushElementToDebugStack(element) {
            if (currentDebugElementStack !== null) {
              currentDebugElementStack.push(element);
            }
          };

          resetCurrentDebugStack = function resetCurrentDebugStack() {
            currentDebugElementStack = null;
            currentDebugStack = null;
            ReactDebugCurrentFrame.getCurrentStack = null;
          };

          getStackAddendum = function getStackAddendum() {
            if (currentDebugStack === null) {
              return '';
            }

            var stack = '';
            var debugStack = currentDebugStack;

            for (var i = debugStack.length - 1; i >= 0; i--) {
              var frame = debugStack[i];
              var _debugElementStack = frame.debugElementStack;

              for (var ii = _debugElementStack.length - 1; ii >= 0; ii--) {
                stack += describeStackFrame(_debugElementStack[ii]);
              }
            }

            return stack;
          };
        }
        var didWarnDefaultInputValue = false;
        var didWarnDefaultChecked = false;
        var didWarnDefaultSelectValue = false;
        var didWarnDefaultTextareaValue = false;
        var didWarnInvalidOptionChildren = false;
        var didWarnAboutNoopUpdateForComponent = {};
        var didWarnAboutBadClass = {};
        var didWarnAboutDeprecatedWillMount = {};
        var didWarnAboutUndefinedDerivedState = {};
        var didWarnAboutUninitializedState = {};
        var valuePropNames = ['value', 'defaultValue'];
        var newlineEatingTags = {
          listing: true,
          pre: true,
          textarea: true
        };

        function getComponentName(type) {
          return typeof type === 'string' ? type : typeof type === 'function' ? type.displayName || type.name : null;
        } // We accept any tag to be rendered but since this gets injected into arbitrary
        // HTML, we want to make sure that it's a safe tag.
        // http://www.w3.org/TR/REC-xml/#NT-Name


        var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset

        var validatedTagCache = {};

        function validateDangerousTag(tag) {
          if (!validatedTagCache.hasOwnProperty(tag)) {
            !VALID_TAG_REGEX.test(tag) ? invariant(false, 'Invalid tag: %s', tag) : void 0;
            validatedTagCache[tag] = true;
          }
        }

        var processStyleName = memoizeStringOnly(function (styleName) {
          return hyphenateStyleName(styleName);
        });

        function createMarkupForStyles(styles) {
          var serialized = '';
          var delimiter = '';

          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }

            var isCustomProperty = styleName.indexOf('--') === 0;
            var styleValue = styles[styleName];
            {
              if (!isCustomProperty) {
                warnValidStyle$1(styleName, styleValue, getStackAddendum);
              }
            }

            if (styleValue != null) {
              serialized += delimiter + processStyleName(styleName) + ':';
              serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
              delimiter = ';';
            }
          }

          return serialized || null;
        }

        function warnNoop(publicInstance, callerName) {
          {
            var _constructor = publicInstance.constructor;
            var componentName = _constructor && getComponentName(_constructor) || 'ReactClass';
            var warningKey = componentName + '.' + callerName;

            if (didWarnAboutNoopUpdateForComponent[warningKey]) {
              return;
            }

            warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op.\n\nPlease check the code for the %s component.', callerName, callerName, componentName);
            didWarnAboutNoopUpdateForComponent[warningKey] = true;
          }
        }

        function shouldConstruct(Component) {
          return Component.prototype && Component.prototype.isReactComponent;
        }

        function getNonChildrenInnerMarkup(props) {
          var innerHTML = props.dangerouslySetInnerHTML;

          if (innerHTML != null) {
            if (innerHTML.__html != null) {
              return innerHTML.__html;
            }
          } else {
            var content = props.children;

            if (typeof content === 'string' || typeof content === 'number') {
              return escapeTextForBrowser(content);
            }
          }

          return null;
        }

        function flattenTopLevelChildren(children) {
          if (!React.isValidElement(children)) {
            return toArray(children);
          }

          var element = children;

          if (element.type !== REACT_FRAGMENT_TYPE) {
            return [element];
          }

          var fragmentChildren = element.props.children;

          if (!React.isValidElement(fragmentChildren)) {
            return toArray(fragmentChildren);
          }

          var fragmentChildElement = fragmentChildren;
          return [fragmentChildElement];
        }

        function flattenOptionChildren(children) {
          var content = ''; // Flatten children and warn if they aren't strings or numbers;
          // invalid types are ignored.

          React.Children.forEach(children, function (child) {
            if (child == null) {
              return;
            }

            if (typeof child === 'string' || typeof child === 'number') {
              content += child;
            } else {
              {
                if (!didWarnInvalidOptionChildren) {
                  didWarnInvalidOptionChildren = true;
                  warning(false, 'Only strings and numbers are supported as <option> children.');
                }
              }
            }
          });
          return content;
        }

        function maskContext(type, context) {
          var contextTypes = type.contextTypes;

          if (!contextTypes) {
            return emptyObject;
          }

          var maskedContext = {};

          for (var contextName in contextTypes) {
            maskedContext[contextName] = context[contextName];
          }

          return maskedContext;
        }

        function checkContextTypes(typeSpecs, values, location) {
          {
            checkPropTypes(typeSpecs, values, location, 'Component', getStackAddendum);
          }
        }

        function processContext(type, context) {
          var maskedContext = maskContext(type, context);
          {
            if (type.contextTypes) {
              checkContextTypes(type.contextTypes, maskedContext, 'context');
            }
          }
          return maskedContext;
        }

        var STYLE = 'style';
        var RESERVED_PROPS = {
          children: null,
          dangerouslySetInnerHTML: null,
          suppressContentEditableWarning: null,
          suppressHydrationWarning: null
        };

        function createOpenTagMarkup(tagVerbatim, tagLowercase, props, namespace, makeStaticMarkup, isRootElement) {
          var ret = '<' + tagVerbatim;

          for (var propKey in props) {
            if (!props.hasOwnProperty(propKey)) {
              continue;
            }

            var propValue = props[propKey];

            if (propValue == null) {
              continue;
            }

            if (propKey === STYLE) {
              propValue = createMarkupForStyles(propValue);
            }

            var markup = null;

            if (isCustomComponent(tagLowercase, props)) {
              if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
                markup = createMarkupForCustomAttribute(propKey, propValue);
              }
            } else {
              markup = createMarkupForProperty(propKey, propValue);
            }

            if (markup) {
              ret += ' ' + markup;
            }
          } // For static pages, no need to put React ID and checksum. Saves lots of
          // bytes.


          if (makeStaticMarkup) {
            return ret;
          }

          if (isRootElement) {
            ret += ' ' + createMarkupForRoot();
          }

          return ret;
        }

        function validateRenderResult(child, type) {
          if (child === undefined) {
            invariant(false, '%s(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.', getComponentName(type) || 'Component');
          }
        }

        function resolve(child, context) {
          while (React.isValidElement(child)) {
            // Safe because we just checked it's an element.
            var element = child;
            var Component = element.type;
            {
              pushElementToDebugStack(element);
            }

            if (typeof Component !== 'function') {
              break;
            }

            processChild(element, Component);
          } // Extra closure so queue and replace can be captured properly


          function processChild(element, Component) {
            var publicContext = processContext(Component, context);
            var queue = [];
            var replace = false;
            var updater = {
              isMounted: function isMounted(publicInstance) {
                return false;
              },
              enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
                if (queue === null) {
                  warnNoop(publicInstance, 'forceUpdate');
                  return null;
                }
              },
              enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState) {
                replace = true;
                queue = [completeState];
              },
              enqueueSetState: function enqueueSetState(publicInstance, currentPartialState) {
                if (queue === null) {
                  warnNoop(publicInstance, 'setState');
                  return null;
                }

                queue.push(currentPartialState);
              }
            };
            var inst = void 0;

            if (shouldConstruct(Component)) {
              inst = new Component(element.props, publicContext, updater);

              if (typeof Component.getDerivedStateFromProps === 'function') {
                {
                  if (inst.state === null || inst.state === undefined) {
                    var componentName = getComponentName(Component) || 'Unknown';

                    if (!didWarnAboutUninitializedState[componentName]) {
                      warning(false, '%s: Did not properly initialize state during construction. ' + 'Expected state to be an object, but it was %s.', componentName, inst.state === null ? 'null' : 'undefined');
                      didWarnAboutUninitializedState[componentName] = true;
                    }
                  }
                }
                var partialState = Component.getDerivedStateFromProps.call(null, element.props, inst.state);
                {
                  if (partialState === undefined) {
                    var _componentName = getComponentName(Component) || 'Unknown';

                    if (!didWarnAboutUndefinedDerivedState[_componentName]) {
                      warning(false, '%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', _componentName);
                      didWarnAboutUndefinedDerivedState[_componentName] = true;
                    }
                  }
                }

                if (partialState != null) {
                  inst.state = _assign({}, inst.state, partialState);
                }
              }
            } else {
              {
                if (Component.prototype && typeof Component.prototype.render === 'function') {
                  var _componentName2 = getComponentName(Component) || 'Unknown';

                  if (!didWarnAboutBadClass[_componentName2]) {
                    warning(false, "The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', _componentName2, _componentName2);
                    didWarnAboutBadClass[_componentName2] = true;
                  }
                }
              }
              inst = Component(element.props, publicContext, updater);

              if (inst == null || inst.render == null) {
                child = inst;
                validateRenderResult(child, Component);
                return;
              }
            }

            inst.props = element.props;
            inst.context = publicContext;
            inst.updater = updater;
            var initialState = inst.state;

            if (initialState === undefined) {
              inst.state = initialState = null;
            }

            if (typeof inst.UNSAFE_componentWillMount === 'function' || typeof inst.componentWillMount === 'function') {
              if (typeof inst.componentWillMount === 'function') {
                {
                  if (warnAboutDeprecatedLifecycles && inst.componentWillMount.__suppressDeprecationWarning !== true) {
                    var _componentName3 = getComponentName(Component) || 'Unknown';

                    if (!didWarnAboutDeprecatedWillMount[_componentName3]) {
                      lowPriorityWarning$1(false, '%s: componentWillMount() is deprecated and will be ' + 'removed in the next major version. Read about the motivations ' + 'behind this change: ' + 'https://fb.me/react-async-component-lifecycle-hooks' + '\n\n' + 'As a temporary workaround, you can rename to ' + 'UNSAFE_componentWillMount instead.', _componentName3);
                      didWarnAboutDeprecatedWillMount[_componentName3] = true;
                    }
                  }
                } // In order to support react-lifecycles-compat polyfilled components,
                // Unsafe lifecycles should not be invoked for any component with the new gDSFP.

                if (typeof Component.getDerivedStateFromProps !== 'function') {
                  inst.componentWillMount();
                }
              }

              if (typeof inst.UNSAFE_componentWillMount === 'function' && typeof Component.getDerivedStateFromProps !== 'function') {
                // In order to support react-lifecycles-compat polyfilled components,
                // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
                inst.UNSAFE_componentWillMount();
              }

              if (queue.length) {
                var oldQueue = queue;
                var oldReplace = replace;
                queue = null;
                replace = false;

                if (oldReplace && oldQueue.length === 1) {
                  inst.state = oldQueue[0];
                } else {
                  var nextState = oldReplace ? oldQueue[0] : inst.state;
                  var dontMutate = true;

                  for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
                    var partial = oldQueue[i];

                    var _partialState = typeof partial === 'function' ? partial.call(inst, nextState, element.props, publicContext) : partial;

                    if (_partialState != null) {
                      if (dontMutate) {
                        dontMutate = false;
                        nextState = _assign({}, nextState, _partialState);
                      } else {
                        _assign(nextState, _partialState);
                      }
                    }
                  }

                  inst.state = nextState;
                }
              } else {
                queue = null;
              }
            }

            child = inst.render();
            {
              if (child === undefined && inst.render._isMockFunction) {
                // This is probably bad practice. Consider warning here and
                // deprecating this convenience.
                child = null;
              }
            }
            validateRenderResult(child, Component);
            var childContext = void 0;

            if (typeof inst.getChildContext === 'function') {
              var childContextTypes = Component.childContextTypes;

              if (typeof childContextTypes === 'object') {
                childContext = inst.getChildContext();

                for (var contextKey in childContext) {
                  !(contextKey in childContextTypes) ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', getComponentName(Component) || 'Unknown', contextKey) : void 0;
                }
              } else {
                warning(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', getComponentName(Component) || 'Unknown');
              }
            }

            if (childContext) {
              context = _assign({}, context, childContext);
            }
          }

          return {
            child: child,
            context: context
          };
        }

        var ReactDOMServerRenderer = function () {
          function ReactDOMServerRenderer(children, makeStaticMarkup) {
            _classCallCheck(this, ReactDOMServerRenderer);

            var flatChildren = flattenTopLevelChildren(children);
            var topFrame = {
              type: null,
              // Assume all trees start in the HTML namespace (not totally true, but
              // this is what we did historically)
              domNamespace: Namespaces.html,
              children: flatChildren,
              childIndex: 0,
              context: emptyObject,
              footer: ''
            };
            {
              topFrame.debugElementStack = [];
            }
            this.stack = [topFrame];
            this.exhausted = false;
            this.currentSelectValue = null;
            this.previousWasTextNode = false;
            this.makeStaticMarkup = makeStaticMarkup; // Context (new API)

            this.providerStack = []; // Stack of provider objects

            this.providerIndex = -1;
          } // TODO: type this more strictly:


          ReactDOMServerRenderer.prototype.pushProvider = function pushProvider(provider) {
            this.providerIndex += 1;
            this.providerStack[this.providerIndex] = provider;
            var context = provider.type._context;
            context._currentValue = provider.props.value;
          };

          ReactDOMServerRenderer.prototype.popProvider = function popProvider(provider) {
            {
              !(this.providerIndex > -1 && provider === this.providerStack[this.providerIndex]) ? warning(false, 'Unexpected pop.') : void 0;
            }
            this.providerStack[this.providerIndex] = null;
            this.providerIndex -= 1;
            var context = provider.type._context;

            if (this.providerIndex < 0) {
              context._currentValue = context._defaultValue;
            } else {
              // We assume this type is correct because of the index check above.
              var previousProvider = this.providerStack[this.providerIndex];
              context._currentValue = previousProvider.props.value;
            }
          };

          ReactDOMServerRenderer.prototype.read = function read(bytes) {
            if (this.exhausted) {
              return null;
            }

            var out = '';

            while (out.length < bytes) {
              if (this.stack.length === 0) {
                this.exhausted = true;
                break;
              }

              var frame = this.stack[this.stack.length - 1];

              if (frame.childIndex >= frame.children.length) {
                var _footer = frame.footer;
                out += _footer;

                if (_footer !== '') {
                  this.previousWasTextNode = false;
                }

                this.stack.pop();

                if (frame.type === 'select') {
                  this.currentSelectValue = null;
                } else if (frame.type != null && frame.type.type != null && frame.type.type.$$typeof === REACT_PROVIDER_TYPE) {
                  var provider = frame.type;
                  this.popProvider(provider);
                }

                continue;
              }

              var child = frame.children[frame.childIndex++];
              {
                setCurrentDebugStack(this.stack);
              }
              out += this.render(child, frame.context, frame.domNamespace);
              {
                // TODO: Handle reentrant server render calls. This doesn't.
                resetCurrentDebugStack();
              }
            }

            return out;
          };

          ReactDOMServerRenderer.prototype.render = function render(child, context, parentNamespace) {
            if (typeof child === 'string' || typeof child === 'number') {
              var text = '' + child;

              if (text === '') {
                return '';
              }

              if (this.makeStaticMarkup) {
                return escapeTextForBrowser(text);
              }

              if (this.previousWasTextNode) {
                return '<!-- -->' + escapeTextForBrowser(text);
              }

              this.previousWasTextNode = true;
              return escapeTextForBrowser(text);
            } else {
              var nextChild = void 0;

              var _resolve = resolve(child, context);

              nextChild = _resolve.child;
              context = _resolve.context;

              if (nextChild === null || nextChild === false) {
                return '';
              } else if (!React.isValidElement(nextChild)) {
                if (nextChild != null && nextChild.$$typeof != null) {
                  // Catch unexpected special types early.
                  var $$typeof = nextChild.$$typeof;
                  !($$typeof !== REACT_PORTAL_TYPE) ? invariant(false, 'Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.') : void 0; // Catch-all to prevent an infinite loop if React.Children.toArray() supports some new type.

                  invariant(false, 'Unknown element-like object type: %s. This is likely a bug in React. Please file an issue.', $$typeof.toString());
                }

                var nextChildren = toArray(nextChild);
                var frame = {
                  type: null,
                  domNamespace: parentNamespace,
                  children: nextChildren,
                  childIndex: 0,
                  context: context,
                  footer: ''
                };
                {
                  frame.debugElementStack = [];
                }
                this.stack.push(frame);
                return '';
              } // Safe because we just checked it's an element.


              var nextElement = nextChild;
              var elementType = nextElement.type;

              if (typeof elementType === 'string') {
                return this.renderDOM(nextElement, context, parentNamespace);
              }

              switch (elementType) {
                case REACT_STRICT_MODE_TYPE:
                case REACT_ASYNC_MODE_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_FRAGMENT_TYPE:
                  {
                    var _nextChildren = toArray(nextChild.props.children);

                    var _frame = {
                      type: null,
                      domNamespace: parentNamespace,
                      children: _nextChildren,
                      childIndex: 0,
                      context: context,
                      footer: ''
                    };
                    {
                      _frame.debugElementStack = [];
                    }
                    this.stack.push(_frame);
                    return '';
                  }
                // eslint-disable-next-line-no-fallthrough

                default:
                  break;
              }

              if (typeof elementType === 'object' && elementType !== null) {
                switch (elementType.$$typeof) {
                  case REACT_FORWARD_REF_TYPE:
                    {
                      var element = nextChild;

                      var _nextChildren2 = toArray(elementType.render(element.props, element.ref));

                      var _frame2 = {
                        type: null,
                        domNamespace: parentNamespace,
                        children: _nextChildren2,
                        childIndex: 0,
                        context: context,
                        footer: ''
                      };
                      {
                        _frame2.debugElementStack = [];
                      }
                      this.stack.push(_frame2);
                      return '';
                    }

                  case REACT_PROVIDER_TYPE:
                    {
                      var provider = nextChild;
                      var nextProps = provider.props;

                      var _nextChildren3 = toArray(nextProps.children);

                      var _frame3 = {
                        type: provider,
                        domNamespace: parentNamespace,
                        children: _nextChildren3,
                        childIndex: 0,
                        context: context,
                        footer: ''
                      };
                      {
                        _frame3.debugElementStack = [];
                      }
                      this.pushProvider(provider);
                      this.stack.push(_frame3);
                      return '';
                    }

                  case REACT_CONTEXT_TYPE:
                    {
                      var consumer = nextChild;
                      var _nextProps = consumer.props;
                      var nextValue = consumer.type._currentValue;

                      var _nextChildren4 = toArray(_nextProps.children(nextValue));

                      var _frame4 = {
                        type: nextChild,
                        domNamespace: parentNamespace,
                        children: _nextChildren4,
                        childIndex: 0,
                        context: context,
                        footer: ''
                      };
                      {
                        _frame4.debugElementStack = [];
                      }
                      this.stack.push(_frame4);
                      return '';
                    }

                  default:
                    break;
                }
              }

              var info = '';
              {
                var owner = nextElement._owner;

                if (elementType === undefined || typeof elementType === 'object' && elementType !== null && Object.keys(elementType).length === 0) {
                  info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                }

                var ownerName = owner ? getComponentName(owner) : null;

                if (ownerName) {
                  info += '\n\nCheck the render method of `' + ownerName + '`.';
                }
              }
              invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', elementType == null ? elementType : typeof elementType, info);
            }
          };

          ReactDOMServerRenderer.prototype.renderDOM = function renderDOM(element, context, parentNamespace) {
            var tag = element.type.toLowerCase();
            var namespace = parentNamespace;

            if (parentNamespace === Namespaces.html) {
              namespace = getIntrinsicNamespace(tag);
            }

            {
              if (namespace === Namespaces.html) {
                // Should this check be gated by parent namespace? Not sure we want to
                // allow <SVG> or <mATH>.
                !(tag === element.type) ? warning(false, '<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', element.type) : void 0;
              }
            }
            validateDangerousTag(tag);
            var props = element.props;

            if (tag === 'input') {
              {
                ReactControlledValuePropTypes.checkPropTypes('input', props, getStackAddendum);

                if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
                  warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', 'A component', props.type);
                  didWarnDefaultChecked = true;
                }

                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
                  warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', 'A component', props.type);
                  didWarnDefaultInputValue = true;
                }
              }
              props = _assign({
                type: undefined
              }, props, {
                defaultChecked: undefined,
                defaultValue: undefined,
                value: props.value != null ? props.value : props.defaultValue,
                checked: props.checked != null ? props.checked : props.defaultChecked
              });
            } else if (tag === 'textarea') {
              {
                ReactControlledValuePropTypes.checkPropTypes('textarea', props, getStackAddendum);

                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
                  warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
                  didWarnDefaultTextareaValue = true;
                }
              }
              var initialValue = props.value;

              if (initialValue == null) {
                var defaultValue = props.defaultValue; // TODO (yungsters): Remove support for children content in <textarea>.

                var textareaChildren = props.children;

                if (textareaChildren != null) {
                  {
                    warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
                  }
                  !(defaultValue == null) ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : void 0;

                  if (Array.isArray(textareaChildren)) {
                    !(textareaChildren.length <= 1) ? invariant(false, '<textarea> can only have at most one child.') : void 0;
                    textareaChildren = textareaChildren[0];
                  }

                  defaultValue = '' + textareaChildren;
                }

                if (defaultValue == null) {
                  defaultValue = '';
                }

                initialValue = defaultValue;
              }

              props = _assign({}, props, {
                value: undefined,
                children: '' + initialValue
              });
            } else if (tag === 'select') {
              {
                ReactControlledValuePropTypes.checkPropTypes('select', props, getStackAddendum);

                for (var i = 0; i < valuePropNames.length; i++) {
                  var propName = valuePropNames[i];

                  if (props[propName] == null) {
                    continue;
                  }

                  var isArray = Array.isArray(props[propName]);

                  if (props.multiple && !isArray) {
                    warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, '' // getDeclarationErrorAddendum(),
                    );
                  } else if (!props.multiple && isArray) {
                    warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, '' // getDeclarationErrorAddendum(),
                    );
                  }
                }

                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
                  warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
                  didWarnDefaultSelectValue = true;
                }
              }
              this.currentSelectValue = props.value != null ? props.value : props.defaultValue;
              props = _assign({}, props, {
                value: undefined
              });
            } else if (tag === 'option') {
              var selected = null;
              var selectValue = this.currentSelectValue;
              var optionChildren = flattenOptionChildren(props.children);

              if (selectValue != null) {
                var value = void 0;

                if (props.value != null) {
                  value = props.value + '';
                } else {
                  value = optionChildren;
                }

                selected = false;

                if (Array.isArray(selectValue)) {
                  // multiple
                  for (var j = 0; j < selectValue.length; j++) {
                    if ('' + selectValue[j] === value) {
                      selected = true;
                      break;
                    }
                  }
                } else {
                  selected = '' + selectValue === value;
                }

                props = _assign({
                  selected: undefined,
                  children: undefined
                }, props, {
                  selected: selected,
                  children: optionChildren
                });
              }
            }

            {
              validatePropertiesInDevelopment(tag, props);
            }
            assertValidProps(tag, props, getStackAddendum);
            var out = createOpenTagMarkup(element.type, tag, props, namespace, this.makeStaticMarkup, this.stack.length === 1);
            var footer = '';

            if (omittedCloseTags.hasOwnProperty(tag)) {
              out += '/>';
            } else {
              out += '>';
              footer = '</' + element.type + '>';
            }

            var children = void 0;
            var innerMarkup = getNonChildrenInnerMarkup(props);

            if (innerMarkup != null) {
              children = [];

              if (newlineEatingTags[tag] && innerMarkup.charAt(0) === '\n') {
                // text/html ignores the first character in these tags if it's a newline
                // Prefer to break application/xml over text/html (for now) by adding
                // a newline specifically to get eaten by the parser. (Alternately for
                // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
                // \r is normalized out by HTMLTextAreaElement#value.)
                // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
                // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
                // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
                // See: Parsing of "textarea" "listing" and "pre" elements
                //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
                out += '\n';
              }

              out += innerMarkup;
            } else {
              children = toArray(props.children);
            }

            var frame = {
              domNamespace: getChildNamespace(parentNamespace, element.type),
              type: tag,
              children: children,
              childIndex: 0,
              context: context,
              footer: footer
            };
            {
              frame.debugElementStack = [];
            }
            this.stack.push(frame);
            this.previousWasTextNode = false;
            return out;
          };

          return ReactDOMServerRenderer;
        }();
        /**
         * Render a ReactElement to its initial HTML. This should only be used on the
         * server.
         * See https://reactjs.org/docs/react-dom-server.html#rendertostring
         */


        function renderToString(element) {
          var renderer = new ReactDOMServerRenderer(element, false);
          var markup = renderer.read(Infinity);
          return markup;
        }
        /**
         * Similar to renderToString, except this doesn't create extra DOM attributes
         * such as data-react-id that React uses internally.
         * See https://reactjs.org/docs/react-dom-server.html#rendertostaticmarkup
         */


        function renderToStaticMarkup(element) {
          var renderer = new ReactDOMServerRenderer(element, true);
          var markup = renderer.read(Infinity);
          return markup;
        }

        function renderToNodeStream() {
          invariant(false, 'ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.');
        }

        function renderToStaticNodeStream() {
          invariant(false, 'ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.');
        } // Note: when changing this, also consider https://github.com/facebook/react/issues/11526


        var ReactDOMServerBrowser = {
          renderToString: renderToString,
          renderToStaticMarkup: renderToStaticMarkup,
          renderToNodeStream: renderToNodeStream,
          renderToStaticNodeStream: renderToStaticNodeStream,
          version: ReactVersion
        };
        var ReactDOMServerBrowser$1 = Object.freeze({
          default: ReactDOMServerBrowser
        });
        var ReactDOMServer = ReactDOMServerBrowser$1 && ReactDOMServerBrowser || ReactDOMServerBrowser$1; // TODO: decide on the top-level export form.
        // This is hacky but makes it work with both Rollup and Jest

        var server_browser = ReactDOMServer.default ? ReactDOMServer.default : ReactDOMServer;
        module.exports = server_browser;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(17));
  /***/
},
/* 598 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('react'), require('prop-types'), require('../lib/String'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.react, global.propTypes, global.String);
      global.HeatMap = mod.exports;
    }
  })(this, function (exports, _react, _propTypes, _String) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.HeatMap = undefined;

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var evtNames = ['click', 'mouseover', 'recenter'];

    var wrappedPromise = function wrappedPromise() {
      var wrappedPromise = {},
          promise = new Promise(function (resolve, reject) {
        wrappedPromise.resolve = resolve;
        wrappedPromise.reject = reject;
      });
      wrappedPromise.then = promise.then.bind(promise);
      wrappedPromise.catch = promise.catch.bind(promise);
      wrappedPromise.promise = promise;
      return wrappedPromise;
    };

    var HeatMap = exports.HeatMap = function (_React$Component) {
      _inherits(HeatMap, _React$Component);

      function HeatMap() {
        _classCallCheck(this, HeatMap);

        return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
      }

      _createClass(HeatMap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.heatMapPromise = wrappedPromise();
          this.renderHeatMap();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
            if (this.heatMap) {
              this.heatMap.setMap(null);
              this.renderHeatMap();
            }
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.heatMap) {
            this.heatMap.setMap(null);
          }
        }
      }, {
        key: 'renderHeatMap',
        value: function renderHeatMap() {
          var _this2 = this;

          var _props = this.props,
              map = _props.map,
              google = _props.google,
              positions = _props.positions,
              mapCenter = _props.mapCenter,
              icon = _props.icon,
              gradient = _props.gradient,
              _props$radius = _props.radius,
              radius = _props$radius === undefined ? 20 : _props$radius,
              _props$opacity = _props.opacity,
              opacity = _props$opacity === undefined ? 0.2 : _props$opacity,
              props = _objectWithoutProperties(_props, ['map', 'google', 'positions', 'mapCenter', 'icon', 'gradient', 'radius', 'opacity']);

          if (!google) {
            return null;
          }

          var data = positions.map(function (pos) {
            return new google.maps.LatLng(pos.lat, pos.lng);
          });

          var pref = _extends({
            map: map,
            gradient: gradient,
            radius: radius,
            opacity: opacity,
            data: data
          }, props);

          this.heatMap = new google.maps.visualization.HeatmapLayer(pref);
          this.heatMap.set('radius', radius === undefined ? 20 : radius);
          this.heatMap.set('opacity', opacity === undefined ? 0.2 : opacity);
          evtNames.forEach(function (e) {
            _this2.heatMap.addListener(e, _this2.handleEvent(e));
          });
          this.heatMapPromise.resolve(this.heatMap);
        }
      }, {
        key: 'getHeatMap',
        value: function getHeatMap() {
          return this.heatMapPromise;
        }
      }, {
        key: 'handleEvent',
        value: function handleEvent(evt) {
          var _this3 = this;

          return function (e) {
            var evtName = 'on' + (0, _String.camelize)(evt);

            if (_this3.props[evtName]) {
              _this3.props[evtName](_this3.props, _this3.heatMap, e);
            }
          };
        }
      }, {
        key: 'render',
        value: function render() {
          return null;
        }
      }]);

      return HeatMap;
    }(_react2.default.Component);

    HeatMap.propTypes = {
      position: _propTypes2.default.object,
      map: _propTypes2.default.object,
      icon: _propTypes2.default.string
    };
    evtNames.forEach(function (e) {
      return HeatMap.propTypes[e] = _propTypes2.default.func;
    });
    HeatMap.defaultProps = {
      name: 'HeatMap'
    };
    exports.default = HeatMap;
  });
  /***/

},
/* 599 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(193), __webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
      global.Polygon = mod.exports;
    }
  })(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Polygon = undefined;

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var evtNames = ['click', 'mouseout', 'mouseover'];

    var wrappedPromise = function wrappedPromise() {
      var wrappedPromise = {},
          promise = new Promise(function (resolve, reject) {
        wrappedPromise.resolve = resolve;
        wrappedPromise.reject = reject;
      });
      wrappedPromise.then = promise.then.bind(promise);
      wrappedPromise.catch = promise.catch.bind(promise);
      wrappedPromise.promise = promise;
      return wrappedPromise;
    };

    var Polygon = exports.Polygon = function (_React$Component) {
      _inherits(Polygon, _React$Component);

      function Polygon() {
        _classCallCheck(this, Polygon);

        return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
      }

      _createClass(Polygon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.polygonPromise = wrappedPromise();
          this.renderPolygon();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
            if (this.polygon) {
              this.polygon.setMap(null);
            }

            this.renderPolygon();
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
        }
      }, {
        key: 'renderPolygon',
        value: function renderPolygon() {
          var _this2 = this;

          var _props = this.props,
              map = _props.map,
              google = _props.google,
              paths = _props.paths,
              strokeColor = _props.strokeColor,
              strokeOpacity = _props.strokeOpacity,
              strokeWeight = _props.strokeWeight,
              fillColor = _props.fillColor,
              fillOpacity = _props.fillOpacity,
              props = _objectWithoutProperties(_props, ['map', 'google', 'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

          if (!google) {
            return null;
          }

          var params = _extends({
            map: map,
            paths: paths,
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight,
            fillColor: fillColor,
            fillOpacity: fillOpacity
          }, props);

          this.polygon = new google.maps.Polygon(params);
          evtNames.forEach(function (e) {
            _this2.polygon.addListener(e, _this2.handleEvent(e));
          });
          this.polygonPromise.resolve(this.polygon);
        }
      }, {
        key: 'getPolygon',
        value: function getPolygon() {
          return this.polygonPromise;
        }
      }, {
        key: 'handleEvent',
        value: function handleEvent(evt) {
          var _this3 = this;

          return function (e) {
            var evtName = 'on' + (0, _String.camelize)(evt);

            if (_this3.props[evtName]) {
              _this3.props[evtName](_this3.props, _this3.polygon, e);
            }
          };
        }
      }, {
        key: 'render',
        value: function render() {
          return null;
        }
      }]);

      return Polygon;
    }(_react2.default.Component);

    Polygon.propTypes = {
      paths: _propTypes2.default.array,
      strokeColor: _propTypes2.default.string,
      strokeOpacity: _propTypes2.default.number,
      strokeWeight: _propTypes2.default.number,
      fillColor: _propTypes2.default.string,
      fillOpacity: _propTypes2.default.number
    };
    evtNames.forEach(function (e) {
      return Polygon.propTypes[e] = _propTypes2.default.func;
    });
    Polygon.defaultProps = {
      name: 'Polygon'
    };
    exports.default = Polygon;
  });
  /***/

},
/* 600 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports);
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports);
      global.cancelablePromise = mod.exports;
    }
  })(this, function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    }); // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html

    var makeCancelable = exports.makeCancelable = function makeCancelable(promise) {
      var hasCanceled_ = false;
      var wrappedPromise = new Promise(function (resolve, reject) {
        promise.then(function (val) {
          return hasCanceled_ ? reject({
            isCanceled: true
          }) : resolve(val);
        });
        promise.catch(function (error) {
          return hasCanceled_ ? reject({
            isCanceled: true
          }) : reject(error);
        });
      });
      return {
        promise: wrappedPromise,
        cancel: function cancel() {
          hasCanceled_ = true;
        }
      };
    };
  });
  /***/

},
/* 601 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(193), __webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
      factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
      global.Polyline = mod.exports;
    }
  })(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Polyline = undefined;

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var evtNames = ['click', 'mouseout', 'mouseover'];

    var wrappedPromise = function wrappedPromise() {
      var wrappedPromise = {},
          promise = new Promise(function (resolve, reject) {
        wrappedPromise.resolve = resolve;
        wrappedPromise.reject = reject;
      });
      wrappedPromise.then = promise.then.bind(promise);
      wrappedPromise.catch = promise.catch.bind(promise);
      wrappedPromise.promise = promise;
      return wrappedPromise;
    };

    var Polyline = exports.Polyline = function (_React$Component) {
      _inherits(Polyline, _React$Component);

      function Polyline() {
        _classCallCheck(this, Polyline);

        return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
      }

      _createClass(Polyline, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.polylinePromise = wrappedPromise();
          this.renderPolyline();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
            if (this.polyline) {
              this.polyline.setMap(null);
            }

            this.renderPolyline();
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.polyline) {
            this.polyline.setMap(null);
          }
        }
      }, {
        key: 'renderPolyline',
        value: function renderPolyline() {
          var _this2 = this;

          var _props = this.props,
              map = _props.map,
              google = _props.google,
              path = _props.path,
              strokeColor = _props.strokeColor,
              strokeOpacity = _props.strokeOpacity,
              strokeWeight = _props.strokeWeight,
              props = _objectWithoutProperties(_props, ['map', 'google', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight']);

          if (!google) {
            return null;
          }

          var params = _extends({
            map: map,
            path: path,
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight
          }, props);

          this.polyline = new google.maps.Polyline(params);
          evtNames.forEach(function (e) {
            _this2.polyline.addListener(e, _this2.handleEvent(e));
          });
          this.polylinePromise.resolve(this.polyline);
        }
      }, {
        key: 'getPolyline',
        value: function getPolyline() {
          return this.polylinePromise;
        }
      }, {
        key: 'handleEvent',
        value: function handleEvent(evt) {
          var _this3 = this;

          return function (e) {
            var evtName = 'on' + (0, _String.camelize)(evt);

            if (_this3.props[evtName]) {
              _this3.props[evtName](_this3.props, _this3.polyline, e);
            }
          };
        }
      }, {
        key: 'render',
        value: function render() {
          return null;
        }
      }]);

      return Polyline;
    }(_react2.default.Component);

    Polyline.propTypes = {
      path: _propTypes2.default.array,
      strokeColor: _propTypes2.default.string,
      strokeOpacity: _propTypes2.default.number,
      strokeWeight: _propTypes2.default.number
    };
    evtNames.forEach(function (e) {
      return Polyline.propTypes[e] = _propTypes2.default.func;
    });
    Polyline.defaultProps = {
      name: 'Polyline'
    };
    exports.default = Polyline;
  });
  /***/

},
/* 602 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Place = function Place(_ref) {
    var item = _ref.item,
        currentMarker = _ref.currentMarker,
        currentColor = _ref.currentColor,
        index = _ref.index,
        className = _ref.className;
    return _react2.default.createElement('div', {
      className: 'gr-poi-map__place ' + className + ' ' + (currentMarker ? 'gr-poi-map__place--show' : ''),
      key: (0, _generic.randomStr)(item.name + '-review'),
      style: {
        borderColor: currentColor
      }
    }, _react2.default.createElement('div', {
      className: 'gr-poi-map__map-pin'
    }, _react2.default.createElement('i', {
      className: 'gr-icon icon-map-pin gr-poi-map__map-icon',
      style: {
        color: currentColor
      },
      'aria-hidden': 'true'
    }), _react2.default.createElement('span', {
      className: 'gr-poi-map__map-index'
    }, index)), _react2.default.createElement('h3', {
      className: 'gr-poi-map__place-heading'
    }, item.displayName || item.name), _react2.default.createElement('p', {
      className: 'gr-poi-map__place-text'
    }, item.description), item.website && _react2.default.createElement('a', {
      href: item.website,
      target: '_blank',
      className: 'gr-poi-map__place-link',
      rel: 'noopener noreferrer',
      style: {
        textDecorationColor: currentColor
      }
    }, item.website.match(/https?:\/\/(www[0-9]?\.)?(.[^/:]+)/)[2]));
  };

  Place.propTypes = {
    item: _propTypes2.default.shape({
      name: _propTypes2.default.string,
      description: _propTypes2.default.string,
      website: _propTypes2.default.string
    }),
    currentMarker: _propTypes2.default.bool.isRequired,
    currentColor: _propTypes2.default.string,
    index: _propTypes2.default.string,
    className: _propTypes2.default.string
  };
  Place.defaultProps = {
    item: null,
    currentColor: null,
    index: null,
    className: null
  };
  exports.default = Place;
  /***/
},
/* 603 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(604);

  var _generic = __webpack_require__(10);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Tab = function Tab(_ref) {
    var link = _ref.link,
        action = _ref.action,
        className = _ref.className,
        color = _ref.color,
        currentItem = _ref.currentItem,
        open = _ref.open;
    var ID = (0, _generic.randomStr)('gr-poi-map-tab');
    var TEXT = link === 'food' ? 'Food and Drink' : link.charAt(0).toUpperCase() + link.slice(1);
    return _react2.default.createElement('a', {
      href: '/',
      onClick: action,
      className: 'gr-poi-map-tab ' + className
    }, TEXT, currentItem && _react2.default.createElement('i', {
      className: 'gr-icon ' + (open ? 'icon-chevron-up' : 'icon-chevron-down') + ' gr-poi-map-tab__icon',
      'aria-hidden': 'true'
    }), _react2.default.createElement('svg', {
      width: '0',
      height: '0',
      className: 'gr-poi-map-tab__svg',
      style: {
        backgroundColor: color
      }
    }, _react2.default.createElement('defs', null, _react2.default.createElement('clipPath', {
      id: ID,
      clipPathUnits: 'objectBoundingBox',
      transform: 'scale(0.00383 0.0222)'
    }, _react2.default.createElement('polygon', {
      points: '5 20 0 65 285 65 190 0'
    }))), _react2.default.createElement('rect', {
      className: 'gr-poi-map-tab__rect',
      style: {
        clipPath: 'url(#' + ID + ')',
        fill: color
      },
      width: '100%',
      height: '100%'
    })));
  };

  Tab.propTypes = {
    link: _propTypes2.default.string,
    action: _propTypes2.default.func,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    currentItem: _propTypes2.default.bool,
    open: _propTypes2.default.bool
  };
  Tab.defaultProps = {
    link: null,
    action: null,
    className: '',
    color: null,
    currentItem: false,
    open: false
  };
  exports.default = Tab;
  /***/
},
/* 604 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(605);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!./Tab.css", function () {
      var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!./Tab.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 605 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-poi-map-tab {\n  text-transform: uppercase;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 700;\n  display: block;\n  padding: 20px 15px;\n  opacity: .5;\n  transition: opacity ease .3s;\n  position: relative; }\n  .gr-poi-map-tab:hover, .gr-poi-map-tab:focus {\n    color: #FFFFFF;\n    opacity: 1;\n    text-decoration: none;\n    transition: opacity ease .3s; }\n  .gr-poi-map-tab__svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map-tab__svg {\n        background-color: transparent !important; } }\n  .gr-poi-map-tab--selected {\n    opacity: 1;\n    padding: 30px 25px 5px 17px;\n    max-width: 220px;\n    z-index: 1;\n    outline: none; }\n    .gr-poi-map-tab--selected .gr-poi-map-tab__svg {\n      background-color: transparent !important; }\n  @media all and (min-width: 768px) {\n    .gr-poi-map-tab {\n      margin: 0 5px;\n      text-align: center;\n      min-width: 183px; }\n      .gr-poi-map-tab, .gr-poi-map-tab--selected {\n        padding: 30px 40px 10px 25px; } }\n  @media only screen and (min-width: 768px) and (max-width: 810px) {\n    .gr-poi-map-tab {\n      min-width: 170px; } }\n  .gr-poi-map-tab__icon {\n    font-size: 25px;\n    margin-left: 5px;\n    vertical-align: middle; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map-tab__icon {\n        display: none; } }\n", ""]); // exports

  /***/
},
/* 606 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(55);

  var _scriptCache = __webpack_require__(195);

  var _scriptCache2 = _interopRequireDefault(_scriptCache);

  var _googleApi = __webpack_require__(607);

  var _POIMapStyle = __webpack_require__(608);

  var _POIMapStyle2 = _interopRequireDefault(_POIMapStyle);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {};

  var wrapper = exports.wrapper = function wrapper(options) {
    return function (WrappedComponent) {
      var apiKey = options.apiKey;
      var libraries = options.libraries || ['places'];

      var Wrapper = function (_Component) {
        _inherits(Wrapper, _Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          _this.setRef = _this.setRef.bind(_this);
          _this.state = {
            loaded: false,
            map: null,
            google: null
          };
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            this.scriptCache = (0, _scriptCache2.default)({
              google: (0, _googleApi.googleApi)({
                apiKey: apiKey,
                libraries: libraries
              })
            });
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            this.scriptCache.google.onLoad(function () {
              return _this2.setState({
                loaded: true,
                google: window.google
              });
            });
          }
        }, {
          key: 'setRef',
          value: function setRef(input) {
            if (this.state.loaded && input) {
              var google = this.state.google;
              var locationCenter = this.props.locationCenter;
              var center = new google.maps.LatLng(locationCenter.lat, locationCenter.lng);
              var mapConfig = Object.assign({}, defaultMapConfig, _extends({
                center: center,
                zoom: Number(this.props.zoom) || 15
              }, _POIMapStyle2.default));
              this.map = new google.maps.Map(input, mapConfig);
              this.setState({
                map: this.map
              });
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var props = _extends({}, this.props, {
              loaded: this.state.loaded,
              map: this.state.map,
              google: this.state.google
            });

            return this.state.loaded && _react2.default.createElement(WrappedComponent, _extends({}, props, {
              wrappedRef: this.setRef
            }));
          }
        }]);

        return Wrapper;
      }(_react.Component);

      Wrapper.propTypes = {
        zoom: _propTypes2.default.string,
        loaded: _propTypes2.default.bool,
        map: _propTypes2.default.element,
        google: _propTypes2.default.shape(),
        mapComponent: _propTypes2.default.element,
        locationCenter: _propTypes2.default.shape({
          lat: _propTypes2.default.number,
          lng: _propTypes2.default.number
        })
      };
      Wrapper.defaultProps = {
        zoom: null,
        loaded: null,
        map: null,
        google: null,
        mapComponent: null,
        locationCenter: {
          lat: null,
          lng: null
        }
      };
      return Wrapper;
    };
  };

  exports.default = wrapper;
  /***/
},
/* 607 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var googleApi = exports.googleApi = function googleApi(opts) {
    var options = opts || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || [];
    var client = options.client;
    var URL = 'https://maps.googleapis.com/maps/api/js';
    var channel = null;
    var language = null;
    var region = null;

    var url = function url() {
      var apiUrl = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        channel: channel,
        language: language,
        region: region
      };
      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');
      return apiUrl + '?' + paramStr;
    };

    return url();
  };

  exports.default = googleApi;
  /***/
},
/* 608 */

/***/
function (module, exports) {
  module.exports = {
    "styles": [{
      "elementType": "geometry",
      "stylers": [{
        "color": "#f5f5f5"
      }]
    }, {
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#616161"
      }]
    }, {
      "elementType": "labels.text.stroke",
      "stylers": [{
        "color": "#f5f5f5"
      }]
    }, {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#bdbdbd"
      }]
    }, {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{
        "color": "#eeeeee"
      }]
    }, {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#757575"
      }]
    }, {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{
        "color": "#e5e5e5"
      }]
    }, {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#757575"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [{
        "color": "#dadada"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#616161"
      }]
    }, {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [{
        "color": "#e5e5e5"
      }]
    }, {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [{
        "color": "#eeeeee"
      }]
    }, {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{
        "color": "#c9c9c9"
      }]
    }, {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9e9e9e"
      }]
    }]
    /***/

  };
},
/* 609 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(610);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./POIMap.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./POIMap.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 610 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-poi-map {\n  /* stylelint-disable no-descending-specificity */\n  /* stylelint-enable no-descending-specificity */ }\n  @media all and (min-width: 768px) {\n    .gr-poi-map {\n      padding-bottom: 10px; } }\n  .gr-poi-map__map {\n    height: 450px;\n    position: relative; }\n  .gr-poi-map__tab {\n    position: relative;\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map__tab {\n        display: block;\n        margin: 35px 5px 0; } }\n  .gr-poi-map__accordion {\n    position: absolute;\n    bottom: 0;\n    width: 100%; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map__accordion {\n        display: none; } }\n    .gr-poi-map__accordion .gr-poi-map__tab--active {\n      display: none; }\n    .gr-poi-map__accordion-dropdown {\n      display: none;\n      position: absolute;\n      top: 100%;\n      width: 100%;\n      z-index: 1;\n      background-color: #FFFFFF; }\n      .gr-poi-map__accordion-dropdown--open {\n        display: block; }\n  .gr-poi-map__place {\n    display: none;\n    padding: 25px;\n    border: 4px solid #FFFFFF; }\n    .gr-poi-map__place--show {\n      display: block; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map__place {\n        display: block;\n        border: none;\n        padding: 0 20px;\n        margin-bottom: 30px;\n        opacity: 0;\n        animation-name: slide-left-fade;\n        -webkit-animation: slide-left-fade;\n        -moz-animation: slide-left-fade;\n        -ms-animation: slide-left-fade;\n        -o-animation: slide-left-fade;\n        animation-fill-mode: forwards;\n        animation-duration: 1s; }\n        .gr-poi-map__place + .gr-poi-map__place {\n          animation-delay: .1s; }\n          .gr-poi-map__place + .gr-poi-map__place + .gr-poi-map__place {\n            animation-delay: .2s; }\n            .gr-poi-map__place + .gr-poi-map__place + .gr-poi-map__place + .gr-poi-map__place {\n              animation-delay: .3s; } }\n  .gr-poi-map__place-heading {\n    font-size: 20px;\n    margin-bottom: 3px; }\n  .gr-poi-map__place-text {\n    margin-bottom: 0; }\n  .gr-poi-map__place-link {\n    margin-top: 15px;\n    display: inline-block;\n    text-decoration: underline;\n    color: #7C7C7B; }\n    .gr-poi-map__place-link:hover, .gr-poi-map__place-link:focus {\n      color: inherit; }\n  .gr-poi-map__tabs {\n    border: none;\n    margin: 0 auto; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map__tabs {\n        display: flex;\n        justify-content: center;\n        border-bottom: 4px solid #7C7C7B;\n        max-width: 1000px;\n        margin: 0 auto; } }\n  .gr-poi-map__tab-body {\n    margin: 0 15px;\n    position: relative;\n    top: -1px; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map__tab-body {\n        max-width: 900px;\n        margin: 0 auto;\n        padding: 40px 10px 0; } }\n  .gr-poi-map__map-pin {\n    position: relative;\n    display: inline-block;\n    margin-bottom: 10px; }\n  .gr-poi-map__map-icon {\n    font-size: 35px; }\n  .gr-poi-map__map-index {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    color: #FFFFFF; }\n  .gr-poi-map__grainger-home {\n    color: #4E8382;\n    font-size: 16px;\n    font-weight: 700;\n    font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif; }\n  .gr-poi-map__tab-item {\n    animation-name: fade-in;\n    -webkit-animation: fade-in;\n    -moz-animation: fade-in;\n    -ms-animation: fade-in;\n    -o-animation: fade-in;\n    animation-fill-mode: forwards;\n    animation-duration: .3s;\n    animation-play-state: paused;\n    opacity: 0;\n    background-color: #FFFFFF; }\n    .gr-poi-map__tab-item .gr-poi-map-tab:not(.gr-poi-map-tab--active) {\n      opacity: 1;\n      animation-name: fade-out;\n      -webkit-animation: fade-out;\n      -moz-animation: fade-out;\n      -ms-animation: fade-out;\n      -o-animation: fade-out;\n      animation-fill-mode: forwards;\n      animation-duration: .3s;\n      animation-delay: .3s; }\n    .gr-poi-map__tab-item + .gr-poi-map__tab-item {\n      animation-delay: .1s; }\n      .gr-poi-map__tab-item + .gr-poi-map__tab-item .gr-poi-map-tab {\n        animation-delay: .5s; }\n      .gr-poi-map__tab-item + .gr-poi-map__tab-item + .gr-poi-map__tab-item {\n        animation-delay: .2s; }\n        .gr-poi-map__tab-item + .gr-poi-map__tab-item + .gr-poi-map__tab-item .gr-poi-map-tab {\n          animation-delay: .6s; }\n        .gr-poi-map__tab-item + .gr-poi-map__tab-item + .gr-poi-map__tab-item + .gr-poi-map__tab-item {\n          animation-delay: .3s; }\n          .gr-poi-map__tab-item + .gr-poi-map__tab-item + .gr-poi-map__tab-item + .gr-poi-map__tab-item .gr-poi-map-tab {\n            animation-delay: .7s; }\n  .gr-poi-map .gr-poi-map__accordion-dropdown--open {\n    background-color: transparent; }\n    .gr-poi-map .gr-poi-map__accordion-dropdown--open .gr-poi-map__tab-item {\n      animation-play-state: running; }\n  .gr-poi-map .slick-slider {\n    display: none;\n    padding: 0 30px; }\n    @media all and (min-width: 768px) {\n      .gr-poi-map .slick-slider {\n        display: block; } }\n  @media all and (min-width: 768px) {\n    .gr-poi-map__tab-body-row--desktop-hide {\n      display: none; } }\n\n/* stylelint-disable no-descending-specificity */\n/** close-button(note that there may be a scrollbar) **/\n.gr-poi-map__iw > div:last-child {\n  display: none; }\n\n.gr-poi-map__iw .gm-style-iw {\n  border: none; }\n\n/** set here the desired background-color **/\n.gr-poi-map__iw > div:first-child > div:nth-child(n-1) > div > div,\n.gr-poi-map__iw > div > div:last-child,\n.gr-poi-map__iw .gm-style-iw,\n.gr-poi-map__iw .gm-style-iw > div,\n.gr-poi-map__iw .gm-style-iw > div > div {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  transform: none !important;\n  left: 26px !important;\n  top: 5px !important; }\n\n.gr-poi-map__iw > div:first-child,\n.gr-poi-map__iw > div:first-child > div:nth-child(2) {\n  display: none; }\n\n.gr-poi-map__iw .gm-style-iw,\n.gr-poi-map__iw .gm-style-iw > div,\n.gr-poi-map__iw .gm-style-iw > div > div {\n  width: 100% !important;\n  max-width: 100% !important; }\n\n/** set here the width **/\n.gr-poi-map__iw,\n.gr-poi-map__iw > div:first-child > div:last-child {\n  width: 150px !important; }\n\n@-webkit-keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-ms-keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-o-keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: .5; } }\n\n@-moz-keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: .5; } }\n\n@-ms-keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: .5; } }\n\n@-o-keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: .5; } }\n\n@keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: .5; } }\n\n@-webkit-keyframes slide-left-fade {\n  from {\n    transform: translateX(20px);\n    opacity: 0; }\n  to {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@-moz-keyframes slide-left-fade {\n  from {\n    transform: translateX(20px);\n    opacity: 0; }\n  to {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@-ms-keyframes slide-left-fade {\n  from {\n    transform: translateX(20px);\n    opacity: 0; }\n  to {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@-o-keyframes slide-left-fade {\n  from {\n    transform: translateX(20px);\n    opacity: 0; }\n  to {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes slide-left-fade {\n  from {\n    transform: translateX(20px);\n    opacity: 0; }\n  to {\n    transform: translateX(0);\n    opacity: 1; } }\n", ""]); // exports

  /***/
},
/* 611 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SimpleMap = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _googleMapsReact = __webpack_require__(191);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _graingerMapPin = __webpack_require__(194);

  var _graingerMapPin2 = _interopRequireDefault(_graingerMapPin);

  var _generic = __webpack_require__(10);

  var _GoogleApiComponent = __webpack_require__(612);

  var _GoogleApiComponent2 = _interopRequireDefault(_GoogleApiComponent);

  __webpack_require__(615);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SimpleMap = exports.SimpleMap = function (_Component) {
    _inherits(SimpleMap, _Component);

    _createClass(SimpleMap, null, [{
      key: 'strToLatLng',
      value: function strToLatLng(str) {
        var coordinates = str.split(',').map(function (i) {
          return Number(i);
        });
        return {
          lat: coordinates[0],
          lng: coordinates[1]
        };
      }
    }]);

    function SimpleMap(props) {
      _classCallCheck(this, SimpleMap);

      var _this = _possibleConstructorReturn(this, (SimpleMap.__proto__ || Object.getPrototypeOf(SimpleMap)).call(this, props));
      /* eslint-disable-line no-useless-constructor */


      _this.coordinates = props.locationCenter;
      return _this;
    }

    _createClass(SimpleMap, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return !this.props.loaded ? _react2.default.createElement('div', null, 'Loading...') : _react2.default.createElement('div', {
          className: 'gr-simplemap container'
        }, _react2.default.createElement('h2', {
          className: 'gr-simplemap__title'
        }, this.props.title), _react2.default.createElement('div', {
          className: 'gr-simplemap__map row'
        }, _react2.default.createElement('div', {
          className: 'gr-map',
          id: 'map',
          ref: this.props.wrappedRef,
          style: {
            width: '100%',
            height: '100%'
          }
        }, this.props.items.map(function (item) {
          var coordinates = SimpleMap.strToLatLng(item.coordinates);
          return item.type === 'Development' && _react2.default.createElement(_googleMapsReact.Marker, {
            key: (0, _generic.randomStr)(),
            position: coordinates,
            map: _this2.props.map,
            google: _this2.props.google,
            icon: {
              url: _graingerMapPin2.default,
              anchor: new google.maps.Point(25, 0)
              /* eslint-disable-line no-undef */

            },
            onClick: function onClick() {
              return window.open('https://maps.google.com/?q=' + coordinates.lat + ',' + coordinates.lng);
            }
          });
        }))));
      }
    }]);

    return SimpleMap;
  }(_react.Component);

  SimpleMap.propTypes = {
    locationCenter: _propTypes2.default.shape({
      lat: _propTypes2.default.number,
      lng: _propTypes2.default.number
    }),
    title: _propTypes2.default.string,
    items: _propTypes2.default.arrayOf(_propTypes2.default.object),
    loaded: _propTypes2.default.bool,
    wrappedRef: _propTypes2.default.func,
    map: _propTypes2.default.shape(),
    google: _propTypes2.default.shape()
  };
  SimpleMap.defaultProps = {
    locationCenter: null,
    title: null,
    items: null,
    loaded: false,
    wrappedRef: null,
    map: null,
    google: null
  };
  exports.default = (0, _GoogleApiComponent2.default)({
    apiKey: 'AIzaSyBQRegyJHQpbPx9F3BYJOOGG1qryZkJfZ4'
  })(SimpleMap);
  /***/
},
/* 612 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(55);

  var _scriptCache = __webpack_require__(195);

  var _scriptCache2 = _interopRequireDefault(_scriptCache);

  var _googleApi = __webpack_require__(613);

  var _POIMapStyle = __webpack_require__(614);

  var _POIMapStyle2 = _interopRequireDefault(_POIMapStyle);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false
  };

  var wrapper = exports.wrapper = function wrapper(options) {
    return function (WrappedComponent) {
      var apiKey = options.apiKey;
      var libraries = options.libraries || ['places'];

      var Wrapper = function (_Component) {
        _inherits(Wrapper, _Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          _this.setRef = _this.setRef.bind(_this);
          _this.state = {
            loaded: false,
            map: null,
            google: null
          };
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            this.scriptCache = (0, _scriptCache2.default)({
              google: (0, _googleApi.googleApi)({
                apiKey: apiKey,
                libraries: libraries
              })
            });
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var _this2 = this;

            this.scriptCache.google.onLoad(function () {
              return _this2.setState({
                loaded: true,
                google: window.google
              });
            });
          }
        }, {
          key: 'setRef',
          value: function setRef(input) {
            if (this.state.loaded && input) {
              var google = this.state.google;
              var locationCenter = this.props.locationCenter;
              var center = new google.maps.LatLng(locationCenter.lat, locationCenter.lng);
              var mapConfig = Object.assign({}, defaultMapConfig, _extends({
                center: center,
                zoom: Number(this.props.zoom) || 15
              }, _POIMapStyle2.default));
              this.map = new google.maps.Map(input, mapConfig);
              this.setState({
                map: this.map
              });
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var props = _extends({}, this.props, {
              loaded: this.state.loaded,
              map: this.state.map,
              google: this.state.google
            });

            return this.state.loaded && _react2.default.createElement(WrappedComponent, _extends({}, props, {
              wrappedRef: this.setRef
            }));
          }
        }]);

        return Wrapper;
      }(_react.Component);

      Wrapper.propTypes = {
        zoom: _propTypes2.default.string,
        loaded: _propTypes2.default.bool,
        map: _propTypes2.default.element,
        google: _propTypes2.default.shape(),
        mapComponent: _propTypes2.default.element,
        locationCenter: _propTypes2.default.shape({
          lat: _propTypes2.default.number,
          lng: _propTypes2.default.number
        })
      };
      Wrapper.defaultProps = {
        zoom: null,
        loaded: null,
        map: null,
        google: null,
        mapComponent: null,
        locationCenter: {
          lat: null,
          lng: null
        }
      };
      return Wrapper;
    };
  };

  exports.default = wrapper;
  /***/
},
/* 613 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var googleApi = exports.googleApi = function googleApi(opts) {
    var options = opts || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || [];
    var client = options.client;
    var URL = 'https://maps.googleapis.com/maps/api/js';
    var channel = null;
    var language = null;
    var region = null;

    var url = function url() {
      var apiUrl = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        channel: channel,
        language: language,
        region: region
      };
      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');
      return apiUrl + '?' + paramStr;
    };

    return url();
  };

  exports.default = googleApi;
  /***/
},
/* 614 */

/***/
function (module, exports) {
  module.exports = {
    "styles": [{
      "elementType": "geometry",
      "stylers": [{
        "color": "#f5f5f5"
      }]
    }, {
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#616161"
      }]
    }, {
      "elementType": "labels.text.stroke",
      "stylers": [{
        "color": "#f5f5f5"
      }]
    }, {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#bdbdbd"
      }]
    }, {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{
        "color": "#eeeeee"
      }]
    }, {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#757575"
      }]
    }, {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{
        "color": "#e5e5e5"
      }]
    }, {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#757575"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [{
        "color": "#dadada"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#616161"
      }]
    }, {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [{
        "color": "#e5e5e5"
      }]
    }, {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [{
        "color": "#eeeeee"
      }]
    }, {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{
        "color": "#62b1ad"
      }]
    }, {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "transit.station.rail",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#979797"
      }, {
        "weight": "5.15"
      }]
    }, {
      "featureType": "transit.station.rail",
      "elementType": "geometry.stroke",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "transit.station.rail",
      "elementType": "labels.text",
      "stylers": [{
        "visibility": "on"
      }, {
        "color": "#979797"
      }, {
        "weight": "0.37"
      }]
    }, {
      "featureType": "transit.station.rail",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "on"
      }, {
        "weight": "0.37"
      }, {
        "hue": "#979797"
      }, {
        "saturation": "-100"
      }, {
        "lightness": "50"
      }]
    }]
    /***/

  };
},
/* 615 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(616);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./SimpleMap.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./SimpleMap.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 616 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-simplemap {\n  font-family: \"fs_elliotbold\";\n  margin: 0 auto 2em; }\n  @media all and (min-width: 768px) {\n    .gr-simplemap {\n      padding-bottom: 10px; } }\n  .gr-simplemap__map {\n    height: 450px;\n    position: relative; }\n  .gr-simplemap__title {\n    text-align: center;\n    padding: 15px;\n    margin: 0;\n    color: black;\n    font-size: 30px;\n    text-transform: uppercase; }\n", ""]); // exports

  /***/
},
/* 617 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _RentalProcessItem = __webpack_require__(618);

  var _RentalProcessItem2 = _interopRequireDefault(_RentalProcessItem);

  var _generic = __webpack_require__(10);

  __webpack_require__(622);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var RentalProcess = function RentalProcess(_ref) {
    var title = _ref.title,
        processes = _ref.processes;
    return _react2.default.createElement('div', {
      className: 'gr-rental-process'
    }, _react2.default.createElement('div', {
      className: 'gr-rental-process__container'
    }, title && _react2.default.createElement('h2', {
      className: 'gr-rental-process__title'
    }, title), _react2.default.createElement('div', {
      className: 'gr-rental-process__process-items'
    }, processes && processes.map(function (process, index) {
      return _react2.default.createElement(_RentalProcessItem2.default, {
        process: process,
        index: index,
        key: (0, _generic.randomStr)()
      });
    }))));
  };

  RentalProcess.propTypes = {
    title: _propTypes2.default.string,
    processes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      title: _propTypes2.default.string,
      text: _propTypes2.default.string,
      items: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }))
  };
  RentalProcess.defaultProps = {
    title: null,
    processes: null
  };
  exports.default = RentalProcess;
  /***/
},
/* 618 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _generic = __webpack_require__(10);

  var _slugify = __webpack_require__(619);

  var _List = __webpack_require__(61);

  __webpack_require__(620);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var RentalProcessItem = function RentalProcessItem(_ref) {
    var process = _ref.process,
        index = _ref.index;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('div', {
      className: 'gr-rental-process-item'
    }, process.title && _react2.default.createElement('h3', {
      className: 'gr-rental-process-item__title'
    }, index + 1, '. ', process.title), _react2.default.createElement('div', {
      className: 'gr-rental-process-item__content'
    }, process.text && _react2.default.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: process.text
      }
    }), _react2.default.createElement('div', {
      className: 'gr-rental-process-item__list-content'
    }, _react2.default.createElement('h4', {
      className: 'gr-rental-process-item__list-title'
    }, 'What you\'ll need'), process.items && _react2.default.createElement(_List.List, {
      isUnstyled: true,
      className: 'gr-rental-process-item__list'
    }, process.items.map(function (text) {
      return _react2.default.createElement('li', {
        key: (0, _slugify.slugify)(process.title) + '-' + (0, _generic.randomStr)(),
        className: 'gr-rental-process-item__list-item'
      }, text);
    }))))));
  };

  RentalProcessItem.propTypes = {
    process: _propTypes2.default.shape({
      title: _propTypes2.default.string,
      text: _propTypes2.default.string,
      items: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    index: _propTypes2.default.number
  };
  RentalProcessItem.defaultProps = {
    process: null,
    index: null
  };
  exports.default = RentalProcessItem;
  /***/
},
/* 619 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // Generate a random string.
  // Mainly used for generating unique ids

  var slugify = exports.slugify = function slugify(str) {
    return str.replace(/\W/g, '-').toLowerCase();
  };

  exports.default = slugify;
  /***/
},
/* 620 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(621);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!./RentalProcessItem.css", function () {
      var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!./RentalProcessItem.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 621 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-rental-process-item {\n  border-top: 1px solid #FFFFFF;\n  padding: 20px 0; }\n  .gr-rental-process-item:last-child {\n    margin-bottom: 0; }\n  .gr-rental-process-item a {\n    color: #FFFFFF;\n    text-decoration: underline; }\n    .gr-rental-process-item a:hover, .gr-rental-process-item a:focus {\n      color: #4E8382; }\n  @media all and (min-width: 768px) {\n    .gr-rental-process-item {\n      border: none; } }\n  .gr-rental-process-item__title {\n    font-size: 22px;\n    line-height: 24px;\n    margin-bottom: 15px;\n    font-weight: lighter; }\n    @media all and (min-width: 992px) {\n      .gr-rental-process-item__title {\n        padding: 0 15px; } }\n  @media all and (min-width: 992px) {\n    .gr-rental-process-item__content {\n      padding: 0 15px; } }\n  .gr-rental-process-item__list-content {\n    margin-top: 25px; }\n    @media all and (min-width: 768px) {\n      .gr-rental-process-item__list-content {\n        order: 2;\n        margin-top: 30px; } }\n  .gr-rental-process-item__list-title {\n    font-size: 17px;\n    margin-bottom: 20px;\n    font-weight: 200; }\n    @media all and (min-width: 768px) {\n      .gr-rental-process-item__list-title {\n        font-size: 18px; } }\n  .gr-rental-process-item__list-item {\n    position: relative;\n    padding-left: 30px;\n    margin-bottom: 10px; }\n    .gr-rental-process-item__list-item::before {\n      content: '\\E90A';\n      font-family: \"grainger-icons\" !important;\n      line-height: 1;\n      position: absolute;\n      left: 0;\n      top: 3px;\n      font-size: 20px; }\n", ""]); // exports

  /***/
},
/* 622 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(623);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./RentalProcess.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./RentalProcess.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 623 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-rental-process {\n  color: #FFFFFF;\n  max-width: 1920px;\n  margin: 30px auto; }\n  @media all and (min-width: 768px) {\n    .gr-rental-process {\n      margin: 40px auto;\n      padding: 0 15px; } }\n  @media all and (min-width: 992px) {\n    .gr-rental-process {\n      margin: 50px auto; } }\n  .gr-rental-process__container {\n    background-color: #62B1AD;\n    padding: 50px 0 20px; }\n    @media all and (min-width: 768px) {\n      .gr-rental-process__container {\n        padding: 50px 15px; } }\n  .gr-rental-process__title {\n    text-align: center;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    line-height: 32px;\n    font-size: 30px;\n    margin-bottom: 30px; }\n    @media all and (min-width: 768px) {\n      .gr-rental-process__title {\n        margin-bottom: 45px;\n        font-size: 38px;\n        line-height: 40px; } }\n  .gr-rental-process__process-items {\n    padding: 0 15px; }\n    @media all and (min-width: 768px) {\n      .gr-rental-process__process-items {\n        padding: 0;\n        display: flex;\n        flex-wrap: wrap; }\n        .gr-rental-process__process-items .gr-rental-process-item__info,\n        .gr-rental-process__process-items > .gr-rental-process-item__list-content,\n        .gr-rental-process__process-items .gr-rental-process-item {\n          flex: 0 0 33.33%;\n          max-width: 33.33%;\n          padding: 0 15px; } }\n", ""]); // exports

  /***/
},
/* 624 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactAnimateOnScroll = __webpack_require__(86);

  var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);

  __webpack_require__(625);

  var _generic = __webpack_require__(10);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var RentingProcess = function (_PureComponent) {
    _inherits(RentingProcess, _PureComponent);

    function RentingProcess(props) {
      _classCallCheck(this, RentingProcess);

      var _this = _possibleConstructorReturn(this, (RentingProcess.__proto__ || Object.getPrototypeOf(RentingProcess)).call(this, props));

      _this.state = {
        active: -1
      };
      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    _createClass(RentingProcess, [{
      key: 'toggle',
      value: function toggle(i) {
        if ((0, _generic.isMobileView)()) {
          this.setState({
            active: i === this.state.active ? null : i
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            title = _props.title,
            processes = _props.processes;
        return _react2.default.createElement('section', {
          className: 'gr-renting-process'
        }, _react2.default.createElement('div', {
          className: 'container'
        }, title && _react2.default.createElement(_reactAnimateOnScroll2.default, {
          animateOnce: true,
          animateIn: 'fadeInUp',
          animationInDelay: '1000'
        }, _react2.default.createElement('h2', {
          className: 'gr-renting-process__title'
        }, title)), _react2.default.createElement('div', {
          className: 'gr-renting-process__content'
        }, processes && processes.map(function (process, index) {
          return _react2.default.createElement('div', {
            key: (0, _generic.randomStr)(process.subTitle),
            className: 'gr-renting-process__item'
          }, _react2.default.createElement(_reactAnimateOnScroll2.default, {
            animateOnce: true,
            animateIn: 'fadeInUp',
            animationInDelay: '2000'
          }, process.icon && _react2.default.createElement('i', {
            className: 'gr-renting-process__icon icon-' + process.icon
          }), process.subTitle && _react2.default.createElement('h3', {
            /* eslint-disable-line jsx-a11y/no-noninteractive-element-interactions */
            className: 'gr-renting-process__title-item',
            onClick: function onClick() {
              return _this2.toggle(index);
            },
            onKeyUp: function onKeyUp() {}
          }, index + 1 + '. ' + process.subTitle, _react2.default.createElement('i', {
            className: 'gr-icon gr-renting-process__chevron icon-chevron-down\n                      ' + (_this2.state.active === index ? 'gr-renting-process__chevron--rotate' : '') + ' '
          }))), _react2.default.createElement('div', {
            className: 'gr-renting-process__subcontent\n                    ' + (_this2.state.active === index ? 'gr-renting-process__subcontent--active' : '')
          }, process.text && _react2.default.createElement(_reactAnimateOnScroll2.default, {
            animateOnce: true,
            animateIn: 'fadeInUp',
            animationInDelay: '3000'
          }, _react2.default.createElement('div', {
            className: 'gr-renting-process__text',
            dangerouslySetInnerHTML: {
              __html: process.text
            }
          })), _react2.default.createElement(_reactAnimateOnScroll2.default, {
            animateOnce: true,
            animateIn: 'fadeInUp',
            animationInDelay: '4000'
          }, _react2.default.createElement('h4', {
            className: 'gr-renting-process__need'
          }, 'What you\'ll need')), process.checkList && _react2.default.createElement(_reactAnimateOnScroll2.default, {
            animateOnce: true,
            animateIn: 'fadeInUp',
            animationInDelay: '5000'
          }, _react2.default.createElement('div', {
            className: 'gr-renting-process__list-item',
            dangerouslySetInnerHTML: {
              __html: process.checkList
            }
          }))));
        }))));
      }
    }]);

    return RentingProcess;
  }(_react.PureComponent);

  RentingProcess.propTypes = {
    title: _propTypes2.default.string,
    processes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      icon: _propTypes2.default.string,
      subTitle: _propTypes2.default.string,
      text: _propTypes2.default.string,
      checkList: _propTypes2.default.string
    }))
  };
  RentingProcess.defaultProps = {
    title: null,
    processes: null
  };
  exports.default = RentingProcess;
  /***/
},
/* 625 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(626);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./RentingProcess.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./RentingProcess.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 626 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-renting-process {\n  margin: 40px 0; }\n  @media all and (min-width: 768px) {\n    .gr-renting-process {\n      margin: 70px 0; } }\n  .gr-renting-process a {\n    color: #7C7C7B; }\n    .gr-renting-process a:hover, .gr-renting-process a:focus {\n      text-decoration: none; }\n  .gr-renting-process__title {\n    font-family: \"fs_elliotbold\";\n    font-size: 20px;\n    margin: 0 0 20px;\n    text-transform: uppercase;\n    color: #00627B;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__title {\n        font-size: 30px;\n        margin-bottom: 40px; } }\n  .gr-renting-process__title-item {\n    margin: 0;\n    color: #00627B;\n    text-transform: uppercase;\n    font-family: \"fs_elliotbold\";\n    font-size: 18px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__title-item {\n        font-size: 20px; } }\n  @media all and (min-width: 768px) {\n    .gr-renting-process__content {\n      display: flex; } }\n  .gr-renting-process__chevron {\n    color: #7C7C7B;\n    font-size: 40px;\n    transform: rotateX(0);\n    transition: transform .3s ease-in-out, color .2s linear; }\n    .gr-renting-process__chevron--rotate {\n      transform: rotateX(-180deg); }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__chevron {\n        display: none; } }\n  .gr-renting-process__subcontent {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__subcontent {\n        display: block; } }\n    .gr-renting-process__subcontent--active {\n      display: block; }\n  .gr-renting-process__icon {\n    display: none; }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__icon {\n        color: #00627B;\n        font-size: 45px;\n        display: block;\n        margin-bottom: 20px; } }\n  .gr-renting-process__item {\n    border-top: 1px solid #00627B;\n    padding: 20px 0; }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__item {\n        border-top: none;\n        padding: 0 20px;\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%; } }\n    @media all and (min-width: 992px) {\n      .gr-renting-process__item {\n        padding: 0 35px; } }\n  .gr-renting-process__need {\n    text-transform: uppercase;\n    color: #00627B;\n    font-size: 18px;\n    font-family: \"fs_elliotbold\";\n    margin: 20px 0; }\n    @media all and (min-width: 768px) {\n      .gr-renting-process__need {\n        font-size: 20px; } }\n  .gr-renting-process__list-item ul {\n    list-style: none;\n    padding: 0;\n    margin: 0; }\n  .gr-renting-process__list-item li, .gr-renting-process__list-item p {\n    position: relative;\n    margin-bottom: 10px;\n    padding-left: 30px; }\n    .gr-renting-process__list-item li::before, .gr-renting-process__list-item p::before {\n      content: '\\E90A';\n      font-family: \"grainger-icons\" !important;\n      line-height: 1;\n      position: absolute;\n      left: 0;\n      top: 3px;\n      font-size: 20px; }\n", ""]); // exports

  /***/
},
/* 627 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  __webpack_require__(628);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var WalkScore = function WalkScore(_ref) {
    var location = _ref.location,
        body = _ref.body,
        link = _ref.link;
    return _react2.default.createElement('div', {
      className: 'gr-walkscore'
    }, _react2.default.createElement('div', {
      className: 'gr-walkscore__container'
    }, _react2.default.createElement('div', {
      className: 'row gr-walkscore__row'
    }, _react2.default.createElement('div', {
      className: 'col col-12 col-md-5'
    }, link && link.text && link.url && _react2.default.createElement('h2', {
      className: 'gr-walkscore__title'
    }, _react2.default.createElement('a', {
      href: link.url,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: 'gr-walkscore__cta'
    }, 'Walk Score', _react2.default.createElement('sup', {
      className: 'gr-walkscore__sup'
    }, '\xAE'), ': ', link.text))), _react2.default.createElement('div', {
      className: 'col col-12 col-md-7'
    }, _react2.default.createElement('div', {
      className: 'gr-walkscore__clippath'
    }, _react2.default.createElement('div', {
      className: 'gr-walkscore__body'
    }, location && _react2.default.createElement('strong', {
      className: 'gr-walkscore__heading'
    }, location), body && _react2.default.createElement('p', {
      className: 'gr-walkscore__text'
    }, body)), _react2.default.createElement('svg', {
      className: 'gr-walkscore__svg'
    }, _react2.default.createElement('defs', null, _react2.default.createElement('clipPath', {
      id: 'gr-walkscore-clippath-small',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 0, 1 1, 0 .89'
    })), _react2.default.createElement('clipPath', {
      id: 'gr-walkscore-clippath-large',
      clipPathUnits: 'objectBoundingBox'
    }, _react2.default.createElement('polygon', {
      points: '0 0, 1 0, .96 1, .04 .84'
    }))), _react2.default.createElement('rect', {
      className: 'gr-walkscore__rect',
      width: '100%',
      height: '100%'
    })))))));
  };

  WalkScore.propTypes = {
    location: _propTypes2.default.string,
    link: _propTypes2.default.shape({
      url: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool,
      text: _propTypes2.default.string
    }),
    body: _propTypes2.default.string
  };
  WalkScore.defaultProps = {
    location: null,
    link: null,
    body: null
  };
  exports.default = WalkScore;
  /***/
},
/* 628 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(629);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./WalkScore.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./WalkScore.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 629 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-walkscore {\n  margin: 20px 0;\n  text-align: center;\n  overflow: hidden;\n  padding: 10px 0 10px 0; }\n  @media all and (min-width: 768px) {\n    .gr-walkscore {\n      margin: 40px 0;\n      position: relative;\n      padding: 30px 0 30px 0; } }\n  @media all and (min-width: 768px) {\n    .gr-walkscore__row {\n      align-items: center; } }\n  .gr-walkscore__clippath {\n    padding: 0 0 35px;\n    font-size: 16px;\n    color: #FFFFFF;\n    position: relative; }\n    @media all and (min-width: 768px) {\n      .gr-walkscore__clippath {\n        max-width: 500px;\n        padding: 60px 60px 60px; } }\n  .gr-walkscore__body {\n    max-width: 195px;\n    margin: 0 auto;\n    font-size: 17px; }\n    @media all and (min-width: 768px) {\n      .gr-walkscore__body {\n        max-width: none;\n        font-size: 18px; } }\n  .gr-walkscore__text {\n    margin-bottom: 0; }\n  @media all and (min-width: 768px) {\n    .gr-walkscore__title {\n      text-align: right; } }\n  .gr-walkscore__cta {\n    color: #62B1AD;\n    text-decoration: none;\n    position: relative;\n    font-size: 28px;\n    margin-bottom: 5px;\n    display: inline-block; }\n    .gr-walkscore__cta::after {\n      content: '';\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      height: 2px;\n      background-color: #62B1AD; }\n    @media all and (min-width: 768px) {\n      .gr-walkscore__cta {\n        font-size: 30px; } }\n    .gr-walkscore__cta:hover, .gr-walkscore__cta:focus {\n      color: #62B1AD;\n      text-decoration: none; }\n  .gr-walkscore__sup {\n    position: relative;\n    bottom: 18px;\n    font-size: 12px;\n    top: auto; }\n  .gr-walkscore__svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1; }\n  .gr-walkscore__rect {\n    fill: #62B1AD;\n    clip-path: url(\"#gr-walkscore-clippath-small\");\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0); }\n    @media all and (min-width: 768px) {\n      .gr-walkscore__rect {\n        clip-path: url(\"#gr-walkscore-clippath-large\"); } }\n", ""]); // exports

  /***/
},
/* 630 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _ImageTile = __webpack_require__(631);

  var _ImageTile2 = _interopRequireDefault(_ImageTile);

  var _generic = __webpack_require__(10);

  __webpack_require__(634);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ImageTiles = function ImageTiles(props) {
    if (!(props && props.images)) {
      return null;
    }

    return _react2.default.createElement('div', {
      className: 'gr-imagetiles container'
    }, _react2.default.createElement('div', {
      className: 'gr-imagetiles__first-row col-12'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.first_row[0], {
      key: (0, _generic.randomStr)()
    }))), _react2.default.createElement('div', {
      className: 'gr-imagetiles__second-row col-12'
    }, _react2.default.createElement('div', {
      className: 'left gr-imagetiles__verticals col-12 col-sm-6'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.second_left[0], {
      key: (0, _generic.randomStr)()
    })), _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.second_left[1], {
      key: (0, _generic.randomStr)()
    }))), _react2.default.createElement('div', {
      className: 'right col-12 col-sm-6'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.second_right[0], {
      key: (0, _generic.randomStr)()
    })))), _react2.default.createElement('div', {
      className: 'gr-imagetiles__third-row col-12'
    }, _react2.default.createElement('div', {
      className: 'left col-12 col-sm-8'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.third_left[0], {
      key: (0, _generic.randomStr)()
    }))), _react2.default.createElement('div', {
      className: 'right col-12 col-sm-4'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.third_right[0], {
      key: (0, _generic.randomStr)()
    })))), _react2.default.createElement('div', {
      className: 'gr-imagetiles__forth-row col-12'
    }, _react2.default.createElement('div', {
      className: 'left col-12 col-sm-6'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.forth_left[0], {
      key: (0, _generic.randomStr)()
    }))), _react2.default.createElement('div', {
      className: 'right col-12 col-sm-6'
    }, _react2.default.createElement(_ImageTile2.default, _extends({}, props.images.forth_right[0], {
      key: (0, _generic.randomStr)()
    })))));
  };

  ImageTiles.propTypes = {
    images: _propTypes2.default.objectOf(_propTypes2.default.shape)
  };
  ImageTiles.defaultProps = {
    images: null
  };
  exports.default = ImageTiles;
  /***/
},
/* 631 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactAnimateOnScroll = __webpack_require__(86);

  var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);

  var _Img = __webpack_require__(30);

  __webpack_require__(632);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ImageTile = function ImageTile(props) {
    var src = props.src,
        alt = props.alt,
        type = props.type,
        title = props.title,
        className = props.className;
    return _react2.default.createElement('div', {
      className: 'gr-imagetile ' + (className ? className : '')
    }, _react2.default.createElement(_reactAnimateOnScroll2.default, {
      animateOnce: true,
      animateIn: 'fadeIn'
    }, _react2.default.createElement(_Img.Img, {
      src: src,
      className: 'gr-imagetile__image'
    })));
  };
  /* eslint-disable */


  ImageTile.propTypes = {
    src: _propTypes2.default.string,
    type: _propTypes2.default.string,
    title: _propTypes2.default.string,
    alt: _propTypes2.default.string,
    className: _propTypes2.default.string
  };
  ImageTile.defaultProps = {
    src: null,
    type: null,
    title: null,
    alt: null,
    className: null
  };
  exports.default = ImageTile;
  /***/
},
/* 632 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(633);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!./ImageTile.css", function () {
      var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!./ImageTile.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 633 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-imagetile {\n  width: 100%;\n  margin: 0;\n  float: left;\n  box-sizing: border-box;\n  position: relative;\n  height: 100%;\n  padding: 1.2vw 1.2vw 0 0; }\n  @media all and (min-width: 576px) {\n    .gr-imagetile {\n      padding: 1.4vw 1.2vw 0 0; } }\n  .gr-imagetile__image {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    height: auto; }\n", ""]); // exports

  /***/
},
/* 634 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(635);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./ImageTiles.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./ImageTiles.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 635 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".gr-imagetiles::after {\n  display: block;\n  content: \"\";\n  clear: both; }\n\n.gr-imagetiles.container {\n  padding: 1em 0 0 1em;\n  margin: 0 auto;\n  max-width: 1920px; }\n\n.gr-imagetiles__first-row, .gr-imagetiles__second-row, .gr-imagetiles__third-row, .gr-imagetiles__forth-row {\n  width: 100%;\n  float: left;\n  box-sizing: border-box; }\n  .gr-imagetiles__first-row .left, .gr-imagetiles__first-row .right, .gr-imagetiles__second-row .left, .gr-imagetiles__second-row .right, .gr-imagetiles__third-row .left, .gr-imagetiles__third-row .right, .gr-imagetiles__forth-row .left, .gr-imagetiles__forth-row .right {\n    padding: 0; }\n", ""]); // exports

  /***/
},
/* 636 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _propTypes = __webpack_require__(2);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _react = __webpack_require__(1);

  var _react2 = _interopRequireDefault(_react);

  __webpack_require__(637);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Loading = function (_React$Component) {
    _inherits(Loading, _React$Component);

    function Loading(props) {
      _classCallCheck(this, Loading);

      var _this = _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).call(this, props));

      _this.state = {
        complete: false
      };
      return _this;
    }

    _createClass(Loading, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.waitForItems();
      }
    }, {
      key: 'waitForItems',
      value: function waitForItems() {
        var _this2 = this;

        var _props = this.props,
            loadingItems = _props.loadingItems,
            onResult = _props.onResult;
        Promise.all(loadingItems).then(function (r) {
          _this2.resolveLoading(r);
        }).catch(function (e) {
          _this2.setState({
            complete: true
          });

          onResult({
            status: false,
            data: e
          });
        });
      }
    }, {
      key: 'resolveLoading',
      value: function resolveLoading(result) {
        var _this3 = this;

        var _props2 = this.props,
            onResult = _props2.onResult,
            timeout = _props2.timeout,
            page = _props2.page;
        var hasViewed = localStorage.getItem('hasViewed-' + page);
        var errorTimeout = setTimeout(function () {
          return onResult({
            status: false,
            data: result
          });
        }, timeout);
        var startTimeout = setTimeout(function () {
          return _this3.setState({
            startLoading: true
          });
        }, 200);
        var time = 100;

        if (!hasViewed) {
          localStorage.setItem('hasViewed-' + page, true);
          time = 3000;
        }

        setTimeout(function () {
          _this3.setState({
            complete: true
          });

          onResult({
            status: true,
            data: result
          });
          clearTimeout(startTimeout);
          clearTimeout(errorTimeout);
        }, time);
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            complete = _state.complete,
            startLoading = _state.startLoading;
        return _react2.default.createElement('div', {
          className: 'loading ' + (complete ? 'loading--complete' : '') + ' ' + (startLoading ? 'loading--bg-offw' : '')
        }, _react2.default.createElement('div', {
          className: 'loading__container'
        }, startLoading && _react2.default.createElement('div', {
          className: 'loading__wrapper'
        }, _react2.default.createElement('div', {
          className: 'loading__wrapper-shapes'
        }, _react2.default.createElement('svg', {
          width: '47px',
          height: '66px',
          viewBox: '0 0 47 66',
          version: '1.1',
          className: 'loading__svg--green'
        }, _react2.default.createElement('g', {
          stroke: 'none',
          strokeWidth: '1',
          fill: 'none',
          fillRule: 'evenodd'
        }, _react2.default.createElement('g', {
          transform: 'translate(-202.000000, -251.000000)',
          fill: '#62B1AD',
          fillRule: 'nonzero'
        }, _react2.default.createElement('g', {
          transform: 'translate(151.000000, 250.000000)'
        }, _react2.default.createElement('polygon', {
          points: '51 67 51 1 98 28.84375 98 67'
        }))))), _react2.default.createElement('svg', {
          width: '47px',
          height: '66px',
          viewBox: '0 0 47 66',
          version: '1.1',
          className: 'loading__svg--grey'
        }, _react2.default.createElement('g', {
          stroke: 'none',
          strokeWidth: '1',
          fill: 'none',
          fillRule: 'evenodd'
        }, _react2.default.createElement('g', {
          transform: 'translate(-151.000000, -250.000000)',
          fill: '#7C7B7B',
          fillRule: 'nonzero'
        }, _react2.default.createElement('g', {
          transform: 'translate(151.000000, 250.000000)'
        }, _react2.default.createElement('polygon', {
          transform: 'translate(23.500000, 33.000000) scale(-1, 1) translate(-23.500000, -33.000000) ',
          points: '0 66 0 0 47 27.84375 47 66'
        })))))), _react2.default.createElement('div', {
          className: 'loading__wrapper'
        }, _react2.default.createElement('svg', {
          width: '78px',
          height: '12px',
          viewBox: '0 0 78 12',
          version: '1.1',
          className: 'loading__grainger'
        }, _react2.default.createElement('g', {
          stroke: 'none',
          strokeWidth: '1',
          fill: 'none',
          fillRule: 'evenodd'
        }, _react2.default.createElement('g', {
          transform: 'translate(-150.000000, -343.000000)',
          fill: '#7C7B7B'
        }, _react2.default.createElement('path', {
          d: 'M159.024,348.6 L159.024,353.288 C157.84,353.832 156.624,354.136 155.392, 354.136 C152.208,354.136 150,351.832 150,348.568 C150,345.304 152.144, 343 155.264,343 C156.464,343 157.68,343.368 158.88,344.04 L158.56,344.616 C157.456, 343.992 156.384,343.656 155.344,343.656 C152.64,343.656 150.768,345.672 150.768, 348.568 C150.768,351.448 152.688,353.48 155.44,353.48 C156.432,353.48 157.408,353.272 158.288, 352.856 L158.288,349.224 L155.392,349.224 L155.392,348.6 L159.024,348.6 Z M161.968, 353.944 L161.968,343.192 L165.808,343.192 C167.76,343.192 169.136,344.488 169.136, 346.312 C169.136,347.976 168,349.192 166.288,349.352 L169.552,353.944 L168.656, 353.944 L165.488,349.432 L162.736,349.432 L162.736,353.944 L161.968,353.944 Z M162.736, 343.848 L162.736,348.792 L165.712,348.792 C167.264,348.792 168.368,347.8 168.368, 346.312 C168.368,344.856 167.264,343.848 165.712,343.848 L162.736,343.848 Z M171.024, 353.944 L175.472,343.192 L176.224,343.192 L180.672,353.944 L179.856,353.944 L178.544, 350.744 L173.152,350.744 L171.84,353.944 L171.024,353.944 Z M175.856,344.136 L173.392, 350.12 L178.304,350.12 L175.856,344.136 Z M182.912,353.944 L182.912,343.192 L183.696, 343.192 L183.696,353.944 L182.912,353.944 Z M187.216,353.944 L187.216,343.192 L188, 343.192 L195.104,352.84 L195.104,343.192 L195.84,343.192 L195.84,353.944 L195.056, 353.944 L187.952,344.296 L187.952,353.944 L187.216,353.944 Z M207.536,348.6 L207.536, 353.288 C206.352,353.832 205.136,354.136 203.904,354.136 C200.72,354.136 198.512, 351.832 198.512,348.568 C198.512,345.304 200.656,343 203.776,343 C204.976,343 206.192, 343.368 207.392,344.04 L207.072,344.616 C205.968,343.992 204.896,343.656 203.856, 343.656 C201.152,343.656 199.28,345.672 199.28,348.568 C199.28,351.448 201.2, 353.48 203.952,353.48 C204.944,353.48 205.92,353.272 206.8,352.856 L206.8,349.224 L203.904, 349.224 L203.904,348.6 L207.536,348.6 Z M210.48,353.944 L210.48,343.192 L217.056, 343.192 L217.056,343.832 L211.264,343.832 L211.264,348.12 L216.544,348.12 L216.544, 348.76 L211.264,348.76 L211.264,353.304 L217.312,353.304 L217.312,353.944 L210.48, 353.944 Z M220,353.944 L220,343.192 L223.84,343.192 C225.792,343.192 227.168, 344.488 227.168,346.312 C227.168,347.976 226.032,349.192 224.32,349.352 L227.584, 353.944 L226.688,353.944 L223.52,349.432 L220.768,349.432 L220.768, 353.944 L220,353.944 Z M220.768,343.848 L220.768,348.792 L223.744, 348.792 C225.296,348.792 226.4,347.8 226.4,346.312 C226.4,344.856 225.296, 343.848 223.744,343.848 L220.768,343.848 Z',
          id: 'GRAINGER'
        })))), _react2.default.createElement('svg', {
          width: '52px',
          height: '1px',
          viewBox: '0 0 52 1',
          version: '1.1',
          className: 'loading__grainger-underline'
        }, _react2.default.createElement('g', {
          stroke: 'none',
          strokeWidth: '1',
          fill: 'none',
          fillRule: 'evenodd'
        }, _react2.default.createElement('g', {
          transform: 'translate(-163.000000, -362.000000)',
          fillRule: 'nonzero',
          stroke: '#979797'
        }, _react2.default.createElement('path', {
          d: 'M163,362.5 L215,362.5'
        }))))))));
      }
    }]);

    return Loading;
  }(_react2.default.Component);

  Loading.propTypes = {
    onResult: _propTypes2.default.func,
    loadingItems: _propTypes2.default.arrayOf(_propTypes2.default.object),
    timeout: _propTypes2.default.number,
    page: _propTypes2.default.string
  };
  Loading.defaultProps = {
    onResult: function onResult() {},
    loadingItems: null,
    timeout: 0,
    page: ''
  };
  exports.default = Loading;
  /***/
},
/* 637 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(638);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./Loading.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./Loading.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 638 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, ".loading {\n  opacity: 1;\n  background-color: #FFFFFF;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9; }\n  .loading--complete {\n    opacity: 0;\n    animation: complete 0.05s ease forwards; }\n  .loading--bg-offw {\n    background-color: #F0EFEC; }\n  .loading__container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  .loading__wrapper {\n    position: relative; }\n  .loading__wrapper-shapes {\n    width: 47px;\n    height: 79px;\n    margin: auto;\n    position: relative; }\n  .loading__grainger {\n    animation: textGrainger 2s ease infinite; }\n  .loading__grainger-underline {\n    display: block;\n    margin: 5px auto;\n    animation: line 2s ease infinite; }\n  .loading__svg--green {\n    position: absolute;\n    animation: halfHouseGreen 2s ease infinite; }\n  .loading__svg--grey {\n    animation: halfHouseGrey 2s ease infinite;\n    position: absolute; }\n\n.loading-incomplete {\n  display: none; }\n\n@keyframes halfHouseGreen {\n  0% {\n    left: 52%;\n    top: -30%;\n    opacity: 1; }\n  25% {\n    left: 52%;\n    top: 0;\n    opacity: 1; }\n  50% {\n    left: 0;\n    opacity: 1; }\n  90% {\n    left: 0;\n    opacity: 0; }\n  100% {\n    opacity: 0; } }\n\n@keyframes halfHouseGrey {\n  0% {\n    left: -52%;\n    top: 30%;\n    opacity: 1; }\n  25% {\n    left: -52%;\n    top: 0;\n    opacity: 1; }\n  50% {\n    left: 0;\n    opacity: 1; }\n  75% {\n    left: 0;\n    opacity: 1; }\n  85% {\n    left: 0;\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes textGrainger {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 0.5; }\n  50% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  85% {\n    left: 0;\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes line {\n  0% {\n    transform: scaleX(0);\n    opacity: .02; }\n  50% {\n    transform: scaleX(1.05);\n    opacity: 1; }\n  75% {\n    transform: scaleX(1.05);\n    opacity: 1; }\n  85% {\n    transform: scaleX(1.05);\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes complete {\n  0% {\n    opacity: 1; }\n  100% {\n    z-index: -1;\n    opacity: 0;\n    display: none; } }\n", ""]); // exports

  /***/
},
/* 639 */

/***/
function (module, exports, __webpack_require__) {
  var content = __webpack_require__(640);

  if (typeof content === 'string') content = [[module.i, content, '']];
  var transform;
  var insertInto;
  var options = {
    "insertAt": {
      "before": "title"
    },
    "hmr": true
  };
  options.transform = transform;
  options.insertInto = undefined;

  var update = __webpack_require__(4)(content, options);

  if (content.locals) module.exports = content.locals;

  if (false) {
    module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-1!./global.css", function () {
      var newContent = require("!!../../../node_modules/css-loader/index.js??ref--1-1!./global.css");

      if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];

      var locals = function (a, b) {
        var key,
            idx = 0;

        for (key in a) {
          if (!b || a[key] !== b[key]) return false;
          idx++;
        }

        for (key in b) {
          idx--;
        }

        return idx === 0;
      }(content.locals, newContent.locals);

      if (!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');
      update(newContent);
    });
    module.hot.dispose(function () {
      update();
    });
  }
  /***/

},
/* 640 */

/***/
function (module, exports, __webpack_require__) {
  var escape = __webpack_require__(641);

  exports = module.exports = __webpack_require__(3)(false); // imports

  exports.i(__webpack_require__(642), "");
  exports.push([module.i, "@import url(https://s3-eu-west-1.amazonaws.com/pexprodthemes/themes/themes_default/widgets/styles/date-picker.css);", ""]); // module

  exports.push([module.i, "@charset \"UTF-8\";\n/*!\n * Bootstrap Grid v4.1.1 (https://getbootstrap.com/)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n@-ms-viewport {\n  width: device-width; }\n\nhtml {\n  box-sizing: border-box;\n  -ms-overflow-style: scrollbar; }\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit; }\n\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n  @media (min-width: 576px) {\n    .container {\n      max-width: 540px; } }\n  @media (min-width: 768px) {\n    .container {\n      max-width: 720px; } }\n  @media (min-width: 992px) {\n    .container {\n      max-width: 960px; } }\n  @media (min-width: 1200px) {\n    .container {\n      max-width: 1140px; } }\n\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px; }\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%; }\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none; }\n\n.col-1 {\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%; }\n\n.col-2 {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.col-4 {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.col-5 {\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%; }\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.col-7 {\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%; }\n\n.col-8 {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%; }\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%; }\n\n.col-10 {\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%; }\n\n.col-11 {\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%; }\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.order-first {\n  order: -1; }\n\n.order-last {\n  order: 13; }\n\n.order-0 {\n  order: 0; }\n\n.order-1 {\n  order: 1; }\n\n.order-2 {\n  order: 2; }\n\n.order-3 {\n  order: 3; }\n\n.order-4 {\n  order: 4; }\n\n.order-5 {\n  order: 5; }\n\n.order-6 {\n  order: 6; }\n\n.order-7 {\n  order: 7; }\n\n.order-8 {\n  order: 8; }\n\n.order-9 {\n  order: 9; }\n\n.order-10 {\n  order: 10; }\n\n.order-11 {\n  order: 11; }\n\n.order-12 {\n  order: 12; }\n\n.offset-1 {\n  margin-left: 8.33333%; }\n\n.offset-2 {\n  margin-left: 16.66667%; }\n\n.offset-3 {\n  margin-left: 25%; }\n\n.offset-4 {\n  margin-left: 33.33333%; }\n\n.offset-5 {\n  margin-left: 41.66667%; }\n\n.offset-6 {\n  margin-left: 50%; }\n\n.offset-7 {\n  margin-left: 58.33333%; }\n\n.offset-8 {\n  margin-left: 66.66667%; }\n\n.offset-9 {\n  margin-left: 75%; }\n\n.offset-10 {\n  margin-left: 83.33333%; }\n\n.offset-11 {\n  margin-left: 91.66667%; }\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n  .col-sm-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-sm-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-sm-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-sm-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-sm-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-sm-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-sm-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-sm-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-sm-first {\n    order: -1; }\n  .order-sm-last {\n    order: 13; }\n  .order-sm-0 {\n    order: 0; }\n  .order-sm-1 {\n    order: 1; }\n  .order-sm-2 {\n    order: 2; }\n  .order-sm-3 {\n    order: 3; }\n  .order-sm-4 {\n    order: 4; }\n  .order-sm-5 {\n    order: 5; }\n  .order-sm-6 {\n    order: 6; }\n  .order-sm-7 {\n    order: 7; }\n  .order-sm-8 {\n    order: 8; }\n  .order-sm-9 {\n    order: 9; }\n  .order-sm-10 {\n    order: 10; }\n  .order-sm-11 {\n    order: 11; }\n  .order-sm-12 {\n    order: 12; }\n  .offset-sm-0 {\n    margin-left: 0; }\n  .offset-sm-1 {\n    margin-left: 8.33333%; }\n  .offset-sm-2 {\n    margin-left: 16.66667%; }\n  .offset-sm-3 {\n    margin-left: 25%; }\n  .offset-sm-4 {\n    margin-left: 33.33333%; }\n  .offset-sm-5 {\n    margin-left: 41.66667%; }\n  .offset-sm-6 {\n    margin-left: 50%; }\n  .offset-sm-7 {\n    margin-left: 58.33333%; }\n  .offset-sm-8 {\n    margin-left: 66.66667%; }\n  .offset-sm-9 {\n    margin-left: 75%; }\n  .offset-sm-10 {\n    margin-left: 83.33333%; }\n  .offset-sm-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n  .col-md-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-md-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-md-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-md-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-md-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-md-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-md-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-md-first {\n    order: -1; }\n  .order-md-last {\n    order: 13; }\n  .order-md-0 {\n    order: 0; }\n  .order-md-1 {\n    order: 1; }\n  .order-md-2 {\n    order: 2; }\n  .order-md-3 {\n    order: 3; }\n  .order-md-4 {\n    order: 4; }\n  .order-md-5 {\n    order: 5; }\n  .order-md-6 {\n    order: 6; }\n  .order-md-7 {\n    order: 7; }\n  .order-md-8 {\n    order: 8; }\n  .order-md-9 {\n    order: 9; }\n  .order-md-10 {\n    order: 10; }\n  .order-md-11 {\n    order: 11; }\n  .order-md-12 {\n    order: 12; }\n  .offset-md-0 {\n    margin-left: 0; }\n  .offset-md-1 {\n    margin-left: 8.33333%; }\n  .offset-md-2 {\n    margin-left: 16.66667%; }\n  .offset-md-3 {\n    margin-left: 25%; }\n  .offset-md-4 {\n    margin-left: 33.33333%; }\n  .offset-md-5 {\n    margin-left: 41.66667%; }\n  .offset-md-6 {\n    margin-left: 50%; }\n  .offset-md-7 {\n    margin-left: 58.33333%; }\n  .offset-md-8 {\n    margin-left: 66.66667%; }\n  .offset-md-9 {\n    margin-left: 75%; }\n  .offset-md-10 {\n    margin-left: 83.33333%; }\n  .offset-md-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n  .col-lg-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-lg-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-lg-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-lg-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-lg-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-lg-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-lg-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-lg-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-lg-first {\n    order: -1; }\n  .order-lg-last {\n    order: 13; }\n  .order-lg-0 {\n    order: 0; }\n  .order-lg-1 {\n    order: 1; }\n  .order-lg-2 {\n    order: 2; }\n  .order-lg-3 {\n    order: 3; }\n  .order-lg-4 {\n    order: 4; }\n  .order-lg-5 {\n    order: 5; }\n  .order-lg-6 {\n    order: 6; }\n  .order-lg-7 {\n    order: 7; }\n  .order-lg-8 {\n    order: 8; }\n  .order-lg-9 {\n    order: 9; }\n  .order-lg-10 {\n    order: 10; }\n  .order-lg-11 {\n    order: 11; }\n  .order-lg-12 {\n    order: 12; }\n  .offset-lg-0 {\n    margin-left: 0; }\n  .offset-lg-1 {\n    margin-left: 8.33333%; }\n  .offset-lg-2 {\n    margin-left: 16.66667%; }\n  .offset-lg-3 {\n    margin-left: 25%; }\n  .offset-lg-4 {\n    margin-left: 33.33333%; }\n  .offset-lg-5 {\n    margin-left: 41.66667%; }\n  .offset-lg-6 {\n    margin-left: 50%; }\n  .offset-lg-7 {\n    margin-left: 58.33333%; }\n  .offset-lg-8 {\n    margin-left: 66.66667%; }\n  .offset-lg-9 {\n    margin-left: 75%; }\n  .offset-lg-10 {\n    margin-left: 83.33333%; }\n  .offset-lg-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n  .col-xl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-xl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-xl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-xl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-xl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-xl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-xl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-xl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-xl-first {\n    order: -1; }\n  .order-xl-last {\n    order: 13; }\n  .order-xl-0 {\n    order: 0; }\n  .order-xl-1 {\n    order: 1; }\n  .order-xl-2 {\n    order: 2; }\n  .order-xl-3 {\n    order: 3; }\n  .order-xl-4 {\n    order: 4; }\n  .order-xl-5 {\n    order: 5; }\n  .order-xl-6 {\n    order: 6; }\n  .order-xl-7 {\n    order: 7; }\n  .order-xl-8 {\n    order: 8; }\n  .order-xl-9 {\n    order: 9; }\n  .order-xl-10 {\n    order: 10; }\n  .order-xl-11 {\n    order: 11; }\n  .order-xl-12 {\n    order: 12; }\n  .offset-xl-0 {\n    margin-left: 0; }\n  .offset-xl-1 {\n    margin-left: 8.33333%; }\n  .offset-xl-2 {\n    margin-left: 16.66667%; }\n  .offset-xl-3 {\n    margin-left: 25%; }\n  .offset-xl-4 {\n    margin-left: 33.33333%; }\n  .offset-xl-5 {\n    margin-left: 41.66667%; }\n  .offset-xl-6 {\n    margin-left: 50%; }\n  .offset-xl-7 {\n    margin-left: 58.33333%; }\n  .offset-xl-8 {\n    margin-left: 66.66667%; }\n  .offset-xl-9 {\n    margin-left: 75%; }\n  .offset-xl-10 {\n    margin-left: 83.33333%; }\n  .offset-xl-11 {\n    margin-left: 91.66667%; } }\n\n.d-none {\n  display: none !important; }\n\n.d-inline {\n  display: inline !important; }\n\n.d-inline-block {\n  display: inline-block !important; }\n\n.d-block {\n  display: block !important; }\n\n.d-table {\n  display: table !important; }\n\n.d-table-row {\n  display: table-row !important; }\n\n.d-table-cell {\n  display: table-cell !important; }\n\n.d-flex {\n  display: flex !important; }\n\n.d-inline-flex {\n  display: inline-flex !important; }\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important; }\n  .d-sm-inline {\n    display: inline !important; }\n  .d-sm-inline-block {\n    display: inline-block !important; }\n  .d-sm-block {\n    display: block !important; }\n  .d-sm-table {\n    display: table !important; }\n  .d-sm-table-row {\n    display: table-row !important; }\n  .d-sm-table-cell {\n    display: table-cell !important; }\n  .d-sm-flex {\n    display: flex !important; }\n  .d-sm-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important; }\n  .d-md-inline {\n    display: inline !important; }\n  .d-md-inline-block {\n    display: inline-block !important; }\n  .d-md-block {\n    display: block !important; }\n  .d-md-table {\n    display: table !important; }\n  .d-md-table-row {\n    display: table-row !important; }\n  .d-md-table-cell {\n    display: table-cell !important; }\n  .d-md-flex {\n    display: flex !important; }\n  .d-md-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important; }\n  .d-lg-inline {\n    display: inline !important; }\n  .d-lg-inline-block {\n    display: inline-block !important; }\n  .d-lg-block {\n    display: block !important; }\n  .d-lg-table {\n    display: table !important; }\n  .d-lg-table-row {\n    display: table-row !important; }\n  .d-lg-table-cell {\n    display: table-cell !important; }\n  .d-lg-flex {\n    display: flex !important; }\n  .d-lg-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important; }\n  .d-xl-inline {\n    display: inline !important; }\n  .d-xl-inline-block {\n    display: inline-block !important; }\n  .d-xl-block {\n    display: block !important; }\n  .d-xl-table {\n    display: table !important; }\n  .d-xl-table-row {\n    display: table-row !important; }\n  .d-xl-table-cell {\n    display: table-cell !important; }\n  .d-xl-flex {\n    display: flex !important; }\n  .d-xl-inline-flex {\n    display: inline-flex !important; } }\n\n@media print {\n  .d-print-none {\n    display: none !important; }\n  .d-print-inline {\n    display: inline !important; }\n  .d-print-inline-block {\n    display: inline-block !important; }\n  .d-print-block {\n    display: block !important; }\n  .d-print-table {\n    display: table !important; }\n  .d-print-table-row {\n    display: table-row !important; }\n  .d-print-table-cell {\n    display: table-cell !important; }\n  .d-print-flex {\n    display: flex !important; }\n  .d-print-inline-flex {\n    display: inline-flex !important; } }\n\n.flex-row {\n  flex-direction: row !important; }\n\n.flex-column {\n  flex-direction: column !important; }\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important; }\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important; }\n\n.flex-wrap {\n  flex-wrap: wrap !important; }\n\n.flex-nowrap {\n  flex-wrap: nowrap !important; }\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important; }\n\n.flex-fill {\n  flex: 1 1 auto !important; }\n\n.flex-grow-0 {\n  flex-grow: 0 !important; }\n\n.flex-grow-1 {\n  flex-grow: 1 !important; }\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important; }\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important; }\n\n.justify-content-start {\n  justify-content: flex-start !important; }\n\n.justify-content-end {\n  justify-content: flex-end !important; }\n\n.justify-content-center {\n  justify-content: center !important; }\n\n.justify-content-between {\n  justify-content: space-between !important; }\n\n.justify-content-around {\n  justify-content: space-around !important; }\n\n.align-items-start {\n  align-items: flex-start !important; }\n\n.align-items-end {\n  align-items: flex-end !important; }\n\n.align-items-center {\n  align-items: center !important; }\n\n.align-items-baseline {\n  align-items: baseline !important; }\n\n.align-items-stretch {\n  align-items: stretch !important; }\n\n.align-content-start {\n  align-content: flex-start !important; }\n\n.align-content-end {\n  align-content: flex-end !important; }\n\n.align-content-center {\n  align-content: center !important; }\n\n.align-content-between {\n  align-content: space-between !important; }\n\n.align-content-around {\n  align-content: space-around !important; }\n\n.align-content-stretch {\n  align-content: stretch !important; }\n\n.align-self-auto {\n  align-self: auto !important; }\n\n.align-self-start {\n  align-self: flex-start !important; }\n\n.align-self-end {\n  align-self: flex-end !important; }\n\n.align-self-center {\n  align-self: center !important; }\n\n.align-self-baseline {\n  align-self: baseline !important; }\n\n.align-self-stretch {\n  align-self: stretch !important; }\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important; }\n  .flex-sm-column {\n    flex-direction: column !important; }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important; }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-sm-fill {\n    flex: 1 1 auto !important; }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-sm-start {\n    justify-content: flex-start !important; }\n  .justify-content-sm-end {\n    justify-content: flex-end !important; }\n  .justify-content-sm-center {\n    justify-content: center !important; }\n  .justify-content-sm-between {\n    justify-content: space-between !important; }\n  .justify-content-sm-around {\n    justify-content: space-around !important; }\n  .align-items-sm-start {\n    align-items: flex-start !important; }\n  .align-items-sm-end {\n    align-items: flex-end !important; }\n  .align-items-sm-center {\n    align-items: center !important; }\n  .align-items-sm-baseline {\n    align-items: baseline !important; }\n  .align-items-sm-stretch {\n    align-items: stretch !important; }\n  .align-content-sm-start {\n    align-content: flex-start !important; }\n  .align-content-sm-end {\n    align-content: flex-end !important; }\n  .align-content-sm-center {\n    align-content: center !important; }\n  .align-content-sm-between {\n    align-content: space-between !important; }\n  .align-content-sm-around {\n    align-content: space-around !important; }\n  .align-content-sm-stretch {\n    align-content: stretch !important; }\n  .align-self-sm-auto {\n    align-self: auto !important; }\n  .align-self-sm-start {\n    align-self: flex-start !important; }\n  .align-self-sm-end {\n    align-self: flex-end !important; }\n  .align-self-sm-center {\n    align-self: center !important; }\n  .align-self-sm-baseline {\n    align-self: baseline !important; }\n  .align-self-sm-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important; }\n  .flex-md-column {\n    flex-direction: column !important; }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-md-wrap {\n    flex-wrap: wrap !important; }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-md-fill {\n    flex: 1 1 auto !important; }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-md-start {\n    justify-content: flex-start !important; }\n  .justify-content-md-end {\n    justify-content: flex-end !important; }\n  .justify-content-md-center {\n    justify-content: center !important; }\n  .justify-content-md-between {\n    justify-content: space-between !important; }\n  .justify-content-md-around {\n    justify-content: space-around !important; }\n  .align-items-md-start {\n    align-items: flex-start !important; }\n  .align-items-md-end {\n    align-items: flex-end !important; }\n  .align-items-md-center {\n    align-items: center !important; }\n  .align-items-md-baseline {\n    align-items: baseline !important; }\n  .align-items-md-stretch {\n    align-items: stretch !important; }\n  .align-content-md-start {\n    align-content: flex-start !important; }\n  .align-content-md-end {\n    align-content: flex-end !important; }\n  .align-content-md-center {\n    align-content: center !important; }\n  .align-content-md-between {\n    align-content: space-between !important; }\n  .align-content-md-around {\n    align-content: space-around !important; }\n  .align-content-md-stretch {\n    align-content: stretch !important; }\n  .align-self-md-auto {\n    align-self: auto !important; }\n  .align-self-md-start {\n    align-self: flex-start !important; }\n  .align-self-md-end {\n    align-self: flex-end !important; }\n  .align-self-md-center {\n    align-self: center !important; }\n  .align-self-md-baseline {\n    align-self: baseline !important; }\n  .align-self-md-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important; }\n  .flex-lg-column {\n    flex-direction: column !important; }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important; }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-lg-fill {\n    flex: 1 1 auto !important; }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-lg-start {\n    justify-content: flex-start !important; }\n  .justify-content-lg-end {\n    justify-content: flex-end !important; }\n  .justify-content-lg-center {\n    justify-content: center !important; }\n  .justify-content-lg-between {\n    justify-content: space-between !important; }\n  .justify-content-lg-around {\n    justify-content: space-around !important; }\n  .align-items-lg-start {\n    align-items: flex-start !important; }\n  .align-items-lg-end {\n    align-items: flex-end !important; }\n  .align-items-lg-center {\n    align-items: center !important; }\n  .align-items-lg-baseline {\n    align-items: baseline !important; }\n  .align-items-lg-stretch {\n    align-items: stretch !important; }\n  .align-content-lg-start {\n    align-content: flex-start !important; }\n  .align-content-lg-end {\n    align-content: flex-end !important; }\n  .align-content-lg-center {\n    align-content: center !important; }\n  .align-content-lg-between {\n    align-content: space-between !important; }\n  .align-content-lg-around {\n    align-content: space-around !important; }\n  .align-content-lg-stretch {\n    align-content: stretch !important; }\n  .align-self-lg-auto {\n    align-self: auto !important; }\n  .align-self-lg-start {\n    align-self: flex-start !important; }\n  .align-self-lg-end {\n    align-self: flex-end !important; }\n  .align-self-lg-center {\n    align-self: center !important; }\n  .align-self-lg-baseline {\n    align-self: baseline !important; }\n  .align-self-lg-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important; }\n  .flex-xl-column {\n    flex-direction: column !important; }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important; }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-xl-fill {\n    flex: 1 1 auto !important; }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-xl-start {\n    justify-content: flex-start !important; }\n  .justify-content-xl-end {\n    justify-content: flex-end !important; }\n  .justify-content-xl-center {\n    justify-content: center !important; }\n  .justify-content-xl-between {\n    justify-content: space-between !important; }\n  .justify-content-xl-around {\n    justify-content: space-around !important; }\n  .align-items-xl-start {\n    align-items: flex-start !important; }\n  .align-items-xl-end {\n    align-items: flex-end !important; }\n  .align-items-xl-center {\n    align-items: center !important; }\n  .align-items-xl-baseline {\n    align-items: baseline !important; }\n  .align-items-xl-stretch {\n    align-items: stretch !important; }\n  .align-content-xl-start {\n    align-content: flex-start !important; }\n  .align-content-xl-end {\n    align-content: flex-end !important; }\n  .align-content-xl-center {\n    align-content: center !important; }\n  .align-content-xl-between {\n    align-content: space-between !important; }\n  .align-content-xl-around {\n    align-content: space-around !important; }\n  .align-content-xl-stretch {\n    align-content: stretch !important; }\n  .align-self-xl-auto {\n    align-self: auto !important; }\n  .align-self-xl-start {\n    align-self: flex-start !important; }\n  .align-self-xl-end {\n    align-self: flex-end !important; }\n  .align-self-xl-center {\n    align-self: center !important; }\n  .align-self-xl-baseline {\n    align-self: baseline !important; }\n  .align-self-xl-stretch {\n    align-self: stretch !important; } }\n\n.icon-launch-360:before {\n  content: \"\\E918\"; }\n\n.icon-launch-floorplan:before {\n  content: \"\\E919\"; }\n\n.icon-launch-modal:before {\n  content: \"\\E900\"; }\n\n.icon-leave-site:before {\n  content: \"\\E911\"; }\n\n.icon-repairs:before {\n  content: \"\\E869\"; }\n\n.icon-clothes-hanger:before {\n  content: \"\\E910\"; }\n\n.icon-wardrobe:before {\n  content: \"\\E90C\"; }\n\n.icon-balcony:before {\n  content: \"\\E90D\"; }\n\n.icon-pound-strike:before {\n  content: \"\\E90F\"; }\n\n.icon-room-service:before {\n  content: \"\\EB49\"; }\n\n.icon-dining:before {\n  content: \"\\E91C\"; }\n\n.icon-money:before {\n  content: \"\\E91D\"; }\n\n.icon-pet:before {\n  content: \"\\E91F\"; }\n\n.icon-calandar:before {\n  content: \"\\E90E\"; }\n\n.icon-emergency:before {\n  content: \"\\E912\"; }\n\n.icon-fridge:before {\n  content: \"\\E913\"; }\n\n.icon-gym:before {\n  content: \"\\E914\"; }\n\n.icon-laptop:before {\n  content: \"\\E916\"; }\n\n.icon-lock:before {\n  content: \"\\E917\"; }\n\n.icon-floorplan:before {\n  content: \"\\1F322\"; }\n\n.icon-map-pin:before {\n  content: \"\\E90B\"; }\n\n.icon-external-link:before {\n  content: \"\\E905\"; }\n\n.icon-garden:before {\n  content: \"\\E901\"; }\n\n.icon-shop:before {\n  content: \"\\E902\"; }\n\n.icon-sport:before {\n  content: \"\\E903\"; }\n\n.icon-urban-river:before {\n  content: \"\\E904\"; }\n\n.icon-accessible:before {\n  content: \"\\E915\"; }\n\n.icon-person-box:before {\n  content: \"\\E851\"; }\n\n.icon-payment:before {\n  content: \"\\E8A1\"; }\n\n.icon-bike:before {\n  content: \"\\E52F\"; }\n\n.icon-car:before {\n  content: \"\\E531\"; }\n\n.icon-laugh:before {\n  content: \"\\E420\"; }\n\n.icon-trolly:before {\n  content: \"\\E8CC\"; }\n\n.icon-washing-machine:before {\n  content: \"\\E54A\"; }\n\n.icon-film:before {\n  content: \"\\E8DA\"; }\n\n.icon-mail:before {\n  content: \"\\E0E1\"; }\n\n.icon-eye:before {\n  content: \"\\E8F4\"; }\n\n.icon-smile:before {\n  content: \"\\E813\"; }\n\n.icon-speaker_group:before {\n  content: \"\\E32E\"; }\n\n.icon-train:before {\n  content: \"\\E570\"; }\n\n.icon-tram:before {\n  content: \"\\E571\"; }\n\n.icon-tv:before {\n  content: \"\\E333\"; }\n\n.icon-weekend:before {\n  content: \"\\E16B\"; }\n\n.icon-storage:before {\n  content: \"\\E8F9\"; }\n\n.icon-check:before {\n  content: \"\\E90A\"; }\n\n.icon-chevron-right:before {\n  content: \"\\E907\"; }\n\n.icon-chevron-left:before {\n  content: \"\\E908\"; }\n\n.icon-chevron-up:before {\n  content: \"\\E909\"; }\n\n.icon-chevron-down:before {\n  content: \"\\E906\"; }\n\n.icon-wifi:before {\n  content: \"\\E91B\"; }\n\n.icon-facebook:before {\n  content: \"\\EA90\"; }\n\n.icon-instagram:before {\n  content: \"\\EA92\"; }\n\n.icon-twitter:before {\n  content: \"\\EA96\"; }\n\n.icon-play:before {\n  content: \"\\EA1C\"; }\n\n.icon-pause:before {\n  content: \"\\EA1D\"; }\n\n.icon-approve:before {\n  content: \"\\E91A\"; }\n\n.icon-magnifying:before {\n  content: \"\\E91E\"; }\n\n.icon-pen:before {\n  content: \"\\E920\"; }\n\n@font-face {\n  font-family: 'fs_elliotbold';\n  src: url(" + escape(__webpack_require__(643)) + ") format(\"woff2\"), url(" + escape(__webpack_require__(644)) + ") format(\"woff\");\n  font-weight: normal;\n  font-style: normal; }\n\n@font-face {\n  font-family: 'fs_elliotregular';\n  src: url(" + escape(__webpack_require__(645)) + ") format(\"woff2\"), url(" + escape(__webpack_require__(646)) + ") format(\"woff\");\n  font-weight: normal;\n  font-style: normal; }\n\n@font-face {\n  font-family: 'grainger-icons';\n  src: url(" + escape(__webpack_require__(196)) + ");\n  src: url(" + escape(__webpack_require__(196)) + "#iefix) format(\"embedded-opentype\"), url(" + escape(__webpack_require__(647)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(648)) + ") format(\"woff\"), url(" + escape(__webpack_require__(649)) + "#icomoon) format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"grainger-icons\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.country-select .form-group {\n  margin-bottom: 0; }\n\n.country-select, .phone-number {\n  padding-right: 0; }\n\n.country-select .dropdown-single-select-with-search, .phone-number .form-control {\n  width: 100%; }\n\n.country-select .dropdown-menu {\n  max-height: 200px;\n  overflow: auto; }\n\n.country-select .dropdown-menu .country-prefix-search-filter {\n  width: 100%; }\n\n.dropdown.open .dropdown-menu {\n  display: block; }\n\n@media only screen and (max-width: 375px) {\n  .country-select {\n    padding-right: 15px; }\n  .phone-number {\n    padding-left: 0; } }\n\n.country-select .control-label {\n  display: none; }\n\n.dropdown-toggle-country-prefix {\n  height: 43px; }\n\n.flag {\n  display: none;\n  background-repeat: no-repeat; }\n\nul .flag {\n  vertical-align: middle; }\n\n.flag.flag-24 {\n  display: none;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"https://s3-eu-west-1.amazonaws.com/pexthemes/themes/abbe31b/themes_default/widgets/images/sprite-flags-24x24.png\");\n  background-repeat: no-repeat;\n  vertical-align: middle; }\n\n.flag.flag-24.flag-abkhazia {\n  background-position: -0px -0px; }\n\n.flag.flag-24.flag-basque-country {\n  background-position: -24px -0px; }\n\n.flag.flag-24.flag-british-antarctic-territory {\n  background-position: -48px -0px; }\n\n.flag.flag-24.flag-commonwealth {\n  background-position: -72px -0px; }\n\n.flag.flag-24.flag-england {\n  background-position: -96px -0px; }\n\n.flag.flag-24.flag-gosquared {\n  background-position: -120px -0px; }\n\n.flag.flag-24.flag-kosovo {\n  background-position: -144px -0px; }\n\n.flag.flag-24.flag-mars {\n  background-position: -168px -0px; }\n\n.flag.flag-24.flag-nagorno-karabakh {\n  background-position: -192px -0px; }\n\n.flag.flag-24.flag-nato {\n  background-position: -216px -0px; }\n\n.flag.flag-24.flag-northern-cyprus {\n  background-position: -240px -0px; }\n\n.flag.flag-24.flag-olympics {\n  background-position: -264px -0px; }\n\n.flag.flag-24.flag-red-cross {\n  background-position: -288px -0px; }\n\n.flag.flag-24.flag-scotland {\n  background-position: -312px -0px; }\n\n.flag.flag-24.flag-somaliland {\n  background-position: -336px -0px; }\n\n.flag.flag-24.flag-south-ossetia {\n  background-position: -360px -0px; }\n\n.flag.flag-24.flag-united-nations {\n  background-position: -384px -0px; }\n\n.flag.flag-24.flag-unknown {\n  background-position: -0px -24px; }\n\n.flag.flag-24.flag-wales {\n  background-position: -24px -24px; }\n\n.flag.flag-24.flag-AD {\n  background-position: -48px -24px; }\n\n.flag.flag-24.flag-AE {\n  background-position: -72px -24px; }\n\n.flag.flag-24.flag-AF {\n  background-position: -96px -24px; }\n\n.flag.flag-24.flag-AG {\n  background-position: -120px -24px; }\n\n.flag.flag-24.flag-AI {\n  background-position: -144px -24px; }\n\n.flag.flag-24.flag-AL {\n  background-position: -168px -24px; }\n\n.flag.flag-24.flag-AM {\n  background-position: -192px -24px; }\n\n.flag.flag-24.flag-AN {\n  background-position: -216px -24px; }\n\n.flag.flag-24.flag-AO {\n  background-position: -240px -24px; }\n\n.flag.flag-24.flag-AQ {\n  background-position: -264px -24px; }\n\n.flag.flag-24.flag-AR {\n  background-position: -288px -24px; }\n\n.flag.flag-24.flag-AS {\n  background-position: -312px -24px; }\n\n.flag.flag-24.flag-AT {\n  background-position: -336px -24px; }\n\n.flag.flag-24.flag-AU {\n  background-position: -360px -24px; }\n\n.flag.flag-24.flag-AW {\n  background-position: -384px -24px; }\n\n.flag.flag-24.flag-AX {\n  background-position: -0px -48px; }\n\n.flag.flag-24.flag-AZ {\n  background-position: -24px -48px; }\n\n.flag.flag-24.flag-BA {\n  background-position: -48px -48px; }\n\n.flag.flag-24.flag-BB {\n  background-position: -72px -48px; }\n\n.flag.flag-24.flag-BD {\n  background-position: -96px -48px; }\n\n.flag.flag-24.flag-BE {\n  background-position: -120px -48px; }\n\n.flag.flag-24.flag-BF {\n  background-position: -144px -48px; }\n\n.flag.flag-24.flag-BG {\n  background-position: -168px -48px; }\n\n.flag.flag-24.flag-BH {\n  background-position: -192px -48px; }\n\n.flag.flag-24.flag-BI {\n  background-position: -216px -48px; }\n\n.flag.flag-24.flag-BJ {\n  background-position: -240px -48px; }\n\n.flag.flag-24.flag-BL {\n  background-position: -264px -48px; }\n\n.flag.flag-24.flag-BM {\n  background-position: -288px -48px; }\n\n.flag.flag-24.flag-BN {\n  background-position: -312px -48px; }\n\n.flag.flag-24.flag-BO {\n  background-position: -336px -48px; }\n\n.flag.flag-24.flag-BR {\n  background-position: -360px -48px; }\n\n.flag.flag-24.flag-BS {\n  background-position: -384px -48px; }\n\n.flag.flag-24.flag-BT {\n  background-position: -0px -72px; }\n\n.flag.flag-24.flag-BW {\n  background-position: -24px -72px; }\n\n.flag.flag-24.flag-BY {\n  background-position: -48px -72px; }\n\n.flag.flag-24.flag-BZ {\n  background-position: -72px -72px; }\n\n.flag.flag-24.flag-CA {\n  background-position: -96px -72px; }\n\n.flag.flag-24.flag-CC {\n  background-position: -120px -72px; }\n\n.flag.flag-24.flag-CD {\n  background-position: -144px -72px; }\n\n.flag.flag-24.flag-CF {\n  background-position: -168px -72px; }\n\n.flag.flag-24.flag-CG {\n  background-position: -192px -72px; }\n\n.flag.flag-24.flag-CH {\n  background-position: -216px -72px; }\n\n.flag.flag-24.flag-CI {\n  background-position: -240px -72px; }\n\n.flag.flag-24.flag-CK {\n  background-position: -264px -72px; }\n\n.flag.flag-24.flag-CL {\n  background-position: -288px -72px; }\n\n.flag.flag-24.flag-CM {\n  background-position: -312px -72px; }\n\n.flag.flag-24.flag-CN {\n  background-position: -336px -72px; }\n\n.flag.flag-24.flag-CO {\n  background-position: -360px -72px; }\n\n.flag.flag-24.flag-CR {\n  background-position: -384px -72px; }\n\n.flag.flag-24.flag-CU {\n  background-position: -0px -96px; }\n\n.flag.flag-24.flag-CV {\n  background-position: -24px -96px; }\n\n.flag.flag-24.flag-CW {\n  background-position: -48px -96px; }\n\n.flag.flag-24.flag-CX {\n  background-position: -72px -96px; }\n\n.flag.flag-24.flag-CY {\n  background-position: -96px -96px; }\n\n.flag.flag-24.flag-CZ {\n  background-position: -120px -96px; }\n\n.flag.flag-24.flag-DE {\n  background-position: -144px -96px; }\n\n.flag.flag-24.flag-DJ {\n  background-position: -168px -96px; }\n\n.flag.flag-24.flag-DK {\n  background-position: -192px -96px; }\n\n.flag.flag-24.flag-DM {\n  background-position: -216px -96px; }\n\n.flag.flag-24.flag-DO {\n  background-position: -240px -96px; }\n\n.flag.flag-24.flag-DZ {\n  background-position: -264px -96px; }\n\n.flag.flag-24.flag-EC {\n  background-position: -288px -96px; }\n\n.flag.flag-24.flag-EE {\n  background-position: -312px -96px; }\n\n.flag.flag-24.flag-EG {\n  background-position: -336px -96px; }\n\n.flag.flag-24.flag-EH {\n  background-position: -360px -96px; }\n\n.flag.flag-24.flag-ER {\n  background-position: -384px -96px; }\n\n.flag.flag-24.flag-ES {\n  background-position: -0px -120px; }\n\n.flag.flag-24.flag-ET {\n  background-position: -24px -120px; }\n\n.flag.flag-24.flag-EU {\n  background-position: -48px -120px; }\n\n.flag.flag-24.flag-FI {\n  background-position: -72px -120px; }\n\n.flag.flag-24.flag-FJ {\n  background-position: -96px -120px; }\n\n.flag.flag-24.flag-FK {\n  background-position: -120px -120px; }\n\n.flag.flag-24.flag-FM {\n  background-position: -144px -120px; }\n\n.flag.flag-24.flag-FO {\n  background-position: -168px -120px; }\n\n.flag.flag-24.flag-FR {\n  background-position: -192px -120px; }\n\n.flag.flag-24.flag-GA {\n  background-position: -216px -120px; }\n\n.flag.flag-24.flag-GB {\n  background-position: -240px -120px; }\n\n.flag.flag-24.flag-GD {\n  background-position: -264px -120px; }\n\n.flag.flag-24.flag-GE {\n  background-position: -288px -120px; }\n\n.flag.flag-24.flag-GG {\n  background-position: -312px -120px; }\n\n.flag.flag-24.flag-GH {\n  background-position: -336px -120px; }\n\n.flag.flag-24.flag-GI {\n  background-position: -360px -120px; }\n\n.flag.flag-24.flag-GL {\n  background-position: -384px -120px; }\n\n.flag.flag-24.flag-GM {\n  background-position: -0px -144px; }\n\n.flag.flag-24.flag-GN {\n  background-position: -24px -144px; }\n\n.flag.flag-24.flag-GQ {\n  background-position: -48px -144px; }\n\n.flag.flag-24.flag-GR {\n  background-position: -72px -144px; }\n\n.flag.flag-24.flag-GS {\n  background-position: -96px -144px; }\n\n.flag.flag-24.flag-GT {\n  background-position: -120px -144px; }\n\n.flag.flag-24.flag-GU {\n  background-position: -144px -144px; }\n\n.flag.flag-24.flag-GW {\n  background-position: -168px -144px; }\n\n.flag.flag-24.flag-GY {\n  background-position: -192px -144px; }\n\n.flag.flag-24.flag-HK {\n  background-position: -216px -144px; }\n\n.flag.flag-24.flag-HN {\n  background-position: -240px -144px; }\n\n.flag.flag-24.flag-HR {\n  background-position: -264px -144px; }\n\n.flag.flag-24.flag-HT {\n  background-position: -288px -144px; }\n\n.flag.flag-24.flag-HU {\n  background-position: -312px -144px; }\n\n.flag.flag-24.flag-IC {\n  background-position: -336px -144px; }\n\n.flag.flag-24.flag-ID {\n  background-position: -360px -144px; }\n\n.flag.flag-24.flag-IE {\n  background-position: -384px -144px; }\n\n.flag.flag-24.flag-IL {\n  background-position: -0px -168px; }\n\n.flag.flag-24.flag-IM {\n  background-position: -24px -168px; }\n\n.flag.flag-24.flag-IN {\n  background-position: -48px -168px; }\n\n.flag.flag-24.flag-IQ {\n  background-position: -72px -168px; }\n\n.flag.flag-24.flag-IR {\n  background-position: -96px -168px; }\n\n.flag.flag-24.flag-IS {\n  background-position: -120px -168px; }\n\n.flag.flag-24.flag-IT {\n  background-position: -144px -168px; }\n\n.flag.flag-24.flag-JE {\n  background-position: -168px -168px; }\n\n.flag.flag-24.flag-JM {\n  background-position: -192px -168px; }\n\n.flag.flag-24.flag-JO {\n  background-position: -216px -168px; }\n\n.flag.flag-24.flag-JP {\n  background-position: -240px -168px; }\n\n.flag.flag-24.flag-KE {\n  background-position: -264px -168px; }\n\n.flag.flag-24.flag-KG {\n  background-position: -288px -168px; }\n\n.flag.flag-24.flag-KH {\n  background-position: -312px -168px; }\n\n.flag.flag-24.flag-KI {\n  background-position: -336px -168px; }\n\n.flag.flag-24.flag-KM {\n  background-position: -360px -168px; }\n\n.flag.flag-24.flag-KN {\n  background-position: -384px -168px; }\n\n.flag.flag-24.flag-KP {\n  background-position: -0px -192px; }\n\n.flag.flag-24.flag-KR {\n  background-position: -24px -192px; }\n\n.flag.flag-24.flag-KW {\n  background-position: -48px -192px; }\n\n.flag.flag-24.flag-KY {\n  background-position: -72px -192px; }\n\n.flag.flag-24.flag-KZ {\n  background-position: -96px -192px; }\n\n.flag.flag-24.flag-LA {\n  background-position: -120px -192px; }\n\n.flag.flag-24.flag-LB {\n  background-position: -144px -192px; }\n\n.flag.flag-24.flag-LC {\n  background-position: -168px -192px; }\n\n.flag.flag-24.flag-LI {\n  background-position: -192px -192px; }\n\n.flag.flag-24.flag-LK {\n  background-position: -216px -192px; }\n\n.flag.flag-24.flag-LR {\n  background-position: -240px -192px; }\n\n.flag.flag-24.flag-LS {\n  background-position: -264px -192px; }\n\n.flag.flag-24.flag-LT {\n  background-position: -288px -192px; }\n\n.flag.flag-24.flag-LU {\n  background-position: -312px -192px; }\n\n.flag.flag-24.flag-LV {\n  background-position: -336px -192px; }\n\n.flag.flag-24.flag-LY {\n  background-position: -360px -192px; }\n\n.flag.flag-24.flag-MA {\n  background-position: -384px -192px; }\n\n.flag.flag-24.flag-MC {\n  background-position: -0px -216px; }\n\n.flag.flag-24.flag-MD {\n  background-position: -24px -216px; }\n\n.flag.flag-24.flag-ME {\n  background-position: -48px -216px; }\n\n.flag.flag-24.flag-MF {\n  background-position: -72px -216px; }\n\n.flag.flag-24.flag-MG {\n  background-position: -96px -216px; }\n\n.flag.flag-24.flag-MH {\n  background-position: -120px -216px; }\n\n.flag.flag-24.flag-MK {\n  background-position: -144px -216px; }\n\n.flag.flag-24.flag-ML {\n  background-position: -168px -216px; }\n\n.flag.flag-24.flag-MM {\n  background-position: -192px -216px; }\n\n.flag.flag-24.flag-MN {\n  background-position: -216px -216px; }\n\n.flag.flag-24.flag-MO {\n  background-position: -240px -216px; }\n\n.flag.flag-24.flag-MP {\n  background-position: -264px -216px; }\n\n.flag.flag-24.flag-MQ {\n  background-position: -288px -216px; }\n\n.flag.flag-24.flag-MR {\n  background-position: -312px -216px; }\n\n.flag.flag-24.flag-MS {\n  background-position: -336px -216px; }\n\n.flag.flag-24.flag-MT {\n  background-position: -360px -216px; }\n\n.flag.flag-24.flag-MU {\n  background-position: -384px -216px; }\n\n.flag.flag-24.flag-MV {\n  background-position: -0px -240px; }\n\n.flag.flag-24.flag-MW {\n  background-position: -24px -240px; }\n\n.flag.flag-24.flag-MX {\n  background-position: -48px -240px; }\n\n.flag.flag-24.flag-MY {\n  background-position: -72px -240px; }\n\n.flag.flag-24.flag-MZ {\n  background-position: -96px -240px; }\n\n.flag.flag-24.flag-NA {\n  background-position: -120px -240px; }\n\n.flag.flag-24.flag-NC {\n  background-position: -144px -240px; }\n\n.flag.flag-24.flag-NE {\n  background-position: -168px -240px; }\n\n.flag.flag-24.flag-NF {\n  background-position: -192px -240px; }\n\n.flag.flag-24.flag-NG {\n  background-position: -216px -240px; }\n\n.flag.flag-24.flag-NI {\n  background-position: -240px -240px; }\n\n.flag.flag-24.flag-NL {\n  background-position: -264px -240px; }\n\n.flag.flag-24.flag-NO {\n  background-position: -288px -240px; }\n\n.flag.flag-24.flag-NP {\n  background-position: -312px -240px; }\n\n.flag.flag-24.flag-NR {\n  background-position: -336px -240px; }\n\n.flag.flag-24.flag-NU {\n  background-position: -360px -240px; }\n\n.flag.flag-24.flag-NZ {\n  background-position: -384px -240px; }\n\n.flag.flag-24.flag-OM {\n  background-position: -0px -264px; }\n\n.flag.flag-24.flag-PA {\n  background-position: -24px -264px; }\n\n.flag.flag-24.flag-PE {\n  background-position: -48px -264px; }\n\n.flag.flag-24.flag-PF {\n  background-position: -72px -264px; }\n\n.flag.flag-24.flag-PG {\n  background-position: -96px -264px; }\n\n.flag.flag-24.flag-PH {\n  background-position: -120px -264px; }\n\n.flag.flag-24.flag-pirate-black {\n  background-position: -144px -264px; }\n\n.flag.flag-24.flag-pirate-white {\n  background-position: -168px -264px; }\n\n.flag.flag-24.flag-PK {\n  background-position: -192px -264px; }\n\n.flag.flag-24.flag-PL {\n  background-position: -216px -264px; }\n\n.flag.flag-24.flag-PN {\n  background-position: -240px -264px; }\n\n.flag.flag-24.flag-PR {\n  background-position: -264px -264px; }\n\n.flag.flag-24.flag-PS {\n  background-position: -288px -264px; }\n\n.flag.flag-24.flag-PT {\n  background-position: -312px -264px; }\n\n.flag.flag-24.flag-PW {\n  background-position: -336px -264px; }\n\n.flag.flag-24.flag-PY {\n  background-position: -360px -264px; }\n\n.flag.flag-24.flag-QA {\n  background-position: -384px -264px; }\n\n.flag.flag-24.flag-RO {\n  background-position: -0px -288px; }\n\n.flag.flag-24.flag-RS {\n  background-position: -24px -288px; }\n\n.flag.flag-24.flag-RU {\n  background-position: -48px -288px; }\n\n.flag.flag-24.flag-RW {\n  background-position: -72px -288px; }\n\n.flag.flag-24.flag-SA {\n  background-position: -96px -288px; }\n\n.flag.flag-24.flag-SB {\n  background-position: -120px -288px; }\n\n.flag.flag-24.flag-SC {\n  background-position: -144px -288px; }\n\n.flag.flag-24.flag-SD {\n  background-position: -168px -288px; }\n\n.flag.flag-24.flag-SE {\n  background-position: -192px -288px; }\n\n.flag.flag-24.flag-SG {\n  background-position: -216px -288px; }\n\n.flag.flag-24.flag-SH {\n  background-position: -240px -288px; }\n\n.flag.flag-24.flag-SI {\n  background-position: -264px -288px; }\n\n.flag.flag-24.flag-SK {\n  background-position: -288px -288px; }\n\n.flag.flag-24.flag-SL {\n  background-position: -312px -288px; }\n\n.flag.flag-24.flag-SM {\n  background-position: -336px -288px; }\n\n.flag.flag-24.flag-SN {\n  background-position: -360px -288px; }\n\n.flag.flag-24.flag-SO {\n  background-position: -384px -288px; }\n\n.flag.flag-24.flag-SR {\n  background-position: -0px -312px; }\n\n.flag.flag-24.flag-SS {\n  background-position: -24px -312px; }\n\n.flag.flag-24.flag-ST {\n  background-position: -48px -312px; }\n\n.flag.flag-24.flag-SV {\n  background-position: -72px -312px; }\n\n.flag.flag-24.flag-SY {\n  background-position: -96px -312px; }\n\n.flag.flag-24.flag-SZ {\n  background-position: -120px -312px; }\n\n.flag.flag-24.flag-TC {\n  background-position: -144px -312px; }\n\n.flag.flag-24.flag-TD {\n  background-position: -168px -312px; }\n\n.flag.flag-24.flag-TF {\n  background-position: -192px -312px; }\n\n.flag.flag-24.flag-TG {\n  background-position: -216px -312px; }\n\n.flag.flag-24.flag-TH {\n  background-position: -240px -312px; }\n\n.flag.flag-24.flag-TJ {\n  background-position: -264px -312px; }\n\n.flag.flag-24.flag-TK {\n  background-position: -288px -312px; }\n\n.flag.flag-24.flag-TL {\n  background-position: -312px -312px; }\n\n.flag.flag-24.flag-TM {\n  background-position: -336px -312px; }\n\n.flag.flag-24.flag-TN {\n  background-position: -360px -312px; }\n\n.flag.flag-24.flag-TO {\n  background-position: -384px -312px; }\n\n.flag.flag-24.flag-TR {\n  background-position: -0px -336px; }\n\n.flag.flag-24.flag-TT {\n  background-position: -24px -336px; }\n\n.flag.flag-24.flag-TV {\n  background-position: -48px -336px; }\n\n.flag.flag-24.flag-TW {\n  background-position: -72px -336px; }\n\n.flag.flag-24.flag-TZ {\n  background-position: -96px -336px; }\n\n.flag.flag-24.flag-UA {\n  background-position: -120px -336px; }\n\n.flag.flag-24.flag-UG {\n  background-position: -144px -336px; }\n\n.flag.flag-24.flag-US {\n  background-position: -168px -336px; }\n\n.flag.flag-24.flag-UY {\n  background-position: -192px -336px; }\n\n.flag.flag-24.flag-UZ {\n  background-position: -216px -336px; }\n\n.flag.flag-24.flag-VA {\n  background-position: -240px -336px; }\n\n.flag.flag-24.flag-VC {\n  background-position: -264px -336px; }\n\n.flag.flag-24.flag-VE {\n  background-position: -288px -336px; }\n\n.flag.flag-24.flag-VG {\n  background-position: -312px -336px; }\n\n.flag.flag-24.flag-VI {\n  background-position: -336px -336px; }\n\n.flag.flag-24.flag-VN {\n  background-position: -360px -336px; }\n\n.flag.flag-24.flag-VU {\n  background-position: -384px -336px; }\n\n.gr-grainger-contact {\n  position: relative;\n  background-color: rgba(99, 102, 106, 0.05);\n  overflow: hidden; }\n  @media all and (min-width: 768px) {\n    .gr-grainger-contact {\n      margin-bottom: 170px; } }\n  @media all and (min-width: 992px) {\n    .gr-grainger-contact {\n      margin-bottom: 230px; } }\n\n.gr-grainger-form {\n  max-width: 1920px;\n  margin: 0 auto;\n  position: relative; }\n  @media all and (min-width: 768px) {\n    .gr-grainger-form {\n      padding: 0 15px; } }\n  .gr-grainger-form__form {\n    padding: 30px 0;\n    position: relative;\n    z-index: 1; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form__form {\n        padding: 50px 0; } }\n    @media all and (min-width: 992px) {\n      .gr-grainger-form__form {\n        padding: 60px 0; } }\n  .gr-grainger-form .checkbox label {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    cursor: pointer;\n    margin-bottom: 0;\n    color: #4A4A4A; }\n  .gr-grainger-form .checkbox span::before {\n    content: '';\n    width: 25px;\n    height: 25px;\n    visibility: initial;\n    position: absolute;\n    left: 0;\n    top: 0;\n    border: 1px solid #4E8382;\n    background-color: #FFFFFF; }\n  .gr-grainger-form .checkbox input {\n    position: absolute;\n    visibility: hidden;\n    cursor: pointer; }\n    .gr-grainger-form .checkbox input[value=\"true\"] ~ span::before {\n      background-color: #62B1AD;\n      border: none; }\n    .gr-grainger-form .checkbox input[value=\"true\"] ~ span::after {\n      content: '\\E90A';\n      visibility: initial;\n      position: absolute;\n      font-size: 20px;\n      left: 2.5px;\n      top: 2.5px;\n      color: #FFFFFF;\n      font-family: \"grainger-icons\" !important;\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      line-height: 1; }\n  .gr-grainger-form .has-error .enquiry-budget-text-box,\n  .gr-grainger-form .has-error .input-group {\n    border-color: #FF0000 !important; }\n  .gr-grainger-form .has-error .input-group + span {\n    color: #FF0000;\n    margin-top: 5px;\n    display: inline-block; }\n  .gr-grainger-form .has-error .form-control {\n    border-color: #FF0000 !important; }\n  .gr-grainger-form .has-error .checkbox span:before {\n    border-color: #FF0000; }\n  .gr-grainger-form .pex-generic-webform-widget {\n    max-width: 800px;\n    margin: 0 auto; }\n  .gr-grainger-form .generic-webform-widget-title {\n    color: #4E8382;\n    display: inline-block;\n    position: relative;\n    text-transform: uppercase;\n    text-align: center; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .generic-webform-widget-title {\n        margin-bottom: 10px; } }\n    .gr-grainger-form .generic-webform-widget-title h3 {\n      font-size: 30px;\n      line-height: 32px;\n      margin-bottom: 20px; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .generic-webform-widget-title h3 {\n          font-size: 35px;\n          line-height: 38px; } }\n      @media all and (min-width: 992px) {\n        .gr-grainger-form .generic-webform-widget-title h3 {\n          font-size: 40px;\n          line-height: 42px; } }\n  .gr-grainger-form .generic-webform-widget-form {\n    margin: 20px -15px 0; }\n    .gr-grainger-form .generic-webform-widget-form .col-sm-9 {\n      width: 100%;\n      max-width: 100%; }\n    .gr-grainger-form .generic-webform-widget-form .form-group {\n      margin-bottom: 30px; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .generic-webform-widget-form .form-group {\n          margin-bottom: 40px; } }\n      .gr-grainger-form .generic-webform-widget-form .form-group.generic-plugin-phone-number {\n        margin-bottom: 10px; }\n        .gr-grainger-form .generic-webform-widget-form .form-group.generic-plugin-phone-number.has-error .generic-plugin-phone-number-prefix {\n          margin-bottom: 0 !important; }\n        .gr-grainger-form .generic-webform-widget-form .form-group.generic-plugin-phone-number.has-error .input-group + span {\n          display: inline-block;\n          margin-bottom: 30px; }\n          @media all and (min-width: 768px) {\n            .gr-grainger-form .generic-webform-widget-form .form-group.generic-plugin-phone-number.has-error .input-group + span {\n              margin-bottom: 40px; } }\n      .gr-grainger-form .generic-webform-widget-form .form-group.enquiry-budget, .gr-grainger-form .generic-webform-widget-form .form-group.enquiry-numberOfBedrooms, .gr-grainger-form .generic-webform-widget-form .form-group.enquiry-start, .gr-grainger-form .generic-webform-widget-form .form-group.enquiry-comments {\n        margin-bottom: 40px; }\n      .gr-grainger-form .generic-webform-widget-form .form-group.enquiry-marketingSource {\n        margin-bottom: 50px;\n        max-width: 500px; }\n    .gr-grainger-form .generic-webform-widget-form .input-group {\n      align-items: center; }\n    .gr-grainger-form .generic-webform-widget-form .form-control {\n      border: 1px solid #4E8382;\n      border-radius: 0;\n      color: #7C7C7B;\n      height: 40px;\n      padding: 5px 10px; }\n      .gr-grainger-form .generic-webform-widget-form .form-control::placeholder {\n        color: #D8D8D8;\n        text-transform: lowercase; }\n      .gr-grainger-form .generic-webform-widget-form .form-control.enquiry-budget-text-box {\n        border: none;\n        background-color: transparent;\n        border-bottom: 1px solid #4E8382;\n        width: 100px;\n        text-align: center;\n        padding-top: 0;\n        padding-bottom: 0;\n        height: auto;\n        margin-right: 10px; }\n    .gr-grainger-form .generic-webform-widget-form .enquiry-budget-text {\n      color: #4E8382; }\n    .gr-grainger-form .generic-webform-widget-form .control-label {\n      color: #4E8382;\n      font-weight: 700;\n      margin-bottom: 5px; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .generic-webform-widget-form .control-label {\n          font-size: 18px;\n          margin-bottom: 10px; } }\n  .gr-grainger-form .guest-firstName,\n  .gr-grainger-form .guest-lastName {\n    width: 100%;\n    float: left; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .guest-firstName,\n      .gr-grainger-form .guest-lastName {\n        width: 50%; } }\n  .gr-grainger-form .country-select {\n    padding: 0;\n    display: inline-flex;\n    width: auto;\n    vertical-align: top; }\n    .gr-grainger-form .country-select .dropdown-menu {\n      min-width: 250px; }\n  .gr-grainger-form .phone-number {\n    width: calc(100% - 87px);\n    max-width: 100%;\n    display: inline-flex;\n    padding-left: 15px; }\n  .gr-grainger-form .dropdown-single-country-prefix {\n    border: 1px solid #4E8382;\n    background-color: #FFFFFF;\n    border-radius: 0;\n    width: auto; }\n    .gr-grainger-form .dropdown-single-country-prefix .dropdown-toggle::before {\n      content: '+';\n      color: #4E8382;\n      position: absolute;\n      left: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      background-color: #FFFFFF;\n      z-index: 1;\n      pointer-events: none; }\n    .gr-grainger-form .dropdown-single-country-prefix .dropdown-toggle::after {\n      content: \"\\E906\";\n      display: block;\n      color: #4E8382;\n      position: absolute;\n      right: -5px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 30px;\n      height: 30px;\n      font-size: 30px;\n      font-family: \"grainger-icons\" !important;\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      line-height: 1;\n      border: none;\n      margin: 0; }\n    .gr-grainger-form .dropdown-single-country-prefix .dropdown-toggle-country-prefix {\n      border: 7px solid #FFFFFF;\n      background-color: #FFFFFF;\n      width: 85px;\n      height: 38px;\n      padding: 0;\n      overflow: hidden;\n      position: relative;\n      color: #4E8382; }\n      .gr-grainger-form .dropdown-single-country-prefix .dropdown-toggle-country-prefix .dropdown-text {\n        position: absolute;\n        right: 28px;\n        top: 50%;\n        transform: translateY(-50%);\n        color: #4E8382; }\n  .gr-grainger-form .pex-menu-items-country-prefix {\n    color: #979797; }\n  .gr-grainger-form .generic-plugin-phone-number-container {\n    width: 100%; }\n  .gr-grainger-form .flag {\n    display: none; }\n  .gr-grainger-form .enquiry-numberOfBedrooms input[type=\"checkbox\"] {\n    border: none;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px; }\n  .gr-grainger-form .enquiry-numberOfBedrooms .btn {\n    width: 60px;\n    height: 60px;\n    margin: 0;\n    margin-right: 10px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #4E8382;\n    color: #4E8382;\n    border-radius: 50% !important;\n    transition: all ease-in-out .3s;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none; }\n    .gr-grainger-form .enquiry-numberOfBedrooms .btn:last-child {\n      margin-right: 0; }\n    .gr-grainger-form .enquiry-numberOfBedrooms .btn:hover, .gr-grainger-form .enquiry-numberOfBedrooms .btn:focus {\n      background-color: #62B1AD;\n      color: #FFFFFF;\n      border-color: #62B1AD;\n      transition: background-color .1s linear, color .1s linear, border-color .1s linear; }\n    .gr-grainger-form .enquiry-numberOfBedrooms .btn.active {\n      background-color: #62B1AD;\n      color: #FFFFFF;\n      border-color: #62B1AD;\n      transition: background-color .1s linear, color .1s linear, border-color .1s linear; }\n  .gr-grainger-form .enquiry-numberOfBedrooms .info-text {\n    display: block;\n    width: 100%;\n    margin-top: 12px;\n    color: #4E8382; }\n  .gr-grainger-form .enquiry-budget-container {\n    position: relative;\n    padding-left: 20px;\n    color: #4E8382; }\n    .gr-grainger-form .enquiry-budget-container::before {\n      content: '\\A3';\n      position: absolute;\n      left: 0px;\n      bottom: 0; }\n  .gr-grainger-form .date-with-checkbox-container {\n    width: 100%; }\n  .gr-grainger-form .date-container {\n    margin-left: -30px;\n    width: 100vw;\n    overflow-y: scroll;\n    margin-bottom: 15px;\n    margin-top: 10px; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .date-container {\n        margin-left: 0;\n        width: 100%;\n        overflow: visible;\n        text-align: center; } }\n  .gr-grainger-form .react-datepicker {\n    font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif;\n    border: none;\n    background-color: transparent;\n    padding-left: 30px;\n    width: 644px;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: stretch; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .react-datepicker {\n        padding-left: 0;\n        width: 100%;\n        overflow: visible; } }\n    .gr-grainger-form .react-datepicker__month-container {\n      background-color: #FFFFFF;\n      border: 1px solid #979797;\n      padding: 20px 15px 15px;\n      width: 277px;\n      margin-right: 30px;\n      float: none;\n      display: inline-block;\n      vertical-align: top; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .react-datepicker__month-container:last-child {\n          margin-right: 0; } }\n    .gr-grainger-form .react-datepicker__header {\n      background-color: transparent;\n      padding: 0 !important;\n      text-align: left;\n      border: none;\n      font-size: 16px; }\n    .gr-grainger-form .react-datepicker__current-month {\n      font-size: 14px !important;\n      font-weight: 200;\n      margin-bottom: 10px;\n      color: #4E8382;\n      padding: 0 8px; }\n    .gr-grainger-form .react-datepicker__day, .gr-grainger-form .react-datepicker__day-name {\n      margin: 0 !important;\n      padding: 5px;\n      width: 35px;\n      height: 35px;\n      color: #4E8382;\n      font-size: 14px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center; }\n    .gr-grainger-form .react-datepicker__day-name {\n      font-weight: 700; }\n    .gr-grainger-form .react-datepicker__day--today {\n      color: #4E8382;\n      font-weight: 700; }\n    .gr-grainger-form .react-datepicker__day--selected {\n      color: #FFFFFF;\n      background-color: #62B1AD;\n      border-radius: 50%; }\n    .gr-grainger-form .react-datepicker__day:hover, .gr-grainger-form .react-datepicker__day:focus {\n      color: #FFFFFF;\n      background-color: #62B1AD;\n      border-radius: 50%; }\n    .gr-grainger-form .react-datepicker__day--disabled {\n      color: #62B1AD; }\n      .gr-grainger-form .react-datepicker__day--disabled:hover, .gr-grainger-form .react-datepicker__day--disabled:focus {\n        color: #62B1AD;\n        background-color: transparent; }\n    .gr-grainger-form .react-datepicker__month {\n      margin: 0; }\n    .gr-grainger-form .react-datepicker__navigation {\n      border: none;\n      position: absolute;\n      top: 50% !important;\n      font-family: \"grainger-icons\" !important;\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      line-height: 1; }\n      .gr-grainger-form .react-datepicker__navigation--next {\n        right: -6px; }\n        @media all and (min-width: 768px) {\n          .gr-grainger-form .react-datepicker__navigation--next {\n            right: -30px; } }\n        .gr-grainger-form .react-datepicker__navigation--next::before {\n          content: '\\E907';\n          color: #4E8382;\n          position: absolute;\n          right: 0;\n          transform: translateY(-50%);\n          font-size: 40px; }\n      .gr-grainger-form .react-datepicker__navigation--previous {\n        left: 35px; }\n        @media all and (min-width: 768px) {\n          .gr-grainger-form .react-datepicker__navigation--previous {\n            left: 10px; } }\n        .gr-grainger-form .react-datepicker__navigation--previous::before {\n          content: '\\E908';\n          color: #4E8382;\n          position: absolute;\n          right: 0;\n          transform: translateY(-50%);\n          font-size: 40px; }\n  .gr-grainger-form .guest-optOut-text,\n  .gr-grainger-form .guest-vip-text {\n    color: #4E8382; }\n  .gr-grainger-form .guest-vip-link {\n    color: #4E8382;\n    text-decoration: none; }\n    .gr-grainger-form .guest-vip-link:hover, .gr-grainger-form .guest-vip-link:focus {\n      color: #62B1AD;\n      transition: background-color .1s linear; }\n  @media all and (min-width: 768px) {\n    .gr-grainger-form .guest-vip {\n      margin-top: -20px; } }\n  .gr-grainger-form .date-container ~ .checkbox-container .checkbox label::before {\n    content: '';\n    width: 25px;\n    height: 25px;\n    visibility: initial;\n    position: absolute;\n    left: 0;\n    top: 0;\n    border: 1px solid #4E8382;\n    background-color: #FFFFFF; }\n  .gr-grainger-form .date-container[hidden] ~ .checkbox-container .checkbox label::before {\n    background-color: #62B1AD;\n    border: none; }\n  .gr-grainger-form .date-container[hidden] ~ .checkbox-container .checkbox label::after {\n    content: '\\E90A';\n    visibility: initial;\n    position: absolute;\n    font-size: 20px;\n    left: 2.5px;\n    top: 2.5px;\n    color: #FFFFFF;\n    font-family: \"grainger-icons\" !important;\n    speak: none;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1; }\n  .gr-grainger-form .not-sure-checkbox label {\n    color: #4E8382; }\n  .gr-grainger-form .enquiry-comments .form-control {\n    height: 150px;\n    resize: none; }\n  .gr-grainger-form .enquiry-marketingSource .input-group {\n    position: relative;\n    border-bottom: 2px solid #4E8382;\n    width: 100%;\n    overflow: hidden; }\n    .gr-grainger-form .enquiry-marketingSource .input-group::after {\n      content: '\\E906';\n      color: #4E8382;\n      font-size: 35px;\n      position: absolute;\n      right: 2px;\n      top: 50%;\n      transform: translateY(-50%);\n      font-family: \"grainger-icons\" !important;\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      line-height: 1; }\n    .gr-grainger-form .enquiry-marketingSource .input-group select {\n      color: #4E8382;\n      padding: 0 40px 0 0;\n      width: 100%;\n      border: none;\n      box-shadow: none;\n      background: transparent;\n      background-image: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .enquiry-marketingSource .input-group select {\n          font-size: 18px; } }\n  .gr-grainger-form a {\n    color: inherit;\n    text-decoration: underline; }\n  .gr-grainger-form .reCaptcha {\n    margin: 0 -30px;\n    margin-top: 40px; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .reCaptcha {\n        margin: 50px 0; } }\n    .gr-grainger-form .reCaptcha.form-group {\n      margin-bottom: 30px; }\n    .gr-grainger-form .reCaptcha .control-label {\n      display: none; }\n    .gr-grainger-form .reCaptcha .input-group {\n      display: inline-flex;\n      justify-content: center; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .reCaptcha .input-group {\n          justify-content: flex-start; } }\n  .gr-grainger-form .generic-webform-widget-information,\n  .gr-grainger-form .generic-webform-widget-extra-information {\n    padding: 0 15px;\n    display: block;\n    color: #4E8382;\n    font-size: 18px; }\n    .gr-grainger-form .generic-webform-widget-information b,\n    .gr-grainger-form .generic-webform-widget-extra-information b {\n      font-weight: 200; }\n  .gr-grainger-form .btn-submit-generic-webform.btn.btn-default {\n    text-align: center;\n    display: inline-block;\n    color: #FFFFFF;\n    margin: 40px auto 30px auto;\n    padding: 15px 40px;\n    border-radius: 40px;\n    max-width: 240px;\n    line-height: 16px;\n    font-size: 14px;\n    text-transform: uppercase;\n    position: relative;\n    background-color: #4E8382;\n    transition: background-color .1s linear; }\n    .gr-grainger-form .btn-submit-generic-webform.btn.btn-default:hover, .gr-grainger-form .btn-submit-generic-webform.btn.btn-default:focus {\n      background-color: #F36F4A;\n      color: #FFFFFF;\n      text-decoration: none; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .btn-submit-generic-webform.btn.btn-default {\n        margin-bottom: 25px;\n        margin-top: 60px;\n        max-width: 280px; } }\n  .gr-grainger-form .guest-optOut-container {\n    margin-top: 10px; }\n  .gr-grainger-form .generic-thanks-container {\n    padding: 0 10px;\n    text-align: center;\n    color: #4E8382;\n    font-weight: 700;\n    font-size: 17px;\n    line-height: 26px;\n    text-transform: uppercase; }\n    @media all and (min-width: 768px) {\n      .gr-grainger-form .generic-thanks-container {\n        font-size: 24px;\n        line-height: 35px; } }\n    .gr-grainger-form .generic-thanks-container .btn-redirect-url {\n      text-align: center;\n      display: block;\n      color: #FFFFFF;\n      margin: 0 auto;\n      margin-bottom: 0;\n      margin-top: 15px;\n      padding: 15px 40px;\n      border-radius: 40px;\n      max-width: 240px;\n      line-height: 16px;\n      font-size: 14px;\n      text-transform: uppercase;\n      position: relative;\n      background-color: #4E8382;\n      transition: background-color .1s linear; }\n      .gr-grainger-form .generic-thanks-container .btn-redirect-url:hover, .gr-grainger-form .generic-thanks-container .btn-redirect-url:focus {\n        background-color: #F36F4A;\n        color: #FFFFFF;\n        text-decoration: none; }\n      @media all and (min-width: 768px) {\n        .gr-grainger-form .generic-thanks-container .btn-redirect-url {\n          margin-top: 35px; } }\n\nlabel {\n  display: inline-block; }\n\n.btn-group, .btn-group-vertical {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle; }\n\n.btn-group > .btn:first-child {\n  margin-left: 0; }\n\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer; }\n\n.btn-group-vertical > .btn,\n.btn-group > .btn {\n  position: relative;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto; }\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: .375rem .75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: .25rem;\n  -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;\n  -o-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out; }\n\n.input-group {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%; }\n  .input-group > .custom-file,\n  .input-group > .custom-select,\n  .input-group > .form-control {\n    position: relative;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0; }\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: .5rem 0;\n  margin: .125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: .25rem; }\n\nbutton, input, optgroup, select, textarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\n\nbutton, input {\n  overflow: visible; }\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: .75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125); }\n\n.dropdown-toggle:after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: .255em;\n  vertical-align: .255em;\n  content: \"\";\n  border-top: .3em solid;\n  border-right: .3em solid transparent;\n  border-bottom: 0;\n  border-left: .3em solid transparent; }\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: .375rem .75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: .25rem;\n  -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;\n  -o-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out; }\n\nbody {\n  color: #7C7C7B;\n  font-size: 16px;\n  font-family: \"fs_elliotregular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif; }\n  body::after {\n    content: '';\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: transparent;\n    transition: background-color .2s ease; }\n    @media all and (min-width: 992px) {\n      body::after {\n        display: none; } }\n  @media all and (min-width: 768px) {\n    body {\n      font-size: 16px; } }\n\n* {\n  box-sizing: border-box; }\n\nh1, .h1,\nh2, .h2,\nh3, .h3,\nh4, .h4,\nh5, .h5,\nh6, .h6 {\n  font-family: \"fs_elliotbold\"; }\n\n.gutter-narrow {\n  margin-left: -5px;\n  margin-right: -5px; }\n  .gutter-narrow > .col,\n  .gutter-narrow > [class*=\"col-\"] {\n    padding-left: 5px;\n    padding-right: 5px;\n    margin: 0; }\n\n.grey-box {\n  background-color: #e6e6e6;\n  border: var(--demo-component-border);\n  padding: 20px; }\n\n.gr-body-fixed {\n  margin: 0;\n  height: 100%;\n  overflow: hidden;\n  position: relative; }\n\nhtml.gr-body-fixed {\n  /* This is to force the body to have the same rules if we add this class to html tag */ }\n  html.gr-body-fixed body {\n    margin: 0;\n    height: 100%;\n    overflow: hidden;\n    position: relative; }\n\n@media all and (min-width: 768px) {\n  .container-md {\n    max-width: 720px;\n    margin: 0 auto;\n    width: 100%; } }\n\n@media all and (min-width: 992px) {\n  .container-md {\n    max-width: 960px; } }\n\n@media all and (min-width: 1200px) {\n  .container-md {\n    max-width: 1140px; } }\n\na:focus {\n  outline: 2px solid #4E8382; }\n\na:active {\n  outline: none; }\n\n#root {\n  overflow: hidden; }\n  @media all and (min-width: 992px) {\n    #root {\n      overflow-y: hidden; } }\n\n.parallax-outer,\n.parallax-inner {\n  height: 100%; }\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0; }\n\n.left {\n  float: left; }\n\n.right {\n  float: right; }\n", ""]); // exports

  /***/
},
/* 641 */

/***/
function (module, exports) {
  module.exports = function escape(url) {
    if (typeof url !== 'string') {
      return url;
    } // If url is already wrapped in quotes, remove them


    if (/^['"].*['"]$/.test(url)) {
      url = url.slice(1, -1);
    } // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls


    if (/["'() \t\n]/.test(url)) {
      return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
    }

    return url;
  };
  /***/

},
/* 642 */

/***/
function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(3)(false); // imports
  // module

  exports.push([module.i, "@charset \"UTF-8\";\n\n/*!\n * animate.css -http://daneden.me/animate\n * Version - 3.7.0\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2018 Daniel Eden\n */\n\n@-webkit-keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);animation-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);animation-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);animation-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.bounce{-webkit-animation-name:bounce;-webkit-transform-origin:center bottom;animation-name:bounce;transform-origin:center bottom}@-webkit-keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.headShake{-webkit-animation-name:headShake;-webkit-animation-timing-function:ease-in-out;animation-name:headShake;animation-timing-function:ease-in-out}@-webkit-keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}.swing{-webkit-animation-name:swing;-webkit-transform-origin:top center;animation-name:swing;transform-origin:top center}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes jello{0%,11.1%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes jello{0%,11.1%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{-webkit-animation-name:jello;-webkit-transform-origin:center;animation-name:jello;transform-origin:center}@-webkit-keyframes heartBeat{0%{-webkit-transform:scale(1);transform:scale(1)}14%{-webkit-transform:scale(1.3);transform:scale(1.3)}28%{-webkit-transform:scale(1);transform:scale(1)}42%{-webkit-transform:scale(1.3);transform:scale(1.3)}70%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes heartBeat{0%{-webkit-transform:scale(1);transform:scale(1)}14%{-webkit-transform:scale(1.3);transform:scale(1.3)}28%{-webkit-transform:scale(1);transform:scale(1)}42%{-webkit-transform:scale(1.3);transform:scale(1.3)}70%{-webkit-transform:scale(1);transform:scale(1)}}.heartBeat{-webkit-animation-duration:1.3s;-webkit-animation-name:heartBeat;-webkit-animation-timing-function:ease-in-out;animation-duration:1.3s;animation-name:heartBeat;animation-timing-function:ease-in-out}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{-webkit-transform:scale3d(1.03,1.03,1.03);opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{-webkit-transform:scaleX(1);opacity:1;transform:scaleX(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{-webkit-transform:scale3d(1.03,1.03,1.03);opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{-webkit-transform:scaleX(1);opacity:1;transform:scaleX(1)}}.bounceIn{-webkit-animation-duration:.75s;-webkit-animation-name:bounceIn;animation-duration:.75s;animation-name:bounceIn}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(0,-3000px,0);opacity:0;transform:translate3d(0,-3000px,0)}60%{-webkit-transform:translate3d(0,25px,0);opacity:1;transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(0,-3000px,0);opacity:0;transform:translate3d(0,-3000px,0)}60%{-webkit-transform:translate3d(0,25px,0);opacity:1;transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(-3000px,0,0);opacity:0;transform:translate3d(-3000px,0,0)}60%{-webkit-transform:translate3d(25px,0,0);opacity:1;transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(-3000px,0,0);opacity:0;transform:translate3d(-3000px,0,0)}60%{-webkit-transform:translate3d(25px,0,0);opacity:1;transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(3000px,0,0);opacity:0;transform:translate3d(3000px,0,0)}60%{-webkit-transform:translate3d(-25px,0,0);opacity:1;transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(3000px,0,0);opacity:0;transform:translate3d(3000px,0,0)}60%{-webkit-transform:translate3d(-25px,0,0);opacity:1;transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(0,3000px,0);opacity:0;transform:translate3d(0,3000px,0)}60%{-webkit-transform:translate3d(0,-20px,0);opacity:1;transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:translate3d(0,3000px,0);opacity:0;transform:translate3d(0,3000px,0)}60%{-webkit-transform:translate3d(0,-20px,0);opacity:1;transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{-webkit-transform:scale3d(1.1,1.1,1.1);opacity:1;transform:scale3d(1.1,1.1,1.1)}to{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{-webkit-transform:scale3d(1.1,1.1,1.1);opacity:1;transform:scale3d(1.1,1.1,1.1)}to{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-duration:.75s;-webkit-animation-name:bounceOut;animation-duration:.75s;animation-name:bounceOut}@-webkit-keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{-webkit-transform:translate3d(0,-20px,0);opacity:1;transform:translate3d(0,-20px,0)}to{-webkit-transform:translate3d(0,2000px,0);opacity:0;transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{-webkit-transform:translate3d(0,-20px,0);opacity:1;transform:translate3d(0,-20px,0)}to{-webkit-transform:translate3d(0,2000px,0);opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{-webkit-transform:translate3d(20px,0,0);opacity:1;transform:translate3d(20px,0,0)}to{-webkit-transform:translate3d(-2000px,0,0);opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{-webkit-transform:translate3d(20px,0,0);opacity:1;transform:translate3d(20px,0,0)}to{-webkit-transform:translate3d(-2000px,0,0);opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{-webkit-transform:translate3d(-20px,0,0);opacity:1;transform:translate3d(-20px,0,0)}to{-webkit-transform:translate3d(2000px,0,0);opacity:0;transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{-webkit-transform:translate3d(-20px,0,0);opacity:1;transform:translate3d(-20px,0,0)}to{-webkit-transform:translate3d(2000px,0,0);opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{-webkit-transform:translate3d(0,20px,0);opacity:1;transform:translate3d(0,20px,0)}to{-webkit-transform:translate3d(0,-2000px,0);opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{-webkit-transform:translate3d(0,20px,0);opacity:1;transform:translate3d(0,20px,0)}to{-webkit-transform:translate3d(0,-2000px,0);opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{-webkit-transform:translate3d(0,-100%,0);opacity:0;transform:translate3d(0,-100%,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInDown{0%{-webkit-transform:translate3d(0,-100%,0);opacity:0;transform:translate3d(0,-100%,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{0%{-webkit-transform:translate3d(0,-2000px,0);opacity:0;transform:translate3d(0,-2000px,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInDownBig{0%{-webkit-transform:translate3d(0,-2000px,0);opacity:0;transform:translate3d(0,-2000px,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{0%{-webkit-transform:translate3d(-100%,0,0);opacity:0;transform:translate3d(-100%,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInLeft{0%{-webkit-transform:translate3d(-100%,0,0);opacity:0;transform:translate3d(-100%,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{0%{-webkit-transform:translate3d(-2000px,0,0);opacity:0;transform:translate3d(-2000px,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInLeftBig{0%{-webkit-transform:translate3d(-2000px,0,0);opacity:0;transform:translate3d(-2000px,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{0%{-webkit-transform:translate3d(100%,0,0);opacity:0;transform:translate3d(100%,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInRight{0%{-webkit-transform:translate3d(100%,0,0);opacity:0;transform:translate3d(100%,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{0%{-webkit-transform:translate3d(2000px,0,0);opacity:0;transform:translate3d(2000px,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInRightBig{0%{-webkit-transform:translate3d(2000px,0,0);opacity:0;transform:translate3d(2000px,0,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{0%{-webkit-transform:translate3d(0,100%,0);opacity:0;transform:translate3d(0,100%,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInUp{0%{-webkit-transform:translate3d(0,100%,0);opacity:0;transform:translate3d(0,100%,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{0%{-webkit-transform:translate3d(0,2000px,0);opacity:0;transform:translate3d(0,2000px,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes fadeInUpBig{0%{-webkit-transform:translate3d(0,2000px,0);opacity:0;transform:translate3d(0,2000px,0)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{-webkit-transform:translate3d(0,100%,0);opacity:0;transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{-webkit-transform:translate3d(0,100%,0);opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{0%{opacity:1}to{-webkit-transform:translate3d(0,2000px,0);opacity:0;transform:translate3d(0,2000px,0)}}@keyframes fadeOutDownBig{0%{opacity:1}to{-webkit-transform:translate3d(0,2000px,0);opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{0%{opacity:1}to{-webkit-transform:translate3d(-100%,0,0);opacity:0;transform:translate3d(-100%,0,0)}}@keyframes fadeOutLeft{0%{opacity:1}to{-webkit-transform:translate3d(-100%,0,0);opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{0%{opacity:1}to{-webkit-transform:translate3d(-2000px,0,0);opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes fadeOutLeftBig{0%{opacity:1}to{-webkit-transform:translate3d(-2000px,0,0);opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0);opacity:0;transform:translate3d(100%,0,0)}}@keyframes fadeOutRight{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0);opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{0%{opacity:1}to{-webkit-transform:translate3d(2000px,0,0);opacity:0;transform:translate3d(2000px,0,0)}}@keyframes fadeOutRightBig{0%{opacity:1}to{-webkit-transform:translate3d(2000px,0,0);opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{-webkit-transform:translate3d(0,-100%,0);opacity:0;transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{-webkit-transform:translate3d(0,-100%,0);opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{0%{opacity:1}to{-webkit-transform:translate3d(0,-2000px,0);opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes fadeOutUpBig{0%{opacity:1}to{-webkit-transform:translate3d(0,-2000px,0);opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{0%{-webkit-animation-timing-function:ease-out;-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);animation-timing-function:ease-out;transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn)}40%{-webkit-animation-timing-function:ease-out;-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);animation-timing-function:ease-out;transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg)}50%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);animation-timing-function:ease-in;transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg)}80%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);animation-timing-function:ease-in;transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg)}to{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);animation-timing-function:ease-in;transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg)}}@keyframes flip{0%{-webkit-animation-timing-function:ease-out;-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);animation-timing-function:ease-out;transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn)}40%{-webkit-animation-timing-function:ease-out;-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);animation-timing-function:ease-out;transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg)}50%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);animation-timing-function:ease-in;transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg)}80%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);animation-timing-function:ease-in;transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg)}to{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);animation-timing-function:ease-in;transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg)}}.animated.flip{-webkit-animation-name:flip;-webkit-backface-visibility:visible;animation-name:flip;backface-visibility:visible}@-webkit-keyframes flipInX{0%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateX(90deg)}40%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in;transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);opacity:1;transform:perspective(400px) rotateX(10deg)}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInX{0%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateX(90deg)}40%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in;transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);opacity:1;transform:perspective(400px) rotateX(10deg)}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInX{-webkit-animation-name:flipInX;-webkit-backface-visibility:visible!important;animation-name:flipInX;backface-visibility:visible!important}@-webkit-keyframes flipInY{0%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateY(90deg);animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateY(90deg)}40%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateY(-20deg);animation-timing-function:ease-in;transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);opacity:1;transform:perspective(400px) rotateY(10deg)}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInY{0%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateY(90deg);animation-timing-function:ease-in;opacity:0;transform:perspective(400px) rotateY(90deg)}40%{-webkit-animation-timing-function:ease-in;-webkit-transform:perspective(400px) rotateY(-20deg);animation-timing-function:ease-in;transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);opacity:1;transform:perspective(400px) rotateY(10deg)}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInY{-webkit-animation-name:flipInY;-webkit-backface-visibility:visible!important;animation-name:flipInY;backface-visibility:visible!important}@-webkit-keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);opacity:1;transform:perspective(400px) rotateX(-20deg)}to{-webkit-transform:perspective(400px) rotateX(90deg);opacity:0;transform:perspective(400px) rotateX(90deg)}}@keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);opacity:1;transform:perspective(400px) rotateX(-20deg)}to{-webkit-transform:perspective(400px) rotateX(90deg);opacity:0;transform:perspective(400px) rotateX(90deg)}}.flipOutX{-webkit-animation-duration:.75s;-webkit-animation-name:flipOutX;-webkit-backface-visibility:visible!important;animation-duration:.75s;animation-name:flipOutX;backface-visibility:visible!important}@-webkit-keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);opacity:1;transform:perspective(400px) rotateY(-15deg)}to{-webkit-transform:perspective(400px) rotateY(90deg);opacity:0;transform:perspective(400px) rotateY(90deg)}}@keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);opacity:1;transform:perspective(400px) rotateY(-15deg)}to{-webkit-transform:perspective(400px) rotateY(90deg);opacity:0;transform:perspective(400px) rotateY(90deg)}}.flipOutY{-webkit-animation-duration:.75s;-webkit-animation-name:flipOutY;-webkit-backface-visibility:visible!important;animation-duration:.75s;animation-name:flipOutY;backface-visibility:visible!important}@-webkit-keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);opacity:0;transform:translate3d(100%,0,0) skewX(-30deg)}60%{-webkit-transform:skewX(20deg);opacity:1;transform:skewX(20deg)}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);opacity:0;transform:translate3d(100%,0,0) skewX(-30deg)}60%{-webkit-transform:skewX(20deg);opacity:1;transform:skewX(20deg)}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-name:lightSpeedIn;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);opacity:0;transform:translate3d(100%,0,0) skewX(30deg)}}@keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);opacity:0;transform:translate3d(100%,0,0) skewX(30deg)}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-name:lightSpeedOut;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{0%{-webkit-transform:rotate(-200deg);-webkit-transform-origin:center;opacity:0;transform:rotate(-200deg);transform-origin:center}to{-webkit-transform:translateZ(0);-webkit-transform-origin:center;opacity:1;transform:translateZ(0);transform-origin:center}}@keyframes rotateIn{0%{-webkit-transform:rotate(-200deg);-webkit-transform-origin:center;opacity:0;transform:rotate(-200deg);transform-origin:center}to{-webkit-transform:translateZ(0);-webkit-transform-origin:center;opacity:1;transform:translateZ(0);transform-origin:center}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{0%{-webkit-transform:rotate(-45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(-45deg);transform-origin:left bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:left bottom;opacity:1;transform:translateZ(0);transform-origin:left bottom}}@keyframes rotateInDownLeft{0%{-webkit-transform:rotate(-45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(-45deg);transform-origin:left bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:left bottom;opacity:1;transform:translateZ(0);transform-origin:left bottom}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{0%{-webkit-transform:rotate(45deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(45deg);transform-origin:right bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:right bottom;opacity:1;transform:translateZ(0);transform-origin:right bottom}}@keyframes rotateInDownRight{0%{-webkit-transform:rotate(45deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(45deg);transform-origin:right bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:right bottom;opacity:1;transform:translateZ(0);transform-origin:right bottom}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{0%{-webkit-transform:rotate(45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(45deg);transform-origin:left bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:left bottom;opacity:1;transform:translateZ(0);transform-origin:left bottom}}@keyframes rotateInUpLeft{0%{-webkit-transform:rotate(45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(45deg);transform-origin:left bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:left bottom;opacity:1;transform:translateZ(0);transform-origin:left bottom}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{0%{-webkit-transform:rotate(-90deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(-90deg);transform-origin:right bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:right bottom;opacity:1;transform:translateZ(0);transform-origin:right bottom}}@keyframes rotateInUpRight{0%{-webkit-transform:rotate(-90deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(-90deg);transform-origin:right bottom}to{-webkit-transform:translateZ(0);-webkit-transform-origin:right bottom;opacity:1;transform:translateZ(0);transform-origin:right bottom}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{0%{-webkit-transform-origin:center;opacity:1;transform-origin:center}to{-webkit-transform:rotate(200deg);-webkit-transform-origin:center;opacity:0;transform:rotate(200deg);transform-origin:center}}@keyframes rotateOut{0%{-webkit-transform-origin:center;opacity:1;transform-origin:center}to{-webkit-transform:rotate(200deg);-webkit-transform-origin:center;opacity:0;transform:rotate(200deg);transform-origin:center}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{0%{-webkit-transform-origin:left bottom;opacity:1;transform-origin:left bottom}to{-webkit-transform:rotate(45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(45deg);transform-origin:left bottom}}@keyframes rotateOutDownLeft{0%{-webkit-transform-origin:left bottom;opacity:1;transform-origin:left bottom}to{-webkit-transform:rotate(45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(45deg);transform-origin:left bottom}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{0%{-webkit-transform-origin:right bottom;opacity:1;transform-origin:right bottom}to{-webkit-transform:rotate(-45deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(-45deg);transform-origin:right bottom}}@keyframes rotateOutDownRight{0%{-webkit-transform-origin:right bottom;opacity:1;transform-origin:right bottom}to{-webkit-transform:rotate(-45deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(-45deg);transform-origin:right bottom}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{0%{-webkit-transform-origin:left bottom;opacity:1;transform-origin:left bottom}to{-webkit-transform:rotate(-45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(-45deg);transform-origin:left bottom}}@keyframes rotateOutUpLeft{0%{-webkit-transform-origin:left bottom;opacity:1;transform-origin:left bottom}to{-webkit-transform:rotate(-45deg);-webkit-transform-origin:left bottom;opacity:0;transform:rotate(-45deg);transform-origin:left bottom}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{0%{-webkit-transform-origin:right bottom;opacity:1;transform-origin:right bottom}to{-webkit-transform:rotate(90deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(90deg);transform-origin:right bottom}}@keyframes rotateOutUpRight{0%{-webkit-transform-origin:right bottom;opacity:1;transform-origin:right bottom}to{-webkit-transform:rotate(90deg);-webkit-transform-origin:right bottom;opacity:0;transform:rotate(90deg);transform-origin:right bottom}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{-webkit-animation-timing-function:ease-in-out;-webkit-transform-origin:top left;animation-timing-function:ease-in-out;transform-origin:top left}20%,60%{-webkit-animation-timing-function:ease-in-out;-webkit-transform:rotate(80deg);-webkit-transform-origin:top left;animation-timing-function:ease-in-out;transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-animation-timing-function:ease-in-out;-webkit-transform:rotate(60deg);-webkit-transform-origin:top left;animation-timing-function:ease-in-out;opacity:1;transform:rotate(60deg);transform-origin:top left}to{-webkit-transform:translate3d(0,700px,0);opacity:0;transform:translate3d(0,700px,0)}}@keyframes hinge{0%{-webkit-animation-timing-function:ease-in-out;-webkit-transform-origin:top left;animation-timing-function:ease-in-out;transform-origin:top left}20%,60%{-webkit-animation-timing-function:ease-in-out;-webkit-transform:rotate(80deg);-webkit-transform-origin:top left;animation-timing-function:ease-in-out;transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-animation-timing-function:ease-in-out;-webkit-transform:rotate(60deg);-webkit-transform-origin:top left;animation-timing-function:ease-in-out;opacity:1;transform:rotate(60deg);transform-origin:top left}to{-webkit-transform:translate3d(0,700px,0);opacity:0;transform:translate3d(0,700px,0)}}.hinge{-webkit-animation-duration:2s;-webkit-animation-name:hinge;animation-duration:2s;animation-name:hinge}@-webkit-keyframes jackInTheBox{0%{-webkit-transform:scale(.1) rotate(30deg);-webkit-transform-origin:center bottom;opacity:0;transform:scale(.1) rotate(30deg);transform-origin:center bottom}50%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}70%{-webkit-transform:rotate(3deg);transform:rotate(3deg)}to{-webkit-transform:scale(1);opacity:1;transform:scale(1)}}@keyframes jackInTheBox{0%{-webkit-transform:scale(.1) rotate(30deg);-webkit-transform-origin:center bottom;opacity:0;transform:scale(.1) rotate(30deg);transform-origin:center bottom}50%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}70%{-webkit-transform:rotate(3deg);transform:rotate(3deg)}to{-webkit-transform:scale(1);opacity:1;transform:scale(1)}}.jackInTheBox{-webkit-animation-name:jackInTheBox;animation-name:jackInTheBox}@-webkit-keyframes rollIn{0%{-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}@keyframes rollIn{0%{-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{-webkit-transform:translateZ(0);opacity:1;transform:translateZ(0)}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) rotate(120deg);opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}@keyframes rollOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) rotate(120deg);opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{0%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0)}}@keyframes zoomInDown{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0)}}@keyframes zoomInLeft{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0)}}@keyframes zoomInRight{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0)}}@keyframes zoomInUp{0%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0)}60%{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0)}to{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom}}@keyframes zoomOutDown{40%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0)}to{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{-webkit-transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}@keyframes zoomOutLeft{40%{-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{-webkit-transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{-webkit-transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}@keyframes zoomOutRight{40%{-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{-webkit-transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0)}to{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom}}@keyframes zoomOutUp{40%{-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19);opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0)}to{-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1);opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInDown{-webkit-animation-name:slideInDown;animation-name:slideInDown}@-webkit-keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInLeft{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}@-webkit-keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInRight{-webkit-animation-name:slideInRight;animation-name:slideInRight}@-webkit-keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInUp{-webkit-animation-name:slideInUp;animation-name:slideInUp}@-webkit-keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:hidden}}@keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:hidden}}.slideOutDown{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}@-webkit-keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:hidden}}@keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:hidden}}.slideOutLeft{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}@-webkit-keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:hidden}}@keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:hidden}}.slideOutRight{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}@-webkit-keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:hidden}}@keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:hidden}}.slideOutUp{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}.animated{-webkit-animation-duration:1s;-webkit-animation-fill-mode:both;animation-duration:1s;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.delay-1s{-webkit-animation-delay:1s;animation-delay:1s}.animated.delay-2s{-webkit-animation-delay:2s;animation-delay:2s}.animated.delay-3s{-webkit-animation-delay:3s;animation-delay:3s}.animated.delay-4s{-webkit-animation-delay:4s;animation-delay:4s}.animated.delay-5s{-webkit-animation-delay:5s;animation-delay:5s}.animated.fast{-webkit-animation-duration:.8s;animation-duration:.8s}.animated.faster{-webkit-animation-duration:.5s;animation-duration:.5s}.animated.slow{-webkit-animation-duration:2s;animation-duration:2s}.animated.slower{-webkit-animation-duration:3s;animation-duration:3s}@media (prefers-reduced-motion){.animated{-webkit-animation:unset!important;-webkit-transition:none!important;animation:unset!important;transition:none!important}}", ""]); // exports

  /***/
},
/* 643 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/86770fd3b0045db5d6fd9933a7048842.woff2";
  /***/
},
/* 644 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/161c03585e982e06ac1d7d40a247ef95.woff";
  /***/
},
/* 645 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/97d12e9f5c253941b42fe6673231f225.woff2";
  /***/
},
/* 646 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/66ff4c0c86b4376185c07c0838b57445.woff";
  /***/
},
/* 647 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/c43b2bde1ea50f1657c1828341bad71a.ttf";
  /***/
},
/* 648 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/4008e3c0bf5a6b9f686f51e25f273c4f.woff";
  /***/
},
/* 649 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__.p + "assets/gcl/c953086ba21db4ade5c0be4270232e3d.svg";
  /***/
}]);